var bj = Object.defineProperty;
var OA = (f) => {
  throw TypeError(f);
};
var kj = (f, s, n) => s in f ? bj(f, s, { enumerable: !0, configurable: !0, writable: !0, value: n }) : f[s] = n;
var Z = (f, s, n) => kj(f, typeof s != "symbol" ? s + "" : s, n), hR = (f, s, n) => s.has(f) || OA("Cannot " + n);
var d = (f, s, n) => (hR(f, s, "read from private field"), n ? n.call(f) : s.get(f)), R = (f, s, n) => s.has(f) ? OA("Cannot add the same private member more than once") : s instanceof WeakSet ? s.add(f) : s.set(f, n), L = (f, s, n, o) => (hR(f, s, "write to private field"), o ? o.call(f, n) : s.set(f, n), n), S = (f, s, n) => (hR(f, s, "access private method"), n);
import { jsx as lt, Fragment as xj, jsxs as hy } from "react/jsx-runtime";
import * as ue from "react";
import RP from "react";
import { g as Rj, a as Dj, i as AA, h as Mj, b as Lj, c as $j, d as Oj, e as Aj, f as Pj } from "./vidstack-google-cast-CsCVUqMF.js";
const wo = Symbol(0);
let Qb = !1, xR = !1, bl = null, ov = null, Ns = null, rs = 0, rv = [], kM = {};
const _j = () => {
}, wy = 0, DP = 1, Yb = 2, k0 = 3;
function Nj() {
  Qb = !0, queueMicrotask(MP);
}
function MP() {
  if (!rv.length) {
    Qb = !1;
    return;
  }
  xR = !0;
  for (let f = 0; f < rv.length; f++)
    rv[f].$st !== wy && Uj(rv[f]);
  rv = [], Qb = !1, xR = !1;
}
function Uj(f) {
  let s = [f];
  for (; f = f[wo]; )
    f.$e && f.$st !== wy && s.push(f);
  for (let n = s.length - 1; n >= 0; n--)
    AM(s[n]);
}
function zj(f) {
  const s = Gb();
  return lw(s, f.length ? f.bind(null, my.bind(s)) : f, null);
}
function ye(f) {
  return lw(bl, f, null);
}
function py(f) {
  return lw(null, f, null);
}
function Xu() {
  xR || MP();
}
function xM() {
  return bl;
}
function Cl(f, s) {
  try {
    return lw(s, f, null);
  } catch (n) {
    DM(s, n);
    return;
  }
}
function RM(f, s = bl) {
  return s == null ? void 0 : s.$cx[f];
}
function Fj(f, s, n = bl) {
  n && (n.$cx = { ...n.$cx, [f]: s });
}
function Wt(f) {
  if (!f || !bl)
    return f || _j;
  const s = bl;
  return s.$d ? Array.isArray(s.$d) ? s.$d.push(f) : s.$d = [s.$d, f] : s.$d = f, function() {
    s.$st !== k0 && (f.call(null), x0(s.$d) ? s.$d = null : Array.isArray(s.$d) && s.$d.splice(s.$d.indexOf(f), 1));
  };
}
function my(f = !0) {
  if (this.$st !== k0) {
    if (this.$h)
      if (Array.isArray(this.$h))
        for (let s = this.$h.length - 1; s >= 0; s--)
          my.call(this.$h[s]);
      else
        my.call(this.$h);
    if (f) {
      const s = this[wo];
      s && (Array.isArray(s.$h) ? s.$h.splice(s.$h.indexOf(this), 1) : s.$h = null), Vj(this);
    }
  }
}
function Vj(f) {
  f.$st = k0, f.$d && LP(f), f.$s && RR(f, 0), f[wo] = null, f.$s = null, f.$o = null, f.$h = null, f.$cx = kM, f.$eh = null;
}
function LP(f) {
  try {
    if (Array.isArray(f.$d))
      for (let s = f.$d.length - 1; s >= 0; s--) {
        const n = f.$d[s];
        n.call(n);
      }
    else
      f.$d.call(f.$d);
    f.$d = null;
  } catch (s) {
    DM(f, s);
  }
}
function lw(f, s, n) {
  const o = bl, h = ov;
  bl = f, ov = n;
  try {
    return s.call(f);
  } finally {
    bl = o, ov = h;
  }
}
function DM(f, s) {
  if (!f || !f.$eh)
    throw s;
  let n = 0, o = f.$eh.length, h = s;
  for (n = 0; n < o; n++)
    try {
      f.$eh[n](h);
      break;
    } catch (v) {
      h = v;
    }
  if (n === o)
    throw h;
}
function MM() {
  return this.$st === k0 ? this.$v : (ov && !this.$e && (!Ns && ov.$s && ov.$s[rs] == this ? rs++ : Ns ? Ns.push(this) : Ns = [this]), this.$c && AM(this), this.$v);
}
function $P(f) {
  const s = x0(f) ? f(this.$v) : f;
  if (this.$ch(this.$v, s) && (this.$v = s, this.$o))
    for (let n = 0; n < this.$o.length; n++)
      PP(this.$o[n], Yb);
  return this.$v;
}
const LM = function() {
  this[wo] = null, this.$h = null, bl && bl.append(this);
}, ip = LM.prototype;
ip.$cx = kM;
ip.$eh = null;
ip.$c = null;
ip.$d = null;
ip.append = function(f) {
  f[wo] = this, this.$h ? Array.isArray(this.$h) ? this.$h.push(f) : this.$h = [this.$h, f] : this.$h = f, f.$cx = f.$cx === kM ? this.$cx : { ...this.$cx, ...f.$cx }, this.$eh && (f.$eh = f.$eh ? [...f.$eh, ...this.$eh] : this.$eh);
};
ip.dispose = function() {
  my.call(this);
};
function Gb() {
  return new LM();
}
const OP = function(s, n, o) {
  LM.call(this), this.$st = n ? Yb : wy, this.$i = !1, this.$e = !1, this.$s = null, this.$o = null, this.$v = s, n && (this.$c = n), o && o.dirty && (this.$ch = o.dirty);
}, $M = OP.prototype;
Object.setPrototypeOf($M, ip);
$M.$ch = Hj;
$M.call = MM;
function OM(f, s, n) {
  return new OP(f, s, n);
}
function Hj(f, s) {
  return f !== s;
}
function x0(f) {
  return typeof f == "function";
}
function AM(f) {
  if (f.$st === DP)
    for (let s = 0; s < f.$s.length && (AM(f.$s[s]), f.$st !== Yb); s++)
      ;
  f.$st === Yb ? AP(f) : f.$st = wy;
}
function Ij(f) {
  f.$h && my.call(f, !1), f.$d && LP(f), f.$eh = f[wo] ? f[wo].$eh : null;
}
function AP(f) {
  let s = Ns, n = rs;
  Ns = null, rs = 0;
  try {
    Ij(f);
    const o = lw(f, f.$c, f);
    PA(f), !f.$e && f.$i ? $P.call(f, o) : (f.$v = o, f.$i = !0);
  } catch (o) {
    PA(f), DM(f, o);
  } finally {
    Ns = s, rs = n, f.$st = wy;
  }
}
function PA(f) {
  if (Ns) {
    if (f.$s && RR(f, rs), f.$s && rs > 0) {
      f.$s.length = rs + Ns.length;
      for (let n = 0; n < Ns.length; n++)
        f.$s[rs + n] = Ns[n];
    } else
      f.$s = Ns;
    let s;
    for (let n = rs; n < f.$s.length; n++)
      s = f.$s[n], s.$o ? s.$o.push(f) : s.$o = [f];
  } else f.$s && rs < f.$s.length && (RR(f, rs), f.$s.length = rs);
}
function PP(f, s) {
  if (!(f.$st >= s) && (f.$e && f.$st === wy && (rv.push(f), Qb || Nj()), f.$st = s, f.$o))
    for (let n = 0; n < f.$o.length; n++)
      PP(f.$o[n], DP);
}
function RR(f, s) {
  let n, o;
  for (let h = s; h < f.$s.length; h++)
    n = f.$s[h], n.$o && (o = n.$o.indexOf(f), n.$o[o] = n.$o[n.$o.length - 1], n.$o.pop());
}
function Wb(...f) {
}
function Zu(f) {
  return f === null;
}
function pi(f) {
  return typeof f > "u";
}
function qj(f) {
  return Zu(f) || pi(f);
}
function jj(f) {
  return (f == null ? void 0 : f.constructor) === Object;
}
function ss(f) {
  return typeof f == "number" && !Number.isNaN(f);
}
function Ze(f) {
  return typeof f == "string";
}
function wQ(f) {
  return typeof f == "boolean";
}
function ls(f) {
  return typeof f == "function";
}
function Vr(f) {
  return Array.isArray(f);
}
const Bj = Event, _P = Symbol("DOM_EVENT");
var yP, gP;
class vt extends (gP = Bj, yP = _P, gP) {
  constructor(n, ...o) {
    var v, y;
    super(n, o[0]);
    Z(this, yP, !0);
    /**
     * The event detail.
     */
    Z(this, "detail");
    /**
     * The event trigger chain.
     */
    Z(this, "triggers", new Qj());
    this.detail = (v = o[0]) == null ? void 0 : v.detail;
    const h = (y = o[0]) == null ? void 0 : y.trigger;
    h && this.triggers.add(h);
  }
  /**
   * The preceding event that was responsible for this event being fired.
   */
  get trigger() {
    return this.triggers.source;
  }
  /**
   * The origin event that lead to this event being fired.
   */
  get originEvent() {
    return this.triggers.origin;
  }
  /**
   * Whether the origin event was triggered by the user.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Event/isTrusted}
   */
  get isOriginTrusted() {
    var n;
    return ((n = this.triggers.origin) == null ? void 0 : n.isTrusted) ?? !1;
  }
}
class Qj {
  constructor() {
    Z(this, "chain", []);
  }
  get source() {
    return this.chain[0];
  }
  get origin() {
    return this.chain[this.chain.length - 1];
  }
  /**
   * Appends the event to the end of the chain.
   */
  add(s) {
    this.chain.push(s), Yj(s) && this.chain.push(...s.triggers);
  }
  /**
   * Removes the event from the chain and returns it (if found).
   */
  remove(s) {
    return this.chain.splice(this.chain.indexOf(s), 1)[0];
  }
  /**
   * Returns whether the chain contains the given `event`.
   */
  has(s) {
    return this.chain.some((n) => n === s);
  }
  /**
   * Returns whether the chain contains the given event type.
   */
  hasType(s) {
    return !!this.findType(s);
  }
  /**
   * Returns the first event with the given `type` found in the chain.
   */
  findType(s) {
    return this.chain.find((n) => n.type === s);
  }
  /**
   * Walks an event chain on a given `event`, and invokes the given `callback` for each trigger event.
   */
  walk(s) {
    for (const n of this.chain) {
      const o = s(n);
      if (o) return [n, o];
    }
  }
  [Symbol.iterator]() {
    return this.chain.values();
  }
}
function Yj(f) {
  return !!(f != null && f[_P]);
}
class NP extends EventTarget {
  constructor() {
    super(...arguments);
    /** @internal type only */
    Z(this, "$ts__events");
  }
  addEventListener(n, o, h) {
    return super.addEventListener(n, o, h);
  }
  removeEventListener(n, o, h) {
    return super.removeEventListener(n, o, h);
  }
}
function En(f, s, n, o) {
  return f.addEventListener(s, n, o), Wt(() => f.removeEventListener(s, n, o));
}
var uv, cv;
class gn {
  constructor(s) {
    R(this, uv);
    R(this, cv);
    L(this, uv, s), L(this, cv, new AbortController()), Wt(this.abort.bind(this));
  }
  get signal() {
    return d(this, cv).signal;
  }
  add(s, n, o) {
    if (this.signal.aborted) throw Error("aborted");
    return d(this, uv).addEventListener(s, n, {
      ...o,
      signal: o != null && o.signal ? Gj(this.signal, o.signal) : this.signal
    }), this;
  }
  remove(s, n) {
    return d(this, uv).removeEventListener(s, n), this;
  }
  abort(s) {
    d(this, cv).abort(s);
  }
}
uv = new WeakMap(), cv = new WeakMap();
function Gj(...f) {
  const s = new AbortController(), n = { signal: s.signal };
  function o(h) {
    s.abort(h.target.reason);
  }
  for (const h of f) {
    if (h.aborted) {
      s.abort(h.reason);
      break;
    }
    h.addEventListener("abort", o, n);
  }
  return s.signal;
}
function Wj(f) {
  return !!(f != null && f.type.startsWith("touch"));
}
function R0(f) {
  return !!(f != null && f.type.startsWith("key"));
}
function Kj(f) {
  return R0(f) && f.key === "Enter";
}
function UP(f) {
  return R0(f) && (f.key === "Enter" || f.key === " ");
}
function Xj(f) {
  return f instanceof Node;
}
function Rt(f, s, n) {
  if (f) if (!n && n !== "" && n !== 0)
    f.removeAttribute(s);
  else {
    const o = n === !0 ? "" : n + "";
    f.getAttribute(s) !== o && f.setAttribute(s, o);
  }
  else return;
}
function Nd(f, s, n) {
  if (f) !n && n !== 0 ? f.style.removeProperty(s) : f.style.setProperty(s, n + "");
  else return;
}
function D0(f) {
  return f.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function Zj(f) {
  return Jj(f).replace(/\s/g, "");
}
function Jj(f) {
  return zP(f.replace(/-./g, (s) => " " + s[1].toUpperCase()));
}
function zP(f) {
  return f.charAt(0).toUpperCase() + f.slice(1);
}
function Kb(f) {
  return f ? "true" : "false";
}
function EQ(f) {
  return Object.keys(f);
}
function DR() {
  let f, s;
  return { promise: new Promise((o, h) => {
    f = o, s = h;
  }), resolve: f, reject: s };
}
function eB(f) {
  return new Promise((s) => setTimeout(s, f));
}
function Ey(f) {
  let s = -1, n;
  function o(...h) {
    n = h, !(s >= 0) && (s = window.requestAnimationFrame(() => {
      f.apply(this, n), s = -1, n = void 0;
    }));
  }
  return o;
}
const tB = typeof window < "u" ? "requestIdleCallback" in window ? window.requestIdleCallback : (f) => window.setTimeout(f, 1) : Wb;
function nB(f, s) {
  return new Promise((n) => {
    tB((o) => {
      f == null || f(o), n();
    }, s);
  });
}
function MR(f) {
  return !Ze(f) && "width" in f && "height" in f && ss(f.width) && ss(f.height);
}
var Ja = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5,
  fullscreen: 6
}, _A = [
  "webkitFullscreenEnabled",
  "webkitFullscreenElement",
  "webkitRequestFullscreen",
  "webkitExitFullscreen",
  "webkitfullscreenchange",
  "webkitfullscreenerror",
  "-webkit-full-screen"
], NA = [
  "mozFullScreenEnabled",
  "mozFullScreenElement",
  "mozRequestFullScreen",
  "mozCancelFullScreen",
  "mozfullscreenchange",
  "mozfullscreenerror",
  "-moz-full-screen"
], UA = [
  "msFullscreenEnabled",
  "msFullscreenElement",
  "msRequestFullscreen",
  "msExitFullscreen",
  "MSFullscreenChange",
  "MSFullscreenError",
  "-ms-fullscreen"
], Pa = typeof window < "u" && typeof window.document < "u" ? window.document : {}, Os = "fullscreenEnabled" in Pa && Object.keys(Ja) || _A[0] in Pa && _A || NA[0] in Pa && NA || UA[0] in Pa && UA || [], Zh = {
  requestFullscreen: function(f) {
    return f[Os[Ja.requestFullscreen]]();
  },
  requestFullscreenFunction: function(f) {
    return f[Os[Ja.requestFullscreen]];
  },
  get exitFullscreen() {
    return Pa[Os[Ja.exitFullscreen]].bind(Pa);
  },
  get fullscreenPseudoClass() {
    return ":" + Os[Ja.fullscreen];
  },
  addEventListener: function(f, s, n) {
    return Pa.addEventListener(Os[Ja[f]], s, n);
  },
  removeEventListener: function(f, s, n) {
    return Pa.removeEventListener(Os[Ja[f]], s, n);
  },
  get fullscreenEnabled() {
    return !!Pa[Os[Ja.fullscreenEnabled]];
  },
  set fullscreenEnabled(f) {
  },
  get fullscreenElement() {
    return Pa[Os[Ja.fullscreenElement]];
  },
  set fullscreenElement(f) {
  },
  get onfullscreenchange() {
    return Pa[("on" + Os[Ja.fullscreenchange]).toLowerCase()];
  },
  set onfullscreenchange(f) {
    return Pa[("on" + Os[Ja.fullscreenchange]).toLowerCase()] = f;
  },
  get onfullscreenerror() {
    return Pa[("on" + Os[Ja.fullscreenerror]).toLowerCase()];
  },
  set onfullscreenerror(f) {
    return Pa[("on" + Os[Ja.fullscreenerror]).toLowerCase()] = f;
  }
};
function st(f, s) {
  const n = OM(f, null, s), o = MM.bind(n);
  return o[wo] = !0, o.set = $P.bind(n), o;
}
function iB(f) {
  return x0(f) && wo in f;
}
function ow(f, s) {
  const n = OM(
    s == null ? void 0 : s.initial,
    f,
    s
  ), o = MM.bind(n);
  return o[wo] = !0, o;
}
function FP(f, s) {
  const n = OM(
    null,
    function() {
      let h = f();
      return x0(h) && Wt(h), null;
    },
    void 0
  );
  return n.$e = !0, AP(n), my.bind(n, !0);
}
function rB(f) {
  return iB(f) && "set" in f;
}
const J = FP;
function Cy(f) {
  return { id: Symbol(), provide: f };
}
function Ju(f, s, n = xM()) {
  var h;
  const o = !pi(s);
  Fj(f.id, o ? s : (h = f.provide) == null ? void 0 : h.call(f), n);
}
function Us(f) {
  return RM(f.id);
}
function Jh(f) {
  return !pi(RM(f.id));
}
const pR = /* @__PURE__ */ Symbol(0), mR = /* @__PURE__ */ Symbol(0), M0 = /* @__PURE__ */ Symbol(0), vR = {};
var SP, dv, fv, vh, hv, Eo, VP, HP, IP, qP;
SP = M0;
class aB {
  constructor(s, n, o) {
    R(this, Eo);
    /** @internal type only */
    Z(this, "$ts__events");
    /** @internal type only */
    Z(this, "$ts__vars");
    /* @internal */
    Z(this, SP, null);
    Z(this, "$el", st(null));
    Z(this, "el", null);
    Z(this, "scope", null);
    Z(this, "attachScope", null);
    Z(this, "connectScope", null);
    Z(this, "component", null);
    Z(this, "destroyed", !1);
    Z(this, "props", vR);
    Z(this, "attrs", null);
    Z(this, "styles", null);
    Z(this, "state");
    Z(this, "$state");
    R(this, dv, []);
    R(this, fv, []);
    R(this, vh, []);
    R(this, hv, []);
    var y;
    this.scope = n, o != null && o.scope && o.scope.append(n);
    let h = s.state, v = s.props;
    if (h && (this.$state = h.create(), this.state = new Proxy(this.$state, {
      get: (k, D) => this.$state[D]()
    }), Ju(h, this.$state)), v && (this.props = sB(v), o != null && o.props))
      for (const k of Object.keys(o.props))
        (y = this.props[k]) == null || y.set(o.props[k]);
    Wt(this.destroy.bind(this));
  }
  setup() {
    Cl(() => {
      for (const s of d(this, dv)) s();
    }, this.scope);
  }
  attach(s) {
    this.el || (this.el = s, this.$el.set(s), Cl(() => {
      this.attachScope = Gb(), Cl(() => {
        for (const n of d(this, fv)) n(this.el);
        S(this, Eo, VP).call(this), S(this, Eo, HP).call(this);
      }, this.attachScope);
    }, this.scope), s.dispatchEvent(new Event("attached")));
  }
  detach() {
    var s;
    (s = this.attachScope) == null || s.dispose(), this.attachScope = null, this.connectScope = null, this.el = null, this.$el.set(null);
  }
  connect() {
    !this.el || !this.attachScope || !d(this, vh).length || Cl(() => {
      this.connectScope = Gb(), Cl(() => {
        for (const s of d(this, vh)) s(this.el);
      }, this.connectScope);
    }, this.attachScope);
  }
  disconnect() {
    var s;
    (s = this.connectScope) == null || s.dispose(), this.connectScope = null;
  }
  destroy() {
    if (this.destroyed) return;
    this.destroyed = !0, Cl(() => {
      for (const n of d(this, hv)) n(this.el);
    }, this.scope);
    const s = this.el;
    this.detach(), this.scope.dispose(), d(this, dv).length = 0, d(this, fv).length = 0, d(this, vh).length = 0, d(this, hv).length = 0, this.component = null, this.attrs = null, this.styles = null, this.props = vR, this.scope = null, this.state = vR, this.$state = null, s && delete s.$;
  }
  addHooks(s) {
    s.onSetup && d(this, dv).push(s.onSetup.bind(s)), s.onAttach && d(this, fv).push(s.onAttach.bind(s)), s.onConnect && d(this, vh).push(s.onConnect.bind(s)), s.onDestroy && d(this, hv).push(s.onDestroy.bind(s));
  }
}
dv = new WeakMap(), fv = new WeakMap(), vh = new WeakMap(), hv = new WeakMap(), Eo = new WeakSet(), VP = function() {
  if (this.attrs)
    for (const s of Object.keys(this.attrs))
      ls(this.attrs[s]) ? J(S(this, Eo, IP).bind(this, s)) : Rt(this.el, s, this.attrs[s]);
}, HP = function() {
  if (this.styles)
    for (const s of Object.keys(this.styles))
      ls(this.styles[s]) ? J(S(this, Eo, qP).bind(this, s)) : Nd(this.el, s, this.styles[s]);
}, IP = function(s) {
  Rt(this.el, s, this.attrs[s].call(this.component));
}, qP = function(s) {
  Nd(this.el, s, this.styles[s].call(this.component));
};
function sB(f) {
  const s = {};
  for (const n of Object.keys(f)) {
    const o = f[n];
    s[n] = st(o, o);
  }
  return s;
}
let aT = { $$: null };
function lB(f, s) {
  return zj(() => {
    aT.$$ = new aB(f, xM(), s);
    const n = new f();
    return aT.$$.component = n, aT.$$ = null, n;
  });
}
class Hs extends EventTarget {
  constructor() {
    super();
    /** @internal */
    Z(this, "$$");
    aT.$$ && this.attach(aT);
  }
  get el() {
    return this.$$.el;
  }
  get $el() {
    return this.$$.$el();
  }
  get scope() {
    return this.$$.scope;
  }
  get attachScope() {
    return this.$$.attachScope;
  }
  get connectScope() {
    return this.$$.connectScope;
  }
  /** @internal */
  get $props() {
    return this.$$.props;
  }
  /** @internal */
  get $state() {
    return this.$$.$state;
  }
  get state() {
    return this.$$.state;
  }
  attach({ $$: n }) {
    return this.$$ = n, n.addHooks(this), this;
  }
  addEventListener(n, o, h) {
    this.listen(n, o, h);
  }
  removeEventListener(n, o, h) {
    var v;
    (v = this.el) == null || v.removeEventListener(n, o, h);
  }
  /**
   * The given callback is invoked when the component is ready to be set up.
   *
   * - This hook will run once.
   * - This hook is called both client-side and server-side.
   * - It's safe to use context inside this hook.
   * - The host element has not attached yet - wait for `onAttach`.
   */
  /**
   * This method can be used to specify attributes that should be set on the host element. Any
   * attributes that are assigned to a function will be considered a signal and updated accordingly.
   */
  setAttributes(n) {
    this.$$.attrs || (this.$$.attrs = {}), Object.assign(this.$$.attrs, n);
  }
  /**
   * This method can be used to specify styles that should set be set on the host element. Any
   * styles that are assigned to a function will be considered a signal and updated accordingly.
   */
  setStyles(n) {
    this.$$.styles || (this.$$.styles = {}), Object.assign(this.$$.styles, n);
  }
  /**
   * This method is used to satisfy the CSS variables contract specified on the current
   * component. Other CSS variables can be set via the `setStyles` method.
   */
  setCSSVars(n) {
    this.setStyles(n);
  }
  /**
   * Type-safe utility for creating component DOM events.
   */
  createEvent(n, ...o) {
    return new vt(n, o[0]);
  }
  /**
   * Creates a `DOMEvent` and dispatches it from the host element. This method is typed to
   * match all component events.
   */
  dispatch(n, ...o) {
    if (!this.el) return !1;
    const h = n instanceof Event ? n : new vt(n, o[0]);
    return Object.defineProperty(h, "target", {
      get: () => this.$$.component
    }), py(() => {
      var v, y;
      return (y = (v = this.$$)[M0]) == null || y.call(v, h), this.el.dispatchEvent(h);
    });
  }
  dispatchEvent(n) {
    return this.dispatch(n);
  }
  /**
   * Adds an event listener for the given `type` and returns a function which can be invoked to
   * remove the event listener.
   *
   * - The listener is removed if the current scope is disposed.
   * - This method is safe to use on the server (noop).
   */
  listen(n, o, h) {
    return this.el ? En(this.el, n, o, h) : Wb;
  }
}
class Ci extends Hs {
  subscribe(s) {
    return Cl(() => J(() => s(this.state)), this.$$.scope);
  }
  destroy() {
    this.$$.destroy();
  }
}
function rn(f, s, n) {
  f[pR] || (f[pR] = /* @__PURE__ */ new Set()), f[pR].add(s);
}
function Zi(f, s, n) {
  f[mR] || (f[mR] = /* @__PURE__ */ new Set()), f[mR].add(s);
}
var pv;
class by {
  constructor(s) {
    Z(this, "id", Symbol(0));
    Z(this, "record");
    R(this, pv);
    this.record = s, L(this, pv, Object.getOwnPropertyDescriptors(s));
  }
  create() {
    const s = {}, n = new Proxy(s, { get: (o, h) => s[h]() });
    for (const o of Object.keys(this.record)) {
      const h = d(this, pv)[o].get;
      s[o] = h ? ow(h.bind(n)) : st(this.record[o]);
    }
    return s;
  }
  reset(s, n) {
    for (const o of Object.keys(s))
      !d(this, pv)[o].get && (!n || n(o)) && s[o].set(this.record[o]);
  }
}
pv = new WeakMap();
function uw(f) {
  return Us(f);
}
const oB = (navigator == null ? void 0 : navigator.userAgent.toLowerCase()) || "", L0 = /iphone|ipad|ipod|ios|crios|fxios/i.test(oB), jP = /(iphone|ipod)/gi.test((navigator == null ? void 0 : navigator.platform) || ""), $0 = !!window.chrome, Xb = !!window.safari || L0;
function BP() {
  return uB() && ls(screen.orientation.unlock);
}
function uB() {
  return !pi(window.screen.orientation) && !pi(window.screen.orientation.lock);
}
function QP(f, s) {
  return f || (f = document.createElement("audio")), f.canPlayType(s).length > 0;
}
function YP(f, s) {
  return f || (f = document.createElement("video")), f.canPlayType(s).length > 0;
}
function cB(f) {
  return f || (f = document.createElement("video")), f.canPlayType("application/vnd.apple.mpegurl").length > 0;
}
function dB(f) {
  return !!document.pictureInPictureEnabled && !(f != null && f.disablePictureInPicture);
}
function fB(f) {
  return ls(f == null ? void 0 : f.webkitSupportsPresentationMode) && ls(f == null ? void 0 : f.webkitSetPresentationMode);
}
async function hB() {
  const f = document.createElement("video");
  return f.volume = 0.5, await eB(0), f.volume === 0.5;
}
function pB() {
  return (window == null ? void 0 : window.ManagedMediaSource) ?? (window == null ? void 0 : window.MediaSource) ?? (window == null ? void 0 : window.WebKitMediaSource);
}
function mB() {
  return (window == null ? void 0 : window.SourceBuffer) ?? (window == null ? void 0 : window.WebKitSourceBuffer);
}
function PM() {
  const f = pB();
  if (pi(f)) return !1;
  const s = f && ls(f.isTypeSupported) && f.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), n = mB(), o = pi(n) || !pi(n.prototype) && ls(n.prototype.appendBuffer) && ls(n.prototype.remove);
  return !!s && !!o;
}
function vB() {
  return PM();
}
var Du;
class Cb {
  constructor(s, n) {
    R(this, Du);
    Vr(s) ? L(this, Du, s) : !pi(s) && !pi(n) ? L(this, Du, [[s, n]]) : L(this, Du, []);
  }
  get length() {
    return d(this, Du).length;
  }
  start(s) {
    return d(this, Du)[s][0] ?? 1 / 0;
  }
  end(s) {
    return d(this, Du)[s][1] ?? 1 / 0;
  }
}
Du = new WeakMap();
function zA(f) {
  if (!f.length) return null;
  let s = f.start(0);
  for (let n = 1; n < f.length; n++) {
    const o = f.start(n);
    o < s && (s = o);
  }
  return s;
}
function mh(f) {
  if (!f.length) return null;
  let s = f.end(0);
  for (let n = 1; n < f.length; n++) {
    const o = f.end(n);
    o > s && (s = o);
  }
  return s;
}
function yB(f) {
  if (f.length <= 1)
    return f;
  f.sort((o, h) => o[0] - h[0]);
  let s = [], n = f[0];
  for (let o = 1; o < f.length; o++) {
    const h = f[o];
    n[1] >= h[0] - 1 ? n = [n[0], Math.max(n[1], h[1])] : (s.push(n), n = h);
  }
  return s.push(n), s;
}
function gB(f, s, n) {
  let o = s[0], h = s[1];
  return n < o ? [n, -1] : n === o ? s : o === -1 ? (s[0] = n, s) : (n > o && (s[1] = n, h === -1 && f.push(s)), yB(f), s);
}
const SB = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx|flac)($|\?)/i, TB = /* @__PURE__ */ new Set([
  "audio/aac",
  "audio/mpeg",
  "audio/ogg",
  "audio/3gp",
  "audio/mp3",
  "audio/webm",
  "audio/flac",
  "audio/m4a",
  "audio/m4b",
  "audio/mp4a",
  "audio/mp4"
]), wB = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, EB = /* @__PURE__ */ new Set([
  "video/mp4",
  "video/webm",
  "video/3gp",
  "video/ogg",
  "video/avi",
  "video/mpeg"
]), CB = /\.(m3u8)($|\?)/i, bB = /\.(mpd)($|\?)/i, kB = /* @__PURE__ */ new Set([
  // Apple sanctioned
  "application/vnd.apple.mpegurl",
  // Apple sanctioned for backwards compatibility
  "audio/mpegurl",
  // Very common
  "audio/x-mpegurl",
  // Very common
  "application/x-mpegurl",
  // Included for completeness
  "video/x-mpegurl",
  "video/mpegurl",
  "application/mpegurl"
]), xB = /* @__PURE__ */ new Set(["application/dash+xml"]);
function GP({ src: f, type: s }) {
  return Ze(f) ? SB.test(f) || TB.has(s) || f.startsWith("blob:") && s === "audio/object" : s === "audio/object";
}
function WP(f) {
  return Ze(f.src) ? wB.test(f.src) || EB.has(f.type) || f.src.startsWith("blob:") && f.type === "video/object" || ky(f) && cB() : f.type === "video/object";
}
function ky({ src: f, type: s }) {
  return Ze(f) && CB.test(f) || kB.has(s);
}
function _M({ src: f, type: s }) {
  return Ze(f) && bB.test(f) || xB.has(s);
}
function KP(f) {
  return Ze(f.src) && (GP(f) || WP(f) || ky(f));
}
function CQ(f) {
  return typeof window.MediaStream < "u" && f instanceof window.MediaStream;
}
function RB(f, s) {
  const n = new URL(f);
  for (const o of Object.keys(s)) {
    const h = s[o];
    pi(h) || n.searchParams.set(o, s[o] + "");
  }
  return n.toString();
}
function O0(f, s = "preconnect") {
  const n = document.querySelector(`link[href="${f}"]`);
  if (!Zu(n)) return !0;
  const o = document.createElement("link");
  return o.rel = s, o.href = f, o.crossOrigin = "true", document.head.append(o), !0;
}
const XS = {};
function NM(f) {
  if (XS[f]) return XS[f].promise;
  const s = DR(), n = document.querySelector(`script[src="${f}"]`);
  if (!Zu(n))
    return s.resolve(), s.promise;
  XS[f] = s;
  const o = document.createElement("script");
  return o.src = f, o.onload = () => {
    s.resolve(), delete XS[f];
  }, o.onerror = () => {
    s.reject(), delete XS[f];
  }, setTimeout(() => document.head.append(o), 0), s.promise;
}
function sT(f) {
  return f === "use-credentials" ? "include" : Ze(f) ? "same-origin" : void 0;
}
const DB = Symbol(0), MB = Symbol(0), LB = Symbol(0), $B = Symbol(0), OB = Symbol(0), AB = Symbol(0), PB = Symbol(0), tt = {
  crossOrigin: DB,
  readyState: MB,
  updateActiveCues: LB,
  canLoad: $B,
  onModeChange: OB,
  native: AB,
  nativeHLS: PB
};
function FA(f, s) {
  return s >= f.startTime && s < f.endTime;
}
function XP(f, s, n) {
  let o = null, h = xM();
  function v() {
    const y = Ze(s) ? [s] : s, k = f.toArray().find((D) => y.includes(D.kind) && D.mode === "showing");
    if (k !== o) {
      if (!k) {
        n(null), o = null;
        return;
      }
      k.readyState == 2 ? n(k) : (n(null), Cl(() => {
        const D = En(
          k,
          "load",
          () => {
            n(k), D();
          },
          { once: !0 }
        );
      }, h)), o = k;
    }
  }
  return v(), En(f, "mode-change", v);
}
var TP, wP, EP, CP, cT, Mu, mv, dT, yh, vr, nd, wi, ZP, LR, JS, $R, OR, JP;
class Ud extends NP {
  constructor(n) {
    super();
    R(this, wi);
    Z(this, "src");
    Z(this, "content");
    Z(this, "type");
    Z(this, "encoding");
    Z(this, "id", "");
    Z(this, "label", "");
    Z(this, "language", "");
    Z(this, "kind");
    Z(this, "default", !1);
    Z(this, "sourceType");
    R(this, cT, !1);
    R(this, Mu, 0);
    R(this, mv, "disabled");
    R(this, dT, {});
    R(this, yh, []);
    R(this, vr, []);
    R(this, nd, []);
    /** @internal */
    Z(this, CP, 0);
    /** @internal */
    Z(this, EP);
    /** @internal */
    Z(this, wP, null);
    /** @internal */
    Z(this, TP, null);
    for (const o of Object.keys(n)) this[o] = n[o];
    this.type || (this.type = "vtt"), n.content ? S(this, wi, ZP).call(this, n) : n.src || (this[tt.readyState] = 2);
  }
  static createId(n) {
    return `vds-${n.type}-${n.kind}-${n.src ?? n.label ?? "?"}`;
  }
  get metadata() {
    return d(this, dT);
  }
  get regions() {
    return d(this, yh);
  }
  get cues() {
    return d(this, vr);
  }
  get activeCues() {
    return d(this, nd);
  }
  /**
   * - 0: Not Loading
   * - 1: Loading
   * - 2: Ready
   * - 3: Error
   */
  get readyState() {
    return this[tt.readyState];
  }
  get mode() {
    return d(this, mv);
  }
  set mode(n) {
    this.setMode(n);
  }
  addCue(n, o) {
    var y;
    let h = 0, v = d(this, vr).length;
    for (h = 0; h < v && !(n.endTime <= d(this, vr)[h].startTime); h++) ;
    h === v ? d(this, vr).push(n) : d(this, vr).splice(h, 0, n), n instanceof TextTrackCue || (y = this[tt.native]) == null || y.track.addCue(n), this.dispatchEvent(new vt("add-cue", { detail: n, trigger: o })), FA(n, d(this, Mu)) && this[tt.updateActiveCues](d(this, Mu), o);
  }
  removeCue(n, o) {
    var v;
    const h = d(this, vr).indexOf(n);
    if (h >= 0) {
      const y = d(this, nd).includes(n);
      d(this, vr).splice(h, 1), (v = this[tt.native]) == null || v.track.removeCue(n), this.dispatchEvent(new vt("remove-cue", { detail: n, trigger: o })), y && this[tt.updateActiveCues](d(this, Mu), o);
    }
  }
  setMode(n, o) {
    var h;
    d(this, mv) !== n && (L(this, mv, n), this.readyState === 2 ? this[tt.updateActiveCues](d(this, Mu), o) : S(this, wi, LR).call(this), this.dispatchEvent(new vt("mode-change", { detail: this, trigger: o })), (h = this[tt.onModeChange]) == null || h.call(this));
  }
  /** @internal */
  [(CP = tt.readyState, EP = tt.crossOrigin, wP = tt.onModeChange, TP = tt.native, tt.updateActiveCues)](n, o) {
    if (L(this, Mu, n), !d(this, vr).length) return;
    const h = [];
    for (let y = 0, k = d(this, vr).length; y < k; y++) {
      const D = d(this, vr)[y];
      FA(D, n) && h.push(D);
    }
    let v = h.length !== d(this, nd).length;
    if (!v) {
      for (let y = 0; y < h.length; y++)
        if (!d(this, nd).includes(h[y])) {
          v = !0;
          break;
        }
    }
    L(this, nd, h), v && S(this, wi, JP).call(this, o);
  }
  /** @internal */
  [tt.canLoad]() {
    L(this, cT, !0), S(this, wi, LR).call(this);
  }
}
cT = new WeakMap(), Mu = new WeakMap(), mv = new WeakMap(), dT = new WeakMap(), yh = new WeakMap(), vr = new WeakMap(), nd = new WeakMap(), wi = new WeakSet(), ZP = function(n) {
  import("./dev-D3SS6qhA.js").then((o) => o.d).then(({ parseText: o, VTTCue: h, VTTRegion: v }) => {
    !Ze(n.content) || n.type === "json" ? (S(this, wi, OR).call(this, n.content, h, v), this.readyState !== 3 && S(this, wi, JS).call(this)) : o(n.content, { type: n.type }).then(({ cues: y, regions: k }) => {
      L(this, vr, y), L(this, yh, k), S(this, wi, JS).call(this);
    });
  });
}, LR = async function() {
  var n, o;
  if (!(!d(this, cT) || this[tt.readyState] > 0)) {
    if (this[tt.readyState] = 1, this.dispatchEvent(new vt("load-start")), !this.src) {
      S(this, wi, JS).call(this);
      return;
    }
    try {
      const { parseResponse: h, VTTCue: v, VTTRegion: y } = await import("./dev-D3SS6qhA.js").then(($) => $.d), k = (n = this[tt.crossOrigin]) == null ? void 0 : n.call(this), D = fetch(this.src, {
        headers: this.type === "json" ? { "Content-Type": "application/json" } : void 0,
        credentials: sT(k)
      });
      if (this.type === "json")
        S(this, wi, OR).call(this, await (await D).text(), v, y);
      else {
        const { errors: $, metadata: _, regions: A, cues: B } = await h(D, {
          type: this.type,
          encoding: this.encoding
        });
        if (((o = $[0]) == null ? void 0 : o.code) === 0)
          throw $[0];
        L(this, dT, _), L(this, yh, A), L(this, vr, B);
      }
      S(this, wi, JS).call(this);
    } catch (h) {
      S(this, wi, $R).call(this, h);
    }
  }
}, JS = function() {
  if (this[tt.readyState] = 2, !this.src || this.type !== "vtt") {
    const o = this[tt.native];
    if (o && !o.managed)
      for (const h of d(this, vr)) o.track.addCue(h);
  }
  const n = new vt("load");
  this[tt.updateActiveCues](d(this, Mu), n), this.dispatchEvent(n);
}, $R = function(n) {
  this[tt.readyState] = 3, this.dispatchEvent(new vt("error", { detail: n }));
}, OR = function(n, o, h) {
  try {
    const { regions: v, cues: y } = NB(n, o, h);
    L(this, yh, v), L(this, vr, y);
  } catch (v) {
    S(this, wi, $R).call(this, v);
  }
}, JP = function(n) {
  this.dispatchEvent(new vt("cue-change", { trigger: n }));
};
const _B = /captions|subtitles/;
function _a(f) {
  return _B.test(f.kind);
}
function NB(f, s, n) {
  const o = Ze(f) ? JSON.parse(f) : f;
  let h = [], v = [];
  return o.regions && n && (h = o.regions.map((y) => Object.assign(new n(), y))), (o.cues || Vr(o)) && (v = (Vr(o) ? o : o.cues).filter((y) => ss(y.startTime) && ss(y.endTime)).map((y) => Object.assign(new s(0, 0, ""), y))), { regions: h, cues: v };
}
const xy = new by({
  artist: "",
  artwork: null,
  audioTrack: null,
  audioTracks: [],
  autoPlay: !1,
  autoPlayError: null,
  audioGain: null,
  buffered: new Cb(),
  canLoad: !1,
  canLoadPoster: !1,
  canFullscreen: !1,
  canOrientScreen: BP(),
  canPictureInPicture: !1,
  canPlay: !1,
  clipStartTime: 0,
  clipEndTime: 0,
  controls: !1,
  get iOSControls() {
    return jP && this.mediaType === "video" && (!this.playsInline || !Zh.fullscreenEnabled && this.fullscreen);
  },
  get nativeControls() {
    return this.controls || this.iOSControls;
  },
  controlsVisible: !1,
  get controlsHidden() {
    return !this.controlsVisible;
  },
  crossOrigin: null,
  ended: !1,
  error: null,
  fullscreen: !1,
  get loop() {
    return this.providedLoop || this.userPrefersLoop;
  },
  logLevel: "silent",
  mediaType: "unknown",
  muted: !1,
  paused: !0,
  played: new Cb(),
  playing: !1,
  playsInline: !1,
  pictureInPicture: !1,
  preload: "metadata",
  playbackRate: 1,
  qualities: [],
  quality: null,
  autoQuality: !1,
  canSetQuality: !0,
  canSetPlaybackRate: !0,
  canSetVolume: !1,
  canSetAudioGain: !1,
  seekable: new Cb(),
  seeking: !1,
  source: { src: "", type: "" },
  sources: [],
  started: !1,
  textTracks: [],
  textTrack: null,
  get hasCaptions() {
    return this.textTracks.filter(_a).length > 0;
  },
  volume: 1,
  waiting: !1,
  realCurrentTime: 0,
  get currentTime() {
    return this.ended ? this.duration : this.clipStartTime > 0 ? Math.max(0, Math.min(this.realCurrentTime - this.clipStartTime, this.duration)) : this.realCurrentTime;
  },
  providedDuration: -1,
  intrinsicDuration: 0,
  get duration() {
    return this.seekableWindow;
  },
  get title() {
    return this.providedTitle || this.inferredTitle;
  },
  get poster() {
    return this.providedPoster || this.inferredPoster;
  },
  get viewType() {
    return this.providedViewType !== "unknown" ? this.providedViewType : this.inferredViewType;
  },
  get streamType() {
    return this.providedStreamType !== "unknown" ? this.providedStreamType : this.inferredStreamType;
  },
  get currentSrc() {
    return this.source;
  },
  get bufferedStart() {
    const f = zA(this.buffered) ?? 0;
    return Math.max(f, this.clipStartTime);
  },
  get bufferedEnd() {
    const f = mh(this.buffered) ?? 0;
    return Math.min(this.seekableEnd, Math.max(0, f - this.clipStartTime));
  },
  get bufferedWindow() {
    return Math.max(0, this.bufferedEnd - this.bufferedStart);
  },
  get seekableStart() {
    if (this.isLiveDVR && this.liveDVRWindow > 0)
      return Math.max(0, this.seekableEnd - this.liveDVRWindow);
    const f = zA(this.seekable) ?? 0;
    return Math.max(f, this.clipStartTime);
  },
  get seekableEnd() {
    if (this.providedDuration > 0) return this.providedDuration;
    const f = this.liveSyncPosition > 0 ? this.liveSyncPosition : this.canPlay ? mh(this.seekable) ?? 1 / 0 : 0;
    return this.clipEndTime > 0 ? Math.min(this.clipEndTime, f) : f;
  },
  get seekableWindow() {
    const f = this.seekableEnd - this.seekableStart;
    return isNaN(f) ? 1 / 0 : Math.max(0, f);
  },
  // ~~ remote playback ~~
  canAirPlay: !1,
  canGoogleCast: !1,
  remotePlaybackState: "disconnected",
  remotePlaybackType: "none",
  remotePlaybackLoader: null,
  remotePlaybackInfo: null,
  get isAirPlayConnected() {
    return this.remotePlaybackType === "airplay" && this.remotePlaybackState === "connected";
  },
  get isGoogleCastConnected() {
    return this.remotePlaybackType === "google-cast" && this.remotePlaybackState === "connected";
  },
  // ~~ responsive design ~~
  pointer: "fine",
  orientation: "landscape",
  width: 0,
  height: 0,
  mediaWidth: 0,
  mediaHeight: 0,
  lastKeyboardAction: null,
  // ~~ user props ~~
  userBehindLiveEdge: !1,
  // ~~ live props ~~
  liveEdgeTolerance: 10,
  minLiveDVRWindow: 60,
  get canSeek() {
    return /unknown|on-demand|:dvr/.test(this.streamType) && Number.isFinite(this.duration) && (!this.isLiveDVR || this.duration >= this.liveDVRWindow);
  },
  get live() {
    return this.streamType.includes("live") || !Number.isFinite(this.duration);
  },
  get liveEdgeStart() {
    return this.live && Number.isFinite(this.seekableEnd) ? Math.max(0, this.seekableEnd - this.liveEdgeTolerance) : 0;
  },
  get liveEdge() {
    return this.live && (!this.canSeek || !this.userBehindLiveEdge && this.currentTime >= this.liveEdgeStart);
  },
  get liveEdgeWindow() {
    return this.live && Number.isFinite(this.seekableEnd) ? this.seekableEnd - this.liveEdgeStart : 0;
  },
  get isLiveDVR() {
    return /:dvr/.test(this.streamType);
  },
  get liveDVRWindow() {
    return Math.max(this.inferredLiveDVRWindow, this.minLiveDVRWindow);
  },
  // ~~ internal props ~~
  autoPlaying: !1,
  providedTitle: "",
  inferredTitle: "",
  providedLoop: !1,
  userPrefersLoop: !1,
  providedPoster: "",
  inferredPoster: "",
  inferredViewType: "unknown",
  providedViewType: "unknown",
  providedStreamType: "unknown",
  inferredStreamType: "unknown",
  liveSyncPosition: null,
  inferredLiveDVRWindow: 0,
  savedState: null
}), e_ = /* @__PURE__ */ new Set([
  "autoPlayError",
  "autoPlaying",
  "buffered",
  "canPlay",
  "error",
  "paused",
  "played",
  "playing",
  "seekable",
  "seeking",
  "waiting"
]), UB = /* @__PURE__ */ new Set([
  ...e_,
  "ended",
  "inferredPoster",
  "inferredStreamType",
  "inferredTitle",
  "intrinsicDuration",
  "inferredLiveDVRWindow",
  "liveSyncPosition",
  "realCurrentTime",
  "savedState",
  "started",
  "userBehindLiveEdge"
]);
function VA(f, s = !1) {
  const n = s ? e_ : UB;
  xy.reset(f, (o) => n.has(o)), Xu();
}
function t_(f, s) {
  const n = f + s.clipStartTime(), o = Math.floor(f) === Math.floor(s.seekableStart()), h = Math.floor(n) === Math.floor(s.seekableEnd());
  return o ? s.seekableStart() : h ? s.seekableEnd() : s.isLiveDVR() && s.liveDVRWindow() > 0 && n < s.seekableEnd() - s.liveDVRWindow() ? s.bufferedStart() : Math.min(Math.max(s.seekableStart() + 0.1, n), s.seekableEnd() - 0.1);
}
const UM = Cy();
function Ua() {
  return Us(UM);
}
var gh, ts, vv, a0, Bt, nn, zB;
class n_ {
  constructor(s = void 0) {
    R(this, Bt);
    R(this, gh, null);
    R(this, ts, null);
    R(this, vv, -1);
    R(this, a0);
    L(this, a0, s);
  }
  /**
   * Set the target from which to dispatch media requests events from. The events should bubble
   * up from this target to the player element.
   *
   * @example
   * ```ts
   * const button = document.querySelector('button');
   * remote.setTarget(button);
   * ```
   */
  setTarget(s) {
    L(this, gh, s);
  }
  /**
   * Returns the current player element. This method will attempt to find the player by
   * searching up from either the given `target` or default target set via `remote.setTarget`.
   *
   * @example
   * ```ts
   * const player = remote.getPlayer();
   * ```
   */
  getPlayer(s) {
    var n;
    return d(this, ts) ? d(this, ts) : ((n = s ?? d(this, gh)) == null || n.dispatchEvent(
      new vt("find-media-player", {
        detail: (o) => void L(this, ts, o),
        bubbles: !0,
        composed: !0
      })
    ), d(this, ts));
  }
  /**
   * Set the current player element so the remote can support toggle methods such as
   * `togglePaused` as they rely on the current media state.
   */
  setPlayer(s) {
    L(this, ts, s);
  }
  /**
   * Dispatch a request to start the media loading process. This will only work if the media
   * player has been initialized with a custom loading strategy `load="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoading(s) {
    S(this, Bt, nn).call(this, "media-start-loading", s);
  }
  /**
   * Dispatch a request to start the poster loading process. This will only work if the media
   * player has been initialized with a custom poster loading strategy `posterLoad="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoadingPoster(s) {
    S(this, Bt, nn).call(this, "media-poster-start-loading", s);
  }
  /**
   * Dispatch a request to connect to AirPlay.
   *
   * @see {@link https://www.apple.com/au/airplay}
   */
  requestAirPlay(s) {
    S(this, Bt, nn).call(this, "media-airplay-request", s);
  }
  /**
   * Dispatch a request to connect to Google Cast.
   *
   * @see {@link https://developers.google.com/cast/docs/overview}
   */
  requestGoogleCast(s) {
    S(this, Bt, nn).call(this, "media-google-cast-request", s);
  }
  /**
   * Dispatch a request to begin/resume media playback.
   */
  play(s) {
    S(this, Bt, nn).call(this, "media-play-request", s);
  }
  /**
   * Dispatch a request to pause media playback.
   */
  pause(s) {
    S(this, Bt, nn).call(this, "media-pause-request", s);
  }
  /**
   * Dispatch a request to set the media volume to mute (0).
   */
  mute(s) {
    S(this, Bt, nn).call(this, "media-mute-request", s);
  }
  /**
   * Dispatch a request to unmute the media volume and set it back to it's previous state.
   */
  unmute(s) {
    S(this, Bt, nn).call(this, "media-unmute-request", s);
  }
  /**
   * Dispatch a request to enter fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  enterFullscreen(s, n) {
    S(this, Bt, nn).call(this, "media-enter-fullscreen-request", n, s);
  }
  /**
   * Dispatch a request to exit fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  exitFullscreen(s, n) {
    S(this, Bt, nn).call(this, "media-exit-fullscreen-request", n, s);
  }
  /**
   * Dispatch a request to lock the screen orientation.
   *
   * @docs {@link https://www.vidstack.io/docs/player/screen-orientation#remote-control}
   */
  lockScreenOrientation(s, n) {
    S(this, Bt, nn).call(this, "media-orientation-lock-request", n, s);
  }
  /**
   * Dispatch a request to unlock the screen orientation.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/screen-orientation#remote-control}
   */
  unlockScreenOrientation(s) {
    S(this, Bt, nn).call(this, "media-orientation-unlock-request", s);
  }
  /**
   * Dispatch a request to enter picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  enterPictureInPicture(s) {
    S(this, Bt, nn).call(this, "media-enter-pip-request", s);
  }
  /**
   * Dispatch a request to exit picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  exitPictureInPicture(s) {
    S(this, Bt, nn).call(this, "media-exit-pip-request", s);
  }
  /**
   * Notify the media player that a seeking process is happening and to seek to the given `time`.
   */
  seeking(s, n) {
    S(this, Bt, nn).call(this, "media-seeking-request", n, s);
  }
  /**
   * Notify the media player that a seeking operation has completed and to seek to the given `time`.
   * This is generally called after a series of `remote.seeking()` calls.
   */
  seek(s, n) {
    S(this, Bt, nn).call(this, "media-seek-request", n, s);
  }
  seekToLiveEdge(s) {
    S(this, Bt, nn).call(this, "media-live-edge-request", s);
  }
  /**
   * Dispatch a request to update the length of the media in seconds.
   *
   * @example
   * ```ts
   * remote.changeDuration(100); // 100 seconds
   * ```
   */
  changeDuration(s, n) {
    S(this, Bt, nn).call(this, "media-duration-change-request", n, s);
  }
  /**
   * Dispatch a request to update the clip start time. This is the time at which media playback
   * should start at.
   *
   * @example
   * ```ts
   * remote.changeClipStart(100); // start at 100 seconds
   * ```
   */
  changeClipStart(s, n) {
    S(this, Bt, nn).call(this, "media-clip-start-change-request", n, s);
  }
  /**
   * Dispatch a request to update the clip end time. This is the time at which media playback
   * should end at.
   *
   * @example
   * ```ts
   * remote.changeClipEnd(100); // end at 100 seconds
   * ```
   */
  changeClipEnd(s, n) {
    S(this, Bt, nn).call(this, "media-clip-end-change-request", n, s);
  }
  /**
   * Dispatch a request to update the media volume to the given `volume` level which is a value
   * between 0 and 1.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/audio-gain#remote-control}
   * @example
   * ```ts
   * remote.changeVolume(0); // 0%
   * remote.changeVolume(0.05); // 5%
   * remote.changeVolume(0.5); // 50%
   * remote.changeVolume(0.75); // 70%
   * remote.changeVolume(1); // 100%
   * ```
   */
  changeVolume(s, n) {
    S(this, Bt, nn).call(this, "media-volume-change-request", n, Math.max(0, Math.min(1, s)));
  }
  /**
   * Dispatch a request to change the current audio track.
   *
   * @example
   * ```ts
   * remote.changeAudioTrack(1); // track at index 1
   * ```
   */
  changeAudioTrack(s, n) {
    S(this, Bt, nn).call(this, "media-audio-track-change-request", n, s);
  }
  /**
   * Dispatch a request to change the video quality. The special value `-1` represents auto quality
   * selection.
   *
   * @example
   * ```ts
   * remote.changeQuality(-1); // auto
   * remote.changeQuality(1); // quality at index 1
   * ```
   */
  changeQuality(s, n) {
    S(this, Bt, nn).call(this, "media-quality-change-request", n, s);
  }
  /**
   * Request auto quality selection.
   */
  requestAutoQuality(s) {
    this.changeQuality(-1, s);
  }
  /**
   * Dispatch a request to change the mode of the text track at the given index.
   *
   * @example
   * ```ts
   * remote.changeTextTrackMode(1, 'showing'); // track at index 1
   * ```
   */
  changeTextTrackMode(s, n, o) {
    S(this, Bt, nn).call(this, "media-text-track-change-request", o, {
      index: s,
      mode: n
    });
  }
  /**
   * Dispatch a request to change the media playback rate.
   *
   * @example
   * ```ts
   * remote.changePlaybackRate(0.5); // Half the normal speed
   * remote.changePlaybackRate(1); // Normal speed
   * remote.changePlaybackRate(1.5); // 50% faster than normal
   * remote.changePlaybackRate(2); // Double the normal speed
   * ```
   */
  changePlaybackRate(s, n) {
    S(this, Bt, nn).call(this, "media-rate-change-request", n, s);
  }
  /**
   * Dispatch a request to change the media audio gain.
   *
   * @example
   * ```ts
   * remote.changeAudioGain(1); // Disable audio gain
   * remote.changeAudioGain(1.5); // 50% louder
   * remote.changeAudioGain(2); // 100% louder
   * ```
   */
  changeAudioGain(s, n) {
    S(this, Bt, nn).call(this, "media-audio-gain-change-request", n, s);
  }
  /**
   * Dispatch a request to resume idle tracking on controls.
   */
  resumeControls(s) {
    S(this, Bt, nn).call(this, "media-resume-controls-request", s);
  }
  /**
   * Dispatch a request to pause controls idle tracking. Pausing tracking will result in the
   * controls being visible until `remote.resumeControls()` is called. This method
   * is generally used when building custom controls and you'd like to prevent the UI from
   * disappearing.
   *
   * @example
   * ```ts
   * // Prevent controls hiding while menu is being interacted with.
   * function onSettingsOpen() {
   *   remote.pauseControls();
   * }
   *
   * function onSettingsClose() {
   *   remote.resumeControls();
   * }
   * ```
   */
  pauseControls(s) {
    S(this, Bt, nn).call(this, "media-pause-controls-request", s);
  }
  /**
   * Dispatch a request to toggle the media playback state.
   */
  togglePaused(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    n && (n.state.paused ? this.play(s) : this.pause(s));
  }
  /**
   * Dispatch a request to toggle the controls visibility.
   */
  toggleControls(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    n && (n.controls.showing ? n.controls.hide(0, s) : n.controls.show(0, s));
  }
  /**
   * Dispatch a request to toggle the media muted state.
   */
  toggleMuted(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    n && (n.state.muted ? this.unmute(s) : this.mute(s));
  }
  /**
   * Dispatch a request to toggle the media fullscreen state.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  toggleFullscreen(s, n) {
    const o = this.getPlayer(n == null ? void 0 : n.target);
    o && (o.state.fullscreen ? this.exitFullscreen(s, n) : this.enterFullscreen(s, n));
  }
  /**
   * Dispatch a request to toggle the media picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  togglePictureInPicture(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    n && (n.state.pictureInPicture ? this.exitPictureInPicture(s) : this.enterPictureInPicture(s));
  }
  /**
   * Show captions.
   */
  showCaptions(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    if (!n)
      return;
    let o = n.state.textTracks, h = d(this, vv);
    (!o[h] || !_a(o[h])) && (h = -1), h === -1 && (h = o.findIndex((v) => _a(v) && v.default)), h === -1 && (h = o.findIndex((v) => _a(v))), h >= 0 && this.changeTextTrackMode(h, "showing", s), L(this, vv, -1);
  }
  /**
   * Turn captions off.
   */
  disableCaptions(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    if (!n)
      return;
    const o = n.state.textTracks, h = n.state.textTrack;
    if (h) {
      const v = o.indexOf(h);
      this.changeTextTrackMode(v, "disabled", s), L(this, vv, v);
    }
  }
  /**
   * Dispatch a request to toggle the current captions mode.
   */
  toggleCaptions(s) {
    const n = this.getPlayer(s == null ? void 0 : s.target);
    n && (n.state.textTrack ? this.disableCaptions() : this.showCaptions());
  }
  userPrefersLoopChange(s, n) {
    S(this, Bt, nn).call(this, "media-user-loop-change-request", n, s);
  }
}
gh = new WeakMap(), ts = new WeakMap(), vv = new WeakMap(), a0 = new WeakMap(), Bt = new WeakSet(), nn = function(s, n, o) {
  var k, D;
  const h = new vt(s, {
    bubbles: !0,
    composed: !0,
    cancelable: !0,
    detail: o,
    trigger: n
  });
  let v = (n == null ? void 0 : n.target) || null;
  v && v instanceof Ci && (v = v.el), v = !v || v === document || v === window || v === document.body || ((k = d(this, ts)) == null ? void 0 : k.el) && v instanceof Node && !d(this, ts).el.contains(v) ? d(this, gh) ?? ((D = this.getPlayer()) == null ? void 0 : D.el) : v ?? d(this, gh), d(this, ts) ? s === "media-play-request" && !d(this, ts).state.canLoad ? v == null || v.dispatchEvent(h) : d(this, ts).canPlayQueue.enqueue(s, () => v == null ? void 0 : v.dispatchEvent(h)) : v == null || v.dispatchEvent(h);
}, zB = function(s) {
};
var cw = FB;
function FB(f, s, n) {
  var o = null, h = null, v = n && n.leading, y = n && n.trailing;
  v == null && (v = !0), y == null && (y = !v), v == !0 && (y = !1);
  var k = function() {
    o && (clearTimeout(o), o = null);
  }, D = function() {
    var _ = h;
    k(), _ && _();
  }, $ = function() {
    var _ = v && !o, A = this, B = arguments;
    if (h = function() {
      return f.apply(A, B);
    }, o || (o = setTimeout(function() {
      if (o = null, y)
        return h();
    }, s)), _)
      return _ = !1, h();
  };
  return $.cancel = k, $.flush = D, $;
}
var ii;
class VB {
  constructor() {
    Z(this, "playerId", "vds-player");
    Z(this, "mediaId", null);
    R(this, ii, {
      volume: null,
      muted: null,
      audioGain: null,
      time: null,
      lang: null,
      captions: null,
      rate: null,
      quality: null
    });
    Z(this, "saveTimeThrottled", cw(this.saveTime.bind(this), 1e3));
  }
  async getVolume() {
    return d(this, ii).volume;
  }
  async setVolume(s) {
    d(this, ii).volume = s, this.save();
  }
  async getMuted() {
    return d(this, ii).muted;
  }
  async setMuted(s) {
    d(this, ii).muted = s, this.save();
  }
  async getTime() {
    return d(this, ii).time;
  }
  async setTime(s, n) {
    const o = s < 0;
    d(this, ii).time = o ? null : s, o || n ? this.saveTime() : this.saveTimeThrottled();
  }
  async getLang() {
    return d(this, ii).lang;
  }
  async setLang(s) {
    d(this, ii).lang = s, this.save();
  }
  async getCaptions() {
    return d(this, ii).captions;
  }
  async setCaptions(s) {
    d(this, ii).captions = s, this.save();
  }
  async getPlaybackRate() {
    return d(this, ii).rate;
  }
  async setPlaybackRate(s) {
    d(this, ii).rate = s, this.save();
  }
  async getAudioGain() {
    return d(this, ii).audioGain;
  }
  async setAudioGain(s) {
    d(this, ii).audioGain = s, this.save();
  }
  async getVideoQuality() {
    return d(this, ii).quality;
  }
  async setVideoQuality(s) {
    d(this, ii).quality = s, this.save();
  }
  onChange(s, n, o = "vds-player") {
    const h = o ? localStorage.getItem(o) : null, v = n ? localStorage.getItem(n) : null;
    this.playerId = o, this.mediaId = n, L(this, ii, {
      volume: null,
      muted: null,
      audioGain: null,
      lang: null,
      captions: null,
      rate: null,
      quality: null,
      ...h ? JSON.parse(h) : {},
      time: v ? +v : null
    });
  }
  save() {
    if (!this.playerId) return;
    const s = JSON.stringify({ ...d(this, ii), time: void 0 });
    localStorage.setItem(this.playerId, s);
  }
  saveTime() {
    if (!this.mediaId) return;
    const s = (d(this, ii).time ?? 0).toString();
    localStorage.setItem(this.mediaId, s);
  }
}
ii = new WeakMap();
const HB = Symbol(0), IB = Symbol(0), qB = Symbol(0), jB = Symbol(0), BB = Symbol(0), QB = Symbol(0), YB = Symbol(0), GB = Symbol(0), WB = Symbol(0), at = {
  add: HB,
  remove: IB,
  reset: qB,
  select: jB,
  readonly: BB,
  setReadonly: QB,
  onReset: YB,
  onRemove: GB,
  onUserSelect: WB
};
var bP;
class i_ extends NP {
  constructor() {
    super(...arguments);
    Z(this, "items", []);
    /** @internal */
    Z(this, bP, !1);
  }
  get length() {
    return this.items.length;
  }
  get readonly() {
    return this[at.readonly];
  }
  /**
   * Returns the index of the first occurrence of the given item, or -1 if it is not present.
   */
  indexOf(n) {
    return this.items.indexOf(n);
  }
  /**
   * Returns an item matching the given `id`, or `null` if not present.
   */
  getById(n) {
    return n === "" ? null : this.items.find((o) => o.id === n) ?? null;
  }
  /**
   * Transform list to an array.
   */
  toArray() {
    return [...this.items];
  }
  [(bP = at.readonly, Symbol.iterator)]() {
    return this.items.values();
  }
  /** @internal */
  [at.add](n, o) {
    const h = this.items.length;
    "" + h in this || Object.defineProperty(this, h, {
      get() {
        return this.items[h];
      }
    }), !this.items.includes(n) && (this.items.push(n), this.dispatchEvent(new vt("add", { detail: n, trigger: o })));
  }
  /** @internal */
  [at.remove](n, o) {
    var v;
    const h = this.items.indexOf(n);
    h >= 0 && ((v = this[at.onRemove]) == null || v.call(this, n, o), this.items.splice(h, 1), this.dispatchEvent(new vt("remove", { detail: n, trigger: o })));
  }
  /** @internal */
  [at.reset](n) {
    var o;
    for (const h of [...this.items]) this[at.remove](h, n);
    this.items = [], this[at.setReadonly](!1, n), (o = this[at.onReset]) == null || o.call(this);
  }
  /** @internal */
  [at.setReadonly](n, o) {
    this[at.readonly] !== n && (this[at.readonly] = n, this.dispatchEvent(new vt("readonly-change", { detail: n, trigger: o })));
  }
}
const ZS = Symbol(0);
class r_ extends i_ {
  get selected() {
    return this.items.find((s) => s.selected) ?? null;
  }
  get selectedIndex() {
    return this.items.findIndex((s) => s.selected);
  }
  /** @internal */
  [at.onRemove](s, n) {
    this[at.select](s, !1, n);
  }
  /** @internal */
  [at.add](s, n) {
    s[ZS] = !1, Object.defineProperty(s, "selected", {
      get() {
        return this[ZS];
      },
      set: (o) => {
        var h;
        this.readonly || ((h = this[at.onUserSelect]) == null || h.call(this), this[at.select](s, o));
      }
    }), super[at.add](s, n);
  }
  /** @internal */
  [at.select](s, n, o) {
    if (n === (s == null ? void 0 : s[ZS])) return;
    const h = this.selected;
    s && (s[ZS] = n), (n ? h !== s : h === s) && (h && (h[ZS] = !1), this.dispatchEvent(
      new vt("change", {
        detail: {
          prev: h,
          current: this.selected
        },
        trigger: o
      })
    ));
  }
}
class KB extends r_ {
}
function Na(f, s = 2) {
  return Number(f.toFixed(s));
}
function AR(f) {
  var s;
  return ((s = String(f).split(".")[1]) == null ? void 0 : s.length) ?? 0;
}
function zM(f, s, n) {
  return Math.max(f, Math.min(n, s));
}
function HA(f, s) {
  const n = s.composedPath()[0];
  return Xj(n) && f.contains(n);
}
const PR = /* @__PURE__ */ new Set();
{
  let f = function() {
    for (const s of PR)
      try {
        s();
      } catch {
      }
    window.requestAnimationFrame(f);
  };
  f();
}
function XB(f) {
  return PR.add(f), () => PR.delete(f);
}
function Wi(f, s, n) {
  f.hasAttribute(s) || f.setAttribute(s, n);
}
function ZB(f, s) {
  if (f.hasAttribute("aria-label") || f.hasAttribute("data-no-label")) return;
  if (!ls(s)) {
    Rt(f, "aria-label", s);
    return;
  }
  function n() {
    Rt(f, "aria-label", s());
  }
  J(n);
}
function a_(f) {
  const s = getComputedStyle(f);
  return s.display !== "none" && parseInt(s.opacity) > 0;
}
function JB(f) {
  return !!f && ("checkVisibility" in f ? f.checkVisibility({ checkOpacity: !0, checkVisibilityCSS: !0 }) : a_(f));
}
function s_(f, s) {
  return XB(() => s(JB(f)));
}
function l_(f, s, n) {
  for (; s; ) {
    if (s === f)
      return !0;
    if (n != null && n(s))
      break;
    s = s.parentElement;
  }
  return !1;
}
function vy(f, s) {
  return new gn(f).add("pointerup", (n) => {
    n.button === 0 && !n.defaultPrevented && s(n);
  }).add("keydown", (n) => {
    UP(n) && s(n);
  });
}
function o_(f) {
  return Wj(f) && (f.touches.length > 1 || f.changedTouches.length > 1);
}
function e5(f) {
  return getComputedStyle(f).animationName !== "none";
}
function Zb(f) {
  return f instanceof HTMLElement;
}
var fT, Lu, hT, id, zs, u_, c_, _R, NR;
class t5 {
  constructor() {
    R(this, zs);
    Z(this, "priority", 0);
    R(this, fT, !0);
    R(this, Lu, null);
    R(this, hT, null);
    R(this, id, /* @__PURE__ */ new Set());
  }
  canRender(s, n) {
    return !!n;
  }
  attach(s) {
    L(this, Lu, s), s && (s.textTracks.onchange = S(this, zs, NR).bind(this));
  }
  addTrack(s) {
    d(this, id).add(s), S(this, zs, u_).call(this, s);
  }
  removeTrack(s) {
    var n, o;
    (o = (n = s[tt.native]) == null ? void 0 : n.remove) == null || o.call(n), s[tt.native] = null, d(this, id).delete(s);
  }
  changeTrack(s) {
    const n = s == null ? void 0 : s[tt.native];
    n && n.track.mode !== "showing" && (n.track.mode = "showing"), L(this, hT, s);
  }
  setDisplay(s) {
    L(this, fT, s), S(this, zs, NR).call(this);
  }
  detach() {
    d(this, Lu) && (d(this, Lu).textTracks.onchange = null);
    for (const s of d(this, id)) this.removeTrack(s);
    d(this, id).clear(), L(this, Lu, null), L(this, hT, null);
  }
}
fT = new WeakMap(), Lu = new WeakMap(), hT = new WeakMap(), id = new WeakMap(), zs = new WeakSet(), u_ = function(s) {
  var o;
  if (!d(this, Lu)) return;
  const n = s[o = tt.native] ?? (s[o] = S(this, zs, c_).call(this, s));
  Zb(n) && (d(this, Lu).append(n), n.track.mode = n.default ? "showing" : "disabled");
}, c_ = function(s) {
  const n = document.createElement("track"), o = s.default || s.mode === "showing", h = s.src && s.type === "vtt";
  return n.id = s.id, n.src = h ? s.src : "", n.label = s.label, n.kind = s.kind, n.default = o, s.language && (n.srclang = s.language), o && !h && S(this, zs, _R).call(this, s, n.track), n;
}, _R = function(s, n) {
  var o;
  if (!(s.src && s.type === "vtt" || (o = n.cues) != null && o.length))
    for (const h of s.cues) n.addCue(h);
}, NR = function(s) {
  for (const n of d(this, id)) {
    const o = n[tt.native];
    if (!o) continue;
    if (!d(this, fT)) {
      o.track.mode = o.managed ? "hidden" : "disabled";
      continue;
    }
    const h = o.track.mode === "showing";
    h && S(this, zs, _R).call(this, n, o.track), n.setMode(h ? "showing" : "disabled", s);
  }
};
var Sh, yv, Th, pT, mT, ns, so, hi, d_, UR, f_, h_, p_, av, m_;
class n5 {
  constructor(s) {
    R(this, hi);
    R(this, Sh, null);
    R(this, yv);
    R(this, Th, []);
    R(this, pT);
    R(this, mT, !1);
    R(this, ns, null);
    R(this, so, null);
    L(this, pT, s);
    const n = s.textTracks;
    L(this, yv, n), J(S(this, hi, d_).bind(this)), Wt(S(this, hi, m_).bind(this)), new gn(n).add("add", S(this, hi, h_).bind(this)).add("remove", S(this, hi, p_).bind(this)).add("mode-change", S(this, hi, av).bind(this));
  }
  add(s) {
    d(this, Th).push(s), py(S(this, hi, av).bind(this));
  }
  remove(s) {
    s.detach(), d(this, Th).splice(d(this, Th).indexOf(s), 1), py(S(this, hi, av).bind(this));
  }
  /** @internal */
  attachVideo(s) {
    requestAnimationFrame(() => {
      if (L(this, Sh, s), s) {
        L(this, ns, new t5()), d(this, ns).attach(s);
        for (const n of d(this, yv)) S(this, hi, UR).call(this, n);
      }
      S(this, hi, av).call(this);
    });
  }
}
Sh = new WeakMap(), yv = new WeakMap(), Th = new WeakMap(), pT = new WeakMap(), mT = new WeakMap(), ns = new WeakMap(), so = new WeakMap(), hi = new WeakSet(), d_ = function() {
  const { nativeControls: s } = d(this, pT).$state;
  L(this, mT, s()), S(this, hi, av).call(this);
}, UR = function(s) {
  var n;
  _a(s) && ((n = d(this, ns)) == null || n.addTrack(s));
}, f_ = function(s) {
  var n;
  _a(s) && ((n = d(this, ns)) == null || n.removeTrack(s));
}, h_ = function(s) {
  S(this, hi, UR).call(this, s.detail);
}, p_ = function(s) {
  S(this, hi, f_).call(this, s.detail);
}, av = function() {
  var o, h, v, y, k, D, $;
  const s = d(this, yv).selected;
  if (d(this, Sh) && (d(this, mT) || s != null && s[tt.nativeHLS])) {
    (o = d(this, so)) == null || o.changeTrack(null), (h = d(this, ns)) == null || h.setDisplay(!0), (v = d(this, ns)) == null || v.changeTrack(s);
    return;
  }
  if ((y = d(this, ns)) == null || y.setDisplay(!1), (k = d(this, ns)) == null || k.changeTrack(null), !s) {
    (D = d(this, so)) == null || D.changeTrack(null);
    return;
  }
  const n = d(this, Th).sort((_, A) => _.priority - A.priority).find((_) => _.canRender(s, d(this, Sh)));
  d(this, so) !== n && (($ = d(this, so)) == null || $.detach(), n == null || n.attach(d(this, Sh)), L(this, so, n ?? null)), n == null || n.changeTrack(s);
}, m_ = function() {
  var s, n;
  (s = d(this, ns)) == null || s.detach(), L(this, ns, null), (n = d(this, so)) == null || n.detach(), L(this, so, null);
};
var FM = i5;
function i5(f, s, n) {
  var o = null, h = null, v = function() {
    o && (clearTimeout(o), h = null, o = null);
  }, y = function() {
    var D = h;
    v(), D && D();
  }, k = function() {
    if (!s)
      return f.apply(this, arguments);
    var D = this, $ = arguments, _ = n && !o;
    if (v(), h = function() {
      f.apply(D, $);
    }, o = setTimeout(function() {
      if (o = null, !_) {
        var A = h;
        return h = null, A();
      }
    }, s), _)
      return h();
  };
  return k.cancel = v, k.flush = y, k;
}
var kP, wh, lo, oo, uo, vT, gv, yT, Co, v_, zR, FR;
class r5 extends i_ {
  constructor() {
    super();
    R(this, Co);
    R(this, wh, !1);
    R(this, lo, {});
    R(this, oo, null);
    R(this, uo, null);
    /** @internal */
    Z(this, kP);
    R(this, vT, FM(async () => {
      var h;
      if (!d(this, wh)) return;
      !d(this, uo) && d(this, oo) && L(this, uo, await d(this, oo).getLang());
      const n = await ((h = d(this, oo)) == null ? void 0 : h.getCaptions()), o = [
        ["captions", "subtitles"],
        "chapters",
        "descriptions",
        "metadata"
      ];
      for (const v of o) {
        const y = this.getByKind(v);
        if (y.find((A) => A.mode === "showing")) continue;
        const k = d(this, uo) ? y.find((A) => A.language === d(this, uo)) : null, D = Vr(v) ? d(this, lo)[v.find((A) => d(this, lo)[A]) || ""] : d(this, lo)[v], $ = k ?? D, _ = $ && _a($);
        $ && (!_ || n !== !1) && ($.mode = "showing", _ && S(this, Co, zR).call(this, $));
      }
    }, 300));
    R(this, gv, null);
    R(this, yT, S(this, Co, v_).bind(this));
  }
  get selected() {
    return this.items.find((o) => o.mode === "showing" && _a(o)) ?? null;
  }
  get selectedIndex() {
    const n = this.selected;
    return n ? this.indexOf(n) : -1;
  }
  get preferredLang() {
    return d(this, uo);
  }
  set preferredLang(n) {
    L(this, uo, n), S(this, Co, FR).call(this, n);
  }
  add(n, o) {
    const h = n instanceof Ud, v = h ? n : new Ud(n), y = n.kind === "captions" || n.kind === "subtitles" ? "captions" : n.kind;
    return d(this, lo)[y] && n.default && delete n.default, v.addEventListener("mode-change", d(this, yT)), this[at.add](v, o), v[tt.crossOrigin] = this[tt.crossOrigin], d(this, wh) && v[tt.canLoad](), n.default && (d(this, lo)[y] = v), d(this, vT).call(this), this;
  }
  remove(n, o) {
    if (L(this, gv, n), !!this.items.includes(n))
      return n === d(this, lo)[n.kind] && delete d(this, lo)[n.kind], n.mode = "disabled", n[tt.onModeChange] = null, n.removeEventListener("mode-change", d(this, yT)), this[at.remove](n, o), L(this, gv, null), this;
  }
  clear(n) {
    for (const o of [...this.items])
      this.remove(o, n);
    return this;
  }
  getByKind(n) {
    const o = Array.isArray(n) ? n : [n];
    return this.items.filter((h) => o.includes(h.kind));
  }
  /** @internal */
  [(kP = tt.crossOrigin, tt.canLoad)]() {
    if (!d(this, wh)) {
      for (const n of this.items) n[tt.canLoad]();
      L(this, wh, !0), d(this, vT).call(this);
    }
  }
  setStorage(n) {
    L(this, oo, n);
  }
}
wh = new WeakMap(), lo = new WeakMap(), oo = new WeakMap(), uo = new WeakMap(), vT = new WeakMap(), gv = new WeakMap(), yT = new WeakMap(), Co = new WeakSet(), v_ = function(n) {
  const o = n.detail;
  if (d(this, oo) && _a(o) && o !== d(this, gv) && S(this, Co, zR).call(this, o), o.mode === "showing") {
    const h = _a(o) ? ["captions", "subtitles"] : [o.kind];
    for (const v of this.items)
      v.mode === "showing" && v != o && h.includes(v.kind) && (v.mode = "disabled");
  }
  this.dispatchEvent(
    new vt("mode-change", {
      detail: n.detail,
      trigger: n
    })
  );
}, zR = function(n) {
  var o, h;
  n.mode !== "disabled" && S(this, Co, FR).call(this, n.language), (h = (o = d(this, oo)) == null ? void 0 : o.setCaptions) == null || h.call(
    o,
    this.items.some((v) => _a(v) && v.mode === "showing")
  );
}, FR = function(n) {
  var o, h;
  (h = (o = d(this, oo)) == null ? void 0 : o.setLang) == null || h.call(o, L(this, uo, n));
};
const a5 = Symbol(0), s5 = Symbol(0), la = {
  setAuto: a5,
  enableAuto: s5
};
var xP, Eh;
class l5 extends r_ {
  constructor() {
    super(...arguments);
    R(this, Eh, !1);
    /**
     * Configures quality switching:
     *
     * - `current`: Trigger an immediate quality level switch. This will abort the current fragment
     * request if any, flush the whole buffer, and fetch fragment matching with current position
     * and requested quality level.
     *
     * - `next`: Trigger a quality level switch for next fragment. This could eventually flush
     * already buffered next fragment.
     *
     * - `load`: Set quality level for next loaded fragment.
     *
     * @see {@link https://www.vidstack.io/docs/player/api/video-quality#switch}
     * @see {@link https://github.com/video-dev/hls.js/blob/master/docs/API.md#quality-switch-control-api}
     */
    Z(this, "switch", "current");
    /** @internal */
    Z(this, xP);
  }
  /**
   * Whether automatic quality selection is enabled.
   */
  get auto() {
    return d(this, Eh) || this.readonly;
  }
  /** @internal */
  [(xP = la.enableAuto, at.onUserSelect)]() {
    this[la.setAuto](!1);
  }
  /** @internal */
  [at.onReset](n) {
    this[la.enableAuto] = void 0, this[la.setAuto](!1, n);
  }
  /**
   * Request automatic quality selection (if supported). This will be a no-op if the list is
   * `readonly` as that already implies auto-selection.
   */
  autoSelect(n) {
    var o;
    this.readonly || d(this, Eh) || !this[la.enableAuto] || ((o = this[la.enableAuto]) == null || o.call(this, n), this[la.setAuto](!0, n));
  }
  getBySrc(n) {
    return this.items.find((o) => o.src === n);
  }
  /** @internal */
  [la.setAuto](n, o) {
    d(this, Eh) !== n && (L(this, Eh, n), this.dispatchEvent(
      new vt("auto-change", {
        detail: n,
        trigger: o
      })
    ));
  }
}
Eh = new WeakMap();
function o5(f, s) {
  return [...f].sort(s ? c5 : u5);
}
function u5(f, s) {
  return f.height === s.height ? (f.bitrate ?? 0) - (s.bitrate ?? 0) : f.height - s.height;
}
function c5(f, s) {
  return s.height === f.height ? (s.bitrate ?? 0) - (f.bitrate ?? 0) : s.height - f.height;
}
function bQ(f) {
  return (f == null ? void 0 : f.$$PROVIDER_TYPE) === "AUDIO";
}
function kQ(f) {
  return (f == null ? void 0 : f.$$PROVIDER_TYPE) === "VIDEO";
}
function xQ(f) {
  return (f == null ? void 0 : f.$$PROVIDER_TYPE) === "DASH";
}
function RQ(f) {
  return (f == null ? void 0 : f.$$PROVIDER_TYPE) === "YOUTUBE";
}
function DQ(f) {
  return (f == null ? void 0 : f.$$PROVIDER_TYPE) === "VIMEO";
}
function d5(f) {
  return f instanceof HTMLAudioElement;
}
function f5(f) {
  return f instanceof HTMLVideoElement;
}
function h5(f) {
  return d5(f) || f5(f);
}
class rp extends Hs {
}
const p5 = {
  togglePaused: "k Space",
  toggleMuted: "m",
  toggleFullscreen: "f",
  togglePictureInPicture: "i",
  toggleCaptions: "c",
  seekBackward: "j J ArrowLeft",
  seekForward: "l L ArrowRight",
  volumeUp: "ArrowUp",
  volumeDown: "ArrowDown",
  speedUp: ">",
  slowDown: "<"
}, eT = /* @__PURE__ */ new Set(["Shift", "Alt", "Meta", "Ctrl"]), m5 = 'button, [role="button"]', IA = 'input, textarea, select, [contenteditable], [role^="menuitem"], [role="timer"]';
var Yi, mi, y_, g_, S_, T_, bb, Ch, w_, $u, VR, E_;
class v5 extends rp {
  constructor(n) {
    super();
    R(this, mi);
    R(this, Yi);
    R(this, Ch);
    R(this, $u, null);
    L(this, Yi, n);
  }
  onConnect() {
    J(S(this, mi, y_).bind(this));
  }
}
Yi = new WeakMap(), mi = new WeakSet(), y_ = function() {
  const { keyDisabled: n, keyTarget: o } = this.$props;
  if (n()) return;
  const h = o() === "player" ? this.el : document, v = st(!1);
  h === this.el ? new gn(this.el).add("focusin", () => v.set(!0)).add("focusout", (y) => {
    this.el.contains(y.target) || v.set(!1);
  }) : (ye(v) || v.set(document.querySelector("[data-media-player]") === this.el), En(document, "focusin", (y) => {
    const k = y.composedPath().find((D) => D instanceof Element && D.localName === "media-player");
    k !== void 0 && v.set(this.el === k);
  })), J(() => {
    v() && new gn(h).add("keyup", S(this, mi, g_).bind(this)).add("keydown", S(this, mi, S_).bind(this)).add("keydown", S(this, mi, T_).bind(this), { capture: !0 });
  });
}, g_ = function(n) {
  var y, k;
  const o = document.activeElement;
  if (!n.key || !this.$state.canSeek() || o != null && o.matches(IA))
    return;
  let { method: h, value: v } = S(this, mi, bb).call(this, n);
  if (!Ze(v) && !Vr(v)) {
    (y = v == null ? void 0 : v.onKeyUp) == null || y.call(v, {
      event: n,
      player: d(this, Yi).player,
      remote: d(this, Yi).remote
    }), (k = v == null ? void 0 : v.callback) == null || k.call(v, n, d(this, Yi).remote);
    return;
  }
  if (h != null && h.startsWith("seek") && (n.preventDefault(), n.stopPropagation(), d(this, $u) ? (S(this, mi, VR).call(this, n, h === "seekForward"), L(this, $u, null)) : (d(this, Yi).remote.seek(d(this, Ch), n), L(this, Ch, void 0))), h != null && h.startsWith("volume")) {
    const D = this.el.querySelector("[data-media-volume-slider]");
    D == null || D.dispatchEvent(
      new KeyboardEvent("keyup", {
        key: h === "volumeUp" ? "Up" : "Down",
        shiftKey: n.shiftKey,
        trigger: n
      })
    );
  }
}, S_ = function(n) {
  var k, D, $, _;
  if (!n.key || eT.has(n.key)) return;
  const o = document.activeElement;
  if (o != null && o.matches(IA) || UP(n) && (o != null && o.matches(m5)))
    return;
  let { method: h, value: v } = S(this, mi, bb).call(this, n), y = !n.metaKey && /^[0-9]$/.test(n.key);
  if (!Ze(v) && !Vr(v) && !y) {
    (k = v == null ? void 0 : v.onKeyDown) == null || k.call(v, {
      event: n,
      player: d(this, Yi).player,
      remote: d(this, Yi).remote
    }), (D = v == null ? void 0 : v.callback) == null || D.call(v, n, d(this, Yi).remote);
    return;
  }
  if (!h && y && !S5(n)) {
    n.preventDefault(), n.stopPropagation(), d(this, Yi).remote.seek(this.$state.duration() / 10 * Number(n.key), n);
    return;
  }
  if (h) {
    switch (n.preventDefault(), n.stopPropagation(), h) {
      case "seekForward":
      case "seekBackward":
        S(this, mi, E_).call(this, n, h, h === "seekForward");
        break;
      case "volumeUp":
      case "volumeDown":
        const A = this.el.querySelector("[data-media-volume-slider]");
        if (A)
          A.dispatchEvent(
            new KeyboardEvent("keydown", {
              key: h === "volumeUp" ? "Up" : "Down",
              shiftKey: n.shiftKey,
              trigger: n
            })
          );
        else {
          const W = n.shiftKey ? 0.1 : 0.05;
          d(this, Yi).remote.changeVolume(
            this.$state.volume() + (h === "volumeUp" ? +W : -W),
            n
          );
        }
        break;
      case "toggleFullscreen":
        d(this, Yi).remote.toggleFullscreen("prefer-media", n);
        break;
      case "speedUp":
      case "slowDown":
        const B = this.$state.playbackRate();
        d(this, Yi).remote.changePlaybackRate(
          Math.max(0.25, Math.min(2, B + (h === "speedUp" ? 0.25 : -0.25))),
          n
        );
        break;
      default:
        (_ = ($ = d(this, Yi).remote)[h]) == null || _.call($, n);
    }
    this.$state.lastKeyboardAction.set({
      action: h,
      event: n
    });
  }
}, T_ = function(n) {
  h5(n.target) && S(this, mi, bb).call(this, n).method && n.preventDefault();
}, bb = function(n) {
  const o = {
    ...this.$props.keyShortcuts(),
    ...d(this, Yi).ariaKeys
  }, h = Object.keys(o).find((v) => {
    var $;
    const y = o[v], k = Vr(y) ? y.join(" ") : Ze(y) ? y : y == null ? void 0 : y.keys, D = ($ = Vr(k) ? k : k == null ? void 0 : k.split(" ")) == null ? void 0 : $.map(
      (_) => g5(_).replace(/Control/g, "Ctrl").split("+")
    );
    return D == null ? void 0 : D.some((_) => {
      const A = new Set(_.filter((B) => eT.has(B)));
      for (const B of eT) {
        const W = B.toLowerCase() + "Key";
        if (!A.has(B) && n[W])
          return !1;
      }
      return _.every((B) => eT.has(B) ? n[B.toLowerCase() + "Key"] : n.key === B.replace("Space", " "));
    });
  });
  return {
    method: h,
    value: h ? o[h] : null
  };
}, Ch = new WeakMap(), w_ = function(n, o) {
  const h = n.shiftKey ? 10 : 5;
  return L(this, Ch, Math.max(
    0,
    Math.min(
      (d(this, Ch) ?? this.$state.currentTime()) + (o === "seekForward" ? +h : -h),
      this.$state.duration()
    )
  ));
}, $u = new WeakMap(), VR = function(n, o) {
  var h;
  (h = d(this, $u)) == null || h.dispatchEvent(
    new KeyboardEvent(n.type, {
      key: o ? "Right" : "Left",
      shiftKey: n.shiftKey,
      trigger: n
    })
  );
}, E_ = function(n, o, h) {
  this.$state.canSeek() && (d(this, $u) || L(this, $u, this.el.querySelector("[data-media-time-slider]")), d(this, $u) ? S(this, mi, VR).call(this, n, h) : d(this, Yi).remote.seeking(S(this, mi, w_).call(this, n, o), n));
};
const y5 = ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")"];
function g5(f) {
  return f.replace(/Shift\+(\d)/g, (s, n) => y5[n - 1]);
}
function S5(f) {
  for (const s of eT)
    if (f[s.toLowerCase() + "Key"])
      return !0;
  return !1;
}
var bh;
class T5 extends Hs {
  constructor(n) {
    super();
    R(this, bh);
    L(this, bh, n);
  }
  onAttach(n) {
    const { $props: o, ariaKeys: h } = Ua(), v = n.getAttribute("aria-keyshortcuts");
    if (v) {
      h[d(this, bh)] = v, Wt(() => {
        delete h[d(this, bh)];
      });
      return;
    }
    const y = o.keyShortcuts()[d(this, bh)];
    if (y) {
      const k = Vr(y) ? y.join(" ") : Ze(y) ? y : y == null ? void 0 : y.keys;
      n.setAttribute("aria-keyshortcuts", Vr(k) ? k.join(" ") : k);
    }
  }
}
bh = new WeakMap();
var Sv, Ou, gT, Tv, rd, wv, Qt, C_, b_, k_, x_, R_, D_, M_, L_, kb, HR, tT, IR;
class w5 extends rp {
  constructor() {
    super(...arguments);
    R(this, Qt);
    R(this, Sv, -2);
    R(this, Ou, !1);
    R(this, gT, st(!1));
    R(this, Tv, st(!1));
    R(this, rd, null);
    R(this, wv, st(!0));
    /**
     * The default amount of delay in milliseconds while media playback is progressing without user
     * activity to indicate an idle state (i.e., hide controls).
     *
     * @defaultValue 2000
     */
    Z(this, "defaultDelay", 2e3);
  }
  /**
   * Whether controls can hide after a delay in user interaction. If this is false, controls will
   * not hide and be user controlled.
   */
  get canIdle() {
    return d(this, wv).call(this);
  }
  set canIdle(n) {
    d(this, wv).set(n);
  }
  /**
   * Whether controls visibility should be toggled when the mouse enters and leaves the player
   * container.
   *
   * @defaultValue false
   */
  get hideOnMouseLeave() {
    const { hideControlsOnMouseLeave: n } = this.$props;
    return d(this, gT).call(this) || n();
  }
  set hideOnMouseLeave(n) {
    d(this, gT).set(n);
  }
  /**
   * Whether media controls are currently visible.
   */
  get showing() {
    return this.$state.controlsVisible();
  }
  /**
   * Show controls.
   */
  show(n = 0, o) {
    S(this, Qt, kb).call(this), d(this, Ou) || S(this, Qt, tT).call(this, !0, n, o);
  }
  /**
   * Hide controls.
   */
  hide(n = this.defaultDelay, o) {
    S(this, Qt, kb).call(this), d(this, Ou) || S(this, Qt, tT).call(this, !1, n, o);
  }
  /**
   * Whether all idle tracking on controls should be paused until resumed again.
   */
  pause(n) {
    L(this, Ou, !0), S(this, Qt, kb).call(this), S(this, Qt, tT).call(this, !0, 0, n);
  }
  resume(n) {
    L(this, Ou, !1), !this.$state.paused() && S(this, Qt, tT).call(this, !1, this.defaultDelay, n);
  }
  onConnect() {
    J(S(this, Qt, C_).bind(this));
  }
}
Sv = new WeakMap(), Ou = new WeakMap(), gT = new WeakMap(), Tv = new WeakMap(), rd = new WeakMap(), wv = new WeakMap(), Qt = new WeakSet(), C_ = function() {
  const { viewType: n } = this.$state;
  if (!this.el || !d(this, wv).call(this)) return;
  if (n() === "audio") {
    this.show();
    return;
  }
  J(S(this, Qt, b_).bind(this)), J(S(this, Qt, k_).bind(this));
  const o = S(this, Qt, x_).bind(this), h = S(this, Qt, R_).bind(this), v = S(this, Qt, D_).bind(this);
  new gn(this.el).add("can-play", (y) => this.show(0, y)).add("play", o).add("pause", h).add("end", v).add("auto-play-fail", h);
}, b_ = function() {
  if (!this.el) return;
  const { started: n, pointer: o, paused: h } = this.$state;
  if (!n() || o() !== "fine") return;
  const v = new gn(this.el), y = this.hideOnMouseLeave;
  (!y || !d(this, Tv).call(this)) && J(() => {
    h() || v.add("pointermove", S(this, Qt, HR).bind(this));
  }), y && v.add("mouseenter", S(this, Qt, M_).bind(this)).add("mouseleave", S(this, Qt, L_).bind(this));
}, k_ = function() {
  const { paused: n, started: o, autoPlayError: h } = this.$state;
  if (n() || h() && !o()) return;
  const v = S(this, Qt, HR).bind(this);
  J(() => {
    if (!this.el) return;
    const y = this.$state.pointer(), k = y === "coarse", D = new gn(this.el), $ = [k ? "touchend" : "pointerup", "keydown"];
    for (const _ of $)
      D.add(_, v, { passive: !1 });
  });
}, x_ = function(n) {
  n.triggers.hasType("ended") || (this.show(0, n), this.hide(void 0, n));
}, R_ = function(n) {
  this.show(0, n);
}, D_ = function(n) {
  const { loop: o } = this.$state;
  o() && this.hide(0, n);
}, M_ = function(n) {
  d(this, Tv).set(!1), this.show(0, n), this.hide(void 0, n);
}, L_ = function(n) {
  d(this, Tv).set(!0), this.hide(0, n);
}, kb = function() {
  window.clearTimeout(d(this, Sv)), L(this, Sv, -1);
}, HR = function(n) {
  var o;
  // @ts-expect-error
  n.MEDIA_GESTURE || d(this, Ou) || o_(n) || (R0(n) && (n.key === "Escape" ? ((o = this.el) == null || o.focus(), L(this, rd, null)) : d(this, rd) && (n.preventDefault(), requestAnimationFrame(() => {
    var h;
    (h = d(this, rd)) == null || h.focus(), L(this, rd, null);
  }))), this.show(0, n), this.hide(this.defaultDelay, n));
}, tT = function(n, o, h) {
  if (o === 0) {
    S(this, Qt, IR).call(this, n, h);
    return;
  }
  L(this, Sv, window.setTimeout(() => {
    this.scope && S(this, Qt, IR).call(this, n && !d(this, Ou), h);
  }, o));
}, IR = function(n, o) {
  var h;
  this.$state.controlsVisible() !== n && (this.$state.controlsVisible.set(n), !n && document.activeElement && ((h = this.el) != null && h.contains(document.activeElement)) && L(this, rd, document.activeElement), this.dispatch("controls-change", {
    detail: n,
    trigger: o
  }));
};
const qR = Zh.fullscreenEnabled;
var ad, Ev, zd, $_, O_, A_;
class E5 extends Hs {
  constructor() {
    super(...arguments);
    R(this, zd);
    /**
     * Tracks whether we're the active fullscreen event listener. Fullscreen events can only be
     * listened to globally on the document so we need to know if they relate to the current host
     * element or not.
     */
    R(this, ad, !1);
    R(this, Ev, !1);
  }
  get active() {
    return d(this, Ev);
  }
  get supported() {
    return qR;
  }
  onConnect() {
    new gn(Zh).add("fullscreenchange", S(this, zd, O_).bind(this)).add("fullscreenerror", S(this, zd, A_).bind(this)), Wt(S(this, zd, $_).bind(this));
  }
  async enter() {
    try {
      return L(this, ad, !0), !this.el || yR(this.el) ? void 0 : (qA(), Zh.requestFullscreen(this.el));
    } catch (n) {
      throw L(this, ad, !1), n;
    }
  }
  async exit() {
    if (!(!this.el || !yR(this.el)))
      return qA(), Zh.exitFullscreen();
  }
}
ad = new WeakMap(), Ev = new WeakMap(), zd = new WeakSet(), $_ = async function() {
  qR && await this.exit();
}, O_ = function(n) {
  const o = yR(this.el);
  o !== d(this, Ev) && (o || L(this, ad, !1), L(this, Ev, o), this.dispatch("fullscreen-change", { detail: o, trigger: n }));
}, A_ = function(n) {
  d(this, ad) && (this.dispatch("fullscreen-error", { detail: null, trigger: n }), L(this, ad, !1));
};
function yR(f) {
  if (Zh.fullscreenElement === f) return !0;
  try {
    return f.matches(
      // @ts-expect-error - `fullscreenPseudoClass` is missing from `@types/fscreen`.
      Zh.fullscreenPseudoClass
    );
  } catch {
    return !1;
  }
}
function qA() {
  if (!qR)
    throw Error(
      "[vidstack] no fullscreen API"
    );
}
var sd, Au, kh, os, P_, jR, BR, QR;
const s0 = class s0 extends Hs {
  constructor() {
    super(...arguments);
    R(this, os);
    R(this, sd, st(S(this, os, QR).call(this)));
    R(this, Au, st(!1));
    R(this, kh);
  }
  /**
   * The current screen orientation type.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */
  get type() {
    return d(this, sd).call(this);
  }
  /**
   * Whether the screen orientation is currently locked.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */
  get locked() {
    return d(this, Au).call(this);
  }
  /**
   * Whether the viewport is in a portrait orientation.
   *
   * @signal
   */
  get portrait() {
    return d(this, sd).call(this).startsWith("portrait");
  }
  /**
   * Whether the viewport is in a landscape orientation.
   *
   * @signal
   */
  get landscape() {
    return d(this, sd).call(this).startsWith("landscape");
  }
  /**
   * Whether the native Screen Orientation API is available.
   */
  get supported() {
    return s0.supported;
  }
  onConnect() {
    if (this.supported)
      En(screen.orientation, "change", S(this, os, jR).bind(this));
    else {
      const n = window.matchMedia("(orientation: landscape)");
      n.onchange = S(this, os, jR).bind(this), Wt(() => n.onchange = null);
    }
    Wt(S(this, os, P_).bind(this));
  }
  /**
   * Locks the orientation of the screen to the desired orientation type using the
   * Screen Orientation API.
   *
   * @param lockType - The screen lock orientation type.
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */
  async lock(n) {
    ye(d(this, Au)) || d(this, kh) === n || (S(this, os, BR).call(this), await screen.orientation.lock(n), d(this, Au).set(!0), L(this, kh, n));
  }
  /**
   * Unlocks the orientation of the screen to it's default state using the Screen Orientation
   * API. This method will throw an error if the API is unavailable.
   *
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */
  async unlock() {
    ye(d(this, Au)) && (S(this, os, BR).call(this), L(this, kh, void 0), await screen.orientation.unlock(), d(this, Au).set(!1));
  }
};
sd = new WeakMap(), Au = new WeakMap(), kh = new WeakMap(), os = new WeakSet(), P_ = async function() {
  this.supported && d(this, Au).call(this) && await this.unlock();
}, jR = function(n) {
  d(this, sd).set(S(this, os, QR).call(this)), this.dispatch("orientation-change", {
    detail: {
      orientation: ye(d(this, sd)),
      lock: d(this, kh)
    },
    trigger: n
  });
}, BR = function() {
  if (!this.supported)
    throw Error(
      "[vidstack] no orientation API"
    );
}, QR = function() {
  return this.supported ? window.screen.orientation.type : window.innerWidth >= window.innerHeight ? "landscape-primary" : "portrait-primary";
}, /**
 * Whether the native Screen Orientation API is available.
 */
Z(s0, "supported", BP());
let Jb = s0;
class C5 {
  constructor() {
    Z(this, "name", "audio");
    Z(this, "target");
  }
  canPlay(s) {
    return GP(s) ? !Ze(s.src) || s.type === "?" || QP(this.target, s.type) : !1;
  }
  mediaType() {
    return "audio";
  }
  async load(s) {
    return new (await import("./vidstack-audio-DbPc3idL.js")).AudioProvider(this.target, s);
  }
}
class VM {
  constructor() {
    Z(this, "name", "video");
    Z(this, "target");
  }
  canPlay(s) {
    return WP(s) ? !Ze(s.src) || s.type === "?" || YP(this.target, s.type) : !1;
  }
  mediaType() {
    return "video";
  }
  async load(s) {
    return new (await import("./vidstack-video-q8xqLJoa.js")).VideoProvider(this.target, s);
  }
}
const l0 = class l0 extends VM {
  constructor() {
    super(...arguments);
    Z(this, "name", "hls");
  }
  canPlay(n) {
    return l0.supported && ky(n);
  }
  async load(n) {
    return new (await import("./vidstack-hls-DSVUi5_h.js")).HLSProvider(this.target, n);
  }
};
Z(l0, "supported", PM());
let YR = l0, xb = null, e0 = [], t0 = [];
function HM() {
  return xb ?? (xb = new AudioContext());
}
function b5() {
  const f = HM(), s = f.createGain();
  return s.connect(f.destination), e0.push(s), s;
}
function k5(f, s) {
  const n = HM(), o = n.createMediaElementSource(f);
  return s && o.connect(s), t0.push(o), o;
}
function x5(f) {
  const s = e0.indexOf(f);
  s !== -1 && (e0.splice(s, 1), f.disconnect(), __());
}
function R5(f) {
  const s = t0.indexOf(f);
  s !== -1 && (t0.splice(s, 1), f.disconnect(), __());
}
function __() {
  xb && e0.length === 0 && t0.length === 0 && xb.close().then(() => {
    xb = null;
  });
}
var ST, Cv, is, As, np, N_, GR;
class MQ {
  constructor(s, n) {
    R(this, np);
    R(this, ST);
    R(this, Cv);
    R(this, is, null);
    R(this, As, null);
    L(this, ST, s), L(this, Cv, n);
  }
  get currentGain() {
    var s, n;
    return ((n = (s = d(this, is)) == null ? void 0 : s.gain) == null ? void 0 : n.value) ?? null;
  }
  get supported() {
    return !0;
  }
  setGain(s) {
    const n = this.currentGain;
    if (s !== this.currentGain) {
      if (s === 1 && n !== 1) {
        this.removeGain();
        return;
      }
      d(this, is) || (L(this, is, b5()), d(this, As) && d(this, As).connect(d(this, is))), d(this, As) || L(this, As, k5(d(this, ST), d(this, is))), d(this, is).gain.value = s, d(this, Cv).call(this, s);
    }
  }
  removeGain() {
    d(this, is) && (d(this, As) && d(this, As).connect(HM().destination), S(this, np, GR).call(this), d(this, Cv).call(this, null));
  }
  destroy() {
    S(this, np, N_).call(this), S(this, np, GR).call(this);
  }
}
ST = new WeakMap(), Cv = new WeakMap(), is = new WeakMap(), As = new WeakMap(), np = new WeakSet(), N_ = function() {
  if (d(this, As))
    try {
      R5(d(this, As));
    } catch {
    } finally {
      L(this, As, null);
    }
}, GR = function() {
  if (d(this, is))
    try {
      x5(d(this, is));
    } catch {
    } finally {
      L(this, is, null);
    }
};
const D5 = ["focus", "blur", "visibilitychange", "pageshow", "pagehide"];
var xh, bv, TT, o0, U_;
class M5 {
  constructor() {
    R(this, o0);
    R(this, xh, st(jA()));
    R(this, bv, st(document.visibilityState));
    R(this, TT);
  }
  connect() {
    const s = new gn(window), n = S(this, o0, U_).bind(this);
    for (const o of D5)
      s.add(o, n);
    Xb && s.add("beforeunload", (o) => {
      L(this, TT, setTimeout(() => {
        o.defaultPrevented || o.returnValue.length > 0 || (d(this, xh).set("hidden"), d(this, bv).set("hidden"));
      }, 0));
    });
  }
  /**
   * The current page state. Important to note we only account for a subset of page states, as
   * the rest aren't valuable to the player at the moment.
   *
   * - **active:** A page is in the active state if it is visible and has input focus.
   * - **passive:** A page is in the passive state if it is visible and does not have input focus.
   * - **hidden:** A page is in the hidden state if it is not visible.
   *
   * @see https://developers.google.com/web/updates/2018/07/page-lifecycle-api#states
   */
  get pageState() {
    return d(this, xh).call(this);
  }
  /**
   * The current document visibility state.
   *
   * - **visible:** The page content may be at least partially visible. In practice, this means that
   * the page is the foreground tab of a non-minimized window.
   * - **hidden:** The page content is not visible to the user. In practice this means that the
   * document is either a background tab or part of a minimized window, or the OS screen lock is
   * active.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilityState
   */
  get visibility() {
    return d(this, bv).call(this);
  }
}
xh = new WeakMap(), bv = new WeakMap(), TT = new WeakMap(), o0 = new WeakSet(), U_ = function(s) {
  Xb && window.clearTimeout(d(this, TT)), (s.type !== "blur" || d(this, xh).call(this) === "active") && (d(this, xh).set(jA(s)), d(this, bv).set(document.visibilityState == "hidden" ? "hidden" : "visible"));
};
function jA(f) {
  return (f == null ? void 0 : f.type) === "blur" || document.visibilityState === "hidden" ? "hidden" : document.hasFocus() ? "active" : "passive";
}
var Pu, wT, ET, WR;
class IM {
  constructor(s) {
    R(this, ET);
    R(this, Pu);
    R(this, wT);
    L(this, wT, s);
  }
  start() {
    pi(d(this, Pu)) && S(this, ET, WR).call(this);
  }
  stop() {
    ss(d(this, Pu)) && window.cancelAnimationFrame(d(this, Pu)), L(this, Pu, void 0);
  }
}
Pu = new WeakMap(), wT = new WeakMap(), ET = new WeakSet(), WR = function() {
  L(this, Pu, window.requestAnimationFrame(() => {
    pi(d(this, Pu)) || (d(this, wT).call(this), S(this, ET, WR).call(this));
  }));
};
var CT, xt, ld, kv, xv, Rh, bT, Rv, K, jt, z_, Dv, Mv, F_, V_, H_, I_, u0, CM, ni, L5, ch, q_, KR, j_, B_, Q_, Rb, Y_, G_, W_, K_, X_, Z_, J_, eN, tN, nN, iN, rN, aN, sN, lN, oN, uN, cN;
class LQ {
  constructor(s, n) {
    R(this, K);
    R(this, CT);
    R(this, xt);
    R(this, ld, !1);
    R(this, kv, !1);
    R(this, xv, !1);
    R(this, Rh, new IM(S(this, K, F_).bind(this)));
    R(this, bT, new M5());
    R(this, Rv);
    /**
     * The `timeupdate` event fires surprisingly infrequently during playback, meaning your progress
     * bar (or whatever else is synced to the currentTime) moves in a choppy fashion. This helps
     * resolve that by retrieving time updates in a request animation frame loop.
     */
    R(this, Dv, 0);
    R(this, Mv, -1);
    R(this, u0);
    R(this, CM);
    L(this, CT, s), L(this, xt, n), L(this, Rv, new gn(s.media)), S(this, K, V_).call(this), d(this, bT).connect(), J(S(this, K, tN).bind(this)), Wt(S(this, K, z_).bind(this));
  }
}
CT = new WeakMap(), xt = new WeakMap(), ld = new WeakMap(), kv = new WeakMap(), xv = new WeakMap(), Rh = new WeakMap(), bT = new WeakMap(), Rv = new WeakMap(), K = new WeakSet(), jt = function() {
  return d(this, CT).media;
}, z_ = function() {
  var s;
  L(this, kv, !1), L(this, xv, !1), d(this, Rh).stop(), d(this, Rv).abort(), (s = d(this, u0)) == null || s.clear();
}, Dv = new WeakMap(), Mv = new WeakMap(), F_ = function() {
  const s = d(this, K, jt).currentTime;
  !(Xb && s - d(this, Mv) < 0.35) && d(this, Dv) !== s && (S(this, K, ch).call(this, s), L(this, Dv, s));
}, V_ = function() {
  S(this, K, ni).call(this, "loadstart", S(this, K, q_)), S(this, K, ni).call(this, "abort", S(this, K, KR)), S(this, K, ni).call(this, "emptied", S(this, K, j_)), S(this, K, ni).call(this, "error", S(this, K, cN)), S(this, K, ni).call(this, "volumechange", S(this, K, rN));
}, H_ = function() {
  d(this, kv) || (S(this, K, ni).call(this, "loadeddata", S(this, K, B_)), S(this, K, ni).call(this, "loadedmetadata", S(this, K, Q_)), S(this, K, ni).call(this, "canplay", S(this, K, W_)), S(this, K, ni).call(this, "canplaythrough", S(this, K, K_)), S(this, K, ni).call(this, "durationchange", S(this, K, iN)), S(this, K, ni).call(this, "play", S(this, K, Y_)), S(this, K, ni).call(this, "progress", S(this, K, lN)), S(this, K, ni).call(this, "stalled", S(this, K, Z_)), S(this, K, ni).call(this, "suspend", S(this, K, oN)), S(this, K, ni).call(this, "ratechange", S(this, K, uN)), L(this, kv, !0));
}, I_ = function() {
  d(this, xv) || (S(this, K, ni).call(this, "pause", S(this, K, G_)), S(this, K, ni).call(this, "playing", S(this, K, X_)), S(this, K, ni).call(this, "seeked", S(this, K, aN)), S(this, K, ni).call(this, "seeking", S(this, K, sN)), S(this, K, ni).call(this, "ended", S(this, K, eN)), S(this, K, ni).call(this, "waiting", S(this, K, J_)), L(this, xv, !0));
}, u0 = new WeakMap(), CM = new WeakMap(), ni = function(s, n) {
  d(this, Rv).add(s, n.bind(this));
}, L5 = function(s) {
}, ch = function(s, n) {
  const o = Math.min(s, d(this, xt).$state.seekableEnd());
  d(this, xt).notify("time-change", o, n);
}, q_ = function(s) {
  if (d(this, K, jt).networkState === 3) {
    S(this, K, KR).call(this, s);
    return;
  }
  S(this, K, H_).call(this), d(this, xt).notify("load-start", void 0, s);
}, KR = function(s) {
  d(this, xt).notify("abort", void 0, s);
}, j_ = function() {
  d(this, xt).notify("emptied", void 0, event);
}, B_ = function(s) {
  d(this, xt).notify("loaded-data", void 0, s);
}, Q_ = function(s) {
  L(this, Dv, 0), L(this, Mv, -1), S(this, K, I_).call(this), d(this, xt).notify("loaded-metadata", void 0, s), (L0 || Xb && ky(d(this, xt).$state.source())) && d(this, xt).delegate.ready(S(this, K, Rb).call(this), s);
}, Rb = function() {
  return {
    provider: ye(d(this, xt).$provider),
    duration: d(this, K, jt).duration,
    buffered: d(this, K, jt).buffered,
    seekable: d(this, K, jt).seekable
  };
}, Y_ = function(s) {
  d(this, xt).$state.canPlay && d(this, xt).notify("play", void 0, s);
}, G_ = function(s) {
  d(this, K, jt).readyState === 1 && !d(this, ld) || (L(this, ld, !1), d(this, Rh).stop(), d(this, xt).notify("pause", void 0, s));
}, W_ = function(s) {
  d(this, xt).delegate.ready(S(this, K, Rb).call(this), s);
}, K_ = function(s) {
  d(this, xt).$state.started() || d(this, xt).notify("can-play-through", S(this, K, Rb).call(this), s);
}, X_ = function(s) {
  d(this, K, jt).paused || (L(this, ld, !1), d(this, xt).notify("playing", void 0, s), d(this, Rh).start());
}, Z_ = function(s) {
  d(this, xt).notify("stalled", void 0, s), d(this, K, jt).readyState < 3 && (L(this, ld, !0), d(this, xt).notify("waiting", void 0, s));
}, J_ = function(s) {
  d(this, K, jt).readyState < 3 && (L(this, ld, !0), d(this, xt).notify("waiting", void 0, s));
}, eN = function(s) {
  d(this, Rh).stop(), S(this, K, ch).call(this, d(this, K, jt).duration, s), d(this, xt).notify("end", void 0, s), d(this, xt).$state.loop() && qj(d(this, K, jt).controls) && (d(this, K, jt).controls = !1);
}, tN = function() {
  const s = d(this, xt).$state.paused(), n = d(this, bT).visibility === "hidden";
  (s || n) && En(d(this, K, jt), "timeupdate", S(this, K, nN).bind(this));
}, nN = function(s) {
  S(this, K, ch).call(this, d(this, K, jt).currentTime, s);
}, iN = function(s) {
  d(this, xt).$state.ended() && S(this, K, ch).call(this, d(this, K, jt).duration, s), d(this, xt).notify("duration-change", d(this, K, jt).duration, s);
}, rN = function(s) {
  const n = {
    volume: d(this, K, jt).volume,
    muted: d(this, K, jt).muted
  };
  d(this, xt).notify("volume-change", n, s);
}, aN = function(s) {
  L(this, Mv, d(this, K, jt).currentTime), S(this, K, ch).call(this, d(this, K, jt).currentTime, s), d(this, xt).notify("seeked", d(this, K, jt).currentTime, s), Math.trunc(d(this, K, jt).currentTime) === Math.trunc(d(this, K, jt).duration) && AR(d(this, K, jt).duration) > AR(d(this, K, jt).currentTime) && (S(this, K, ch).call(this, d(this, K, jt).duration, s), d(this, K, jt).ended || d(this, xt).player.dispatch(
    new vt("media-play-request", {
      trigger: s
    })
  ));
}, sN = function(s) {
  d(this, xt).notify("seeking", d(this, K, jt).currentTime, s);
}, lN = function(s) {
  const n = {
    buffered: d(this, K, jt).buffered,
    seekable: d(this, K, jt).seekable
  };
  d(this, xt).notify("progress", n, s);
}, oN = function(s) {
  d(this, xt).notify("suspend", void 0, s);
}, uN = function(s) {
  d(this, xt).notify("rate-change", d(this, K, jt).playbackRate, s);
}, cN = function(s) {
  const n = d(this, K, jt).error;
  if (!n) return;
  const o = {
    message: n.message,
    code: n.code,
    mediaError: n
  };
  d(this, xt).notify("error", o, s);
};
var kT, pl, Hi, sv, dN, fN, hN, XR, pN;
class $Q {
  constructor(s, n) {
    R(this, Hi);
    R(this, kT);
    R(this, pl);
    L(this, kT, s), L(this, pl, n), d(this, Hi, sv).onaddtrack = S(this, Hi, dN).bind(this), d(this, Hi, sv).onremovetrack = S(this, Hi, fN).bind(this), d(this, Hi, sv).onchange = S(this, Hi, hN).bind(this), En(d(this, pl).audioTracks, "change", S(this, Hi, pN).bind(this));
  }
}
kT = new WeakMap(), pl = new WeakMap(), Hi = new WeakSet(), sv = function() {
  return d(this, kT).media.audioTracks;
}, dN = function(s) {
  const n = s.track;
  if (n.label === "") return;
  const o = n.id.toString() || `native-audio-${d(this, pl).audioTracks.length}`, h = {
    id: o,
    label: n.label,
    language: n.language,
    kind: n.kind,
    selected: !1
  };
  d(this, pl).audioTracks[at.add](h, s), n.enabled && (h.selected = !0);
}, fN = function(s) {
  const n = d(this, pl).audioTracks.getById(s.track.id);
  n && d(this, pl).audioTracks[at.remove](n, s);
}, hN = function(s) {
  let n = S(this, Hi, XR).call(this);
  if (!n) return;
  const o = d(this, pl).audioTracks.getById(n.id);
  o && d(this, pl).audioTracks[at.select](o, !0, s);
}, XR = function() {
  return Array.from(d(this, Hi, sv)).find((s) => s.enabled);
}, pN = function(s) {
  const { current: n } = s.detail;
  if (!n) return;
  const o = d(this, Hi, sv).getTrackById(n.id);
  if (o) {
    const h = S(this, Hi, XR).call(this);
    h && (h.enabled = !1), o.enabled = !0;
  }
};
var Ps, xT, RT, Dh, Fd, mN, vN, yN;
class $5 {
  constructor(s, n) {
    R(this, Fd);
    R(this, Ps);
    R(this, xT);
    R(this, RT);
    R(this, Dh, st(!1));
    L(this, Ps, s), L(this, xT, n), S(this, Fd, mN).call(this);
  }
  get supported() {
    return d(this, Dh).call(this);
  }
  async prompt() {
    if (!this.supported) throw Error("Not supported on this platform.");
    return this.type === "airplay" && d(this, Ps).webkitShowPlaybackTargetPicker ? d(this, Ps).webkitShowPlaybackTargetPicker() : d(this, Ps).remote.prompt();
  }
}
Ps = new WeakMap(), xT = new WeakMap(), RT = new WeakMap(), Dh = new WeakMap(), Fd = new WeakSet(), mN = function() {
  var s;
  !((s = d(this, Ps)) != null && s.remote) || !this.canPrompt || (d(this, Ps).remote.watchAvailability((n) => {
    d(this, Dh).set(n);
  }).catch(() => {
    d(this, Dh).set(!1);
  }), J(S(this, Fd, vN).bind(this)));
}, vN = function() {
  if (!d(this, Dh).call(this)) return;
  const s = ["connecting", "connect", "disconnect"], n = S(this, Fd, yN).bind(this);
  n(), En(d(this, Ps), "playing", n);
  const o = new gn(d(this, Ps).remote);
  for (const h of s)
    o.add(h, n);
}, yN = function(s) {
  const n = d(this, Ps).remote.state;
  if (n === d(this, RT)) return;
  const o = { type: this.type, state: n };
  d(this, xT).notify("remote-playback-change", o, s), L(this, RT, n);
};
class OQ extends $5 {
  constructor() {
    super(...arguments);
    Z(this, "type", "airplay");
  }
  get canPrompt() {
    return "WebKitPlaybackTargetAvailabilityEvent" in window;
  }
}
var Lv, $v, yy, gN, SN;
class AQ {
  constructor(s, n) {
    R(this, yy);
    R(this, Lv);
    R(this, $v);
    L(this, Lv, s), L(this, $v, n), s.textTracks.onaddtrack = S(this, yy, gN).bind(this), Wt(S(this, yy, SN).bind(this));
  }
}
Lv = new WeakMap(), $v = new WeakMap(), yy = new WeakSet(), gN = function(s) {
  const n = s.track;
  if (!n || O5(d(this, Lv), n)) return;
  const o = new Ud({
    id: n.id,
    kind: n.kind,
    label: n.label ?? "",
    language: n.language,
    type: "vtt"
  });
  o[tt.native] = { track: n }, o[tt.readyState] = 2, o[tt.nativeHLS] = !0;
  let h = 0;
  const v = (y) => {
    if (n.cues)
      for (let k = h; k < n.cues.length; k++)
        o.addCue(n.cues[k], y), h++;
  };
  v(s), n.oncuechange = v, d(this, $v).textTracks.add(o, s), o.setMode(n.mode, s);
}, SN = function() {
  var s;
  d(this, Lv).textTracks.onaddtrack = null;
  for (const n of d(this, $v).textTracks) {
    const o = (s = n[tt.native]) == null ? void 0 : s.track;
    o != null && o.oncuechange && (o.oncuechange = null);
  }
};
function O5(f, s) {
  return Array.from(f.children).find((n) => n.track === s);
}
var Mh, DT, gy, TN, wN, MT;
class PQ {
  constructor(s, n) {
    R(this, gy);
    R(this, Mh);
    R(this, DT);
    R(this, MT, (s, n) => {
      d(this, DT).notify("picture-in-picture-change", s, n);
    });
    L(this, Mh, s), L(this, DT, n), new gn(s).add("enterpictureinpicture", S(this, gy, TN).bind(this)).add("leavepictureinpicture", S(this, gy, wN).bind(this));
  }
  get active() {
    return document.pictureInPictureElement === d(this, Mh);
  }
  get supported() {
    return dB(d(this, Mh));
  }
  async enter() {
    return d(this, Mh).requestPictureInPicture();
  }
  exit() {
    return document.exitPictureInPicture();
  }
}
Mh = new WeakMap(), DT = new WeakMap(), gy = new WeakSet(), TN = function(s) {
  d(this, MT).call(this, !0, s);
}, wN = function(s) {
  d(this, MT).call(this, !1, s);
}, MT = new WeakMap();
var Lh, Ov, co, c0, EN;
class _Q {
  constructor(s, n) {
    R(this, c0);
    R(this, Lh);
    R(this, Ov);
    R(this, co, "inline");
    L(this, Lh, s), L(this, Ov, n), En(s, "webkitpresentationmodechanged", S(this, c0, EN).bind(this));
  }
  get mode() {
    return d(this, co);
  }
  get supported() {
    return fB(d(this, Lh));
  }
  async setPresentationMode(s) {
    d(this, co) !== s && d(this, Lh).webkitSetPresentationMode(s);
  }
}
Lh = new WeakMap(), Ov = new WeakMap(), co = new WeakMap(), c0 = new WeakSet(), EN = function(s) {
  var o;
  const n = d(this, co);
  L(this, co, d(this, Lh).webkitPresentationMode), (o = d(this, Ov).player) == null || o.dispatch(
    new vt("video-presentation-change", {
      detail: d(this, co),
      trigger: s
    })
  ), ["fullscreen", "picture-in-picture"].forEach((h) => {
    (d(this, co) === h || n === h) && d(this, Ov).notify(`${h}-change`, d(this, co) === h, s);
  });
};
var od;
class NQ {
  constructor(s) {
    R(this, od);
    L(this, od, s);
  }
  get active() {
    return d(this, od).mode === "fullscreen";
  }
  get supported() {
    return d(this, od).supported;
  }
  async enter() {
    d(this, od).setPresentationMode("fullscreen");
  }
  async exit() {
    d(this, od).setPresentationMode("inline");
  }
}
od = new WeakMap();
var ud;
class UQ {
  constructor(s) {
    R(this, ud);
    L(this, ud, s);
  }
  get active() {
    return d(this, ud).mode === "picture-in-picture";
  }
  get supported() {
    return d(this, ud).supported;
  }
  async enter() {
    d(this, ud).setPresentationMode("picture-in-picture");
  }
  async exit() {
    d(this, ud).setPresentationMode("inline");
  }
}
ud = new WeakMap();
function BA(f) {
  try {
    return new Intl.DisplayNames(navigator.languages, { type: "language" }).of(f) ?? null;
  } catch {
    return null;
  }
}
const A5 = (f) => `dash-${D0(f)}`;
var cd, cn, mt, Av, Pv, Be, dh, CN, bN, kN, _u, _v, xN, RN, DN, MN, LN, $N, ON, AN, dd, PN, Db, ZR, _N, JR, NN, UN, eD;
class zQ {
  constructor(s, n) {
    R(this, Be);
    R(this, cd);
    R(this, cn);
    R(this, mt, null);
    R(this, Av, /* @__PURE__ */ new Set());
    R(this, Pv, null);
    Z(this, "config", {});
    R(this, _u, null);
    R(this, _v, {});
    R(this, dd, -1);
    L(this, cd, s), L(this, cn, n);
  }
  get instance() {
    return d(this, mt);
  }
  setup(s) {
    L(this, mt, s().create());
    const n = S(this, Be, kN).bind(this);
    for (const o of Object.values(s.events)) d(this, mt).on(o, n);
    d(this, mt).on(s.events.ERROR, S(this, Be, $N).bind(this));
    for (const o of d(this, Av)) o(d(this, mt));
    d(this, cn).player.dispatch("dash-instance", {
      detail: d(this, mt)
    }), d(this, mt).initialize(d(this, cd), void 0, !1), d(this, mt).updateSettings({
      streaming: {
        text: {
          // Disabling text rendering by dash.
          defaultEnabled: !1,
          dispatchForManualRendering: !0
        },
        buffer: {
          /// Enables buffer replacement when switching bitrates for faster switching.
          fastSwitchEnabled: !0
        }
      },
      ...this.config
    }), d(this, mt).on(s.events.FRAGMENT_LOADING_STARTED, S(this, Be, ON).bind(this)), d(this, mt).on(
      s.events.FRAGMENT_LOADING_COMPLETED,
      S(this, Be, AN).bind(this)
    ), d(this, mt).on(s.events.MANIFEST_LOADED, S(this, Be, LN).bind(this)), d(this, mt).on(s.events.QUALITY_CHANGE_RENDERED, S(this, Be, MN).bind(this)), d(this, mt).on(s.events.TEXT_TRACKS_ADDED, S(this, Be, RN).bind(this)), d(this, mt).on(s.events.TRACK_CHANGE_RENDERED, S(this, Be, DN).bind(this)), d(this, cn).qualities[la.enableAuto] = S(this, Be, _N).bind(this), En(d(this, cn).qualities, "change", S(this, Be, NN).bind(this)), En(d(this, cn).audioTracks, "change", S(this, Be, UN).bind(this)), L(this, Pv, J(S(this, Be, CN).bind(this)));
  }
  onInstance(s) {
    return d(this, Av).add(s), () => d(this, Av).delete(s);
  }
  loadSource(s) {
    var n;
    S(this, Be, eD).call(this), Ze(s.src) && ((n = d(this, mt)) == null || n.attachSource(s.src));
  }
  destroy() {
    var s, n;
    S(this, Be, eD).call(this), (s = d(this, mt)) == null || s.destroy(), L(this, mt, null), (n = d(this, Pv)) == null || n.call(this), L(this, Pv, null);
  }
}
cd = new WeakMap(), cn = new WeakMap(), mt = new WeakMap(), Av = new WeakMap(), Pv = new WeakMap(), Be = new WeakSet(), dh = function(s) {
  return new vt(A5(s.type), { detail: s });
}, CN = function() {
  if (!d(this, cn).$state.live()) return;
  const s = new IM(S(this, Be, bN).bind(this));
  return s.start(), s.stop.bind(s);
}, bN = function() {
  if (!d(this, mt)) return;
  const s = d(this, mt).duration() - d(this, mt).time();
  d(this, cn).$state.liveSyncPosition.set(isNaN(s) ? 1 / 0 : s);
}, kN = function(s) {
  var n;
  (n = d(this, cn).player) == null || n.dispatch(S(this, Be, dh).call(this, s));
}, _u = new WeakMap(), _v = new WeakMap(), xN = function(s) {
  var k;
  const n = (k = d(this, _u)) == null ? void 0 : k[tt.native], o = (n == null ? void 0 : n.track).cues;
  if (!n || !o) return;
  const h = d(this, _u).id, v = d(this, _v)[h] ?? 0, y = S(this, Be, dh).call(this, s);
  for (let D = v; D < o.length; D++) {
    const $ = o[D];
    $.positionAlign || ($.positionAlign = "auto"), d(this, _u).addCue($, y);
  }
  d(this, _v)[h] = o.length;
}, RN = function(s) {
  var v;
  if (!d(this, mt)) return;
  const n = s.tracks, o = [...d(this, cd).textTracks].filter((y) => "manualMode" in y), h = S(this, Be, dh).call(this, s);
  for (let y = 0; y < o.length; y++) {
    const k = n[y], D = o[y], $ = `dash-${k.kind}-${y}`, _ = new Ud({
      id: $,
      label: (k == null ? void 0 : k.label) ?? ((v = k.labels.find((A) => A.text)) == null ? void 0 : v.text) ?? ((k == null ? void 0 : k.lang) && BA(k.lang)) ?? (k == null ? void 0 : k.lang) ?? void 0,
      language: k.lang ?? void 0,
      kind: k.kind,
      default: k.defaultTrack
    });
    _[tt.native] = {
      managed: !0,
      track: D
    }, _[tt.readyState] = 2, _[tt.onModeChange] = () => {
      d(this, mt) && (_.mode === "showing" ? (d(this, mt).setTextTrack(y), L(this, _u, _)) : (d(this, mt).setTextTrack(-1), L(this, _u, null)));
    }, d(this, cn).textTracks.add(_, h);
  }
}, DN = function(s) {
  const { mediaType: n, newMediaInfo: o } = s;
  if (n === "audio") {
    const h = d(this, cn).audioTracks.getById(`dash-audio-${o.index}`);
    if (h) {
      const v = S(this, Be, dh).call(this, s);
      d(this, cn).audioTracks[at.select](h, !0, v);
    }
  }
}, MN = function(s) {
  if (s.mediaType !== "video") return;
  const n = d(this, cn).qualities[s.newQuality];
  if (n) {
    const o = S(this, Be, dh).call(this, s);
    d(this, cn).qualities[at.select](n, !0, o);
  }
}, LN = function(s) {
  if (d(this, cn).$state.canPlay() || !d(this, mt)) return;
  const { type: n, mediaPresentationDuration: o } = s.data, h = S(this, Be, dh).call(this, s);
  d(this, cn).notify("stream-type-change", n !== "static" ? "live" : "on-demand", h), d(this, cn).notify("duration-change", o, h), d(this, cn).qualities[la.setAuto](!0, h);
  const v = d(this, mt).getVideoElement(), y = d(this, mt).getTracksForTypeFromManifest(
    "video",
    s.data
  ), k = [...new Set(y.map((A) => A.mimeType))].find(
    (A) => A && YP(v, A)
  ), D = y.filter(
    (A) => k === A.mimeType
  )[0];
  let $ = d(this, mt).getTracksForTypeFromManifest(
    "audio",
    s.data
  );
  const _ = [...new Set($.map((A) => A.mimeType))].find(
    (A) => A && QP(v, A)
  );
  if ($ = $.filter((A) => _ === A.mimeType), D == null || D.bitrateList.forEach((A, B) => {
    var ne;
    const W = {
      id: ((ne = A.id) == null ? void 0 : ne.toString()) ?? `dash-bitrate-${B}`,
      width: A.width ?? 0,
      height: A.height ?? 0,
      bitrate: A.bandwidth ?? 0,
      codec: D.codec,
      index: B
    };
    d(this, cn).qualities[at.add](W, h);
  }), ss(D == null ? void 0 : D.index)) {
    const A = d(this, cn).qualities[D.index];
    A && d(this, cn).qualities[at.select](A, !0, h);
  }
  $.forEach((A, B) => {
    const ne = A.labels.find((Re) => navigator.languages.some((Lt) => Re.lang && Lt.toLowerCase().startsWith(Re.lang.toLowerCase()))) || A.labels[0], ce = {
      id: `dash-audio-${A == null ? void 0 : A.index}`,
      label: (ne == null ? void 0 : ne.text) ?? (A.lang && BA(A.lang)) ?? A.lang ?? "",
      language: A.lang ?? "",
      kind: "main",
      mimeType: A.mimeType,
      codec: A.codec,
      index: B
    };
    d(this, cn).audioTracks[at.add](ce, h);
  }), v.dispatchEvent(new vt("canplay", { trigger: h }));
}, $N = function(s) {
  const { type: n, error: o } = s;
  switch (o.code) {
    case 27:
      S(this, Be, PN).call(this, o);
      break;
    default:
      S(this, Be, ZR).call(this, o);
      break;
  }
}, ON = function() {
  d(this, dd) >= 0 && S(this, Be, Db).call(this);
}, AN = function(s) {
  s.mediaType === "text" && requestAnimationFrame(S(this, Be, xN).bind(this, s));
}, dd = new WeakMap(), PN = function(s) {
  var n;
  S(this, Be, Db).call(this), (n = d(this, mt)) == null || n.play(), L(this, dd, window.setTimeout(() => {
    L(this, dd, -1), S(this, Be, ZR).call(this, s);
  }, 5e3));
}, Db = function() {
  clearTimeout(d(this, dd)), L(this, dd, -1);
}, ZR = function(s) {
  d(this, cn).notify("error", {
    message: s.message ?? "",
    code: 1,
    error: s
  });
}, _N = function() {
  var n;
  S(this, Be, JR).call(this, "video", !0);
  const { qualities: s } = d(this, cn);
  (n = d(this, mt)) == null || n.setQualityFor("video", s.selectedIndex, !0);
}, JR = function(s, n) {
  var o;
  (o = d(this, mt)) == null || o.updateSettings({
    streaming: { abr: { autoSwitchBitrate: { [s]: n } } }
  });
}, NN = function() {
  const { qualities: s } = d(this, cn);
  !d(this, mt) || s.auto || !s.selected || (S(this, Be, JR).call(this, "video", !1), d(this, mt).setQualityFor("video", s.selectedIndex, s.switch === "current"), $0 && (d(this, cd).currentTime = d(this, cd).currentTime));
}, UN = function() {
  if (!d(this, mt)) return;
  const { audioTracks: s } = d(this, cn), n = d(this, mt).getTracksFor("audio").find(
    (o) => s.selected && s.selected.id === `dash-audio-${o.index}`
  );
  n && d(this, mt).setCurrentTrack(n);
}, eD = function() {
  S(this, Be, Db).call(this), L(this, _u, null), L(this, _v, {});
};
function lT(f) {
  return f instanceof Error ? f : Error(typeof f == "string" ? f : JSON.stringify(f));
}
function xu(f, s) {
  if (!f)
    throw Error("Assertion failed.");
}
var $h, fo, LT, bo, zN, FN, VN, HN;
class FQ {
  constructor(s, n, o) {
    R(this, bo);
    R(this, $h);
    R(this, fo);
    R(this, LT);
    L(this, $h, s), L(this, fo, n), L(this, LT, o), S(this, bo, zN).call(this);
  }
}
$h = new WeakMap(), fo = new WeakMap(), LT = new WeakMap(), bo = new WeakSet(), zN = async function() {
  const s = {
    onLoadStart: S(this, bo, FN).bind(this),
    onLoaded: S(this, bo, VN).bind(this),
    onLoadError: S(this, bo, HN).bind(this)
  };
  let n = await _5(d(this, $h), s);
  if (pi(n) && !Ze(d(this, $h)) && (n = await P5(d(this, $h), s)), !n) return null;
  if (!window.dashjs.supportsMediaSource()) {
    const o = "[vidstack] `dash.js` is not supported in this environment";
    return d(this, fo).player.dispatch(new vt("dash-unsupported")), d(this, fo).notify("error", { message: o, code: 4 }), null;
  }
  return n;
}, FN = function() {
  d(this, fo).player.dispatch(new vt("dash-lib-load-start"));
}, VN = function(s) {
  d(this, fo).player.dispatch(
    new vt("dash-lib-loaded", {
      detail: s
    })
  ), d(this, LT).call(this, s);
}, HN = function(s) {
  const n = lT(s);
  d(this, fo).player.dispatch(
    new vt("dash-lib-load-error", {
      detail: n
    })
  ), d(this, fo).notify("error", {
    message: n.message,
    code: 4,
    error: n
  });
};
async function P5(f, s = {}) {
  var n, o, h, v, y, k, D;
  if (!pi(f)) {
    if ((n = s.onLoadStart) == null || n.call(s), N5(f))
      return (o = s.onLoaded) == null || o.call(s, f), f;
    if (QA(f)) {
      const $ = f.MediaPlayer;
      return (h = s.onLoaded) == null || h.call(s, $), $;
    }
    try {
      const $ = (v = await f()) == null ? void 0 : v.default;
      if (QA($))
        return (y = s.onLoaded) == null || y.call(s, $.MediaPlayer), $.MediaPlayer;
      if ($)
        (k = s.onLoaded) == null || k.call(s, $);
      else
        throw Error(
          ""
        );
      return $;
    } catch ($) {
      (D = s.onLoadError) == null || D.call(s, $);
    }
  }
}
async function _5(f, s = {}) {
  var n, o, h;
  if (Ze(f)) {
    (n = s.onLoadStart) == null || n.call(s);
    try {
      if (await NM(f), !ls(window.dashjs.MediaPlayer))
        throw Error(
          ""
        );
      const v = window.dashjs.MediaPlayer;
      return (o = s.onLoaded) == null || o.call(s, v), v;
    } catch (v) {
      (h = s.onLoadError) == null || h.call(s, v);
    }
  }
}
function N5(f) {
  return f && f.prototype && f.prototype !== Function;
}
function QA(f) {
  return f && "MediaPlayer" in f;
}
const d0 = class d0 extends VM {
  constructor() {
    super(...arguments);
    Z(this, "name", "dash");
  }
  canPlay(n) {
    return d0.supported && _M(n);
  }
  async load(n) {
    return new (await import("./vidstack-dash-jo1859zo.js")).DASHProvider(this.target, n);
  }
};
Z(d0, "supported", vB());
let tD = d0;
class U5 {
  constructor() {
    Z(this, "name", "vimeo");
    Z(this, "target");
  }
  preconnect() {
    const s = [
      "https://i.vimeocdn.com",
      "https://f.vimeocdn.com",
      "https://fresnel.vimeocdn.com"
    ];
    for (const n of s)
      O0(n);
  }
  canPlay(s) {
    return Ze(s.src) && s.type === "video/vimeo";
  }
  mediaType() {
    return "video";
  }
  async load(s) {
    return new (await import("./vidstack-vimeo-BA-4I7ZM.js").then((n) => n.p)).VimeoProvider(this.target, s);
  }
  async loadPoster(s, n, o) {
    const { resolveVimeoVideoId: h, getVimeoVideoInfo: v } = await import("./vidstack-vimeo-BA-4I7ZM.js").then((D) => D.u);
    if (!Ze(s.src)) return null;
    const { videoId: y, hash: k } = h(s.src);
    return y ? v(y, o, k).then((D) => D ? D.poster : null) : null;
  }
}
class z5 {
  constructor() {
    Z(this, "name", "youtube");
    Z(this, "target");
  }
  preconnect() {
    const s = [
      // Botguard script.
      "https://www.google.com",
      // Posters.
      "https://i.ytimg.com",
      // Ads.
      "https://googleads.g.doubleclick.net",
      "https://static.doubleclick.net"
    ];
    for (const n of s)
      O0(n);
  }
  canPlay(s) {
    return Ze(s.src) && s.type === "video/youtube";
  }
  mediaType() {
    return "video";
  }
  async load(s) {
    return new (await import("./vidstack-youtube-BAC5Q-v0.js").then((n) => n.p)).YouTubeProvider(this.target, s);
  }
  async loadPoster(s, n, o) {
    const { findYouTubePoster: h, resolveYouTubeVideoId: v } = await import("./vidstack-youtube-BAC5Q-v0.js").then((k) => k.u), y = Ze(s.src) && v(s.src);
    return y ? h(y, o) : null;
  }
}
function gR(f, s) {
  const n = String(f), o = n.length;
  if (o < s) {
    const v = s - o;
    return `${"0".repeat(v)}${f}`;
  }
  return n;
}
function IN(f) {
  const s = Math.trunc(f / 3600), n = Math.trunc(f % 3600 / 60), o = Math.trunc(f % 60), h = Number((f - Math.trunc(f)).toPrecision(3));
  return {
    hours: s,
    minutes: n,
    seconds: o,
    fraction: h
  };
}
function qM(f, { padHrs: s = null, padMins: n = null, showHrs: o = !1, showMs: h = !1 } = {}) {
  const { hours: v, minutes: y, seconds: k, fraction: D } = IN(f), $ = s ? gR(v, 2) : v, _ = n || Zu(n) && f >= 3600 ? gR(y, 2) : y, A = gR(k, 2), B = h && D > 0 ? `.${String(D).replace(/^0?\./, "")}` : "", W = `${_}:${A}${B}`;
  return v > 0 || o ? `${$}:${W}` : W;
}
function YA(f) {
  const s = [], { hours: n, minutes: o, seconds: h } = IN(f);
  return n > 0 && s.push(`${n} hour`), o > 0 && s.push(`${o} min`), (h > 0 || s.length === 0) && s.push(`${h} sec`), s.join(" ");
}
const SR = Symbol(0), F5 = [
  "autoPlay",
  "canAirPlay",
  "canFullscreen",
  "canGoogleCast",
  "canLoad",
  "canLoadPoster",
  "canPictureInPicture",
  "canPlay",
  "canSeek",
  "ended",
  "fullscreen",
  "isAirPlayConnected",
  "isGoogleCastConnected",
  "live",
  "liveEdge",
  "loop",
  "mediaType",
  "muted",
  "paused",
  "pictureInPicture",
  "playing",
  "playsInline",
  "remotePlaybackState",
  "remotePlaybackType",
  "seeking",
  "started",
  "streamType",
  "viewType",
  "waiting"
], V5 = {
  artist: "",
  artwork: null,
  autoplay: !1,
  autoPlay: !1,
  clipStartTime: 0,
  clipEndTime: 0,
  controls: !1,
  currentTime: 0,
  crossorigin: null,
  crossOrigin: null,
  duration: -1,
  fullscreenOrientation: "landscape",
  googleCast: {},
  load: "visible",
  posterLoad: "visible",
  logLevel: "silent",
  loop: !1,
  muted: !1,
  paused: !0,
  playsinline: !1,
  playsInline: !1,
  playbackRate: 1,
  poster: "",
  preload: "metadata",
  preferNativeHLS: !1,
  src: "",
  title: "",
  controlsDelay: 2e3,
  hideControlsOnMouseLeave: !1,
  viewType: "unknown",
  streamType: "unknown",
  volume: 1,
  liveEdgeTolerance: 10,
  minLiveDVRWindow: 60,
  keyDisabled: !1,
  keyTarget: "player",
  keyShortcuts: p5,
  storage: null
};
var $T, Oh;
class GA extends rp {
  constructor(n, o) {
    super();
    R(this, $T);
    R(this, Oh);
    L(this, $T, n), L(this, Oh, o);
  }
  async onAttach(n) {
    const o = this.$props[d(this, $T)]();
    if (o === "eager")
      requestAnimationFrame(d(this, Oh));
    else if (o === "idle")
      nB(d(this, Oh));
    else if (o === "visible") {
      let h, v = new IntersectionObserver((y) => {
        this.scope && y[0].isIntersecting && (h == null || h(), h = void 0, d(this, Oh).call(this));
      });
      v.observe(n), h = Wt(() => v.disconnect());
    }
  }
}
$T = new WeakMap(), Oh = new WeakMap();
var OT, ml, f0, qN;
class H5 {
  constructor(s, n) {
    R(this, f0);
    R(this, OT);
    R(this, ml);
    L(this, OT, s), L(this, ml, n);
  }
  notify(s, ...n) {
    d(this, OT).call(this, new vt(s, {
      detail: n == null ? void 0 : n[0],
      trigger: n == null ? void 0 : n[1]
    }));
  }
  async ready(s, n) {
    return py(async () => {
      var Kt, Mt, Ae, wt, Sn, Je, ot;
      d(this, ml);
      const {
        autoPlay: o,
        canPlay: h,
        started: v,
        duration: y,
        seekable: k,
        buffered: D,
        remotePlaybackInfo: $,
        playsInline: _,
        savedState: A,
        source: B
      } = d(this, ml).$state;
      if (h()) return;
      const W = {
        duration: (s == null ? void 0 : s.duration) ?? y(),
        seekable: (s == null ? void 0 : s.seekable) ?? k(),
        buffered: (s == null ? void 0 : s.buffered) ?? D(),
        provider: d(this, ml).$provider()
      };
      this.notify("can-play", W, n), Xu();
      let ne = d(this, ml).$provider(), { storage: ce, qualities: Re } = d(this, ml), { muted: Lt, volume: $t, clipStartTime: Ve, playbackRate: ct } = d(this, ml).$props;
      await ((Kt = ce == null ? void 0 : ce.onLoad) == null ? void 0 : Kt.call(ce, B()));
      const Ye = (Mt = A()) == null ? void 0 : Mt.currentTime, Tt = (Ae = A()) == null ? void 0 : Ae.paused, He = await (ce == null ? void 0 : ce.getTime()), de = Ye ?? He ?? Ve(), Ge = Tt === !1 || Tt !== !0 && !v() && o();
      if (ne) {
        ne.setVolume(await (ce == null ? void 0 : ce.getVolume()) ?? $t()), ne.setMuted(Lt() || !!await (ce == null ? void 0 : ce.getMuted()));
        const oe = await (ce == null ? void 0 : ce.getAudioGain()) ?? 1;
        oe > 1 && ((Sn = (wt = ne.audioGain) == null ? void 0 : wt.setGain) == null || Sn.call(wt, oe)), (Je = ne.setPlaybackRate) == null || Je.call(ne, await (ce == null ? void 0 : ce.getPlaybackRate()) ?? ct()), (ot = ne.setPlaysInline) == null || ot.call(ne, _()), de > 0 && ne.setCurrentTime(de);
      }
      const ft = await (ce == null ? void 0 : ce.getVideoQuality());
      if (ft && Re.length) {
        let oe = null, Le = 1 / 0;
        for (const he of Re) {
          const yt = Math.abs(ft.width - he.width) + Math.abs(ft.height - he.height) + (ft.bitrate ? Math.abs(ft.bitrate - (he.bitrate ?? 0)) : 0);
          yt < Le && (oe = he, Le = yt);
        }
        oe && (oe.selected = !0);
      }
      h() && Ge ? await S(this, f0, qN).call(this, n) : He && He > 0 && this.notify("started", void 0, n), $.set(null);
    });
  }
}
OT = new WeakMap(), ml = new WeakMap(), f0 = new WeakSet(), qN = async function(s) {
  const {
    player: n,
    $state: { autoPlaying: o, muted: h }
  } = d(this, ml);
  o.set(!0);
  const v = new vt("auto-play-attempt", { trigger: s });
  try {
    await n.play(v);
  } catch {
  }
};
var fd;
class I5 {
  constructor() {
    R(this, fd, /* @__PURE__ */ new Map());
  }
  /**
   * Queue the given `item` under the given `key` to be processed at a later time by calling
   * `serve(key)`.
   */
  enqueue(s, n) {
    d(this, fd).set(s, n);
  }
  /**
   * Process item in queue for the given `key`.
   */
  serve(s) {
    const n = this.peek(s);
    return d(this, fd).delete(s), n;
  }
  /**
   * Peek at item in queue for the given `key`.
   */
  peek(s) {
    return d(this, fd).get(s);
  }
  /**
   * Removes queued item under the given `key`.
   */
  delete(s) {
    d(this, fd).delete(s);
  }
  /**
   * Clear all items in the queue.
   */
  clear() {
    d(this, fd).clear();
  }
}
fd = new WeakMap();
var hd, Nv, vl, Vd, nD, iD;
class jN {
  constructor() {
    R(this, Vd);
    R(this, hd, !1);
    R(this, Nv, DR());
    R(this, vl, /* @__PURE__ */ new Map());
  }
  /**
   * The number of callbacks that are currently in queue.
   */
  get size() {
    return d(this, vl).size;
  }
  /**
   * Whether items in the queue are being served immediately, otherwise they're queued to
   * be processed later.
   */
  get isServing() {
    return d(this, hd);
  }
  /**
   * Waits for the queue to be flushed (ie: start serving).
   */
  async waitForFlush() {
    d(this, hd) || await d(this, Nv).promise;
  }
  /**
   * Queue the given `callback` to be invoked at a later time by either calling the `serve()` or
   * `start()` methods. If the queue has started serving (i.e., `start()` was already called),
   * then the callback will be invoked immediately.
   *
   * @param key - Uniquely identifies this callback so duplicates are ignored.
   * @param callback - The function to call when this item in the queue is being served.
   */
  enqueue(s, n) {
    if (d(this, hd)) {
      n();
      return;
    }
    d(this, vl).delete(s), d(this, vl).set(s, n);
  }
  /**
   * Invokes the callback with the given `key` in the queue (if it exists).
   */
  serve(s) {
    var n;
    (n = d(this, vl).get(s)) == null || n(), d(this, vl).delete(s);
  }
  /**
   * Flush all queued items and start serving future requests immediately until `stop()` is called.
   */
  start() {
    S(this, Vd, nD).call(this), L(this, hd, !0), d(this, vl).size > 0 && S(this, Vd, nD).call(this);
  }
  /**
   * Stop serving requests, they'll be queued until you begin processing again by calling `start()`.
   */
  stop() {
    L(this, hd, !1);
  }
  /**
   * Stop serving requests, empty the request queue, and release any promises waiting for the
   * queue to flush.
   */
  reset() {
    this.stop(), d(this, vl).clear(), S(this, Vd, iD).call(this);
  }
}
hd = new WeakMap(), Nv = new WeakMap(), vl = new WeakMap(), Vd = new WeakSet(), nD = function() {
  for (const s of d(this, vl).keys()) this.serve(s);
  S(this, Vd, iD).call(this);
}, iD = function() {
  d(this, Nv).resolve(), L(this, Nv, DR());
};
function q5(f) {
  return f ? "true" : "false";
}
function ap(f) {
  return () => q5(f());
}
function j5() {
  return typeof window > "u" ? !1 : window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
var Nu, rt, Uu, Ah, zu, xn, pd, St, BN, QN, YN, rD, Uv, aD, sD, GN, WN, KN, XN, ZN, JN, Ph, eU, lD, oD, Q5;
class B5 extends rp {
  constructor(n, o, h) {
    super();
    R(this, St);
    R(this, Nu);
    R(this, rt);
    R(this, Uu);
    Z(this, "controls");
    R(this, Ah);
    R(this, zu);
    R(this, xn);
    R(this, pd, new jN());
    R(this, Uv, !1);
    R(this, Ph);
    L(this, Nu, n), L(this, rt, o), L(this, Uu, h), L(this, xn, h.$provider), this.controls = new w5(), L(this, Ah, new E5()), L(this, zu, new Jb());
  }
  onAttach() {
    this.listen("fullscreen-change", S(this, St, eU).bind(this));
  }
  onConnect(n) {
    const o = Object.getOwnPropertyNames(Object.getPrototypeOf(this)), h = new gn(n), v = S(this, St, YN).bind(this);
    for (const y of o)
      y.startsWith("media-") && h.add(y, v);
    S(this, St, BN).call(this), J(S(this, St, QN).bind(this)), J(S(this, St, GN).bind(this)), J(S(this, St, WN).bind(this)), J(S(this, St, KN).bind(this)), J(S(this, St, XN).bind(this)), J(S(this, St, ZN).bind(this)), J(S(this, St, JN).bind(this));
  }
  onDestroy() {
    try {
      const n = this.createEvent("destroy"), { pictureInPicture: o, fullscreen: h } = this.$state;
      h() && this.exitFullscreen("prefer-media", n), o() && this.exitPictureInPicture(n);
    } catch {
    }
    d(this, pd).reset();
  }
  async play(n) {
    const { canPlay: o, paused: h, autoPlaying: v } = this.$state;
    if (S(this, St, rD).call(this, n) || !ye(h)) return;
    n && d(this, rt).queue.enqueue("media-play-request", n);
    const y = ye(v);
    try {
      const k = ye(d(this, xn));
      return TR(k, ye(o)), Y5(y), await k.play();
    } catch (k) {
      const D = this.createEvent("play-fail", {
        detail: lT(k),
        trigger: n
      });
      throw D.autoPlay = y, d(this, Nu).handle(D), k;
    }
  }
  async pause(n) {
    const { canPlay: o, paused: h } = this.$state;
    if (!ye(h)) {
      n && d(this, rt).queue.enqueue("media-pause-request", n);
      try {
        const v = ye(d(this, xn));
        return TR(v, ye(o)), await v.pause();
      } catch (v) {
        throw d(this, rt).queue.delete("media-pause-request"), v;
      }
    }
  }
  setAudioGain(n, o) {
    const { audioGain: h, canSetAudioGain: v } = this.$state;
    if (h() === n) return;
    const y = d(this, xn).call(this);
    if (!(y != null && y.audioGain) || !v())
      throw Error("[vidstack] audio gain api not available");
    o && d(this, rt).queue.enqueue("media-audio-gain-change-request", o), y.audioGain.setGain(n);
  }
  seekToLiveEdge(n) {
    const { canPlay: o, live: h, liveEdge: v, canSeek: y, liveSyncPosition: k, seekableEnd: D, userBehindLiveEdge: $ } = this.$state;
    if ($.set(!1), ye(() => !h() || v() || !y())) return;
    const _ = ye(d(this, xn));
    TR(_, ye(o)), n && d(this, rt).queue.enqueue("media-seek-request", n);
    const A = D() - 2;
    _.setCurrentTime(Math.min(A, k() ?? A));
  }
  async enterFullscreen(n = "prefer-media", o) {
    const h = S(this, St, aD).call(this, n);
    if (WA(n, h), !h.active)
      return ye(this.$state.pictureInPicture) && (L(this, Uv, !0), await this.exitPictureInPicture(o)), o && d(this, rt).queue.enqueue("media-enter-fullscreen-request", o), h.enter();
  }
  async exitFullscreen(n = "prefer-media", o) {
    const h = S(this, St, aD).call(this, n);
    if (WA(n, h), !!h.active) {
      o && d(this, rt).queue.enqueue("media-exit-fullscreen-request", o);
      try {
        const v = await h.exit();
        return d(this, Uv) && ye(this.$state.canPictureInPicture) && await this.enterPictureInPicture(), v;
      } finally {
        L(this, Uv, !1);
      }
    }
  }
  async enterPictureInPicture(n) {
    if (S(this, St, sD).call(this), !this.$state.pictureInPicture())
      return n && d(this, rt).queue.enqueue("media-enter-pip-request", n), await d(this, xn).call(this).pictureInPicture.enter();
  }
  async exitPictureInPicture(n) {
    if (S(this, St, sD).call(this), !!this.$state.pictureInPicture())
      return n && d(this, rt).queue.enqueue("media-exit-pip-request", n), await d(this, xn).call(this).pictureInPicture.exit();
  }
  async "media-airplay-request"(n) {
    try {
      await this.requestAirPlay(n);
    } catch {
    }
  }
  async requestAirPlay(n) {
    var o;
    try {
      const h = (o = d(this, xn).call(this)) == null ? void 0 : o.airPlay;
      if (!(h != null && h.supported))
        throw Error("No AirPlay adapter.");
      return n && d(this, rt).queue.enqueue("media-airplay-request", n), await h.prompt();
    } catch (h) {
      throw d(this, rt).queue.delete("media-airplay-request"), h;
    }
  }
  async "media-google-cast-request"(n) {
    try {
      await this.requestGoogleCast(n);
    } catch {
    }
  }
  async requestGoogleCast(n) {
    try {
      const { canGoogleCast: o } = this.$state;
      if (!ye(o)) {
        const v = Error(
          "Cast not available."
        );
        throw v.code = "CAST_NOT_AVAILABLE", v;
      }
      if (O0("https://www.gstatic.com"), !d(this, Ph)) {
        const v = await Promise.resolve().then(() => hQ);
        L(this, Ph, new v.GoogleCastLoader());
      }
      await d(this, Ph).prompt(d(this, Uu)), n && d(this, rt).queue.enqueue("media-google-cast-request", n);
      const h = ye(this.$state.remotePlaybackState) !== "disconnected";
      h && this.$state.savedState.set({
        paused: ye(this.$state.paused),
        currentTime: ye(this.$state.currentTime)
      }), this.$state.remotePlaybackLoader.set(h ? d(this, Ph) : null);
    } catch (o) {
      throw d(this, rt).queue.delete("media-google-cast-request"), o;
    }
  }
  "media-clip-start-change-request"(n) {
    const { clipStartTime: o } = this.$state;
    o.set(n.detail);
  }
  "media-clip-end-change-request"(n) {
    const { clipEndTime: o } = this.$state;
    o.set(n.detail), this.dispatch("duration-change", {
      detail: n.detail,
      trigger: n
    });
  }
  "media-duration-change-request"(n) {
    const { providedDuration: o, clipEndTime: h } = this.$state;
    o.set(n.detail), h() <= 0 && this.dispatch("duration-change", {
      detail: n.detail,
      trigger: n
    });
  }
  "media-audio-track-change-request"(n) {
    const { logger: o, audioTracks: h } = d(this, Uu);
    if (h.readonly)
      return;
    const v = n.detail, y = h[v];
    if (y) {
      const k = n.type;
      d(this, rt).queue.enqueue(k, n), y.selected = !0;
    }
  }
  async "media-enter-fullscreen-request"(n) {
    try {
      await this.enterFullscreen(n.detail, n);
    } catch (o) {
      S(this, St, lD).call(this, o, n);
    }
  }
  async "media-exit-fullscreen-request"(n) {
    try {
      await this.exitFullscreen(n.detail, n);
    } catch (o) {
      S(this, St, lD).call(this, o, n);
    }
  }
  async "media-orientation-lock-request"(n) {
    const o = n.type;
    try {
      d(this, rt).queue.enqueue(o, n), await d(this, zu).lock(n.detail);
    } catch {
      d(this, rt).queue.delete(o);
    }
  }
  async "media-orientation-unlock-request"(n) {
    const o = n.type;
    try {
      d(this, rt).queue.enqueue(o, n), await d(this, zu).unlock();
    } catch {
      d(this, rt).queue.delete(o);
    }
  }
  async "media-enter-pip-request"(n) {
    try {
      await this.enterPictureInPicture(n);
    } catch (o) {
      S(this, St, oD).call(this, o, n);
    }
  }
  async "media-exit-pip-request"(n) {
    try {
      await this.exitPictureInPicture(n);
    } catch (o) {
      S(this, St, oD).call(this, o, n);
    }
  }
  "media-live-edge-request"(n) {
    const { live: o, liveEdge: h, canSeek: v } = this.$state;
    if (!(!o() || h() || !v())) {
      d(this, rt).queue.enqueue("media-seek-request", n);
      try {
        this.seekToLiveEdge();
      } catch {
        d(this, rt).queue.delete("media-seek-request");
      }
    }
  }
  async "media-loop-request"(n) {
    try {
      d(this, rt).looping = !0, d(this, rt).replaying = !0, await this.play(n);
    } catch {
      d(this, rt).looping = !1;
    }
  }
  "media-user-loop-change-request"(n) {
    this.$state.userPrefersLoop.set(n.detail);
  }
  async "media-pause-request"(n) {
    if (!this.$state.paused())
      try {
        await this.pause(n);
      } catch {
      }
  }
  async "media-play-request"(n) {
    if (this.$state.paused())
      try {
        await this.play(n);
      } catch {
      }
  }
  "media-rate-change-request"(n) {
    const { playbackRate: o, canSetPlaybackRate: h } = this.$state;
    if (o() === n.detail || !h()) return;
    const v = d(this, xn).call(this);
    v != null && v.setPlaybackRate && (d(this, rt).queue.enqueue("media-rate-change-request", n), v.setPlaybackRate(n.detail));
  }
  "media-audio-gain-change-request"(n) {
    try {
      this.setAudioGain(n.detail, n);
    } catch {
    }
  }
  "media-quality-change-request"(n) {
    var k, D;
    const { qualities: o, storage: h, logger: v } = d(this, Uu);
    if (o.readonly)
      return;
    d(this, rt).queue.enqueue("media-quality-change-request", n);
    const y = n.detail;
    if (y < 0)
      o.autoSelect(n), n.isOriginTrusted && ((k = h == null ? void 0 : h.setVideoQuality) == null || k.call(h, null));
    else {
      const $ = o[y];
      $ && ($.selected = !0, n.isOriginTrusted && ((D = h == null ? void 0 : h.setVideoQuality) == null || D.call(h, {
        id: $.id,
        width: $.width,
        height: $.height,
        bitrate: $.bitrate
      })));
    }
  }
  "media-pause-controls-request"(n) {
    const o = n.type;
    d(this, rt).queue.enqueue(o, n), this.controls.pause(n);
  }
  "media-resume-controls-request"(n) {
    const o = n.type;
    d(this, rt).queue.enqueue(o, n), this.controls.resume(n);
  }
  "media-seek-request"(n) {
    const { canSeek: o, ended: h, live: v, seekableEnd: y, userBehindLiveEdge: k } = this.$state, D = n.detail;
    h() && (d(this, rt).replaying = !0);
    const $ = n.type;
    d(this, rt).seeking = !1, d(this, rt).queue.delete($);
    const _ = t_(D, this.$state);
    !Number.isFinite(_) || !o() || (d(this, rt).queue.enqueue($, n), d(this, xn).call(this).setCurrentTime(_), v() && n.isOriginTrusted && Math.abs(y() - _) >= 2 && k.set(!0));
  }
  "media-seeking-request"(n) {
    const o = n.type;
    d(this, rt).queue.enqueue(o, n), this.$state.seeking.set(!0), d(this, rt).seeking = !0;
  }
  "media-start-loading"(n) {
    if (this.$state.canLoad()) return;
    const o = n.type;
    d(this, rt).queue.enqueue(o, n), d(this, Nu).handle(this.createEvent("can-load"));
  }
  "media-poster-start-loading"(n) {
    if (this.$state.canLoadPoster()) return;
    const o = n.type;
    d(this, rt).queue.enqueue(o, n), d(this, Nu).handle(this.createEvent("can-load-poster"));
  }
  "media-text-track-change-request"(n) {
    const { index: o, mode: h } = n.detail, v = d(this, Uu).textTracks[o];
    if (v) {
      const y = n.type;
      d(this, rt).queue.enqueue(y, n), v.setMode(h, n);
    }
  }
  "media-mute-request"(n) {
    if (this.$state.muted()) return;
    const o = n.type;
    d(this, rt).queue.enqueue(o, n), d(this, xn).call(this).setMuted(!0);
  }
  "media-unmute-request"(n) {
    const { muted: o, volume: h } = this.$state;
    if (!o()) return;
    const v = n.type;
    d(this, rt).queue.enqueue(v, n), d(this, Uu).$provider().setMuted(!1), h() === 0 && (d(this, rt).queue.enqueue(v, n), d(this, xn).call(this).setVolume(0.25));
  }
  "media-volume-change-request"(n) {
    const { muted: o, volume: h } = this.$state, v = n.detail;
    if (h() === v) return;
    const y = n.type;
    d(this, rt).queue.enqueue(y, n), d(this, xn).call(this).setVolume(v), v > 0 && o() && (d(this, rt).queue.enqueue(y, n), d(this, xn).call(this).setMuted(!1));
  }
}
Nu = new WeakMap(), rt = new WeakMap(), Uu = new WeakMap(), Ah = new WeakMap(), zu = new WeakMap(), xn = new WeakMap(), pd = new WeakMap(), St = new WeakSet(), BN = function() {
  const { load: n } = this.$props, { canLoad: o } = this.$state;
  if (n() !== "play" || o()) return;
  const h = this.listen("media-play-request", (v) => {
    S(this, St, rD).call(this, v), h();
  });
}, QN = function() {
  const n = d(this, xn).call(this), o = this.$state.canPlay();
  return n && o && d(this, pd).start(), () => {
    d(this, pd).stop();
  };
}, YN = function(n) {
  n.stopPropagation(), !n.defaultPrevented && this[n.type] && (ye(d(this, xn)) ? this[n.type](n) : d(this, pd).enqueue(n.type, () => {
    ye(d(this, xn)) && this[n.type](n);
  }));
}, rD = function(n) {
  const { load: o } = this.$props, { canLoad: h } = this.$state;
  if (o() === "play" && !h()) {
    const v = this.createEvent("media-start-loading", { trigger: n });
    return this.dispatchEvent(v), d(this, pd).enqueue("media-play-request", async () => {
      try {
        await this.play(v);
      } catch {
      }
    }), !0;
  }
  return !1;
}, Uv = new WeakMap(), aD = function(n) {
  const o = ye(d(this, xn));
  return n === "prefer-media" && d(this, Ah).supported || n === "media" ? d(this, Ah) : o == null ? void 0 : o.fullscreen;
}, sD = function() {
  if (!this.$state.canPictureInPicture())
    throw Error(
      "[vidstack] no pip support"
    );
}, GN = function() {
  this.controls.defaultDelay = this.$props.controlsDelay();
}, WN = function() {
  var h, v;
  const { canSetAudioGain: n } = this.$state, o = !!((v = (h = d(this, xn).call(this)) == null ? void 0 : h.audioGain) != null && v.supported);
  n.set(o);
}, KN = function() {
  var h, v;
  const { canAirPlay: n } = this.$state, o = !!((v = (h = d(this, xn).call(this)) == null ? void 0 : h.airPlay) != null && v.supported);
  n.set(o);
}, XN = function() {
  const { canGoogleCast: n, source: o } = this.$state, h = $0 && !L0 && KP(o());
  n.set(h);
}, ZN = function() {
  var h, v;
  const { canFullscreen: n } = this.$state, o = d(this, Ah).supported || !!((v = (h = d(this, xn).call(this)) == null ? void 0 : h.fullscreen) != null && v.supported);
  n.set(o);
}, JN = function() {
  var h, v;
  const { canPictureInPicture: n } = this.$state, o = !!((v = (h = d(this, xn).call(this)) == null ? void 0 : h.pictureInPicture) != null && v.supported);
  n.set(o);
}, Ph = new WeakMap(), eU = async function(n) {
  const o = ye(this.$props.fullscreenOrientation), h = n.detail;
  if (!(pi(o) || o === "none" || !d(this, zu).supported))
    if (h) {
      if (d(this, zu).locked) return;
      this.dispatch("media-orientation-lock-request", {
        detail: o,
        trigger: n
      });
    } else d(this, zu).locked && this.dispatch("media-orientation-unlock-request", {
      trigger: n
    });
}, lD = function(n, o) {
  d(this, Nu).handle(
    this.createEvent("fullscreen-error", {
      detail: lT(n)
    })
  );
}, oD = function(n, o) {
  d(this, Nu).handle(
    this.createEvent("picture-in-picture-error", {
      detail: lT(n)
    })
  );
}, Q5 = function(n, o, h) {
};
function TR(f, s) {
  if (!(f && s))
    throw Error(
      "[vidstack] media not ready"
    );
}
function WA(f, s) {
  if (!(s != null && s.supported))
    throw Error(
      "[vidstack] no fullscreen support"
    );
}
function Y5(f) {
  if (!(!j5() || !f))
    throw Error(
      "[vidstack] autoplay blocked"
    );
}
class G5 {
  constructor() {
    Z(this, "seeking", !1);
    Z(this, "looping", !1);
    Z(this, "replaying", !1);
    Z(this, "queue", new I5());
  }
}
const W5 = /* @__PURE__ */ new Set([
  "auto-play",
  "auto-play-fail",
  "can-load",
  "sources-change",
  "source-change",
  "load-start",
  "abort",
  "error",
  "loaded-metadata",
  "loaded-data",
  "can-play",
  "play",
  "play-fail",
  "pause",
  "playing",
  "seeking",
  "seeked",
  "waiting"
]);
var ia, It, dn, _h, zv, Nh, Uh, Fu, md, se, tU, nU, Jc, qn, iU, rU, aU, Mb, uD, cD, sU, dD, lU, oU, Fv, fD, Lb, uU, cU, dU, hD, pD, mD, fU, vD, hU, Vv, pU, yD;
class K5 extends rp {
  constructor(n, o) {
    super();
    R(this, se);
    R(this, ia);
    R(this, It);
    R(this, dn, /* @__PURE__ */ new Map());
    R(this, _h, !1);
    R(this, zv, []);
    R(this, Nh, [-1, -1]);
    R(this, Uh, !1);
    R(this, Fu);
    R(this, md, !1);
    R(this, Fv, null);
    Z(this, "seeking", cw(
      (n) => {
        const { seeking: o, realCurrentTime: h, paused: v } = this.$state;
        o.set(!0), h.set(n.detail), S(this, se, qn).call(this, "media-seeking-request", n), v() && (L(this, Fu, n), d(this, Vv).call(this)), L(this, Nh, [-1, -1]);
      },
      150,
      { leading: !0 }
    ));
    R(this, Vv, FM(() => {
      if (!d(this, Fu)) return;
      L(this, Uh, !0);
      const { waiting: n, playing: o } = this.$state;
      n.set(!0), o.set(!1);
      const h = this.createEvent("waiting", { trigger: d(this, Fu) });
      d(this, dn).set("waiting", h), this.dispatch(h), L(this, Fu, void 0), L(this, Uh, !1);
    }, 300));
    L(this, ia, n), L(this, It, o);
  }
  onAttach(n) {
    n.setAttribute("aria-busy", "true"), new gn(this).add("fullscreen-change", this["fullscreen-change"].bind(this)).add("fullscreen-error", this["fullscreen-error"].bind(this)).add("orientation-change", this["orientation-change"].bind(this));
  }
  onConnect(n) {
    J(S(this, se, cU).bind(this)), S(this, se, iU).call(this), S(this, se, rU).call(this), S(this, se, aU).call(this), S(this, se, tU).call(this), Wt(S(this, se, nU).bind(this));
  }
  onDestroy() {
    const { audioTracks: n, qualities: o, textTracks: h } = d(this, It);
    n[at.reset](), o[at.reset](), h[at.reset](), S(this, se, Lb).call(this);
  }
  handle(n) {
    if (!this.scope) return;
    const o = n.type;
    py(() => {
      var h;
      return (h = this[n.type]) == null ? void 0 : h.call(this, n);
    }), W5.has(o) && d(this, dn).set(o, n), this.dispatch(n);
  }
  "provider-change"(n) {
    var v, y;
    const o = d(this, It).$provider(), h = n.detail;
    (o == null ? void 0 : o.type) !== (h == null ? void 0 : h.type) && ((v = o == null ? void 0 : o.destroy) == null || v.call(o), (y = o == null ? void 0 : o.scope) == null || y.dispose(), d(this, It).$provider.set(n.detail), o && n.detail === null && S(this, se, hD).call(this, n));
  }
  "provider-loader-change"(n) {
  }
  "auto-play"(n) {
    this.$state.autoPlayError.set(null);
  }
  "auto-play-fail"(n) {
    this.$state.autoPlayError.set(n.detail), S(this, se, Jc).call(this);
  }
  "can-load"(n) {
    this.$state.canLoad.set(!0), d(this, dn).set("can-load", n), d(this, It).textTracks[tt.canLoad](), S(this, se, qn).call(this, "media-start-loading", n);
  }
  "can-load-poster"(n) {
    this.$state.canLoadPoster.set(!0), d(this, dn).set("can-load-poster", n), S(this, se, qn).call(this, "media-poster-start-loading", n);
  }
  "media-type-change"(n) {
    const o = d(this, dn).get("source-change");
    o && n.triggers.add(o);
    const h = this.$state.viewType();
    this.$state.mediaType.set(n.detail);
    const v = this.$state.providedViewType(), y = v === "unknown" ? n.detail : v;
    h !== y && setTimeout(() => {
      requestAnimationFrame(() => {
        this.scope && (this.$state.inferredViewType.set(n.detail), this.dispatch("view-type-change", {
          detail: y,
          trigger: n
        }));
      });
    }, 0);
  }
  "stream-type-change"(n) {
    const o = d(this, dn).get("source-change");
    o && n.triggers.add(o);
    const { streamType: h, inferredStreamType: v } = this.$state;
    v.set(n.detail), n.detail = h();
  }
  "rate-change"(n) {
    var v;
    const { storage: o } = d(this, It), { canPlay: h } = this.$state;
    this.$state.playbackRate.set(n.detail), S(this, se, qn).call(this, "media-rate-change-request", n), h() && ((v = o == null ? void 0 : o.setPlaybackRate) == null || v.call(o, n.detail));
  }
  "remote-playback-change"(n) {
    const { remotePlaybackState: o, remotePlaybackType: h } = this.$state, { type: v, state: y } = n.detail, k = y === "connected";
    h.set(v), o.set(y);
    const D = v === "airplay" ? "media-airplay-request" : "media-google-cast-request";
    if (k)
      S(this, se, qn).call(this, D, n);
    else {
      const $ = d(this, ia).queue.peek(D);
      $ && (n.request = $, n.triggers.add($));
    }
  }
  "sources-change"(n) {
    const o = this.$state.sources(), h = n.detail;
    this.$state.sources.set(h), S(this, se, dU).call(this, o, h, n);
  }
  "source-change"(n) {
    var h, v;
    n.isQualityChange = ((h = n.originEvent) == null ? void 0 : h.type) === "quality-change";
    const o = n.detail;
    S(this, se, hD).call(this, n, n.isQualityChange), d(this, dn).set(n.type, n), this.$state.source.set(o), (v = this.el) == null || v.setAttribute("aria-busy", "true");
  }
  abort(n) {
    const o = d(this, dn).get("source-change");
    o && n.triggers.add(o);
    const h = d(this, dn).get("can-load");
    h && !n.triggers.hasType("can-load") && n.triggers.add(h);
  }
  "load-start"(n) {
    const o = d(this, dn).get("source-change");
    o && n.triggers.add(o);
  }
  error(n) {
    this.$state.error.set(n.detail);
    const o = d(this, dn).get("abort");
    o && n.triggers.add(o);
  }
  "loaded-metadata"(n) {
    const o = d(this, dn).get("load-start");
    o && n.triggers.add(o);
  }
  "loaded-data"(n) {
    const o = d(this, dn).get("load-start");
    o && n.triggers.add(o);
  }
  "can-play"(n) {
    var h;
    const o = d(this, dn).get("loaded-metadata");
    o && n.triggers.add(o), S(this, se, pD).call(this, n.detail), (h = this.el) == null || h.setAttribute("aria-busy", "false");
  }
  "can-play-through"(n) {
    S(this, se, pD).call(this, n.detail);
    const o = d(this, dn).get("can-play");
    o && n.triggers.add(o);
  }
  "duration-change"(n) {
    const { live: o, intrinsicDuration: h, providedDuration: v, clipEndTime: y, ended: k } = this.$state, D = n.detail;
    if (!o()) {
      const $ = Number.isNaN(D) ? 0 : D;
      h.set($), k() && S(this, se, vD).call(this, n);
    }
    (v() > 0 || y() > 0) && n.stopImmediatePropagation();
  }
  progress(n) {
    const { buffered: o, seekable: h } = this.$state, { buffered: v, seekable: y } = n.detail, k = mh(v), D = v.length !== o().length, $ = k !== mh(o()), _ = mh(y), A = y.length !== h().length, B = _ !== mh(h());
    (D || $) && o.set(v), (A || B) && h.set(y);
  }
  play(n) {
    const {
      paused: o,
      autoPlayError: h,
      ended: v,
      autoPlaying: y,
      playsInline: k,
      pointer: D,
      muted: $,
      viewType: _,
      live: A,
      userBehindLiveEdge: B
    } = this.$state;
    if (S(this, se, mD).call(this), !o()) {
      n.stopImmediatePropagation();
      return;
    }
    n.autoPlay = y();
    const W = d(this, dn).get("waiting");
    W && n.triggers.add(W), S(this, se, qn).call(this, "media-play-request", n), d(this, dn).set("play", n), o.set(!1), h.set(null), n.autoPlay && (this.handle(
      this.createEvent("auto-play", {
        detail: { muted: $() },
        trigger: n
      })
    ), y.set(!1)), (v() || d(this, ia).replaying) && (d(this, ia).replaying = !1, v.set(!1), this.handle(this.createEvent("replay", { trigger: n }))), !k() && _() === "video" && D() === "coarse" && d(this, It).remote.enterFullscreen("prefer-media", n), A() && !B() && d(this, It).remote.seekToLiveEdge(n);
  }
  "play-fail"(n) {
    const { muted: o, autoPlaying: h } = this.$state, v = d(this, dn).get("play");
    v && n.triggers.add(v), S(this, se, qn).call(this, "media-play-request", n);
    const { paused: y, playing: k } = this.$state;
    y.set(!0), k.set(!1), S(this, se, Jc).call(this), d(this, dn).set("play-fail", n), n.autoPlay && (this.handle(
      this.createEvent("auto-play-fail", {
        detail: {
          muted: o(),
          error: n.detail
        },
        trigger: n
      })
    ), h.set(!1));
  }
  playing(n) {
    const o = d(this, dn).get("play"), h = d(this, dn).get("seeked");
    o ? n.triggers.add(o) : h && n.triggers.add(h), setTimeout(() => S(this, se, Jc).call(this), 0);
    const {
      paused: v,
      playing: y,
      live: k,
      liveSyncPosition: D,
      seekableEnd: $,
      started: _,
      currentTime: A,
      seeking: B,
      ended: W
    } = this.$state;
    if (v.set(!1), y.set(!0), B.set(!1), W.set(!1), d(this, ia).looping) {
      d(this, ia).looping = !1;
      return;
    }
    if (k() && !_() && A() === 0) {
      const ne = D() ?? $() - 2;
      Number.isFinite(ne) && d(this, It).$provider().setCurrentTime(ne);
    }
    this.started(n);
  }
  started(n) {
    const { started: o } = this.$state;
    o() || (o.set(!0), this.handle(this.createEvent("started", { trigger: n })));
  }
  pause(n) {
    var y;
    (y = this.el) != null && y.isConnected || L(this, md, !0), S(this, se, qn).call(this, "media-pause-request", n);
    const o = d(this, dn).get("seeked");
    o && n.triggers.add(o);
    const { paused: h, playing: v } = this.$state;
    h.set(!0), v.set(!1), d(this, _h) && setTimeout(() => {
      this.handle(this.createEvent("end", { trigger: n })), L(this, _h, !1);
    }, 0), S(this, se, Jc).call(this);
  }
  "time-change"(n) {
    if (d(this, ia).looping) {
      n.stopImmediatePropagation();
      return;
    }
    let { waiting: o, played: h, clipEndTime: v, realCurrentTime: y, currentTime: k } = this.$state, D = n.detail, $ = v();
    y.set(D), S(this, se, fU).call(this), o.set(!1);
    for (const _ of d(this, It).textTracks)
      _[tt.updateActiveCues](D, n);
    $ > 0 && D >= $ && (L(this, _h, !0), this.dispatch("media-pause-request", { trigger: n })), S(this, se, hU).call(this), this.dispatch("time-update", {
      detail: { currentTime: k(), played: h() },
      trigger: n
    });
  }
  "audio-gain-change"(n) {
    var y;
    const { storage: o } = d(this, It), { canPlay: h, audioGain: v } = this.$state;
    v.set(n.detail), S(this, se, qn).call(this, "media-audio-gain-change-request", n), h() && ((y = o == null ? void 0 : o.setAudioGain) == null || y.call(o, v()));
  }
  "volume-change"(n) {
    var D, $;
    const { storage: o } = d(this, It), { volume: h, muted: v, canPlay: y } = this.$state, k = n.detail;
    h.set(k.volume), v.set(k.muted || k.volume === 0), S(this, se, qn).call(this, "media-volume-change-request", n), S(this, se, qn).call(this, k.muted ? "media-mute-request" : "media-unmute-request", n), y() && ((D = o == null ? void 0 : o.setVolume) == null || D.call(o, h()), ($ = o == null ? void 0 : o.setMuted) == null || $.call(o, v()));
  }
  seeked(n) {
    const { seeking: o, currentTime: h, realCurrentTime: v, paused: y, seekableEnd: k, ended: D, live: $ } = this.$state;
    if (d(this, ia).seeking)
      o.set(!0), n.stopImmediatePropagation();
    else if (o()) {
      const _ = d(this, dn).get("waiting");
      _ && n.triggers.add(_);
      const A = d(this, dn).get("seeking");
      A && !n.triggers.has(A) && n.triggers.add(A), y() && S(this, se, yD).call(this), o.set(!1), v.set(n.detail), S(this, se, qn).call(this, "media-seek-request", n);
      const B = n == null ? void 0 : n.originEvent;
      B != null && B.isTrusted && !(B instanceof MessageEvent) && !/seek/.test(B.type) && this.started(n);
    }
    $() || (Math.floor(v()) !== Math.floor(k()) ? D.set(!1) : this.end(n));
  }
  waiting(n) {
    d(this, Uh) || d(this, ia).seeking || (n.stopImmediatePropagation(), L(this, Fu, n), d(this, Vv).call(this));
  }
  end(n) {
    const { loop: o, ended: h } = this.$state;
    if (!(!o() && h())) {
      if (o()) {
        setTimeout(() => {
          requestAnimationFrame(() => {
            S(this, se, mD).call(this, n), this.dispatch("media-loop-request", { trigger: n });
          });
        }, 10);
        return;
      }
      setTimeout(() => S(this, se, pU).call(this, n), 0);
    }
  }
  "fullscreen-change"(n) {
    const o = n.detail;
    this.$state.fullscreen.set(o), S(this, se, qn).call(this, o ? "media-enter-fullscreen-request" : "media-exit-fullscreen-request", n);
  }
  "fullscreen-error"(n) {
    S(this, se, qn).call(this, "media-enter-fullscreen-request", n), S(this, se, qn).call(this, "media-exit-fullscreen-request", n);
  }
  "orientation-change"(n) {
    const o = n.detail.lock;
    S(this, se, qn).call(this, o ? "media-orientation-lock-request" : "media-orientation-unlock-request", n);
  }
  "picture-in-picture-change"(n) {
    const o = n.detail;
    this.$state.pictureInPicture.set(o), S(this, se, qn).call(this, o ? "media-enter-pip-request" : "media-exit-pip-request", n);
  }
  "picture-in-picture-error"(n) {
    S(this, se, qn).call(this, "media-enter-pip-request", n), S(this, se, qn).call(this, "media-exit-pip-request", n);
  }
  "title-change"(n) {
    n.trigger && (n.stopImmediatePropagation(), this.$state.inferredTitle.set(n.detail));
  }
  "poster-change"(n) {
    n.trigger && (n.stopImmediatePropagation(), this.$state.inferredPoster.set(n.detail));
  }
}
ia = new WeakMap(), It = new WeakMap(), dn = new WeakMap(), _h = new WeakMap(), zv = new WeakMap(), Nh = new WeakMap(), Uh = new WeakMap(), Fu = new WeakMap(), md = new WeakMap(), se = new WeakSet(), tU = function() {
  d(this, md) && (requestAnimationFrame(() => {
    this.scope && d(this, It).remote.play(new vt("dom-connect"));
  }), L(this, md, !1));
}, nU = function() {
  var n;
  d(this, md) || (L(this, md, !this.$state.paused()), (n = d(this, It).$provider()) == null || n.pause());
}, Jc = function() {
  S(this, se, yD).call(this), L(this, _h, !1), d(this, ia).replaying = !1, d(this, ia).looping = !1, L(this, Uh, !1), L(this, Fu, void 0), d(this, dn).clear();
}, qn = function(n, o) {
  const h = d(this, ia).queue.serve(n);
  h && (o.request = h, o.triggers.add(h));
}, iU = function() {
  S(this, se, Mb).call(this), S(this, se, uD).call(this);
  const n = d(this, It).textTracks;
  new gn(n).add("add", S(this, se, Mb).bind(this)).add("remove", S(this, se, Mb).bind(this)).add("mode-change", S(this, se, uD).bind(this));
}, rU = function() {
  const n = d(this, It).qualities;
  new gn(n).add("add", S(this, se, dD).bind(this)).add("remove", S(this, se, dD).bind(this)).add("change", S(this, se, lU).bind(this)).add("auto-change", S(this, se, oU).bind(this)).add("readonly-change", S(this, se, uU).bind(this));
}, aU = function() {
  const n = d(this, It).audioTracks;
  new gn(n).add("add", S(this, se, cD).bind(this)).add("remove", S(this, se, cD).bind(this)).add("change", S(this, se, sU).bind(this));
}, Mb = function(n) {
  const { textTracks: o } = this.$state;
  o.set(d(this, It).textTracks.toArray()), this.dispatch("text-tracks-change", {
    detail: o(),
    trigger: n
  });
}, uD = function(n) {
  n && S(this, se, qn).call(this, "media-text-track-change-request", n);
  const o = d(this, It).textTracks.selected, { textTrack: h } = this.$state;
  h() !== o && (h.set(o), this.dispatch("text-track-change", {
    detail: o,
    trigger: n
  }));
}, cD = function(n) {
  const { audioTracks: o } = this.$state;
  o.set(d(this, It).audioTracks.toArray()), this.dispatch("audio-tracks-change", {
    detail: o(),
    trigger: n
  });
}, sU = function(n) {
  const { audioTrack: o } = this.$state;
  o.set(d(this, It).audioTracks.selected), n && S(this, se, qn).call(this, "media-audio-track-change-request", n), this.dispatch("audio-track-change", {
    detail: o(),
    trigger: n
  });
}, dD = function(n) {
  const { qualities: o } = this.$state;
  o.set(d(this, It).qualities.toArray()), this.dispatch("qualities-change", {
    detail: o(),
    trigger: n
  });
}, lU = function(n) {
  const { quality: o } = this.$state;
  o.set(d(this, It).qualities.selected), n && S(this, se, qn).call(this, "media-quality-change-request", n), this.dispatch("quality-change", {
    detail: o(),
    trigger: n
  });
}, oU = function() {
  const { qualities: n } = d(this, It), o = n.auto;
  this.$state.autoQuality.set(o), o || S(this, se, Lb).call(this);
}, Fv = new WeakMap(), fD = function() {
  S(this, se, Lb).call(this), L(this, Fv, J(() => {
    const { qualities: n } = d(this, It), { mediaWidth: o, mediaHeight: h } = this.$state, v = o(), y = h();
    if (v === 0 || y === 0) return;
    let k = null, D = 1 / 0;
    for (const $ of n) {
      const _ = Math.abs($.width - v) + Math.abs($.height - y);
      _ < D && (D = _, k = $);
    }
    k && n[at.select](
      k,
      !0,
      new vt("resize", { detail: { width: v, height: y } })
    );
  }));
}, Lb = function() {
  var n;
  (n = d(this, Fv)) == null || n.call(this), L(this, Fv, null);
}, uU = function() {
  this.$state.canSetQuality.set(!d(this, It).qualities.readonly);
}, cU = function() {
  const { canSetVolume: n, isGoogleCastConnected: o } = this.$state;
  if (o()) {
    n.set(!1);
    return;
  }
  hB().then(n.set);
}, dU = function(n, o, h) {
  let { qualities: v } = d(this, It), y = !1, k = !1;
  for (const D of n) {
    if (!MR(D)) continue;
    if (!o.some((_) => _.src === D.src)) {
      const _ = v.getBySrc(D.src);
      _ && (v[at.remove](_, h), k = !0);
    }
  }
  k && !v.length && (this.$state.savedState.set(null), v[at.reset](h));
  for (const D of o) {
    if (!MR(D) || v.getBySrc(D.src)) continue;
    const $ = {
      id: D.id ?? D.height + "p",
      bitrate: null,
      codec: null,
      ...D,
      selected: !1
    };
    v[at.add]($, h), y = !0;
  }
  y && !v[la.enableAuto] && (S(this, se, fD).call(this), v[la.enableAuto] = S(this, se, fD).bind(this), v[la.setAuto](!0, h));
}, hD = function(n, o = !1) {
  const { audioTracks: h, qualities: v } = d(this, It);
  if (!o) {
    L(this, zv, []), L(this, Nh, [-1, -1]), h[at.reset](n), v[at.reset](n), VA(this.$state, o), S(this, se, Jc).call(this);
    return;
  }
  VA(this.$state, o), S(this, se, Jc).call(this);
}, pD = function(n) {
  const { seekable: o, buffered: h, intrinsicDuration: v, canPlay: y } = this.$state;
  y.set(!0), h.set(n.buffered), o.set(n.seekable);
  const k = mh(n.seekable) ?? 1 / 0;
  v.set(k);
}, mD = function(n) {
  if (!ye(d(this, It).$provider)) return;
  const { ended: h, seekableStart: v, clipEndTime: y, currentTime: k, realCurrentTime: D, duration: $ } = this.$state, _ = h() || D() < v() || y() > 0 && D() >= y() || Math.abs(k() - $()) < 0.1;
  return _ && this.dispatch("media-seek-request", {
    detail: v(),
    trigger: n
  }), _;
}, fU = function() {
  const { currentTime: n, played: o, paused: h } = this.$state;
  h() || (L(this, Nh, gB(
    d(this, zv),
    d(this, Nh),
    n()
  )), o.set(new Cb(d(this, zv))));
}, // Called to update time again incase duration precision has changed.
vD = function(n) {
  const { clipStartTime: o, clipEndTime: h, duration: v } = this.$state;
  o() > 0 || h() > 0 || this.handle(
    this.createEvent("time-change", {
      detail: v(),
      trigger: n
    })
  );
}, hU = function() {
  var v;
  const { storage: n } = d(this, It), { canPlay: o, realCurrentTime: h } = this.$state;
  o() && ((v = n == null ? void 0 : n.setTime) == null || v.call(n, h()));
}, Vv = new WeakMap(), pU = function(n) {
  var D;
  const { storage: o } = d(this, It), { paused: h, seeking: v, ended: y, duration: k } = this.$state;
  S(this, se, vD).call(this, n), h() || this.dispatch("pause", { trigger: n }), v() && this.dispatch("seeked", {
    detail: k(),
    trigger: n
  }), y.set(!0), S(this, se, Jc).call(this), (D = o == null ? void 0 : o.setTime) == null || D.call(o, k(), !0), this.dispatch("ended", {
    trigger: n
  });
}, yD = function() {
  d(this, Vv).cancel(), this.$state.waiting.set(!1);
};
var _t, mU, vU, Z5, yU, gU, SU, TU, wU, EU, CU, bU, kU, xU, RU, DU, MU, LU;
class X5 extends rp {
  constructor() {
    super(...arguments);
    R(this, _t);
  }
  onSetup() {
    S(this, _t, mU).call(this);
    const n = [
      S(this, _t, yU),
      S(this, _t, SU),
      S(this, _t, xU),
      S(this, _t, RU),
      S(this, _t, wU),
      S(this, _t, CU),
      S(this, _t, bU),
      S(this, _t, DU),
      S(this, _t, LU),
      S(this, _t, MU),
      S(this, _t, TU),
      S(this, _t, kU),
      S(this, _t, EU),
      S(this, _t, vU),
      S(this, _t, gU)
    ];
    for (const o of n)
      J(o.bind(this));
  }
}
_t = new WeakSet(), mU = function() {
  var h;
  const n = {
    duration: "providedDuration",
    loop: "providedLoop",
    poster: "providedPoster",
    streamType: "providedStreamType",
    title: "providedTitle",
    viewType: "providedViewType"
  }, o = /* @__PURE__ */ new Set([
    "currentTime",
    "paused",
    "playbackRate",
    "volume"
  ]);
  for (const v of Object.keys(this.$props))
    o.has(v) || (h = this.$state[n[v] ?? v]) == null || h.set(this.$props[v]());
  this.$state.muted.set(this.$props.muted() || this.$props.volume() === 0);
}, // Sync "provided" props with internal state. Provided props are used to differentiate from
// provider inferred values.
vU = function() {
  const { viewType: n, streamType: o, title: h, poster: v, loop: y } = this.$props, k = this.$state;
  k.providedPoster.set(v()), k.providedStreamType.set(o()), k.providedViewType.set(n()), k.providedTitle.set(h()), k.providedLoop.set(y());
}, Z5 = function() {
}, yU = function() {
  const { artist: n, artwork: o } = this.$props;
  this.$state.artist.set(n()), this.$state.artwork.set(o());
}, gU = function() {
  const { title: n } = this.$state;
  this.dispatch("title-change", { detail: n() });
}, SU = function() {
  const n = this.$props.autoPlay() || this.$props.autoplay();
  this.$state.autoPlay.set(n), this.dispatch("auto-play-change", { detail: n });
}, TU = function() {
  const n = this.$state.loop();
  this.dispatch("loop-change", { detail: n });
}, wU = function() {
  const n = this.$props.controls();
  this.$state.controls.set(n);
}, EU = function() {
  const { poster: n } = this.$state;
  this.dispatch("poster-change", { detail: n() });
}, CU = function() {
  const n = this.$props.crossOrigin() ?? this.$props.crossorigin(), o = n === !0 ? "" : n;
  this.$state.crossOrigin.set(o);
}, bU = function() {
  const { duration: n } = this.$props;
  this.dispatch("media-duration-change-request", {
    detail: n()
  });
}, kU = function() {
  const n = this.$props.playsInline() || this.$props.playsinline();
  this.$state.playsInline.set(n), this.dispatch("plays-inline-change", { detail: n });
}, xU = function() {
  const { clipStartTime: n } = this.$props;
  this.dispatch("media-clip-start-change-request", {
    detail: n()
  });
}, RU = function() {
  const { clipEndTime: n } = this.$props;
  this.dispatch("media-clip-end-change-request", {
    detail: n()
  });
}, DU = function() {
  this.dispatch("live-change", { detail: this.$state.live() });
}, MU = function() {
  this.$state.liveEdgeTolerance.set(this.$props.liveEdgeTolerance()), this.$state.minLiveDVRWindow.set(this.$props.minLiveDVRWindow());
}, LU = function() {
  this.dispatch("live-edge-change", { detail: this.$state.liveEdge() });
};
const KA = ["play", "pause", "seekforward", "seekbackward", "seekto"];
var ko, $U, OU, AU, PU;
class J5 extends rp {
  constructor() {
    super(...arguments);
    R(this, ko);
  }
  onConnect() {
    J(S(this, ko, OU).bind(this)), J(S(this, ko, AU).bind(this));
    const n = S(this, ko, PU).bind(this);
    for (const o of KA)
      navigator.mediaSession.setActionHandler(o, n);
    Wt(S(this, ko, $U).bind(this));
  }
}
ko = new WeakSet(), $U = function() {
  for (const n of KA)
    navigator.mediaSession.setActionHandler(n, null);
}, OU = function() {
  const { title: n, artist: o, artwork: h, poster: v } = this.$state;
  navigator.mediaSession.metadata = new MediaMetadata({
    title: n(),
    artist: o(),
    artwork: h() ?? [{ src: v() }]
  });
}, AU = function() {
  const { canPlay: n, paused: o } = this.$state;
  navigator.mediaSession.playbackState = n() ? o() ? "paused" : "playing" : "none";
}, PU = function(n) {
  const o = new vt("media-session-action", { detail: n });
  switch (n.action) {
    case "play":
      this.dispatch("media-play-request", { trigger: o });
      break;
    case "pause":
      this.dispatch("media-pause-request", { trigger: o });
      break;
    case "seekto":
    case "seekforward":
    case "seekbackward":
      this.dispatch("media-seek-request", {
        detail: ss(n.seekTime) ? n.seekTime : this.$state.currentTime() + (n.seekOffset ?? (n.action === "seekforward" ? 10 : -10)),
        trigger: o
      });
      break;
  }
};
let gD = st(!1);
En(document, "pointerdown", () => {
  gD.set(!1);
}), En(document, "keydown", (f) => {
  f.metaKey || f.altKey || f.ctrlKey || gD.set(!0);
});
var vd, xo, _U, NU, UU, zU;
class dw extends Hs {
  constructor() {
    super(...arguments);
    R(this, xo);
    R(this, vd, st(!1));
  }
  onConnect(n) {
    J(() => {
      const o = new gn(n);
      if (!gD()) {
        d(this, vd).set(!1), mb(n, !1), o.add("pointerenter", S(this, xo, UU).bind(this)).add("pointerleave", S(this, xo, zU).bind(this));
        return;
      }
      const h = document.activeElement === n;
      d(this, vd).set(h), mb(n, h), o.add("focus", S(this, xo, _U).bind(this)).add("blur", S(this, xo, NU).bind(this));
    });
  }
  focused() {
    return d(this, vd).call(this);
  }
}
vd = new WeakMap(), xo = new WeakSet(), _U = function() {
  d(this, vd).set(!0), mb(this.el, !0);
}, NU = function() {
  d(this, vd).set(!1), mb(this.el, !1);
}, UU = function() {
  XA(this.el, !0);
}, zU = function() {
  XA(this.el, !1);
};
function mb(f, s) {
  Rt(f, "data-focus", s), Rt(f, "data-hocus", s);
}
function XA(f, s) {
  Rt(f, "data-hocus", s), Rt(f, "data-hover", s);
}
var e8 = Object.defineProperty, t8 = Object.getOwnPropertyDescriptor, hn = (f, s, n, o) => {
  for (var h = o > 1 ? void 0 : o ? t8(s, n) : s, v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = (o ? y(s, n, h) : y(h)) || h);
  return o && h && e8(s, n, h), h;
}, To, yr, zh, gr, be, es, $b, Hv, FU, VU, HU, IU, qU, nT, SD, jU, TD, BU, wD, QU, ED, YU, CD, GU, bD, WU, KU, XU, ZU;
const on = (To = class extends Ci {
  constructor() {
    super();
    R(this, be);
    R(this, yr);
    R(this, zh);
    R(this, gr);
    Z(this, "canPlayQueue", new jN());
    Z(this, "remoteControl");
    R(this, Hv, !1);
    Z(this, "orientation");
    new X5();
    const n = {
      player: this,
      qualities: new l5(),
      audioTracks: new KB(),
      storage: null,
      $provider: st(null),
      $providerSetup: st(!1),
      $props: this.$props,
      $state: this.$state
    };
    n.remote = this.remoteControl = new n_(
      void 0
    ), n.remote.setPlayer(this), n.textTracks = new r5(), n.textTracks[tt.crossOrigin] = this.$state.crossOrigin, n.textRenderers = new n5(n), n.ariaKeys = {}, L(this, yr, n), Ju(UM, n), this.orientation = new Jb(), new dw(), new v5(n);
    const o = new G5();
    L(this, zh, new K5(o, n)), L(this, gr, new B5(d(this, zh), o, n)), n.delegate = new H5(d(this, zh).handle.bind(d(this, zh)), n), n.notify = n.delegate.notify.bind(n.delegate), typeof navigator < "u" && "mediaSession" in navigator && new J5(), new GA("load", this.startLoading.bind(this)), new GA("posterLoad", this.startLoadingPoster.bind(this));
  }
  onSetup() {
    S(this, be, IU).call(this), J(S(this, be, HU).bind(this)), J(S(this, be, BU).bind(this)), J(S(this, be, jU).bind(this)), J(S(this, be, YU).bind(this)), J(S(this, be, QU).bind(this)), J(S(this, be, WU).bind(this)), J(S(this, be, GU).bind(this));
  }
  onAttach(n) {
    n.setAttribute("data-media-player", ""), Wi(n, "tabindex", "0"), Wi(n, "role", "region"), J(S(this, be, XU).bind(this)), J(S(this, be, FU).bind(this)), J(S(this, be, VU).bind(this)), En(n, "find-media-player", S(this, be, qU).bind(this));
  }
  onConnect(n) {
    jP && Rt(n, "data-iphone", "");
    const o = window.matchMedia("(pointer: coarse)");
    S(this, be, SD).call(this, o), o.onchange = S(this, be, SD).bind(this);
    const h = new ResizeObserver(Ey(S(this, be, nT).bind(this)));
    h.observe(n), J(S(this, be, nT).bind(this)), this.dispatch("media-player-connect", {
      detail: this,
      bubbles: !0,
      composed: !0
    }), Wt(() => {
      h.disconnect(), o.onchange = null;
    });
  }
  onDestroy() {
    d(this, yr).player = null, this.canPlayQueue.reset();
  }
  get provider() {
    return d(this, be, es);
  }
  get controls() {
    return d(this, gr).controls;
  }
  set controls(n) {
    d(this, be, $b).controls.set(n);
  }
  get title() {
    return ye(this.$state.title);
  }
  set title(n) {
    if (d(this, Hv)) {
      L(this, Hv, !1);
      return;
    }
    d(this, be, $b).title.set(n);
  }
  get qualities() {
    return d(this, yr).qualities;
  }
  get audioTracks() {
    return d(this, yr).audioTracks;
  }
  get textTracks() {
    return d(this, yr).textTracks;
  }
  get textRenderers() {
    return d(this, yr).textRenderers;
  }
  get duration() {
    return this.$state.duration();
  }
  set duration(n) {
    d(this, be, $b).duration.set(n);
  }
  get paused() {
    return ye(this.$state.paused);
  }
  set paused(n) {
    S(this, be, TD).call(this, n);
  }
  get muted() {
    return ye(this.$state.muted);
  }
  set muted(n) {
    S(this, be, wD).call(this, n);
  }
  get currentTime() {
    return ye(this.$state.currentTime);
  }
  set currentTime(n) {
    S(this, be, ED).call(this, n);
  }
  get volume() {
    return ye(this.$state.volume);
  }
  set volume(n) {
    S(this, be, CD).call(this, n);
  }
  get playbackRate() {
    return ye(this.$state.playbackRate);
  }
  set playbackRate(n) {
    S(this, be, bD).call(this, n);
  }
  async play(n) {
    return d(this, gr).play(n);
  }
  async pause(n) {
    return d(this, gr).pause(n);
  }
  async enterFullscreen(n, o) {
    return d(this, gr).enterFullscreen(n, o);
  }
  async exitFullscreen(n, o) {
    return d(this, gr).exitFullscreen(n, o);
  }
  enterPictureInPicture(n) {
    return d(this, gr).enterPictureInPicture(n);
  }
  exitPictureInPicture(n) {
    return d(this, gr).exitPictureInPicture(n);
  }
  seekToLiveEdge(n) {
    d(this, gr).seekToLiveEdge(n);
  }
  startLoading(n) {
    d(this, yr).notify("can-load", void 0, n);
  }
  startLoadingPoster(n) {
    d(this, yr).notify("can-load-poster", void 0, n);
  }
  requestAirPlay(n) {
    return d(this, gr).requestAirPlay(n);
  }
  requestGoogleCast(n) {
    return d(this, gr).requestGoogleCast(n);
  }
  setAudioGain(n, o) {
    return d(this, gr).setAudioGain(n, o);
  }
  destroy() {
    super.destroy(), d(this, yr).remote.setPlayer(null), this.dispatch("destroy");
  }
}, yr = new WeakMap(), zh = new WeakMap(), gr = new WeakMap(), be = new WeakSet(), es = function() {
  return d(this, yr).$provider();
}, $b = function() {
  return this.$props;
}, Hv = new WeakMap(), FU = function() {
  const n = this.$el, { title: o, live: h, viewType: v, providedTitle: y } = this.$state, k = h(), D = zP(v()), $ = D !== "Unknown" ? `${k ? "Live " : ""}${D}` : k ? "Live" : "Media", _ = o();
  Rt(
    this.el,
    "aria-label",
    `${$} Player` + (_ ? ` - ${_}` : "")
  ), n != null && n.hasAttribute("title") && (L(this, Hv, !0), n == null || n.removeAttribute("title"));
}, VU = function() {
  const n = this.orientation.landscape ? "landscape" : "portrait";
  this.$state.orientation.set(n), Rt(this.el, "data-orientation", n), S(this, be, nT).call(this);
}, HU = function() {
  this.$state.canPlay() && d(this, be, es) ? this.canPlayQueue.start() : this.canPlayQueue.stop();
}, IU = function() {
  if (To[SR]) {
    this.setAttributes(To[SR]);
    return;
  }
  const n = {
    "data-load": function() {
      return this.$props.load();
    },
    "data-captions": function() {
      const h = this.$state.textTrack();
      return !!h && _a(h);
    },
    "data-ios-controls": function() {
      return this.$state.iOSControls();
    },
    "data-controls": function() {
      return this.controls.showing;
    },
    "data-buffering": function() {
      const { canLoad: h, canPlay: v, waiting: y } = this.$state;
      return h() && (!v() || y());
    },
    "data-error": function() {
      const { error: h } = this.$state;
      return !!h();
    },
    "data-autoplay-error": function() {
      const { autoPlayError: h } = this.$state;
      return !!h();
    }
  }, o = {
    autoPlay: "autoplay",
    canAirPlay: "can-airplay",
    canPictureInPicture: "can-pip",
    pictureInPicture: "pip",
    playsInline: "playsinline",
    remotePlaybackState: "remote-state",
    remotePlaybackType: "remote-type",
    isAirPlayConnected: "airplay",
    isGoogleCastConnected: "google-cast"
  };
  for (const h of F5) {
    const v = "data-" + (o[h] ?? D0(h));
    n[v] = function() {
      return this.$state[h]();
    };
  }
  delete n.title, To[SR] = n, this.setAttributes(n);
}, qU = function(n) {
  n.detail(this);
}, nT = function() {
  if (!this.el) return;
  const n = this.el.clientWidth, o = this.el.clientHeight;
  this.$state.width.set(n), this.$state.height.set(o), Nd(this.el, "--player-width", n + "px"), Nd(this.el, "--player-height", o + "px");
}, SD = function(n) {
  const o = n.matches ? "coarse" : "fine";
  Rt(this.el, "data-pointer", o), this.$state.pointer.set(o), S(this, be, nT).call(this);
}, jU = function() {
  S(this, be, TD).call(this, this.$props.paused());
}, TD = function(n) {
  n ? this.canPlayQueue.enqueue("paused", () => d(this, gr).pause()) : this.canPlayQueue.enqueue("paused", () => d(this, gr).play());
}, BU = function() {
  S(this, be, wD).call(this, this.$props.muted());
}, wD = function(n) {
  this.canPlayQueue.enqueue("muted", () => {
    d(this, be, es) && d(this, be, es).setMuted(n);
  });
}, QU = function() {
  S(this, be, ED).call(this, this.$props.currentTime());
}, ED = function(n) {
  this.canPlayQueue.enqueue("currentTime", () => {
    const { currentTime: o } = this.$state;
    n !== ye(o) && ye(() => {
      if (!d(this, be, es)) return;
      const h = t_(n, this.$state);
      Number.isFinite(h) && d(this, be, es).setCurrentTime(h);
    });
  });
}, YU = function() {
  S(this, be, CD).call(this, this.$props.volume());
}, CD = function(n) {
  const o = zM(0, n, 1);
  this.canPlayQueue.enqueue("volume", () => {
    d(this, be, es) && d(this, be, es).setVolume(o);
  });
}, GU = function() {
  S(this, be, bD).call(this, this.$props.playbackRate());
}, bD = function(n) {
  this.canPlayQueue.enqueue("rate", () => {
    var o, h;
    d(this, be, es) && ((h = (o = d(this, be, es)).setPlaybackRate) == null || h.call(o, n));
  });
}, WU = function() {
  S(this, be, KU).call(this, this.$props.playsInline());
}, KU = function(n) {
  this.canPlayQueue.enqueue("playsinline", () => {
    var o, h;
    d(this, be, es) && ((h = (o = d(this, be, es)).setPlaysInline) == null || h.call(o, n));
  });
}, XU = function() {
  var h;
  let n = this.$props.storage(), o = Ze(n) ? new VB() : n;
  if (o != null && o.onChange) {
    const { source: v } = this.$state, y = Ze(n) ? n : (h = this.el) == null ? void 0 : h.id, k = ow(S(this, be, ZU).bind(this));
    J(() => o.onChange(v(), k(), y || void 0));
  }
  d(this, yr).storage = o, d(this, yr).textTracks.setStorage(o), Wt(() => {
    var v;
    (v = o == null ? void 0 : o.onDestroy) == null || v.call(o), d(this, yr).storage = null, d(this, yr).textTracks.setStorage(null);
  });
}, ZU = function() {
  const { clipStartTime: n, clipEndTime: o } = this.$props, { source: h } = this.$state, v = h();
  return v.src ? `${v.src}:${n()}:${o()}` : null;
}, Z(To, "props", V5), Z(To, "state", xy), To);
hn([
  rn
], on.prototype, "canPlayQueue", 2);
hn([
  rn
], on.prototype, "remoteControl", 2);
hn([
  rn
], on.prototype, "provider", 1);
hn([
  rn
], on.prototype, "controls", 1);
hn([
  rn
], on.prototype, "orientation", 2);
hn([
  rn
], on.prototype, "title", 1);
hn([
  rn
], on.prototype, "qualities", 1);
hn([
  rn
], on.prototype, "audioTracks", 1);
hn([
  rn
], on.prototype, "textTracks", 1);
hn([
  rn
], on.prototype, "textRenderers", 1);
hn([
  rn
], on.prototype, "duration", 1);
hn([
  rn
], on.prototype, "paused", 1);
hn([
  rn
], on.prototype, "muted", 1);
hn([
  rn
], on.prototype, "currentTime", 1);
hn([
  rn
], on.prototype, "volume", 1);
hn([
  rn
], on.prototype, "playbackRate", 1);
hn([
  Zi
], on.prototype, "play", 1);
hn([
  Zi
], on.prototype, "pause", 1);
hn([
  Zi
], on.prototype, "enterFullscreen", 1);
hn([
  Zi
], on.prototype, "exitFullscreen", 1);
hn([
  Zi
], on.prototype, "enterPictureInPicture", 1);
hn([
  Zi
], on.prototype, "exitPictureInPicture", 1);
hn([
  Zi
], on.prototype, "seekToLiveEdge", 1);
hn([
  Zi
], on.prototype, "startLoading", 1);
hn([
  Zi
], on.prototype, "startLoadingPoster", 1);
hn([
  Zi
], on.prototype, "requestAirPlay", 1);
hn([
  Zi
], on.prototype, "requestGoogleCast", 1);
hn([
  Zi
], on.prototype, "setAudioGain", 1);
let n8 = on;
function i8(f, s) {
  return fetch(f, s).then((n) => n.text()).then((n) => /type="static"/.test(n) ? "on-demand" : "live");
}
function JU(f, s) {
  return fetch(f, s).then((n) => n.text()).then((n) => {
    const o = r8(n);
    if (o)
      return JU(
        /^https?:/.test(o) ? o : new URL(o, f).href,
        s
      );
    const h = /EXT-X-PLAYLIST-TYPE:\s*VOD/.test(n) ? "on-demand" : "live";
    return h === "live" && a8(n) >= 10 && (/#EXT-X-DVR-ENABLED:\s*true/.test(n) || n.includes("#EXT-X-DISCONTINUITY")) ? "live:dvr" : h;
  });
}
function r8(f) {
  const s = f.match(/#EXT-X-STREAM-INF:[^\n]+(\n[^\n]+)*/g);
  return s ? s[0].split(`
`)[1].trim() : null;
}
function a8(f) {
  const s = f.split(`
`);
  for (const n of s)
    if (n.startsWith("#EXT-X-TARGETDURATION")) {
      const o = parseFloat(n.split(":")[1]);
      if (!isNaN(o))
        return o;
    }
  return -1;
}
const kD = /* @__PURE__ */ new Map();
var Iv, qv, AT, qt, Vu, vi, ez, tz, xD, RD, DD, nz, iz, rz;
class s8 {
  constructor(s, n, o, h = []) {
    R(this, vi);
    R(this, Iv, !1);
    R(this, qv);
    R(this, AT);
    R(this, qt);
    R(this, Vu);
    L(this, AT, s), L(this, qt, n), L(this, Vu, o);
    const v = new tD(), y = new YR(), k = new VM(), D = new C5(), $ = new z5(), _ = new U5(), A = [$, _];
    L(this, qv, ow(() => {
      const W = n.$state.remotePlaybackLoader(), ne = n.$props.preferNativeHLS() ? [k, D, v, y, ...A, ...h] : [y, k, D, v, ...A, ...h];
      return W ? [W, ...ne] : ne;
    }));
    const { $state: B } = n;
    B.sources.set(ZA(n.$props.src()));
    for (const W of B.sources()) {
      const ne = d(this, qv).call(this).find((Re) => Re.canPlay(W));
      if (!ne) continue;
      const ce = ne.mediaType(W);
      n.$state.source.set(W), n.$state.mediaType.set(ce), n.$state.inferredViewType.set(ce), d(this, Vu).set(ne), L(this, Iv, !0);
      break;
    }
  }
  connect() {
    const s = d(this, Vu).call(this);
    d(this, Iv) && (S(this, vi, RD).call(this, d(this, qt).$state.source(), s), S(this, vi, DD).call(this, s), L(this, Iv, !1)), J(S(this, vi, ez).bind(this)), J(S(this, vi, tz).bind(this)), J(S(this, vi, nz).bind(this)), J(S(this, vi, iz).bind(this)), J(S(this, vi, rz).bind(this));
  }
}
Iv = new WeakMap(), qv = new WeakMap(), AT = new WeakMap(), qt = new WeakMap(), Vu = new WeakMap(), vi = new WeakSet(), ez = function() {
  d(this, qt).notify("sources-change", [
    ...ZA(d(this, qt).$props.src()),
    ...d(this, AT).call(this)
  ]);
}, tz = function() {
  var y;
  const { $state: s } = d(this, qt), n = s.sources(), o = ye(s.source), h = S(this, vi, xD).call(this, o, n);
  if (((y = n[0]) == null ? void 0 : y.src) && !h.src && !h.type) {
    const { crossOrigin: k } = s, D = sT(k()), $ = new AbortController();
    return Promise.all(
      n.map(
        (_) => Ze(_.src) && _.type === "?" ? fetch(_.src, {
          method: "HEAD",
          credentials: D,
          signal: $.signal
        }).then((A) => (_.type = A.headers.get("content-type") || "??", kD.set(_.src, _.type), _)).catch(() => _) : _
      )
    ).then((_) => {
      if ($.signal.aborted) return;
      const A = S(this, vi, xD).call(this, ye(s.source), _);
      Xu(), A.src || d(this, qt).notify("error", {
        message: "Failed to load resource.",
        code: 4
      });
    }), () => $.abort();
  }
  Xu();
}, xD = function(s, n) {
  let o = { src: "", type: "" }, h = null, v = new vt("sources-change", { detail: { sources: n } }), y = d(this, qv).call(this), { started: k, paused: D, currentTime: $, quality: _, savedState: A } = d(this, qt).$state;
  for (const B of n) {
    const W = y.find((ne) => ne.canPlay(B));
    if (W) {
      o = B, h = W;
      break;
    }
  }
  if (MR(o)) {
    const B = _(), W = n.find((ne) => ne.src === (B == null ? void 0 : B.src));
    ye(k) ? A.set({
      paused: ye(D),
      currentTime: ye($)
    }) : A.set(null), W && (o = W, v = new vt("quality-change", {
      detail: { quality: B }
    }));
  }
  return eP(s, o) || S(this, vi, RD).call(this, o, h, v), h !== ye(d(this, Vu)) && S(this, vi, DD).call(this, h, v), o;
}, RD = function(s, n, o) {
  d(this, qt).notify("source-change", s, o), d(this, qt).notify("media-type-change", (n == null ? void 0 : n.mediaType(s)) || "unknown", o);
}, DD = function(s, n) {
  d(this, qt).$providerSetup.set(!1), d(this, qt).notify("provider-change", null, n), s && ye(() => {
    var o;
    return (o = s.preconnect) == null ? void 0 : o.call(s, d(this, qt));
  }), d(this, Vu).set(s), d(this, qt).notify("provider-loader-change", s, n);
}, nz = function() {
  const s = d(this, qt).$provider();
  if (!(!s || ye(d(this, qt).$providerSetup))) {
    if (d(this, qt).$state.canLoad()) {
      Cl(() => s.setup(), s.scope), d(this, qt).$providerSetup.set(!0);
      return;
    }
    ye(() => {
      var n;
      return (n = s.preconnect) == null ? void 0 : n.call(s);
    });
  }
}, iz = function() {
  if (!d(this, qt).$providerSetup()) return;
  const s = d(this, qt).$provider(), n = d(this, qt).$state.source(), o = ye(d(this, qt).$state.crossOrigin), h = ye(d(this, qt).$props.preferNativeHLS);
  if (!eP(s == null ? void 0 : s.currentSrc, n)) {
    if (d(this, qt).$state.canLoad()) {
      const v = new AbortController();
      return ky(n) ? (h || !PM()) && JU(n.src, {
        credentials: sT(o),
        signal: v.signal
      }).then((y) => {
        d(this, qt).notify("stream-type-change", y);
      }).catch(Wb) : _M(n) ? i8(n.src, {
        credentials: sT(o),
        signal: v.signal
      }).then((y) => {
        d(this, qt).notify("stream-type-change", y);
      }).catch(Wb) : d(this, qt).notify("stream-type-change", "on-demand"), ye(() => {
        const y = ye(d(this, qt).$state.preload);
        return s == null ? void 0 : s.loadSource(n, y).catch((k) => {
        });
      }), () => v.abort();
    }
    try {
      Ze(n.src) && O0(new URL(n.src).origin);
    } catch {
    }
  }
}, rz = function() {
  const s = d(this, Vu).call(this), { providedPoster: n, source: o, canLoadPoster: h } = d(this, qt).$state;
  if (!s || !s.loadPoster || !o() || !h() || n()) return;
  const v = new AbortController(), y = new vt("source-change", { detail: o });
  return s.loadPoster(o(), d(this, qt), v).then((k) => {
    d(this, qt).notify("poster-change", k || "", y);
  }).catch(() => {
    d(this, qt).notify("poster-change", "", y);
  }), () => {
    v.abort();
  };
};
function ZA(f) {
  return (Vr(f) ? f : [f]).map((s) => Ze(s) ? { src: s, type: JA(s) } : { ...s, type: JA(s.src, s.type) });
}
function JA(f, s) {
  return Ze(s) && s.length ? s : Ze(f) && kD.has(f) ? kD.get(f) : !s && ky({ src: f, type: "" }) ? "application/x-mpegurl" : !s && _M({ src: f, type: "" }) ? "application/dash+xml" : !Ze(f) || f.startsWith("blob:") ? "video/object" : f.includes("youtube") || f.includes("youtu.be") ? "video/youtube" : f.includes("vimeo") && !f.includes("progressive_redirect") && !f.includes(".m3u8") ? "video/vimeo" : "?";
}
function eP(f, s) {
  return (f == null ? void 0 : f.src) === (s == null ? void 0 : s.src) && (f == null ? void 0 : f.type) === (s == null ? void 0 : s.type);
}
var PT, yd, _T, h0, az;
class l8 {
  constructor(s, n) {
    R(this, h0);
    R(this, PT);
    R(this, yd);
    R(this, _T, []);
    L(this, PT, s), L(this, yd, n), J(S(this, h0, az).bind(this));
  }
}
PT = new WeakMap(), yd = new WeakMap(), _T = new WeakMap(), h0 = new WeakSet(), az = function() {
  const s = d(this, PT).call(this);
  for (const n of d(this, _T))
    if (!s.some((o) => o.id === n.id)) {
      const o = n.id && d(this, yd).textTracks.getById(n.id);
      o && d(this, yd).textTracks.remove(o);
    }
  for (const n of s) {
    const o = n.id || Ud.createId(n);
    d(this, yd).textTracks.getById(o) || (n.id = o, d(this, yd).textTracks.add(n));
  }
  L(this, _T, s);
};
var o8 = Object.defineProperty, u8 = Object.getOwnPropertyDescriptor, c8 = (f, s, n, o) => {
  for (var h = u8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && o8(s, n, h), h;
}, wb, yl, NT, UT, zT, jv, Bv, us, lz, MD, LD, $D;
let sz = (wb = class extends Ci {
  constructor() {
    super(...arguments);
    R(this, us);
    R(this, yl);
    R(this, NT);
    R(this, UT, st([]));
    R(this, zT, st([]));
    R(this, jv, null);
    R(this, Bv, -1);
  }
  onSetup() {
    L(this, yl, Ua()), L(this, NT, new s8(
      d(this, UT),
      d(this, yl),
      this.$state.loader,
      this.$props.loaders()
    ));
  }
  onAttach(n) {
    n.setAttribute("data-media-provider", "");
  }
  onConnect(n) {
    d(this, NT).connect(), new l8(d(this, zT), d(this, yl));
    const o = new ResizeObserver(Ey(S(this, us, LD).bind(this)));
    o.observe(n);
    const h = new MutationObserver(S(this, us, $D).bind(this));
    h.observe(n, { attributes: !0, childList: !0 }), S(this, us, LD).call(this), S(this, us, $D).call(this), Wt(() => {
      o.disconnect(), h.disconnect();
    });
  }
  load(n) {
    n == null || n.setAttribute("aria-hidden", "true"), window.cancelAnimationFrame(d(this, Bv)), L(this, Bv, requestAnimationFrame(() => S(this, us, lz).call(this, n))), Wt(() => {
      window.cancelAnimationFrame(d(this, Bv));
    });
  }
  onDestroy() {
    L(this, jv, null), S(this, us, MD).call(this);
  }
}, yl = new WeakMap(), NT = new WeakMap(), UT = new WeakMap(), zT = new WeakMap(), jv = new WeakMap(), Bv = new WeakMap(), us = new WeakSet(), lz = function(n) {
  if (!this.scope) return;
  const o = this.$state.loader(), { $provider: h } = d(this, yl);
  d(this, jv) === o && (o == null ? void 0 : o.target) === n && ye(h) || (S(this, us, MD).call(this), L(this, jv, o), o && (o.target = n || null), !(!o || !n) && o.load(d(this, yl)).then((v) => {
    this.scope && ye(this.$state.loader) === o && d(this, yl).notify("provider-change", v);
  }));
}, MD = function() {
  var n;
  (n = d(this, yl)) == null || n.notify("provider-change", null);
}, LD = function() {
  if (!this.el) return;
  const { player: n, $state: o } = d(this, yl), h = this.el.offsetWidth, v = this.el.offsetHeight;
  n && (o.mediaWidth.set(h), o.mediaHeight.set(v), n.el && (Nd(n.el, "--media-width", h + "px"), Nd(n.el, "--media-height", v + "px")));
}, $D = function() {
  const n = [], o = [], h = this.el.children;
  for (const v of h)
    if (!v.hasAttribute("data-vds")) {
      if (v instanceof HTMLSourceElement) {
        const y = {
          id: v.id,
          src: v.src,
          type: v.type
        };
        for (const k of ["id", "src", "width", "height", "bitrate", "codec"]) {
          const D = v.getAttribute(`data-${k}`);
          Ze(D) && (y[k] = /id|src|codec/.test(k) ? D : Number(D));
        }
        n.push(y);
      } else if (v instanceof HTMLTrackElement) {
        const y = {
          src: v.src,
          kind: v.track.kind,
          language: v.srclang,
          label: v.label,
          default: v.default,
          type: v.getAttribute("data-type")
        };
        o.push({
          id: v.id || Ud.createId(y),
          ...y
        });
      }
    }
  d(this, UT).set(n), d(this, zT).set(o), Xu();
}, Z(wb, "props", {
  loaders: []
}), Z(wb, "state", new by({
  loader: null
})), wb);
c8([
  Zi
], sz.prototype, "load");
var gl, _d, oz, Fh, Vh, ho, Ob;
class d8 extends Hs {
  constructor(n) {
    super();
    R(this, _d);
    R(this, gl);
    R(this, Fh, -1);
    R(this, Vh, -1);
    R(this, ho, null);
    L(this, gl, n), J(S(this, _d, oz).bind(this));
  }
  onDestroy() {
    var n;
    (n = d(this, ho)) == null || n.call(this), L(this, ho, null);
  }
  show(n) {
    var o, h, v;
    S(this, _d, Ob).call(this), window.cancelAnimationFrame(d(this, Vh)), L(this, Vh, -1), (o = d(this, ho)) == null || o.call(this), L(this, ho, null), L(this, Fh, window.setTimeout(() => {
      L(this, Fh, -1);
      const y = d(this, gl).content();
      y && y.style.removeProperty("display"), ye(() => d(this, gl).onChange(!0, n));
    }, ((v = (h = d(this, gl)).showDelay) == null ? void 0 : v.call(h)) ?? 0));
  }
  hide(n) {
    S(this, _d, Ob).call(this), ye(() => d(this, gl).onChange(!1, n)), L(this, Vh, requestAnimationFrame(() => {
      var h;
      S(this, _d, Ob).call(this), L(this, Vh, -1);
      const o = d(this, gl).content();
      if (o) {
        const v = () => {
          o.style.display = "none", L(this, ho, null);
        };
        if (e5(o)) {
          (h = d(this, ho)) == null || h.call(this);
          const k = En(o, "animationend", v, { once: !0 });
          L(this, ho, k);
        } else
          v();
      }
    }));
  }
}
gl = new WeakMap(), _d = new WeakSet(), oz = function() {
  const n = d(this, gl).trigger();
  if (!n) {
    this.hide();
    return;
  }
  const o = this.show.bind(this), h = this.hide.bind(this);
  d(this, gl).listen(n, o, h);
}, Fh = new WeakMap(), Vh = new WeakMap(), ho = new WeakMap(), Ob = function() {
  window.clearTimeout(d(this, Fh)), L(this, Fh, -1);
};
var Hu, Ro, uz, cz, dz, fz;
class n0 extends Hs {
  constructor(n) {
    super();
    R(this, Ro);
    R(this, Hu);
    L(this, Hu, n), new dw(), n.keyShortcut && new T5(n.keyShortcut);
  }
  onSetup() {
    const { disabled: n } = this.$props;
    this.setAttributes({
      "data-pressed": d(this, Hu).isPresssed,
      "aria-pressed": S(this, Ro, uz).bind(this),
      "aria-disabled": () => n() ? "true" : null
    });
  }
  onAttach(n) {
    Wi(n, "tabindex", "0"), Wi(n, "role", "button"), Wi(n, "type", "button");
  }
  onConnect(n) {
    const o = vy(n, S(this, Ro, dz).bind(this));
    for (const h of ["click", "touchstart"])
      o.add(h, S(this, Ro, fz).bind(this), {
        passive: !0
      });
  }
}
Hu = new WeakMap(), Ro = new WeakSet(), uz = function() {
  return Kb(d(this, Hu).isPresssed());
}, cz = function(n) {
  rB(d(this, Hu).isPresssed) && d(this, Hu).isPresssed.set((o) => !o);
}, dz = function(n) {
  if (this.$props.disabled() || this.el.hasAttribute("data-disabled")) {
    n.preventDefault(), n.stopImmediatePropagation();
    return;
  }
  n.preventDefault(), (d(this, Hu).onPress ?? S(this, Ro, cz)).call(this, n);
}, fz = function(n) {
  this.$props.disabled() && (n.preventDefault(), n.stopImmediatePropagation());
}, Z(n0, "props", {
  disabled: !1
});
var f8 = Object.defineProperty, h8 = Object.getOwnPropertyDescriptor, p8 = (f, s, n, o) => {
  for (var h = h8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && f8(s, n, h), h;
}, FT;
class hz extends Ci {
  constructor() {
    super();
    R(this, FT, st(!1));
    new n0({
      isPresssed: d(this, FT)
    });
  }
  get pressed() {
    return d(this, FT).call(this);
  }
}
FT = new WeakMap(), Z(hz, "props", {
  disabled: !1,
  defaultPressed: !1
});
p8([
  rn
], hz.prototype, "pressed");
var kR, gd, ec, pz, OD, mz;
let m8 = (kR = class extends Ci {
  constructor() {
    super();
    R(this, ec);
    R(this, gd);
    new n0({
      isPresssed: S(this, ec, OD).bind(this),
      keyShortcut: "toggleFullscreen",
      onPress: S(this, ec, pz).bind(this)
    });
  }
  onSetup() {
    L(this, gd, Ua());
    const { fullscreen: n } = d(this, gd).$state, o = S(this, ec, mz).bind(this);
    this.setAttributes({
      "data-active": n,
      "data-supported": o,
      "aria-hidden": ap(() => !o())
    });
  }
  onAttach(n) {
    n.setAttribute("data-media-tooltip", "fullscreen"), ZB(n, "Fullscreen");
  }
}, gd = new WeakMap(), ec = new WeakSet(), pz = function(n) {
  const o = d(this, gd).remote, h = this.$props.target();
  S(this, ec, OD).call(this) ? o.exitFullscreen(h, n) : o.enterFullscreen(h, n);
}, OD = function() {
  const { fullscreen: n } = d(this, gd).$state;
  return n();
}, mz = function() {
  const { canFullscreen: n } = d(this, gd).$state;
  return n();
}, Z(kR, "props", {
  ...n0.props,
  target: "prefer-media"
}), kR);
const A0 = new by({
  min: 0,
  max: 100,
  value: 0,
  step: 1,
  pointerValue: 0,
  focused: !1,
  dragging: !1,
  pointing: !1,
  hidden: !1,
  get active() {
    return this.dragging || this.focused || this.pointing;
  },
  get fillRate() {
    return tP(this.min, this.max, this.value);
  },
  get fillPercent() {
    return this.fillRate * 100;
  },
  get pointerRate() {
    return tP(this.min, this.max, this.pointerValue);
  },
  get pointerPercent() {
    return this.pointerRate * 100;
  }
});
function tP(f, s, n) {
  const o = s - f, h = n - f;
  return o > 0 ? h / o : 0;
}
var Qv, Sd, p0, yz;
class vz extends Hs {
  constructor(n) {
    super();
    R(this, p0);
    R(this, Qv);
    R(this, Sd);
    L(this, Qv, n);
  }
  onConnect(n) {
    L(this, Sd, new IntersectionObserver((o) => {
      var h, v;
      (v = (h = d(this, Qv)).callback) == null || v.call(h, o, d(this, Sd));
    }, d(this, Qv))), d(this, Sd).observe(n), Wt(S(this, p0, yz).bind(this));
  }
}
Qv = new WeakMap(), Sd = new WeakMap(), p0 = new WeakSet(), /**
 * Disconnect any active intersection observers.
 */
yz = function() {
  var n;
  (n = d(this, Sd)) == null || n.disconnect(), L(this, Sd, void 0);
};
const jM = Cy(), oT = Cy();
function v8(f, s, n, o) {
  return zM(f, Na(n, AR(o)), s);
}
function y8(f, s, n, o) {
  const h = zM(0, n, 1), v = s - f, y = v * h, k = y / o, D = o * Math.round(k);
  return f + D;
}
const wR = {
  Left: -1,
  ArrowLeft: -1,
  Up: 1,
  ArrowUp: 1,
  Right: 1,
  ArrowRight: 1,
  Down: -1,
  ArrowDown: -1
};
var Sr, Td, Yv, $e, gz, wd, Sl, Iu, Sz, Tz, wz, Ez, Cz, Ab, ed, iT, bz, kz, xz, Rz, Pb, AD, Gv, qu, Dz, Mz, PD, _D, Lz, $z, m0;
class g8 extends Hs {
  constructor(n, o) {
    super();
    R(this, $e);
    R(this, Sr);
    R(this, Td);
    R(this, Yv);
    R(this, wd, null);
    R(this, Sl, null);
    R(this, Iu, null);
    // -------------------------------------------------------------------------------------------
    // Keyboard Events
    // -------------------------------------------------------------------------------------------
    R(this, Gv);
    R(this, qu, !1);
    R(this, m0, cw(
      (n) => {
        S(this, $e, ed).call(this, S(this, $e, iT).call(this, n), n);
      },
      20,
      { leading: !0 }
    ));
    L(this, Sr, n), L(this, Td, o);
  }
  onSetup() {
    Jh(oT) && L(this, Yv, Us(oT));
  }
  onConnect(n) {
    J(S(this, $e, wz).bind(this, n)), J(S(this, $e, Ez).bind(this, n)), d(this, Sr).swipeGesture && J(S(this, $e, gz).bind(this));
  }
}
Sr = new WeakMap(), Td = new WeakMap(), Yv = new WeakMap(), $e = new WeakSet(), gz = function() {
  var o;
  const { pointer: n } = d(this, Td).$state;
  if (n() !== "coarse" || !d(this, Sr).swipeGesture()) {
    L(this, wd, null);
    return;
  }
  L(this, wd, (o = d(this, Td).player.el) == null ? void 0 : o.querySelector(
    "media-provider,[data-media-provider]"
  )), d(this, wd) && new gn(d(this, wd)).add("touchstart", S(this, $e, Sz).bind(this), {
    passive: !0
  }).add("touchmove", S(this, $e, Tz).bind(this), { passive: !1 });
}, wd = new WeakMap(), Sl = new WeakMap(), Iu = new WeakMap(), Sz = function(n) {
  L(this, Sl, n.touches[0]);
}, Tz = function(n) {
  if (Zu(d(this, Sl)) || o_(n)) return;
  const o = n.touches[0], h = o.clientX - d(this, Sl).clientX, v = o.clientY - d(this, Sl).clientY, y = this.$state.dragging();
  !y && Math.abs(v) > 5 || y || (n.preventDefault(), Math.abs(h) > 20 && (L(this, Sl, o), L(this, Iu, this.$state.value()), S(this, $e, Pb).call(this, d(this, Iu), n)));
}, wz = function(n) {
  const { hidden: o } = this.$props;
  En(n, "focus", S(this, $e, Cz).bind(this)), !(o() || d(this, Sr).isDisabled()) && new gn(n).add("keyup", S(this, $e, Mz).bind(this)).add("keydown", S(this, $e, Dz).bind(this)).add("pointerenter", S(this, $e, bz).bind(this)).add("pointermove", S(this, $e, kz).bind(this)).add("pointerleave", S(this, $e, xz).bind(this)).add("pointerdown", S(this, $e, Rz).bind(this));
}, Ez = function(n) {
  d(this, Sr).isDisabled() || !this.$state.dragging() || new gn(document).add("pointerup", S(this, $e, Lz).bind(this), { capture: !0 }).add("pointermove", d(this, m0).bind(this)).add("touchmove", S(this, $e, $z).bind(this), {
    passive: !1
  });
}, Cz = function() {
  S(this, $e, ed).call(this, this.$state.value());
}, Ab = function(n, o) {
  var _, A, B, W;
  const { value: h, min: v, max: y, dragging: k } = this.$state, D = Math.max(v(), Math.min(n, y()));
  h.set(D);
  const $ = this.createEvent("value-change", { detail: D, trigger: o });
  if (this.dispatch($), (A = (_ = d(this, Sr)).onValueChange) == null || A.call(_, $), k()) {
    const ne = this.createEvent("drag-value-change", { detail: D, trigger: o });
    this.dispatch(ne), (W = (B = d(this, Sr)).onDragValueChange) == null || W.call(B, ne);
  }
}, ed = function(n, o) {
  const { pointerValue: h, dragging: v } = this.$state;
  h.set(n), this.dispatch("pointer-value-change", { detail: n, trigger: o }), v() && S(this, $e, Ab).call(this, n, o);
}, iT = function(n) {
  let o, h = this.el.getBoundingClientRect(), { min: v, max: y } = this.$state;
  if (this.$props.orientation() === "vertical") {
    const { bottom: k, height: D } = h;
    o = (k - n.clientY) / D;
  } else if (d(this, Sl) && ss(d(this, Iu))) {
    const { width: k } = d(this, wd).getBoundingClientRect(), D = (n.clientX - d(this, Sl).clientX) / k, $ = y() - v(), _ = $ * Math.abs(D);
    o = (D < 0 ? d(this, Iu) - _ : d(this, Iu) + _) / $;
  } else {
    const { left: k, width: D } = h;
    o = (n.clientX - k) / D;
  }
  return Math.max(
    v(),
    Math.min(
      y(),
      d(this, Sr).roundValue(
        y8(v(), y(), o, d(this, Sr).getStep())
      )
    )
  );
}, bz = function(n) {
  this.$state.pointing.set(!0);
}, kz = function(n) {
  const { dragging: o } = this.$state;
  o() || S(this, $e, ed).call(this, S(this, $e, iT).call(this, n), n);
}, xz = function(n) {
  this.$state.pointing.set(!1);
}, Rz = function(n) {
  if (n.button !== 0) return;
  const o = S(this, $e, iT).call(this, n);
  S(this, $e, Pb).call(this, o, n), S(this, $e, ed).call(this, o, n);
}, Pb = function(n, o) {
  var y, k, D, $;
  const { dragging: h } = this.$state;
  if (h()) return;
  h.set(!0), d(this, Td).remote.pauseControls(o);
  const v = this.createEvent("drag-start", { detail: n, trigger: o });
  this.dispatch(v), (k = (y = d(this, Sr)).onDragStart) == null || k.call(y, v), ($ = (D = d(this, Yv)) == null ? void 0 : D.onDragStart) == null || $.call(D);
}, AD = function(n, o) {
  var y, k, D, $;
  const { dragging: h } = this.$state;
  if (!h()) return;
  h.set(!1), d(this, Td).remote.resumeControls(o);
  const v = this.createEvent("drag-end", { detail: n, trigger: o });
  this.dispatch(v), (k = (y = d(this, Sr)).onDragEnd) == null || k.call(y, v), L(this, Sl, null), L(this, Iu, null), ($ = (D = d(this, Yv)) == null ? void 0 : D.onDragEnd) == null || $.call(D);
}, Gv = new WeakMap(), qu = new WeakMap(), Dz = function(n) {
  if (!Object.keys(wR).includes(n.key)) return;
  const { key: h } = n, v = S(this, $e, PD).call(this, n);
  if (!Zu(v)) {
    S(this, $e, ed).call(this, v, n), S(this, $e, Ab).call(this, v, n);
    return;
  }
  const y = S(this, $e, _D).call(this, n);
  d(this, qu) || (L(this, qu, h === d(this, Gv)), !this.$state.dragging() && d(this, qu) && S(this, $e, Pb).call(this, y, n)), S(this, $e, ed).call(this, y, n), L(this, Gv, h);
}, Mz = function(n) {
  if (!Object.keys(wR).includes(n.key) || !Zu(S(this, $e, PD).call(this, n))) return;
  const h = d(this, qu) ? this.$state.pointerValue() : S(this, $e, _D).call(this, n);
  S(this, $e, Ab).call(this, h, n), S(this, $e, AD).call(this, h, n), L(this, Gv, ""), L(this, qu, !1);
}, PD = function(n) {
  let o = n.key, { min: h, max: v } = this.$state;
  return o === "Home" || o === "PageUp" ? h() : o === "End" || o === "PageDown" ? v() : !n.metaKey && /^[0-9]$/.test(o) ? (v() - h()) / 10 * Number(o) : null;
}, _D = function(n) {
  var Lt, $t;
  const { key: o, shiftKey: h } = n;
  n.preventDefault(), n.stopPropagation();
  const { shiftKeyMultiplier: v } = this.$props, { min: y, max: k, value: D, pointerValue: $ } = this.$state, _ = d(this, Sr).getStep(), A = d(this, Sr).getKeyStep(), B = h ? A * v() : A, W = Number(wR[o]), ne = B * W, ce = d(this, qu) ? $() : (($t = (Lt = d(this, Sr)).getValue) == null ? void 0 : $t.call(Lt)) ?? D(), Re = (ce + ne) / _;
  return Math.max(y(), Math.min(k(), Number((_ * Re).toFixed(3))));
}, // -------------------------------------------------------------------------------------------
// Document (Pointer Events)
// -------------------------------------------------------------------------------------------
Lz = function(n) {
  if (n.button !== 0) return;
  n.preventDefault(), n.stopImmediatePropagation();
  const o = S(this, $e, iT).call(this, n);
  S(this, $e, ed).call(this, o, n), S(this, $e, AD).call(this, o, n);
}, $z = function(n) {
  n.preventDefault();
}, m0 = new WeakMap();
const uT = Cy(() => ({}));
var VT, La, HT, IT, Ki, Oz, Az, Pz, _z, Nz, Uz, zz, Fz, v0;
class ep extends Hs {
  constructor(n) {
    super();
    R(this, Ki);
    R(this, VT);
    R(this, La);
    R(this, HT, st(!0));
    R(this, IT, st(!0));
    R(this, v0, Ey((n, o) => {
      var h, v;
      (h = this.el) == null || h.style.setProperty("--slider-fill", n + "%"), (v = this.el) == null || v.style.setProperty("--slider-pointer", o + "%");
    }));
    L(this, La, n);
  }
  onSetup() {
    L(this, VT, Ua());
    const n = new dw();
    n.attach(this), this.$state.focused = n.focused.bind(n), Jh(uT) || Ju(uT, {
      default: "value"
    }), Ju(jM, {
      orientation: this.$props.orientation,
      disabled: d(this, La).isDisabled,
      preview: st(null)
    }), J(S(this, Ki, Pz).bind(this)), J(S(this, Ki, _z).bind(this)), J(S(this, Ki, Nz).bind(this)), S(this, Ki, zz).call(this), new g8(d(this, La), d(this, VT)).attach(this), new vz({
      callback: S(this, Ki, Oz).bind(this)
    }).attach(this);
  }
  onAttach(n) {
    Wi(n, "role", "slider"), Wi(n, "tabindex", "0"), Wi(n, "autocomplete", "off"), J(S(this, Ki, Fz).bind(this));
  }
  onConnect(n) {
    Wt(s_(n, d(this, HT).set)), J(S(this, Ki, Az).bind(this));
  }
}
VT = new WeakMap(), La = new WeakMap(), HT = new WeakMap(), IT = new WeakMap(), Ki = new WeakSet(), Oz = function(n) {
  d(this, IT).set(n[0].isIntersecting);
}, // -------------------------------------------------------------------------------------------
// Watch
// -------------------------------------------------------------------------------------------
Az = function() {
  const { hidden: n } = this.$props;
  this.$state.hidden.set(n() || !d(this, HT).call(this) || !d(this, IT).bind(this));
}, Pz = function() {
  const { dragging: n, value: o, min: h, max: v } = this.$state;
  ye(n) || o.set(v8(h(), v(), o(), d(this, La).getStep()));
}, _z = function() {
  this.$state.step.set(d(this, La).getStep());
}, Nz = function() {
  if (!d(this, La).isDisabled()) return;
  const { dragging: n, pointing: o } = this.$state;
  n.set(!1), o.set(!1);
}, // -------------------------------------------------------------------------------------------
// ARIA
// -------------------------------------------------------------------------------------------
Uz = function() {
  return Kb(d(this, La).isDisabled());
}, // -------------------------------------------------------------------------------------------
// Attributes
// -------------------------------------------------------------------------------------------
zz = function() {
  const { orientation: n } = this.$props, { dragging: o, active: h, pointing: v } = this.$state;
  this.setAttributes({
    "data-dragging": o,
    "data-pointing": v,
    "data-active": h,
    "aria-disabled": S(this, Ki, Uz).bind(this),
    "aria-valuemin": d(this, La).aria.valueMin ?? this.$state.min,
    "aria-valuemax": d(this, La).aria.valueMax ?? this.$state.max,
    "aria-valuenow": d(this, La).aria.valueNow,
    "aria-valuetext": d(this, La).aria.valueText,
    "aria-orientation": n
  });
}, Fz = function() {
  const { fillPercent: n, pointerPercent: o } = this.$state;
  d(this, v0).call(this, Na(n(), 3), Na(o(), 3));
}, v0 = new WeakMap(), Z(ep, "props", {
  hidden: !1,
  disabled: !1,
  step: 1,
  keyStep: 1,
  orientation: "horizontal",
  shiftKeyMultiplier: 5
});
var Do, Vz, Hz, Iz, qz;
class tp extends Ci {
  constructor() {
    super();
    R(this, Do);
    new ep({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: Math.round,
      isDisabled: this.$props.disabled,
      aria: {
        valueNow: S(this, Do, Vz).bind(this),
        valueText: S(this, Do, Hz).bind(this)
      }
    });
  }
  onSetup() {
    J(S(this, Do, Iz).bind(this)), J(S(this, Do, qz).bind(this));
  }
}
Do = new WeakSet(), // -------------------------------------------------------------------------------------------
// Props
// -------------------------------------------------------------------------------------------
Vz = function() {
  const { value: n } = this.$state;
  return Math.round(n());
}, Hz = function() {
  const { value: n, max: o } = this.$state;
  return Na(n() / o() * 100, 2) + "%";
}, // -------------------------------------------------------------------------------------------
// Watch
// -------------------------------------------------------------------------------------------
Iz = function() {
  const { value: n } = this.$props;
  this.$state.value.set(n());
}, qz = function() {
  const { min: n, max: o } = this.$props;
  this.$state.min.set(n()), this.$state.max.set(o());
}, Z(tp, "props", {
  ...ep.props,
  min: 0,
  max: 100,
  value: 0
}), Z(tp, "state", A0);
const Ru = /* @__PURE__ */ new Map(), vb = /* @__PURE__ */ new Map();
var qT, Wv, jT, Pn, jz, Bz, UD, zD, FD, VD, Qz, _b;
const KM = class KM {
  constructor(s, n, o) {
    R(this, Pn);
    R(this, qT);
    R(this, Wv);
    R(this, jT);
    Z(this, "$images", st([]));
    L(this, Wv, s), L(this, jT, n), L(this, qT, o), J(S(this, Pn, jz).bind(this));
  }
  static create(s, n) {
    const o = Ua();
    return new KM(s, n, o);
  }
};
qT = new WeakMap(), Wv = new WeakMap(), jT = new WeakMap(), Pn = new WeakSet(), jz = function() {
  var o;
  const { canLoad: s } = d(this, qT).$state;
  if (!s()) return;
  const n = d(this, Wv).call(this);
  if (n) {
    if (Ze(n) && Ru.has(n)) {
      const h = Ru.get(n);
      if (Ru.delete(n), Ru.set(n, h), Ru.size > 99) {
        const v = Ru.keys().next().value;
        Ru.delete(v);
      }
      this.$images.set(Ru.get(n));
    } else if (Ze(n)) {
      const h = d(this, jT).call(this), v = n + "::" + h;
      if (!vb.has(v)) {
        const y = new Promise(async (k, D) => {
          try {
            const $ = await fetch(n, {
              credentials: sT(h)
            });
            if ($.headers.get("content-type") === "application/json") {
              const A = await $.json();
              if (Vr(A))
                if (A[0] && "text" in A[0])
                  k(S(this, Pn, zD).call(this, A));
                else {
                  for (let B = 0; B < A.length; B++) {
                    const W = A[B];
                    xu(jj(W), !1), xu(
                      "url" in W && Ze(W.url),
                      !1
                    ), xu(
                      "startTime" in W && ss(W.startTime),
                      !1
                    );
                  }
                  k(A);
                }
              else
                k(S(this, Pn, UD).call(this, A));
              return;
            }
            import("./dev-D3SS6qhA.js").then((A) => A.d).then(async ({ parseResponse: A }) => {
              try {
                const { cues: B } = await A($);
                k(S(this, Pn, zD).call(this, B));
              } catch (B) {
                D(B);
              }
            });
          } catch ($) {
            D($);
          }
        }).then((k) => (Ru.set(v, k), k)).catch((k) => {
          S(this, Pn, _b).call(this, n, k);
        }).finally(() => {
          Ze(v) && vb.delete(v);
        });
        vb.set(v, y);
      }
      (o = vb.get(v)) == null || o.then((y) => {
        this.$images.set(y || []);
      });
    } else if (Vr(n))
      try {
        this.$images.set(S(this, Pn, Bz).call(this, n));
      } catch (h) {
        S(this, Pn, _b).call(this, n, h);
      }
    else
      try {
        this.$images.set(S(this, Pn, UD).call(this, n));
      } catch (h) {
        S(this, Pn, _b).call(this, n, h);
      }
    return () => {
      this.$images.set([]);
    };
  }
}, Bz = function(s) {
  const n = S(this, Pn, FD).call(this);
  return s.map((o, h) => (xu(
    o.url && Ze(o.url)
  ), xu(
    "startTime" in o && ss(o.startTime)
  ), {
    ...o,
    url: Ze(o.url) ? S(this, Pn, VD).call(this, o.url, n) : o.url
  }));
}, UD = function(s) {
  var y;
  xu(Ze(s.url)), xu(Vr(s.tiles) && ((y = s.tiles) == null ? void 0 : y.length));
  const n = new URL(s.url), o = [], h = "tile_width" in s ? s.tile_width : s.tileWidth, v = "tile_height" in s ? s.tile_height : s.tileHeight;
  for (const k of s.tiles)
    o.push({
      url: n,
      startTime: "start" in k ? k.start : k.startTime,
      width: h,
      height: v,
      coords: { x: k.x, y: k.y }
    });
  return o;
}, zD = function(s) {
  for (let h = 0; h < s.length; h++) {
    const v = s[h];
    xu(
      "startTime" in v && ss(v.startTime)
    ), xu(
      "text" in v && Ze(v.text)
    );
  }
  const n = [], o = S(this, Pn, FD).call(this);
  for (const h of s) {
    const [v, y] = h.text.split("#"), k = S(this, Pn, Qz).call(this, y);
    n.push({
      url: S(this, Pn, VD).call(this, v, o),
      startTime: h.startTime,
      endTime: h.endTime,
      width: k == null ? void 0 : k.w,
      height: k == null ? void 0 : k.h,
      coords: k && ss(k.x) && ss(k.y) ? { x: k.x, y: k.y } : void 0
    });
  }
  return n;
}, FD = function() {
  let s = ye(d(this, Wv));
  return !Ze(s) || !/^https?:/.test(s) ? location.href : s;
}, VD = function(s, n) {
  return /^https?:/.test(s) ? new URL(s) : new URL(s, n);
}, Qz = function(s) {
  if (!s) return {};
  const [n, o] = s.split("="), h = o == null ? void 0 : o.split(","), v = {};
  if (!n || !h)
    return null;
  for (let y = 0; y < n.length; y++) {
    const k = +h[y];
    isNaN(k) || (v[n[y]] = k);
  }
  return v;
}, _b = function(s, n) {
};
let ND = KM;
var Kv, Xv, Pt, Yz, ID, Gz, Wz, Kz, Xz, qD, Zz, Jz, jD, td, e2;
class HD extends Ci {
  constructor() {
    super(...arguments);
    R(this, Pt);
    Z(this, "media");
    R(this, Kv);
    R(this, Xv, []);
  }
  onSetup() {
    this.media = Ua(), L(this, Kv, ND.create(this.$props.src, this.$state.crossOrigin)), S(this, Pt, ID).call(this), this.setAttributes({
      "data-loading": S(this, Pt, Xz).bind(this),
      "data-error": S(this, Pt, qD).bind(this),
      "data-hidden": this.$state.hidden,
      "aria-hidden": ap(this.$state.hidden)
    });
  }
  onConnect(n) {
    J(S(this, Pt, Yz).bind(this)), J(S(this, Pt, Zz).bind(this)), J(S(this, Pt, ID).bind(this)), J(S(this, Pt, Gz).bind(this)), J(S(this, Pt, Jz).bind(this)), J(S(this, Pt, jD).bind(this));
  }
  getTime() {
    return this.$props.time();
  }
}
Kv = new WeakMap(), Xv = new WeakMap(), Pt = new WeakSet(), Yz = function() {
  const n = this.$state.img();
  n && new gn(n).add("load", S(this, Pt, Wz).bind(this)).add("error", S(this, Pt, Kz).bind(this));
}, ID = function() {
  const { crossOrigin: n } = this.$props, { crossOrigin: o } = this.$state, { crossOrigin: h } = this.media.$state, v = n() !== null ? n() : h();
  o.set(v === !0 ? "anonymous" : v);
}, Gz = function() {
  const { src: n, loading: o, error: h } = this.$state;
  return n() && (o.set(!0), h.set(null)), () => {
    S(this, Pt, e2).call(this), o.set(!1), h.set(null);
  };
}, Wz = function() {
  const { loading: n, error: o } = this.$state;
  S(this, Pt, jD).call(this), n.set(!1), o.set(null);
}, Kz = function(n) {
  const { loading: o, error: h } = this.$state;
  o.set(!1), h.set(n);
}, Xz = function() {
  const { loading: n, hidden: o } = this.$state;
  return !o() && n();
}, qD = function() {
  const { error: n } = this.$state;
  return !Zu(n());
}, Zz = function() {
  const { hidden: n } = this.$state, { duration: o } = this.media.$state, h = d(this, Kv).$images();
  n.set(S(this, Pt, qD).call(this) || !Number.isFinite(o()) || h.length === 0);
}, Jz = function() {
  let n = d(this, Kv).$images();
  if (!n.length) return;
  let o = this.getTime(), { src: h, activeThumbnail: v } = this.$state, y = -1, k = null;
  for (let D = n.length - 1; D >= 0; D--) {
    const $ = n[D];
    if (o >= $.startTime && (!$.endTime || o < $.endTime)) {
      y = D;
      break;
    }
  }
  n[y] && (k = n[y]), v.set(k), h.set((k == null ? void 0 : k.url.href) || "");
}, jD = function() {
  if (!this.scope || this.$state.hidden()) return;
  const n = this.el, o = this.$state.img(), h = this.$state.activeThumbnail();
  if (!o || !h || !n) return;
  let v = h.width ?? o.naturalWidth, y = (h == null ? void 0 : h.height) ?? o.naturalHeight, {
    maxWidth: k,
    maxHeight: D,
    minWidth: $,
    minHeight: _,
    width: A,
    height: B
  } = getComputedStyle(this.el);
  $ === "100%" && ($ = parseFloat(A) + ""), _ === "100%" && (_ = parseFloat(B) + "");
  let W = Math.max(parseInt($) / v, parseInt(_) / y), ne = Math.min(
    Math.max(parseInt($), parseInt(k)) / v,
    Math.max(parseInt(_), parseInt(D)) / y
  ), ce = !isNaN(ne) && ne < 1 ? ne : W > 1 ? W : 1;
  S(this, Pt, td).call(this, n, "--thumbnail-width", `${v * ce}px`), S(this, Pt, td).call(this, n, "--thumbnail-height", `${y * ce}px`), S(this, Pt, td).call(this, n, "--thumbnail-aspect-ratio", String(Na(v / y, 5))), S(this, Pt, td).call(this, o, "width", `${o.naturalWidth * ce}px`), S(this, Pt, td).call(this, o, "height", `${o.naturalHeight * ce}px`), S(this, Pt, td).call(this, o, "transform", h.coords ? `translate(-${h.coords.x * ce}px, -${h.coords.y * ce}px)` : ""), S(this, Pt, td).call(this, o, "max-width", "none");
}, td = function(n, o, h) {
  n.style.setProperty(o, h), d(this, Xv).push(() => n.style.removeProperty(o));
}, e2 = function() {
  for (const n of d(this, Xv)) n();
  L(this, Xv, []);
}, Z(HD, "props", {
  src: null,
  time: 0,
  crossOrigin: null
}), Z(HD, "state", new by({
  src: "",
  img: null,
  thumbnails: [],
  activeThumbnail: null,
  crossOrigin: null,
  loading: !1,
  error: null,
  hidden: !1
}));
var BT;
class S8 extends HD {
  constructor() {
    super(...arguments);
    R(this, BT);
  }
  onAttach(n) {
    L(this, BT, uw(tp.state));
  }
  getTime() {
    const { duration: n, clipStartTime: o } = this.media.$state;
    return o() + d(this, BT).pointerRate() * n();
  }
}
BT = new WeakMap();
var T8 = Object.defineProperty, w8 = Object.getOwnPropertyDescriptor, E8 = (f, s, n, o) => {
  for (var h = w8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && T8(s, n, h), h;
}, Ed, QT, Mn, t2, n2, BD, i2, QD, r2, a2, YD, s2, l2;
class i0 extends Ci {
  constructor() {
    super(...arguments);
    R(this, Mn);
    R(this, Ed);
    R(this, QT);
  }
  get video() {
    return this.$state.video();
  }
  onSetup() {
    L(this, Ed, Ua()), L(this, QT, uw(tp.state)), S(this, Mn, BD).call(this), this.setAttributes({
      "data-loading": S(this, Mn, i2).bind(this),
      "data-hidden": this.$state.hidden,
      "data-error": S(this, Mn, QD).bind(this),
      "aria-hidden": ap(this.$state.hidden)
    });
  }
  onAttach(n) {
    J(S(this, Mn, t2).bind(this)), J(S(this, Mn, n2).bind(this)), J(S(this, Mn, BD).bind(this)), J(S(this, Mn, r2).bind(this)), J(S(this, Mn, a2).bind(this)), J(S(this, Mn, l2).bind(this));
  }
}
Ed = new WeakMap(), QT = new WeakMap(), Mn = new WeakSet(), t2 = function() {
  const n = this.$state.video();
  n && (n.readyState >= 2 && S(this, Mn, YD).call(this), new gn(n).add("canplay", S(this, Mn, YD).bind(this)).add("error", S(this, Mn, s2).bind(this)));
}, n2 = function() {
  const { src: n } = this.$state, { canLoad: o } = d(this, Ed).$state;
  n.set(o() ? this.$props.src() : null);
}, BD = function() {
  const { crossOrigin: n } = this.$props, { crossOrigin: o } = this.$state, { crossOrigin: h } = d(this, Ed).$state, v = n() !== null ? n() : h();
  o.set(v === !0 ? "anonymous" : v);
}, i2 = function() {
  const { canPlay: n, hidden: o } = this.$state;
  return !n() && !o();
}, QD = function() {
  const { error: n } = this.$state;
  return !Zu(n);
}, r2 = function() {
  const { src: n, hidden: o } = this.$state, { canLoad: h, duration: v } = d(this, Ed).$state;
  o.set(h() && (!n() || S(this, Mn, QD).call(this) || !Number.isFinite(v())));
}, a2 = function() {
  const { src: n, canPlay: o, error: h } = this.$state;
  n(), o.set(!1), h.set(null);
}, YD = function(n) {
  const { canPlay: o, error: h } = this.$state;
  o.set(!0), h.set(null), this.dispatch("can-play", { trigger: n });
}, s2 = function(n) {
  const { canPlay: o, error: h } = this.$state;
  o.set(!1), h.set(n), this.dispatch("error", { trigger: n });
}, l2 = function() {
  const { video: n, canPlay: o } = this.$state, { duration: h } = d(this, Ed).$state, { pointerRate: v } = d(this, QT), y = n();
  o() && y && Number.isFinite(h()) && Number.isFinite(v()) && (y.currentTime = v() * h());
}, Z(i0, "props", {
  src: null,
  crossOrigin: null
}), Z(i0, "state", new by({
  video: null,
  src: null,
  crossOrigin: null,
  canPlay: !1,
  error: null,
  hidden: !1
}));
E8([
  rn
], i0.prototype, "video");
var C8 = Object.defineProperty, b8 = Object.getOwnPropertyDescriptor, k8 = (f, s, n, o) => {
  for (var h = b8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && C8(s, n, h), h;
}, Cd, y0, YT;
class BM extends Ci {
  constructor() {
    super(...arguments);
    R(this, Cd);
    R(this, y0);
    R(this, YT);
  }
  onSetup() {
    L(this, YT, uw(tp.state)), L(this, Cd, Us(uT)), L(this, y0, ow(this.getValueText.bind(this)));
  }
  getValueText() {
    var ce, Re;
    const {
      type: n,
      format: o,
      decimalPlaces: h,
      padHours: v,
      padMinutes: y,
      showHours: k,
      showMs: D
    } = this.$props, { value: $, pointerValue: _, min: A, max: B } = d(this, YT), W = (o == null ? void 0 : o()) ?? d(this, Cd).default, ne = n() === "current" ? $() : _();
    if (W === "percent") {
      const Lt = B() - A(), $t = ne / Lt * 100;
      return (d(this, Cd).percent ?? Na)($t, h()) + "%";
    } else return W === "time" ? (d(this, Cd).time ?? qM)(ne, {
      padHrs: v(),
      padMins: y(),
      showHrs: k(),
      showMs: D()
    }) : (((Re = (ce = d(this, Cd)).value) == null ? void 0 : Re.call(ce, ne)) ?? ne.toFixed(2)) + "";
  }
}
Cd = new WeakMap(), y0 = new WeakMap(), YT = new WeakMap(), Z(BM, "props", {
  type: "pointer",
  format: null,
  showHours: !1,
  showMs: !1,
  padHours: null,
  padMinutes: null,
  decimalPlaces: 2
});
k8([
  Zi
], BM.prototype, "getValueText");
var Zv, GT;
class o2 extends Ci {
  constructor() {
    super(...arguments);
    R(this, Zv);
    R(this, GT, Ey(() => {
      const { disabled: n, orientation: o } = d(this, Zv);
      if (n()) return;
      const h = this.el, { offset: v, noClamp: y } = this.$props;
      h && x8(h, {
        clamp: !y(),
        offset: v(),
        orientation: o()
      });
    }));
  }
  onSetup() {
    L(this, Zv, Us(jM));
    const { active: n } = uw(tp.state);
    this.setAttributes({
      "data-visible": n
    });
  }
  onAttach(n) {
    Object.assign(n.style, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "max-content"
    });
  }
  onConnect(n) {
    const { preview: o } = d(this, Zv);
    o.set(n), Wt(() => o.set(null)), J(d(this, GT).bind(this));
    const h = new ResizeObserver(d(this, GT).bind(this));
    h.observe(n), Wt(() => h.disconnect());
  }
}
Zv = new WeakMap(), GT = new WeakMap(), Z(o2, "props", {
  offset: 0,
  noClamp: !1
});
function x8(f, {
  clamp: s,
  offset: n,
  orientation: o
}) {
  const h = getComputedStyle(f), v = parseFloat(h.width), y = parseFloat(h.height), k = {
    top: null,
    right: null,
    bottom: null,
    left: null
  };
  if (k[o === "horizontal" ? "bottom" : "left"] = `calc(100% + var(--media-slider-preview-offset, ${n}px))`, o === "horizontal") {
    const D = v / 2;
    if (!s)
      k.left = `calc(var(--slider-pointer) - ${D}px)`;
    else {
      const $ = `max(0px, calc(var(--slider-pointer) - ${D}px))`, _ = `calc(100% - ${v}px)`;
      k.left = `min(${$}, ${_})`;
    }
  } else {
    const D = y / 2;
    if (!s)
      k.bottom = `calc(var(--slider-pointer) - ${D}px)`;
    else {
      const $ = `max(${D}px, calc(var(--slider-pointer) - ${D}px))`, _ = `calc(100% - ${y}px)`;
      k.bottom = `min(${$}, ${_})`;
    }
  }
  Object.assign(f.style, k);
}
var _s, Xi, u2, c2, d2, f2, h2, WT, p2, m2, v2;
class GD extends Ci {
  constructor() {
    super(...arguments);
    R(this, Xi);
    R(this, _s);
    R(this, WT, cw(S(this, Xi, p2).bind(this), 25));
  }
  onSetup() {
    L(this, _s, Ua());
    const { audioGain: n } = d(this, _s).$state;
    Ju(uT, {
      default: "percent",
      value(o) {
        return (o * (n() ?? 1)).toFixed(2);
      },
      percent(o) {
        return Math.round(o * (n() ?? 1));
      }
    }), new ep({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: Math.round,
      isDisabled: S(this, Xi, f2).bind(this),
      aria: {
        valueMax: S(this, Xi, d2).bind(this),
        valueNow: S(this, Xi, u2).bind(this),
        valueText: S(this, Xi, c2).bind(this)
      },
      onDragValueChange: S(this, Xi, v2).bind(this),
      onValueChange: S(this, Xi, m2).bind(this)
    }).attach(this), J(S(this, Xi, h2).bind(this));
  }
  onAttach(n) {
    n.setAttribute("data-media-volume-slider", ""), Wi(n, "aria-label", "Volume");
    const { canSetVolume: o } = d(this, _s).$state;
    this.setAttributes({
      "data-supported": o,
      "aria-hidden": ap(() => !o())
    });
  }
}
_s = new WeakMap(), Xi = new WeakSet(), u2 = function() {
  const { value: n } = this.$state, { audioGain: o } = d(this, _s).$state;
  return Math.round(n() * (o() ?? 1));
}, c2 = function() {
  const { value: n, max: o } = this.$state, { audioGain: h } = d(this, _s).$state;
  return Na(n() / o() * (h() ?? 1) * 100, 2) + "%";
}, d2 = function() {
  const { audioGain: n } = d(this, _s).$state;
  return this.$state.max() * (n() ?? 1);
}, f2 = function() {
  const { disabled: n } = this.$props, { canSetVolume: o } = d(this, _s).$state;
  return n() || !o();
}, h2 = function() {
  const { muted: n, volume: o } = d(this, _s).$state, h = n() ? 0 : o() * 100;
  this.$state.value.set(h), this.dispatch("value-change", { detail: h });
}, WT = new WeakMap(), p2 = function(n) {
  if (!n.trigger) return;
  const o = Na(n.detail / 100, 3);
  d(this, _s).remote.changeVolume(o, n);
}, m2 = function(n) {
  d(this, WT).call(this, n);
}, v2 = function(n) {
  d(this, WT).call(this, n);
}, Z(GD, "props", {
  ...ep.props,
  keyStep: 5,
  shiftKeyMultiplier: 2
}), Z(GD, "state", A0);
var Rn, Jv, KT, Ie, y2, g2, S2, T2, w2, WD, E2, ey, C2, b2, KD, k2, XD, x2, R2, D2, M2, L2, $2, fh, O2, A2, P2;
class r0 extends Ci {
  constructor() {
    super();
    R(this, Ie);
    R(this, Rn);
    R(this, Jv);
    R(this, KT, st(null));
    R(this, ey, !1);
    const { noSwipeGesture: n } = this.$props;
    new ep({
      swipeGesture: () => !n(),
      getValue: S(this, Ie, XD).bind(this),
      getStep: S(this, Ie, x2).bind(this),
      getKeyStep: S(this, Ie, R2).bind(this),
      roundValue: S(this, Ie, D2),
      isDisabled: S(this, Ie, M2).bind(this),
      aria: {
        valueNow: S(this, Ie, L2).bind(this),
        valueText: S(this, Ie, $2).bind(this)
      },
      onDragStart: S(this, Ie, C2).bind(this),
      onDragValueChange: S(this, Ie, b2).bind(this),
      onDragEnd: S(this, Ie, KD).bind(this),
      onValueChange: S(this, Ie, k2).bind(this)
    });
  }
  onSetup() {
    L(this, Rn, Ua()), Ju(uT, {
      default: "time",
      value: S(this, Ie, A2).bind(this),
      time: S(this, Ie, P2).bind(this)
    }), this.setAttributes({
      "data-chapters": S(this, Ie, g2).bind(this)
    }), this.setStyles({
      "--slider-progress": S(this, Ie, y2).bind(this)
    }), J(S(this, Ie, T2).bind(this)), J(S(this, Ie, S2).bind(this));
  }
  onAttach(n) {
    n.setAttribute("data-media-time-slider", ""), Wi(n, "aria-label", "Seek");
  }
  onConnect(n) {
    J(S(this, Ie, w2).bind(this)), XP(d(this, Rn).textTracks, "chapters", d(this, KT).set);
  }
}
Rn = new WeakMap(), Jv = new WeakMap(), KT = new WeakMap(), Ie = new WeakSet(), y2 = function() {
  const { bufferedEnd: n, duration: o } = d(this, Rn).$state;
  return Na(Math.min(n() / Math.max(o(), 1), 1) * 100, 3) + "%";
}, g2 = function() {
  var o;
  const { duration: n } = d(this, Rn).$state;
  return ((o = d(this, KT).call(this)) == null ? void 0 : o.cues.length) && Number.isFinite(n()) && n() > 0;
}, S2 = function() {
  L(this, Jv, cw(
    S(this, Ie, WD).bind(this),
    this.$props.seekingRequestThrottle()
  ));
}, T2 = function() {
  if (this.$state.hidden()) return;
  const { value: n, dragging: o } = this.$state, h = S(this, Ie, XD).call(this);
  ye(o) || (n.set(h), this.dispatch("value-change", { detail: h }));
}, w2 = function() {
  const n = d(this, Rn).player.el, { preview: o } = Us(jM);
  n && o() && Rt(n, "data-preview", this.$state.active());
}, WD = function(n, o) {
  d(this, Rn).remote.seeking(n, o);
}, E2 = function(n, o, h) {
  d(this, Jv).cancel();
  const { live: v } = d(this, Rn).$state;
  if (v() && o >= 99) {
    d(this, Rn).remote.seekToLiveEdge(h);
    return;
  }
  d(this, Rn).remote.seek(n, h);
}, ey = new WeakMap(), C2 = function(n) {
  const { pauseWhileDragging: o } = this.$props;
  if (o()) {
    const { paused: h } = d(this, Rn).$state;
    L(this, ey, !h()), d(this, Rn).remote.pause(n);
  }
}, b2 = function(n) {
  d(this, Jv).call(this, S(this, Ie, fh).call(this, n.detail), n);
}, KD = function(n) {
  const { seeking: o } = d(this, Rn).$state;
  ye(o) || S(this, Ie, WD).call(this, S(this, Ie, fh).call(this, n.detail), n);
  const h = n.detail;
  S(this, Ie, E2).call(this, S(this, Ie, fh).call(this, h), h, n);
  const { pauseWhileDragging: v } = this.$props;
  v() && d(this, ey) && (d(this, Rn).remote.play(n), L(this, ey, !1));
}, k2 = function(n) {
  const { dragging: o } = this.$state;
  o() || !n.trigger || S(this, Ie, KD).call(this, n);
}, // -------------------------------------------------------------------------------------------
// Props
// -------------------------------------------------------------------------------------------
XD = function() {
  const { currentTime: n } = d(this, Rn).$state;
  return S(this, Ie, O2).call(this, n());
}, x2 = function() {
  const n = this.$props.step() / d(this, Rn).$state.duration() * 100;
  return Number.isFinite(n) ? n : 1;
}, R2 = function() {
  const n = this.$props.keyStep() / d(this, Rn).$state.duration() * 100;
  return Number.isFinite(n) ? n : 1;
}, D2 = function(n) {
  return Na(n, 3);
}, M2 = function() {
  const { disabled: n } = this.$props, { canSeek: o } = d(this, Rn).$state;
  return n() || !o();
}, // -------------------------------------------------------------------------------------------
// ARIA
// -------------------------------------------------------------------------------------------
L2 = function() {
  const { value: n } = this.$state;
  return Math.round(n());
}, $2 = function() {
  const n = S(this, Ie, fh).call(this, this.$state.value()), { duration: o } = d(this, Rn).$state;
  return Number.isFinite(n) ? `${YA(n)} out of ${YA(o())}` : "live";
}, // -------------------------------------------------------------------------------------------
// Format
// -------------------------------------------------------------------------------------------
fh = function(n) {
  const { duration: o } = d(this, Rn).$state;
  return Na(n / 100 * o(), 5);
}, O2 = function(n) {
  const { liveEdge: o, duration: h } = d(this, Rn).$state, v = Math.max(0, Math.min(1, o() ? 1 : Math.min(n, h()) / h()));
  return Number.isNaN(v) ? 0 : Number.isFinite(v) ? v * 100 : 100;
}, A2 = function(n) {
  const o = S(this, Ie, fh).call(this, n), { live: h, duration: v } = d(this, Rn).$state;
  return Number.isFinite(o) ? (h() ? o - v() : o).toFixed(0) : "LIVE";
}, P2 = function(n, o) {
  const h = S(this, Ie, fh).call(this, n), { live: v, duration: y } = d(this, Rn).$state, k = v() ? h - y() : h;
  return Number.isFinite(h) ? `${k < 0 ? "-" : ""}${qM(Math.abs(k), o)}` : "LIVE";
}, Z(r0, "props", {
  ...ep.props,
  step: 0.1,
  keyStep: 5,
  shiftKeyMultiplier: 2,
  pauseWhileDragging: !1,
  noSwipeGesture: !1,
  seekingRequestThrottle: 100
}), Z(r0, "state", A0);
var R8 = Object.defineProperty, D8 = Object.getOwnPropertyDescriptor, P0 = (f, s, n, o) => {
  for (var h = D8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && R8(s, n, h), h;
}, $a, Hh, ty, po, ra, Ih, aa, ju, qh, bd, qe, ZD, JD, _2, N2, U2, z2, F2, Nb, eM, tM, V2, g0, S0, H2, Ub, zb, I2, q2, j2, B2, XT, Q2, Y2, G2;
class Ry extends Ci {
  constructor() {
    super(...arguments);
    R(this, qe);
    R(this, $a);
    R(this, Hh);
    R(this, ty);
    R(this, po, null);
    R(this, ra, []);
    R(this, Ih, st(null));
    R(this, aa, st([]));
    R(this, ju, st(-1));
    R(this, qh, st(-1));
    R(this, bd, 0);
    R(this, g0, Ey((n) => {
      var D;
      let o, h = d(this, aa).call(this), { seekableStart: v } = d(this, $a).$state, y = v(), k = S(this, qe, Ub).call(this, h);
      for (let $ = d(this, bd); $ < d(this, ra).length; $++)
        if (o = S(this, qe, zb).call(this, h[$], n, y, k), (D = d(this, ra)[$]) == null || D.style.setProperty("--chapter-progress", o + "%"), o < 100) {
          L(this, bd, $);
          break;
        }
    }));
    R(this, S0, ow(S(this, qe, H2).bind(this)));
    R(this, XT, FM(
      () => {
        const n = ye(d(this, Ih));
        !this.scope || !n || !n.cues.length || (d(this, aa).set(S(this, qe, I2).call(this, n.cues)), d(this, ju).set(0), L(this, bd, 0));
      },
      150,
      !0
    ));
  }
  get cues() {
    return d(this, aa).call(this);
  }
  get activeCue() {
    return d(this, aa).call(this)[d(this, ju).call(this)] || null;
  }
  get activePointerCue() {
    return d(this, aa).call(this)[d(this, qh).call(this)] || null;
  }
  onSetup() {
    L(this, $a, Ua()), L(this, Hh, uw(r0.state));
  }
  onAttach(n) {
    XP(d(this, $a).textTracks, "chapters", S(this, qe, ZD).bind(this)), J(S(this, qe, q2).bind(this));
  }
  onConnect() {
    Wt(() => S(this, qe, JD).bind(this));
  }
  onDestroy() {
    S(this, qe, ZD).call(this, null);
  }
  setRefs(n) {
    var o;
    if (L(this, ra, n), (o = d(this, ty)) == null || o.dispose(), d(this, ra).length === 1) {
      const h = d(this, ra)[0];
      h.style.width = "100%", h.style.setProperty("--chapter-fill", "var(--slider-fill)"), h.style.setProperty("--chapter-progress", "var(--slider-progress)");
    } else d(this, ra).length > 0 && Cl(() => S(this, qe, _2).call(this), L(this, ty, Gb()));
  }
}
$a = new WeakMap(), Hh = new WeakMap(), ty = new WeakMap(), po = new WeakMap(), ra = new WeakMap(), Ih = new WeakMap(), aa = new WeakMap(), ju = new WeakMap(), qh = new WeakMap(), bd = new WeakMap(), qe = new WeakSet(), ZD = function(n) {
  ye(d(this, Ih)) !== n && (S(this, qe, JD).call(this), d(this, Ih).set(n));
}, JD = function() {
  var n;
  L(this, ra, []), d(this, aa).set([]), d(this, ju).set(-1), d(this, qh).set(-1), L(this, bd, 0), (n = d(this, ty)) == null || n.dispose();
}, _2 = function() {
  d(this, ra).length && J(S(this, qe, N2).bind(this));
}, N2 = function() {
  const { hidden: n } = d(this, Hh);
  n() || (J(S(this, qe, U2).bind(this)), J(S(this, qe, z2).bind(this)), J(S(this, qe, F2).bind(this)), J(S(this, qe, V2).bind(this)));
}, U2 = function() {
  const n = d(this, aa).call(this);
  if (!n.length) return;
  let o, { seekableStart: h, seekableEnd: v } = d(this, $a).$state, y = h(), k = v() || n[n.length - 1].endTime, D = k - y, $ = 100;
  for (let _ = 0; _ < n.length; _++)
    if (o = n[_], d(this, ra)[_]) {
      const A = _ === n.length - 1 ? $ : Na((o.endTime - Math.max(y, o.startTime)) / D * 100, 3);
      d(this, ra)[_].style.width = A + "%", $ -= A;
    }
}, z2 = function() {
  let { liveEdge: n, seekableStart: o, seekableEnd: h } = d(this, $a).$state, { fillPercent: v, value: y } = d(this, Hh), k = d(this, aa).call(this), D = n(), $ = ye(d(this, ju)), _ = k[$], A = D ? d(this, aa).length - 1 : S(this, qe, tM).call(this, _ && _.startTime / h() * 100 <= ye(y) ? $ : 0, v());
  D || !_ ? S(this, qe, Nb).call(this, 0, k.length, 100) : A > $ ? S(this, qe, Nb).call(this, $, A, 100) : A < $ && S(this, qe, Nb).call(this, A + 1, $ + 1, 0);
  const B = D ? 100 : S(this, qe, zb).call(this, k[A], v(), o(), S(this, qe, Ub).call(this, k));
  S(this, qe, eM).call(this, d(this, ra)[A], B), d(this, ju).set(A);
}, F2 = function() {
  let { hidden: n, pointerPercent: o } = d(this, Hh);
  if (n()) {
    d(this, qh).set(-1);
    return;
  }
  const h = S(this, qe, tM).call(this, 0, o());
  d(this, qh).set(h);
}, Nb = function(n, o, h) {
  for (let v = n; v < o; v++) S(this, qe, eM).call(this, d(this, ra)[v], h);
}, eM = function(n, o) {
  n && (n.style.setProperty("--chapter-fill", o + "%"), Rt(n, "data-active", o > 0 && o < 100), Rt(n, "data-ended", o === 100));
}, tM = function(n, o) {
  let h = 0, v = d(this, aa).call(this);
  if (o === 0) return 0;
  if (o === 100) return v.length - 1;
  let { seekableStart: y } = d(this, $a).$state, k = y(), D = S(this, qe, Ub).call(this, v);
  for (let $ = n; $ < v.length; $++)
    if (h = S(this, qe, zb).call(this, v[$], o, k, D), h >= 0 && h < 100) return $;
  return 0;
}, V2 = function() {
  d(this, g0).call(this, d(this, S0).call(this));
}, g0 = new WeakMap(), S0 = new WeakMap(), H2 = function() {
  const { bufferedEnd: n, duration: o } = d(this, $a).$state;
  return Na(Math.min(n() / Math.max(o(), 1), 1), 3) * 100;
}, Ub = function(n) {
  var v;
  const { seekableEnd: o } = d(this, $a).$state, h = o();
  return Number.isFinite(h) ? h : ((v = n[n.length - 1]) == null ? void 0 : v.endTime) || 0;
}, zb = function(n, o, h, v) {
  if (!n || d(this, aa).call(this).length === 0) return 0;
  const k = v - h, D = Math.max(0, n.startTime - h), $ = Math.min(v, n.endTime) - h, _ = D / k, A = _ * 100, B = Math.min(1, _ + ($ - D) / k) * 100;
  return Math.max(
    0,
    Na(
      o >= B ? 100 : (o - A) / (B - A) * 100,
      3
    )
  );
}, I2 = function(n) {
  let o = [], { seekableStart: h, seekableEnd: v, duration: y } = d(this, $a).$state, k = h(), D = v();
  n = n.filter((A) => A.startTime <= D && A.endTime >= k);
  const $ = n[0];
  $ && $.startTime > k && o.push(new window.VTTCue(k, $.startTime, ""));
  for (let A = 0; A < n.length - 1; A++) {
    const B = n[A], W = n[A + 1];
    if (o.push(B), W) {
      const ne = W.startTime - B.endTime;
      ne > 0 && o.push(new window.VTTCue(B.endTime, B.endTime + ne, ""));
    }
  }
  const _ = n[n.length - 1];
  if (_) {
    o.push(_);
    const A = y();
    A >= 0 && A - _.endTime > 1 && o.push(new window.VTTCue(_.endTime, y(), ""));
  }
  return o;
}, q2 = function() {
  const { source: n } = d(this, $a).$state;
  n(), S(this, qe, j2).call(this);
}, j2 = function() {
  if (!this.scope) return;
  const { disabled: n } = this.$props;
  if (n()) {
    d(this, aa).set([]), d(this, ju).set(0), L(this, bd, 0);
    return;
  }
  const o = d(this, Ih).call(this);
  if (o) {
    const h = d(this, XT).bind(this);
    h(), new gn(o).add("add-cue", h).add("remove-cue", h), J(S(this, qe, B2).bind(this));
  }
  return L(this, po, S(this, qe, G2).call(this)), d(this, po) && J(S(this, qe, Q2).bind(this)), () => {
    d(this, po) && (d(this, po).textContent = "", L(this, po, null));
  };
}, B2 = function() {
  d(this, $a).$state.duration(), d(this, XT).call(this);
}, XT = new WeakMap(), Q2 = function() {
  const n = this.activePointerCue || this.activeCue;
  d(this, po) && (d(this, po).textContent = (n == null ? void 0 : n.text) || "");
}, Y2 = function() {
  let n = this.el;
  for (; n && n.getAttribute("role") !== "slider"; )
    n = n.parentElement;
  return n;
}, G2 = function() {
  const n = S(this, qe, Y2).call(this);
  return n ? n.querySelector('[data-part="chapter-title"]') : null;
}, Z(Ry, "props", {
  disabled: !1
});
P0([
  rn
], Ry.prototype, "cues");
P0([
  rn
], Ry.prototype, "activeCue");
P0([
  rn
], Ry.prototype, "activePointerCue");
P0([
  Zi
], Ry.prototype, "setRefs");
const Pd = Cy(), nP = (f) => typeof f == "object" && f != null && f.nodeType === 1, iP = (f, s) => (!s || f !== "hidden") && f !== "visible" && f !== "clip", yb = (f, s) => {
  if (f.clientHeight < f.scrollHeight || f.clientWidth < f.scrollWidth) {
    const n = getComputedStyle(f, null);
    return iP(n.overflowY, s) || iP(n.overflowX, s) || ((o) => {
      const h = ((v) => {
        if (!v.ownerDocument || !v.ownerDocument.defaultView) return null;
        try {
          return v.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(o);
      return !!h && (h.clientHeight < o.scrollHeight || h.clientWidth < o.scrollWidth);
    })(f);
  }
  return !1;
}, gb = (f, s, n, o, h, v, y, k) => v < f && y > s || v > f && y < s ? 0 : v <= f && k <= n || y >= s && k >= n ? v - f - o : y > s && k < n || v < f && k > n ? y - s + h : 0, M8 = (f) => {
  const s = f.parentElement;
  return s ?? (f.getRootNode().host || null);
}, L8 = (f, s) => {
  var n, o, h, v;
  if (typeof document > "u") return [];
  const { scrollMode: y, block: k, inline: D, boundary: $, skipOverflowHiddenElements: _ } = s, A = typeof $ == "function" ? $ : (Je) => Je !== $;
  if (!nP(f)) throw new TypeError("Invalid target");
  const B = document.scrollingElement || document.documentElement, W = [];
  let ne = f;
  for (; nP(ne) && A(ne); ) {
    if (ne = M8(ne), ne === B) {
      W.push(ne);
      break;
    }
    ne != null && ne === document.body && yb(ne) && !yb(document.documentElement) || ne != null && yb(ne, _) && W.push(ne);
  }
  const ce = (o = (n = window.visualViewport) == null ? void 0 : n.width) != null ? o : innerWidth, Re = (v = (h = window.visualViewport) == null ? void 0 : h.height) != null ? v : innerHeight, { scrollX: Lt, scrollY: $t } = window, { height: Ve, width: ct, top: Ye, right: Tt, bottom: He, left: de } = f.getBoundingClientRect(), { top: Ge, right: ft, bottom: Kt, left: Mt } = ((Je) => {
    const ot = window.getComputedStyle(Je);
    return { top: parseFloat(ot.scrollMarginTop) || 0, right: parseFloat(ot.scrollMarginRight) || 0, bottom: parseFloat(ot.scrollMarginBottom) || 0, left: parseFloat(ot.scrollMarginLeft) || 0 };
  })(f);
  let Ae = k === "start" || k === "nearest" ? Ye - Ge : k === "end" ? He + Kt : Ye + Ve / 2 - Ge + Kt, wt = D === "center" ? de + ct / 2 - Mt + ft : D === "end" ? Tt + ft : de - Mt;
  const Sn = [];
  for (let Je = 0; Je < W.length; Je++) {
    const ot = W[Je], { height: oe, width: Le, top: he, right: yt, bottom: Nt, left: Ii } = ot.getBoundingClientRect();
    if (y === "if-needed" && Ye >= 0 && de >= 0 && He <= Re && Tt <= ce && (ot === B && !yb(ot) || Ye >= he && He <= Nt && de >= Ii && Tt <= yt)) return Sn;
    const jn = getComputedStyle(ot), oa = parseInt(jn.borderLeftWidth, 10), ri = parseInt(jn.borderTopWidth, 10), ai = parseInt(jn.borderRightWidth, 10), bi = parseInt(jn.borderBottomWidth, 10);
    let si = 0, ki = 0;
    const _n = "offsetWidth" in ot ? ot.offsetWidth - ot.clientWidth - oa - ai : 0, er = "offsetHeight" in ot ? ot.offsetHeight - ot.clientHeight - ri - bi : 0, yi = "offsetWidth" in ot ? ot.offsetWidth === 0 ? 0 : Le / ot.offsetWidth : 0, xi = "offsetHeight" in ot ? ot.offsetHeight === 0 ? 0 : oe / ot.offsetHeight : 0;
    if (B === ot) si = k === "start" ? Ae : k === "end" ? Ae - Re : k === "nearest" ? gb($t, $t + Re, Re, ri, bi, $t + Ae, $t + Ae + Ve, Ve) : Ae - Re / 2, ki = D === "start" ? wt : D === "center" ? wt - ce / 2 : D === "end" ? wt - ce : gb(Lt, Lt + ce, ce, oa, ai, Lt + wt, Lt + wt + ct, ct), si = Math.max(0, si + $t), ki = Math.max(0, ki + Lt);
    else {
      si = k === "start" ? Ae - he - ri : k === "end" ? Ae - Nt + bi + er : k === "nearest" ? gb(he, Nt, oe, ri, bi + er, Ae, Ae + Ve, Ve) : Ae - (he + oe / 2) + er / 2, ki = D === "start" ? wt - Ii - oa : D === "center" ? wt - (Ii + Le / 2) + _n / 2 : D === "end" ? wt - yt + ai + _n : gb(Ii, yt, Le, oa, ai + _n, wt, wt + ct, ct);
      const { scrollLeft: tr, scrollTop: Ir } = ot;
      si = xi === 0 ? 0 : Math.max(0, Math.min(Ir + si / xi, ot.scrollHeight - oe / xi + er)), ki = yi === 0 ? 0 : Math.max(0, Math.min(tr + ki / yi, ot.scrollWidth - Le / yi + _n)), Ae += Ir - si, wt += tr - ki;
    }
    Sn.push({ el: ot, top: si, left: ki });
  }
  return Sn;
};
function $8(f, s) {
  const n = L8(f, s);
  for (const { el: o, top: h, left: v } of n)
    o.scroll({ top: h, left: v, behavior: s.behavior });
}
function O8(f, s = {}) {
  $8(f, {
    scrollMode: "if-needed",
    block: "center",
    inline: "center",
    ...s
  });
}
const A8 = /* @__PURE__ */ [
  "a[href]",
  "[tabindex]",
  "input",
  "select",
  "button"
].map((f) => `${f}:not([aria-hidden='true'])`).join(","), P8 = /* @__PURE__ */ new Set([
  "Escape",
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "PageUp",
  "End",
  "PageDown",
  "Enter",
  " "
]);
var kd, Tl, Oa, ZT, vn, hh, nM, W2, iM, K2, X2, Fb, Z2;
class _8 {
  constructor(s) {
    R(this, vn);
    R(this, kd, -1);
    R(this, Tl, null);
    R(this, Oa, []);
    R(this, ZT);
    L(this, ZT, s);
  }
  get items() {
    return d(this, Oa);
  }
  attachMenu(s) {
    En(s, "focus", S(this, vn, W2).bind(this)), L(this, Tl, s), Wt(() => {
      L(this, Tl, null);
    });
  }
  listen() {
    d(this, Tl) && (this.update(), new gn(d(this, Tl)).add("keyup", S(this, vn, K2).bind(this)).add("keydown", S(this, vn, X2).bind(this)), Wt(() => {
      L(this, kd, -1), L(this, Oa, []);
    }));
  }
  update() {
    L(this, kd, 0), L(this, Oa, S(this, vn, Z2).call(this));
  }
  scroll(s = S(this, vn, nM).call(this)) {
    const n = d(this, Oa)[s];
    n && requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        O8(n, {
          behavior: "smooth",
          boundary: (o) => !o.hasAttribute("data-root")
        });
      });
    });
  }
  focusActive(s = !0) {
    const n = S(this, vn, nM).call(this);
    S(this, vn, hh).call(this, n >= 0 ? n : 0, s);
  }
}
kd = new WeakMap(), Tl = new WeakMap(), Oa = new WeakMap(), ZT = new WeakMap(), vn = new WeakSet(), hh = function(s, n = !0) {
  var o;
  L(this, kd, s), d(this, Oa)[s] ? (d(this, Oa)[s].focus({ preventScroll: !0 }), n && this.scroll(s)) : (o = d(this, Tl)) == null || o.focus({ preventScroll: !0 });
}, nM = function() {
  return d(this, Oa).findIndex(
    (s) => document.activeElement === s || s.getAttribute("role") === "menuitemradio" && s.getAttribute("aria-checked") === "true"
  );
}, W2 = function() {
  d(this, kd) >= 0 || (this.update(), this.focusActive());
}, iM = function(s) {
  const n = s.target;
  if (Kj(s) && n instanceof Element) {
    const o = n.getAttribute("role");
    return !/a|input|select|button/.test(n.localName) && !o;
  }
  return P8.has(s.key);
}, K2 = function(s) {
  S(this, vn, iM).call(this, s) && (s.stopPropagation(), s.preventDefault());
}, X2 = function(s) {
  if (S(this, vn, iM).call(this, s))
    switch (s.stopPropagation(), s.preventDefault(), s.key) {
      case "Escape":
        d(this, ZT).closeMenu(s);
        break;
      case "Tab":
        S(this, vn, hh).call(this, S(this, vn, Fb).call(this, s.shiftKey ? -1 : 1));
        break;
      case "ArrowUp":
        S(this, vn, hh).call(this, S(this, vn, Fb).call(this, -1));
        break;
      case "ArrowDown":
        S(this, vn, hh).call(this, S(this, vn, Fb).call(this, 1));
        break;
      case "Home":
      case "PageUp":
        S(this, vn, hh).call(this, 0);
        break;
      case "End":
      case "PageDown":
        S(this, vn, hh).call(this, d(this, Oa).length - 1);
        break;
    }
}, Fb = function(s) {
  var o;
  let n = d(this, kd);
  do
    n = (n + s + d(this, Oa).length) % d(this, Oa).length;
  while (((o = d(this, Oa)[n]) == null ? void 0 : o.offsetParent) === null);
  return n;
}, Z2 = function() {
  if (!d(this, Tl)) return [];
  const s = d(this, Tl).querySelectorAll(A8), n = [], o = (h) => h.getAttribute("role") === "menu";
  for (const h of s)
    Zb(h) && h.offsetParent !== null && // does not have display: none
    l_(d(this, Tl), h, o) && n.push(h);
  return n;
};
var N8 = Object.defineProperty, U8 = Object.getOwnPropertyDescriptor, fw = (f, s, n, o) => {
  for (var h = U8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && N8(s, n, h), h;
};
let z8 = 0;
var wl, ny, iy, sa, JT, mo, Gi, xd, Rd, jh, Bh, Bu, Qh, ew, Yh, Ke, J2, eF, tF, nF, iF, rM, rF, ry, aF, aM, sF, rT, lF, oF, uF, cF, dF, fF, T0, hF, ay, w0, pF, E0, mF, sy, ly, vF;
class Dy extends Ci {
  constructor() {
    super();
    R(this, Ke);
    R(this, wl);
    R(this, ny);
    R(this, iy);
    R(this, sa, st(!1));
    R(this, JT, st(!1));
    R(this, mo, st(null));
    R(this, Gi, st(null));
    R(this, xd);
    R(this, Rd, /* @__PURE__ */ new Set());
    R(this, jh, null);
    R(this, Bh);
    R(this, Bu);
    R(this, Qh, !1);
    R(this, ew, st(!1));
    R(this, Yh, /* @__PURE__ */ new Set());
    R(this, ry, !1);
    R(this, T0, S(this, Ke, hF).bind(this));
    R(this, ay, !1);
    R(this, w0, S(this, Ke, pF).bind(this));
    R(this, E0, S(this, Ke, mF).bind(this));
    R(this, sy, Ey(() => {
      const n = ye(d(this, Gi));
      if (!n) return;
      let o = 0, h = getComputedStyle(n), v = [...n.children];
      for (const y of ["paddingTop", "paddingBottom", "borderTopWidth", "borderBottomWidth"])
        o += parseFloat(h[y]) || 0;
      for (const y of v)
        if (Zb(y) && y.style.display === "contents")
          v.push(...y.children);
        else if (y.nodeType === 3)
          o += parseFloat(getComputedStyle(y).fontSize);
        else if (Zb(y)) {
          if (!a_(y)) continue;
          const k = getComputedStyle(y);
          o += y.offsetHeight + (parseFloat(k.marginTop) || 0) + (parseFloat(k.marginBottom) || 0);
        }
      Nd(n, "--menu-height", o + "px");
    }));
    R(this, ly, !1);
    const { showDelay: n } = this.$props;
    L(this, Bh, new d8({
      trigger: d(this, mo),
      content: d(this, Gi),
      showDelay: n,
      listen: (o, h, v) => {
        vy(o, (k) => {
          d(this, sa).call(this) ? v(k) : h(k);
        });
        const y = S(this, Ke, cF).call(this);
        y && vy(y, (k) => {
          k.stopPropagation(), v(k);
        });
      },
      onChange: S(this, Ke, aF).bind(this)
    }));
  }
  get triggerElement() {
    return d(this, mo).call(this);
  }
  get contentElement() {
    return d(this, Gi).call(this);
  }
  get isSubmenu() {
    return !!d(this, xd);
  }
  onSetup() {
    L(this, wl, Ua());
    const n = ++z8;
    L(this, ny, `media-menu-${n}`), L(this, iy, `media-menu-button-${n}`), L(this, Bu, new _8({
      closeMenu: this.close.bind(this)
    })), Jh(Pd) && L(this, xd, Us(Pd)), S(this, Ke, J2).call(this), this.setAttributes({
      "data-open": d(this, sa),
      "data-root": !this.isSubmenu,
      "data-submenu": this.isSubmenu,
      "data-disabled": S(this, Ke, rT).bind(this)
    }), Ju(Pd, {
      button: d(this, mo),
      content: d(this, Gi),
      expanded: d(this, sa),
      hint: st(""),
      submenu: !!d(this, xd),
      disable: S(this, Ke, lF).bind(this),
      attachMenuButton: S(this, Ke, tF).bind(this),
      attachMenuItems: S(this, Ke, nF).bind(this),
      attachObserver: S(this, Ke, iF).bind(this),
      disableMenuButton: S(this, Ke, rF).bind(this),
      addSubmenu: S(this, Ke, fF).bind(this),
      onTransitionEvent: (o) => {
        d(this, Yh).add(o), Wt(() => {
          d(this, Yh).delete(o);
        });
      }
    });
  }
  onAttach(n) {
    n.style.setProperty("display", "contents");
  }
  onConnect(n) {
    var o;
    J(S(this, Ke, eF).bind(this)), this.isSubmenu && ((o = d(this, xd)) == null || o.addSubmenu(this));
  }
  onDestroy() {
    d(this, mo).set(null), d(this, Gi).set(null), L(this, jh, null), d(this, Yh).clear();
  }
  open(n) {
    ye(d(this, sa)) || (d(this, Bh).show(n), Xu());
  }
  close(n) {
    ye(d(this, sa)) && (d(this, Bh).hide(n), Xu());
  }
}
wl = new WeakMap(), ny = new WeakMap(), iy = new WeakMap(), sa = new WeakMap(), JT = new WeakMap(), mo = new WeakMap(), Gi = new WeakMap(), xd = new WeakMap(), Rd = new WeakMap(), jh = new WeakMap(), Bh = new WeakMap(), Bu = new WeakMap(), Qh = new WeakMap(), ew = new WeakMap(), Yh = new WeakMap(), Ke = new WeakSet(), J2 = function() {
  let n = -1, o = Jh(oT) ? Us(oT) : null;
  Ju(oT, {
    onDragStart: () => {
      var h;
      (h = o == null ? void 0 : o.onDragStart) == null || h.call(o), window.clearTimeout(n), n = -1, L(this, Qh, !0);
    },
    onDragEnd: () => {
      var h;
      (h = o == null ? void 0 : o.onDragEnd) == null || h.call(o), n = window.setTimeout(() => {
        L(this, Qh, !1), n = -1;
      }, 300);
    }
  });
}, eF = function() {
  const n = S(this, Ke, sF).call(this);
  this.isSubmenu || d(this, sy).call(this), S(this, Ke, rM).call(this, n), n && (J(() => {
    const { height: o } = d(this, wl).$state, h = d(this, Gi).call(this);
    h && Nd(h, "--player-height", o() + "px");
  }), d(this, Bu).listen(), this.listen("pointerup", S(this, Ke, oF).bind(this)), En(window, "pointerup", S(this, Ke, uF).bind(this)));
}, tF = function(n) {
  const o = n.el, h = this.isSubmenu, v = ap(S(this, Ke, rT).bind(this));
  Wi(o, "tabindex", h ? "-1" : "0"), Wi(o, "role", h ? "menuitem" : "button"), Rt(o, "id", d(this, iy)), Rt(o, "aria-haspopup", "menu"), Rt(o, "aria-expanded", "false"), Rt(o, "data-root", !this.isSubmenu), Rt(o, "data-submenu", this.isSubmenu), J(() => {
    Rt(o, "data-open", d(this, sa).call(this)), Rt(o, "aria-disabled", v());
  }), d(this, mo).set(o), Wt(() => {
    d(this, mo).set(null);
  });
}, nF = function(n) {
  var y;
  const o = n.el;
  o.style.setProperty("display", "none"), Rt(o, "id", d(this, ny)), Wi(o, "role", "menu"), Wi(o, "tabindex", "-1"), Rt(o, "data-root", !this.isSubmenu), Rt(o, "data-submenu", this.isSubmenu), d(this, Gi).set(o), Wt(() => d(this, Gi).set(null)), J(() => Rt(o, "data-open", d(this, sa).call(this))), d(this, Bu).attachMenu(o), S(this, Ke, rM).call(this, !1);
  const v = S(this, Ke, vF).bind(this);
  this.isSubmenu ? (y = d(this, xd)) == null || y.onTransitionEvent(v) : (n.listen("transitionstart", v), n.listen("transitionend", v), n.listen("animationend", d(this, sy)), n.listen("vds-menu-resize", d(this, sy)));
}, iF = function(n) {
  L(this, jh, n);
}, rM = function(n) {
  const o = ye(d(this, Gi));
  o && Rt(o, "aria-hidden", Kb(!n));
}, rF = function(n) {
  d(this, ew).set(n);
}, ry = new WeakMap(), aF = function(n, o) {
  var y, k, D, $, _, A;
  if (L(this, ry, R0(o)), o == null || o.stopPropagation(), d(this, sa).call(this) === n) return;
  if (S(this, Ke, rT).call(this)) {
    n && d(this, Bh).hide(o);
    return;
  }
  (y = this.el) == null || y.dispatchEvent(
    new Event("vds-menu-resize", {
      bubbles: !0,
      composed: !0
    })
  );
  const h = d(this, mo).call(this), v = d(this, Gi).call(this);
  if (h && (Rt(h, "aria-controls", n && d(this, ny)), Rt(h, "aria-expanded", Kb(n))), v && Rt(v, "aria-labelledby", n && d(this, iy)), d(this, sa).set(n), S(this, Ke, dF).call(this, o), Xu(), d(this, ry)) {
    n ? v == null || v.focus() : h == null || h.focus();
    for (const B of [this.el, v])
      B && B.setAttribute("data-keyboard", "");
  } else
    for (const B of [this.el, v])
      B && B.removeAttribute("data-keyboard");
  if (this.dispatch(n ? "open" : "close", { trigger: o }), n)
    !this.isSubmenu && d(this, wl).activeMenu !== this && ((k = d(this, wl).activeMenu) == null || k.close(o), d(this, wl).activeMenu = this), ($ = (D = d(this, jh)) == null ? void 0 : D.onOpen) == null || $.call(D, o);
  else {
    if (this.isSubmenu)
      for (const B of d(this, Rd)) B.close(o);
    else
      d(this, wl).activeMenu = null;
    (A = (_ = d(this, jh)) == null ? void 0 : _.onClose) == null || A.call(_, o);
  }
  n && requestAnimationFrame(S(this, Ke, aM).bind(this));
}, aM = function() {
  d(this, ly) || d(this, ay) || (d(this, Bu).update(), requestAnimationFrame(() => {
    d(this, ry) ? d(this, Bu).focusActive() : d(this, Bu).scroll();
  }));
}, sF = function() {
  return !S(this, Ke, rT).call(this) && d(this, sa).call(this);
}, rT = function() {
  return d(this, JT).call(this) || d(this, ew).call(this);
}, lF = function(n) {
  d(this, JT).set(n);
}, oF = function(n) {
  const o = d(this, Gi).call(this);
  d(this, Qh) || o && HA(o, n) || n.stopPropagation();
}, uF = function(n) {
  const o = d(this, Gi).call(this);
  d(this, Qh) || o && HA(o, n) || this.close(n);
}, cF = function() {
  var o;
  const n = (o = this.el) == null ? void 0 : o.querySelector('[data-part="close-target"]');
  return this.el && n && l_(this.el, n, (h) => h.getAttribute("role") === "menu") ? n : null;
}, dF = function(n) {
  this.isSubmenu || (d(this, sa).call(this) ? d(this, wl).remote.pauseControls(n) : d(this, wl).remote.resumeControls(n));
}, fF = function(n) {
  d(this, Rd).add(n), new gn(n).add("open", d(this, w0)).add("close", d(this, E0)), Wt(d(this, T0));
}, T0 = new WeakMap(), hF = function(n) {
  d(this, Rd).delete(n);
}, ay = new WeakMap(), w0 = new WeakMap(), pF = function(n) {
  var h;
  L(this, ay, !0);
  const o = d(this, Gi).call(this);
  this.isSubmenu && ((h = this.triggerElement) == null || h.setAttribute("aria-hidden", "true"));
  for (const v of d(this, Rd))
    if (v !== n.target)
      for (const y of [v.el, v.triggerElement])
        y == null || y.setAttribute("aria-hidden", "true");
  if (o) {
    const v = n.target.el;
    for (const y of o.children)
      y.contains(v) ? y.setAttribute("data-open", "") : y !== v && y.setAttribute("data-hidden", "");
  }
}, E0 = new WeakMap(), mF = function(n) {
  var h;
  L(this, ay, !1);
  const o = d(this, Gi).call(this);
  this.isSubmenu && ((h = this.triggerElement) == null || h.setAttribute("aria-hidden", "false"));
  for (const v of d(this, Rd))
    for (const y of [v.el, v.triggerElement])
      y == null || y.setAttribute("aria-hidden", "false");
  if (o)
    for (const v of o.children)
      v.removeAttribute("data-open"), v.removeAttribute("data-hidden");
}, sy = new WeakMap(), ly = new WeakMap(), vF = function(n) {
  const o = d(this, Gi).call(this);
  o && n.propertyName === "height" && (L(this, ly, n.type === "transitionstart"), Rt(o, "data-transition", d(this, ly) ? "height" : null), d(this, sa).call(this) && S(this, Ke, aM).call(this));
  for (const h of d(this, Yh)) h(n);
}, Z(Dy, "props", {
  showDelay: 0
});
fw([
  rn
], Dy.prototype, "triggerElement");
fw([
  rn
], Dy.prototype, "contentElement");
fw([
  rn
], Dy.prototype, "isSubmenu");
fw([
  Zi
], Dy.prototype, "open");
fw([
  Zi
], Dy.prototype, "close");
var F8 = Object.defineProperty, V8 = Object.getOwnPropertyDescriptor, H8 = (f, s, n, o) => {
  for (var h = V8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && F8(s, n, h), h;
}, Dd, tw, tc, gF, SF, sM;
class yF extends Ci {
  constructor() {
    super();
    R(this, tc);
    R(this, Dd);
    R(this, tw, st(null));
    new dw();
  }
  get expanded() {
    var n;
    return ((n = d(this, Dd)) == null ? void 0 : n.expanded()) ?? !1;
  }
  onSetup() {
    L(this, Dd, Us(Pd));
  }
  onAttach(n) {
    d(this, Dd).attachMenuButton(this), J(S(this, tc, gF).bind(this)), Wi(n, "type", "button");
  }
  onConnect(n) {
    J(S(this, tc, SF).bind(this)), S(this, tc, sM).call(this);
    const o = new MutationObserver(S(this, tc, sM).bind(this));
    o.observe(n, { attributeFilter: ["data-part"], childList: !0, subtree: !0 }), Wt(() => o.disconnect()), vy(n, (h) => {
      this.dispatch("select", { trigger: h });
    });
  }
}
Dd = new WeakMap(), tw = new WeakMap(), tc = new WeakSet(), gF = function() {
  d(this, Dd).disableMenuButton(this.$props.disabled());
}, SF = function() {
  const n = d(this, tw).call(this);
  n && J(() => {
    const o = d(this, Dd).hint();
    o && (n.textContent = o);
  });
}, sM = function() {
  var o;
  const n = (o = this.el) == null ? void 0 : o.querySelector('[data-part="hint"]');
  d(this, tw).set(n ?? null);
}, Z(yF, "props", {
  disabled: !1
});
H8([
  rn
], yF.prototype, "expanded");
const lM = Cy();
var Qu, Md, bM, Fs, wF, EF, C0, oM, uM;
class TF extends Hs {
  constructor() {
    super(...arguments);
    R(this, Fs);
    R(this, Qu, /* @__PURE__ */ new Set());
    R(this, Md, st(""));
    R(this, bM, null);
    Z(this, "onValueChange");
    R(this, C0, S(this, Fs, oM).bind(this));
  }
  get values() {
    return Array.from(d(this, Qu)).map((n) => n.value());
  }
  get value() {
    return d(this, Md).call(this);
  }
  set value(n) {
    S(this, Fs, oM).call(this, n);
  }
  onSetup() {
    Ju(lM, {
      add: S(this, Fs, wF).bind(this),
      remove: S(this, Fs, EF).bind(this)
    });
  }
  onAttach(n) {
    Jh(Pd) || Wi(n, "role", "radiogroup"), this.setAttributes({ value: d(this, Md) });
  }
  onDestroy() {
    d(this, Qu).clear();
  }
}
Qu = new WeakMap(), Md = new WeakMap(), bM = new WeakMap(), Fs = new WeakSet(), wF = function(n) {
  d(this, Qu).has(n) || (d(this, Qu).add(n), n.onCheck = d(this, C0), n.check(n.value() === d(this, Md).call(this)));
}, EF = function(n) {
  n.onCheck = null, d(this, Qu).delete(n);
}, C0 = new WeakMap(), oM = function(n, o) {
  var k;
  const h = ye(d(this, Md));
  if (!n || n === h) return;
  const v = S(this, Fs, uM).call(this, h), y = S(this, Fs, uM).call(this, n);
  v == null || v.check(!1, o), y == null || y.check(!0, o), d(this, Md).set(n), (k = this.onValueChange) == null || k.call(this, n, o);
}, uM = function(n) {
  for (const o of d(this, Qu))
    if (n === ye(o.value)) return o;
  return null;
};
var I8 = Object.defineProperty, q8 = Object.getOwnPropertyDescriptor, CF = (f, s, n, o) => {
  for (var h = q8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && I8(s, n, h), h;
}, Yu, Sy, bF, kF;
class QM extends Ci {
  constructor() {
    super();
    R(this, Sy);
    R(this, Yu);
    L(this, Yu, new TF()), d(this, Yu).onValueChange = S(this, Sy, kF).bind(this);
  }
  get values() {
    return d(this, Yu).values;
  }
  get value() {
    return d(this, Yu).value;
  }
  set value(n) {
    d(this, Yu).value = n;
  }
  onSetup() {
    J(S(this, Sy, bF).bind(this));
  }
}
Yu = new WeakMap(), Sy = new WeakSet(), bF = function() {
  d(this, Yu).value = this.$props.value();
}, kF = function(n, o) {
  const h = this.createEvent("change", { detail: n, trigger: o });
  this.dispatch(h);
}, Z(QM, "props", {
  value: ""
});
CF([
  rn
], QM.prototype, "values");
CF([
  rn
], QM.prototype, "value");
var j8 = Object.defineProperty, B8 = Object.getOwnPropertyDescriptor, Q8 = (f, s, n, o) => {
  for (var h = B8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && j8(s, n, h), h;
}, vo, Gh, Tr, RF, DF, MF, LF, $F, cM, OF;
class xF extends Ci {
  constructor() {
    super();
    R(this, Tr);
    R(this, vo, st(!1));
    R(this, Gh, {
      value: this.$props.value,
      check: S(this, Tr, $F).bind(this),
      onCheck: null
    });
    new dw();
  }
  get checked() {
    return d(this, vo).call(this);
  }
  onSetup() {
    this.setAttributes({
      value: this.$props.value,
      "data-checked": d(this, vo),
      "aria-checked": ap(d(this, vo))
    });
  }
  onAttach(n) {
    const o = Jh(Pd);
    Wi(n, "tabindex", o ? "-1" : "0"), Wi(n, "role", o ? "menuitemradio" : "radio"), J(S(this, Tr, MF).bind(this));
  }
  onConnect(n) {
    S(this, Tr, DF).call(this), vy(n, S(this, Tr, LF).bind(this)), Wt(S(this, Tr, RF).bind(this));
  }
}
vo = new WeakMap(), Gh = new WeakMap(), Tr = new WeakSet(), RF = function() {
  Cl(() => {
    Us(lM).remove(d(this, Gh));
  }, this.connectScope);
}, DF = function() {
  Us(lM).add(d(this, Gh));
}, MF = function() {
  var h, v;
  const { value: n } = this.$props, o = n();
  ye(d(this, vo)) && ((v = (h = d(this, Gh)).onCheck) == null || v.call(h, o));
}, LF = function(n) {
  var o, h;
  ye(d(this, vo)) || (S(this, Tr, cM).call(this, !0, n), S(this, Tr, OF).call(this, n), (h = (o = d(this, Gh)).onCheck) == null || h.call(o, ye(this.$props.value), n));
}, $F = function(n, o) {
  ye(d(this, vo)) !== n && S(this, Tr, cM).call(this, n, o);
}, cM = function(n, o) {
  d(this, vo).set(n), this.dispatch("change", { detail: n, trigger: o });
}, OF = function(n) {
  this.dispatch("select", { trigger: n });
}, Z(xF, "props", {
  value: ""
});
Q8([
  rn
], xF.prototype, "checked");
var Y8 = Object.defineProperty, G8 = Object.getOwnPropertyDescriptor, YM = (f, s, n, o) => {
  for (var h = G8(s, n), v = f.length - 1, y; v >= 0; v--)
    (y = f[v]) && (h = y(s, n, h) || h);
  return h && Y8(s, n, h), h;
};
const AF = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
var Ld, oy, Wh, Vs, PF, _F, NF, UF, zF;
class _0 extends Ci {
  constructor() {
    super();
    R(this, Vs);
    R(this, Ld);
    R(this, oy);
    R(this, Wh);
    L(this, Wh, new TF()), d(this, Wh).onValueChange = S(this, Vs, zF).bind(this);
  }
  get value() {
    return d(this, Wh).value;
  }
  get disabled() {
    const { rates: n } = this.$props, { canSetPlaybackRate: o } = d(this, Ld).$state;
    return !o() || n().length === 0;
  }
  onSetup() {
    L(this, Ld, Ua()), Jh(Pd) && L(this, oy, Us(Pd));
  }
  onConnect(n) {
    J(S(this, Vs, PF).bind(this)), J(S(this, Vs, _F).bind(this)), J(S(this, Vs, NF).bind(this));
  }
  getOptions() {
    const { rates: n, normalLabel: o } = this.$props;
    return n().map((h) => ({
      label: h === 1 ? o : h + "×",
      value: h.toString()
    }));
  }
}
Ld = new WeakMap(), oy = new WeakMap(), Wh = new WeakMap(), Vs = new WeakSet(), PF = function() {
  d(this, Wh).value = S(this, Vs, UF).call(this);
}, _F = function() {
  var v;
  const { normalLabel: n } = this.$props, { playbackRate: o } = d(this, Ld).$state, h = o();
  (v = d(this, oy)) == null || v.hint.set(h === 1 ? n() : h + "×");
}, NF = function() {
  var n;
  (n = d(this, oy)) == null || n.disable(this.disabled);
}, UF = function() {
  const { playbackRate: n } = d(this, Ld).$state;
  return n().toString();
}, zF = function(n, o) {
  if (this.disabled) return;
  const h = +n;
  d(this, Ld).remote.changePlaybackRate(h, o), this.dispatch("change", { detail: h, trigger: o });
}, Z(_0, "props", {
  normalLabel: "Normal",
  rates: AF
});
YM([
  rn
], _0.prototype, "value");
YM([
  rn
], _0.prototype, "disabled");
YM([
  Zi
], _0.prototype, "getOptions");
var uy, Gu, Wu, nw, dM;
class W8 {
  constructor(s) {
    R(this, nw);
    Z(this, "priority", 10);
    R(this, uy, null);
    R(this, Gu);
    R(this, Wu);
    L(this, Gu, s);
  }
  attach() {
  }
  canRender() {
    return !0;
  }
  detach() {
    var s;
    (s = d(this, Wu)) == null || s.abort(), L(this, Wu, void 0), d(this, Gu).reset(), L(this, uy, null);
  }
  changeTrack(s) {
    var n;
    !s || d(this, uy) === s || ((n = d(this, Wu)) == null || n.abort(), L(this, Wu, new gn(s)), s.readyState < 2 ? (d(this, Gu).reset(), d(this, Wu).add("load", () => S(this, nw, dM).call(this, s), { once: !0 })) : S(this, nw, dM).call(this, s), d(this, Wu).add("add-cue", (o) => {
      d(this, Gu).addCue(o.detail);
    }).add("remove-cue", (o) => {
      d(this, Gu).removeCue(o.detail);
    }), L(this, uy, s));
  }
}
uy = new WeakMap(), Gu = new WeakMap(), Wu = new WeakMap(), nw = new WeakSet(), dM = function(s) {
  d(this, Gu).changeTrack({
    cues: [...s.cues],
    regions: [...s.regions]
  });
};
var as, Aa, ut, Vb, FF, VF, HF, fM, IF, qF, jF, BF, hM, QF, YF, Ku, pM, Hb, mM, vM;
let K8 = (as = class extends Ci {
  constructor() {
    super(...arguments);
    R(this, ut);
    R(this, Aa);
    R(this, Ku, -1);
  }
  onSetup() {
    L(this, Aa, Ua()), this.setAttributes({
      "aria-hidden": ap(S(this, ut, Vb).bind(this))
    });
  }
  onAttach(n) {
    n.style.setProperty("pointer-events", "none");
  }
  onConnect(n) {
    as.lib() || import("./dev-D3SS6qhA.js").then((o) => o.d).then((o) => as.lib.set(o)), J(S(this, ut, FF).bind(this));
  }
}, Aa = new WeakMap(), ut = new WeakSet(), Vb = function() {
  const { textTrack: n, remotePlaybackState: o, iOSControls: h } = d(this, Aa).$state, v = n();
  return h() || o() === "connected" || !v || !_a(v);
}, FF = function() {
  if (!as.lib()) return;
  const { viewType: n } = d(this, Aa).$state;
  return n() === "audio" ? S(this, ut, VF).call(this) : S(this, ut, qF).call(this);
}, VF = function() {
  return J(S(this, ut, HF).bind(this)), S(this, ut, hM).call(this, null), () => {
    this.el.textContent = "";
  };
}, HF = function() {
  if (S(this, ut, Vb).call(this)) return;
  S(this, ut, fM).call(this);
  const { textTrack: n } = d(this, Aa).$state;
  En(n(), "cue-change", S(this, ut, fM).bind(this)), J(S(this, ut, IF).bind(this));
}, fM = function() {
  this.el.textContent = "", d(this, Ku) >= 0 && S(this, ut, Hb).call(this);
  const { realCurrentTime: n, textTrack: o } = d(this, Aa).$state, { renderVTTCueString: h } = as.lib(), v = ye(n), y = ye(o).activeCues;
  for (const k of y) {
    const D = S(this, ut, mM).call(this), $ = S(this, ut, vM).call(this);
    $.innerHTML = h(k, v), D.append($), this.el.append($);
  }
}, IF = function() {
  const { realCurrentTime: n } = d(this, Aa).$state, { updateTimedVTTCueNodes: o } = as.lib();
  o(this.el, n());
}, qF = function() {
  const { CaptionsRenderer: n } = as.lib(), o = new n(this.el), h = new W8(o);
  return d(this, Aa).textRenderers.add(h), J(S(this, ut, jF).bind(this, o)), J(S(this, ut, BF).bind(this, o)), S(this, ut, hM).call(this, o), () => {
    this.el.textContent = "", d(this, Aa).textRenderers.remove(h), o.destroy();
  };
}, jF = function(n) {
  n.dir = this.$props.textDir();
}, BF = function(n) {
  var v;
  if (S(this, ut, Vb).call(this)) return;
  const { realCurrentTime: o, textTrack: h } = d(this, Aa).$state;
  n.currentTime = o(), d(this, Ku) >= 0 && ((v = h()) != null && v.activeCues[0]) && S(this, ut, Hb).call(this);
}, hM = function(n) {
  const o = d(this, Aa).player;
  if (!o) return;
  const h = S(this, ut, QF).bind(this, n);
  En(o, "vds-font-change", h);
}, QF = function(n) {
  var h;
  if (d(this, Ku) >= 0) {
    S(this, ut, pM).call(this);
    return;
  }
  const { textTrack: o } = d(this, Aa).$state;
  (h = o()) != null && h.activeCues[0] ? n == null || n.update(!0) : S(this, ut, YF).call(this);
}, YF = function() {
  var h, v;
  const n = S(this, ut, mM).call(this);
  Rt(n, "data-example", "");
  const o = S(this, ut, vM).call(this);
  Rt(o, "data-example", ""), o.textContent = this.$props.exampleText(), n == null || n.append(o), (h = this.el) == null || h.append(n), (v = this.el) == null || v.setAttribute("data-example", ""), S(this, ut, pM).call(this);
}, Ku = new WeakMap(), pM = function() {
  window.clearTimeout(d(this, Ku)), L(this, Ku, window.setTimeout(S(this, ut, Hb).bind(this), 2500));
}, Hb = function() {
  var n, o;
  (n = this.el) == null || n.removeAttribute("data-example"), (o = this.el) != null && o.querySelector("[data-example]") && (this.el.textContent = ""), L(this, Ku, -1);
}, mM = function() {
  const n = document.createElement("div");
  return Rt(n, "data-part", "cue-display"), n;
}, vM = function() {
  const n = document.createElement("div");
  return Rt(n, "data-part", "cue"), n;
}, Z(as, "props", {
  textDir: "ltr",
  exampleText: "Captions look like this."
}), Z(as, "lib", st(null)), as);
var Eb, cy, $d, iw, rw, Ei, GF, WF, KF, yM, XF, ZF, gM, JF;
let X8 = (Eb = class extends Ci {
  constructor() {
    super(...arguments);
    R(this, Ei);
    R(this, cy);
    R(this, $d, st(null));
    R(this, iw, st(!0));
    R(this, rw, st(!0));
  }
  onSetup() {
    L(this, cy, Ua()), S(this, Ei, yM).call(this);
    const { type: n } = this.$props;
    this.setAttributes({
      "data-type": n,
      "data-remainder": S(this, Ei, gM).bind(this)
    }), new vz({
      callback: S(this, Ei, GF).bind(this)
    }).attach(this);
  }
  onAttach(n) {
    n.hasAttribute("role") || J(S(this, Ei, XF).bind(this)), J(S(this, Ei, yM).bind(this));
  }
  onConnect(n) {
    Wt(s_(n, d(this, iw).set)), J(S(this, Ei, WF).bind(this)), J(S(this, Ei, KF).bind(this));
  }
}, cy = new WeakMap(), $d = new WeakMap(), iw = new WeakMap(), rw = new WeakMap(), Ei = new WeakSet(), GF = function(n) {
  d(this, rw).set(n[0].isIntersecting);
}, WF = function() {
  const { hidden: n } = this.$props;
  this.$state.hidden.set(n() || !d(this, iw).call(this) || !d(this, rw).call(this));
}, KF = function() {
  if (!this.$props.toggle()) {
    d(this, $d).set(null);
    return;
  }
  this.el && vy(this.el, S(this, Ei, JF).bind(this));
}, yM = function() {
  const { hidden: n, timeText: o } = this.$state, { duration: h } = d(this, cy).$state;
  if (n()) return;
  const { type: v, padHours: y, padMinutes: k, showHours: D } = this.$props, $ = S(this, Ei, ZF).call(this, v()), _ = h(), A = S(this, Ei, gM).call(this);
  if (!Number.isFinite($ + _)) {
    o.set("LIVE");
    return;
  }
  const B = A ? Math.max(0, _ - $) : $, W = qM(B, {
    padHrs: y(),
    padMins: k(),
    showHrs: D()
  });
  o.set((A ? "-" : "") + W);
}, XF = function() {
  if (!this.el) return;
  const { toggle: n } = this.$props;
  Rt(this.el, "role", n() ? "timer" : null), Rt(this.el, "tabindex", n() ? 0 : null);
}, ZF = function(n) {
  const { bufferedEnd: o, duration: h, currentTime: v } = d(this, cy).$state;
  switch (n) {
    case "buffered":
      return o();
    case "duration":
      return h();
    default:
      return v();
  }
}, gM = function() {
  return this.$props.remainder() && d(this, $d).call(this) !== !1;
}, JF = function(n) {
  if (n.preventDefault(), d(this, $d).call(this) === null) {
    d(this, $d).set(!this.$props.remainder());
    return;
  }
  d(this, $d).set((o) => !o);
}, Z(Eb, "props", {
  type: "current",
  showHours: !1,
  padHours: null,
  padMinutes: null,
  remainder: !1,
  toggle: !1,
  hidden: !1
}), Z(Eb, "state", new by({
  timeText: "",
  hidden: !1
})), Eb);
class GM extends n8 {
}
class Z8 extends sz {
}
class J8 extends m8 {
}
class eV extends tp {
}
class e6 extends r0 {
}
class t6 extends GD {
}
class n6 extends S8 {
}
class i6 extends BM {
}
class r6 extends i0 {
}
class a6 extends o2 {
}
class s6 extends Ry {
}
class l6 extends K8 {
}
class o6 extends X8 {
}
const N0 = ue.createContext({ current: null });
N0.displayName = "Scope";
function u6(f, ...s) {
  return ue.createElement(N0.Provider, { value: f }, ...s);
}
function c6() {
  return ue.useContext(N0).current;
}
function tV(f) {
  const s = c6();
  return ue.useMemo(() => RM(f.id, s), [s]);
}
function nV(f, s) {
  typeof f == "function" ? f(s) : f && (f.current = s);
}
function Hd(...f) {
  return (s) => f.forEach((n) => nV(n, s));
}
function d6(f, s) {
  const n = ue.forwardRef((o, h) => {
    var Re, Lt, $t, Ve, ct, Ye, Tt, He;
    let v = ue.useContext(N0), y = ue.useRef(null), k = ue.useRef();
    if (!k.current) {
      const de = h6(), Ge = sP(f, de, o, v.current);
      de.component = Ge, k.current = de, y.current = Ge.scope;
    }
    function D() {
      let de = k.current, Ge = v.current;
      if (window.cancelAnimationFrame(de.destroyId), de.destroyId = -1, de.component.$$.destroyed) {
        const ft = sP(f, de, o, Ge);
        de.component = ft, de.attached = !1, de.forwardRef = !1, y.current = ft.scope;
      }
      return de.el && aP(de, de.el), de.forwardRef || (nV(h, de.component), de.forwardRef = !0), () => Ib(de);
    }
    function $(de) {
      const Ge = k.current;
      if (!Ge.forwardRef) {
        Ge.el = de;
        return;
      }
      window.cancelAnimationFrame(Ge.refChangeId), Ge.refChangeId = window.requestAnimationFrame(() => {
        const ft = k.current;
        ft.refChangeId = -1, ft.el !== de && (Ib(ft), de && aP(ft, de), ft.el = de);
      });
    }
    ue.useEffect(() => {
      const de = k.current;
      return window.cancelAnimationFrame(de.destroyId), de.destroyId = -1, function() {
        ls(o.children) && (window.cancelAnimationFrame(de.refChangeId), de.refChangeId = -1, window.cancelAnimationFrame(de.connectId), de.connectId = -1, window.cancelAnimationFrame(de.destroyId), de.destroyId = window.requestAnimationFrame(() => {
          de.destroyId = -1, Ib(de), de.component.$$.destroy(), de.component.$$[M0] = null, de.callbacks = {}, de.domCallbacks = {}, y.current = null;
        }));
      };
    }, []), ue.useEffect(Xu);
    let _ = k.current, { children: A, ...B } = o, W = {}, ne = _.prevProps, ce = Object.keys(B);
    _.callbacks = {};
    for (const de of [...ne, ...ce])
      if (s.props.has(de))
        _.component.$props[de].set(
          // If the prop was removed we'll use the default value provided on Component creation.
          pi(B[de]) ? (Re = f.props) == null ? void 0 : Re[de] : B[de]
        );
      else if ((Lt = s.events) != null && Lt.has(de) || ($t = s.eventsRE) != null && $t.test(de))
        _.callbacks[de] = B[de];
      else if ((Ve = s.domEvents) != null && Ve.has(de) || (ct = s.domEventsRE) != null && ct.test(de)) {
        let Ge = D0(de.slice(2));
        _.domCallbacks[Ge] = B[de], ce.includes(de) ? _.el && !((He = _.listening) != null && He.has(Ge)) && (_.listening || (_.listening = /* @__PURE__ */ new Set()), _.listening.add(Ge), _.el.addEventListener(Ge, _.onDOMEvent)) : ((Ye = _.el) == null || Ye.removeEventListener(Ge, _.onDOMEvent), (Tt = _.listening) == null || Tt.delete(Ge));
      } else
        W[de] = B[de];
    return _.prevProps = ce, u6(
      y,
      ue.createElement(f6, {
        effect: D
      }),
      ls(A) ? A == null ? void 0 : A(
        {
          ...W,
          suppressHydrationWarning: !0,
          ref: $
        },
        _.component
      ) : A
    );
  });
  return n.displayName = f.name + "Bridge", n;
}
function f6({ effect: f }) {
  return ue.useEffect(f, []), null;
}
const rP = /* @__PURE__ */ new Map();
function h6() {
  const f = {
    el: null,
    prevProps: [],
    callbacks: {},
    domCallbacks: {},
    refChangeId: -1,
    connectId: -1,
    destroyId: -1,
    attached: !1,
    forwardRef: !1,
    listening: null,
    onDOMEvent(s) {
      var o, h;
      const n = pi(s.detail) ? [s] : [s.detail, s];
      (h = (o = f.domCallbacks)[s.type]) == null || h.call(o, ...n);
    }
  };
  return f;
}
function aP(f, s) {
  if (!(f.el === s && f.attached)) {
    if (f.attached && Ib(f), f.domCallbacks) {
      f.listening || (f.listening = /* @__PURE__ */ new Set());
      for (const n of Object.keys(f.domCallbacks))
        f.listening.has(n) || (s.addEventListener(n, f.onDOMEvent), f.listening.add(n));
    }
    f.component.$$.attach(s), f.connectId = window.requestAnimationFrame(() => {
      f.component.$$.connect(), f.connectId = -1;
    }), f.attached = !0;
  }
}
function Ib(f) {
  if (f.attached && (window.cancelAnimationFrame(f.connectId), f.connectId = -1, f.component.$$.detach(), f.attached = !1, f.el && f.listening)) {
    for (const s of f.listening)
      f.el.removeEventListener(s, f.onDOMEvent);
    f.listening.clear();
  }
}
function p6(f) {
  var o, h;
  let s = rP.get(f.type), n = pi(f.detail) ? [f] : [f.detail, f];
  s || rP.set(f.type, s = `on${Zj(f.type)}`), (h = (o = this.callbacks)[s]) == null || h.call(o, ...n);
}
function sP(f, s, n, o) {
  const h = lB(f, { props: n, scope: o });
  return h.$$[M0] = p6.bind(s), h.$$.setup(), h;
}
function hw(f) {
  return tV(f);
}
function Dn(f, s) {
  const [, n] = ue.useState();
  return ue.useEffect(() => FP(() => {
    f(), n({});
  }), [s ?? f]), f();
}
function m6(f) {
  const [, s] = ue.useState(), n = ue.useRef(null);
  return n.current == null && (n.current = {
    state: {},
    $update: st({}),
    props: /* @__PURE__ */ new Set()
  }), ue.useEffect(() => {
    let { state: o, $update: h, props: v } = n.current;
    return J(() => {
      for (const y of v) {
        const k = f[y]();
        o[y] = Vr(k) ? [...k] : k;
      }
      h(), s({});
    });
  }, [f]), ue.useMemo(() => {
    let { state: o, $update: h, props: v } = n.current, y = !1;
    return v.clear(), new Proxy(o, {
      get(k, D) {
        if (!v.has(D) && D in f) {
          v.add(D);
          const $ = f[D]();
          o[D] = Vr($) ? [...$] : $, y || (h.set({}), y = !0, queueMicrotask(() => y = !1));
        }
        return o[D];
      },
      set(k, D, $) {
        return D in f || (o[D] = $), !0;
      }
    });
  }, [f]);
}
function cs(f, s) {
  return d6(f, {
    props: new Set(Object.keys(f.props || {})),
    events: new Set(s == null ? void 0 : s.events),
    eventsRE: s == null ? void 0 : s.eventsRegex,
    domEvents: s == null ? void 0 : s.domEvents,
    domEventsRE: s == null ? void 0 : s.domEventsRegex
  });
}
const v6 = [
  "onAbort",
  "onAudioTrackChange",
  "onAudioTracksChange",
  "onAutoPlay",
  "onAutoPlayChange",
  "onAutoPlayFail",
  "onCanLoad",
  "onCanPlay",
  "onCanPlayThrough",
  "onControlsChange",
  "onDestroy",
  "onDurationChange",
  "onEmptied",
  "onEnd",
  "onEnded",
  "onError",
  "onFindMediaPlayer",
  "onFullscreenChange",
  "onFullscreenError",
  "onLiveChange",
  "onLiveEdgeChange",
  "onLoadedData",
  "onLoadedMetadata",
  "onLoadStart",
  "onLoopChange",
  "onOrientationChange",
  "onPause",
  "onPictureInPictureChange",
  "onPictureInPictureError",
  "onPlay",
  "onPlayFail",
  "onPlaying",
  "onPlaysInlineChange",
  "onPosterChange",
  "onProgress",
  "onProviderChange",
  "onProviderLoaderChange",
  "onProviderSetup",
  "onQualitiesChange",
  "onQualityChange",
  "onRateChange",
  "onReplay",
  "onSeeked",
  "onSeeking",
  "onSourceChange",
  "onSourceChange",
  "onStalled",
  "onStarted",
  "onStreamTypeChange",
  "onSuspend",
  "onTextTrackChange",
  "onTextTracksChange",
  "onTimeUpdate",
  "onTitleChange",
  "onVdsLog",
  "onVideoPresentationChange",
  "onVolumeChange",
  "onWaiting"
], iV = ue.forwardRef((f, s) => {
  const { children: n, ...o } = f, h = ue.Children.toArray(n), v = h.find(g6);
  if (v) {
    const y = v.props.children, k = h.map((D) => D === v ? ue.Children.count(y) > 1 ? ue.Children.only(null) : ue.isValidElement(y) ? y.props.children : null : D);
    return /* @__PURE__ */ lt(SM, { ...o, ref: s, children: ue.isValidElement(y) ? ue.cloneElement(y, void 0, k) : null });
  }
  return /* @__PURE__ */ lt(SM, { ...o, ref: s, children: n });
});
iV.displayName = "Slot";
const SM = ue.forwardRef((f, s) => {
  const { children: n, ...o } = f;
  return ue.isValidElement(n) ? ue.cloneElement(n, {
    ...S6(o, n.props),
    ref: s ? Hd(s, n.ref) : n.ref
  }) : ue.Children.count(n) > 1 ? ue.Children.only(null) : null;
});
SM.displayName = "SlotClone";
const y6 = ({ children: f }) => /* @__PURE__ */ lt(xj, { children: f });
function g6(f) {
  return ue.isValidElement(f) && f.type === y6;
}
function S6(f, s) {
  const n = { ...s };
  for (const o in s) {
    const h = f[o], v = s[o];
    /^on[A-Z]/.test(o) ? h && v ? n[o] = (...k) => {
      v(...k), h(...k);
    } : h && (n[o] = h) : o === "style" ? n[o] = { ...h, ...v } : o === "className" && (n[o] = [h, v].filter(Boolean).join(" "));
  }
  return { ...f, ...n };
}
const T6 = ["button", "div", "span", "img", "video", "audio"], Ji = T6.reduce((f, s) => {
  const n = ue.forwardRef((o, h) => {
    const { asChild: v, ...y } = o;
    return /* @__PURE__ */ lt(v ? iV : s, { ...y, ref: h });
  });
  return n.displayName = `Primitive.${s}`, { ...f, [s]: n };
}, {}), w6 = cs(GM, {
  events: v6,
  eventsRegex: /^onHls/,
  domEventsRegex: /^onMedia/
}), E6 = ue.forwardRef(
  ({ aspectRatio: f, children: s, ...n }, o) => /* @__PURE__ */ lt(
    w6,
    {
      ...n,
      src: n.src,
      ref: o,
      style: {
        aspectRatio: f,
        ...n.style
      },
      children: (h) => /* @__PURE__ */ lt(Ji.div, { ...h, children: s })
    }
  )
);
E6.displayName = "MediaPlayer";
function sp() {
  return tV(UM);
}
const rV = /* @__PURE__ */ ue.forwardRef((f, s) => {
  const { width: n, height: o, size: h = null, paths: v, ...y } = f;
  return ue.createElement("svg", {
    viewBox: "0 0 32 32",
    ...y,
    width: n ?? h,
    height: o ?? h,
    fill: "none",
    "aria-hidden": "true",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    ref: s,
    dangerouslySetInnerHTML: { __html: v }
  });
});
rV.displayName = "VidstackIcon";
function C6(f) {
  return (f == null ? void 0 : f.$$PROVIDER_TYPE) === "REMOTION";
}
const b6 = cs(Z8), k6 = ue.forwardRef(
  ({ loaders: f = [], children: s, iframeProps: n, mediaProps: o, ...h }, v) => {
    const y = ue.useMemo(() => f.map((k) => new k()), f);
    return /* @__PURE__ */ lt(b6, { ...h, loaders: y, ref: v, children: (k, D) => /* @__PURE__ */ hy("div", { ...k, children: [
      /* @__PURE__ */ lt(aV, { provider: D, mediaProps: o, iframeProps: n }),
      s
    ] }) });
  }
);
k6.displayName = "MediaProvider";
function aV({ provider: f, mediaProps: s, iframeProps: n }) {
  const { sources: o, crossOrigin: h, poster: v, remotePlaybackInfo: y, nativeControls: k, viewType: D } = hw(xy), { loader: $ } = f.$state, { $provider: _, $providerSetup: A } = sp(), B = Dn(o), W = Dn(k), ne = Dn(h), ce = Dn(v), Re = Dn($), Lt = Dn(_), $t = Dn(A), Ve = Dn(y), ct = Re == null ? void 0 : Re.mediaType(), Ye = Dn(D), Tt = Ye === "audio", He = (Re == null ? void 0 : Re.name) === "youtube", de = (Re == null ? void 0 : Re.name) === "vimeo", Ge = He || de, ft = (Re == null ? void 0 : Re.name) === "remotion", Kt = (Re == null ? void 0 : Re.name) === "google-cast", [Mt, Ae] = ue.useState(""), [wt, Sn] = ue.useState(!1);
  return ue.useEffect(() => {
    !Kt || Mt || import("./chromecast-fcYiHsj5.js").then((Je) => {
      Ae(Je.default);
    });
  }, [Kt]), ue.useEffect(() => {
    Sn(!0);
  }, []), Kt ? /* @__PURE__ */ hy(
    "div",
    {
      className: "vds-google-cast",
      ref: (Je) => {
        f.load(Je);
      },
      children: [
        /* @__PURE__ */ lt(rV, { paths: Mt }),
        Ve != null && Ve.deviceName ? /* @__PURE__ */ hy("span", { className: "vds-google-cast-info", children: [
          "Google Cast on",
          " ",
          /* @__PURE__ */ lt("span", { className: "vds-google-cast-device-name", children: Ve.deviceName })
        ] }) : null
      ]
    }
  ) : ft ? /* @__PURE__ */ lt("div", { "data-remotion-canvas": !0, children: /* @__PURE__ */ lt(
    "div",
    {
      "data-remotion-container": !0,
      ref: (Je) => {
        f.load(Je);
      },
      children: C6(Lt) && $t ? ue.createElement(Lt.render) : null
    }
  ) }) : Ge ? ue.createElement(
    ue.Fragment,
    null,
    ue.createElement("iframe", {
      ...n,
      className: (n != null && n.className ? `${n.className} ` : "") + He ? "vds-youtube" : "vds-vimeo",
      suppressHydrationWarning: !0,
      tabIndex: W ? void 0 : -1,
      "aria-hidden": "true",
      "data-no-controls": W ? void 0 : "",
      ref(Je) {
        f.load(Je);
      }
    }),
    !W && !Tt ? ue.createElement("div", { className: "vds-blocker" }) : null
  ) : ct ? ue.createElement(ct === "audio" ? "audio" : "video", {
    ...s,
    controls: W ? !0 : null,
    crossOrigin: typeof ne == "boolean" ? "" : ne,
    poster: ct === "video" && W && ce ? ce : null,
    suppressHydrationWarning: !0,
    children: wt ? null : B.map(
      ({ src: Je, type: ot }) => Ze(Je) ? /* @__PURE__ */ lt("source", { src: Je, type: ot !== "?" ? ot : void 0 }, Je) : null
    ),
    ref(Je) {
      f.load(Je);
    }
  }) : null;
}
aV.displayName = "MediaOutlet";
function x6(f) {
  const s = sp(), n = ue.useMemo(() => new Ud(f), Object.values(f));
  return ue.useEffect(() => (s.textTracks.add(n), () => void s.textTracks.remove(n)), [n]), n;
}
function R6({ lang: f, ...s }) {
  return x6({ language: f, ...s }), null;
}
R6.displayName = "Track";
const D6 = cs(J8, {
  domEventsRegex: /^onMedia/
}), M6 = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(D6, { ...s, children: (o) => /* @__PURE__ */ lt(
    Ji.button,
    {
      ...o,
      ref: Hd(o.ref, n),
      children: f
    }
  ) })
);
M6.displayName = "FullscreenButton";
const lP = eV.state.record, L6 = Object.keys(lP).reduce(
  (f, s) => ({
    ...f,
    [s]() {
      return lP[s];
    }
  }),
  {}
);
function ER(f, s) {
  const n = hw(A0);
  return Dn((n || L6)[f]);
}
const WM = [
  "onDragStart",
  "onDragEnd",
  "onDragValueChange",
  "onValueChange",
  "onPointerValueChange"
], $6 = cs(i6), O6 = cs(eV, {
  events: WM
}), A6 = ue.forwardRef(({ children: f, ...s }, n) => /* @__PURE__ */ lt(O6, { ...s, ref: n, children: (o) => /* @__PURE__ */ lt(Ji.div, { ...o, children: f }) }));
A6.displayName = "Slider";
const P6 = ue.forwardRef((f, s) => /* @__PURE__ */ lt(Ji.div, { ...f, ref: s }));
P6.displayName = "SliderThumb";
const _6 = ue.forwardRef((f, s) => /* @__PURE__ */ lt(Ji.div, { ...f, ref: s }));
_6.displayName = "SliderTrack";
const N6 = ue.forwardRef((f, s) => /* @__PURE__ */ lt(Ji.div, { ...f, ref: s }));
N6.displayName = "SliderTrackFill";
const U6 = cs(a6), z6 = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(U6, { ...s, children: (o) => /* @__PURE__ */ lt(
    Ji.div,
    {
      ...o,
      ref: Hd(o.ref, n),
      children: f
    }
  ) })
);
z6.displayName = "SliderPreview";
const F6 = ue.forwardRef(({ children: f, ...s }, n) => /* @__PURE__ */ lt($6, { ...s, children: (o, h) => {
  const v = Dn(() => h.getValueText(), h);
  return /* @__PURE__ */ hy(Ji.div, { ...o, ref: n, children: [
    v,
    f
  ] });
} }));
F6.displayName = "SliderValue";
const V6 = ue.forwardRef(({ children: f, ...s }, n) => {
  const o = ER("min"), h = ER("max"), v = ER("step"), y = (h - o) / v;
  return /* @__PURE__ */ lt(Ji.div, { ...s, ref: n, children: Array.from({ length: Math.floor(y) + 1 }).map((k, D) => f(D)) });
});
V6.displayName = "SliderSteps";
const H6 = cs(t6, {
  events: WM,
  domEventsRegex: /^onMedia/
}), I6 = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(H6, { ...s, ref: n, children: (o) => /* @__PURE__ */ lt(Ji.div, { ...o, children: f }) })
);
I6.displayName = "VolumeSlider";
function q6(f = 0, s = 0, n = "") {
  return new window.VTTCue(f, s, n);
}
const U0 = ue.createContext({
  $chapters: st(null)
});
U0.displayName = "TimeSliderContext";
const j6 = cs(e6, {
  events: WM,
  domEventsRegex: /^onMedia/
}), B6 = ue.forwardRef(
  ({ children: f, ...s }, n) => {
    const o = ue.useMemo(() => st(null), []);
    return /* @__PURE__ */ lt(U0.Provider, { value: { $chapters: o }, children: /* @__PURE__ */ lt(j6, { ...s, ref: n, children: (h) => /* @__PURE__ */ lt(Ji.div, { ...h, children: f }) }) });
  }
);
B6.displayName = "TimeSlider";
const Q6 = cs(s6), Y6 = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(Q6, { ...s, children: (o, h) => /* @__PURE__ */ lt(
    Ji.div,
    {
      ...o,
      ref: Hd(o.ref, n),
      children: /* @__PURE__ */ lt(sV, { instance: h, children: f })
    }
  ) })
);
Y6.displayName = "SliderChapters";
function sV({ instance: f, children: s }) {
  const n = Dn(() => f.cues, f), o = ue.useRef([]), h = ue.useRef(null), { $chapters: v } = ue.useContext(U0);
  return h.current || (h.current = q6()), ue.useEffect(() => (v.set(f), () => void v.set(null)), [f]), ue.useEffect(() => {
    f.setRefs(o.current);
  }, [n]), s(n.length ? n : [h.current], (y) => {
    if (!y) {
      o.current.length = 0;
      return;
    }
    o.current.push(y);
  });
}
sV.displayName = "SliderChapterTracks";
const G6 = ue.forwardRef(
  ({ children: f, ...s }, n) => {
    const { $chapters: o } = ue.useContext(U0), [h, v] = ue.useState();
    return ue.useEffect(() => J(() => {
      const y = o(), k = (y == null ? void 0 : y.activePointerCue) || (y == null ? void 0 : y.activeCue);
      v((k == null ? void 0 : k.text) || "");
    }), []), /* @__PURE__ */ hy(Ji.div, { ...s, ref: n, children: [
      h,
      f
    ] });
  }
);
G6.displayName = "SliderChapterTitle";
const W6 = ue.forwardRef((f, s) => /* @__PURE__ */ lt(Ji.div, { ...f, ref: s }));
W6.displayName = "SliderProgress";
const K6 = cs(n6), X6 = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(K6, { ...s, children: (o) => /* @__PURE__ */ lt(Ji.div, { ...o, ref: Hd(o.ref, n), children: f }) })
);
X6.displayName = "SliderThumbnail";
const Z6 = cs(r6, {
  events: ["onCanPlay", "onError"]
}), J6 = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(Z6, { ...s, children: (o, h) => /* @__PURE__ */ lt(
    lV,
    {
      ...o,
      instance: h,
      ref: Hd(o.ref, n),
      children: f
    }
  ) })
);
J6.displayName = "SliderVideo";
const lV = ue.forwardRef(
  ({ instance: f, children: s, ...n }, o) => {
    const { canLoad: h } = hw(xy), { src: v, video: y, crossOrigin: k } = f.$state, D = Dn(v), $ = Dn(h), _ = Dn(k);
    return /* @__PURE__ */ lt(
      Ji.video,
      {
        style: { maxWidth: "unset" },
        ...n,
        src: D || void 0,
        muted: !0,
        playsInline: !0,
        preload: $ ? "auto" : "none",
        crossOrigin: _ || void 0,
        ref: Hd(y.set, o),
        children: s
      }
    );
  }
);
lV.displayName = "SliderVideoProvider";
var Sb = { exports: {} }, Da = {}, Tb = { exports: {} }, CR = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oP;
function eQ() {
  return oP || (oP = 1, function(f) {
    function s(oe, Le) {
      var he = oe.length;
      oe.push(Le);
      e: for (; 0 < he; ) {
        var yt = he - 1 >>> 1, Nt = oe[yt];
        if (0 < h(Nt, Le)) oe[yt] = Le, oe[he] = Nt, he = yt;
        else break e;
      }
    }
    function n(oe) {
      return oe.length === 0 ? null : oe[0];
    }
    function o(oe) {
      if (oe.length === 0) return null;
      var Le = oe[0], he = oe.pop();
      if (he !== Le) {
        oe[0] = he;
        e: for (var yt = 0, Nt = oe.length, Ii = Nt >>> 1; yt < Ii; ) {
          var jn = 2 * (yt + 1) - 1, oa = oe[jn], ri = jn + 1, ai = oe[ri];
          if (0 > h(oa, he)) ri < Nt && 0 > h(ai, oa) ? (oe[yt] = ai, oe[ri] = he, yt = ri) : (oe[yt] = oa, oe[jn] = he, yt = jn);
          else if (ri < Nt && 0 > h(ai, he)) oe[yt] = ai, oe[ri] = he, yt = ri;
          else break e;
        }
      }
      return Le;
    }
    function h(oe, Le) {
      var he = oe.sortIndex - Le.sortIndex;
      return he !== 0 ? he : oe.id - Le.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var v = performance;
      f.unstable_now = function() {
        return v.now();
      };
    } else {
      var y = Date, k = y.now();
      f.unstable_now = function() {
        return y.now() - k;
      };
    }
    var D = [], $ = [], _ = 1, A = null, B = 3, W = !1, ne = !1, ce = !1, Re = typeof setTimeout == "function" ? setTimeout : null, Lt = typeof clearTimeout == "function" ? clearTimeout : null, $t = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function Ve(oe) {
      for (var Le = n($); Le !== null; ) {
        if (Le.callback === null) o($);
        else if (Le.startTime <= oe) o($), Le.sortIndex = Le.expirationTime, s(D, Le);
        else break;
        Le = n($);
      }
    }
    function ct(oe) {
      if (ce = !1, Ve(oe), !ne) if (n(D) !== null) ne = !0, Je(Ye);
      else {
        var Le = n($);
        Le !== null && ot(ct, Le.startTime - oe);
      }
    }
    function Ye(oe, Le) {
      ne = !1, ce && (ce = !1, Lt(de), de = -1), W = !0;
      var he = B;
      try {
        for (Ve(Le), A = n(D); A !== null && (!(A.expirationTime > Le) || oe && !Kt()); ) {
          var yt = A.callback;
          if (typeof yt == "function") {
            A.callback = null, B = A.priorityLevel;
            var Nt = yt(A.expirationTime <= Le);
            Le = f.unstable_now(), typeof Nt == "function" ? A.callback = Nt : A === n(D) && o(D), Ve(Le);
          } else o(D);
          A = n(D);
        }
        if (A !== null) var Ii = !0;
        else {
          var jn = n($);
          jn !== null && ot(ct, jn.startTime - Le), Ii = !1;
        }
        return Ii;
      } finally {
        A = null, B = he, W = !1;
      }
    }
    var Tt = !1, He = null, de = -1, Ge = 5, ft = -1;
    function Kt() {
      return !(f.unstable_now() - ft < Ge);
    }
    function Mt() {
      if (He !== null) {
        var oe = f.unstable_now();
        ft = oe;
        var Le = !0;
        try {
          Le = He(!0, oe);
        } finally {
          Le ? Ae() : (Tt = !1, He = null);
        }
      } else Tt = !1;
    }
    var Ae;
    if (typeof $t == "function") Ae = function() {
      $t(Mt);
    };
    else if (typeof MessageChannel < "u") {
      var wt = new MessageChannel(), Sn = wt.port2;
      wt.port1.onmessage = Mt, Ae = function() {
        Sn.postMessage(null);
      };
    } else Ae = function() {
      Re(Mt, 0);
    };
    function Je(oe) {
      He = oe, Tt || (Tt = !0, Ae());
    }
    function ot(oe, Le) {
      de = Re(function() {
        oe(f.unstable_now());
      }, Le);
    }
    f.unstable_IdlePriority = 5, f.unstable_ImmediatePriority = 1, f.unstable_LowPriority = 4, f.unstable_NormalPriority = 3, f.unstable_Profiling = null, f.unstable_UserBlockingPriority = 2, f.unstable_cancelCallback = function(oe) {
      oe.callback = null;
    }, f.unstable_continueExecution = function() {
      ne || W || (ne = !0, Je(Ye));
    }, f.unstable_forceFrameRate = function(oe) {
      0 > oe || 125 < oe ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : Ge = 0 < oe ? Math.floor(1e3 / oe) : 5;
    }, f.unstable_getCurrentPriorityLevel = function() {
      return B;
    }, f.unstable_getFirstCallbackNode = function() {
      return n(D);
    }, f.unstable_next = function(oe) {
      switch (B) {
        case 1:
        case 2:
        case 3:
          var Le = 3;
          break;
        default:
          Le = B;
      }
      var he = B;
      B = Le;
      try {
        return oe();
      } finally {
        B = he;
      }
    }, f.unstable_pauseExecution = function() {
    }, f.unstable_requestPaint = function() {
    }, f.unstable_runWithPriority = function(oe, Le) {
      switch (oe) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          oe = 3;
      }
      var he = B;
      B = oe;
      try {
        return Le();
      } finally {
        B = he;
      }
    }, f.unstable_scheduleCallback = function(oe, Le, he) {
      var yt = f.unstable_now();
      switch (typeof he == "object" && he !== null ? (he = he.delay, he = typeof he == "number" && 0 < he ? yt + he : yt) : he = yt, oe) {
        case 1:
          var Nt = -1;
          break;
        case 2:
          Nt = 250;
          break;
        case 5:
          Nt = 1073741823;
          break;
        case 4:
          Nt = 1e4;
          break;
        default:
          Nt = 5e3;
      }
      return Nt = he + Nt, oe = { id: _++, callback: Le, priorityLevel: oe, startTime: he, expirationTime: Nt, sortIndex: -1 }, he > yt ? (oe.sortIndex = he, s($, oe), n(D) === null && oe === n($) && (ce ? (Lt(de), de = -1) : ce = !0, ot(ct, he - yt))) : (oe.sortIndex = Nt, s(D, oe), ne || W || (ne = !0, Je(Ye))), oe;
    }, f.unstable_shouldYield = Kt, f.unstable_wrapCallback = function(oe) {
      var Le = B;
      return function() {
        var he = B;
        B = Le;
        try {
          return oe.apply(this, arguments);
        } finally {
          B = he;
        }
      };
    };
  }(CR)), CR;
}
var bR = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uP;
function tQ() {
  return uP || (uP = 1, function(f) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var s = !1, n = 5;
      function o(pe, ze) {
        var ht = pe.length;
        pe.push(ze), y(pe, ze, ht);
      }
      function h(pe) {
        return pe.length === 0 ? null : pe[0];
      }
      function v(pe) {
        if (pe.length === 0)
          return null;
        var ze = pe[0], ht = pe.pop();
        return ht !== ze && (pe[0] = ht, k(pe, ht, 0)), ze;
      }
      function y(pe, ze, ht) {
        for (var an = ht; an > 0; ) {
          var Ln = an - 1 >>> 1, wr = pe[Ln];
          if (D(wr, ze) > 0)
            pe[Ln] = ze, pe[an] = wr, an = Ln;
          else
            return;
        }
      }
      function k(pe, ze, ht) {
        for (var an = ht, Ln = pe.length, wr = Ln >>> 1; an < wr; ) {
          var Bn = (an + 1) * 2 - 1, Er = pe[Bn], Qn = Bn + 1, $n = pe[Qn];
          if (D(Er, ze) < 0)
            Qn < Ln && D($n, Er) < 0 ? (pe[an] = $n, pe[Qn] = ze, an = Qn) : (pe[an] = Er, pe[Bn] = ze, an = Bn);
          else if (Qn < Ln && D($n, ze) < 0)
            pe[an] = $n, pe[Qn] = ze, an = Qn;
          else
            return;
        }
      }
      function D(pe, ze) {
        var ht = pe.sortIndex - ze.sortIndex;
        return ht !== 0 ? ht : pe.id - ze.id;
      }
      var $ = 1, _ = 2, A = 3, B = 4, W = 5;
      function ne(pe, ze) {
      }
      var ce = typeof performance == "object" && typeof performance.now == "function";
      if (ce) {
        var Re = performance;
        f.unstable_now = function() {
          return Re.now();
        };
      } else {
        var Lt = Date, $t = Lt.now();
        f.unstable_now = function() {
          return Lt.now() - $t;
        };
      }
      var Ve = 1073741823, ct = -1, Ye = 250, Tt = 5e3, He = 1e4, de = Ve, Ge = [], ft = [], Kt = 1, Mt = null, Ae = A, wt = !1, Sn = !1, Je = !1, ot = typeof setTimeout == "function" ? setTimeout : null, oe = typeof clearTimeout == "function" ? clearTimeout : null, Le = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function he(pe) {
        for (var ze = h(ft); ze !== null; ) {
          if (ze.callback === null)
            v(ft);
          else if (ze.startTime <= pe)
            v(ft), ze.sortIndex = ze.expirationTime, o(Ge, ze);
          else
            return;
          ze = h(ft);
        }
      }
      function yt(pe) {
        if (Je = !1, he(pe), !Sn)
          if (h(Ge) !== null)
            Sn = !0, jr(Nt);
          else {
            var ze = h(ft);
            ze !== null && ds(yt, ze.startTime - pe);
          }
      }
      function Nt(pe, ze) {
        Sn = !1, Je && (Je = !1, $o()), wt = !0;
        var ht = Ae;
        try {
          var an;
          if (!s) return Ii(pe, ze);
        } finally {
          Mt = null, Ae = ht, wt = !1;
        }
      }
      function Ii(pe, ze) {
        var ht = ze;
        for (he(ht), Mt = h(Ge); Mt !== null && !(Mt.expirationTime > ht && (!pe || Id())); ) {
          var an = Mt.callback;
          if (typeof an == "function") {
            Mt.callback = null, Ae = Mt.priorityLevel;
            var Ln = Mt.expirationTime <= ht, wr = an(Ln);
            ht = f.unstable_now(), typeof wr == "function" ? Mt.callback = wr : Mt === h(Ge) && v(Ge), he(ht);
          } else
            v(Ge);
          Mt = h(Ge);
        }
        if (Mt !== null)
          return !0;
        var Bn = h(ft);
        return Bn !== null && ds(yt, Bn.startTime - ht), !1;
      }
      function jn(pe, ze) {
        switch (pe) {
          case $:
          case _:
          case A:
          case B:
          case W:
            break;
          default:
            pe = A;
        }
        var ht = Ae;
        Ae = pe;
        try {
          return ze();
        } finally {
          Ae = ht;
        }
      }
      function oa(pe) {
        var ze;
        switch (Ae) {
          case $:
          case _:
          case A:
            ze = A;
            break;
          default:
            ze = Ae;
            break;
        }
        var ht = Ae;
        Ae = ze;
        try {
          return pe();
        } finally {
          Ae = ht;
        }
      }
      function ri(pe) {
        var ze = Ae;
        return function() {
          var ht = Ae;
          Ae = ze;
          try {
            return pe.apply(this, arguments);
          } finally {
            Ae = ht;
          }
        };
      }
      function ai(pe, ze, ht) {
        var an = f.unstable_now(), Ln;
        if (typeof ht == "object" && ht !== null) {
          var wr = ht.delay;
          typeof wr == "number" && wr > 0 ? Ln = an + wr : Ln = an;
        } else
          Ln = an;
        var Bn;
        switch (pe) {
          case $:
            Bn = ct;
            break;
          case _:
            Bn = Ye;
            break;
          case W:
            Bn = de;
            break;
          case B:
            Bn = He;
            break;
          case A:
          default:
            Bn = Tt;
            break;
        }
        var Er = Ln + Bn, Qn = {
          id: Kt++,
          callback: ze,
          priorityLevel: pe,
          startTime: Ln,
          expirationTime: Er,
          sortIndex: -1
        };
        return Ln > an ? (Qn.sortIndex = Ln, o(ft, Qn), h(Ge) === null && Qn === h(ft) && (Je ? $o() : Je = !0, ds(yt, Ln - an))) : (Qn.sortIndex = Er, o(Ge, Qn), !Sn && !wt && (Sn = !0, jr(Nt))), Qn;
      }
      function bi() {
      }
      function si() {
        !Sn && !wt && (Sn = !0, jr(Nt));
      }
      function ki() {
        return h(Ge);
      }
      function _n(pe) {
        pe.callback = null;
      }
      function er() {
        return Ae;
      }
      var yi = !1, xi = null, tr = -1, Ir = n, nc = -1;
      function Id() {
        var pe = f.unstable_now() - nc;
        return !(pe < Ir);
      }
      function qd() {
      }
      function Lo(pe) {
        if (pe < 0 || pe > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        pe > 0 ? Ir = Math.floor(1e3 / pe) : Ir = n;
      }
      var qr = function() {
        if (xi !== null) {
          var pe = f.unstable_now();
          nc = pe;
          var ze = !0, ht = !0;
          try {
            ht = xi(ze, pe);
          } finally {
            ht ? ua() : (yi = !1, xi = null);
          }
        } else
          yi = !1;
      }, ua;
      if (typeof Le == "function")
        ua = function() {
          Le(qr);
        };
      else if (typeof MessageChannel < "u") {
        var za = new MessageChannel(), ic = za.port2;
        za.port1.onmessage = qr, ua = function() {
          ic.postMessage(null);
        };
      } else
        ua = function() {
          ot(qr, 0);
        };
      function jr(pe) {
        xi = pe, yi || (yi = !0, ua());
      }
      function ds(pe, ze) {
        tr = ot(function() {
          pe(f.unstable_now());
        }, ze);
      }
      function $o() {
        oe(tr), tr = -1;
      }
      var Oo = qd, jd = null;
      f.unstable_IdlePriority = W, f.unstable_ImmediatePriority = $, f.unstable_LowPriority = B, f.unstable_NormalPriority = A, f.unstable_Profiling = jd, f.unstable_UserBlockingPriority = _, f.unstable_cancelCallback = _n, f.unstable_continueExecution = si, f.unstable_forceFrameRate = Lo, f.unstable_getCurrentPriorityLevel = er, f.unstable_getFirstCallbackNode = ki, f.unstable_next = oa, f.unstable_pauseExecution = bi, f.unstable_requestPaint = Oo, f.unstable_runWithPriority = jn, f.unstable_scheduleCallback = ai, f.unstable_shouldYield = Id, f.unstable_wrapCallback = ri, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(bR)), bR;
}
var cP;
function oV() {
  return cP || (cP = 1, process.env.NODE_ENV === "production" ? Tb.exports = eQ() : Tb.exports = tQ()), Tb.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dP;
function nQ() {
  if (dP) return Da;
  dP = 1;
  var f = RP, s = oV();
  function n(i) {
    for (var r = "https://reactjs.org/docs/error-decoder.html?invariant=" + i, u = 1; u < arguments.length; u++) r += "&args[]=" + encodeURIComponent(arguments[u]);
    return "Minified React error #" + i + "; visit " + r + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var o = /* @__PURE__ */ new Set(), h = {};
  function v(i, r) {
    y(i, r), y(i + "Capture", r);
  }
  function y(i, r) {
    for (h[i] = r, i = 0; i < r.length; i++) o.add(r[i]);
  }
  var k = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), D = Object.prototype.hasOwnProperty, $ = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, _ = {}, A = {};
  function B(i) {
    return D.call(A, i) ? !0 : D.call(_, i) ? !1 : $.test(i) ? A[i] = !0 : (_[i] = !0, !1);
  }
  function W(i, r, u, p) {
    if (u !== null && u.type === 0) return !1;
    switch (typeof r) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return p ? !1 : u !== null ? !u.acceptsBooleans : (i = i.toLowerCase().slice(0, 5), i !== "data-" && i !== "aria-");
      default:
        return !1;
    }
  }
  function ne(i, r, u, p) {
    if (r === null || typeof r > "u" || W(i, r, u, p)) return !0;
    if (p) return !1;
    if (u !== null) switch (u.type) {
      case 3:
        return !r;
      case 4:
        return r === !1;
      case 5:
        return isNaN(r);
      case 6:
        return isNaN(r) || 1 > r;
    }
    return !1;
  }
  function ce(i, r, u, p, g, w, b) {
    this.acceptsBooleans = r === 2 || r === 3 || r === 4, this.attributeName = p, this.attributeNamespace = g, this.mustUseProperty = u, this.propertyName = i, this.type = r, this.sanitizeURL = w, this.removeEmptyString = b;
  }
  var Re = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(i) {
    Re[i] = new ce(i, 0, !1, i, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(i) {
    var r = i[0];
    Re[r] = new ce(r, 1, !1, i[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(i) {
    Re[i] = new ce(i, 2, !1, i.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(i) {
    Re[i] = new ce(i, 2, !1, i, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(i) {
    Re[i] = new ce(i, 3, !1, i.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(i) {
    Re[i] = new ce(i, 3, !0, i, null, !1, !1);
  }), ["capture", "download"].forEach(function(i) {
    Re[i] = new ce(i, 4, !1, i, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(i) {
    Re[i] = new ce(i, 6, !1, i, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(i) {
    Re[i] = new ce(i, 5, !1, i.toLowerCase(), null, !1, !1);
  });
  var Lt = /[\-:]([a-z])/g;
  function $t(i) {
    return i[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(i) {
    var r = i.replace(
      Lt,
      $t
    );
    Re[r] = new ce(r, 1, !1, i, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(i) {
    var r = i.replace(Lt, $t);
    Re[r] = new ce(r, 1, !1, i, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(i) {
    var r = i.replace(Lt, $t);
    Re[r] = new ce(r, 1, !1, i, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(i) {
    Re[i] = new ce(i, 1, !1, i.toLowerCase(), null, !1, !1);
  }), Re.xlinkHref = new ce("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(i) {
    Re[i] = new ce(i, 1, !1, i.toLowerCase(), null, !0, !0);
  });
  function Ve(i, r, u, p) {
    var g = Re.hasOwnProperty(r) ? Re[r] : null;
    (g !== null ? g.type !== 0 : p || !(2 < r.length) || r[0] !== "o" && r[0] !== "O" || r[1] !== "n" && r[1] !== "N") && (ne(r, u, g, p) && (u = null), p || g === null ? B(r) && (u === null ? i.removeAttribute(r) : i.setAttribute(r, "" + u)) : g.mustUseProperty ? i[g.propertyName] = u === null ? g.type === 3 ? !1 : "" : u : (r = g.attributeName, p = g.attributeNamespace, u === null ? i.removeAttribute(r) : (g = g.type, u = g === 3 || g === 4 && u === !0 ? "" : "" + u, p ? i.setAttributeNS(p, r, u) : i.setAttribute(r, u))));
  }
  var ct = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Ye = Symbol.for("react.element"), Tt = Symbol.for("react.portal"), He = Symbol.for("react.fragment"), de = Symbol.for("react.strict_mode"), Ge = Symbol.for("react.profiler"), ft = Symbol.for("react.provider"), Kt = Symbol.for("react.context"), Mt = Symbol.for("react.forward_ref"), Ae = Symbol.for("react.suspense"), wt = Symbol.for("react.suspense_list"), Sn = Symbol.for("react.memo"), Je = Symbol.for("react.lazy"), ot = Symbol.for("react.offscreen"), oe = Symbol.iterator;
  function Le(i) {
    return i === null || typeof i != "object" ? null : (i = oe && i[oe] || i["@@iterator"], typeof i == "function" ? i : null);
  }
  var he = Object.assign, yt;
  function Nt(i) {
    if (yt === void 0) try {
      throw Error();
    } catch (u) {
      var r = u.stack.trim().match(/\n( *(at )?)/);
      yt = r && r[1] || "";
    }
    return `
` + yt + i;
  }
  var Ii = !1;
  function jn(i, r) {
    if (!i || Ii) return "";
    Ii = !0;
    var u = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (r) if (r = function() {
        throw Error();
      }, Object.defineProperty(r.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(r, []);
        } catch (j) {
          var p = j;
        }
        Reflect.construct(i, [], r);
      } else {
        try {
          r.call();
        } catch (j) {
          p = j;
        }
        i.call(r.prototype);
      }
      else {
        try {
          throw Error();
        } catch (j) {
          p = j;
        }
        i();
      }
    } catch (j) {
      if (j && p && typeof j.stack == "string") {
        for (var g = j.stack.split(`
`), w = p.stack.split(`
`), b = g.length - 1, O = w.length - 1; 1 <= b && 0 <= O && g[b] !== w[O]; ) O--;
        for (; 1 <= b && 0 <= O; b--, O--) if (g[b] !== w[O]) {
          if (b !== 1 || O !== 1)
            do
              if (b--, O--, 0 > O || g[b] !== w[O]) {
                var P = `
` + g[b].replace(" at new ", " at ");
                return i.displayName && P.includes("<anonymous>") && (P = P.replace("<anonymous>", i.displayName)), P;
              }
            while (1 <= b && 0 <= O);
          break;
        }
      }
    } finally {
      Ii = !1, Error.prepareStackTrace = u;
    }
    return (i = i ? i.displayName || i.name : "") ? Nt(i) : "";
  }
  function oa(i) {
    switch (i.tag) {
      case 5:
        return Nt(i.type);
      case 16:
        return Nt("Lazy");
      case 13:
        return Nt("Suspense");
      case 19:
        return Nt("SuspenseList");
      case 0:
      case 2:
      case 15:
        return i = jn(i.type, !1), i;
      case 11:
        return i = jn(i.type.render, !1), i;
      case 1:
        return i = jn(i.type, !0), i;
      default:
        return "";
    }
  }
  function ri(i) {
    if (i == null) return null;
    if (typeof i == "function") return i.displayName || i.name || null;
    if (typeof i == "string") return i;
    switch (i) {
      case He:
        return "Fragment";
      case Tt:
        return "Portal";
      case Ge:
        return "Profiler";
      case de:
        return "StrictMode";
      case Ae:
        return "Suspense";
      case wt:
        return "SuspenseList";
    }
    if (typeof i == "object") switch (i.$$typeof) {
      case Kt:
        return (i.displayName || "Context") + ".Consumer";
      case ft:
        return (i._context.displayName || "Context") + ".Provider";
      case Mt:
        var r = i.render;
        return i = i.displayName, i || (i = r.displayName || r.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
      case Sn:
        return r = i.displayName || null, r !== null ? r : ri(i.type) || "Memo";
      case Je:
        r = i._payload, i = i._init;
        try {
          return ri(i(r));
        } catch {
        }
    }
    return null;
  }
  function ai(i) {
    var r = i.type;
    switch (i.tag) {
      case 24:
        return "Cache";
      case 9:
        return (r.displayName || "Context") + ".Consumer";
      case 10:
        return (r._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return i = r.render, i = i.displayName || i.name || "", r.displayName || (i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return r;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return ri(r);
      case 8:
        return r === de ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof r == "function") return r.displayName || r.name || null;
        if (typeof r == "string") return r;
    }
    return null;
  }
  function bi(i) {
    switch (typeof i) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return i;
      case "object":
        return i;
      default:
        return "";
    }
  }
  function si(i) {
    var r = i.type;
    return (i = i.nodeName) && i.toLowerCase() === "input" && (r === "checkbox" || r === "radio");
  }
  function ki(i) {
    var r = si(i) ? "checked" : "value", u = Object.getOwnPropertyDescriptor(i.constructor.prototype, r), p = "" + i[r];
    if (!i.hasOwnProperty(r) && typeof u < "u" && typeof u.get == "function" && typeof u.set == "function") {
      var g = u.get, w = u.set;
      return Object.defineProperty(i, r, { configurable: !0, get: function() {
        return g.call(this);
      }, set: function(b) {
        p = "" + b, w.call(this, b);
      } }), Object.defineProperty(i, r, { enumerable: u.enumerable }), { getValue: function() {
        return p;
      }, setValue: function(b) {
        p = "" + b;
      }, stopTracking: function() {
        i._valueTracker = null, delete i[r];
      } };
    }
  }
  function _n(i) {
    i._valueTracker || (i._valueTracker = ki(i));
  }
  function er(i) {
    if (!i) return !1;
    var r = i._valueTracker;
    if (!r) return !0;
    var u = r.getValue(), p = "";
    return i && (p = si(i) ? i.checked ? "true" : "false" : i.value), i = p, i !== u ? (r.setValue(i), !0) : !1;
  }
  function yi(i) {
    if (i = i || (typeof document < "u" ? document : void 0), typeof i > "u") return null;
    try {
      return i.activeElement || i.body;
    } catch {
      return i.body;
    }
  }
  function xi(i, r) {
    var u = r.checked;
    return he({}, r, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: u ?? i._wrapperState.initialChecked });
  }
  function tr(i, r) {
    var u = r.defaultValue == null ? "" : r.defaultValue, p = r.checked != null ? r.checked : r.defaultChecked;
    u = bi(r.value != null ? r.value : u), i._wrapperState = { initialChecked: p, initialValue: u, controlled: r.type === "checkbox" || r.type === "radio" ? r.checked != null : r.value != null };
  }
  function Ir(i, r) {
    r = r.checked, r != null && Ve(i, "checked", r, !1);
  }
  function nc(i, r) {
    Ir(i, r);
    var u = bi(r.value), p = r.type;
    if (u != null) p === "number" ? (u === 0 && i.value === "" || i.value != u) && (i.value = "" + u) : i.value !== "" + u && (i.value = "" + u);
    else if (p === "submit" || p === "reset") {
      i.removeAttribute("value");
      return;
    }
    r.hasOwnProperty("value") ? qd(i, r.type, u) : r.hasOwnProperty("defaultValue") && qd(i, r.type, bi(r.defaultValue)), r.checked == null && r.defaultChecked != null && (i.defaultChecked = !!r.defaultChecked);
  }
  function Id(i, r, u) {
    if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
      var p = r.type;
      if (!(p !== "submit" && p !== "reset" || r.value !== void 0 && r.value !== null)) return;
      r = "" + i._wrapperState.initialValue, u || r === i.value || (i.value = r), i.defaultValue = r;
    }
    u = i.name, u !== "" && (i.name = ""), i.defaultChecked = !!i._wrapperState.initialChecked, u !== "" && (i.name = u);
  }
  function qd(i, r, u) {
    (r !== "number" || yi(i.ownerDocument) !== i) && (u == null ? i.defaultValue = "" + i._wrapperState.initialValue : i.defaultValue !== "" + u && (i.defaultValue = "" + u));
  }
  var Lo = Array.isArray;
  function qr(i, r, u, p) {
    if (i = i.options, r) {
      r = {};
      for (var g = 0; g < u.length; g++) r["$" + u[g]] = !0;
      for (u = 0; u < i.length; u++) g = r.hasOwnProperty("$" + i[u].value), i[u].selected !== g && (i[u].selected = g), g && p && (i[u].defaultSelected = !0);
    } else {
      for (u = "" + bi(u), r = null, g = 0; g < i.length; g++) {
        if (i[g].value === u) {
          i[g].selected = !0, p && (i[g].defaultSelected = !0);
          return;
        }
        r !== null || i[g].disabled || (r = i[g]);
      }
      r !== null && (r.selected = !0);
    }
  }
  function ua(i, r) {
    if (r.dangerouslySetInnerHTML != null) throw Error(n(91));
    return he({}, r, { value: void 0, defaultValue: void 0, children: "" + i._wrapperState.initialValue });
  }
  function za(i, r) {
    var u = r.value;
    if (u == null) {
      if (u = r.children, r = r.defaultValue, u != null) {
        if (r != null) throw Error(n(92));
        if (Lo(u)) {
          if (1 < u.length) throw Error(n(93));
          u = u[0];
        }
        r = u;
      }
      r == null && (r = ""), u = r;
    }
    i._wrapperState = { initialValue: bi(u) };
  }
  function ic(i, r) {
    var u = bi(r.value), p = bi(r.defaultValue);
    u != null && (u = "" + u, u !== i.value && (i.value = u), r.defaultValue == null && i.defaultValue !== u && (i.defaultValue = u)), p != null && (i.defaultValue = "" + p);
  }
  function jr(i) {
    var r = i.textContent;
    r === i._wrapperState.initialValue && r !== "" && r !== null && (i.value = r);
  }
  function ds(i) {
    switch (i) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function $o(i, r) {
    return i == null || i === "http://www.w3.org/1999/xhtml" ? ds(r) : i === "http://www.w3.org/2000/svg" && r === "foreignObject" ? "http://www.w3.org/1999/xhtml" : i;
  }
  var Oo, jd = function(i) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(r, u, p, g) {
      MSApp.execUnsafeLocalFunction(function() {
        return i(r, u, p, g);
      });
    } : i;
  }(function(i, r) {
    if (i.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in i) i.innerHTML = r;
    else {
      for (Oo = Oo || document.createElement("div"), Oo.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>", r = Oo.firstChild; i.firstChild; ) i.removeChild(i.firstChild);
      for (; r.firstChild; ) i.appendChild(r.firstChild);
    }
  });
  function pe(i, r) {
    if (r) {
      var u = i.firstChild;
      if (u && u === i.lastChild && u.nodeType === 3) {
        u.nodeValue = r;
        return;
      }
    }
    i.textContent = r;
  }
  var ze = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, ht = ["Webkit", "ms", "Moz", "O"];
  Object.keys(ze).forEach(function(i) {
    ht.forEach(function(r) {
      r = r + i.charAt(0).toUpperCase() + i.substring(1), ze[r] = ze[i];
    });
  });
  function an(i, r, u) {
    return r == null || typeof r == "boolean" || r === "" ? "" : u || typeof r != "number" || r === 0 || ze.hasOwnProperty(i) && ze[i] ? ("" + r).trim() : r + "px";
  }
  function Ln(i, r) {
    i = i.style;
    for (var u in r) if (r.hasOwnProperty(u)) {
      var p = u.indexOf("--") === 0, g = an(u, r[u], p);
      u === "float" && (u = "cssFloat"), p ? i.setProperty(u, g) : i[u] = g;
    }
  }
  var wr = he({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Bn(i, r) {
    if (r) {
      if (wr[i] && (r.children != null || r.dangerouslySetInnerHTML != null)) throw Error(n(137, i));
      if (r.dangerouslySetInnerHTML != null) {
        if (r.children != null) throw Error(n(60));
        if (typeof r.dangerouslySetInnerHTML != "object" || !("__html" in r.dangerouslySetInnerHTML)) throw Error(n(61));
      }
      if (r.style != null && typeof r.style != "object") throw Error(n(62));
    }
  }
  function Er(i, r) {
    if (i.indexOf("-") === -1) return typeof r.is == "string";
    switch (i) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Qn = null;
  function $n(i) {
    return i = i.target || i.srcElement || window, i.correspondingUseElement && (i = i.correspondingUseElement), i.nodeType === 3 ? i.parentNode : i;
  }
  var li = null, rc = null, kl = null;
  function lp(i) {
    if (i = Pe(i)) {
      if (typeof li != "function") throw Error(n(280));
      var r = i.stateNode;
      r && (r = Nn(r), li(i.stateNode, i.type, r));
    }
  }
  function pw(i) {
    rc ? kl ? kl.push(i) : kl = [i] : rc = i;
  }
  function mw() {
    if (rc) {
      var i = rc, r = kl;
      if (kl = rc = null, lp(i), r) for (i = 0; i < r.length; i++) lp(r[i]);
    }
  }
  function My(i, r) {
    return i(r);
  }
  function Ly() {
  }
  var $y = !1;
  function Oy(i, r, u) {
    if ($y) return i(r, u);
    $y = !0;
    try {
      return My(i, r, u);
    } finally {
      $y = !1, (rc !== null || kl !== null) && (Ly(), mw());
    }
  }
  function Ao(i, r) {
    var u = i.stateNode;
    if (u === null) return null;
    var p = Nn(u);
    if (p === null) return null;
    u = p[r];
    e: switch (r) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (p = !p.disabled) || (i = i.type, p = !(i === "button" || i === "input" || i === "select" || i === "textarea")), i = !p;
        break e;
      default:
        i = !1;
    }
    if (i) return null;
    if (u && typeof u != "function") throw Error(n(231, r, typeof u));
    return u;
  }
  var xl = !1;
  if (k) try {
    var Fa = {};
    Object.defineProperty(Fa, "passive", { get: function() {
      xl = !0;
    } }), window.addEventListener("test", Fa, Fa), window.removeEventListener("test", Fa, Fa);
  } catch {
    xl = !1;
  }
  function ac(i, r, u, p, g, w, b, O, P) {
    var j = Array.prototype.slice.call(arguments, 3);
    try {
      r.apply(u, j);
    } catch (ie) {
      this.onError(ie);
    }
  }
  var Po = !1, sc = null, lc = !1, Bd = null, oc = { onError: function(i) {
    Po = !0, sc = i;
  } };
  function op(i, r, u, p, g, w, b, O, P) {
    Po = !1, sc = null, ac.apply(oc, arguments);
  }
  function up(i, r, u, p, g, w, b, O, P) {
    if (op.apply(this, arguments), Po) {
      if (Po) {
        var j = sc;
        Po = !1, sc = null;
      } else throw Error(n(198));
      lc || (lc = !0, Bd = j);
    }
  }
  function Va(i) {
    var r = i, u = i;
    if (i.alternate) for (; r.return; ) r = r.return;
    else {
      i = r;
      do
        r = i, r.flags & 4098 && (u = r.return), i = r.return;
      while (i);
    }
    return r.tag === 3 ? u : null;
  }
  function qi(i) {
    if (i.tag === 13) {
      var r = i.memoizedState;
      if (r === null && (i = i.alternate, i !== null && (r = i.memoizedState)), r !== null) return r.dehydrated;
    }
    return null;
  }
  function vw(i) {
    if (Va(i) !== i) throw Error(n(188));
  }
  function z0(i) {
    var r = i.alternate;
    if (!r) {
      if (r = Va(i), r === null) throw Error(n(188));
      return r !== i ? null : i;
    }
    for (var u = i, p = r; ; ) {
      var g = u.return;
      if (g === null) break;
      var w = g.alternate;
      if (w === null) {
        if (p = g.return, p !== null) {
          u = p;
          continue;
        }
        break;
      }
      if (g.child === w.child) {
        for (w = g.child; w; ) {
          if (w === u) return vw(g), i;
          if (w === p) return vw(g), r;
          w = w.sibling;
        }
        throw Error(n(188));
      }
      if (u.return !== p.return) u = g, p = w;
      else {
        for (var b = !1, O = g.child; O; ) {
          if (O === u) {
            b = !0, u = g, p = w;
            break;
          }
          if (O === p) {
            b = !0, p = g, u = w;
            break;
          }
          O = O.sibling;
        }
        if (!b) {
          for (O = w.child; O; ) {
            if (O === u) {
              b = !0, u = w, p = g;
              break;
            }
            if (O === p) {
              b = !0, p = w, u = g;
              break;
            }
            O = O.sibling;
          }
          if (!b) throw Error(n(189));
        }
      }
      if (u.alternate !== p) throw Error(n(190));
    }
    if (u.tag !== 3) throw Error(n(188));
    return u.stateNode.current === u ? i : r;
  }
  function Ay(i) {
    return i = z0(i), i !== null ? yw(i) : null;
  }
  function yw(i) {
    if (i.tag === 5 || i.tag === 6) return i;
    for (i = i.child; i !== null; ) {
      var r = yw(i);
      if (r !== null) return r;
      i = i.sibling;
    }
    return null;
  }
  var gw = s.unstable_scheduleCallback, Sw = s.unstable_cancelCallback, Tw = s.unstable_shouldYield, F0 = s.unstable_requestPaint, sn = s.unstable_now, gt = s.unstable_getCurrentPriorityLevel, _o = s.unstable_ImmediatePriority, Py = s.unstable_UserBlockingPriority, Qd = s.unstable_NormalPriority, ww = s.unstable_LowPriority, _y = s.unstable_IdlePriority, Yd = null, Ha = null;
  function Ew(i) {
    if (Ha && typeof Ha.onCommitFiberRoot == "function") try {
      Ha.onCommitFiberRoot(Yd, i, void 0, (i.current.flags & 128) === 128);
    } catch {
    }
  }
  var ca = Math.clz32 ? Math.clz32 : Ny, V0 = Math.log, H0 = Math.LN2;
  function Ny(i) {
    return i >>>= 0, i === 0 ? 32 : 31 - (V0(i) / H0 | 0) | 0;
  }
  var uc = 64, Ia = 4194304;
  function No(i) {
    switch (i & -i) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return i & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return i & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return i;
    }
  }
  function Uo(i, r) {
    var u = i.pendingLanes;
    if (u === 0) return 0;
    var p = 0, g = i.suspendedLanes, w = i.pingedLanes, b = u & 268435455;
    if (b !== 0) {
      var O = b & ~g;
      O !== 0 ? p = No(O) : (w &= b, w !== 0 && (p = No(w)));
    } else b = u & ~g, b !== 0 ? p = No(b) : w !== 0 && (p = No(w));
    if (p === 0) return 0;
    if (r !== 0 && r !== p && !(r & g) && (g = p & -p, w = r & -r, g >= w || g === 16 && (w & 4194240) !== 0)) return r;
    if (p & 4 && (p |= u & 16), r = i.entangledLanes, r !== 0) for (i = i.entanglements, r &= p; 0 < r; ) u = 31 - ca(r), g = 1 << u, p |= i[u], r &= ~g;
    return p;
  }
  function I0(i, r) {
    switch (i) {
      case 1:
      case 2:
      case 4:
        return r + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return r + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Uy(i, r) {
    for (var u = i.suspendedLanes, p = i.pingedLanes, g = i.expirationTimes, w = i.pendingLanes; 0 < w; ) {
      var b = 31 - ca(w), O = 1 << b, P = g[b];
      P === -1 ? (!(O & u) || O & p) && (g[b] = I0(O, r)) : P <= r && (i.expiredLanes |= O), w &= ~O;
    }
  }
  function zy(i) {
    return i = i.pendingLanes & -1073741825, i !== 0 ? i : i & 1073741824 ? 1073741824 : 0;
  }
  function cp() {
    var i = uc;
    return uc <<= 1, !(uc & 4194240) && (uc = 64), i;
  }
  function Fy(i) {
    for (var r = [], u = 0; 31 > u; u++) r.push(i);
    return r;
  }
  function zo(i, r, u) {
    i.pendingLanes |= r, r !== 536870912 && (i.suspendedLanes = 0, i.pingedLanes = 0), i = i.eventTimes, r = 31 - ca(r), i[r] = u;
  }
  function q0(i, r) {
    var u = i.pendingLanes & ~r;
    i.pendingLanes = r, i.suspendedLanes = 0, i.pingedLanes = 0, i.expiredLanes &= r, i.mutableReadLanes &= r, i.entangledLanes &= r, r = i.entanglements;
    var p = i.eventTimes;
    for (i = i.expirationTimes; 0 < u; ) {
      var g = 31 - ca(u), w = 1 << g;
      r[g] = 0, p[g] = -1, i[g] = -1, u &= ~w;
    }
  }
  function dp(i, r) {
    var u = i.entangledLanes |= r;
    for (i = i.entanglements; u; ) {
      var p = 31 - ca(u), g = 1 << p;
      g & r | i[p] & r && (i[p] |= r), u &= ~g;
    }
  }
  var Xt = 0;
  function Vy(i) {
    return i &= -i, 1 < i ? 4 < i ? i & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var Zt, Hy, Iy, nt, qy, nr = !1, Rl = [], da = null, Dl = null, On = null, pn = /* @__PURE__ */ new Map(), Gd = /* @__PURE__ */ new Map(), Ri = [], fa = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Is(i, r) {
    switch (i) {
      case "focusin":
      case "focusout":
        da = null;
        break;
      case "dragenter":
      case "dragleave":
        Dl = null;
        break;
      case "mouseover":
      case "mouseout":
        On = null;
        break;
      case "pointerover":
      case "pointerout":
        pn.delete(r.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Gd.delete(r.pointerId);
    }
  }
  function Wd(i, r, u, p, g, w) {
    return i === null || i.nativeEvent !== w ? (i = { blockedOn: r, domEventName: u, eventSystemFlags: p, nativeEvent: w, targetContainers: [g] }, r !== null && (r = Pe(r), r !== null && Hy(r)), i) : (i.eventSystemFlags |= p, r = i.targetContainers, g !== null && r.indexOf(g) === -1 && r.push(g), i);
  }
  function jy(i, r, u, p, g) {
    switch (r) {
      case "focusin":
        return da = Wd(da, i, r, u, p, g), !0;
      case "dragenter":
        return Dl = Wd(Dl, i, r, u, p, g), !0;
      case "mouseover":
        return On = Wd(On, i, r, u, p, g), !0;
      case "pointerover":
        var w = g.pointerId;
        return pn.set(w, Wd(pn.get(w) || null, i, r, u, p, g)), !0;
      case "gotpointercapture":
        return w = g.pointerId, Gd.set(w, Wd(Gd.get(w) || null, i, r, u, p, g)), !0;
    }
    return !1;
  }
  function By(i) {
    var r = Go(i.target);
    if (r !== null) {
      var u = Va(r);
      if (u !== null) {
        if (r = u.tag, r === 13) {
          if (r = qi(u), r !== null) {
            i.blockedOn = r, qy(i.priority, function() {
              Iy(u);
            });
            return;
          }
        } else if (r === 3 && u.stateNode.current.memoizedState.isDehydrated) {
          i.blockedOn = u.tag === 3 ? u.stateNode.containerInfo : null;
          return;
        }
      }
    }
    i.blockedOn = null;
  }
  function Kd(i) {
    if (i.blockedOn !== null) return !1;
    for (var r = i.targetContainers; 0 < r.length; ) {
      var u = hp(i.domEventName, i.eventSystemFlags, r[0], i.nativeEvent);
      if (u === null) {
        u = i.nativeEvent;
        var p = new u.constructor(u.type, u);
        Qn = p, u.target.dispatchEvent(p), Qn = null;
      } else return r = Pe(u), r !== null && Hy(r), i.blockedOn = u, !1;
      r.shift();
    }
    return !0;
  }
  function Cw(i, r, u) {
    Kd(i) && u.delete(r);
  }
  function j0() {
    nr = !1, da !== null && Kd(da) && (da = null), Dl !== null && Kd(Dl) && (Dl = null), On !== null && Kd(On) && (On = null), pn.forEach(Cw), Gd.forEach(Cw);
  }
  function Xd(i, r) {
    i.blockedOn === r && (i.blockedOn = null, nr || (nr = !0, s.unstable_scheduleCallback(s.unstable_NormalPriority, j0)));
  }
  function Ml(i) {
    function r(g) {
      return Xd(g, i);
    }
    if (0 < Rl.length) {
      Xd(Rl[0], i);
      for (var u = 1; u < Rl.length; u++) {
        var p = Rl[u];
        p.blockedOn === i && (p.blockedOn = null);
      }
    }
    for (da !== null && Xd(da, i), Dl !== null && Xd(Dl, i), On !== null && Xd(On, i), pn.forEach(r), Gd.forEach(r), u = 0; u < Ri.length; u++) p = Ri[u], p.blockedOn === i && (p.blockedOn = null);
    for (; 0 < Ri.length && (u = Ri[0], u.blockedOn === null); ) By(u), u.blockedOn === null && Ri.shift();
  }
  var Fo = ct.ReactCurrentBatchConfig, Vo = !0;
  function bw(i, r, u, p) {
    var g = Xt, w = Fo.transition;
    Fo.transition = null;
    try {
      Xt = 1, fp(i, r, u, p);
    } finally {
      Xt = g, Fo.transition = w;
    }
  }
  function kw(i, r, u, p) {
    var g = Xt, w = Fo.transition;
    Fo.transition = null;
    try {
      Xt = 4, fp(i, r, u, p);
    } finally {
      Xt = g, Fo.transition = w;
    }
  }
  function fp(i, r, u, p) {
    if (Vo) {
      var g = hp(i, r, u, p);
      if (g === null) $p(i, r, p, Zd, u), Is(i, p);
      else if (jy(g, i, r, u, p)) p.stopPropagation();
      else if (Is(i, p), r & 4 && -1 < fa.indexOf(i)) {
        for (; g !== null; ) {
          var w = Pe(g);
          if (w !== null && Zt(w), w = hp(i, r, u, p), w === null && $p(i, r, p, Zd, u), w === g) break;
          g = w;
        }
        g !== null && p.stopPropagation();
      } else $p(i, r, p, null, u);
    }
  }
  var Zd = null;
  function hp(i, r, u, p) {
    if (Zd = null, i = $n(p), i = Go(i), i !== null) if (r = Va(i), r === null) i = null;
    else if (u = r.tag, u === 13) {
      if (i = qi(r), i !== null) return i;
      i = null;
    } else if (u === 3) {
      if (r.stateNode.current.memoizedState.isDehydrated) return r.tag === 3 ? r.stateNode.containerInfo : null;
      i = null;
    } else r !== i && (i = null);
    return Zd = i, null;
  }
  function pp(i) {
    switch (i) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (gt()) {
          case _o:
            return 1;
          case Py:
            return 4;
          case Qd:
          case ww:
            return 16;
          case _y:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var qs = null, mp = null, cc = null;
  function Qy() {
    if (cc) return cc;
    var i, r = mp, u = r.length, p, g = "value" in qs ? qs.value : qs.textContent, w = g.length;
    for (i = 0; i < u && r[i] === g[i]; i++) ;
    var b = u - i;
    for (p = 1; p <= b && r[u - p] === g[w - p]; p++) ;
    return cc = g.slice(i, 1 < p ? 1 - p : void 0);
  }
  function vp(i) {
    var r = i.keyCode;
    return "charCode" in i ? (i = i.charCode, i === 0 && r === 13 && (i = 13)) : i = r, i === 10 && (i = 13), 32 <= i || i === 13 ? i : 0;
  }
  function yp() {
    return !0;
  }
  function gp() {
    return !1;
  }
  function Cr(i) {
    function r(u, p, g, w, b) {
      this._reactName = u, this._targetInst = g, this.type = p, this.nativeEvent = w, this.target = b, this.currentTarget = null;
      for (var O in i) i.hasOwnProperty(O) && (u = i[O], this[O] = u ? u(w) : w[O]);
      return this.isDefaultPrevented = (w.defaultPrevented != null ? w.defaultPrevented : w.returnValue === !1) ? yp : gp, this.isPropagationStopped = gp, this;
    }
    return he(r.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var u = this.nativeEvent;
      u && (u.preventDefault ? u.preventDefault() : typeof u.returnValue != "unknown" && (u.returnValue = !1), this.isDefaultPrevented = yp);
    }, stopPropagation: function() {
      var u = this.nativeEvent;
      u && (u.stopPropagation ? u.stopPropagation() : typeof u.cancelBubble != "unknown" && (u.cancelBubble = !0), this.isPropagationStopped = yp);
    }, persist: function() {
    }, isPersistent: yp }), r;
  }
  var Ho = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(i) {
    return i.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Sp = Cr(Ho), dc = he({}, Ho, { view: 0, detail: 0 }), B0 = Cr(dc), Yy, Di, Io, Jd = he({}, dc, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Zy, button: 0, buttons: 0, relatedTarget: function(i) {
    return i.relatedTarget === void 0 ? i.fromElement === i.srcElement ? i.toElement : i.fromElement : i.relatedTarget;
  }, movementX: function(i) {
    return "movementX" in i ? i.movementX : (i !== Io && (Io && i.type === "mousemove" ? (Yy = i.screenX - Io.screenX, Di = i.screenY - Io.screenY) : Di = Yy = 0, Io = i), Yy);
  }, movementY: function(i) {
    return "movementY" in i ? i.movementY : Di;
  } }), Gy = Cr(Jd), Q0 = he({}, Jd, { dataTransfer: 0 }), fc = Cr(Q0), Wy = he({}, dc, { relatedTarget: 0 }), Tp = Cr(Wy), Y0 = he({}, Ho, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), G0 = Cr(Y0), W0 = he({}, Ho, { clipboardData: function(i) {
    return "clipboardData" in i ? i.clipboardData : window.clipboardData;
  } }), xw = Cr(W0), Ky = he({}, Ho, { data: 0 }), Xy = Cr(Ky), Rw = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Dw = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, K0 = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function js(i) {
    var r = this.nativeEvent;
    return r.getModifierState ? r.getModifierState(i) : (i = K0[i]) ? !!r[i] : !1;
  }
  function Zy() {
    return js;
  }
  var Jy = he({}, dc, { key: function(i) {
    if (i.key) {
      var r = Rw[i.key] || i.key;
      if (r !== "Unidentified") return r;
    }
    return i.type === "keypress" ? (i = vp(i), i === 13 ? "Enter" : String.fromCharCode(i)) : i.type === "keydown" || i.type === "keyup" ? Dw[i.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Zy, charCode: function(i) {
    return i.type === "keypress" ? vp(i) : 0;
  }, keyCode: function(i) {
    return i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
  }, which: function(i) {
    return i.type === "keypress" ? vp(i) : i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
  } }), eg = Cr(Jy), tg = he({}, Jd, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Mw = Cr(tg), wp = he({}, dc, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Zy }), Lw = Cr(wp), br = he({}, Ho, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Bs = Cr(br), Yn = he({}, Jd, {
    deltaX: function(i) {
      return "deltaX" in i ? i.deltaX : "wheelDeltaX" in i ? -i.wheelDeltaX : 0;
    },
    deltaY: function(i) {
      return "deltaY" in i ? i.deltaY : "wheelDeltaY" in i ? -i.wheelDeltaY : "wheelDelta" in i ? -i.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Qs = Cr(Yn), ng = [9, 13, 27, 32], hc = k && "CompositionEvent" in window, ef = null;
  k && "documentMode" in document && (ef = document.documentMode);
  var tf = k && "TextEvent" in window && !ef, $w = k && (!hc || ef && 8 < ef && 11 >= ef), Ow = " ", Ep = !1;
  function Aw(i, r) {
    switch (i) {
      case "keyup":
        return ng.indexOf(r.keyCode) !== -1;
      case "keydown":
        return r.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Pw(i) {
    return i = i.detail, typeof i == "object" && "data" in i ? i.data : null;
  }
  var pc = !1;
  function _w(i, r) {
    switch (i) {
      case "compositionend":
        return Pw(r);
      case "keypress":
        return r.which !== 32 ? null : (Ep = !0, Ow);
      case "textInput":
        return i = r.data, i === Ow && Ep ? null : i;
      default:
        return null;
    }
  }
  function X0(i, r) {
    if (pc) return i === "compositionend" || !hc && Aw(i, r) ? (i = Qy(), cc = mp = qs = null, pc = !1, i) : null;
    switch (i) {
      case "paste":
        return null;
      case "keypress":
        if (!(r.ctrlKey || r.altKey || r.metaKey) || r.ctrlKey && r.altKey) {
          if (r.char && 1 < r.char.length) return r.char;
          if (r.which) return String.fromCharCode(r.which);
        }
        return null;
      case "compositionend":
        return $w && r.locale !== "ko" ? null : r.data;
      default:
        return null;
    }
  }
  var Z0 = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function Nw(i) {
    var r = i && i.nodeName && i.nodeName.toLowerCase();
    return r === "input" ? !!Z0[i.type] : r === "textarea";
  }
  function ig(i, r, u, p) {
    pw(p), r = of(r, "onChange"), 0 < r.length && (u = new Sp("onChange", "change", null, u, p), i.push({ event: u, listeners: r }));
  }
  var fs = null, qo = null;
  function Uw(i) {
    Qo(i, 0);
  }
  function nf(i) {
    var r = ja(i);
    if (er(r)) return i;
  }
  function J0(i, r) {
    if (i === "change") return r;
  }
  var zw = !1;
  if (k) {
    var rg;
    if (k) {
      var ag = "oninput" in document;
      if (!ag) {
        var Fw = document.createElement("div");
        Fw.setAttribute("oninput", "return;"), ag = typeof Fw.oninput == "function";
      }
      rg = ag;
    } else rg = !1;
    zw = rg && (!document.documentMode || 9 < document.documentMode);
  }
  function Vw() {
    fs && (fs.detachEvent("onpropertychange", Hw), qo = fs = null);
  }
  function Hw(i) {
    if (i.propertyName === "value" && nf(qo)) {
      var r = [];
      ig(r, qo, i, $n(i)), Oy(Uw, r);
    }
  }
  function ek(i, r, u) {
    i === "focusin" ? (Vw(), fs = r, qo = u, fs.attachEvent("onpropertychange", Hw)) : i === "focusout" && Vw();
  }
  function Iw(i) {
    if (i === "selectionchange" || i === "keyup" || i === "keydown") return nf(qo);
  }
  function tk(i, r) {
    if (i === "click") return nf(r);
  }
  function qw(i, r) {
    if (i === "input" || i === "change") return nf(r);
  }
  function nk(i, r) {
    return i === r && (i !== 0 || 1 / i === 1 / r) || i !== i && r !== r;
  }
  var qa = typeof Object.is == "function" ? Object.is : nk;
  function rf(i, r) {
    if (qa(i, r)) return !0;
    if (typeof i != "object" || i === null || typeof r != "object" || r === null) return !1;
    var u = Object.keys(i), p = Object.keys(r);
    if (u.length !== p.length) return !1;
    for (p = 0; p < u.length; p++) {
      var g = u[p];
      if (!D.call(r, g) || !qa(i[g], r[g])) return !1;
    }
    return !0;
  }
  function jw(i) {
    for (; i && i.firstChild; ) i = i.firstChild;
    return i;
  }
  function Cp(i, r) {
    var u = jw(i);
    i = 0;
    for (var p; u; ) {
      if (u.nodeType === 3) {
        if (p = i + u.textContent.length, i <= r && p >= r) return { node: u, offset: r - i };
        i = p;
      }
      e: {
        for (; u; ) {
          if (u.nextSibling) {
            u = u.nextSibling;
            break e;
          }
          u = u.parentNode;
        }
        u = void 0;
      }
      u = jw(u);
    }
  }
  function Ll(i, r) {
    return i && r ? i === r ? !0 : i && i.nodeType === 3 ? !1 : r && r.nodeType === 3 ? Ll(i, r.parentNode) : "contains" in i ? i.contains(r) : i.compareDocumentPosition ? !!(i.compareDocumentPosition(r) & 16) : !1 : !1;
  }
  function af() {
    for (var i = window, r = yi(); r instanceof i.HTMLIFrameElement; ) {
      try {
        var u = typeof r.contentWindow.location.href == "string";
      } catch {
        u = !1;
      }
      if (u) i = r.contentWindow;
      else break;
      r = yi(i.document);
    }
    return r;
  }
  function bp(i) {
    var r = i && i.nodeName && i.nodeName.toLowerCase();
    return r && (r === "input" && (i.type === "text" || i.type === "search" || i.type === "tel" || i.type === "url" || i.type === "password") || r === "textarea" || i.contentEditable === "true");
  }
  function mc(i) {
    var r = af(), u = i.focusedElem, p = i.selectionRange;
    if (r !== u && u && u.ownerDocument && Ll(u.ownerDocument.documentElement, u)) {
      if (p !== null && bp(u)) {
        if (r = p.start, i = p.end, i === void 0 && (i = r), "selectionStart" in u) u.selectionStart = r, u.selectionEnd = Math.min(i, u.value.length);
        else if (i = (r = u.ownerDocument || document) && r.defaultView || window, i.getSelection) {
          i = i.getSelection();
          var g = u.textContent.length, w = Math.min(p.start, g);
          p = p.end === void 0 ? w : Math.min(p.end, g), !i.extend && w > p && (g = p, p = w, w = g), g = Cp(u, w);
          var b = Cp(
            u,
            p
          );
          g && b && (i.rangeCount !== 1 || i.anchorNode !== g.node || i.anchorOffset !== g.offset || i.focusNode !== b.node || i.focusOffset !== b.offset) && (r = r.createRange(), r.setStart(g.node, g.offset), i.removeAllRanges(), w > p ? (i.addRange(r), i.extend(b.node, b.offset)) : (r.setEnd(b.node, b.offset), i.addRange(r)));
        }
      }
      for (r = [], i = u; i = i.parentNode; ) i.nodeType === 1 && r.push({ element: i, left: i.scrollLeft, top: i.scrollTop });
      for (typeof u.focus == "function" && u.focus(), u = 0; u < r.length; u++) i = r[u], i.element.scrollLeft = i.left, i.element.scrollTop = i.top;
    }
  }
  var ik = k && "documentMode" in document && 11 >= document.documentMode, vc = null, sg = null, sf = null, lg = !1;
  function og(i, r, u) {
    var p = u.window === u ? u.document : u.nodeType === 9 ? u : u.ownerDocument;
    lg || vc == null || vc !== yi(p) || (p = vc, "selectionStart" in p && bp(p) ? p = { start: p.selectionStart, end: p.selectionEnd } : (p = (p.ownerDocument && p.ownerDocument.defaultView || window).getSelection(), p = { anchorNode: p.anchorNode, anchorOffset: p.anchorOffset, focusNode: p.focusNode, focusOffset: p.focusOffset }), sf && rf(sf, p) || (sf = p, p = of(sg, "onSelect"), 0 < p.length && (r = new Sp("onSelect", "select", null, r, u), i.push({ event: r, listeners: p }), r.target = vc)));
  }
  function kp(i, r) {
    var u = {};
    return u[i.toLowerCase()] = r.toLowerCase(), u["Webkit" + i] = "webkit" + r, u["Moz" + i] = "moz" + r, u;
  }
  var jo = { animationend: kp("Animation", "AnimationEnd"), animationiteration: kp("Animation", "AnimationIteration"), animationstart: kp("Animation", "AnimationStart"), transitionend: kp("Transition", "TransitionEnd") }, Mi = {}, ug = {};
  k && (ug = document.createElement("div").style, "AnimationEvent" in window || (delete jo.animationend.animation, delete jo.animationiteration.animation, delete jo.animationstart.animation), "TransitionEvent" in window || delete jo.transitionend.transition);
  function xp(i) {
    if (Mi[i]) return Mi[i];
    if (!jo[i]) return i;
    var r = jo[i], u;
    for (u in r) if (r.hasOwnProperty(u) && u in ug) return Mi[i] = r[u];
    return i;
  }
  var Bw = xp("animationend"), Qw = xp("animationiteration"), Yw = xp("animationstart"), Gw = xp("transitionend"), cg = /* @__PURE__ */ new Map(), Rp = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function ha(i, r) {
    cg.set(i, r), v(r, [i]);
  }
  for (var dg = 0; dg < Rp.length; dg++) {
    var Bo = Rp[dg], rk = Bo.toLowerCase(), ak = Bo[0].toUpperCase() + Bo.slice(1);
    ha(rk, "on" + ak);
  }
  ha(Bw, "onAnimationEnd"), ha(Qw, "onAnimationIteration"), ha(Yw, "onAnimationStart"), ha("dblclick", "onDoubleClick"), ha("focusin", "onFocus"), ha("focusout", "onBlur"), ha(Gw, "onTransitionEnd"), y("onMouseEnter", ["mouseout", "mouseover"]), y("onMouseLeave", ["mouseout", "mouseover"]), y("onPointerEnter", ["pointerout", "pointerover"]), y("onPointerLeave", ["pointerout", "pointerover"]), v("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), v("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), v("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), v("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), v("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), v("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), fg = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
  function Dp(i, r, u) {
    var p = i.type || "unknown-event";
    i.currentTarget = u, up(p, r, void 0, i), i.currentTarget = null;
  }
  function Qo(i, r) {
    r = (r & 4) !== 0;
    for (var u = 0; u < i.length; u++) {
      var p = i[u], g = p.event;
      p = p.listeners;
      e: {
        var w = void 0;
        if (r) for (var b = p.length - 1; 0 <= b; b--) {
          var O = p[b], P = O.instance, j = O.currentTarget;
          if (O = O.listener, P !== w && g.isPropagationStopped()) break e;
          Dp(g, O, j), w = P;
        }
        else for (b = 0; b < p.length; b++) {
          if (O = p[b], P = O.instance, j = O.currentTarget, O = O.listener, P !== w && g.isPropagationStopped()) break e;
          Dp(g, O, j), w = P;
        }
      }
    }
    if (lc) throw i = Bd, lc = !1, Bd = null, i;
  }
  function Yt(i, r) {
    var u = r[df];
    u === void 0 && (u = r[df] = /* @__PURE__ */ new Set());
    var p = i + "__bubble";
    u.has(p) || (Ww(r, i, 2, !1), u.add(p));
  }
  function Mp(i, r, u) {
    var p = 0;
    r && (p |= 4), Ww(u, i, p, r);
  }
  var Lp = "_reactListening" + Math.random().toString(36).slice(2);
  function yc(i) {
    if (!i[Lp]) {
      i[Lp] = !0, o.forEach(function(u) {
        u !== "selectionchange" && (fg.has(u) || Mp(u, !1, i), Mp(u, !0, i));
      });
      var r = i.nodeType === 9 ? i : i.ownerDocument;
      r === null || r[Lp] || (r[Lp] = !0, Mp("selectionchange", !1, r));
    }
  }
  function Ww(i, r, u, p) {
    switch (pp(r)) {
      case 1:
        var g = bw;
        break;
      case 4:
        g = kw;
        break;
      default:
        g = fp;
    }
    u = g.bind(null, r, u, i), g = void 0, !xl || r !== "touchstart" && r !== "touchmove" && r !== "wheel" || (g = !0), p ? g !== void 0 ? i.addEventListener(r, u, { capture: !0, passive: g }) : i.addEventListener(r, u, !0) : g !== void 0 ? i.addEventListener(r, u, { passive: g }) : i.addEventListener(r, u, !1);
  }
  function $p(i, r, u, p, g) {
    var w = p;
    if (!(r & 1) && !(r & 2) && p !== null) e: for (; ; ) {
      if (p === null) return;
      var b = p.tag;
      if (b === 3 || b === 4) {
        var O = p.stateNode.containerInfo;
        if (O === g || O.nodeType === 8 && O.parentNode === g) break;
        if (b === 4) for (b = p.return; b !== null; ) {
          var P = b.tag;
          if ((P === 3 || P === 4) && (P = b.stateNode.containerInfo, P === g || P.nodeType === 8 && P.parentNode === g)) return;
          b = b.return;
        }
        for (; O !== null; ) {
          if (b = Go(O), b === null) return;
          if (P = b.tag, P === 5 || P === 6) {
            p = w = b;
            continue e;
          }
          O = O.parentNode;
        }
      }
      p = p.return;
    }
    Oy(function() {
      var j = w, ie = $n(u), re = [];
      e: {
        var te = cg.get(i);
        if (te !== void 0) {
          var Te = Sp, ke = i;
          switch (i) {
            case "keypress":
              if (vp(u) === 0) break e;
            case "keydown":
            case "keyup":
              Te = eg;
              break;
            case "focusin":
              ke = "focus", Te = Tp;
              break;
            case "focusout":
              ke = "blur", Te = Tp;
              break;
            case "beforeblur":
            case "afterblur":
              Te = Tp;
              break;
            case "click":
              if (u.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Te = Gy;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Te = fc;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Te = Lw;
              break;
            case Bw:
            case Qw:
            case Yw:
              Te = G0;
              break;
            case Gw:
              Te = Bs;
              break;
            case "scroll":
              Te = B0;
              break;
            case "wheel":
              Te = Qs;
              break;
            case "copy":
            case "cut":
            case "paste":
              Te = xw;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Te = Mw;
          }
          var De = (r & 4) !== 0, Hn = !De && i === "scroll", F = De ? te !== null ? te + "Capture" : null : te;
          De = [];
          for (var U = j, I; U !== null; ) {
            I = U;
            var le = I.stateNode;
            if (I.tag === 5 && le !== null && (I = le, F !== null && (le = Ao(U, F), le != null && De.push(gc(U, le, I)))), Hn) break;
            U = U.return;
          }
          0 < De.length && (te = new Te(te, ke, null, u, ie), re.push({ event: te, listeners: De }));
        }
      }
      if (!(r & 7)) {
        e: {
          if (te = i === "mouseover" || i === "pointerover", Te = i === "mouseout" || i === "pointerout", te && u !== Qn && (ke = u.relatedTarget || u.fromElement) && (Go(ke) || ke[Ys])) break e;
          if ((Te || te) && (te = ie.window === ie ? ie : (te = ie.ownerDocument) ? te.defaultView || te.parentWindow : window, Te ? (ke = u.relatedTarget || u.toElement, Te = j, ke = ke ? Go(ke) : null, ke !== null && (Hn = Va(ke), ke !== Hn || ke.tag !== 5 && ke.tag !== 6) && (ke = null)) : (Te = null, ke = j), Te !== ke)) {
            if (De = Gy, le = "onMouseLeave", F = "onMouseEnter", U = "mouse", (i === "pointerout" || i === "pointerover") && (De = Mw, le = "onPointerLeave", F = "onPointerEnter", U = "pointer"), Hn = Te == null ? te : ja(Te), I = ke == null ? te : ja(ke), te = new De(le, U + "leave", Te, u, ie), te.target = Hn, te.relatedTarget = I, le = null, Go(ie) === j && (De = new De(F, U + "enter", ke, u, ie), De.target = I, De.relatedTarget = Hn, le = De), Hn = le, Te && ke) t: {
              for (De = Te, F = ke, U = 0, I = De; I; I = $l(I)) U++;
              for (I = 0, le = F; le; le = $l(le)) I++;
              for (; 0 < U - I; ) De = $l(De), U--;
              for (; 0 < I - U; ) F = $l(F), I--;
              for (; U--; ) {
                if (De === F || F !== null && De === F.alternate) break t;
                De = $l(De), F = $l(F);
              }
              De = null;
            }
            else De = null;
            Te !== null && Kw(re, te, Te, De, !1), ke !== null && Hn !== null && Kw(re, Hn, ke, De, !0);
          }
        }
        e: {
          if (te = j ? ja(j) : window, Te = te.nodeName && te.nodeName.toLowerCase(), Te === "select" || Te === "input" && te.type === "file") var ge = J0;
          else if (Nw(te)) if (zw) ge = qw;
          else {
            ge = Iw;
            var Ne = ek;
          }
          else (Te = te.nodeName) && Te.toLowerCase() === "input" && (te.type === "checkbox" || te.type === "radio") && (ge = tk);
          if (ge && (ge = ge(i, j))) {
            ig(re, ge, u, ie);
            break e;
          }
          Ne && Ne(i, te, j), i === "focusout" && (Ne = te._wrapperState) && Ne.controlled && te.type === "number" && qd(te, "number", te.value);
        }
        switch (Ne = j ? ja(j) : window, i) {
          case "focusin":
            (Nw(Ne) || Ne.contentEditable === "true") && (vc = Ne, sg = j, sf = null);
            break;
          case "focusout":
            sf = sg = vc = null;
            break;
          case "mousedown":
            lg = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            lg = !1, og(re, u, ie);
            break;
          case "selectionchange":
            if (ik) break;
          case "keydown":
          case "keyup":
            og(re, u, ie);
        }
        var Fe;
        if (hc) e: {
          switch (i) {
            case "compositionstart":
              var We = "onCompositionStart";
              break e;
            case "compositionend":
              We = "onCompositionEnd";
              break e;
            case "compositionupdate":
              We = "onCompositionUpdate";
              break e;
          }
          We = void 0;
        }
        else pc ? Aw(i, u) && (We = "onCompositionEnd") : i === "keydown" && u.keyCode === 229 && (We = "onCompositionStart");
        We && ($w && u.locale !== "ko" && (pc || We !== "onCompositionStart" ? We === "onCompositionEnd" && pc && (Fe = Qy()) : (qs = ie, mp = "value" in qs ? qs.value : qs.textContent, pc = !0)), Ne = of(j, We), 0 < Ne.length && (We = new Xy(We, i, null, u, ie), re.push({ event: We, listeners: Ne }), Fe ? We.data = Fe : (Fe = Pw(u), Fe !== null && (We.data = Fe)))), (Fe = tf ? _w(i, u) : X0(i, u)) && (j = of(j, "onBeforeInput"), 0 < j.length && (ie = new Xy("onBeforeInput", "beforeinput", null, u, ie), re.push({ event: ie, listeners: j }), ie.data = Fe));
      }
      Qo(re, r);
    });
  }
  function gc(i, r, u) {
    return { instance: i, listener: r, currentTarget: u };
  }
  function of(i, r) {
    for (var u = r + "Capture", p = []; i !== null; ) {
      var g = i, w = g.stateNode;
      g.tag === 5 && w !== null && (g = w, w = Ao(i, u), w != null && p.unshift(gc(i, w, g)), w = Ao(i, r), w != null && p.push(gc(i, w, g))), i = i.return;
    }
    return p;
  }
  function $l(i) {
    if (i === null) return null;
    do
      i = i.return;
    while (i && i.tag !== 5);
    return i || null;
  }
  function Kw(i, r, u, p, g) {
    for (var w = r._reactName, b = []; u !== null && u !== p; ) {
      var O = u, P = O.alternate, j = O.stateNode;
      if (P !== null && P === p) break;
      O.tag === 5 && j !== null && (O = j, g ? (P = Ao(u, w), P != null && b.unshift(gc(u, P, O))) : g || (P = Ao(u, w), P != null && b.push(gc(u, P, O)))), u = u.return;
    }
    b.length !== 0 && i.push({ event: r, listeners: b });
  }
  var Xw = /\r\n?/g, sk = /\u0000|\uFFFD/g;
  function Zw(i) {
    return (typeof i == "string" ? i : "" + i).replace(Xw, `
`).replace(sk, "");
  }
  function Op(i, r, u) {
    if (r = Zw(r), Zw(i) !== r && u) throw Error(n(425));
  }
  function Ol() {
  }
  var uf = null, Yo = null;
  function Ap(i, r) {
    return i === "textarea" || i === "noscript" || typeof r.children == "string" || typeof r.children == "number" || typeof r.dangerouslySetInnerHTML == "object" && r.dangerouslySetInnerHTML !== null && r.dangerouslySetInnerHTML.__html != null;
  }
  var Pp = typeof setTimeout == "function" ? setTimeout : void 0, hg = typeof clearTimeout == "function" ? clearTimeout : void 0, Jw = typeof Promise == "function" ? Promise : void 0, Sc = typeof queueMicrotask == "function" ? queueMicrotask : typeof Jw < "u" ? function(i) {
    return Jw.resolve(null).then(i).catch(_p);
  } : Pp;
  function _p(i) {
    setTimeout(function() {
      throw i;
    });
  }
  function Tc(i, r) {
    var u = r, p = 0;
    do {
      var g = u.nextSibling;
      if (i.removeChild(u), g && g.nodeType === 8) if (u = g.data, u === "/$") {
        if (p === 0) {
          i.removeChild(g), Ml(r);
          return;
        }
        p--;
      } else u !== "$" && u !== "$?" && u !== "$!" || p++;
      u = g;
    } while (u);
    Ml(r);
  }
  function hs(i) {
    for (; i != null; i = i.nextSibling) {
      var r = i.nodeType;
      if (r === 1 || r === 3) break;
      if (r === 8) {
        if (r = i.data, r === "$" || r === "$!" || r === "$?") break;
        if (r === "/$") return null;
      }
    }
    return i;
  }
  function eE(i) {
    i = i.previousSibling;
    for (var r = 0; i; ) {
      if (i.nodeType === 8) {
        var u = i.data;
        if (u === "$" || u === "$!" || u === "$?") {
          if (r === 0) return i;
          r--;
        } else u === "/$" && r++;
      }
      i = i.previousSibling;
    }
    return null;
  }
  var Al = Math.random().toString(36).slice(2), ps = "__reactFiber$" + Al, cf = "__reactProps$" + Al, Ys = "__reactContainer$" + Al, df = "__reactEvents$" + Al, wc = "__reactListeners$" + Al, lk = "__reactHandles$" + Al;
  function Go(i) {
    var r = i[ps];
    if (r) return r;
    for (var u = i.parentNode; u; ) {
      if (r = u[Ys] || u[ps]) {
        if (u = r.alternate, r.child !== null || u !== null && u.child !== null) for (i = eE(i); i !== null; ) {
          if (u = i[ps]) return u;
          i = eE(i);
        }
        return r;
      }
      i = u, u = i.parentNode;
    }
    return null;
  }
  function Pe(i) {
    return i = i[ps] || i[Ys], !i || i.tag !== 5 && i.tag !== 6 && i.tag !== 13 && i.tag !== 3 ? null : i;
  }
  function ja(i) {
    if (i.tag === 5 || i.tag === 6) return i.stateNode;
    throw Error(n(33));
  }
  function Nn(i) {
    return i[cf] || null;
  }
  var Et = [], pa = -1;
  function Ba(i) {
    return { current: i };
  }
  function un(i) {
    0 > pa || (i.current = Et[pa], Et[pa] = null, pa--);
  }
  function Oe(i, r) {
    pa++, Et[pa] = i.current, i.current = r;
  }
  var kr = {}, An = Ba(kr), oi = Ba(!1), xr = kr;
  function ma(i, r) {
    var u = i.type.contextTypes;
    if (!u) return kr;
    var p = i.stateNode;
    if (p && p.__reactInternalMemoizedUnmaskedChildContext === r) return p.__reactInternalMemoizedMaskedChildContext;
    var g = {}, w;
    for (w in u) g[w] = r[w];
    return p && (i = i.stateNode, i.__reactInternalMemoizedUnmaskedChildContext = r, i.__reactInternalMemoizedMaskedChildContext = g), g;
  }
  function Gn(i) {
    return i = i.childContextTypes, i != null;
  }
  function Ec() {
    un(oi), un(An);
  }
  function tE(i, r, u) {
    if (An.current !== kr) throw Error(n(168));
    Oe(An, r), Oe(oi, u);
  }
  function ff(i, r, u) {
    var p = i.stateNode;
    if (r = r.childContextTypes, typeof p.getChildContext != "function") return u;
    p = p.getChildContext();
    for (var g in p) if (!(g in r)) throw Error(n(108, ai(i) || "Unknown", g));
    return he({}, u, p);
  }
  function Rr(i) {
    return i = (i = i.stateNode) && i.__reactInternalMemoizedMergedChildContext || kr, xr = An.current, Oe(An, i), Oe(oi, oi.current), !0;
  }
  function Np(i, r, u) {
    var p = i.stateNode;
    if (!p) throw Error(n(169));
    u ? (i = ff(i, r, xr), p.__reactInternalMemoizedMergedChildContext = i, un(oi), un(An), Oe(An, i)) : un(oi), Oe(oi, u);
  }
  var ms = null, Cc = !1, Gs = !1;
  function Up(i) {
    ms === null ? ms = [i] : ms.push(i);
  }
  function Pl(i) {
    Cc = !0, Up(i);
  }
  function vs() {
    if (!Gs && ms !== null) {
      Gs = !0;
      var i = 0, r = Xt;
      try {
        var u = ms;
        for (Xt = 1; i < u.length; i++) {
          var p = u[i];
          do
            p = p(!0);
          while (p !== null);
        }
        ms = null, Cc = !1;
      } catch (g) {
        throw ms !== null && (ms = ms.slice(i + 1)), gw(_o, vs), g;
      } finally {
        Xt = r, Gs = !1;
      }
    }
    return null;
  }
  var _l = [], Nl = 0, Ul = null, Ws = 0, Wn = [], va = 0, Br = null, ys = 1, gs = "";
  function Wo(i, r) {
    _l[Nl++] = Ws, _l[Nl++] = Ul, Ul = i, Ws = r;
  }
  function nE(i, r, u) {
    Wn[va++] = ys, Wn[va++] = gs, Wn[va++] = Br, Br = i;
    var p = ys;
    i = gs;
    var g = 32 - ca(p) - 1;
    p &= ~(1 << g), u += 1;
    var w = 32 - ca(r) + g;
    if (30 < w) {
      var b = g - g % 5;
      w = (p & (1 << b) - 1).toString(32), p >>= b, g -= b, ys = 1 << 32 - ca(r) + g | u << g | p, gs = w + i;
    } else ys = 1 << w | u << g | p, gs = i;
  }
  function zp(i) {
    i.return !== null && (Wo(i, 1), nE(i, 1, 0));
  }
  function Fp(i) {
    for (; i === Ul; ) Ul = _l[--Nl], _l[Nl] = null, Ws = _l[--Nl], _l[Nl] = null;
    for (; i === Br; ) Br = Wn[--va], Wn[va] = null, gs = Wn[--va], Wn[va] = null, ys = Wn[--va], Wn[va] = null;
  }
  var Dr = null, Mr = null, Tn = !1, ya = null;
  function pg(i, r) {
    var u = Ea(5, null, null, 0);
    u.elementType = "DELETED", u.stateNode = r, u.return = i, r = i.deletions, r === null ? (i.deletions = [u], i.flags |= 16) : r.push(u);
  }
  function iE(i, r) {
    switch (i.tag) {
      case 5:
        var u = i.type;
        return r = r.nodeType !== 1 || u.toLowerCase() !== r.nodeName.toLowerCase() ? null : r, r !== null ? (i.stateNode = r, Dr = i, Mr = hs(r.firstChild), !0) : !1;
      case 6:
        return r = i.pendingProps === "" || r.nodeType !== 3 ? null : r, r !== null ? (i.stateNode = r, Dr = i, Mr = null, !0) : !1;
      case 13:
        return r = r.nodeType !== 8 ? null : r, r !== null ? (u = Br !== null ? { id: ys, overflow: gs } : null, i.memoizedState = { dehydrated: r, treeContext: u, retryLane: 1073741824 }, u = Ea(18, null, null, 0), u.stateNode = r, u.return = i, i.child = u, Dr = i, Mr = null, !0) : !1;
      default:
        return !1;
    }
  }
  function mg(i) {
    return (i.mode & 1) !== 0 && (i.flags & 128) === 0;
  }
  function vg(i) {
    if (Tn) {
      var r = Mr;
      if (r) {
        var u = r;
        if (!iE(i, r)) {
          if (mg(i)) throw Error(n(418));
          r = hs(u.nextSibling);
          var p = Dr;
          r && iE(i, r) ? pg(p, u) : (i.flags = i.flags & -4097 | 2, Tn = !1, Dr = i);
        }
      } else {
        if (mg(i)) throw Error(n(418));
        i.flags = i.flags & -4097 | 2, Tn = !1, Dr = i;
      }
    }
  }
  function ui(i) {
    for (i = i.return; i !== null && i.tag !== 5 && i.tag !== 3 && i.tag !== 13; ) i = i.return;
    Dr = i;
  }
  function Vp(i) {
    if (i !== Dr) return !1;
    if (!Tn) return ui(i), Tn = !0, !1;
    var r;
    if ((r = i.tag !== 3) && !(r = i.tag !== 5) && (r = i.type, r = r !== "head" && r !== "body" && !Ap(i.type, i.memoizedProps)), r && (r = Mr)) {
      if (mg(i)) throw hf(), Error(n(418));
      for (; r; ) pg(i, r), r = hs(r.nextSibling);
    }
    if (ui(i), i.tag === 13) {
      if (i = i.memoizedState, i = i !== null ? i.dehydrated : null, !i) throw Error(n(317));
      e: {
        for (i = i.nextSibling, r = 0; i; ) {
          if (i.nodeType === 8) {
            var u = i.data;
            if (u === "/$") {
              if (r === 0) {
                Mr = hs(i.nextSibling);
                break e;
              }
              r--;
            } else u !== "$" && u !== "$!" && u !== "$?" || r++;
          }
          i = i.nextSibling;
        }
        Mr = null;
      }
    } else Mr = Dr ? hs(i.stateNode.nextSibling) : null;
    return !0;
  }
  function hf() {
    for (var i = Mr; i; ) i = hs(i.nextSibling);
  }
  function zl() {
    Mr = Dr = null, Tn = !1;
  }
  function Ks(i) {
    ya === null ? ya = [i] : ya.push(i);
  }
  var ok = ct.ReactCurrentBatchConfig;
  function Ko(i, r, u) {
    if (i = u.ref, i !== null && typeof i != "function" && typeof i != "object") {
      if (u._owner) {
        if (u = u._owner, u) {
          if (u.tag !== 1) throw Error(n(309));
          var p = u.stateNode;
        }
        if (!p) throw Error(n(147, i));
        var g = p, w = "" + i;
        return r !== null && r.ref !== null && typeof r.ref == "function" && r.ref._stringRef === w ? r.ref : (r = function(b) {
          var O = g.refs;
          b === null ? delete O[w] : O[w] = b;
        }, r._stringRef = w, r);
      }
      if (typeof i != "string") throw Error(n(284));
      if (!u._owner) throw Error(n(290, i));
    }
    return i;
  }
  function Hp(i, r) {
    throw i = Object.prototype.toString.call(r), Error(n(31, i === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : i));
  }
  function rE(i) {
    var r = i._init;
    return r(i._payload);
  }
  function Xo(i) {
    function r(F, U) {
      if (i) {
        var I = F.deletions;
        I === null ? (F.deletions = [U], F.flags |= 16) : I.push(U);
      }
    }
    function u(F, U) {
      if (!i) return null;
      for (; U !== null; ) r(F, U), U = U.sibling;
      return null;
    }
    function p(F, U) {
      for (F = /* @__PURE__ */ new Map(); U !== null; ) U.key !== null ? F.set(U.key, U) : F.set(U.index, U), U = U.sibling;
      return F;
    }
    function g(F, U) {
      return F = Ql(F, U), F.index = 0, F.sibling = null, F;
    }
    function w(F, U, I) {
      return F.index = I, i ? (I = F.alternate, I !== null ? (I = I.index, I < U ? (F.flags |= 2, U) : I) : (F.flags |= 2, U)) : (F.flags |= 1048576, U);
    }
    function b(F) {
      return i && F.alternate === null && (F.flags |= 2), F;
    }
    function O(F, U, I, le) {
      return U === null || U.tag !== 6 ? (U = Yg(I, F.mode, le), U.return = F, U) : (U = g(U, I), U.return = F, U);
    }
    function P(F, U, I, le) {
      var ge = I.type;
      return ge === He ? ie(F, U, I.props.children, le, I.key) : U !== null && (U.elementType === ge || typeof ge == "object" && ge !== null && ge.$$typeof === Je && rE(ge) === U.type) ? (le = g(U, I.props), le.ref = Ko(F, U, I), le.return = F, le) : (le = qf(I.type, I.key, I.props, null, F.mode, le), le.ref = Ko(F, U, I), le.return = F, le);
    }
    function j(F, U, I, le) {
      return U === null || U.tag !== 4 || U.stateNode.containerInfo !== I.containerInfo || U.stateNode.implementation !== I.implementation ? (U = Tm(I, F.mode, le), U.return = F, U) : (U = g(U, I.children || []), U.return = F, U);
    }
    function ie(F, U, I, le, ge) {
      return U === null || U.tag !== 7 ? (U = nl(I, F.mode, le, ge), U.return = F, U) : (U = g(U, I), U.return = F, U);
    }
    function re(F, U, I) {
      if (typeof U == "string" && U !== "" || typeof U == "number") return U = Yg("" + U, F.mode, I), U.return = F, U;
      if (typeof U == "object" && U !== null) {
        switch (U.$$typeof) {
          case Ye:
            return I = qf(U.type, U.key, U.props, null, F.mode, I), I.ref = Ko(F, null, U), I.return = F, I;
          case Tt:
            return U = Tm(U, F.mode, I), U.return = F, U;
          case Je:
            var le = U._init;
            return re(F, le(U._payload), I);
        }
        if (Lo(U) || Le(U)) return U = nl(U, F.mode, I, null), U.return = F, U;
        Hp(F, U);
      }
      return null;
    }
    function te(F, U, I, le) {
      var ge = U !== null ? U.key : null;
      if (typeof I == "string" && I !== "" || typeof I == "number") return ge !== null ? null : O(F, U, "" + I, le);
      if (typeof I == "object" && I !== null) {
        switch (I.$$typeof) {
          case Ye:
            return I.key === ge ? P(F, U, I, le) : null;
          case Tt:
            return I.key === ge ? j(F, U, I, le) : null;
          case Je:
            return ge = I._init, te(
              F,
              U,
              ge(I._payload),
              le
            );
        }
        if (Lo(I) || Le(I)) return ge !== null ? null : ie(F, U, I, le, null);
        Hp(F, I);
      }
      return null;
    }
    function Te(F, U, I, le, ge) {
      if (typeof le == "string" && le !== "" || typeof le == "number") return F = F.get(I) || null, O(U, F, "" + le, ge);
      if (typeof le == "object" && le !== null) {
        switch (le.$$typeof) {
          case Ye:
            return F = F.get(le.key === null ? I : le.key) || null, P(U, F, le, ge);
          case Tt:
            return F = F.get(le.key === null ? I : le.key) || null, j(U, F, le, ge);
          case Je:
            var Ne = le._init;
            return Te(F, U, I, Ne(le._payload), ge);
        }
        if (Lo(le) || Le(le)) return F = F.get(I) || null, ie(U, F, le, ge, null);
        Hp(U, le);
      }
      return null;
    }
    function ke(F, U, I, le) {
      for (var ge = null, Ne = null, Fe = U, We = U = 0, di = null; Fe !== null && We < I.length; We++) {
        Fe.index > We ? (di = Fe, Fe = null) : di = Fe.sibling;
        var Ft = te(F, Fe, I[We], le);
        if (Ft === null) {
          Fe === null && (Fe = di);
          break;
        }
        i && Fe && Ft.alternate === null && r(F, Fe), U = w(Ft, U, We), Ne === null ? ge = Ft : Ne.sibling = Ft, Ne = Ft, Fe = di;
      }
      if (We === I.length) return u(F, Fe), Tn && Wo(F, We), ge;
      if (Fe === null) {
        for (; We < I.length; We++) Fe = re(F, I[We], le), Fe !== null && (U = w(Fe, U, We), Ne === null ? ge = Fe : Ne.sibling = Fe, Ne = Fe);
        return Tn && Wo(F, We), ge;
      }
      for (Fe = p(F, Fe); We < I.length; We++) di = Te(Fe, F, We, I[We], le), di !== null && (i && di.alternate !== null && Fe.delete(di.key === null ? We : di.key), U = w(di, U, We), Ne === null ? ge = di : Ne.sibling = di, Ne = di);
      return i && Fe.forEach(function(Wl) {
        return r(F, Wl);
      }), Tn && Wo(F, We), ge;
    }
    function De(F, U, I, le) {
      var ge = Le(I);
      if (typeof ge != "function") throw Error(n(150));
      if (I = ge.call(I), I == null) throw Error(n(151));
      for (var Ne = ge = null, Fe = U, We = U = 0, di = null, Ft = I.next(); Fe !== null && !Ft.done; We++, Ft = I.next()) {
        Fe.index > We ? (di = Fe, Fe = null) : di = Fe.sibling;
        var Wl = te(F, Fe, Ft.value, le);
        if (Wl === null) {
          Fe === null && (Fe = di);
          break;
        }
        i && Fe && Wl.alternate === null && r(F, Fe), U = w(Wl, U, We), Ne === null ? ge = Wl : Ne.sibling = Wl, Ne = Wl, Fe = di;
      }
      if (Ft.done) return u(
        F,
        Fe
      ), Tn && Wo(F, We), ge;
      if (Fe === null) {
        for (; !Ft.done; We++, Ft = I.next()) Ft = re(F, Ft.value, le), Ft !== null && (U = w(Ft, U, We), Ne === null ? ge = Ft : Ne.sibling = Ft, Ne = Ft);
        return Tn && Wo(F, We), ge;
      }
      for (Fe = p(F, Fe); !Ft.done; We++, Ft = I.next()) Ft = Te(Fe, F, We, Ft.value, le), Ft !== null && (i && Ft.alternate !== null && Fe.delete(Ft.key === null ? We : Ft.key), U = w(Ft, U, We), Ne === null ? ge = Ft : Ne.sibling = Ft, Ne = Ft);
      return i && Fe.forEach(function(Ek) {
        return r(F, Ek);
      }), Tn && Wo(F, We), ge;
    }
    function Hn(F, U, I, le) {
      if (typeof I == "object" && I !== null && I.type === He && I.key === null && (I = I.props.children), typeof I == "object" && I !== null) {
        switch (I.$$typeof) {
          case Ye:
            e: {
              for (var ge = I.key, Ne = U; Ne !== null; ) {
                if (Ne.key === ge) {
                  if (ge = I.type, ge === He) {
                    if (Ne.tag === 7) {
                      u(F, Ne.sibling), U = g(Ne, I.props.children), U.return = F, F = U;
                      break e;
                    }
                  } else if (Ne.elementType === ge || typeof ge == "object" && ge !== null && ge.$$typeof === Je && rE(ge) === Ne.type) {
                    u(F, Ne.sibling), U = g(Ne, I.props), U.ref = Ko(F, Ne, I), U.return = F, F = U;
                    break e;
                  }
                  u(F, Ne);
                  break;
                } else r(F, Ne);
                Ne = Ne.sibling;
              }
              I.type === He ? (U = nl(I.props.children, F.mode, le, I.key), U.return = F, F = U) : (le = qf(I.type, I.key, I.props, null, F.mode, le), le.ref = Ko(F, U, I), le.return = F, F = le);
            }
            return b(F);
          case Tt:
            e: {
              for (Ne = I.key; U !== null; ) {
                if (U.key === Ne) if (U.tag === 4 && U.stateNode.containerInfo === I.containerInfo && U.stateNode.implementation === I.implementation) {
                  u(F, U.sibling), U = g(U, I.children || []), U.return = F, F = U;
                  break e;
                } else {
                  u(F, U);
                  break;
                }
                else r(F, U);
                U = U.sibling;
              }
              U = Tm(I, F.mode, le), U.return = F, F = U;
            }
            return b(F);
          case Je:
            return Ne = I._init, Hn(F, U, Ne(I._payload), le);
        }
        if (Lo(I)) return ke(F, U, I, le);
        if (Le(I)) return De(F, U, I, le);
        Hp(F, I);
      }
      return typeof I == "string" && I !== "" || typeof I == "number" ? (I = "" + I, U !== null && U.tag === 6 ? (u(F, U.sibling), U = g(U, I), U.return = F, F = U) : (u(F, U), U = Yg(I, F.mode, le), U.return = F, F = U), b(F)) : u(F, U);
    }
    return Hn;
  }
  var Un = Xo(!0), me = Xo(!1), Qr = Ba(null), Lr = null, bc = null, yg = null;
  function gg() {
    yg = bc = Lr = null;
  }
  function Sg(i) {
    var r = Qr.current;
    un(Qr), i._currentValue = r;
  }
  function Tg(i, r, u) {
    for (; i !== null; ) {
      var p = i.alternate;
      if ((i.childLanes & r) !== r ? (i.childLanes |= r, p !== null && (p.childLanes |= r)) : p !== null && (p.childLanes & r) !== r && (p.childLanes |= r), i === u) break;
      i = i.return;
    }
  }
  function Cn(i, r) {
    Lr = i, yg = bc = null, i = i.dependencies, i !== null && i.firstContext !== null && (i.lanes & r && (Xn = !0), i.firstContext = null);
  }
  function ga(i) {
    var r = i._currentValue;
    if (yg !== i) if (i = { context: i, memoizedValue: r, next: null }, bc === null) {
      if (Lr === null) throw Error(n(308));
      bc = i, Lr.dependencies = { lanes: 0, firstContext: i };
    } else bc = bc.next = i;
    return r;
  }
  var Zo = null;
  function wg(i) {
    Zo === null ? Zo = [i] : Zo.push(i);
  }
  function Eg(i, r, u, p) {
    var g = r.interleaved;
    return g === null ? (u.next = u, wg(r)) : (u.next = g.next, g.next = u), r.interleaved = u, Yr(i, p);
  }
  function Yr(i, r) {
    i.lanes |= r;
    var u = i.alternate;
    for (u !== null && (u.lanes |= r), u = i, i = i.return; i !== null; ) i.childLanes |= r, u = i.alternate, u !== null && (u.childLanes |= r), u = i, i = i.return;
    return u.tag === 3 ? u.stateNode : null;
  }
  var Gr = !1;
  function Cg(i) {
    i.updateQueue = { baseState: i.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function aE(i, r) {
    i = i.updateQueue, r.updateQueue === i && (r.updateQueue = { baseState: i.baseState, firstBaseUpdate: i.firstBaseUpdate, lastBaseUpdate: i.lastBaseUpdate, shared: i.shared, effects: i.effects });
  }
  function Xs(i, r) {
    return { eventTime: i, lane: r, tag: 0, payload: null, callback: null, next: null };
  }
  function Fl(i, r, u) {
    var p = i.updateQueue;
    if (p === null) return null;
    if (p = p.shared, Ct & 2) {
      var g = p.pending;
      return g === null ? r.next = r : (r.next = g.next, g.next = r), p.pending = r, Yr(i, u);
    }
    return g = p.interleaved, g === null ? (r.next = r, wg(p)) : (r.next = g.next, g.next = r), p.interleaved = r, Yr(i, u);
  }
  function Ip(i, r, u) {
    if (r = r.updateQueue, r !== null && (r = r.shared, (u & 4194240) !== 0)) {
      var p = r.lanes;
      p &= i.pendingLanes, u |= p, r.lanes = u, dp(i, u);
    }
  }
  function sE(i, r) {
    var u = i.updateQueue, p = i.alternate;
    if (p !== null && (p = p.updateQueue, u === p)) {
      var g = null, w = null;
      if (u = u.firstBaseUpdate, u !== null) {
        do {
          var b = { eventTime: u.eventTime, lane: u.lane, tag: u.tag, payload: u.payload, callback: u.callback, next: null };
          w === null ? g = w = b : w = w.next = b, u = u.next;
        } while (u !== null);
        w === null ? g = w = r : w = w.next = r;
      } else g = w = r;
      u = { baseState: p.baseState, firstBaseUpdate: g, lastBaseUpdate: w, shared: p.shared, effects: p.effects }, i.updateQueue = u;
      return;
    }
    i = u.lastBaseUpdate, i === null ? u.firstBaseUpdate = r : i.next = r, u.lastBaseUpdate = r;
  }
  function pf(i, r, u, p) {
    var g = i.updateQueue;
    Gr = !1;
    var w = g.firstBaseUpdate, b = g.lastBaseUpdate, O = g.shared.pending;
    if (O !== null) {
      g.shared.pending = null;
      var P = O, j = P.next;
      P.next = null, b === null ? w = j : b.next = j, b = P;
      var ie = i.alternate;
      ie !== null && (ie = ie.updateQueue, O = ie.lastBaseUpdate, O !== b && (O === null ? ie.firstBaseUpdate = j : O.next = j, ie.lastBaseUpdate = P));
    }
    if (w !== null) {
      var re = g.baseState;
      b = 0, ie = j = P = null, O = w;
      do {
        var te = O.lane, Te = O.eventTime;
        if ((p & te) === te) {
          ie !== null && (ie = ie.next = {
            eventTime: Te,
            lane: 0,
            tag: O.tag,
            payload: O.payload,
            callback: O.callback,
            next: null
          });
          e: {
            var ke = i, De = O;
            switch (te = r, Te = u, De.tag) {
              case 1:
                if (ke = De.payload, typeof ke == "function") {
                  re = ke.call(Te, re, te);
                  break e;
                }
                re = ke;
                break e;
              case 3:
                ke.flags = ke.flags & -65537 | 128;
              case 0:
                if (ke = De.payload, te = typeof ke == "function" ? ke.call(Te, re, te) : ke, te == null) break e;
                re = he({}, re, te);
                break e;
              case 2:
                Gr = !0;
            }
          }
          O.callback !== null && O.lane !== 0 && (i.flags |= 64, te = g.effects, te === null ? g.effects = [O] : te.push(O));
        } else Te = { eventTime: Te, lane: te, tag: O.tag, payload: O.payload, callback: O.callback, next: null }, ie === null ? (j = ie = Te, P = re) : ie = ie.next = Te, b |= te;
        if (O = O.next, O === null) {
          if (O = g.shared.pending, O === null) break;
          te = O, O = te.next, te.next = null, g.lastBaseUpdate = te, g.shared.pending = null;
        }
      } while (!0);
      if (ie === null && (P = re), g.baseState = P, g.firstBaseUpdate = j, g.lastBaseUpdate = ie, r = g.shared.interleaved, r !== null) {
        g = r;
        do
          b |= g.lane, g = g.next;
        while (g !== r);
      } else w === null && (g.shared.lanes = 0);
      Cs |= b, i.lanes = b, i.memoizedState = re;
    }
  }
  function bg(i, r, u) {
    if (i = r.effects, r.effects = null, i !== null) for (r = 0; r < i.length; r++) {
      var p = i[r], g = p.callback;
      if (g !== null) {
        if (p.callback = null, p = u, typeof g != "function") throw Error(n(191, g));
        g.call(p);
      }
    }
  }
  var mf = {}, Ss = Ba(mf), vf = Ba(mf), yf = Ba(mf);
  function Jo(i) {
    if (i === mf) throw Error(n(174));
    return i;
  }
  function kg(i, r) {
    switch (Oe(yf, r), Oe(vf, i), Oe(Ss, mf), i = r.nodeType, i) {
      case 9:
      case 11:
        r = (r = r.documentElement) ? r.namespaceURI : $o(null, "");
        break;
      default:
        i = i === 8 ? r.parentNode : r, r = i.namespaceURI || null, i = i.tagName, r = $o(r, i);
    }
    un(Ss), Oe(Ss, r);
  }
  function eu() {
    un(Ss), un(vf), un(yf);
  }
  function lE(i) {
    Jo(yf.current);
    var r = Jo(Ss.current), u = $o(r, i.type);
    r !== u && (Oe(vf, i), Oe(Ss, u));
  }
  function qp(i) {
    vf.current === i && (un(Ss), un(vf));
  }
  var bn = Ba(0);
  function jp(i) {
    for (var r = i; r !== null; ) {
      if (r.tag === 13) {
        var u = r.memoizedState;
        if (u !== null && (u = u.dehydrated, u === null || u.data === "$?" || u.data === "$!")) return r;
      } else if (r.tag === 19 && r.memoizedProps.revealOrder !== void 0) {
        if (r.flags & 128) return r;
      } else if (r.child !== null) {
        r.child.return = r, r = r.child;
        continue;
      }
      if (r === i) break;
      for (; r.sibling === null; ) {
        if (r.return === null || r.return === i) return null;
        r = r.return;
      }
      r.sibling.return = r.return, r = r.sibling;
    }
    return null;
  }
  var gf = [];
  function _e() {
    for (var i = 0; i < gf.length; i++) gf[i]._workInProgressVersionPrimary = null;
    gf.length = 0;
  }
  var dt = ct.ReactCurrentDispatcher, Ut = ct.ReactCurrentBatchConfig, Jt = 0, zt = null, Kn = null, gi = null, Bp = !1, Sf = !1, tu = 0, ee = 0;
  function Ot() {
    throw Error(n(321));
  }
  function je(i, r) {
    if (r === null) return !1;
    for (var u = 0; u < r.length && u < i.length; u++) if (!qa(i[u], r[u])) return !1;
    return !0;
  }
  function Vl(i, r, u, p, g, w) {
    if (Jt = w, zt = r, r.memoizedState = null, r.updateQueue = null, r.lanes = 0, dt.current = i === null || i.memoizedState === null ? sm : kf, i = u(p, g), Sf) {
      w = 0;
      do {
        if (Sf = !1, tu = 0, 25 <= w) throw Error(n(301));
        w += 1, gi = Kn = null, r.updateQueue = null, dt.current = lm, i = u(p, g);
      } while (Sf);
    }
    if (dt.current = su, r = Kn !== null && Kn.next !== null, Jt = 0, gi = Kn = zt = null, Bp = !1, r) throw Error(n(300));
    return i;
  }
  function Qa() {
    var i = tu !== 0;
    return tu = 0, i;
  }
  function ji() {
    var i = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return gi === null ? zt.memoizedState = gi = i : gi = gi.next = i, gi;
  }
  function zn() {
    if (Kn === null) {
      var i = zt.alternate;
      i = i !== null ? i.memoizedState : null;
    } else i = Kn.next;
    var r = gi === null ? zt.memoizedState : gi.next;
    if (r !== null) gi = r, Kn = i;
    else {
      if (i === null) throw Error(n(310));
      Kn = i, i = { memoizedState: Kn.memoizedState, baseState: Kn.baseState, baseQueue: Kn.baseQueue, queue: Kn.queue, next: null }, gi === null ? zt.memoizedState = gi = i : gi = gi.next = i;
    }
    return gi;
  }
  function Zs(i, r) {
    return typeof r == "function" ? r(i) : r;
  }
  function Hl(i) {
    var r = zn(), u = r.queue;
    if (u === null) throw Error(n(311));
    u.lastRenderedReducer = i;
    var p = Kn, g = p.baseQueue, w = u.pending;
    if (w !== null) {
      if (g !== null) {
        var b = g.next;
        g.next = w.next, w.next = b;
      }
      p.baseQueue = g = w, u.pending = null;
    }
    if (g !== null) {
      w = g.next, p = p.baseState;
      var O = b = null, P = null, j = w;
      do {
        var ie = j.lane;
        if ((Jt & ie) === ie) P !== null && (P = P.next = { lane: 0, action: j.action, hasEagerState: j.hasEagerState, eagerState: j.eagerState, next: null }), p = j.hasEagerState ? j.eagerState : i(p, j.action);
        else {
          var re = {
            lane: ie,
            action: j.action,
            hasEagerState: j.hasEagerState,
            eagerState: j.eagerState,
            next: null
          };
          P === null ? (O = P = re, b = p) : P = P.next = re, zt.lanes |= ie, Cs |= ie;
        }
        j = j.next;
      } while (j !== null && j !== w);
      P === null ? b = p : P.next = O, qa(p, r.memoizedState) || (Xn = !0), r.memoizedState = p, r.baseState = b, r.baseQueue = P, u.lastRenderedState = p;
    }
    if (i = u.interleaved, i !== null) {
      g = i;
      do
        w = g.lane, zt.lanes |= w, Cs |= w, g = g.next;
      while (g !== i);
    } else g === null && (u.lanes = 0);
    return [r.memoizedState, u.dispatch];
  }
  function nu(i) {
    var r = zn(), u = r.queue;
    if (u === null) throw Error(n(311));
    u.lastRenderedReducer = i;
    var p = u.dispatch, g = u.pending, w = r.memoizedState;
    if (g !== null) {
      u.pending = null;
      var b = g = g.next;
      do
        w = i(w, b.action), b = b.next;
      while (b !== g);
      qa(w, r.memoizedState) || (Xn = !0), r.memoizedState = w, r.baseQueue === null && (r.baseState = w), u.lastRenderedState = w;
    }
    return [w, p];
  }
  function Qp() {
  }
  function Yp(i, r) {
    var u = zt, p = zn(), g = r(), w = !qa(p.memoizedState, g);
    if (w && (p.memoizedState = g, Xn = !0), p = p.queue, Tf(Kp.bind(null, u, p, i), [i]), p.getSnapshot !== r || w || gi !== null && gi.memoizedState.tag & 1) {
      if (u.flags |= 2048, iu(9, Wp.bind(null, u, p, g, r), void 0, null), ci === null) throw Error(n(349));
      Jt & 30 || Gp(u, r, g);
    }
    return g;
  }
  function Gp(i, r, u) {
    i.flags |= 16384, i = { getSnapshot: r, value: u }, r = zt.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, zt.updateQueue = r, r.stores = [i]) : (u = r.stores, u === null ? r.stores = [i] : u.push(i));
  }
  function Wp(i, r, u, p) {
    r.value = u, r.getSnapshot = p, Xp(r) && Zp(i);
  }
  function Kp(i, r, u) {
    return u(function() {
      Xp(r) && Zp(i);
    });
  }
  function Xp(i) {
    var r = i.getSnapshot;
    i = i.value;
    try {
      var u = r();
      return !qa(i, u);
    } catch {
      return !0;
    }
  }
  function Zp(i) {
    var r = Yr(i, 1);
    r !== null && sr(r, i, 1, -1);
  }
  function Jp(i) {
    var r = ji();
    return typeof i == "function" && (i = i()), r.memoizedState = r.baseState = i, i = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Zs, lastRenderedState: i }, r.queue = i, i = i.dispatch = au.bind(null, zt, i), [r.memoizedState, i];
  }
  function iu(i, r, u, p) {
    return i = { tag: i, create: r, destroy: u, deps: p, next: null }, r = zt.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, zt.updateQueue = r, r.lastEffect = i.next = i) : (u = r.lastEffect, u === null ? r.lastEffect = i.next = i : (p = u.next, u.next = i, i.next = p, r.lastEffect = i)), i;
  }
  function em() {
    return zn().memoizedState;
  }
  function kc(i, r, u, p) {
    var g = ji();
    zt.flags |= i, g.memoizedState = iu(1 | r, u, void 0, p === void 0 ? null : p);
  }
  function xc(i, r, u, p) {
    var g = zn();
    p = p === void 0 ? null : p;
    var w = void 0;
    if (Kn !== null) {
      var b = Kn.memoizedState;
      if (w = b.destroy, p !== null && je(p, b.deps)) {
        g.memoizedState = iu(r, u, w, p);
        return;
      }
    }
    zt.flags |= i, g.memoizedState = iu(1 | r, u, w, p);
  }
  function tm(i, r) {
    return kc(8390656, 8, i, r);
  }
  function Tf(i, r) {
    return xc(2048, 8, i, r);
  }
  function nm(i, r) {
    return xc(4, 2, i, r);
  }
  function wf(i, r) {
    return xc(4, 4, i, r);
  }
  function ru(i, r) {
    if (typeof r == "function") return i = i(), r(i), function() {
      r(null);
    };
    if (r != null) return i = i(), r.current = i, function() {
      r.current = null;
    };
  }
  function im(i, r, u) {
    return u = u != null ? u.concat([i]) : null, xc(4, 4, ru.bind(null, r, i), u);
  }
  function Ef() {
  }
  function rm(i, r) {
    var u = zn();
    r = r === void 0 ? null : r;
    var p = u.memoizedState;
    return p !== null && r !== null && je(r, p[1]) ? p[0] : (u.memoizedState = [i, r], i);
  }
  function am(i, r) {
    var u = zn();
    r = r === void 0 ? null : r;
    var p = u.memoizedState;
    return p !== null && r !== null && je(r, p[1]) ? p[0] : (i = i(), u.memoizedState = [i, r], i);
  }
  function xg(i, r, u) {
    return Jt & 21 ? (qa(u, r) || (u = cp(), zt.lanes |= u, Cs |= u, i.baseState = !0), r) : (i.baseState && (i.baseState = !1, Xn = !0), i.memoizedState = u);
  }
  function Cf(i, r) {
    var u = Xt;
    Xt = u !== 0 && 4 > u ? u : 4, i(!0);
    var p = Ut.transition;
    Ut.transition = {};
    try {
      i(!1), r();
    } finally {
      Xt = u, Ut.transition = p;
    }
  }
  function Rg() {
    return zn().memoizedState;
  }
  function bf(i, r, u) {
    var p = bs(i);
    if (u = { lane: p, action: u, hasEagerState: !1, eagerState: null, next: null }, Wr(i)) oE(r, u);
    else if (u = Eg(i, r, u, p), u !== null) {
      var g = ei();
      sr(u, i, p, g), ln(u, r, p);
    }
  }
  function au(i, r, u) {
    var p = bs(i), g = { lane: p, action: u, hasEagerState: !1, eagerState: null, next: null };
    if (Wr(i)) oE(r, g);
    else {
      var w = i.alternate;
      if (i.lanes === 0 && (w === null || w.lanes === 0) && (w = r.lastRenderedReducer, w !== null)) try {
        var b = r.lastRenderedState, O = w(b, u);
        if (g.hasEagerState = !0, g.eagerState = O, qa(O, b)) {
          var P = r.interleaved;
          P === null ? (g.next = g, wg(r)) : (g.next = P.next, P.next = g), r.interleaved = g;
          return;
        }
      } catch {
      } finally {
      }
      u = Eg(i, r, g, p), u !== null && (g = ei(), sr(u, i, p, g), ln(u, r, p));
    }
  }
  function Wr(i) {
    var r = i.alternate;
    return i === zt || r !== null && r === zt;
  }
  function oE(i, r) {
    Sf = Bp = !0;
    var u = i.pending;
    u === null ? r.next = r : (r.next = u.next, u.next = r), i.pending = r;
  }
  function ln(i, r, u) {
    if (u & 4194240) {
      var p = r.lanes;
      p &= i.pendingLanes, u |= p, r.lanes = u, dp(i, u);
    }
  }
  var su = { readContext: ga, useCallback: Ot, useContext: Ot, useEffect: Ot, useImperativeHandle: Ot, useInsertionEffect: Ot, useLayoutEffect: Ot, useMemo: Ot, useReducer: Ot, useRef: Ot, useState: Ot, useDebugValue: Ot, useDeferredValue: Ot, useTransition: Ot, useMutableSource: Ot, useSyncExternalStore: Ot, useId: Ot, unstable_isNewReconciler: !1 }, sm = { readContext: ga, useCallback: function(i, r) {
    return ji().memoizedState = [i, r === void 0 ? null : r], i;
  }, useContext: ga, useEffect: tm, useImperativeHandle: function(i, r, u) {
    return u = u != null ? u.concat([i]) : null, kc(
      4194308,
      4,
      ru.bind(null, r, i),
      u
    );
  }, useLayoutEffect: function(i, r) {
    return kc(4194308, 4, i, r);
  }, useInsertionEffect: function(i, r) {
    return kc(4, 2, i, r);
  }, useMemo: function(i, r) {
    var u = ji();
    return r = r === void 0 ? null : r, i = i(), u.memoizedState = [i, r], i;
  }, useReducer: function(i, r, u) {
    var p = ji();
    return r = u !== void 0 ? u(r) : r, p.memoizedState = p.baseState = r, i = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: i, lastRenderedState: r }, p.queue = i, i = i.dispatch = bf.bind(null, zt, i), [p.memoizedState, i];
  }, useRef: function(i) {
    var r = ji();
    return i = { current: i }, r.memoizedState = i;
  }, useState: Jp, useDebugValue: Ef, useDeferredValue: function(i) {
    return ji().memoizedState = i;
  }, useTransition: function() {
    var i = Jp(!1), r = i[0];
    return i = Cf.bind(null, i[1]), ji().memoizedState = i, [r, i];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(i, r, u) {
    var p = zt, g = ji();
    if (Tn) {
      if (u === void 0) throw Error(n(407));
      u = u();
    } else {
      if (u = r(), ci === null) throw Error(n(349));
      Jt & 30 || Gp(p, r, u);
    }
    g.memoizedState = u;
    var w = { value: u, getSnapshot: r };
    return g.queue = w, tm(Kp.bind(
      null,
      p,
      w,
      i
    ), [i]), p.flags |= 2048, iu(9, Wp.bind(null, p, w, u, r), void 0, null), u;
  }, useId: function() {
    var i = ji(), r = ci.identifierPrefix;
    if (Tn) {
      var u = gs, p = ys;
      u = (p & ~(1 << 32 - ca(p) - 1)).toString(32) + u, r = ":" + r + "R" + u, u = tu++, 0 < u && (r += "H" + u.toString(32)), r += ":";
    } else u = ee++, r = ":" + r + "r" + u.toString(32) + ":";
    return i.memoizedState = r;
  }, unstable_isNewReconciler: !1 }, kf = {
    readContext: ga,
    useCallback: rm,
    useContext: ga,
    useEffect: Tf,
    useImperativeHandle: im,
    useInsertionEffect: nm,
    useLayoutEffect: wf,
    useMemo: am,
    useReducer: Hl,
    useRef: em,
    useState: function() {
      return Hl(Zs);
    },
    useDebugValue: Ef,
    useDeferredValue: function(i) {
      var r = zn();
      return xg(r, Kn.memoizedState, i);
    },
    useTransition: function() {
      var i = Hl(Zs)[0], r = zn().memoizedState;
      return [i, r];
    },
    useMutableSource: Qp,
    useSyncExternalStore: Yp,
    useId: Rg,
    unstable_isNewReconciler: !1
  }, lm = { readContext: ga, useCallback: rm, useContext: ga, useEffect: Tf, useImperativeHandle: im, useInsertionEffect: nm, useLayoutEffect: wf, useMemo: am, useReducer: nu, useRef: em, useState: function() {
    return nu(Zs);
  }, useDebugValue: Ef, useDeferredValue: function(i) {
    var r = zn();
    return Kn === null ? r.memoizedState = i : xg(r, Kn.memoizedState, i);
  }, useTransition: function() {
    var i = nu(Zs)[0], r = zn().memoizedState;
    return [i, r];
  }, useMutableSource: Qp, useSyncExternalStore: Yp, useId: Rg, unstable_isNewReconciler: !1 };
  function Ya(i, r) {
    if (i && i.defaultProps) {
      r = he({}, r), i = i.defaultProps;
      for (var u in i) r[u] === void 0 && (r[u] = i[u]);
      return r;
    }
    return r;
  }
  function Dg(i, r, u, p) {
    r = i.memoizedState, u = u(p, r), u = u == null ? r : he({}, r, u), i.memoizedState = u, i.lanes === 0 && (i.updateQueue.baseState = u);
  }
  var om = { isMounted: function(i) {
    return (i = i._reactInternals) ? Va(i) === i : !1;
  }, enqueueSetState: function(i, r, u) {
    i = i._reactInternals;
    var p = ei(), g = bs(i), w = Xs(p, g);
    w.payload = r, u != null && (w.callback = u), r = Fl(i, w, g), r !== null && (sr(r, i, g, p), Ip(r, i, g));
  }, enqueueReplaceState: function(i, r, u) {
    i = i._reactInternals;
    var p = ei(), g = bs(i), w = Xs(p, g);
    w.tag = 1, w.payload = r, u != null && (w.callback = u), r = Fl(i, w, g), r !== null && (sr(r, i, g, p), Ip(r, i, g));
  }, enqueueForceUpdate: function(i, r) {
    i = i._reactInternals;
    var u = ei(), p = bs(i), g = Xs(u, p);
    g.tag = 2, r != null && (g.callback = r), r = Fl(i, g, p), r !== null && (sr(r, i, p, u), Ip(r, i, p));
  } };
  function uE(i, r, u, p, g, w, b) {
    return i = i.stateNode, typeof i.shouldComponentUpdate == "function" ? i.shouldComponentUpdate(p, w, b) : r.prototype && r.prototype.isPureReactComponent ? !rf(u, p) || !rf(g, w) : !0;
  }
  function um(i, r, u) {
    var p = !1, g = kr, w = r.contextType;
    return typeof w == "object" && w !== null ? w = ga(w) : (g = Gn(r) ? xr : An.current, p = r.contextTypes, w = (p = p != null) ? ma(i, g) : kr), r = new r(u, w), i.memoizedState = r.state !== null && r.state !== void 0 ? r.state : null, r.updater = om, i.stateNode = r, r._reactInternals = i, p && (i = i.stateNode, i.__reactInternalMemoizedUnmaskedChildContext = g, i.__reactInternalMemoizedMaskedChildContext = w), r;
  }
  function cE(i, r, u, p) {
    i = r.state, typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(u, p), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(u, p), r.state !== i && om.enqueueReplaceState(r, r.state, null);
  }
  function xf(i, r, u, p) {
    var g = i.stateNode;
    g.props = u, g.state = i.memoizedState, g.refs = {}, Cg(i);
    var w = r.contextType;
    typeof w == "object" && w !== null ? g.context = ga(w) : (w = Gn(r) ? xr : An.current, g.context = ma(i, w)), g.state = i.memoizedState, w = r.getDerivedStateFromProps, typeof w == "function" && (Dg(i, r, w, u), g.state = i.memoizedState), typeof r.getDerivedStateFromProps == "function" || typeof g.getSnapshotBeforeUpdate == "function" || typeof g.UNSAFE_componentWillMount != "function" && typeof g.componentWillMount != "function" || (r = g.state, typeof g.componentWillMount == "function" && g.componentWillMount(), typeof g.UNSAFE_componentWillMount == "function" && g.UNSAFE_componentWillMount(), r !== g.state && om.enqueueReplaceState(g, g.state, null), pf(i, u, g, p), g.state = i.memoizedState), typeof g.componentDidMount == "function" && (i.flags |= 4194308);
  }
  function lu(i, r) {
    try {
      var u = "", p = r;
      do
        u += oa(p), p = p.return;
      while (p);
      var g = u;
    } catch (w) {
      g = `
Error generating stack: ` + w.message + `
` + w.stack;
    }
    return { value: i, source: r, stack: g, digest: null };
  }
  function Mg(i, r, u) {
    return { value: i, source: null, stack: u ?? null, digest: r ?? null };
  }
  function Lg(i, r) {
    try {
      console.error(r.value);
    } catch (u) {
      setTimeout(function() {
        throw u;
      });
    }
  }
  var cm = typeof WeakMap == "function" ? WeakMap : Map;
  function dE(i, r, u) {
    u = Xs(-1, u), u.tag = 3, u.payload = { element: null };
    var p = r.value;
    return u.callback = function() {
      Oc || (Oc = !0, cu = p), Lg(i, r);
    }, u;
  }
  function $g(i, r, u) {
    u = Xs(-1, u), u.tag = 3;
    var p = i.type.getDerivedStateFromError;
    if (typeof p == "function") {
      var g = r.value;
      u.payload = function() {
        return p(g);
      }, u.callback = function() {
        Lg(i, r);
      };
    }
    var w = i.stateNode;
    return w !== null && typeof w.componentDidCatch == "function" && (u.callback = function() {
      Lg(i, r), typeof p != "function" && (jl === null ? jl = /* @__PURE__ */ new Set([this]) : jl.add(this));
      var b = r.stack;
      this.componentDidCatch(r.value, { componentStack: b !== null ? b : "" });
    }), u;
  }
  function Og(i, r, u) {
    var p = i.pingCache;
    if (p === null) {
      p = i.pingCache = new cm();
      var g = /* @__PURE__ */ new Set();
      p.set(r, g);
    } else g = p.get(r), g === void 0 && (g = /* @__PURE__ */ new Set(), p.set(r, g));
    g.has(u) || (g.add(u), i = mk.bind(null, i, r, u), r.then(i, i));
  }
  function fE(i) {
    do {
      var r;
      if ((r = i.tag === 13) && (r = i.memoizedState, r = r !== null ? r.dehydrated !== null : !0), r) return i;
      i = i.return;
    } while (i !== null);
    return null;
  }
  function Il(i, r, u, p, g) {
    return i.mode & 1 ? (i.flags |= 65536, i.lanes = g, i) : (i === r ? i.flags |= 65536 : (i.flags |= 128, u.flags |= 131072, u.flags &= -52805, u.tag === 1 && (u.alternate === null ? u.tag = 17 : (r = Xs(-1, 1), r.tag = 2, Fl(u, r, 1))), u.lanes |= 1), i);
  }
  var Rf = ct.ReactCurrentOwner, Xn = !1;
  function Li(i, r, u, p) {
    r.child = i === null ? me(r, null, u, p) : Un(r, i.child, u, p);
  }
  function $r(i, r, u, p, g) {
    u = u.render;
    var w = r.ref;
    return Cn(r, g), p = Vl(i, r, u, p, w, g), u = Qa(), i !== null && !Xn ? (r.updateQueue = i.updateQueue, r.flags &= -2053, i.lanes &= ~g, Ta(i, r, g)) : (Tn && u && zp(r), r.flags |= 1, Li(i, r, p, g), r.child);
  }
  function ou(i, r, u, p, g) {
    if (i === null) {
      var w = u.type;
      return typeof w == "function" && !Qg(w) && w.defaultProps === void 0 && u.compare === null && u.defaultProps === void 0 ? (r.tag = 15, r.type = w, it(i, r, w, p, g)) : (i = qf(u.type, null, p, r, r.mode, g), i.ref = r.ref, i.return = r, r.child = i);
    }
    if (w = i.child, !(i.lanes & g)) {
      var b = w.memoizedProps;
      if (u = u.compare, u = u !== null ? u : rf, u(b, p) && i.ref === r.ref) return Ta(i, r, g);
    }
    return r.flags |= 1, i = Ql(w, p), i.ref = r.ref, i.return = r, r.child = i;
  }
  function it(i, r, u, p, g) {
    if (i !== null) {
      var w = i.memoizedProps;
      if (rf(w, p) && i.ref === r.ref) if (Xn = !1, r.pendingProps = p = w, (i.lanes & g) !== 0) i.flags & 131072 && (Xn = !0);
      else return r.lanes = i.lanes, Ta(i, r, g);
    }
    return hE(i, r, u, p, g);
  }
  function Df(i, r, u) {
    var p = r.pendingProps, g = p.children, w = i !== null ? i.memoizedState : null;
    if (p.mode === "hidden") if (!(r.mode & 1)) r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Oe(Mc, Kr), Kr |= u;
    else {
      if (!(u & 1073741824)) return i = w !== null ? w.baseLanes | u : u, r.lanes = r.childLanes = 1073741824, r.memoizedState = { baseLanes: i, cachePool: null, transitions: null }, r.updateQueue = null, Oe(Mc, Kr), Kr |= i, null;
      r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, p = w !== null ? w.baseLanes : u, Oe(Mc, Kr), Kr |= p;
    }
    else w !== null ? (p = w.baseLanes | u, r.memoizedState = null) : p = u, Oe(Mc, Kr), Kr |= p;
    return Li(i, r, g, u), r.child;
  }
  function Ag(i, r) {
    var u = r.ref;
    (i === null && u !== null || i !== null && i.ref !== u) && (r.flags |= 512, r.flags |= 2097152);
  }
  function hE(i, r, u, p, g) {
    var w = Gn(u) ? xr : An.current;
    return w = ma(r, w), Cn(r, g), u = Vl(i, r, u, p, w, g), p = Qa(), i !== null && !Xn ? (r.updateQueue = i.updateQueue, r.flags &= -2053, i.lanes &= ~g, Ta(i, r, g)) : (Tn && p && zp(r), r.flags |= 1, Li(i, r, u, g), r.child);
  }
  function pE(i, r, u, p, g) {
    if (Gn(u)) {
      var w = !0;
      Rr(r);
    } else w = !1;
    if (Cn(r, g), r.stateNode === null) Sa(i, r), um(r, u, p), xf(r, u, p, g), p = !0;
    else if (i === null) {
      var b = r.stateNode, O = r.memoizedProps;
      b.props = O;
      var P = b.context, j = u.contextType;
      typeof j == "object" && j !== null ? j = ga(j) : (j = Gn(u) ? xr : An.current, j = ma(r, j));
      var ie = u.getDerivedStateFromProps, re = typeof ie == "function" || typeof b.getSnapshotBeforeUpdate == "function";
      re || typeof b.UNSAFE_componentWillReceiveProps != "function" && typeof b.componentWillReceiveProps != "function" || (O !== p || P !== j) && cE(r, b, p, j), Gr = !1;
      var te = r.memoizedState;
      b.state = te, pf(r, p, b, g), P = r.memoizedState, O !== p || te !== P || oi.current || Gr ? (typeof ie == "function" && (Dg(r, u, ie, p), P = r.memoizedState), (O = Gr || uE(r, u, O, p, te, P, j)) ? (re || typeof b.UNSAFE_componentWillMount != "function" && typeof b.componentWillMount != "function" || (typeof b.componentWillMount == "function" && b.componentWillMount(), typeof b.UNSAFE_componentWillMount == "function" && b.UNSAFE_componentWillMount()), typeof b.componentDidMount == "function" && (r.flags |= 4194308)) : (typeof b.componentDidMount == "function" && (r.flags |= 4194308), r.memoizedProps = p, r.memoizedState = P), b.props = p, b.state = P, b.context = j, p = O) : (typeof b.componentDidMount == "function" && (r.flags |= 4194308), p = !1);
    } else {
      b = r.stateNode, aE(i, r), O = r.memoizedProps, j = r.type === r.elementType ? O : Ya(r.type, O), b.props = j, re = r.pendingProps, te = b.context, P = u.contextType, typeof P == "object" && P !== null ? P = ga(P) : (P = Gn(u) ? xr : An.current, P = ma(r, P));
      var Te = u.getDerivedStateFromProps;
      (ie = typeof Te == "function" || typeof b.getSnapshotBeforeUpdate == "function") || typeof b.UNSAFE_componentWillReceiveProps != "function" && typeof b.componentWillReceiveProps != "function" || (O !== re || te !== P) && cE(r, b, p, P), Gr = !1, te = r.memoizedState, b.state = te, pf(r, p, b, g);
      var ke = r.memoizedState;
      O !== re || te !== ke || oi.current || Gr ? (typeof Te == "function" && (Dg(r, u, Te, p), ke = r.memoizedState), (j = Gr || uE(r, u, j, p, te, ke, P) || !1) ? (ie || typeof b.UNSAFE_componentWillUpdate != "function" && typeof b.componentWillUpdate != "function" || (typeof b.componentWillUpdate == "function" && b.componentWillUpdate(p, ke, P), typeof b.UNSAFE_componentWillUpdate == "function" && b.UNSAFE_componentWillUpdate(p, ke, P)), typeof b.componentDidUpdate == "function" && (r.flags |= 4), typeof b.getSnapshotBeforeUpdate == "function" && (r.flags |= 1024)) : (typeof b.componentDidUpdate != "function" || O === i.memoizedProps && te === i.memoizedState || (r.flags |= 4), typeof b.getSnapshotBeforeUpdate != "function" || O === i.memoizedProps && te === i.memoizedState || (r.flags |= 1024), r.memoizedProps = p, r.memoizedState = ke), b.props = p, b.state = ke, b.context = P, p = j) : (typeof b.componentDidUpdate != "function" || O === i.memoizedProps && te === i.memoizedState || (r.flags |= 4), typeof b.getSnapshotBeforeUpdate != "function" || O === i.memoizedProps && te === i.memoizedState || (r.flags |= 1024), p = !1);
    }
    return Mf(i, r, u, p, w, g);
  }
  function Mf(i, r, u, p, g, w) {
    Ag(i, r);
    var b = (r.flags & 128) !== 0;
    if (!p && !b) return g && Np(r, u, !1), Ta(i, r, w);
    p = r.stateNode, Rf.current = r;
    var O = b && typeof u.getDerivedStateFromError != "function" ? null : p.render();
    return r.flags |= 1, i !== null && b ? (r.child = Un(r, i.child, null, w), r.child = Un(r, null, O, w)) : Li(i, r, O, w), r.memoizedState = p.state, g && Np(r, u, !0), r.child;
  }
  function Rc(i) {
    var r = i.stateNode;
    r.pendingContext ? tE(i, r.pendingContext, r.pendingContext !== r.context) : r.context && tE(i, r.context, !1), kg(i, r.containerInfo);
  }
  function mE(i, r, u, p, g) {
    return zl(), Ks(g), r.flags |= 256, Li(i, r, u, p), r.child;
  }
  var dm = { dehydrated: null, treeContext: null, retryLane: 0 };
  function Pg(i) {
    return { baseLanes: i, cachePool: null, transitions: null };
  }
  function fm(i, r, u) {
    var p = r.pendingProps, g = bn.current, w = !1, b = (r.flags & 128) !== 0, O;
    if ((O = b) || (O = i !== null && i.memoizedState === null ? !1 : (g & 2) !== 0), O ? (w = !0, r.flags &= -129) : (i === null || i.memoizedState !== null) && (g |= 1), Oe(bn, g & 1), i === null)
      return vg(r), i = r.memoizedState, i !== null && (i = i.dehydrated, i !== null) ? (r.mode & 1 ? i.data === "$!" ? r.lanes = 8 : r.lanes = 1073741824 : r.lanes = 1, null) : (b = p.children, i = p.fallback, w ? (p = r.mode, w = r.child, b = { mode: "hidden", children: b }, !(p & 1) && w !== null ? (w.childLanes = 0, w.pendingProps = b) : w = Yl(b, p, 0, null), i = nl(i, p, u, null), w.return = r, i.return = r, w.sibling = i, r.child = w, r.child.memoizedState = Pg(u), r.memoizedState = dm, i) : _g(r, b));
    if (g = i.memoizedState, g !== null && (O = g.dehydrated, O !== null)) return vE(i, r, b, p, O, g, u);
    if (w) {
      w = p.fallback, b = r.mode, g = i.child, O = g.sibling;
      var P = { mode: "hidden", children: p.children };
      return !(b & 1) && r.child !== g ? (p = r.child, p.childLanes = 0, p.pendingProps = P, r.deletions = null) : (p = Ql(g, P), p.subtreeFlags = g.subtreeFlags & 14680064), O !== null ? w = Ql(O, w) : (w = nl(w, b, u, null), w.flags |= 2), w.return = r, p.return = r, p.sibling = w, r.child = p, p = w, w = r.child, b = i.child.memoizedState, b = b === null ? Pg(u) : { baseLanes: b.baseLanes | u, cachePool: null, transitions: b.transitions }, w.memoizedState = b, w.childLanes = i.childLanes & ~u, r.memoizedState = dm, p;
    }
    return w = i.child, i = w.sibling, p = Ql(w, { mode: "visible", children: p.children }), !(r.mode & 1) && (p.lanes = u), p.return = r, p.sibling = null, i !== null && (u = r.deletions, u === null ? (r.deletions = [i], r.flags |= 16) : u.push(i)), r.child = p, r.memoizedState = null, p;
  }
  function _g(i, r) {
    return r = Yl({ mode: "visible", children: r }, i.mode, 0, null), r.return = i, i.child = r;
  }
  function Lf(i, r, u, p) {
    return p !== null && Ks(p), Un(r, i.child, null, u), i = _g(r, r.pendingProps.children), i.flags |= 2, r.memoizedState = null, i;
  }
  function vE(i, r, u, p, g, w, b) {
    if (u)
      return r.flags & 256 ? (r.flags &= -257, p = Mg(Error(n(422))), Lf(i, r, b, p)) : r.memoizedState !== null ? (r.child = i.child, r.flags |= 128, null) : (w = p.fallback, g = r.mode, p = Yl({ mode: "visible", children: p.children }, g, 0, null), w = nl(w, g, b, null), w.flags |= 2, p.return = r, w.return = r, p.sibling = w, r.child = p, r.mode & 1 && Un(r, i.child, null, b), r.child.memoizedState = Pg(b), r.memoizedState = dm, w);
    if (!(r.mode & 1)) return Lf(i, r, b, null);
    if (g.data === "$!") {
      if (p = g.nextSibling && g.nextSibling.dataset, p) var O = p.dgst;
      return p = O, w = Error(n(419)), p = Mg(w, p, void 0), Lf(i, r, b, p);
    }
    if (O = (b & i.childLanes) !== 0, Xn || O) {
      if (p = ci, p !== null) {
        switch (b & -b) {
          case 4:
            g = 2;
            break;
          case 16:
            g = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            g = 32;
            break;
          case 536870912:
            g = 268435456;
            break;
          default:
            g = 0;
        }
        g = g & (p.suspendedLanes | b) ? 0 : g, g !== 0 && g !== w.retryLane && (w.retryLane = g, Yr(i, g), sr(p, i, g, -1));
      }
      return Bg(), p = Mg(Error(n(421))), Lf(i, r, b, p);
    }
    return g.data === "$?" ? (r.flags |= 128, r.child = i.child, r = vk.bind(null, i), g._reactRetry = r, null) : (i = w.treeContext, Mr = hs(g.nextSibling), Dr = r, Tn = !0, ya = null, i !== null && (Wn[va++] = ys, Wn[va++] = gs, Wn[va++] = Br, ys = i.id, gs = i.overflow, Br = r), r = _g(r, p.children), r.flags |= 4096, r);
  }
  function Ng(i, r, u) {
    i.lanes |= r;
    var p = i.alternate;
    p !== null && (p.lanes |= r), Tg(i.return, r, u);
  }
  function ir(i, r, u, p, g) {
    var w = i.memoizedState;
    w === null ? i.memoizedState = { isBackwards: r, rendering: null, renderingStartTime: 0, last: p, tail: u, tailMode: g } : (w.isBackwards = r, w.rendering = null, w.renderingStartTime = 0, w.last = p, w.tail = u, w.tailMode = g);
  }
  function Ts(i, r, u) {
    var p = r.pendingProps, g = p.revealOrder, w = p.tail;
    if (Li(i, r, p.children, u), p = bn.current, p & 2) p = p & 1 | 2, r.flags |= 128;
    else {
      if (i !== null && i.flags & 128) e: for (i = r.child; i !== null; ) {
        if (i.tag === 13) i.memoizedState !== null && Ng(i, u, r);
        else if (i.tag === 19) Ng(i, u, r);
        else if (i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === r) break e;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === r) break e;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
      p &= 1;
    }
    if (Oe(bn, p), !(r.mode & 1)) r.memoizedState = null;
    else switch (g) {
      case "forwards":
        for (u = r.child, g = null; u !== null; ) i = u.alternate, i !== null && jp(i) === null && (g = u), u = u.sibling;
        u = g, u === null ? (g = r.child, r.child = null) : (g = u.sibling, u.sibling = null), ir(r, !1, g, u, w);
        break;
      case "backwards":
        for (u = null, g = r.child, r.child = null; g !== null; ) {
          if (i = g.alternate, i !== null && jp(i) === null) {
            r.child = g;
            break;
          }
          i = g.sibling, g.sibling = u, u = g, g = i;
        }
        ir(r, !0, u, null, w);
        break;
      case "together":
        ir(r, !1, null, null, void 0);
        break;
      default:
        r.memoizedState = null;
    }
    return r.child;
  }
  function Sa(i, r) {
    !(r.mode & 1) && i !== null && (i.alternate = null, r.alternate = null, r.flags |= 2);
  }
  function Ta(i, r, u) {
    if (i !== null && (r.dependencies = i.dependencies), Cs |= r.lanes, !(u & r.childLanes)) return null;
    if (i !== null && r.child !== i.child) throw Error(n(153));
    if (r.child !== null) {
      for (i = r.child, u = Ql(i, i.pendingProps), r.child = u, u.return = r; i.sibling !== null; ) i = i.sibling, u = u.sibling = Ql(i, i.pendingProps), u.return = r;
      u.sibling = null;
    }
    return r.child;
  }
  function $f(i, r, u) {
    switch (r.tag) {
      case 3:
        Rc(r), zl();
        break;
      case 5:
        lE(r);
        break;
      case 1:
        Gn(r.type) && Rr(r);
        break;
      case 4:
        kg(r, r.stateNode.containerInfo);
        break;
      case 10:
        var p = r.type._context, g = r.memoizedProps.value;
        Oe(Qr, p._currentValue), p._currentValue = g;
        break;
      case 13:
        if (p = r.memoizedState, p !== null)
          return p.dehydrated !== null ? (Oe(bn, bn.current & 1), r.flags |= 128, null) : u & r.child.childLanes ? fm(i, r, u) : (Oe(bn, bn.current & 1), i = Ta(i, r, u), i !== null ? i.sibling : null);
        Oe(bn, bn.current & 1);
        break;
      case 19:
        if (p = (u & r.childLanes) !== 0, i.flags & 128) {
          if (p) return Ts(i, r, u);
          r.flags |= 128;
        }
        if (g = r.memoizedState, g !== null && (g.rendering = null, g.tail = null, g.lastEffect = null), Oe(bn, bn.current), p) break;
        return null;
      case 22:
      case 23:
        return r.lanes = 0, Df(i, r, u);
    }
    return Ta(i, r, u);
  }
  var wa, Zn, yE, gE;
  wa = function(i, r) {
    for (var u = r.child; u !== null; ) {
      if (u.tag === 5 || u.tag === 6) i.appendChild(u.stateNode);
      else if (u.tag !== 4 && u.child !== null) {
        u.child.return = u, u = u.child;
        continue;
      }
      if (u === r) break;
      for (; u.sibling === null; ) {
        if (u.return === null || u.return === r) return;
        u = u.return;
      }
      u.sibling.return = u.return, u = u.sibling;
    }
  }, Zn = function() {
  }, yE = function(i, r, u, p) {
    var g = i.memoizedProps;
    if (g !== p) {
      i = r.stateNode, Jo(Ss.current);
      var w = null;
      switch (u) {
        case "input":
          g = xi(i, g), p = xi(i, p), w = [];
          break;
        case "select":
          g = he({}, g, { value: void 0 }), p = he({}, p, { value: void 0 }), w = [];
          break;
        case "textarea":
          g = ua(i, g), p = ua(i, p), w = [];
          break;
        default:
          typeof g.onClick != "function" && typeof p.onClick == "function" && (i.onclick = Ol);
      }
      Bn(u, p);
      var b;
      u = null;
      for (j in g) if (!p.hasOwnProperty(j) && g.hasOwnProperty(j) && g[j] != null) if (j === "style") {
        var O = g[j];
        for (b in O) O.hasOwnProperty(b) && (u || (u = {}), u[b] = "");
      } else j !== "dangerouslySetInnerHTML" && j !== "children" && j !== "suppressContentEditableWarning" && j !== "suppressHydrationWarning" && j !== "autoFocus" && (h.hasOwnProperty(j) ? w || (w = []) : (w = w || []).push(j, null));
      for (j in p) {
        var P = p[j];
        if (O = g != null ? g[j] : void 0, p.hasOwnProperty(j) && P !== O && (P != null || O != null)) if (j === "style") if (O) {
          for (b in O) !O.hasOwnProperty(b) || P && P.hasOwnProperty(b) || (u || (u = {}), u[b] = "");
          for (b in P) P.hasOwnProperty(b) && O[b] !== P[b] && (u || (u = {}), u[b] = P[b]);
        } else u || (w || (w = []), w.push(
          j,
          u
        )), u = P;
        else j === "dangerouslySetInnerHTML" ? (P = P ? P.__html : void 0, O = O ? O.__html : void 0, P != null && O !== P && (w = w || []).push(j, P)) : j === "children" ? typeof P != "string" && typeof P != "number" || (w = w || []).push(j, "" + P) : j !== "suppressContentEditableWarning" && j !== "suppressHydrationWarning" && (h.hasOwnProperty(j) ? (P != null && j === "onScroll" && Yt("scroll", i), w || O === P || (w = [])) : (w = w || []).push(j, P));
      }
      u && (w = w || []).push("style", u);
      var j = w;
      (r.updateQueue = j) && (r.flags |= 4);
    }
  }, gE = function(i, r, u, p) {
    u !== p && (r.flags |= 4);
  };
  function Of(i, r) {
    if (!Tn) switch (i.tailMode) {
      case "hidden":
        r = i.tail;
        for (var u = null; r !== null; ) r.alternate !== null && (u = r), r = r.sibling;
        u === null ? i.tail = null : u.sibling = null;
        break;
      case "collapsed":
        u = i.tail;
        for (var p = null; u !== null; ) u.alternate !== null && (p = u), u = u.sibling;
        p === null ? r || i.tail === null ? i.tail = null : i.tail.sibling = null : p.sibling = null;
    }
  }
  function Si(i) {
    var r = i.alternate !== null && i.alternate.child === i.child, u = 0, p = 0;
    if (r) for (var g = i.child; g !== null; ) u |= g.lanes | g.childLanes, p |= g.subtreeFlags & 14680064, p |= g.flags & 14680064, g.return = i, g = g.sibling;
    else for (g = i.child; g !== null; ) u |= g.lanes | g.childLanes, p |= g.subtreeFlags, p |= g.flags, g.return = i, g = g.sibling;
    return i.subtreeFlags |= p, i.childLanes = u, r;
  }
  function SE(i, r, u) {
    var p = r.pendingProps;
    switch (Fp(r), r.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Si(r), null;
      case 1:
        return Gn(r.type) && Ec(), Si(r), null;
      case 3:
        return p = r.stateNode, eu(), un(oi), un(An), _e(), p.pendingContext && (p.context = p.pendingContext, p.pendingContext = null), (i === null || i.child === null) && (Vp(r) ? r.flags |= 4 : i === null || i.memoizedState.isDehydrated && !(r.flags & 256) || (r.flags |= 1024, ya !== null && (du(ya), ya = null))), Zn(i, r), Si(r), null;
      case 5:
        qp(r);
        var g = Jo(yf.current);
        if (u = r.type, i !== null && r.stateNode != null) yE(i, r, u, p, g), i.ref !== r.ref && (r.flags |= 512, r.flags |= 2097152);
        else {
          if (!p) {
            if (r.stateNode === null) throw Error(n(166));
            return Si(r), null;
          }
          if (i = Jo(Ss.current), Vp(r)) {
            p = r.stateNode, u = r.type;
            var w = r.memoizedProps;
            switch (p[ps] = r, p[cf] = w, i = (r.mode & 1) !== 0, u) {
              case "dialog":
                Yt("cancel", p), Yt("close", p);
                break;
              case "iframe":
              case "object":
              case "embed":
                Yt("load", p);
                break;
              case "video":
              case "audio":
                for (g = 0; g < lf.length; g++) Yt(lf[g], p);
                break;
              case "source":
                Yt("error", p);
                break;
              case "img":
              case "image":
              case "link":
                Yt(
                  "error",
                  p
                ), Yt("load", p);
                break;
              case "details":
                Yt("toggle", p);
                break;
              case "input":
                tr(p, w), Yt("invalid", p);
                break;
              case "select":
                p._wrapperState = { wasMultiple: !!w.multiple }, Yt("invalid", p);
                break;
              case "textarea":
                za(p, w), Yt("invalid", p);
            }
            Bn(u, w), g = null;
            for (var b in w) if (w.hasOwnProperty(b)) {
              var O = w[b];
              b === "children" ? typeof O == "string" ? p.textContent !== O && (w.suppressHydrationWarning !== !0 && Op(p.textContent, O, i), g = ["children", O]) : typeof O == "number" && p.textContent !== "" + O && (w.suppressHydrationWarning !== !0 && Op(
                p.textContent,
                O,
                i
              ), g = ["children", "" + O]) : h.hasOwnProperty(b) && O != null && b === "onScroll" && Yt("scroll", p);
            }
            switch (u) {
              case "input":
                _n(p), Id(p, w, !0);
                break;
              case "textarea":
                _n(p), jr(p);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof w.onClick == "function" && (p.onclick = Ol);
            }
            p = g, r.updateQueue = p, p !== null && (r.flags |= 4);
          } else {
            b = g.nodeType === 9 ? g : g.ownerDocument, i === "http://www.w3.org/1999/xhtml" && (i = ds(u)), i === "http://www.w3.org/1999/xhtml" ? u === "script" ? (i = b.createElement("div"), i.innerHTML = "<script><\/script>", i = i.removeChild(i.firstChild)) : typeof p.is == "string" ? i = b.createElement(u, { is: p.is }) : (i = b.createElement(u), u === "select" && (b = i, p.multiple ? b.multiple = !0 : p.size && (b.size = p.size))) : i = b.createElementNS(i, u), i[ps] = r, i[cf] = p, wa(i, r, !1, !1), r.stateNode = i;
            e: {
              switch (b = Er(u, p), u) {
                case "dialog":
                  Yt("cancel", i), Yt("close", i), g = p;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Yt("load", i), g = p;
                  break;
                case "video":
                case "audio":
                  for (g = 0; g < lf.length; g++) Yt(lf[g], i);
                  g = p;
                  break;
                case "source":
                  Yt("error", i), g = p;
                  break;
                case "img":
                case "image":
                case "link":
                  Yt(
                    "error",
                    i
                  ), Yt("load", i), g = p;
                  break;
                case "details":
                  Yt("toggle", i), g = p;
                  break;
                case "input":
                  tr(i, p), g = xi(i, p), Yt("invalid", i);
                  break;
                case "option":
                  g = p;
                  break;
                case "select":
                  i._wrapperState = { wasMultiple: !!p.multiple }, g = he({}, p, { value: void 0 }), Yt("invalid", i);
                  break;
                case "textarea":
                  za(i, p), g = ua(i, p), Yt("invalid", i);
                  break;
                default:
                  g = p;
              }
              Bn(u, g), O = g;
              for (w in O) if (O.hasOwnProperty(w)) {
                var P = O[w];
                w === "style" ? Ln(i, P) : w === "dangerouslySetInnerHTML" ? (P = P ? P.__html : void 0, P != null && jd(i, P)) : w === "children" ? typeof P == "string" ? (u !== "textarea" || P !== "") && pe(i, P) : typeof P == "number" && pe(i, "" + P) : w !== "suppressContentEditableWarning" && w !== "suppressHydrationWarning" && w !== "autoFocus" && (h.hasOwnProperty(w) ? P != null && w === "onScroll" && Yt("scroll", i) : P != null && Ve(i, w, P, b));
              }
              switch (u) {
                case "input":
                  _n(i), Id(i, p, !1);
                  break;
                case "textarea":
                  _n(i), jr(i);
                  break;
                case "option":
                  p.value != null && i.setAttribute("value", "" + bi(p.value));
                  break;
                case "select":
                  i.multiple = !!p.multiple, w = p.value, w != null ? qr(i, !!p.multiple, w, !1) : p.defaultValue != null && qr(
                    i,
                    !!p.multiple,
                    p.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof g.onClick == "function" && (i.onclick = Ol);
              }
              switch (u) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  p = !!p.autoFocus;
                  break e;
                case "img":
                  p = !0;
                  break e;
                default:
                  p = !1;
              }
            }
            p && (r.flags |= 4);
          }
          r.ref !== null && (r.flags |= 512, r.flags |= 2097152);
        }
        return Si(r), null;
      case 6:
        if (i && r.stateNode != null) gE(i, r, i.memoizedProps, p);
        else {
          if (typeof p != "string" && r.stateNode === null) throw Error(n(166));
          if (u = Jo(yf.current), Jo(Ss.current), Vp(r)) {
            if (p = r.stateNode, u = r.memoizedProps, p[ps] = r, (w = p.nodeValue !== u) && (i = Dr, i !== null)) switch (i.tag) {
              case 3:
                Op(p.nodeValue, u, (i.mode & 1) !== 0);
                break;
              case 5:
                i.memoizedProps.suppressHydrationWarning !== !0 && Op(p.nodeValue, u, (i.mode & 1) !== 0);
            }
            w && (r.flags |= 4);
          } else p = (u.nodeType === 9 ? u : u.ownerDocument).createTextNode(p), p[ps] = r, r.stateNode = p;
        }
        return Si(r), null;
      case 13:
        if (un(bn), p = r.memoizedState, i === null || i.memoizedState !== null && i.memoizedState.dehydrated !== null) {
          if (Tn && Mr !== null && r.mode & 1 && !(r.flags & 128)) hf(), zl(), r.flags |= 98560, w = !1;
          else if (w = Vp(r), p !== null && p.dehydrated !== null) {
            if (i === null) {
              if (!w) throw Error(n(318));
              if (w = r.memoizedState, w = w !== null ? w.dehydrated : null, !w) throw Error(n(317));
              w[ps] = r;
            } else zl(), !(r.flags & 128) && (r.memoizedState = null), r.flags |= 4;
            Si(r), w = !1;
          } else ya !== null && (du(ya), ya = null), w = !0;
          if (!w) return r.flags & 65536 ? r : null;
        }
        return r.flags & 128 ? (r.lanes = u, r) : (p = p !== null, p !== (i !== null && i.memoizedState !== null) && p && (r.child.flags |= 8192, r.mode & 1 && (i === null || bn.current & 1 ? Vn === 0 && (Vn = 3) : Bg())), r.updateQueue !== null && (r.flags |= 4), Si(r), null);
      case 4:
        return eu(), Zn(i, r), i === null && yc(r.stateNode.containerInfo), Si(r), null;
      case 10:
        return Sg(r.type._context), Si(r), null;
      case 17:
        return Gn(r.type) && Ec(), Si(r), null;
      case 19:
        if (un(bn), w = r.memoizedState, w === null) return Si(r), null;
        if (p = (r.flags & 128) !== 0, b = w.rendering, b === null) if (p) Of(w, !1);
        else {
          if (Vn !== 0 || i !== null && i.flags & 128) for (i = r.child; i !== null; ) {
            if (b = jp(i), b !== null) {
              for (r.flags |= 128, Of(w, !1), p = b.updateQueue, p !== null && (r.updateQueue = p, r.flags |= 4), r.subtreeFlags = 0, p = u, u = r.child; u !== null; ) w = u, i = p, w.flags &= 14680066, b = w.alternate, b === null ? (w.childLanes = 0, w.lanes = i, w.child = null, w.subtreeFlags = 0, w.memoizedProps = null, w.memoizedState = null, w.updateQueue = null, w.dependencies = null, w.stateNode = null) : (w.childLanes = b.childLanes, w.lanes = b.lanes, w.child = b.child, w.subtreeFlags = 0, w.deletions = null, w.memoizedProps = b.memoizedProps, w.memoizedState = b.memoizedState, w.updateQueue = b.updateQueue, w.type = b.type, i = b.dependencies, w.dependencies = i === null ? null : { lanes: i.lanes, firstContext: i.firstContext }), u = u.sibling;
              return Oe(bn, bn.current & 1 | 2), r.child;
            }
            i = i.sibling;
          }
          w.tail !== null && sn() > $c && (r.flags |= 128, p = !0, Of(w, !1), r.lanes = 4194304);
        }
        else {
          if (!p) if (i = jp(b), i !== null) {
            if (r.flags |= 128, p = !0, u = i.updateQueue, u !== null && (r.updateQueue = u, r.flags |= 4), Of(w, !0), w.tail === null && w.tailMode === "hidden" && !b.alternate && !Tn) return Si(r), null;
          } else 2 * sn() - w.renderingStartTime > $c && u !== 1073741824 && (r.flags |= 128, p = !0, Of(w, !1), r.lanes = 4194304);
          w.isBackwards ? (b.sibling = r.child, r.child = b) : (u = w.last, u !== null ? u.sibling = b : r.child = b, w.last = b);
        }
        return w.tail !== null ? (r = w.tail, w.rendering = r, w.tail = r.sibling, w.renderingStartTime = sn(), r.sibling = null, u = bn.current, Oe(bn, p ? u & 1 | 2 : u & 1), r) : (Si(r), null);
      case 22:
      case 23:
        return jg(), p = r.memoizedState !== null, i !== null && i.memoizedState !== null !== p && (r.flags |= 8192), p && r.mode & 1 ? Kr & 1073741824 && (Si(r), r.subtreeFlags & 6 && (r.flags |= 8192)) : Si(r), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(n(156, r.tag));
  }
  function hm(i, r) {
    switch (Fp(r), r.tag) {
      case 1:
        return Gn(r.type) && Ec(), i = r.flags, i & 65536 ? (r.flags = i & -65537 | 128, r) : null;
      case 3:
        return eu(), un(oi), un(An), _e(), i = r.flags, i & 65536 && !(i & 128) ? (r.flags = i & -65537 | 128, r) : null;
      case 5:
        return qp(r), null;
      case 13:
        if (un(bn), i = r.memoizedState, i !== null && i.dehydrated !== null) {
          if (r.alternate === null) throw Error(n(340));
          zl();
        }
        return i = r.flags, i & 65536 ? (r.flags = i & -65537 | 128, r) : null;
      case 19:
        return un(bn), null;
      case 4:
        return eu(), null;
      case 10:
        return Sg(r.type._context), null;
      case 22:
      case 23:
        return jg(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Af = !1, Bi = !1, uk = typeof WeakSet == "function" ? WeakSet : Set, Ce = null;
  function Dc(i, r) {
    var u = i.ref;
    if (u !== null) if (typeof u == "function") try {
      u(null);
    } catch (p) {
      wn(i, r, p);
    }
    else u.current = null;
  }
  function pm(i, r, u) {
    try {
      u();
    } catch (p) {
      wn(i, r, p);
    }
  }
  var TE = !1;
  function wE(i, r) {
    if (uf = Vo, i = af(), bp(i)) {
      if ("selectionStart" in i) var u = { start: i.selectionStart, end: i.selectionEnd };
      else e: {
        u = (u = i.ownerDocument) && u.defaultView || window;
        var p = u.getSelection && u.getSelection();
        if (p && p.rangeCount !== 0) {
          u = p.anchorNode;
          var g = p.anchorOffset, w = p.focusNode;
          p = p.focusOffset;
          try {
            u.nodeType, w.nodeType;
          } catch {
            u = null;
            break e;
          }
          var b = 0, O = -1, P = -1, j = 0, ie = 0, re = i, te = null;
          t: for (; ; ) {
            for (var Te; re !== u || g !== 0 && re.nodeType !== 3 || (O = b + g), re !== w || p !== 0 && re.nodeType !== 3 || (P = b + p), re.nodeType === 3 && (b += re.nodeValue.length), (Te = re.firstChild) !== null; )
              te = re, re = Te;
            for (; ; ) {
              if (re === i) break t;
              if (te === u && ++j === g && (O = b), te === w && ++ie === p && (P = b), (Te = re.nextSibling) !== null) break;
              re = te, te = re.parentNode;
            }
            re = Te;
          }
          u = O === -1 || P === -1 ? null : { start: O, end: P };
        } else u = null;
      }
      u = u || { start: 0, end: 0 };
    } else u = null;
    for (Yo = { focusedElem: i, selectionRange: u }, Vo = !1, Ce = r; Ce !== null; ) if (r = Ce, i = r.child, (r.subtreeFlags & 1028) !== 0 && i !== null) i.return = r, Ce = i;
    else for (; Ce !== null; ) {
      r = Ce;
      try {
        var ke = r.alternate;
        if (r.flags & 1024) switch (r.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (ke !== null) {
              var De = ke.memoizedProps, Hn = ke.memoizedState, F = r.stateNode, U = F.getSnapshotBeforeUpdate(r.elementType === r.type ? De : Ya(r.type, De), Hn);
              F.__reactInternalSnapshotBeforeUpdate = U;
            }
            break;
          case 3:
            var I = r.stateNode.containerInfo;
            I.nodeType === 1 ? I.textContent = "" : I.nodeType === 9 && I.documentElement && I.removeChild(I.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(n(163));
        }
      } catch (le) {
        wn(r, r.return, le);
      }
      if (i = r.sibling, i !== null) {
        i.return = r.return, Ce = i;
        break;
      }
      Ce = r.return;
    }
    return ke = TE, TE = !1, ke;
  }
  function Pf(i, r, u) {
    var p = r.updateQueue;
    if (p = p !== null ? p.lastEffect : null, p !== null) {
      var g = p = p.next;
      do {
        if ((g.tag & i) === i) {
          var w = g.destroy;
          g.destroy = void 0, w !== void 0 && pm(r, u, w);
        }
        g = g.next;
      } while (g !== p);
    }
  }
  function _f(i, r) {
    if (r = r.updateQueue, r = r !== null ? r.lastEffect : null, r !== null) {
      var u = r = r.next;
      do {
        if ((u.tag & i) === i) {
          var p = u.create;
          u.destroy = p();
        }
        u = u.next;
      } while (u !== r);
    }
  }
  function Ug(i) {
    var r = i.ref;
    if (r !== null) {
      var u = i.stateNode;
      switch (i.tag) {
        case 5:
          i = u;
          break;
        default:
          i = u;
      }
      typeof r == "function" ? r(i) : r.current = i;
    }
  }
  function mm(i) {
    var r = i.alternate;
    r !== null && (i.alternate = null, mm(r)), i.child = null, i.deletions = null, i.sibling = null, i.tag === 5 && (r = i.stateNode, r !== null && (delete r[ps], delete r[cf], delete r[df], delete r[wc], delete r[lk])), i.stateNode = null, i.return = null, i.dependencies = null, i.memoizedProps = null, i.memoizedState = null, i.pendingProps = null, i.stateNode = null, i.updateQueue = null;
  }
  function Nf(i) {
    return i.tag === 5 || i.tag === 3 || i.tag === 4;
  }
  function Js(i) {
    e: for (; ; ) {
      for (; i.sibling === null; ) {
        if (i.return === null || Nf(i.return)) return null;
        i = i.return;
      }
      for (i.sibling.return = i.return, i = i.sibling; i.tag !== 5 && i.tag !== 6 && i.tag !== 18; ) {
        if (i.flags & 2 || i.child === null || i.tag === 4) continue e;
        i.child.return = i, i = i.child;
      }
      if (!(i.flags & 2)) return i.stateNode;
    }
  }
  function ws(i, r, u) {
    var p = i.tag;
    if (p === 5 || p === 6) i = i.stateNode, r ? u.nodeType === 8 ? u.parentNode.insertBefore(i, r) : u.insertBefore(i, r) : (u.nodeType === 8 ? (r = u.parentNode, r.insertBefore(i, u)) : (r = u, r.appendChild(i)), u = u._reactRootContainer, u != null || r.onclick !== null || (r.onclick = Ol));
    else if (p !== 4 && (i = i.child, i !== null)) for (ws(i, r, u), i = i.sibling; i !== null; ) ws(i, r, u), i = i.sibling;
  }
  function Es(i, r, u) {
    var p = i.tag;
    if (p === 5 || p === 6) i = i.stateNode, r ? u.insertBefore(i, r) : u.appendChild(i);
    else if (p !== 4 && (i = i.child, i !== null)) for (Es(i, r, u), i = i.sibling; i !== null; ) Es(i, r, u), i = i.sibling;
  }
  var Fn = null, rr = !1;
  function ar(i, r, u) {
    for (u = u.child; u !== null; ) EE(i, r, u), u = u.sibling;
  }
  function EE(i, r, u) {
    if (Ha && typeof Ha.onCommitFiberUnmount == "function") try {
      Ha.onCommitFiberUnmount(Yd, u);
    } catch {
    }
    switch (u.tag) {
      case 5:
        Bi || Dc(u, r);
      case 6:
        var p = Fn, g = rr;
        Fn = null, ar(i, r, u), Fn = p, rr = g, Fn !== null && (rr ? (i = Fn, u = u.stateNode, i.nodeType === 8 ? i.parentNode.removeChild(u) : i.removeChild(u)) : Fn.removeChild(u.stateNode));
        break;
      case 18:
        Fn !== null && (rr ? (i = Fn, u = u.stateNode, i.nodeType === 8 ? Tc(i.parentNode, u) : i.nodeType === 1 && Tc(i, u), Ml(i)) : Tc(Fn, u.stateNode));
        break;
      case 4:
        p = Fn, g = rr, Fn = u.stateNode.containerInfo, rr = !0, ar(i, r, u), Fn = p, rr = g;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Bi && (p = u.updateQueue, p !== null && (p = p.lastEffect, p !== null))) {
          g = p = p.next;
          do {
            var w = g, b = w.destroy;
            w = w.tag, b !== void 0 && (w & 2 || w & 4) && pm(u, r, b), g = g.next;
          } while (g !== p);
        }
        ar(i, r, u);
        break;
      case 1:
        if (!Bi && (Dc(u, r), p = u.stateNode, typeof p.componentWillUnmount == "function")) try {
          p.props = u.memoizedProps, p.state = u.memoizedState, p.componentWillUnmount();
        } catch (O) {
          wn(u, r, O);
        }
        ar(i, r, u);
        break;
      case 21:
        ar(i, r, u);
        break;
      case 22:
        u.mode & 1 ? (Bi = (p = Bi) || u.memoizedState !== null, ar(i, r, u), Bi = p) : ar(i, r, u);
        break;
      default:
        ar(i, r, u);
    }
  }
  function CE(i) {
    var r = i.updateQueue;
    if (r !== null) {
      i.updateQueue = null;
      var u = i.stateNode;
      u === null && (u = i.stateNode = new uk()), r.forEach(function(p) {
        var g = OE.bind(null, i, p);
        u.has(p) || (u.add(p), p.then(g, g));
      });
    }
  }
  function Ga(i, r) {
    var u = r.deletions;
    if (u !== null) for (var p = 0; p < u.length; p++) {
      var g = u[p];
      try {
        var w = i, b = r, O = b;
        e: for (; O !== null; ) {
          switch (O.tag) {
            case 5:
              Fn = O.stateNode, rr = !1;
              break e;
            case 3:
              Fn = O.stateNode.containerInfo, rr = !0;
              break e;
            case 4:
              Fn = O.stateNode.containerInfo, rr = !0;
              break e;
          }
          O = O.return;
        }
        if (Fn === null) throw Error(n(160));
        EE(w, b, g), Fn = null, rr = !1;
        var P = g.alternate;
        P !== null && (P.return = null), g.return = null;
      } catch (j) {
        wn(g, r, j);
      }
    }
    if (r.subtreeFlags & 12854) for (r = r.child; r !== null; ) zg(r, i), r = r.sibling;
  }
  function zg(i, r) {
    var u = i.alternate, p = i.flags;
    switch (i.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (Ga(r, i), Or(i), p & 4) {
          try {
            Pf(3, i, i.return), _f(3, i);
          } catch (De) {
            wn(i, i.return, De);
          }
          try {
            Pf(5, i, i.return);
          } catch (De) {
            wn(i, i.return, De);
          }
        }
        break;
      case 1:
        Ga(r, i), Or(i), p & 512 && u !== null && Dc(u, u.return);
        break;
      case 5:
        if (Ga(r, i), Or(i), p & 512 && u !== null && Dc(u, u.return), i.flags & 32) {
          var g = i.stateNode;
          try {
            pe(g, "");
          } catch (De) {
            wn(i, i.return, De);
          }
        }
        if (p & 4 && (g = i.stateNode, g != null)) {
          var w = i.memoizedProps, b = u !== null ? u.memoizedProps : w, O = i.type, P = i.updateQueue;
          if (i.updateQueue = null, P !== null) try {
            O === "input" && w.type === "radio" && w.name != null && Ir(g, w), Er(O, b);
            var j = Er(O, w);
            for (b = 0; b < P.length; b += 2) {
              var ie = P[b], re = P[b + 1];
              ie === "style" ? Ln(g, re) : ie === "dangerouslySetInnerHTML" ? jd(g, re) : ie === "children" ? pe(g, re) : Ve(g, ie, re, j);
            }
            switch (O) {
              case "input":
                nc(g, w);
                break;
              case "textarea":
                ic(g, w);
                break;
              case "select":
                var te = g._wrapperState.wasMultiple;
                g._wrapperState.wasMultiple = !!w.multiple;
                var Te = w.value;
                Te != null ? qr(g, !!w.multiple, Te, !1) : te !== !!w.multiple && (w.defaultValue != null ? qr(
                  g,
                  !!w.multiple,
                  w.defaultValue,
                  !0
                ) : qr(g, !!w.multiple, w.multiple ? [] : "", !1));
            }
            g[cf] = w;
          } catch (De) {
            wn(i, i.return, De);
          }
        }
        break;
      case 6:
        if (Ga(r, i), Or(i), p & 4) {
          if (i.stateNode === null) throw Error(n(162));
          g = i.stateNode, w = i.memoizedProps;
          try {
            g.nodeValue = w;
          } catch (De) {
            wn(i, i.return, De);
          }
        }
        break;
      case 3:
        if (Ga(r, i), Or(i), p & 4 && u !== null && u.memoizedState.isDehydrated) try {
          Ml(r.containerInfo);
        } catch (De) {
          wn(i, i.return, De);
        }
        break;
      case 4:
        Ga(r, i), Or(i);
        break;
      case 13:
        Ga(r, i), Or(i), g = i.child, g.flags & 8192 && (w = g.memoizedState !== null, g.stateNode.isHidden = w, !w || g.alternate !== null && g.alternate.memoizedState !== null || (Hg = sn())), p & 4 && CE(i);
        break;
      case 22:
        if (ie = u !== null && u.memoizedState !== null, i.mode & 1 ? (Bi = (j = Bi) || ie, Ga(r, i), Bi = j) : Ga(r, i), Or(i), p & 8192) {
          if (j = i.memoizedState !== null, (i.stateNode.isHidden = j) && !ie && i.mode & 1) for (Ce = i, ie = i.child; ie !== null; ) {
            for (re = Ce = ie; Ce !== null; ) {
              switch (te = Ce, Te = te.child, te.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Pf(4, te, te.return);
                  break;
                case 1:
                  Dc(te, te.return);
                  var ke = te.stateNode;
                  if (typeof ke.componentWillUnmount == "function") {
                    p = te, u = te.return;
                    try {
                      r = p, ke.props = r.memoizedProps, ke.state = r.memoizedState, ke.componentWillUnmount();
                    } catch (De) {
                      wn(p, u, De);
                    }
                  }
                  break;
                case 5:
                  Dc(te, te.return);
                  break;
                case 22:
                  if (te.memoizedState !== null) {
                    Uf(re);
                    continue;
                  }
              }
              Te !== null ? (Te.return = te, Ce = Te) : Uf(re);
            }
            ie = ie.sibling;
          }
          e: for (ie = null, re = i; ; ) {
            if (re.tag === 5) {
              if (ie === null) {
                ie = re;
                try {
                  g = re.stateNode, j ? (w = g.style, typeof w.setProperty == "function" ? w.setProperty("display", "none", "important") : w.display = "none") : (O = re.stateNode, P = re.memoizedProps.style, b = P != null && P.hasOwnProperty("display") ? P.display : null, O.style.display = an("display", b));
                } catch (De) {
                  wn(i, i.return, De);
                }
              }
            } else if (re.tag === 6) {
              if (ie === null) try {
                re.stateNode.nodeValue = j ? "" : re.memoizedProps;
              } catch (De) {
                wn(i, i.return, De);
              }
            } else if ((re.tag !== 22 && re.tag !== 23 || re.memoizedState === null || re === i) && re.child !== null) {
              re.child.return = re, re = re.child;
              continue;
            }
            if (re === i) break e;
            for (; re.sibling === null; ) {
              if (re.return === null || re.return === i) break e;
              ie === re && (ie = null), re = re.return;
            }
            ie === re && (ie = null), re.sibling.return = re.return, re = re.sibling;
          }
        }
        break;
      case 19:
        Ga(r, i), Or(i), p & 4 && CE(i);
        break;
      case 21:
        break;
      default:
        Ga(
          r,
          i
        ), Or(i);
    }
  }
  function Or(i) {
    var r = i.flags;
    if (r & 2) {
      try {
        e: {
          for (var u = i.return; u !== null; ) {
            if (Nf(u)) {
              var p = u;
              break e;
            }
            u = u.return;
          }
          throw Error(n(160));
        }
        switch (p.tag) {
          case 5:
            var g = p.stateNode;
            p.flags & 32 && (pe(g, ""), p.flags &= -33);
            var w = Js(i);
            Es(i, w, g);
            break;
          case 3:
          case 4:
            var b = p.stateNode.containerInfo, O = Js(i);
            ws(i, O, b);
            break;
          default:
            throw Error(n(161));
        }
      } catch (P) {
        wn(i, i.return, P);
      }
      i.flags &= -3;
    }
    r & 4096 && (i.flags &= -4097);
  }
  function ck(i, r, u) {
    Ce = i, Fg(i);
  }
  function Fg(i, r, u) {
    for (var p = (i.mode & 1) !== 0; Ce !== null; ) {
      var g = Ce, w = g.child;
      if (g.tag === 22 && p) {
        var b = g.memoizedState !== null || Af;
        if (!b) {
          var O = g.alternate, P = O !== null && O.memoizedState !== null || Bi;
          O = Af;
          var j = Bi;
          if (Af = b, (Bi = P) && !j) for (Ce = g; Ce !== null; ) b = Ce, P = b.child, b.tag === 22 && b.memoizedState !== null ? Vg(g) : P !== null ? (P.return = b, Ce = P) : Vg(g);
          for (; w !== null; ) Ce = w, Fg(w), w = w.sibling;
          Ce = g, Af = O, Bi = j;
        }
        bE(i);
      } else g.subtreeFlags & 8772 && w !== null ? (w.return = g, Ce = w) : bE(i);
    }
  }
  function bE(i) {
    for (; Ce !== null; ) {
      var r = Ce;
      if (r.flags & 8772) {
        var u = r.alternate;
        try {
          if (r.flags & 8772) switch (r.tag) {
            case 0:
            case 11:
            case 15:
              Bi || _f(5, r);
              break;
            case 1:
              var p = r.stateNode;
              if (r.flags & 4 && !Bi) if (u === null) p.componentDidMount();
              else {
                var g = r.elementType === r.type ? u.memoizedProps : Ya(r.type, u.memoizedProps);
                p.componentDidUpdate(g, u.memoizedState, p.__reactInternalSnapshotBeforeUpdate);
              }
              var w = r.updateQueue;
              w !== null && bg(r, w, p);
              break;
            case 3:
              var b = r.updateQueue;
              if (b !== null) {
                if (u = null, r.child !== null) switch (r.child.tag) {
                  case 5:
                    u = r.child.stateNode;
                    break;
                  case 1:
                    u = r.child.stateNode;
                }
                bg(r, b, u);
              }
              break;
            case 5:
              var O = r.stateNode;
              if (u === null && r.flags & 4) {
                u = O;
                var P = r.memoizedProps;
                switch (r.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    P.autoFocus && u.focus();
                    break;
                  case "img":
                    P.src && (u.src = P.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (r.memoizedState === null) {
                var j = r.alternate;
                if (j !== null) {
                  var ie = j.memoizedState;
                  if (ie !== null) {
                    var re = ie.dehydrated;
                    re !== null && Ml(re);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(n(163));
          }
          Bi || r.flags & 512 && Ug(r);
        } catch (te) {
          wn(r, r.return, te);
        }
      }
      if (r === i) {
        Ce = null;
        break;
      }
      if (u = r.sibling, u !== null) {
        u.return = r.return, Ce = u;
        break;
      }
      Ce = r.return;
    }
  }
  function Uf(i) {
    for (; Ce !== null; ) {
      var r = Ce;
      if (r === i) {
        Ce = null;
        break;
      }
      var u = r.sibling;
      if (u !== null) {
        u.return = r.return, Ce = u;
        break;
      }
      Ce = r.return;
    }
  }
  function Vg(i) {
    for (; Ce !== null; ) {
      var r = Ce;
      try {
        switch (r.tag) {
          case 0:
          case 11:
          case 15:
            var u = r.return;
            try {
              _f(4, r);
            } catch (P) {
              wn(r, u, P);
            }
            break;
          case 1:
            var p = r.stateNode;
            if (typeof p.componentDidMount == "function") {
              var g = r.return;
              try {
                p.componentDidMount();
              } catch (P) {
                wn(r, g, P);
              }
            }
            var w = r.return;
            try {
              Ug(r);
            } catch (P) {
              wn(r, w, P);
            }
            break;
          case 5:
            var b = r.return;
            try {
              Ug(r);
            } catch (P) {
              wn(r, b, P);
            }
        }
      } catch (P) {
        wn(r, r.return, P);
      }
      if (r === i) {
        Ce = null;
        break;
      }
      var O = r.sibling;
      if (O !== null) {
        O.return = r.return, Ce = O;
        break;
      }
      Ce = r.return;
    }
  }
  var dk = Math.ceil, ql = ct.ReactCurrentDispatcher, uu = ct.ReactCurrentOwner, $i = ct.ReactCurrentBatchConfig, Ct = 0, ci = null, Jn = null, Oi = 0, Kr = 0, Mc = Ba(0), Vn = 0, zf = null, Cs = 0, Lc = 0, vm = 0, Ff = null, Ar = null, Hg = 0, $c = 1 / 0, Xr = null, Oc = !1, cu = null, jl = null, ym = !1, el = null, Vf = 0, Bl = 0, Ac = null, Hf = -1, Qi = 0;
  function ei() {
    return Ct & 6 ? sn() : Hf !== -1 ? Hf : Hf = sn();
  }
  function bs(i) {
    return i.mode & 1 ? Ct & 2 && Oi !== 0 ? Oi & -Oi : ok.transition !== null ? (Qi === 0 && (Qi = cp()), Qi) : (i = Xt, i !== 0 || (i = window.event, i = i === void 0 ? 16 : pp(i.type)), i) : 1;
  }
  function sr(i, r, u, p) {
    if (50 < Bl) throw Bl = 0, Ac = null, Error(n(185));
    zo(i, u, p), (!(Ct & 2) || i !== ci) && (i === ci && (!(Ct & 2) && (Lc |= u), Vn === 4 && Wa(i, Oi)), Pr(i, p), u === 1 && Ct === 0 && !(r.mode & 1) && ($c = sn() + 500, Cc && vs()));
  }
  function Pr(i, r) {
    var u = i.callbackNode;
    Uy(i, r);
    var p = Uo(i, i === ci ? Oi : 0);
    if (p === 0) u !== null && Sw(u), i.callbackNode = null, i.callbackPriority = 0;
    else if (r = p & -p, i.callbackPriority !== r) {
      if (u != null && Sw(u), r === 1) i.tag === 0 ? Pl(Ig.bind(null, i)) : Up(Ig.bind(null, i)), Sc(function() {
        !(Ct & 6) && vs();
      }), u = null;
      else {
        switch (Vy(p)) {
          case 1:
            u = _o;
            break;
          case 4:
            u = Py;
            break;
          case 16:
            u = Qd;
            break;
          case 536870912:
            u = _y;
            break;
          default:
            u = Qd;
        }
        u = PE(u, gm.bind(null, i));
      }
      i.callbackPriority = r, i.callbackNode = u;
    }
  }
  function gm(i, r) {
    if (Hf = -1, Qi = 0, Ct & 6) throw Error(n(327));
    var u = i.callbackNode;
    if (Pc() && i.callbackNode !== u) return null;
    var p = Uo(i, i === ci ? Oi : 0);
    if (p === 0) return null;
    if (p & 30 || p & i.expiredLanes || r) r = Sm(i, p);
    else {
      r = p;
      var g = Ct;
      Ct |= 2;
      var w = xE();
      (ci !== i || Oi !== r) && (Xr = null, $c = sn() + 500, tl(i, r));
      do
        try {
          RE();
          break;
        } catch (O) {
          kE(i, O);
        }
      while (!0);
      gg(), ql.current = w, Ct = g, Jn !== null ? r = 0 : (ci = null, Oi = 0, r = Vn);
    }
    if (r !== 0) {
      if (r === 2 && (g = zy(i), g !== 0 && (p = g, r = If(i, g))), r === 1) throw u = zf, tl(i, 0), Wa(i, p), Pr(i, sn()), u;
      if (r === 6) Wa(i, p);
      else {
        if (g = i.current.alternate, !(p & 30) && !fk(g) && (r = Sm(i, p), r === 2 && (w = zy(i), w !== 0 && (p = w, r = If(i, w))), r === 1)) throw u = zf, tl(i, 0), Wa(i, p), Pr(i, sn()), u;
        switch (i.finishedWork = g, i.finishedLanes = p, r) {
          case 0:
          case 1:
            throw Error(n(345));
          case 2:
            hu(i, Ar, Xr);
            break;
          case 3:
            if (Wa(i, p), (p & 130023424) === p && (r = Hg + 500 - sn(), 10 < r)) {
              if (Uo(i, 0) !== 0) break;
              if (g = i.suspendedLanes, (g & p) !== p) {
                ei(), i.pingedLanes |= i.suspendedLanes & g;
                break;
              }
              i.timeoutHandle = Pp(hu.bind(null, i, Ar, Xr), r);
              break;
            }
            hu(i, Ar, Xr);
            break;
          case 4:
            if (Wa(i, p), (p & 4194240) === p) break;
            for (r = i.eventTimes, g = -1; 0 < p; ) {
              var b = 31 - ca(p);
              w = 1 << b, b = r[b], b > g && (g = b), p &= ~w;
            }
            if (p = g, p = sn() - p, p = (120 > p ? 120 : 480 > p ? 480 : 1080 > p ? 1080 : 1920 > p ? 1920 : 3e3 > p ? 3e3 : 4320 > p ? 4320 : 1960 * dk(p / 1960)) - p, 10 < p) {
              i.timeoutHandle = Pp(hu.bind(null, i, Ar, Xr), p);
              break;
            }
            hu(i, Ar, Xr);
            break;
          case 5:
            hu(i, Ar, Xr);
            break;
          default:
            throw Error(n(329));
        }
      }
    }
    return Pr(i, sn()), i.callbackNode === u ? gm.bind(null, i) : null;
  }
  function If(i, r) {
    var u = Ff;
    return i.current.memoizedState.isDehydrated && (tl(i, r).flags |= 256), i = Sm(i, r), i !== 2 && (r = Ar, Ar = u, r !== null && du(r)), i;
  }
  function du(i) {
    Ar === null ? Ar = i : Ar.push.apply(Ar, i);
  }
  function fk(i) {
    for (var r = i; ; ) {
      if (r.flags & 16384) {
        var u = r.updateQueue;
        if (u !== null && (u = u.stores, u !== null)) for (var p = 0; p < u.length; p++) {
          var g = u[p], w = g.getSnapshot;
          g = g.value;
          try {
            if (!qa(w(), g)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (u = r.child, r.subtreeFlags & 16384 && u !== null) u.return = r, r = u;
      else {
        if (r === i) break;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === i) return !0;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
    }
    return !0;
  }
  function Wa(i, r) {
    for (r &= ~vm, r &= ~Lc, i.suspendedLanes |= r, i.pingedLanes &= ~r, i = i.expirationTimes; 0 < r; ) {
      var u = 31 - ca(r), p = 1 << u;
      i[u] = -1, r &= ~p;
    }
  }
  function Ig(i) {
    if (Ct & 6) throw Error(n(327));
    Pc();
    var r = Uo(i, 0);
    if (!(r & 1)) return Pr(i, sn()), null;
    var u = Sm(i, r);
    if (i.tag !== 0 && u === 2) {
      var p = zy(i);
      p !== 0 && (r = p, u = If(i, p));
    }
    if (u === 1) throw u = zf, tl(i, 0), Wa(i, r), Pr(i, sn()), u;
    if (u === 6) throw Error(n(345));
    return i.finishedWork = i.current.alternate, i.finishedLanes = r, hu(i, Ar, Xr), Pr(i, sn()), null;
  }
  function qg(i, r) {
    var u = Ct;
    Ct |= 1;
    try {
      return i(r);
    } finally {
      Ct = u, Ct === 0 && ($c = sn() + 500, Cc && vs());
    }
  }
  function fu(i) {
    el !== null && el.tag === 0 && !(Ct & 6) && Pc();
    var r = Ct;
    Ct |= 1;
    var u = $i.transition, p = Xt;
    try {
      if ($i.transition = null, Xt = 1, i) return i();
    } finally {
      Xt = p, $i.transition = u, Ct = r, !(Ct & 6) && vs();
    }
  }
  function jg() {
    Kr = Mc.current, un(Mc);
  }
  function tl(i, r) {
    i.finishedWork = null, i.finishedLanes = 0;
    var u = i.timeoutHandle;
    if (u !== -1 && (i.timeoutHandle = -1, hg(u)), Jn !== null) for (u = Jn.return; u !== null; ) {
      var p = u;
      switch (Fp(p), p.tag) {
        case 1:
          p = p.type.childContextTypes, p != null && Ec();
          break;
        case 3:
          eu(), un(oi), un(An), _e();
          break;
        case 5:
          qp(p);
          break;
        case 4:
          eu();
          break;
        case 13:
          un(bn);
          break;
        case 19:
          un(bn);
          break;
        case 10:
          Sg(p.type._context);
          break;
        case 22:
        case 23:
          jg();
      }
      u = u.return;
    }
    if (ci = i, Jn = i = Ql(i.current, null), Oi = Kr = r, Vn = 0, zf = null, vm = Lc = Cs = 0, Ar = Ff = null, Zo !== null) {
      for (r = 0; r < Zo.length; r++) if (u = Zo[r], p = u.interleaved, p !== null) {
        u.interleaved = null;
        var g = p.next, w = u.pending;
        if (w !== null) {
          var b = w.next;
          w.next = g, p.next = b;
        }
        u.pending = p;
      }
      Zo = null;
    }
    return i;
  }
  function kE(i, r) {
    do {
      var u = Jn;
      try {
        if (gg(), dt.current = su, Bp) {
          for (var p = zt.memoizedState; p !== null; ) {
            var g = p.queue;
            g !== null && (g.pending = null), p = p.next;
          }
          Bp = !1;
        }
        if (Jt = 0, gi = Kn = zt = null, Sf = !1, tu = 0, uu.current = null, u === null || u.return === null) {
          Vn = 1, zf = r, Jn = null;
          break;
        }
        e: {
          var w = i, b = u.return, O = u, P = r;
          if (r = Oi, O.flags |= 32768, P !== null && typeof P == "object" && typeof P.then == "function") {
            var j = P, ie = O, re = ie.tag;
            if (!(ie.mode & 1) && (re === 0 || re === 11 || re === 15)) {
              var te = ie.alternate;
              te ? (ie.updateQueue = te.updateQueue, ie.memoizedState = te.memoizedState, ie.lanes = te.lanes) : (ie.updateQueue = null, ie.memoizedState = null);
            }
            var Te = fE(b);
            if (Te !== null) {
              Te.flags &= -257, Il(Te, b, O, w, r), Te.mode & 1 && Og(w, j, r), r = Te, P = j;
              var ke = r.updateQueue;
              if (ke === null) {
                var De = /* @__PURE__ */ new Set();
                De.add(P), r.updateQueue = De;
              } else ke.add(P);
              break e;
            } else {
              if (!(r & 1)) {
                Og(w, j, r), Bg();
                break e;
              }
              P = Error(n(426));
            }
          } else if (Tn && O.mode & 1) {
            var Hn = fE(b);
            if (Hn !== null) {
              !(Hn.flags & 65536) && (Hn.flags |= 256), Il(Hn, b, O, w, r), Ks(lu(P, O));
              break e;
            }
          }
          w = P = lu(P, O), Vn !== 4 && (Vn = 2), Ff === null ? Ff = [w] : Ff.push(w), w = b;
          do {
            switch (w.tag) {
              case 3:
                w.flags |= 65536, r &= -r, w.lanes |= r;
                var F = dE(w, P, r);
                sE(w, F);
                break e;
              case 1:
                O = P;
                var U = w.type, I = w.stateNode;
                if (!(w.flags & 128) && (typeof U.getDerivedStateFromError == "function" || I !== null && typeof I.componentDidCatch == "function" && (jl === null || !jl.has(I)))) {
                  w.flags |= 65536, r &= -r, w.lanes |= r;
                  var le = $g(w, O, r);
                  sE(w, le);
                  break e;
                }
            }
            w = w.return;
          } while (w !== null);
        }
        ME(u);
      } catch (ge) {
        r = ge, Jn === u && u !== null && (Jn = u = u.return);
        continue;
      }
      break;
    } while (!0);
  }
  function xE() {
    var i = ql.current;
    return ql.current = su, i === null ? su : i;
  }
  function Bg() {
    (Vn === 0 || Vn === 3 || Vn === 2) && (Vn = 4), ci === null || !(Cs & 268435455) && !(Lc & 268435455) || Wa(ci, Oi);
  }
  function Sm(i, r) {
    var u = Ct;
    Ct |= 2;
    var p = xE();
    (ci !== i || Oi !== r) && (Xr = null, tl(i, r));
    do
      try {
        hk();
        break;
      } catch (g) {
        kE(i, g);
      }
    while (!0);
    if (gg(), Ct = u, ql.current = p, Jn !== null) throw Error(n(261));
    return ci = null, Oi = 0, Vn;
  }
  function hk() {
    for (; Jn !== null; ) DE(Jn);
  }
  function RE() {
    for (; Jn !== null && !Tw(); ) DE(Jn);
  }
  function DE(i) {
    var r = AE(i.alternate, i, Kr);
    i.memoizedProps = i.pendingProps, r === null ? ME(i) : Jn = r, uu.current = null;
  }
  function ME(i) {
    var r = i;
    do {
      var u = r.alternate;
      if (i = r.return, r.flags & 32768) {
        if (u = hm(u, r), u !== null) {
          u.flags &= 32767, Jn = u;
          return;
        }
        if (i !== null) i.flags |= 32768, i.subtreeFlags = 0, i.deletions = null;
        else {
          Vn = 6, Jn = null;
          return;
        }
      } else if (u = SE(u, r, Kr), u !== null) {
        Jn = u;
        return;
      }
      if (r = r.sibling, r !== null) {
        Jn = r;
        return;
      }
      Jn = r = i;
    } while (r !== null);
    Vn === 0 && (Vn = 5);
  }
  function hu(i, r, u) {
    var p = Xt, g = $i.transition;
    try {
      $i.transition = null, Xt = 1, pk(i, r, u, p);
    } finally {
      $i.transition = g, Xt = p;
    }
    return null;
  }
  function pk(i, r, u, p) {
    do
      Pc();
    while (el !== null);
    if (Ct & 6) throw Error(n(327));
    u = i.finishedWork;
    var g = i.finishedLanes;
    if (u === null) return null;
    if (i.finishedWork = null, i.finishedLanes = 0, u === i.current) throw Error(n(177));
    i.callbackNode = null, i.callbackPriority = 0;
    var w = u.lanes | u.childLanes;
    if (q0(i, w), i === ci && (Jn = ci = null, Oi = 0), !(u.subtreeFlags & 2064) && !(u.flags & 2064) || ym || (ym = !0, PE(Qd, function() {
      return Pc(), null;
    })), w = (u.flags & 15990) !== 0, u.subtreeFlags & 15990 || w) {
      w = $i.transition, $i.transition = null;
      var b = Xt;
      Xt = 1;
      var O = Ct;
      Ct |= 4, uu.current = null, wE(i, u), zg(u, i), mc(Yo), Vo = !!uf, Yo = uf = null, i.current = u, ck(u), F0(), Ct = O, Xt = b, $i.transition = w;
    } else i.current = u;
    if (ym && (ym = !1, el = i, Vf = g), w = i.pendingLanes, w === 0 && (jl = null), Ew(u.stateNode), Pr(i, sn()), r !== null) for (p = i.onRecoverableError, u = 0; u < r.length; u++) g = r[u], p(g.value, { componentStack: g.stack, digest: g.digest });
    if (Oc) throw Oc = !1, i = cu, cu = null, i;
    return Vf & 1 && i.tag !== 0 && Pc(), w = i.pendingLanes, w & 1 ? i === Ac ? Bl++ : (Bl = 0, Ac = i) : Bl = 0, vs(), null;
  }
  function Pc() {
    if (el !== null) {
      var i = Vy(Vf), r = $i.transition, u = Xt;
      try {
        if ($i.transition = null, Xt = 16 > i ? 16 : i, el === null) var p = !1;
        else {
          if (i = el, el = null, Vf = 0, Ct & 6) throw Error(n(331));
          var g = Ct;
          for (Ct |= 4, Ce = i.current; Ce !== null; ) {
            var w = Ce, b = w.child;
            if (Ce.flags & 16) {
              var O = w.deletions;
              if (O !== null) {
                for (var P = 0; P < O.length; P++) {
                  var j = O[P];
                  for (Ce = j; Ce !== null; ) {
                    var ie = Ce;
                    switch (ie.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Pf(8, ie, w);
                    }
                    var re = ie.child;
                    if (re !== null) re.return = ie, Ce = re;
                    else for (; Ce !== null; ) {
                      ie = Ce;
                      var te = ie.sibling, Te = ie.return;
                      if (mm(ie), ie === j) {
                        Ce = null;
                        break;
                      }
                      if (te !== null) {
                        te.return = Te, Ce = te;
                        break;
                      }
                      Ce = Te;
                    }
                  }
                }
                var ke = w.alternate;
                if (ke !== null) {
                  var De = ke.child;
                  if (De !== null) {
                    ke.child = null;
                    do {
                      var Hn = De.sibling;
                      De.sibling = null, De = Hn;
                    } while (De !== null);
                  }
                }
                Ce = w;
              }
            }
            if (w.subtreeFlags & 2064 && b !== null) b.return = w, Ce = b;
            else e: for (; Ce !== null; ) {
              if (w = Ce, w.flags & 2048) switch (w.tag) {
                case 0:
                case 11:
                case 15:
                  Pf(9, w, w.return);
              }
              var F = w.sibling;
              if (F !== null) {
                F.return = w.return, Ce = F;
                break e;
              }
              Ce = w.return;
            }
          }
          var U = i.current;
          for (Ce = U; Ce !== null; ) {
            b = Ce;
            var I = b.child;
            if (b.subtreeFlags & 2064 && I !== null) I.return = b, Ce = I;
            else e: for (b = U; Ce !== null; ) {
              if (O = Ce, O.flags & 2048) try {
                switch (O.tag) {
                  case 0:
                  case 11:
                  case 15:
                    _f(9, O);
                }
              } catch (ge) {
                wn(O, O.return, ge);
              }
              if (O === b) {
                Ce = null;
                break e;
              }
              var le = O.sibling;
              if (le !== null) {
                le.return = O.return, Ce = le;
                break e;
              }
              Ce = O.return;
            }
          }
          if (Ct = g, vs(), Ha && typeof Ha.onPostCommitFiberRoot == "function") try {
            Ha.onPostCommitFiberRoot(Yd, i);
          } catch {
          }
          p = !0;
        }
        return p;
      } finally {
        Xt = u, $i.transition = r;
      }
    }
    return !1;
  }
  function LE(i, r, u) {
    r = lu(u, r), r = dE(i, r, 1), i = Fl(i, r, 1), r = ei(), i !== null && (zo(i, 1, r), Pr(i, r));
  }
  function wn(i, r, u) {
    if (i.tag === 3) LE(i, i, u);
    else for (; r !== null; ) {
      if (r.tag === 3) {
        LE(r, i, u);
        break;
      } else if (r.tag === 1) {
        var p = r.stateNode;
        if (typeof r.type.getDerivedStateFromError == "function" || typeof p.componentDidCatch == "function" && (jl === null || !jl.has(p))) {
          i = lu(u, i), i = $g(r, i, 1), r = Fl(r, i, 1), i = ei(), r !== null && (zo(r, 1, i), Pr(r, i));
          break;
        }
      }
      r = r.return;
    }
  }
  function mk(i, r, u) {
    var p = i.pingCache;
    p !== null && p.delete(r), r = ei(), i.pingedLanes |= i.suspendedLanes & u, ci === i && (Oi & u) === u && (Vn === 4 || Vn === 3 && (Oi & 130023424) === Oi && 500 > sn() - Hg ? tl(i, 0) : vm |= u), Pr(i, r);
  }
  function $E(i, r) {
    r === 0 && (i.mode & 1 ? (r = Ia, Ia <<= 1, !(Ia & 130023424) && (Ia = 4194304)) : r = 1);
    var u = ei();
    i = Yr(i, r), i !== null && (zo(i, r, u), Pr(i, u));
  }
  function vk(i) {
    var r = i.memoizedState, u = 0;
    r !== null && (u = r.retryLane), $E(i, u);
  }
  function OE(i, r) {
    var u = 0;
    switch (i.tag) {
      case 13:
        var p = i.stateNode, g = i.memoizedState;
        g !== null && (u = g.retryLane);
        break;
      case 19:
        p = i.stateNode;
        break;
      default:
        throw Error(n(314));
    }
    p !== null && p.delete(r), $E(i, u);
  }
  var AE;
  AE = function(i, r, u) {
    if (i !== null) if (i.memoizedProps !== r.pendingProps || oi.current) Xn = !0;
    else {
      if (!(i.lanes & u) && !(r.flags & 128)) return Xn = !1, $f(i, r, u);
      Xn = !!(i.flags & 131072);
    }
    else Xn = !1, Tn && r.flags & 1048576 && nE(r, Ws, r.index);
    switch (r.lanes = 0, r.tag) {
      case 2:
        var p = r.type;
        Sa(i, r), i = r.pendingProps;
        var g = ma(r, An.current);
        Cn(r, u), g = Vl(null, r, p, i, g, u);
        var w = Qa();
        return r.flags |= 1, typeof g == "object" && g !== null && typeof g.render == "function" && g.$$typeof === void 0 ? (r.tag = 1, r.memoizedState = null, r.updateQueue = null, Gn(p) ? (w = !0, Rr(r)) : w = !1, r.memoizedState = g.state !== null && g.state !== void 0 ? g.state : null, Cg(r), g.updater = om, r.stateNode = g, g._reactInternals = r, xf(r, p, i, u), r = Mf(null, r, p, !0, w, u)) : (r.tag = 0, Tn && w && zp(r), Li(null, r, g, u), r = r.child), r;
      case 16:
        p = r.elementType;
        e: {
          switch (Sa(i, r), i = r.pendingProps, g = p._init, p = g(p._payload), r.type = p, g = r.tag = gk(p), i = Ya(p, i), g) {
            case 0:
              r = hE(null, r, p, i, u);
              break e;
            case 1:
              r = pE(null, r, p, i, u);
              break e;
            case 11:
              r = $r(null, r, p, i, u);
              break e;
            case 14:
              r = ou(null, r, p, Ya(p.type, i), u);
              break e;
          }
          throw Error(n(
            306,
            p,
            ""
          ));
        }
        return r;
      case 0:
        return p = r.type, g = r.pendingProps, g = r.elementType === p ? g : Ya(p, g), hE(i, r, p, g, u);
      case 1:
        return p = r.type, g = r.pendingProps, g = r.elementType === p ? g : Ya(p, g), pE(i, r, p, g, u);
      case 3:
        e: {
          if (Rc(r), i === null) throw Error(n(387));
          p = r.pendingProps, w = r.memoizedState, g = w.element, aE(i, r), pf(r, p, null, u);
          var b = r.memoizedState;
          if (p = b.element, w.isDehydrated) if (w = { element: p, isDehydrated: !1, cache: b.cache, pendingSuspenseBoundaries: b.pendingSuspenseBoundaries, transitions: b.transitions }, r.updateQueue.baseState = w, r.memoizedState = w, r.flags & 256) {
            g = lu(Error(n(423)), r), r = mE(i, r, p, u, g);
            break e;
          } else if (p !== g) {
            g = lu(Error(n(424)), r), r = mE(i, r, p, u, g);
            break e;
          } else for (Mr = hs(r.stateNode.containerInfo.firstChild), Dr = r, Tn = !0, ya = null, u = me(r, null, p, u), r.child = u; u; ) u.flags = u.flags & -3 | 4096, u = u.sibling;
          else {
            if (zl(), p === g) {
              r = Ta(i, r, u);
              break e;
            }
            Li(i, r, p, u);
          }
          r = r.child;
        }
        return r;
      case 5:
        return lE(r), i === null && vg(r), p = r.type, g = r.pendingProps, w = i !== null ? i.memoizedProps : null, b = g.children, Ap(p, g) ? b = null : w !== null && Ap(p, w) && (r.flags |= 32), Ag(i, r), Li(i, r, b, u), r.child;
      case 6:
        return i === null && vg(r), null;
      case 13:
        return fm(i, r, u);
      case 4:
        return kg(r, r.stateNode.containerInfo), p = r.pendingProps, i === null ? r.child = Un(r, null, p, u) : Li(i, r, p, u), r.child;
      case 11:
        return p = r.type, g = r.pendingProps, g = r.elementType === p ? g : Ya(p, g), $r(i, r, p, g, u);
      case 7:
        return Li(i, r, r.pendingProps, u), r.child;
      case 8:
        return Li(i, r, r.pendingProps.children, u), r.child;
      case 12:
        return Li(i, r, r.pendingProps.children, u), r.child;
      case 10:
        e: {
          if (p = r.type._context, g = r.pendingProps, w = r.memoizedProps, b = g.value, Oe(Qr, p._currentValue), p._currentValue = b, w !== null) if (qa(w.value, b)) {
            if (w.children === g.children && !oi.current) {
              r = Ta(i, r, u);
              break e;
            }
          } else for (w = r.child, w !== null && (w.return = r); w !== null; ) {
            var O = w.dependencies;
            if (O !== null) {
              b = w.child;
              for (var P = O.firstContext; P !== null; ) {
                if (P.context === p) {
                  if (w.tag === 1) {
                    P = Xs(-1, u & -u), P.tag = 2;
                    var j = w.updateQueue;
                    if (j !== null) {
                      j = j.shared;
                      var ie = j.pending;
                      ie === null ? P.next = P : (P.next = ie.next, ie.next = P), j.pending = P;
                    }
                  }
                  w.lanes |= u, P = w.alternate, P !== null && (P.lanes |= u), Tg(
                    w.return,
                    u,
                    r
                  ), O.lanes |= u;
                  break;
                }
                P = P.next;
              }
            } else if (w.tag === 10) b = w.type === r.type ? null : w.child;
            else if (w.tag === 18) {
              if (b = w.return, b === null) throw Error(n(341));
              b.lanes |= u, O = b.alternate, O !== null && (O.lanes |= u), Tg(b, u, r), b = w.sibling;
            } else b = w.child;
            if (b !== null) b.return = w;
            else for (b = w; b !== null; ) {
              if (b === r) {
                b = null;
                break;
              }
              if (w = b.sibling, w !== null) {
                w.return = b.return, b = w;
                break;
              }
              b = b.return;
            }
            w = b;
          }
          Li(i, r, g.children, u), r = r.child;
        }
        return r;
      case 9:
        return g = r.type, p = r.pendingProps.children, Cn(r, u), g = ga(g), p = p(g), r.flags |= 1, Li(i, r, p, u), r.child;
      case 14:
        return p = r.type, g = Ya(p, r.pendingProps), g = Ya(p.type, g), ou(i, r, p, g, u);
      case 15:
        return it(i, r, r.type, r.pendingProps, u);
      case 17:
        return p = r.type, g = r.pendingProps, g = r.elementType === p ? g : Ya(p, g), Sa(i, r), r.tag = 1, Gn(p) ? (i = !0, Rr(r)) : i = !1, Cn(r, u), um(r, p, g), xf(r, p, g, u), Mf(null, r, p, !0, i, u);
      case 19:
        return Ts(i, r, u);
      case 22:
        return Df(i, r, u);
    }
    throw Error(n(156, r.tag));
  };
  function PE(i, r) {
    return gw(i, r);
  }
  function yk(i, r, u, p) {
    this.tag = i, this.key = u, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = r, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = p, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Ea(i, r, u, p) {
    return new yk(i, r, u, p);
  }
  function Qg(i) {
    return i = i.prototype, !(!i || !i.isReactComponent);
  }
  function gk(i) {
    if (typeof i == "function") return Qg(i) ? 1 : 0;
    if (i != null) {
      if (i = i.$$typeof, i === Mt) return 11;
      if (i === Sn) return 14;
    }
    return 2;
  }
  function Ql(i, r) {
    var u = i.alternate;
    return u === null ? (u = Ea(i.tag, r, i.key, i.mode), u.elementType = i.elementType, u.type = i.type, u.stateNode = i.stateNode, u.alternate = i, i.alternate = u) : (u.pendingProps = r, u.type = i.type, u.flags = 0, u.subtreeFlags = 0, u.deletions = null), u.flags = i.flags & 14680064, u.childLanes = i.childLanes, u.lanes = i.lanes, u.child = i.child, u.memoizedProps = i.memoizedProps, u.memoizedState = i.memoizedState, u.updateQueue = i.updateQueue, r = i.dependencies, u.dependencies = r === null ? null : { lanes: r.lanes, firstContext: r.firstContext }, u.sibling = i.sibling, u.index = i.index, u.ref = i.ref, u;
  }
  function qf(i, r, u, p, g, w) {
    var b = 2;
    if (p = i, typeof i == "function") Qg(i) && (b = 1);
    else if (typeof i == "string") b = 5;
    else e: switch (i) {
      case He:
        return nl(u.children, g, w, r);
      case de:
        b = 8, g |= 8;
        break;
      case Ge:
        return i = Ea(12, u, r, g | 2), i.elementType = Ge, i.lanes = w, i;
      case Ae:
        return i = Ea(13, u, r, g), i.elementType = Ae, i.lanes = w, i;
      case wt:
        return i = Ea(19, u, r, g), i.elementType = wt, i.lanes = w, i;
      case ot:
        return Yl(u, g, w, r);
      default:
        if (typeof i == "object" && i !== null) switch (i.$$typeof) {
          case ft:
            b = 10;
            break e;
          case Kt:
            b = 9;
            break e;
          case Mt:
            b = 11;
            break e;
          case Sn:
            b = 14;
            break e;
          case Je:
            b = 16, p = null;
            break e;
        }
        throw Error(n(130, i == null ? i : typeof i, ""));
    }
    return r = Ea(b, u, r, g), r.elementType = i, r.type = p, r.lanes = w, r;
  }
  function nl(i, r, u, p) {
    return i = Ea(7, i, p, r), i.lanes = u, i;
  }
  function Yl(i, r, u, p) {
    return i = Ea(22, i, p, r), i.elementType = ot, i.lanes = u, i.stateNode = { isHidden: !1 }, i;
  }
  function Yg(i, r, u) {
    return i = Ea(6, i, null, r), i.lanes = u, i;
  }
  function Tm(i, r, u) {
    return r = Ea(4, i.children !== null ? i.children : [], i.key, r), r.lanes = u, r.stateNode = { containerInfo: i.containerInfo, pendingChildren: null, implementation: i.implementation }, r;
  }
  function _E(i, r, u, p, g) {
    this.tag = r, this.containerInfo = i, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Fy(0), this.expirationTimes = Fy(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Fy(0), this.identifierPrefix = p, this.onRecoverableError = g, this.mutableSourceEagerHydrationData = null;
  }
  function wm(i, r, u, p, g, w, b, O, P) {
    return i = new _E(i, r, u, O, P), r === 1 ? (r = 1, w === !0 && (r |= 8)) : r = 0, w = Ea(3, null, null, r), i.current = w, w.stateNode = i, w.memoizedState = { element: p, isDehydrated: u, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Cg(w), i;
  }
  function Sk(i, r, u) {
    var p = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: Tt, key: p == null ? null : "" + p, children: i, containerInfo: r, implementation: u };
  }
  function Gg(i) {
    if (!i) return kr;
    i = i._reactInternals;
    e: {
      if (Va(i) !== i || i.tag !== 1) throw Error(n(170));
      var r = i;
      do {
        switch (r.tag) {
          case 3:
            r = r.stateNode.context;
            break e;
          case 1:
            if (Gn(r.type)) {
              r = r.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        r = r.return;
      } while (r !== null);
      throw Error(n(171));
    }
    if (i.tag === 1) {
      var u = i.type;
      if (Gn(u)) return ff(i, u, r);
    }
    return r;
  }
  function NE(i, r, u, p, g, w, b, O, P) {
    return i = wm(u, p, !0, i, g, w, b, O, P), i.context = Gg(null), u = i.current, p = ei(), g = bs(u), w = Xs(p, g), w.callback = r ?? null, Fl(u, w, g), i.current.lanes = g, zo(i, g, p), Pr(i, p), i;
  }
  function Em(i, r, u, p) {
    var g = r.current, w = ei(), b = bs(g);
    return u = Gg(u), r.context === null ? r.context = u : r.pendingContext = u, r = Xs(w, b), r.payload = { element: i }, p = p === void 0 ? null : p, p !== null && (r.callback = p), i = Fl(g, r, b), i !== null && (sr(i, g, b, w), Ip(i, g, b)), b;
  }
  function Cm(i) {
    if (i = i.current, !i.child) return null;
    switch (i.child.tag) {
      case 5:
        return i.child.stateNode;
      default:
        return i.child.stateNode;
    }
  }
  function Wg(i, r) {
    if (i = i.memoizedState, i !== null && i.dehydrated !== null) {
      var u = i.retryLane;
      i.retryLane = u !== 0 && u < r ? u : r;
    }
  }
  function bm(i, r) {
    Wg(i, r), (i = i.alternate) && Wg(i, r);
  }
  var Kg = typeof reportError == "function" ? reportError : function(i) {
    console.error(i);
  };
  function Gl(i) {
    this._internalRoot = i;
  }
  km.prototype.render = Gl.prototype.render = function(i) {
    var r = this._internalRoot;
    if (r === null) throw Error(n(409));
    Em(i, r, null, null);
  }, km.prototype.unmount = Gl.prototype.unmount = function() {
    var i = this._internalRoot;
    if (i !== null) {
      this._internalRoot = null;
      var r = i.containerInfo;
      fu(function() {
        Em(null, i, null, null);
      }), r[Ys] = null;
    }
  };
  function km(i) {
    this._internalRoot = i;
  }
  km.prototype.unstable_scheduleHydration = function(i) {
    if (i) {
      var r = nt();
      i = { blockedOn: null, target: i, priority: r };
      for (var u = 0; u < Ri.length && r !== 0 && r < Ri[u].priority; u++) ;
      Ri.splice(u, 0, i), u === 0 && By(i);
    }
  };
  function Xg(i) {
    return !(!i || i.nodeType !== 1 && i.nodeType !== 9 && i.nodeType !== 11);
  }
  function xm(i) {
    return !(!i || i.nodeType !== 1 && i.nodeType !== 9 && i.nodeType !== 11 && (i.nodeType !== 8 || i.nodeValue !== " react-mount-point-unstable "));
  }
  function UE() {
  }
  function Tk(i, r, u, p, g) {
    if (g) {
      if (typeof p == "function") {
        var w = p;
        p = function() {
          var j = Cm(b);
          w.call(j);
        };
      }
      var b = NE(r, p, i, 0, null, !1, !1, "", UE);
      return i._reactRootContainer = b, i[Ys] = b.current, yc(i.nodeType === 8 ? i.parentNode : i), fu(), b;
    }
    for (; g = i.lastChild; ) i.removeChild(g);
    if (typeof p == "function") {
      var O = p;
      p = function() {
        var j = Cm(P);
        O.call(j);
      };
    }
    var P = wm(i, 0, !1, null, null, !1, !1, "", UE);
    return i._reactRootContainer = P, i[Ys] = P.current, yc(i.nodeType === 8 ? i.parentNode : i), fu(function() {
      Em(r, P, u, p);
    }), P;
  }
  function Rm(i, r, u, p, g) {
    var w = u._reactRootContainer;
    if (w) {
      var b = w;
      if (typeof g == "function") {
        var O = g;
        g = function() {
          var P = Cm(b);
          O.call(P);
        };
      }
      Em(r, b, i, g);
    } else b = Tk(u, r, i, g, p);
    return Cm(b);
  }
  Zt = function(i) {
    switch (i.tag) {
      case 3:
        var r = i.stateNode;
        if (r.current.memoizedState.isDehydrated) {
          var u = No(r.pendingLanes);
          u !== 0 && (dp(r, u | 1), Pr(r, sn()), !(Ct & 6) && ($c = sn() + 500, vs()));
        }
        break;
      case 13:
        fu(function() {
          var p = Yr(i, 1);
          if (p !== null) {
            var g = ei();
            sr(p, i, 1, g);
          }
        }), bm(i, 1);
    }
  }, Hy = function(i) {
    if (i.tag === 13) {
      var r = Yr(i, 134217728);
      if (r !== null) {
        var u = ei();
        sr(r, i, 134217728, u);
      }
      bm(i, 134217728);
    }
  }, Iy = function(i) {
    if (i.tag === 13) {
      var r = bs(i), u = Yr(i, r);
      if (u !== null) {
        var p = ei();
        sr(u, i, r, p);
      }
      bm(i, r);
    }
  }, nt = function() {
    return Xt;
  }, qy = function(i, r) {
    var u = Xt;
    try {
      return Xt = i, r();
    } finally {
      Xt = u;
    }
  }, li = function(i, r, u) {
    switch (r) {
      case "input":
        if (nc(i, u), r = u.name, u.type === "radio" && r != null) {
          for (u = i; u.parentNode; ) u = u.parentNode;
          for (u = u.querySelectorAll("input[name=" + JSON.stringify("" + r) + '][type="radio"]'), r = 0; r < u.length; r++) {
            var p = u[r];
            if (p !== i && p.form === i.form) {
              var g = Nn(p);
              if (!g) throw Error(n(90));
              er(p), nc(p, g);
            }
          }
        }
        break;
      case "textarea":
        ic(i, u);
        break;
      case "select":
        r = u.value, r != null && qr(i, !!u.multiple, r, !1);
    }
  }, My = qg, Ly = fu;
  var zE = { usingClientEntryPoint: !1, Events: [Pe, ja, Nn, pw, mw, qg] }, jf = { findFiberByHostInstance: Go, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, wk = { bundleType: jf.bundleType, version: jf.version, rendererPackageName: jf.rendererPackageName, rendererConfig: jf.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ct.ReactCurrentDispatcher, findHostInstanceByFiber: function(i) {
    return i = Ay(i), i === null ? null : i.stateNode;
  }, findFiberByHostInstance: jf.findFiberByHostInstance, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Bf = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Bf.isDisabled && Bf.supportsFiber) try {
      Yd = Bf.inject(wk), Ha = Bf;
    } catch {
    }
  }
  return Da.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = zE, Da.createPortal = function(i, r) {
    var u = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Xg(r)) throw Error(n(200));
    return Sk(i, r, null, u);
  }, Da.createRoot = function(i, r) {
    if (!Xg(i)) throw Error(n(299));
    var u = !1, p = "", g = Kg;
    return r != null && (r.unstable_strictMode === !0 && (u = !0), r.identifierPrefix !== void 0 && (p = r.identifierPrefix), r.onRecoverableError !== void 0 && (g = r.onRecoverableError)), r = wm(i, 1, !1, null, null, u, !1, p, g), i[Ys] = r.current, yc(i.nodeType === 8 ? i.parentNode : i), new Gl(r);
  }, Da.findDOMNode = function(i) {
    if (i == null) return null;
    if (i.nodeType === 1) return i;
    var r = i._reactInternals;
    if (r === void 0)
      throw typeof i.render == "function" ? Error(n(188)) : (i = Object.keys(i).join(","), Error(n(268, i)));
    return i = Ay(r), i = i === null ? null : i.stateNode, i;
  }, Da.flushSync = function(i) {
    return fu(i);
  }, Da.hydrate = function(i, r, u) {
    if (!xm(r)) throw Error(n(200));
    return Rm(null, i, r, !0, u);
  }, Da.hydrateRoot = function(i, r, u) {
    if (!Xg(i)) throw Error(n(405));
    var p = u != null && u.hydratedSources || null, g = !1, w = "", b = Kg;
    if (u != null && (u.unstable_strictMode === !0 && (g = !0), u.identifierPrefix !== void 0 && (w = u.identifierPrefix), u.onRecoverableError !== void 0 && (b = u.onRecoverableError)), r = NE(r, null, i, 1, u ?? null, g, !1, w, b), i[Ys] = r.current, yc(i), p) for (i = 0; i < p.length; i++) u = p[i], g = u._getVersion, g = g(u._source), r.mutableSourceEagerHydrationData == null ? r.mutableSourceEagerHydrationData = [u, g] : r.mutableSourceEagerHydrationData.push(
      u,
      g
    );
    return new km(r);
  }, Da.render = function(i, r, u) {
    if (!xm(r)) throw Error(n(200));
    return Rm(null, i, r, !1, u);
  }, Da.unmountComponentAtNode = function(i) {
    if (!xm(i)) throw Error(n(40));
    return i._reactRootContainer ? (fu(function() {
      Rm(null, null, i, !1, function() {
        i._reactRootContainer = null, i[Ys] = null;
      });
    }), !0) : !1;
  }, Da.unstable_batchedUpdates = qg, Da.unstable_renderSubtreeIntoContainer = function(i, r, u, p) {
    if (!xm(u)) throw Error(n(200));
    if (i == null || i._reactInternals === void 0) throw Error(n(38));
    return Rm(i, r, u, !1, p);
  }, Da.version = "18.3.1-next-f1338f8080-20240426", Da;
}
var Ma = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fP;
function iQ() {
  return fP || (fP = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var f = RP, s = oV(), n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, o = !1;
    function h(e) {
      o = e;
    }
    function v(e) {
      if (!o) {
        for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), l = 1; l < t; l++)
          a[l - 1] = arguments[l];
        k("warn", e, a);
      }
    }
    function y(e) {
      if (!o) {
        for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), l = 1; l < t; l++)
          a[l - 1] = arguments[l];
        k("error", e, a);
      }
    }
    function k(e, t, a) {
      {
        var l = n.ReactDebugCurrentFrame, c = l.getStackAddendum();
        c !== "" && (t += "%s", a = a.concat([c]));
        var m = a.map(function(T) {
          return String(T);
        });
        m.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, m);
      }
    }
    var D = 0, $ = 1, _ = 2, A = 3, B = 4, W = 5, ne = 6, ce = 7, Re = 8, Lt = 9, $t = 10, Ve = 11, ct = 12, Ye = 13, Tt = 14, He = 15, de = 16, Ge = 17, ft = 18, Kt = 19, Mt = 21, Ae = 22, wt = 23, Sn = 24, Je = 25, ot = !0, oe = !1, Le = !1, he = !1, yt = !1, Nt = !0, Ii = !0, jn = !0, oa = !0, ri = /* @__PURE__ */ new Set(), ai = {}, bi = {};
    function si(e, t) {
      ki(e, t), ki(e + "Capture", t);
    }
    function ki(e, t) {
      ai[e] && y("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), ai[e] = t;
      {
        var a = e.toLowerCase();
        bi[a] = e, e === "onDoubleClick" && (bi.ondblclick = e);
      }
      for (var l = 0; l < t.length; l++)
        ri.add(t[l]);
    }
    var _n = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", er = Object.prototype.hasOwnProperty;
    function yi(e) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, a = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return a;
      }
    }
    function xi(e) {
      try {
        return tr(e), !1;
      } catch {
        return !0;
      }
    }
    function tr(e) {
      return "" + e;
    }
    function Ir(e, t) {
      if (xi(e))
        return y("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", t, yi(e)), tr(e);
    }
    function nc(e) {
      if (xi(e))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", yi(e)), tr(e);
    }
    function Id(e, t) {
      if (xi(e))
        return y("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", t, yi(e)), tr(e);
    }
    function qd(e, t) {
      if (xi(e))
        return y("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", t, yi(e)), tr(e);
    }
    function Lo(e) {
      if (xi(e))
        return y("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", yi(e)), tr(e);
    }
    function qr(e) {
      if (xi(e))
        return y("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", yi(e)), tr(e);
    }
    var ua = 0, za = 1, ic = 2, jr = 3, ds = 4, $o = 5, Oo = 6, jd = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", pe = jd + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", ze = new RegExp("^[" + jd + "][" + pe + "]*$"), ht = {}, an = {};
    function Ln(e) {
      return er.call(an, e) ? !0 : er.call(ht, e) ? !1 : ze.test(e) ? (an[e] = !0, !0) : (ht[e] = !0, y("Invalid attribute name: `%s`", e), !1);
    }
    function wr(e, t, a) {
      return t !== null ? t.type === ua : a ? !1 : e.length > 2 && (e[0] === "o" || e[0] === "O") && (e[1] === "n" || e[1] === "N");
    }
    function Bn(e, t, a, l) {
      if (a !== null && a.type === ua)
        return !1;
      switch (typeof t) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean": {
          if (l)
            return !1;
          if (a !== null)
            return !a.acceptsBooleans;
          var c = e.toLowerCase().slice(0, 5);
          return c !== "data-" && c !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Er(e, t, a, l) {
      if (t === null || typeof t > "u" || Bn(e, t, a, l))
        return !0;
      if (l)
        return !1;
      if (a !== null)
        switch (a.type) {
          case jr:
            return !t;
          case ds:
            return t === !1;
          case $o:
            return isNaN(t);
          case Oo:
            return isNaN(t) || t < 1;
        }
      return !1;
    }
    function Qn(e) {
      return li.hasOwnProperty(e) ? li[e] : null;
    }
    function $n(e, t, a, l, c, m, T) {
      this.acceptsBooleans = t === ic || t === jr || t === ds, this.attributeName = l, this.attributeNamespace = c, this.mustUseProperty = a, this.propertyName = e, this.type = t, this.sanitizeURL = m, this.removeEmptyString = T;
    }
    var li = {}, rc = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    rc.forEach(function(e) {
      li[e] = new $n(
        e,
        ua,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
      var t = e[0], a = e[1];
      li[t] = new $n(
        t,
        za,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
      li[e] = new $n(
        e,
        ic,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
      li[e] = new $n(
        e,
        ic,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(e) {
      li[e] = new $n(
        e,
        jr,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      li[e] = new $n(
        e,
        jr,
        !0,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      li[e] = new $n(
        e,
        ds,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      li[e] = new $n(
        e,
        Oo,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(e) {
      li[e] = new $n(
        e,
        $o,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var kl = /[\-\:]([a-z])/g, lp = function(e) {
      return e[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(kl, lp);
      li[t] = new $n(
        t,
        za,
        !1,
        // mustUseProperty
        e,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(kl, lp);
      li[t] = new $n(
        t,
        za,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(kl, lp);
      li[t] = new $n(
        t,
        za,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(e) {
      li[e] = new $n(
        e,
        za,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var pw = "xlinkHref";
    li[pw] = new $n(
      "xlinkHref",
      za,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(e) {
      li[e] = new $n(
        e,
        za,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var mw = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, My = !1;
    function Ly(e) {
      !My && mw.test(e) && (My = !0, y("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(e)));
    }
    function $y(e, t, a, l) {
      if (l.mustUseProperty) {
        var c = l.propertyName;
        return e[c];
      } else {
        Ir(a, t), l.sanitizeURL && Ly("" + a);
        var m = l.attributeName, T = null;
        if (l.type === ds) {
          if (e.hasAttribute(m)) {
            var E = e.getAttribute(m);
            return E === "" ? !0 : Er(t, a, l, !1) ? E : E === "" + a ? a : E;
          }
        } else if (e.hasAttribute(m)) {
          if (Er(t, a, l, !1))
            return e.getAttribute(m);
          if (l.type === jr)
            return a;
          T = e.getAttribute(m);
        }
        return Er(t, a, l, !1) ? T === null ? a : T : T === "" + a ? a : T;
      }
    }
    function Oy(e, t, a, l) {
      {
        if (!Ln(t))
          return;
        if (!e.hasAttribute(t))
          return a === void 0 ? void 0 : null;
        var c = e.getAttribute(t);
        return Ir(a, t), c === "" + a ? a : c;
      }
    }
    function Ao(e, t, a, l) {
      var c = Qn(t);
      if (!wr(t, c, l)) {
        if (Er(t, a, c, l) && (a = null), l || c === null) {
          if (Ln(t)) {
            var m = t;
            a === null ? e.removeAttribute(m) : (Ir(a, t), e.setAttribute(m, "" + a));
          }
          return;
        }
        var T = c.mustUseProperty;
        if (T) {
          var E = c.propertyName;
          if (a === null) {
            var C = c.type;
            e[E] = C === jr ? !1 : "";
          } else
            e[E] = a;
          return;
        }
        var x = c.attributeName, M = c.attributeNamespace;
        if (a === null)
          e.removeAttribute(x);
        else {
          var z = c.type, N;
          z === jr || z === ds && a === !0 ? N = "" : (Ir(a, x), N = "" + a, c.sanitizeURL && Ly(N.toString())), M ? e.setAttributeNS(M, x, N) : e.setAttribute(x, N);
        }
      }
    }
    var xl = Symbol.for("react.element"), Fa = Symbol.for("react.portal"), ac = Symbol.for("react.fragment"), Po = Symbol.for("react.strict_mode"), sc = Symbol.for("react.profiler"), lc = Symbol.for("react.provider"), Bd = Symbol.for("react.context"), oc = Symbol.for("react.forward_ref"), op = Symbol.for("react.suspense"), up = Symbol.for("react.suspense_list"), Va = Symbol.for("react.memo"), qi = Symbol.for("react.lazy"), vw = Symbol.for("react.scope"), z0 = Symbol.for("react.debug_trace_mode"), Ay = Symbol.for("react.offscreen"), yw = Symbol.for("react.legacy_hidden"), gw = Symbol.for("react.cache"), Sw = Symbol.for("react.tracing_marker"), Tw = Symbol.iterator, F0 = "@@iterator";
    function sn(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = Tw && e[Tw] || e[F0];
      return typeof t == "function" ? t : null;
    }
    var gt = Object.assign, _o = 0, Py, Qd, ww, _y, Yd, Ha, Ew;
    function ca() {
    }
    ca.__reactDisabledLog = !0;
    function V0() {
      {
        if (_o === 0) {
          Py = console.log, Qd = console.info, ww = console.warn, _y = console.error, Yd = console.group, Ha = console.groupCollapsed, Ew = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ca,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        _o++;
      }
    }
    function H0() {
      {
        if (_o--, _o === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: gt({}, e, {
              value: Py
            }),
            info: gt({}, e, {
              value: Qd
            }),
            warn: gt({}, e, {
              value: ww
            }),
            error: gt({}, e, {
              value: _y
            }),
            group: gt({}, e, {
              value: Yd
            }),
            groupCollapsed: gt({}, e, {
              value: Ha
            }),
            groupEnd: gt({}, e, {
              value: Ew
            })
          });
        }
        _o < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ny = n.ReactCurrentDispatcher, uc;
    function Ia(e, t, a) {
      {
        if (uc === void 0)
          try {
            throw Error();
          } catch (c) {
            var l = c.stack.trim().match(/\n( *(at )?)/);
            uc = l && l[1] || "";
          }
        return `
` + uc + e;
      }
    }
    var No = !1, Uo;
    {
      var I0 = typeof WeakMap == "function" ? WeakMap : Map;
      Uo = new I0();
    }
    function Uy(e, t) {
      if (!e || No)
        return "";
      {
        var a = Uo.get(e);
        if (a !== void 0)
          return a;
      }
      var l;
      No = !0;
      var c = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var m;
      m = Ny.current, Ny.current = null, V0();
      try {
        if (t) {
          var T = function() {
            throw Error();
          };
          if (Object.defineProperty(T.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(T, []);
            } catch (Q) {
              l = Q;
            }
            Reflect.construct(e, [], T);
          } else {
            try {
              T.call();
            } catch (Q) {
              l = Q;
            }
            e.call(T.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Q) {
            l = Q;
          }
          e();
        }
      } catch (Q) {
        if (Q && l && typeof Q.stack == "string") {
          for (var E = Q.stack.split(`
`), C = l.stack.split(`
`), x = E.length - 1, M = C.length - 1; x >= 1 && M >= 0 && E[x] !== C[M]; )
            M--;
          for (; x >= 1 && M >= 0; x--, M--)
            if (E[x] !== C[M]) {
              if (x !== 1 || M !== 1)
                do
                  if (x--, M--, M < 0 || E[x] !== C[M]) {
                    var z = `
` + E[x].replace(" at new ", " at ");
                    return e.displayName && z.includes("<anonymous>") && (z = z.replace("<anonymous>", e.displayName)), typeof e == "function" && Uo.set(e, z), z;
                  }
                while (x >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        No = !1, Ny.current = m, H0(), Error.prepareStackTrace = c;
      }
      var N = e ? e.displayName || e.name : "", q = N ? Ia(N) : "";
      return typeof e == "function" && Uo.set(e, q), q;
    }
    function zy(e, t, a) {
      return Uy(e, !0);
    }
    function cp(e, t, a) {
      return Uy(e, !1);
    }
    function Fy(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function zo(e, t, a) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Uy(e, Fy(e));
      if (typeof e == "string")
        return Ia(e);
      switch (e) {
        case op:
          return Ia("Suspense");
        case up:
          return Ia("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case oc:
            return cp(e.render);
          case Va:
            return zo(e.type, t, a);
          case qi: {
            var l = e, c = l._payload, m = l._init;
            try {
              return zo(m(c), t, a);
            } catch {
            }
          }
        }
      return "";
    }
    function q0(e) {
      switch (e._debugOwner && e._debugOwner.type, e._debugSource, e.tag) {
        case W:
          return Ia(e.type);
        case de:
          return Ia("Lazy");
        case Ye:
          return Ia("Suspense");
        case Kt:
          return Ia("SuspenseList");
        case D:
        case _:
        case He:
          return cp(e.type);
        case Ve:
          return cp(e.type.render);
        case $:
          return zy(e.type);
        default:
          return "";
      }
    }
    function dp(e) {
      try {
        var t = "", a = e;
        do
          t += q0(a), a = a.return;
        while (a);
        return t;
      } catch (l) {
        return `
Error generating stack: ` + l.message + `
` + l.stack;
      }
    }
    function Xt(e, t, a) {
      var l = e.displayName;
      if (l)
        return l;
      var c = t.displayName || t.name || "";
      return c !== "" ? a + "(" + c + ")" : a;
    }
    function Vy(e) {
      return e.displayName || "Context";
    }
    function Zt(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case ac:
          return "Fragment";
        case Fa:
          return "Portal";
        case sc:
          return "Profiler";
        case Po:
          return "StrictMode";
        case op:
          return "Suspense";
        case up:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case Bd:
            var t = e;
            return Vy(t) + ".Consumer";
          case lc:
            var a = e;
            return Vy(a._context) + ".Provider";
          case oc:
            return Xt(e, e.render, "ForwardRef");
          case Va:
            var l = e.displayName || null;
            return l !== null ? l : Zt(e.type) || "Memo";
          case qi: {
            var c = e, m = c._payload, T = c._init;
            try {
              return Zt(T(m));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function Hy(e, t, a) {
      var l = t.displayName || t.name || "";
      return e.displayName || (l !== "" ? a + "(" + l + ")" : a);
    }
    function Iy(e) {
      return e.displayName || "Context";
    }
    function nt(e) {
      var t = e.tag, a = e.type;
      switch (t) {
        case Sn:
          return "Cache";
        case Lt:
          var l = a;
          return Iy(l) + ".Consumer";
        case $t:
          var c = a;
          return Iy(c._context) + ".Provider";
        case ft:
          return "DehydratedFragment";
        case Ve:
          return Hy(a, a.render, "ForwardRef");
        case ce:
          return "Fragment";
        case W:
          return a;
        case B:
          return "Portal";
        case A:
          return "Root";
        case ne:
          return "Text";
        case de:
          return Zt(a);
        case Re:
          return a === Po ? "StrictMode" : "Mode";
        case Ae:
          return "Offscreen";
        case ct:
          return "Profiler";
        case Mt:
          return "Scope";
        case Ye:
          return "Suspense";
        case Kt:
          return "SuspenseList";
        case Je:
          return "TracingMarker";
        // The display name for this tags come from the user-provided type:
        case $:
        case D:
        case Ge:
        case _:
        case Tt:
        case He:
          if (typeof a == "function")
            return a.displayName || a.name || null;
          if (typeof a == "string")
            return a;
          break;
      }
      return null;
    }
    var qy = n.ReactDebugCurrentFrame, nr = null, Rl = !1;
    function da() {
      {
        if (nr === null)
          return null;
        var e = nr._debugOwner;
        if (e !== null && typeof e < "u")
          return nt(e);
      }
      return null;
    }
    function Dl() {
      return nr === null ? "" : dp(nr);
    }
    function On() {
      qy.getCurrentStack = null, nr = null, Rl = !1;
    }
    function pn(e) {
      qy.getCurrentStack = e === null ? null : Dl, nr = e, Rl = !1;
    }
    function Gd() {
      return nr;
    }
    function Ri(e) {
      Rl = e;
    }
    function fa(e) {
      return "" + e;
    }
    function Is(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return qr(e), e;
        default:
          return "";
      }
    }
    var Wd = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function jy(e, t) {
      Wd[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || y("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), t.onChange || t.readOnly || t.disabled || t.checked == null || y("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function By(e) {
      var t = e.type, a = e.nodeName;
      return a && a.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
    }
    function Kd(e) {
      return e._valueTracker;
    }
    function Cw(e) {
      e._valueTracker = null;
    }
    function j0(e) {
      var t = "";
      return e && (By(e) ? t = e.checked ? "true" : "false" : t = e.value), t;
    }
    function Xd(e) {
      var t = By(e) ? "checked" : "value", a = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
      qr(e[t]);
      var l = "" + e[t];
      if (!(e.hasOwnProperty(t) || typeof a > "u" || typeof a.get != "function" || typeof a.set != "function")) {
        var c = a.get, m = a.set;
        Object.defineProperty(e, t, {
          configurable: !0,
          get: function() {
            return c.call(this);
          },
          set: function(E) {
            qr(E), l = "" + E, m.call(this, E);
          }
        }), Object.defineProperty(e, t, {
          enumerable: a.enumerable
        });
        var T = {
          getValue: function() {
            return l;
          },
          setValue: function(E) {
            qr(E), l = "" + E;
          },
          stopTracking: function() {
            Cw(e), delete e[t];
          }
        };
        return T;
      }
    }
    function Ml(e) {
      Kd(e) || (e._valueTracker = Xd(e));
    }
    function Fo(e) {
      if (!e)
        return !1;
      var t = Kd(e);
      if (!t)
        return !0;
      var a = t.getValue(), l = j0(e);
      return l !== a ? (t.setValue(l), !0) : !1;
    }
    function Vo(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
        return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    var bw = !1, kw = !1, fp = !1, Zd = !1;
    function hp(e) {
      var t = e.type === "checkbox" || e.type === "radio";
      return t ? e.checked != null : e.value != null;
    }
    function pp(e, t) {
      var a = e, l = t.checked, c = gt({}, t, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: l ?? a._wrapperState.initialChecked
      });
      return c;
    }
    function qs(e, t) {
      jy("input", t), t.checked !== void 0 && t.defaultChecked !== void 0 && !kw && (y("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", da() || "A component", t.type), kw = !0), t.value !== void 0 && t.defaultValue !== void 0 && !bw && (y("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", da() || "A component", t.type), bw = !0);
      var a = e, l = t.defaultValue == null ? "" : t.defaultValue;
      a._wrapperState = {
        initialChecked: t.checked != null ? t.checked : t.defaultChecked,
        initialValue: Is(t.value != null ? t.value : l),
        controlled: hp(t)
      };
    }
    function mp(e, t) {
      var a = e, l = t.checked;
      l != null && Ao(a, "checked", l, !1);
    }
    function cc(e, t) {
      var a = e;
      {
        var l = hp(t);
        !a._wrapperState.controlled && l && !Zd && (y("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Zd = !0), a._wrapperState.controlled && !l && !fp && (y("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), fp = !0);
      }
      mp(e, t);
      var c = Is(t.value), m = t.type;
      if (c != null)
        m === "number" ? (c === 0 && a.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        a.value != c) && (a.value = fa(c)) : a.value !== fa(c) && (a.value = fa(c));
      else if (m === "submit" || m === "reset") {
        a.removeAttribute("value");
        return;
      }
      t.hasOwnProperty("value") ? gp(a, t.type, c) : t.hasOwnProperty("defaultValue") && gp(a, t.type, Is(t.defaultValue)), t.checked == null && t.defaultChecked != null && (a.defaultChecked = !!t.defaultChecked);
    }
    function Qy(e, t, a) {
      var l = e;
      if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
        var c = t.type, m = c === "submit" || c === "reset";
        if (m && (t.value === void 0 || t.value === null))
          return;
        var T = fa(l._wrapperState.initialValue);
        a || T !== l.value && (l.value = T), l.defaultValue = T;
      }
      var E = l.name;
      E !== "" && (l.name = ""), l.defaultChecked = !l.defaultChecked, l.defaultChecked = !!l._wrapperState.initialChecked, E !== "" && (l.name = E);
    }
    function vp(e, t) {
      var a = e;
      cc(a, t), yp(a, t);
    }
    function yp(e, t) {
      var a = t.name;
      if (t.type === "radio" && a != null) {
        for (var l = e; l.parentNode; )
          l = l.parentNode;
        Ir(a, "name");
        for (var c = l.querySelectorAll("input[name=" + JSON.stringify("" + a) + '][type="radio"]'), m = 0; m < c.length; m++) {
          var T = c[m];
          if (!(T === e || T.form !== e.form)) {
            var E = tC(T);
            if (!E)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Fo(T), cc(T, E);
          }
        }
      }
    }
    function gp(e, t, a) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (t !== "number" || Vo(e.ownerDocument) !== e) && (a == null ? e.defaultValue = fa(e._wrapperState.initialValue) : e.defaultValue !== fa(a) && (e.defaultValue = fa(a)));
    }
    var Cr = !1, Ho = !1, Sp = !1;
    function dc(e, t) {
      t.value == null && (typeof t.children == "object" && t.children !== null ? f.Children.forEach(t.children, function(a) {
        a != null && (typeof a == "string" || typeof a == "number" || Ho || (Ho = !0, y("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : t.dangerouslySetInnerHTML != null && (Sp || (Sp = !0, y("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), t.selected != null && !Cr && (y("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Cr = !0);
    }
    function B0(e, t) {
      t.value != null && e.setAttribute("value", fa(Is(t.value)));
    }
    var Yy = Array.isArray;
    function Di(e) {
      return Yy(e);
    }
    var Io;
    Io = !1;
    function Jd() {
      var e = da();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    var Gy = ["value", "defaultValue"];
    function Q0(e) {
      {
        jy("select", e);
        for (var t = 0; t < Gy.length; t++) {
          var a = Gy[t];
          if (e[a] != null) {
            var l = Di(e[a]);
            e.multiple && !l ? y("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", a, Jd()) : !e.multiple && l && y("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", a, Jd());
          }
        }
      }
    }
    function fc(e, t, a, l) {
      var c = e.options;
      if (t) {
        for (var m = a, T = {}, E = 0; E < m.length; E++)
          T["$" + m[E]] = !0;
        for (var C = 0; C < c.length; C++) {
          var x = T.hasOwnProperty("$" + c[C].value);
          c[C].selected !== x && (c[C].selected = x), x && l && (c[C].defaultSelected = !0);
        }
      } else {
        for (var M = fa(Is(a)), z = null, N = 0; N < c.length; N++) {
          if (c[N].value === M) {
            c[N].selected = !0, l && (c[N].defaultSelected = !0);
            return;
          }
          z === null && !c[N].disabled && (z = c[N]);
        }
        z !== null && (z.selected = !0);
      }
    }
    function Wy(e, t) {
      return gt({}, t, {
        value: void 0
      });
    }
    function Tp(e, t) {
      var a = e;
      Q0(t), a._wrapperState = {
        wasMultiple: !!t.multiple
      }, t.value !== void 0 && t.defaultValue !== void 0 && !Io && (y("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Io = !0);
    }
    function Y0(e, t) {
      var a = e;
      a.multiple = !!t.multiple;
      var l = t.value;
      l != null ? fc(a, !!t.multiple, l, !1) : t.defaultValue != null && fc(a, !!t.multiple, t.defaultValue, !0);
    }
    function G0(e, t) {
      var a = e, l = a._wrapperState.wasMultiple;
      a._wrapperState.wasMultiple = !!t.multiple;
      var c = t.value;
      c != null ? fc(a, !!t.multiple, c, !1) : l !== !!t.multiple && (t.defaultValue != null ? fc(a, !!t.multiple, t.defaultValue, !0) : fc(a, !!t.multiple, t.multiple ? [] : "", !1));
    }
    function W0(e, t) {
      var a = e, l = t.value;
      l != null && fc(a, !!t.multiple, l, !1);
    }
    var xw = !1;
    function Ky(e, t) {
      var a = e;
      if (t.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var l = gt({}, t, {
        value: void 0,
        defaultValue: void 0,
        children: fa(a._wrapperState.initialValue)
      });
      return l;
    }
    function Xy(e, t) {
      var a = e;
      jy("textarea", t), t.value !== void 0 && t.defaultValue !== void 0 && !xw && (y("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", da() || "A component"), xw = !0);
      var l = t.value;
      if (l == null) {
        var c = t.children, m = t.defaultValue;
        if (c != null) {
          y("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (m != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Di(c)) {
              if (c.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              c = c[0];
            }
            m = c;
          }
        }
        m == null && (m = ""), l = m;
      }
      a._wrapperState = {
        initialValue: Is(l)
      };
    }
    function Rw(e, t) {
      var a = e, l = Is(t.value), c = Is(t.defaultValue);
      if (l != null) {
        var m = fa(l);
        m !== a.value && (a.value = m), t.defaultValue == null && a.defaultValue !== m && (a.defaultValue = m);
      }
      c != null && (a.defaultValue = fa(c));
    }
    function Dw(e, t) {
      var a = e, l = a.textContent;
      l === a._wrapperState.initialValue && l !== "" && l !== null && (a.value = l);
    }
    function K0(e, t) {
      Rw(e, t);
    }
    var js = "http://www.w3.org/1999/xhtml", Zy = "http://www.w3.org/1998/Math/MathML", Jy = "http://www.w3.org/2000/svg";
    function eg(e) {
      switch (e) {
        case "svg":
          return Jy;
        case "math":
          return Zy;
        default:
          return js;
      }
    }
    function tg(e, t) {
      return e == null || e === js ? eg(t) : e === Jy && t === "foreignObject" ? js : e;
    }
    var Mw = function(e) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, a, l, c) {
        MSApp.execUnsafeLocalFunction(function() {
          return e(t, a, l, c);
        });
      } : e;
    }, wp, Lw = Mw(function(e, t) {
      if (e.namespaceURI === Jy && !("innerHTML" in e)) {
        wp = wp || document.createElement("div"), wp.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>";
        for (var a = wp.firstChild; e.firstChild; )
          e.removeChild(e.firstChild);
        for (; a.firstChild; )
          e.appendChild(a.firstChild);
        return;
      }
      e.innerHTML = t;
    }), br = 1, Bs = 3, Yn = 8, Qs = 9, ng = 11, hc = function(e, t) {
      if (t) {
        var a = e.firstChild;
        if (a && a === e.lastChild && a.nodeType === Bs) {
          a.nodeValue = t;
          return;
        }
      }
      e.textContent = t;
    }, ef = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, tf = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function $w(e, t) {
      return e + t.charAt(0).toUpperCase() + t.substring(1);
    }
    var Ow = ["Webkit", "ms", "Moz", "O"];
    Object.keys(tf).forEach(function(e) {
      Ow.forEach(function(t) {
        tf[$w(t, e)] = tf[e];
      });
    });
    function Ep(e, t, a) {
      var l = t == null || typeof t == "boolean" || t === "";
      return l ? "" : !a && typeof t == "number" && t !== 0 && !(tf.hasOwnProperty(e) && tf[e]) ? t + "px" : (qd(t, e), ("" + t).trim());
    }
    var Aw = /([A-Z])/g, Pw = /^ms-/;
    function pc(e) {
      return e.replace(Aw, "-$1").toLowerCase().replace(Pw, "-ms-");
    }
    var _w = function() {
    };
    {
      var X0 = /^(?:webkit|moz|o)[A-Z]/, Z0 = /^-ms-/, Nw = /-(.)/g, ig = /;\s*$/, fs = {}, qo = {}, Uw = !1, nf = !1, J0 = function(e) {
        return e.replace(Nw, function(t, a) {
          return a.toUpperCase();
        });
      }, zw = function(e) {
        fs.hasOwnProperty(e) && fs[e] || (fs[e] = !0, y(
          "Unsupported style property %s. Did you mean %s?",
          e,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          J0(e.replace(Z0, "ms-"))
        ));
      }, rg = function(e) {
        fs.hasOwnProperty(e) && fs[e] || (fs[e] = !0, y("Unsupported vendor-prefixed style property %s. Did you mean %s?", e, e.charAt(0).toUpperCase() + e.slice(1)));
      }, ag = function(e, t) {
        qo.hasOwnProperty(t) && qo[t] || (qo[t] = !0, y(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, e, t.replace(ig, "")));
      }, Fw = function(e, t) {
        Uw || (Uw = !0, y("`NaN` is an invalid value for the `%s` css style property.", e));
      }, Vw = function(e, t) {
        nf || (nf = !0, y("`Infinity` is an invalid value for the `%s` css style property.", e));
      };
      _w = function(e, t) {
        e.indexOf("-") > -1 ? zw(e) : X0.test(e) ? rg(e) : ig.test(t) && ag(e, t), typeof t == "number" && (isNaN(t) ? Fw(e, t) : isFinite(t) || Vw(e, t));
      };
    }
    var Hw = _w;
    function ek(e) {
      {
        var t = "", a = "";
        for (var l in e)
          if (e.hasOwnProperty(l)) {
            var c = e[l];
            if (c != null) {
              var m = l.indexOf("--") === 0;
              t += a + (m ? l : pc(l)) + ":", t += Ep(l, c, m), a = ";";
            }
          }
        return t || null;
      }
    }
    function Iw(e, t) {
      var a = e.style;
      for (var l in t)
        if (t.hasOwnProperty(l)) {
          var c = l.indexOf("--") === 0;
          c || Hw(l, t[l]);
          var m = Ep(l, t[l], c);
          l === "float" && (l = "cssFloat"), c ? a.setProperty(l, m) : a[l] = m;
        }
    }
    function tk(e) {
      return e == null || typeof e == "boolean" || e === "";
    }
    function qw(e) {
      var t = {};
      for (var a in e)
        for (var l = ef[a] || [a], c = 0; c < l.length; c++)
          t[l[c]] = a;
      return t;
    }
    function nk(e, t) {
      {
        if (!t)
          return;
        var a = qw(e), l = qw(t), c = {};
        for (var m in a) {
          var T = a[m], E = l[m];
          if (E && T !== E) {
            var C = T + "," + E;
            if (c[C])
              continue;
            c[C] = !0, y("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", tk(e[T]) ? "Removing" : "Updating", T, E);
          }
        }
      }
    }
    var qa = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, rf = gt({
      menuitem: !0
    }, qa), jw = "__html";
    function Cp(e, t) {
      if (t) {
        if (rf[e] && (t.children != null || t.dangerouslySetInnerHTML != null))
          throw new Error(e + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (t.dangerouslySetInnerHTML != null) {
          if (t.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof t.dangerouslySetInnerHTML != "object" || !(jw in t.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!t.suppressContentEditableWarning && t.contentEditable && t.children != null && y("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), t.style != null && typeof t.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Ll(e, t) {
      if (e.indexOf("-") === -1)
        return typeof t.is == "string";
      switch (e) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var af = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, bp = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, mc = {}, ik = new RegExp("^(aria)-[" + pe + "]*$"), vc = new RegExp("^(aria)[A-Z][" + pe + "]*$");
    function sg(e, t) {
      {
        if (er.call(mc, t) && mc[t])
          return !0;
        if (vc.test(t)) {
          var a = "aria-" + t.slice(4).toLowerCase(), l = bp.hasOwnProperty(a) ? a : null;
          if (l == null)
            return y("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", t), mc[t] = !0, !0;
          if (t !== l)
            return y("Invalid ARIA attribute `%s`. Did you mean `%s`?", t, l), mc[t] = !0, !0;
        }
        if (ik.test(t)) {
          var c = t.toLowerCase(), m = bp.hasOwnProperty(c) ? c : null;
          if (m == null)
            return mc[t] = !0, !1;
          if (t !== m)
            return y("Unknown ARIA attribute `%s`. Did you mean `%s`?", t, m), mc[t] = !0, !0;
        }
      }
      return !0;
    }
    function sf(e, t) {
      {
        var a = [];
        for (var l in t) {
          var c = sg(e, l);
          c || a.push(l);
        }
        var m = a.map(function(T) {
          return "`" + T + "`";
        }).join(", ");
        a.length === 1 ? y("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", m, e) : a.length > 1 && y("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", m, e);
      }
    }
    function lg(e, t) {
      Ll(e, t) || sf(e, t);
    }
    var og = !1;
    function kp(e, t) {
      {
        if (e !== "input" && e !== "textarea" && e !== "select")
          return;
        t != null && t.value === null && !og && (og = !0, e === "select" && t.multiple ? y("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : y("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
      }
    }
    var jo = function() {
    };
    {
      var Mi = {}, ug = /^on./, xp = /^on[^A-Z]/, Bw = new RegExp("^(aria)-[" + pe + "]*$"), Qw = new RegExp("^(aria)[A-Z][" + pe + "]*$");
      jo = function(e, t, a, l) {
        if (er.call(Mi, t) && Mi[t])
          return !0;
        var c = t.toLowerCase();
        if (c === "onfocusin" || c === "onfocusout")
          return y("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Mi[t] = !0, !0;
        if (l != null) {
          var m = l.registrationNameDependencies, T = l.possibleRegistrationNames;
          if (m.hasOwnProperty(t))
            return !0;
          var E = T.hasOwnProperty(c) ? T[c] : null;
          if (E != null)
            return y("Invalid event handler property `%s`. Did you mean `%s`?", t, E), Mi[t] = !0, !0;
          if (ug.test(t))
            return y("Unknown event handler property `%s`. It will be ignored.", t), Mi[t] = !0, !0;
        } else if (ug.test(t))
          return xp.test(t) && y("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", t), Mi[t] = !0, !0;
        if (Bw.test(t) || Qw.test(t))
          return !0;
        if (c === "innerhtml")
          return y("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Mi[t] = !0, !0;
        if (c === "aria")
          return y("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Mi[t] = !0, !0;
        if (c === "is" && a !== null && a !== void 0 && typeof a != "string")
          return y("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof a), Mi[t] = !0, !0;
        if (typeof a == "number" && isNaN(a))
          return y("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", t), Mi[t] = !0, !0;
        var C = Qn(t), x = C !== null && C.type === ua;
        if (af.hasOwnProperty(c)) {
          var M = af[c];
          if (M !== t)
            return y("Invalid DOM property `%s`. Did you mean `%s`?", t, M), Mi[t] = !0, !0;
        } else if (!x && t !== c)
          return y("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", t, c), Mi[t] = !0, !0;
        return typeof a == "boolean" && Bn(t, a, C, !1) ? (a ? y('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', a, t, t, a, t) : y('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', a, t, t, a, t, t, t), Mi[t] = !0, !0) : x ? !0 : Bn(t, a, C, !1) ? (Mi[t] = !0, !1) : ((a === "false" || a === "true") && C !== null && C.type === jr && (y("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", a, t, a === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', t, a), Mi[t] = !0), !0);
      };
    }
    var Yw = function(e, t, a) {
      {
        var l = [];
        for (var c in t) {
          var m = jo(e, c, t[c], a);
          m || l.push(c);
        }
        var T = l.map(function(E) {
          return "`" + E + "`";
        }).join(", ");
        l.length === 1 ? y("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", T, e) : l.length > 1 && y("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", T, e);
      }
    };
    function Gw(e, t, a) {
      Ll(e, t) || Yw(e, t, a);
    }
    var cg = 1, Rp = 2, ha = 4, dg = cg | Rp | ha, Bo = null;
    function rk(e) {
      Bo !== null && y("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Bo = e;
    }
    function ak() {
      Bo === null && y("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Bo = null;
    }
    function lf(e) {
      return e === Bo;
    }
    function fg(e) {
      var t = e.target || e.srcElement || window;
      return t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === Bs ? t.parentNode : t;
    }
    var Dp = null, Qo = null, Yt = null;
    function Mp(e) {
      var t = Uc(e);
      if (t) {
        if (typeof Dp != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var a = t.stateNode;
        if (a) {
          var l = tC(a);
          Dp(t.stateNode, t.type, l);
        }
      }
    }
    function Lp(e) {
      Dp = e;
    }
    function yc(e) {
      Qo ? Yt ? Yt.push(e) : Yt = [e] : Qo = e;
    }
    function Ww() {
      return Qo !== null || Yt !== null;
    }
    function $p() {
      if (Qo) {
        var e = Qo, t = Yt;
        if (Qo = null, Yt = null, Mp(e), t)
          for (var a = 0; a < t.length; a++)
            Mp(t[a]);
      }
    }
    var gc = function(e, t) {
      return e(t);
    }, of = function() {
    }, $l = !1;
    function Kw() {
      var e = Ww();
      e && (of(), $p());
    }
    function Xw(e, t, a) {
      if ($l)
        return e(t, a);
      $l = !0;
      try {
        return gc(e, t, a);
      } finally {
        $l = !1, Kw();
      }
    }
    function sk(e, t, a) {
      gc = e, of = a;
    }
    function Zw(e) {
      return e === "button" || e === "input" || e === "select" || e === "textarea";
    }
    function Op(e, t, a) {
      switch (e) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(a.disabled && Zw(t));
        default:
          return !1;
      }
    }
    function Ol(e, t) {
      var a = e.stateNode;
      if (a === null)
        return null;
      var l = tC(a);
      if (l === null)
        return null;
      var c = l[t];
      if (Op(t, e.type, l))
        return null;
      if (c && typeof c != "function")
        throw new Error("Expected `" + t + "` listener to be a function, instead got a value of `" + typeof c + "` type.");
      return c;
    }
    var uf = !1;
    if (_n)
      try {
        var Yo = {};
        Object.defineProperty(Yo, "passive", {
          get: function() {
            uf = !0;
          }
        }), window.addEventListener("test", Yo, Yo), window.removeEventListener("test", Yo, Yo);
      } catch {
        uf = !1;
      }
    function Ap(e, t, a, l, c, m, T, E, C) {
      var x = Array.prototype.slice.call(arguments, 3);
      try {
        t.apply(a, x);
      } catch (M) {
        this.onError(M);
      }
    }
    var Pp = Ap;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var hg = document.createElement("react");
      Pp = function(t, a, l, c, m, T, E, C, x) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var M = document.createEvent("Event"), z = !1, N = !0, q = window.event, Q = Object.getOwnPropertyDescriptor(window, "event");
        function Y() {
          hg.removeEventListener(G, Ue, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = q);
        }
        var ve = Array.prototype.slice.call(arguments, 3);
        function Ue() {
          z = !0, Y(), a.apply(l, ve), N = !1;
        }
        var Me, kt = !1, pt = !1;
        function V(H) {
          if (Me = H.error, kt = !0, Me === null && H.colno === 0 && H.lineno === 0 && (pt = !0), H.defaultPrevented && Me != null && typeof Me == "object")
            try {
              Me._suppressLogging = !0;
            } catch {
            }
        }
        var G = "react-" + (t || "invokeguardedcallback");
        if (window.addEventListener("error", V), hg.addEventListener(G, Ue, !1), M.initEvent(G, !1, !1), hg.dispatchEvent(M), Q && Object.defineProperty(window, "event", Q), z && N && (kt ? pt && (Me = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Me = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Me)), window.removeEventListener("error", V), !z)
          return Y(), Ap.apply(this, arguments);
      };
    }
    var Jw = Pp, Sc = !1, _p = null, Tc = !1, hs = null, eE = {
      onError: function(e) {
        Sc = !0, _p = e;
      }
    };
    function Al(e, t, a, l, c, m, T, E, C) {
      Sc = !1, _p = null, Jw.apply(eE, arguments);
    }
    function ps(e, t, a, l, c, m, T, E, C) {
      if (Al.apply(this, arguments), Sc) {
        var x = df();
        Tc || (Tc = !0, hs = x);
      }
    }
    function cf() {
      if (Tc) {
        var e = hs;
        throw Tc = !1, hs = null, e;
      }
    }
    function Ys() {
      return Sc;
    }
    function df() {
      if (Sc) {
        var e = _p;
        return Sc = !1, _p = null, e;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function wc(e) {
      return e._reactInternals;
    }
    function lk(e) {
      return e._reactInternals !== void 0;
    }
    function Go(e, t) {
      e._reactInternals = t;
    }
    var Pe = (
      /*                      */
      0
    ), ja = (
      /*                */
      1
    ), Nn = (
      /*                    */
      2
    ), Et = (
      /*                       */
      4
    ), pa = (
      /*                */
      16
    ), Ba = (
      /*                 */
      32
    ), un = (
      /*                     */
      64
    ), Oe = (
      /*                   */
      128
    ), kr = (
      /*            */
      256
    ), An = (
      /*                          */
      512
    ), oi = (
      /*                     */
      1024
    ), xr = (
      /*                      */
      2048
    ), ma = (
      /*                    */
      4096
    ), Gn = (
      /*                   */
      8192
    ), Ec = (
      /*             */
      16384
    ), tE = (
      /*               */
      32767
    ), ff = (
      /*                   */
      32768
    ), Rr = (
      /*                */
      65536
    ), Np = (
      /* */
      131072
    ), ms = (
      /*                       */
      1048576
    ), Cc = (
      /*                    */
      2097152
    ), Gs = (
      /*                 */
      4194304
    ), Up = (
      /*                */
      8388608
    ), Pl = (
      /*               */
      16777216
    ), vs = (
      /*              */
      33554432
    ), _l = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      Et | oi | 0
    ), Nl = Nn | Et | pa | Ba | An | ma | Gn, Ul = Et | un | An | Gn, Ws = xr | pa, Wn = Gs | Up | Cc, va = n.ReactCurrentOwner;
    function Br(e) {
      var t = e, a = e;
      if (e.alternate)
        for (; t.return; )
          t = t.return;
      else {
        var l = t;
        do
          t = l, (t.flags & (Nn | ma)) !== Pe && (a = t.return), l = t.return;
        while (l);
      }
      return t.tag === A ? a : null;
    }
    function ys(e) {
      if (e.tag === Ye) {
        var t = e.memoizedState;
        if (t === null) {
          var a = e.alternate;
          a !== null && (t = a.memoizedState);
        }
        if (t !== null)
          return t.dehydrated;
      }
      return null;
    }
    function gs(e) {
      return e.tag === A ? e.stateNode.containerInfo : null;
    }
    function Wo(e) {
      return Br(e) === e;
    }
    function nE(e) {
      {
        var t = va.current;
        if (t !== null && t.tag === $) {
          var a = t, l = a.stateNode;
          l._warnedAboutRefsInRender || y("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", nt(a) || "A component"), l._warnedAboutRefsInRender = !0;
        }
      }
      var c = wc(e);
      return c ? Br(c) === c : !1;
    }
    function zp(e) {
      if (Br(e) !== e)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Fp(e) {
      var t = e.alternate;
      if (!t) {
        var a = Br(e);
        if (a === null)
          throw new Error("Unable to find node on an unmounted component.");
        return a !== e ? null : e;
      }
      for (var l = e, c = t; ; ) {
        var m = l.return;
        if (m === null)
          break;
        var T = m.alternate;
        if (T === null) {
          var E = m.return;
          if (E !== null) {
            l = c = E;
            continue;
          }
          break;
        }
        if (m.child === T.child) {
          for (var C = m.child; C; ) {
            if (C === l)
              return zp(m), e;
            if (C === c)
              return zp(m), t;
            C = C.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (l.return !== c.return)
          l = m, c = T;
        else {
          for (var x = !1, M = m.child; M; ) {
            if (M === l) {
              x = !0, l = m, c = T;
              break;
            }
            if (M === c) {
              x = !0, c = m, l = T;
              break;
            }
            M = M.sibling;
          }
          if (!x) {
            for (M = T.child; M; ) {
              if (M === l) {
                x = !0, l = T, c = m;
                break;
              }
              if (M === c) {
                x = !0, c = T, l = m;
                break;
              }
              M = M.sibling;
            }
            if (!x)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (l.alternate !== c)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (l.tag !== A)
        throw new Error("Unable to find node on an unmounted component.");
      return l.stateNode.current === l ? e : t;
    }
    function Dr(e) {
      var t = Fp(e);
      return t !== null ? Mr(t) : null;
    }
    function Mr(e) {
      if (e.tag === W || e.tag === ne)
        return e;
      for (var t = e.child; t !== null; ) {
        var a = Mr(t);
        if (a !== null)
          return a;
        t = t.sibling;
      }
      return null;
    }
    function Tn(e) {
      var t = Fp(e);
      return t !== null ? ya(t) : null;
    }
    function ya(e) {
      if (e.tag === W || e.tag === ne)
        return e;
      for (var t = e.child; t !== null; ) {
        if (t.tag !== B) {
          var a = ya(t);
          if (a !== null)
            return a;
        }
        t = t.sibling;
      }
      return null;
    }
    var pg = s.unstable_scheduleCallback, iE = s.unstable_cancelCallback, mg = s.unstable_shouldYield, vg = s.unstable_requestPaint, ui = s.unstable_now, Vp = s.unstable_getCurrentPriorityLevel, hf = s.unstable_ImmediatePriority, zl = s.unstable_UserBlockingPriority, Ks = s.unstable_NormalPriority, ok = s.unstable_LowPriority, Ko = s.unstable_IdlePriority, Hp = s.unstable_yieldValue, rE = s.unstable_setDisableYieldValue, Xo = null, Un = null, me = null, Qr = !1, Lr = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function bc(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (t.isDisabled)
        return !0;
      if (!t.supportsFiber)
        return y("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        Ii && (e = gt({}, e, {
          getLaneLabelMap: Zo,
          injectProfilingHooks: ga
        })), Xo = t.inject(e), Un = t;
      } catch (a) {
        y("React instrumentation encountered an error: %s.", a);
      }
      return !!t.checkDCE;
    }
    function yg(e, t) {
      if (Un && typeof Un.onScheduleFiberRoot == "function")
        try {
          Un.onScheduleFiberRoot(Xo, e, t);
        } catch (a) {
          Qr || (Qr = !0, y("React instrumentation encountered an error: %s", a));
        }
    }
    function gg(e, t) {
      if (Un && typeof Un.onCommitFiberRoot == "function")
        try {
          var a = (e.current.flags & Oe) === Oe;
          if (jn) {
            var l;
            switch (t) {
              case ir:
                l = hf;
                break;
              case Ts:
                l = zl;
                break;
              case Sa:
                l = Ks;
                break;
              case Ta:
                l = Ko;
                break;
              default:
                l = Ks;
                break;
            }
            Un.onCommitFiberRoot(Xo, e, l, a);
          }
        } catch (c) {
          Qr || (Qr = !0, y("React instrumentation encountered an error: %s", c));
        }
    }
    function Sg(e) {
      if (Un && typeof Un.onPostCommitFiberRoot == "function")
        try {
          Un.onPostCommitFiberRoot(Xo, e);
        } catch (t) {
          Qr || (Qr = !0, y("React instrumentation encountered an error: %s", t));
        }
    }
    function Tg(e) {
      if (Un && typeof Un.onCommitFiberUnmount == "function")
        try {
          Un.onCommitFiberUnmount(Xo, e);
        } catch (t) {
          Qr || (Qr = !0, y("React instrumentation encountered an error: %s", t));
        }
    }
    function Cn(e) {
      if (typeof Hp == "function" && (rE(e), h(e)), Un && typeof Un.setStrictMode == "function")
        try {
          Un.setStrictMode(Xo, e);
        } catch (t) {
          Qr || (Qr = !0, y("React instrumentation encountered an error: %s", t));
        }
    }
    function ga(e) {
      me = e;
    }
    function Zo() {
      {
        for (var e = /* @__PURE__ */ new Map(), t = 1, a = 0; a < tu; a++) {
          var l = oE(t);
          e.set(t, l), t *= 2;
        }
        return e;
      }
    }
    function wg(e) {
      me !== null && typeof me.markCommitStarted == "function" && me.markCommitStarted(e);
    }
    function Eg() {
      me !== null && typeof me.markCommitStopped == "function" && me.markCommitStopped();
    }
    function Yr(e) {
      me !== null && typeof me.markComponentRenderStarted == "function" && me.markComponentRenderStarted(e);
    }
    function Gr() {
      me !== null && typeof me.markComponentRenderStopped == "function" && me.markComponentRenderStopped();
    }
    function Cg(e) {
      me !== null && typeof me.markComponentPassiveEffectMountStarted == "function" && me.markComponentPassiveEffectMountStarted(e);
    }
    function aE() {
      me !== null && typeof me.markComponentPassiveEffectMountStopped == "function" && me.markComponentPassiveEffectMountStopped();
    }
    function Xs(e) {
      me !== null && typeof me.markComponentPassiveEffectUnmountStarted == "function" && me.markComponentPassiveEffectUnmountStarted(e);
    }
    function Fl() {
      me !== null && typeof me.markComponentPassiveEffectUnmountStopped == "function" && me.markComponentPassiveEffectUnmountStopped();
    }
    function Ip(e) {
      me !== null && typeof me.markComponentLayoutEffectMountStarted == "function" && me.markComponentLayoutEffectMountStarted(e);
    }
    function sE() {
      me !== null && typeof me.markComponentLayoutEffectMountStopped == "function" && me.markComponentLayoutEffectMountStopped();
    }
    function pf(e) {
      me !== null && typeof me.markComponentLayoutEffectUnmountStarted == "function" && me.markComponentLayoutEffectUnmountStarted(e);
    }
    function bg() {
      me !== null && typeof me.markComponentLayoutEffectUnmountStopped == "function" && me.markComponentLayoutEffectUnmountStopped();
    }
    function mf(e, t, a) {
      me !== null && typeof me.markComponentErrored == "function" && me.markComponentErrored(e, t, a);
    }
    function Ss(e, t, a) {
      me !== null && typeof me.markComponentSuspended == "function" && me.markComponentSuspended(e, t, a);
    }
    function vf(e) {
      me !== null && typeof me.markLayoutEffectsStarted == "function" && me.markLayoutEffectsStarted(e);
    }
    function yf() {
      me !== null && typeof me.markLayoutEffectsStopped == "function" && me.markLayoutEffectsStopped();
    }
    function Jo(e) {
      me !== null && typeof me.markPassiveEffectsStarted == "function" && me.markPassiveEffectsStarted(e);
    }
    function kg() {
      me !== null && typeof me.markPassiveEffectsStopped == "function" && me.markPassiveEffectsStopped();
    }
    function eu(e) {
      me !== null && typeof me.markRenderStarted == "function" && me.markRenderStarted(e);
    }
    function lE() {
      me !== null && typeof me.markRenderYielded == "function" && me.markRenderYielded();
    }
    function qp() {
      me !== null && typeof me.markRenderStopped == "function" && me.markRenderStopped();
    }
    function bn(e) {
      me !== null && typeof me.markRenderScheduled == "function" && me.markRenderScheduled(e);
    }
    function jp(e, t) {
      me !== null && typeof me.markForceUpdateScheduled == "function" && me.markForceUpdateScheduled(e, t);
    }
    function gf(e, t) {
      me !== null && typeof me.markStateUpdateScheduled == "function" && me.markStateUpdateScheduled(e, t);
    }
    var _e = (
      /*                         */
      0
    ), dt = (
      /*                 */
      1
    ), Ut = (
      /*                    */
      2
    ), Jt = (
      /*               */
      8
    ), zt = (
      /*              */
      16
    ), Kn = Math.clz32 ? Math.clz32 : Sf, gi = Math.log, Bp = Math.LN2;
    function Sf(e) {
      var t = e >>> 0;
      return t === 0 ? 32 : 31 - (gi(t) / Bp | 0) | 0;
    }
    var tu = 31, ee = (
      /*                        */
      0
    ), Ot = (
      /*                          */
      0
    ), je = (
      /*                        */
      1
    ), Vl = (
      /*    */
      2
    ), Qa = (
      /*             */
      4
    ), ji = (
      /*            */
      8
    ), zn = (
      /*                     */
      16
    ), Zs = (
      /*                */
      32
    ), Hl = (
      /*                       */
      4194240
    ), nu = (
      /*                        */
      64
    ), Qp = (
      /*                        */
      128
    ), Yp = (
      /*                        */
      256
    ), Gp = (
      /*                        */
      512
    ), Wp = (
      /*                        */
      1024
    ), Kp = (
      /*                        */
      2048
    ), Xp = (
      /*                        */
      4096
    ), Zp = (
      /*                        */
      8192
    ), Jp = (
      /*                        */
      16384
    ), iu = (
      /*                       */
      32768
    ), em = (
      /*                       */
      65536
    ), kc = (
      /*                       */
      131072
    ), xc = (
      /*                       */
      262144
    ), tm = (
      /*                       */
      524288
    ), Tf = (
      /*                       */
      1048576
    ), nm = (
      /*                       */
      2097152
    ), wf = (
      /*                            */
      130023424
    ), ru = (
      /*                             */
      4194304
    ), im = (
      /*                             */
      8388608
    ), Ef = (
      /*                             */
      16777216
    ), rm = (
      /*                             */
      33554432
    ), am = (
      /*                             */
      67108864
    ), xg = ru, Cf = (
      /*          */
      134217728
    ), Rg = (
      /*                          */
      268435455
    ), bf = (
      /*               */
      268435456
    ), au = (
      /*                        */
      536870912
    ), Wr = (
      /*                   */
      1073741824
    );
    function oE(e) {
      {
        if (e & je)
          return "Sync";
        if (e & Vl)
          return "InputContinuousHydration";
        if (e & Qa)
          return "InputContinuous";
        if (e & ji)
          return "DefaultHydration";
        if (e & zn)
          return "Default";
        if (e & Zs)
          return "TransitionHydration";
        if (e & Hl)
          return "Transition";
        if (e & wf)
          return "Retry";
        if (e & Cf)
          return "SelectiveHydration";
        if (e & bf)
          return "IdleHydration";
        if (e & au)
          return "Idle";
        if (e & Wr)
          return "Offscreen";
      }
    }
    var ln = -1, su = nu, sm = ru;
    function kf(e) {
      switch (Il(e)) {
        case je:
          return je;
        case Vl:
          return Vl;
        case Qa:
          return Qa;
        case ji:
          return ji;
        case zn:
          return zn;
        case Zs:
          return Zs;
        case nu:
        case Qp:
        case Yp:
        case Gp:
        case Wp:
        case Kp:
        case Xp:
        case Zp:
        case Jp:
        case iu:
        case em:
        case kc:
        case xc:
        case tm:
        case Tf:
        case nm:
          return e & Hl;
        case ru:
        case im:
        case Ef:
        case rm:
        case am:
          return e & wf;
        case Cf:
          return Cf;
        case bf:
          return bf;
        case au:
          return au;
        case Wr:
          return Wr;
        default:
          return y("Should have found matching lanes. This is a bug in React."), e;
      }
    }
    function lm(e, t) {
      var a = e.pendingLanes;
      if (a === ee)
        return ee;
      var l = ee, c = e.suspendedLanes, m = e.pingedLanes, T = a & Rg;
      if (T !== ee) {
        var E = T & ~c;
        if (E !== ee)
          l = kf(E);
        else {
          var C = T & m;
          C !== ee && (l = kf(C));
        }
      } else {
        var x = a & ~c;
        x !== ee ? l = kf(x) : m !== ee && (l = kf(m));
      }
      if (l === ee)
        return ee;
      if (t !== ee && t !== l && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (t & c) === ee) {
        var M = Il(l), z = Il(t);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          M >= z || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          M === zn && (z & Hl) !== ee
        )
          return t;
      }
      (l & Qa) !== ee && (l |= a & zn);
      var N = e.entangledLanes;
      if (N !== ee)
        for (var q = e.entanglements, Q = l & N; Q > 0; ) {
          var Y = Xn(Q), ve = 1 << Y;
          l |= q[Y], Q &= ~ve;
        }
      return l;
    }
    function Ya(e, t) {
      for (var a = e.eventTimes, l = ln; t > 0; ) {
        var c = Xn(t), m = 1 << c, T = a[c];
        T > l && (l = T), t &= ~m;
      }
      return l;
    }
    function Dg(e, t) {
      switch (e) {
        case je:
        case Vl:
        case Qa:
          return t + 250;
        case ji:
        case zn:
        case Zs:
        case nu:
        case Qp:
        case Yp:
        case Gp:
        case Wp:
        case Kp:
        case Xp:
        case Zp:
        case Jp:
        case iu:
        case em:
        case kc:
        case xc:
        case tm:
        case Tf:
        case nm:
          return t + 5e3;
        case ru:
        case im:
        case Ef:
        case rm:
        case am:
          return ln;
        case Cf:
        case bf:
        case au:
        case Wr:
          return ln;
        default:
          return y("Should have found matching lanes. This is a bug in React."), ln;
      }
    }
    function om(e, t) {
      for (var a = e.pendingLanes, l = e.suspendedLanes, c = e.pingedLanes, m = e.expirationTimes, T = a; T > 0; ) {
        var E = Xn(T), C = 1 << E, x = m[E];
        x === ln ? ((C & l) === ee || (C & c) !== ee) && (m[E] = Dg(C, t)) : x <= t && (e.expiredLanes |= C), T &= ~C;
      }
    }
    function uE(e) {
      return kf(e.pendingLanes);
    }
    function um(e) {
      var t = e.pendingLanes & -1073741825;
      return t !== ee ? t : t & Wr ? Wr : ee;
    }
    function cE(e) {
      return (e & je) !== ee;
    }
    function xf(e) {
      return (e & Rg) !== ee;
    }
    function lu(e) {
      return (e & wf) === e;
    }
    function Mg(e) {
      var t = je | Qa | zn;
      return (e & t) === ee;
    }
    function Lg(e) {
      return (e & Hl) === e;
    }
    function cm(e, t) {
      var a = Vl | Qa | ji | zn;
      return (t & a) !== ee;
    }
    function dE(e, t) {
      return (t & e.expiredLanes) !== ee;
    }
    function $g(e) {
      return (e & Hl) !== ee;
    }
    function Og() {
      var e = su;
      return su <<= 1, (su & Hl) === ee && (su = nu), e;
    }
    function fE() {
      var e = sm;
      return sm <<= 1, (sm & wf) === ee && (sm = ru), e;
    }
    function Il(e) {
      return e & -e;
    }
    function Rf(e) {
      return Il(e);
    }
    function Xn(e) {
      return 31 - Kn(e);
    }
    function Li(e) {
      return Xn(e);
    }
    function $r(e, t) {
      return (e & t) !== ee;
    }
    function ou(e, t) {
      return (e & t) === t;
    }
    function it(e, t) {
      return e | t;
    }
    function Df(e, t) {
      return e & ~t;
    }
    function Ag(e, t) {
      return e & t;
    }
    function hE(e) {
      return e;
    }
    function pE(e, t) {
      return e !== Ot && e < t ? e : t;
    }
    function Mf(e) {
      for (var t = [], a = 0; a < tu; a++)
        t.push(e);
      return t;
    }
    function Rc(e, t, a) {
      e.pendingLanes |= t, t !== au && (e.suspendedLanes = ee, e.pingedLanes = ee);
      var l = e.eventTimes, c = Li(t);
      l[c] = a;
    }
    function mE(e, t) {
      e.suspendedLanes |= t, e.pingedLanes &= ~t;
      for (var a = e.expirationTimes, l = t; l > 0; ) {
        var c = Xn(l), m = 1 << c;
        a[c] = ln, l &= ~m;
      }
    }
    function dm(e, t, a) {
      e.pingedLanes |= e.suspendedLanes & t;
    }
    function Pg(e, t) {
      var a = e.pendingLanes & ~t;
      e.pendingLanes = t, e.suspendedLanes = ee, e.pingedLanes = ee, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t;
      for (var l = e.entanglements, c = e.eventTimes, m = e.expirationTimes, T = a; T > 0; ) {
        var E = Xn(T), C = 1 << E;
        l[E] = ee, c[E] = ln, m[E] = ln, T &= ~C;
      }
    }
    function fm(e, t) {
      for (var a = e.entangledLanes |= t, l = e.entanglements, c = a; c; ) {
        var m = Xn(c), T = 1 << m;
        // Is this one of the newly entangled lanes?
        T & t | // Is this lane transitively entangled with the newly entangled lanes?
        l[m] & t && (l[m] |= t), c &= ~T;
      }
    }
    function _g(e, t) {
      var a = Il(t), l;
      switch (a) {
        case Qa:
          l = Vl;
          break;
        case zn:
          l = ji;
          break;
        case nu:
        case Qp:
        case Yp:
        case Gp:
        case Wp:
        case Kp:
        case Xp:
        case Zp:
        case Jp:
        case iu:
        case em:
        case kc:
        case xc:
        case tm:
        case Tf:
        case nm:
        case ru:
        case im:
        case Ef:
        case rm:
        case am:
          l = Zs;
          break;
        case au:
          l = bf;
          break;
        default:
          l = Ot;
          break;
      }
      return (l & (e.suspendedLanes | t)) !== Ot ? Ot : l;
    }
    function Lf(e, t, a) {
      if (Lr)
        for (var l = e.pendingUpdatersLaneMap; a > 0; ) {
          var c = Li(a), m = 1 << c, T = l[c];
          T.add(t), a &= ~m;
        }
    }
    function vE(e, t) {
      if (Lr)
        for (var a = e.pendingUpdatersLaneMap, l = e.memoizedUpdaters; t > 0; ) {
          var c = Li(t), m = 1 << c, T = a[c];
          T.size > 0 && (T.forEach(function(E) {
            var C = E.alternate;
            (C === null || !l.has(C)) && l.add(E);
          }), T.clear()), t &= ~m;
        }
    }
    function Ng(e, t) {
      return null;
    }
    var ir = je, Ts = Qa, Sa = zn, Ta = au, $f = Ot;
    function wa() {
      return $f;
    }
    function Zn(e) {
      $f = e;
    }
    function yE(e, t) {
      var a = $f;
      try {
        return $f = e, t();
      } finally {
        $f = a;
      }
    }
    function gE(e, t) {
      return e !== 0 && e < t ? e : t;
    }
    function Of(e, t) {
      return e > t ? e : t;
    }
    function Si(e, t) {
      return e !== 0 && e < t;
    }
    function SE(e) {
      var t = Il(e);
      return Si(ir, t) ? Si(Ts, t) ? xf(t) ? Sa : Ta : Ts : ir;
    }
    function hm(e) {
      var t = e.current.memoizedState;
      return t.isDehydrated;
    }
    var Af;
    function Bi(e) {
      Af = e;
    }
    function uk(e) {
      Af(e);
    }
    var Ce;
    function Dc(e) {
      Ce = e;
    }
    var pm;
    function TE(e) {
      pm = e;
    }
    var wE;
    function Pf(e) {
      wE = e;
    }
    var _f;
    function Ug(e) {
      _f = e;
    }
    var mm = !1, Nf = [], Js = null, ws = null, Es = null, Fn = /* @__PURE__ */ new Map(), rr = /* @__PURE__ */ new Map(), ar = [], EE = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function CE(e) {
      return EE.indexOf(e) > -1;
    }
    function Ga(e, t, a, l, c) {
      return {
        blockedOn: e,
        domEventName: t,
        eventSystemFlags: a,
        nativeEvent: c,
        targetContainers: [l]
      };
    }
    function zg(e, t) {
      switch (e) {
        case "focusin":
        case "focusout":
          Js = null;
          break;
        case "dragenter":
        case "dragleave":
          ws = null;
          break;
        case "mouseover":
        case "mouseout":
          Es = null;
          break;
        case "pointerover":
        case "pointerout": {
          var a = t.pointerId;
          Fn.delete(a);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var l = t.pointerId;
          rr.delete(l);
          break;
        }
      }
    }
    function Or(e, t, a, l, c, m) {
      if (e === null || e.nativeEvent !== m) {
        var T = Ga(t, a, l, c, m);
        if (t !== null) {
          var E = Uc(t);
          E !== null && Ce(E);
        }
        return T;
      }
      e.eventSystemFlags |= l;
      var C = e.targetContainers;
      return c !== null && C.indexOf(c) === -1 && C.push(c), e;
    }
    function ck(e, t, a, l, c) {
      switch (t) {
        case "focusin": {
          var m = c;
          return Js = Or(Js, e, t, a, l, m), !0;
        }
        case "dragenter": {
          var T = c;
          return ws = Or(ws, e, t, a, l, T), !0;
        }
        case "mouseover": {
          var E = c;
          return Es = Or(Es, e, t, a, l, E), !0;
        }
        case "pointerover": {
          var C = c, x = C.pointerId;
          return Fn.set(x, Or(Fn.get(x) || null, e, t, a, l, C)), !0;
        }
        case "gotpointercapture": {
          var M = c, z = M.pointerId;
          return rr.set(z, Or(rr.get(z) || null, e, t, a, l, M)), !0;
        }
      }
      return !1;
    }
    function Fg(e) {
      var t = Gf(e.target);
      if (t !== null) {
        var a = Br(t);
        if (a !== null) {
          var l = a.tag;
          if (l === Ye) {
            var c = ys(a);
            if (c !== null) {
              e.blockedOn = c, _f(e.priority, function() {
                pm(a);
              });
              return;
            }
          } else if (l === A) {
            var m = a.stateNode;
            if (hm(m)) {
              e.blockedOn = gs(a);
              return;
            }
          }
        }
      }
      e.blockedOn = null;
    }
    function bE(e) {
      for (var t = wE(), a = {
        blockedOn: null,
        target: e,
        priority: t
      }, l = 0; l < ar.length && Si(t, ar[l].priority); l++)
        ;
      ar.splice(l, 0, a), l === 0 && Fg(a);
    }
    function Uf(e) {
      if (e.blockedOn !== null)
        return !1;
      for (var t = e.targetContainers; t.length > 0; ) {
        var a = t[0], l = Lc(e.domEventName, e.eventSystemFlags, a, e.nativeEvent);
        if (l === null) {
          var c = e.nativeEvent, m = new c.constructor(c.type, c);
          rk(m), c.target.dispatchEvent(m), ak();
        } else {
          var T = Uc(l);
          return T !== null && Ce(T), e.blockedOn = l, !1;
        }
        t.shift();
      }
      return !0;
    }
    function Vg(e, t, a) {
      Uf(e) && a.delete(t);
    }
    function dk() {
      mm = !1, Js !== null && Uf(Js) && (Js = null), ws !== null && Uf(ws) && (ws = null), Es !== null && Uf(Es) && (Es = null), Fn.forEach(Vg), rr.forEach(Vg);
    }
    function ql(e, t) {
      e.blockedOn === t && (e.blockedOn = null, mm || (mm = !0, s.unstable_scheduleCallback(s.unstable_NormalPriority, dk)));
    }
    function uu(e) {
      if (Nf.length > 0) {
        ql(Nf[0], e);
        for (var t = 1; t < Nf.length; t++) {
          var a = Nf[t];
          a.blockedOn === e && (a.blockedOn = null);
        }
      }
      Js !== null && ql(Js, e), ws !== null && ql(ws, e), Es !== null && ql(Es, e);
      var l = function(E) {
        return ql(E, e);
      };
      Fn.forEach(l), rr.forEach(l);
      for (var c = 0; c < ar.length; c++) {
        var m = ar[c];
        m.blockedOn === e && (m.blockedOn = null);
      }
      for (; ar.length > 0; ) {
        var T = ar[0];
        if (T.blockedOn !== null)
          break;
        Fg(T), T.blockedOn === null && ar.shift();
      }
    }
    var $i = n.ReactCurrentBatchConfig, Ct = !0;
    function ci(e) {
      Ct = !!e;
    }
    function Jn() {
      return Ct;
    }
    function Oi(e, t, a) {
      var l = vm(t), c;
      switch (l) {
        case ir:
          c = Kr;
          break;
        case Ts:
          c = Mc;
          break;
        case Sa:
        default:
          c = Vn;
          break;
      }
      return c.bind(null, t, a, e);
    }
    function Kr(e, t, a, l) {
      var c = wa(), m = $i.transition;
      $i.transition = null;
      try {
        Zn(ir), Vn(e, t, a, l);
      } finally {
        Zn(c), $i.transition = m;
      }
    }
    function Mc(e, t, a, l) {
      var c = wa(), m = $i.transition;
      $i.transition = null;
      try {
        Zn(Ts), Vn(e, t, a, l);
      } finally {
        Zn(c), $i.transition = m;
      }
    }
    function Vn(e, t, a, l) {
      Ct && zf(e, t, a, l);
    }
    function zf(e, t, a, l) {
      var c = Lc(e, t, a, l);
      if (c === null) {
        Mk(e, t, l, Cs, a), zg(e, l);
        return;
      }
      if (ck(c, e, t, a, l)) {
        l.stopPropagation();
        return;
      }
      if (zg(e, l), t & ha && CE(e)) {
        for (; c !== null; ) {
          var m = Uc(c);
          m !== null && uk(m);
          var T = Lc(e, t, a, l);
          if (T === null && Mk(e, t, l, Cs, a), T === c)
            break;
          c = T;
        }
        c !== null && l.stopPropagation();
        return;
      }
      Mk(e, t, l, null, a);
    }
    var Cs = null;
    function Lc(e, t, a, l) {
      Cs = null;
      var c = fg(l), m = Gf(c);
      if (m !== null) {
        var T = Br(m);
        if (T === null)
          m = null;
        else {
          var E = T.tag;
          if (E === Ye) {
            var C = ys(T);
            if (C !== null)
              return C;
            m = null;
          } else if (E === A) {
            var x = T.stateNode;
            if (hm(x))
              return gs(T);
            m = null;
          } else T !== m && (m = null);
        }
      }
      return Cs = m, null;
    }
    function vm(e) {
      switch (e) {
        // Used by SimpleEventPlugin:
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        // Used by polyfills:
        // eslint-disable-next-line no-fallthrough
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        // Only enableCreateEventHandleAPI:
        // eslint-disable-next-line no-fallthrough
        case "beforeblur":
        case "afterblur":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return ir;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Ts;
        case "message": {
          var t = Vp();
          switch (t) {
            case hf:
              return ir;
            case zl:
              return Ts;
            case Ks:
            case ok:
              return Sa;
            case Ko:
              return Ta;
            default:
              return Sa;
          }
        }
        default:
          return Sa;
      }
    }
    function Ff(e, t, a) {
      return e.addEventListener(t, a, !1), a;
    }
    function Ar(e, t, a) {
      return e.addEventListener(t, a, !0), a;
    }
    function Hg(e, t, a, l) {
      return e.addEventListener(t, a, {
        capture: !0,
        passive: l
      }), a;
    }
    function $c(e, t, a, l) {
      return e.addEventListener(t, a, {
        passive: l
      }), a;
    }
    var Xr = null, Oc = null, cu = null;
    function jl(e) {
      return Xr = e, Oc = Vf(), !0;
    }
    function ym() {
      Xr = null, Oc = null, cu = null;
    }
    function el() {
      if (cu)
        return cu;
      var e, t = Oc, a = t.length, l, c = Vf(), m = c.length;
      for (e = 0; e < a && t[e] === c[e]; e++)
        ;
      var T = a - e;
      for (l = 1; l <= T && t[a - l] === c[m - l]; l++)
        ;
      var E = l > 1 ? 1 - l : void 0;
      return cu = c.slice(e, E), cu;
    }
    function Vf() {
      return "value" in Xr ? Xr.value : Xr.textContent;
    }
    function Bl(e) {
      var t, a = e.keyCode;
      return "charCode" in e ? (t = e.charCode, t === 0 && a === 13 && (t = 13)) : t = a, t === 10 && (t = 13), t >= 32 || t === 13 ? t : 0;
    }
    function Ac() {
      return !0;
    }
    function Hf() {
      return !1;
    }
    function Qi(e) {
      function t(a, l, c, m, T) {
        this._reactName = a, this._targetInst = c, this.type = l, this.nativeEvent = m, this.target = T, this.currentTarget = null;
        for (var E in e)
          if (e.hasOwnProperty(E)) {
            var C = e[E];
            C ? this[E] = C(m) : this[E] = m[E];
          }
        var x = m.defaultPrevented != null ? m.defaultPrevented : m.returnValue === !1;
        return x ? this.isDefaultPrevented = Ac : this.isDefaultPrevented = Hf, this.isPropagationStopped = Hf, this;
      }
      return gt(t.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var a = this.nativeEvent;
          a && (a.preventDefault ? a.preventDefault() : typeof a.returnValue != "unknown" && (a.returnValue = !1), this.isDefaultPrevented = Ac);
        },
        stopPropagation: function() {
          var a = this.nativeEvent;
          a && (a.stopPropagation ? a.stopPropagation() : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0), this.isPropagationStopped = Ac);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Ac
      }), t;
    }
    var ei = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, bs = Qi(ei), sr = gt({}, ei, {
      view: 0,
      detail: 0
    }), Pr = Qi(sr), gm, If, du;
    function fk(e) {
      e !== du && (du && e.type === "mousemove" ? (gm = e.screenX - du.screenX, If = e.screenY - du.screenY) : (gm = 0, If = 0), du = e);
    }
    var Wa = gt({}, sr, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: wn,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (fk(e), gm);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : If;
      }
    }), Ig = Qi(Wa), qg = gt({}, Wa, {
      dataTransfer: 0
    }), fu = Qi(qg), jg = gt({}, sr, {
      relatedTarget: 0
    }), tl = Qi(jg), kE = gt({}, ei, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), xE = Qi(kE), Bg = gt({}, ei, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), Sm = Qi(Bg), hk = gt({}, ei, {
      data: 0
    }), RE = Qi(hk), DE = RE, ME = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, hu = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function pk(e) {
      if (e.key) {
        var t = ME[e.key] || e.key;
        if (t !== "Unidentified")
          return t;
      }
      if (e.type === "keypress") {
        var a = Bl(e);
        return a === 13 ? "Enter" : String.fromCharCode(a);
      }
      return e.type === "keydown" || e.type === "keyup" ? hu[e.keyCode] || "Unidentified" : "";
    }
    var Pc = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function LE(e) {
      var t = this, a = t.nativeEvent;
      if (a.getModifierState)
        return a.getModifierState(e);
      var l = Pc[e];
      return l ? !!a[l] : !1;
    }
    function wn(e) {
      return LE;
    }
    var mk = gt({}, sr, {
      key: pk,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: wn,
      // Legacy Interface
      charCode: function(e) {
        return e.type === "keypress" ? Bl(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? Bl(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), $E = Qi(mk), vk = gt({}, Wa, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), OE = Qi(vk), AE = gt({}, sr, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: wn
    }), PE = Qi(AE), yk = gt({}, ei, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Ea = Qi(yk), Qg = gt({}, Wa, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in e ? -e.wheelDeltaX : 0
        );
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in e ? -e.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in e ? -e.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), gk = Qi(Qg), Ql = [9, 13, 27, 32], qf = 229, nl = _n && "CompositionEvent" in window, Yl = null;
    _n && "documentMode" in document && (Yl = document.documentMode);
    var Yg = _n && "TextEvent" in window && !Yl, Tm = _n && (!nl || Yl && Yl > 8 && Yl <= 11), _E = 32, wm = String.fromCharCode(_E);
    function Sk() {
      si("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), si("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), si("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), si("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Gg = !1;
    function NE(e) {
      return (e.ctrlKey || e.altKey || e.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(e.ctrlKey && e.altKey);
    }
    function Em(e) {
      switch (e) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Cm(e, t) {
      return e === "keydown" && t.keyCode === qf;
    }
    function Wg(e, t) {
      switch (e) {
        case "keyup":
          return Ql.indexOf(t.keyCode) !== -1;
        case "keydown":
          return t.keyCode !== qf;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function bm(e) {
      var t = e.detail;
      return typeof t == "object" && "data" in t ? t.data : null;
    }
    function Kg(e) {
      return e.locale === "ko";
    }
    var Gl = !1;
    function km(e, t, a, l, c) {
      var m, T;
      if (nl ? m = Em(t) : Gl ? Wg(t, l) && (m = "onCompositionEnd") : Cm(t, l) && (m = "onCompositionStart"), !m)
        return null;
      Tm && !Kg(l) && (!Gl && m === "onCompositionStart" ? Gl = jl(c) : m === "onCompositionEnd" && Gl && (T = el()));
      var E = IE(a, m);
      if (E.length > 0) {
        var C = new RE(m, t, null, l, c);
        if (e.push({
          event: C,
          listeners: E
        }), T)
          C.data = T;
        else {
          var x = bm(l);
          x !== null && (C.data = x);
        }
      }
    }
    function Xg(e, t) {
      switch (e) {
        case "compositionend":
          return bm(t);
        case "keypress":
          var a = t.which;
          return a !== _E ? null : (Gg = !0, wm);
        case "textInput":
          var l = t.data;
          return l === wm && Gg ? null : l;
        default:
          return null;
      }
    }
    function xm(e, t) {
      if (Gl) {
        if (e === "compositionend" || !nl && Wg(e, t)) {
          var a = el();
          return ym(), Gl = !1, a;
        }
        return null;
      }
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!NE(t)) {
            if (t.char && t.char.length > 1)
              return t.char;
            if (t.which)
              return String.fromCharCode(t.which);
          }
          return null;
        case "compositionend":
          return Tm && !Kg(t) ? null : t.data;
        default:
          return null;
      }
    }
    function UE(e, t, a, l, c) {
      var m;
      if (Yg ? m = Xg(t, l) : m = xm(t, l), !m)
        return null;
      var T = IE(a, "onBeforeInput");
      if (T.length > 0) {
        var E = new DE("onBeforeInput", "beforeinput", null, l, c);
        e.push({
          event: E,
          listeners: T
        }), E.data = m;
      }
    }
    function Tk(e, t, a, l, c, m, T) {
      km(e, t, a, l, c), UE(e, t, a, l, c);
    }
    var Rm = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function zE(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t === "input" ? !!Rm[e.type] : t === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function jf(e) {
      if (!_n)
        return !1;
      var t = "on" + e, a = t in document;
      if (!a) {
        var l = document.createElement("div");
        l.setAttribute(t, "return;"), a = typeof l[t] == "function";
      }
      return a;
    }
    function wk() {
      si("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function Bf(e, t, a, l) {
      yc(l);
      var c = IE(t, "onChange");
      if (c.length > 0) {
        var m = new bs("onChange", "change", null, a, l);
        e.push({
          event: m,
          listeners: c
        });
      }
    }
    var i = null, r = null;
    function u(e) {
      var t = e.nodeName && e.nodeName.toLowerCase();
      return t === "select" || t === "input" && e.type === "file";
    }
    function p(e) {
      var t = [];
      Bf(t, r, e, fg(e)), Xw(g, t);
    }
    function g(e) {
      uL(e, 0);
    }
    function w(e) {
      var t = Am(e);
      if (Fo(t))
        return e;
    }
    function b(e, t) {
      if (e === "change")
        return t;
    }
    var O = !1;
    _n && (O = jf("input") && (!document.documentMode || document.documentMode > 9));
    function P(e, t) {
      i = e, r = t, i.attachEvent("onpropertychange", ie);
    }
    function j() {
      i && (i.detachEvent("onpropertychange", ie), i = null, r = null);
    }
    function ie(e) {
      e.propertyName === "value" && w(r) && p(e);
    }
    function re(e, t, a) {
      e === "focusin" ? (j(), P(t, a)) : e === "focusout" && j();
    }
    function te(e, t) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return w(r);
    }
    function Te(e) {
      var t = e.nodeName;
      return t && t.toLowerCase() === "input" && (e.type === "checkbox" || e.type === "radio");
    }
    function ke(e, t) {
      if (e === "click")
        return w(t);
    }
    function De(e, t) {
      if (e === "input" || e === "change")
        return w(t);
    }
    function Hn(e) {
      var t = e._wrapperState;
      !t || !t.controlled || e.type !== "number" || gp(e, "number", e.value);
    }
    function F(e, t, a, l, c, m, T) {
      var E = a ? Am(a) : window, C, x;
      if (u(E) ? C = b : zE(E) ? O ? C = De : (C = te, x = re) : Te(E) && (C = ke), C) {
        var M = C(t, a);
        if (M) {
          Bf(e, M, l, c);
          return;
        }
      }
      x && x(t, E, a), t === "focusout" && Hn(E);
    }
    function U() {
      ki("onMouseEnter", ["mouseout", "mouseover"]), ki("onMouseLeave", ["mouseout", "mouseover"]), ki("onPointerEnter", ["pointerout", "pointerover"]), ki("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function I(e, t, a, l, c, m, T) {
      var E = t === "mouseover" || t === "pointerover", C = t === "mouseout" || t === "pointerout";
      if (E && !lf(l)) {
        var x = l.relatedTarget || l.fromElement;
        if (x && (Gf(x) || dS(x)))
          return;
      }
      if (!(!C && !E)) {
        var M;
        if (c.window === c)
          M = c;
        else {
          var z = c.ownerDocument;
          z ? M = z.defaultView || z.parentWindow : M = window;
        }
        var N, q;
        if (C) {
          var Q = l.relatedTarget || l.toElement;
          if (N = a, q = Q ? Gf(Q) : null, q !== null) {
            var Y = Br(q);
            (q !== Y || q.tag !== W && q.tag !== ne) && (q = null);
          }
        } else
          N = null, q = a;
        if (N !== q) {
          var ve = Ig, Ue = "onMouseLeave", Me = "onMouseEnter", kt = "mouse";
          (t === "pointerout" || t === "pointerover") && (ve = OE, Ue = "onPointerLeave", Me = "onPointerEnter", kt = "pointer");
          var pt = N == null ? M : Am(N), V = q == null ? M : Am(q), G = new ve(Ue, kt + "leave", N, l, c);
          G.target = pt, G.relatedTarget = V;
          var H = null, ae = Gf(c);
          if (ae === a) {
            var Ee = new ve(Me, kt + "enter", q, l, c);
            Ee.target = V, Ee.relatedTarget = pt, H = Ee;
          }
          nH(e, G, H, N, q);
        }
      }
    }
    function le(e, t) {
      return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
    }
    var ge = typeof Object.is == "function" ? Object.is : le;
    function Ne(e, t) {
      if (ge(e, t))
        return !0;
      if (typeof e != "object" || e === null || typeof t != "object" || t === null)
        return !1;
      var a = Object.keys(e), l = Object.keys(t);
      if (a.length !== l.length)
        return !1;
      for (var c = 0; c < a.length; c++) {
        var m = a[c];
        if (!er.call(t, m) || !ge(e[m], t[m]))
          return !1;
      }
      return !0;
    }
    function Fe(e) {
      for (; e && e.firstChild; )
        e = e.firstChild;
      return e;
    }
    function We(e) {
      for (; e; ) {
        if (e.nextSibling)
          return e.nextSibling;
        e = e.parentNode;
      }
    }
    function di(e, t) {
      for (var a = Fe(e), l = 0, c = 0; a; ) {
        if (a.nodeType === Bs) {
          if (c = l + a.textContent.length, l <= t && c >= t)
            return {
              node: a,
              offset: t - l
            };
          l = c;
        }
        a = Fe(We(a));
      }
    }
    function Ft(e) {
      var t = e.ownerDocument, a = t && t.defaultView || window, l = a.getSelection && a.getSelection();
      if (!l || l.rangeCount === 0)
        return null;
      var c = l.anchorNode, m = l.anchorOffset, T = l.focusNode, E = l.focusOffset;
      try {
        c.nodeType, T.nodeType;
      } catch {
        return null;
      }
      return Wl(e, c, m, T, E);
    }
    function Wl(e, t, a, l, c) {
      var m = 0, T = -1, E = -1, C = 0, x = 0, M = e, z = null;
      e: for (; ; ) {
        for (var N = null; M === t && (a === 0 || M.nodeType === Bs) && (T = m + a), M === l && (c === 0 || M.nodeType === Bs) && (E = m + c), M.nodeType === Bs && (m += M.nodeValue.length), (N = M.firstChild) !== null; )
          z = M, M = N;
        for (; ; ) {
          if (M === e)
            break e;
          if (z === t && ++C === a && (T = m), z === l && ++x === c && (E = m), (N = M.nextSibling) !== null)
            break;
          M = z, z = M.parentNode;
        }
        M = N;
      }
      return T === -1 || E === -1 ? null : {
        start: T,
        end: E
      };
    }
    function Ek(e, t) {
      var a = e.ownerDocument || document, l = a && a.defaultView || window;
      if (l.getSelection) {
        var c = l.getSelection(), m = e.textContent.length, T = Math.min(t.start, m), E = t.end === void 0 ? T : Math.min(t.end, m);
        if (!c.extend && T > E) {
          var C = E;
          E = T, T = C;
        }
        var x = di(e, T), M = di(e, E);
        if (x && M) {
          if (c.rangeCount === 1 && c.anchorNode === x.node && c.anchorOffset === x.offset && c.focusNode === M.node && c.focusOffset === M.offset)
            return;
          var z = a.createRange();
          z.setStart(x.node, x.offset), c.removeAllRanges(), T > E ? (c.addRange(z), c.extend(M.node, M.offset)) : (z.setEnd(M.node, M.offset), c.addRange(z));
        }
      }
    }
    function XM(e) {
      return e && e.nodeType === Bs;
    }
    function ZM(e, t) {
      return !e || !t ? !1 : e === t ? !0 : XM(e) ? !1 : XM(t) ? ZM(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1;
    }
    function zV(e) {
      return e && e.ownerDocument && ZM(e.ownerDocument.documentElement, e);
    }
    function FV(e) {
      try {
        return typeof e.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function JM() {
      for (var e = window, t = Vo(); t instanceof e.HTMLIFrameElement; ) {
        if (FV(t))
          e = t.contentWindow;
        else
          return t;
        t = Vo(e.document);
      }
      return t;
    }
    function Ck(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
    }
    function VV() {
      var e = JM();
      return {
        focusedElem: e,
        selectionRange: Ck(e) ? IV(e) : null
      };
    }
    function HV(e) {
      var t = JM(), a = e.focusedElem, l = e.selectionRange;
      if (t !== a && zV(a)) {
        l !== null && Ck(a) && qV(a, l);
        for (var c = [], m = a; m = m.parentNode; )
          m.nodeType === br && c.push({
            element: m,
            left: m.scrollLeft,
            top: m.scrollTop
          });
        typeof a.focus == "function" && a.focus();
        for (var T = 0; T < c.length; T++) {
          var E = c[T];
          E.element.scrollLeft = E.left, E.element.scrollTop = E.top;
        }
      }
    }
    function IV(e) {
      var t;
      return "selectionStart" in e ? t = {
        start: e.selectionStart,
        end: e.selectionEnd
      } : t = Ft(e), t || {
        start: 0,
        end: 0
      };
    }
    function qV(e, t) {
      var a = t.start, l = t.end;
      l === void 0 && (l = a), "selectionStart" in e ? (e.selectionStart = a, e.selectionEnd = Math.min(l, e.value.length)) : Ek(e, t);
    }
    var jV = _n && "documentMode" in document && document.documentMode <= 11;
    function BV() {
      si("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var Dm = null, bk = null, Zg = null, kk = !1;
    function QV(e) {
      if ("selectionStart" in e && Ck(e))
        return {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      var t = e.ownerDocument && e.ownerDocument.defaultView || window, a = t.getSelection();
      return {
        anchorNode: a.anchorNode,
        anchorOffset: a.anchorOffset,
        focusNode: a.focusNode,
        focusOffset: a.focusOffset
      };
    }
    function YV(e) {
      return e.window === e ? e.document : e.nodeType === Qs ? e : e.ownerDocument;
    }
    function eL(e, t, a) {
      var l = YV(a);
      if (!(kk || Dm == null || Dm !== Vo(l))) {
        var c = QV(Dm);
        if (!Zg || !Ne(Zg, c)) {
          Zg = c;
          var m = IE(bk, "onSelect");
          if (m.length > 0) {
            var T = new bs("onSelect", "select", null, t, a);
            e.push({
              event: T,
              listeners: m
            }), T.target = Dm;
          }
        }
      }
    }
    function GV(e, t, a, l, c, m, T) {
      var E = a ? Am(a) : window;
      switch (t) {
        // Track the input node that has focus.
        case "focusin":
          (zE(E) || E.contentEditable === "true") && (Dm = E, bk = a, Zg = null);
          break;
        case "focusout":
          Dm = null, bk = null, Zg = null;
          break;
        // Don't fire the event while the user is dragging. This matches the
        // semantics of the native select event.
        case "mousedown":
          kk = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          kk = !1, eL(e, l, c);
          break;
        // Chrome and IE fire non-standard event when selection is changed (and
        // sometimes when it hasn't). IE's event fires out of order with respect
        // to key and input events on deletion, so we discard it.
        //
        // Firefox doesn't support selectionchange, so check selection status
        // after each key entry. The selection changes after keydown and before
        // keyup, but we check on keydown as well in the case of holding down a
        // key, when multiple keydown events are fired but only one keyup is.
        // This is also our approach for IE handling, for the reason above.
        case "selectionchange":
          if (jV)
            break;
        // falls through
        case "keydown":
        case "keyup":
          eL(e, l, c);
      }
    }
    function FE(e, t) {
      var a = {};
      return a[e.toLowerCase()] = t.toLowerCase(), a["Webkit" + e] = "webkit" + t, a["Moz" + e] = "moz" + t, a;
    }
    var Mm = {
      animationend: FE("Animation", "AnimationEnd"),
      animationiteration: FE("Animation", "AnimationIteration"),
      animationstart: FE("Animation", "AnimationStart"),
      transitionend: FE("Transition", "TransitionEnd")
    }, xk = {}, tL = {};
    _n && (tL = document.createElement("div").style, "AnimationEvent" in window || (delete Mm.animationend.animation, delete Mm.animationiteration.animation, delete Mm.animationstart.animation), "TransitionEvent" in window || delete Mm.transitionend.transition);
    function VE(e) {
      if (xk[e])
        return xk[e];
      if (!Mm[e])
        return e;
      var t = Mm[e];
      for (var a in t)
        if (t.hasOwnProperty(a) && a in tL)
          return xk[e] = t[a];
      return e;
    }
    var nL = VE("animationend"), iL = VE("animationiteration"), rL = VE("animationstart"), aL = VE("transitionend"), sL = /* @__PURE__ */ new Map(), lL = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function _c(e, t) {
      sL.set(e, t), si(t, [e]);
    }
    function WV() {
      for (var e = 0; e < lL.length; e++) {
        var t = lL[e], a = t.toLowerCase(), l = t[0].toUpperCase() + t.slice(1);
        _c(a, "on" + l);
      }
      _c(nL, "onAnimationEnd"), _c(iL, "onAnimationIteration"), _c(rL, "onAnimationStart"), _c("dblclick", "onDoubleClick"), _c("focusin", "onFocus"), _c("focusout", "onBlur"), _c(aL, "onTransitionEnd");
    }
    function KV(e, t, a, l, c, m, T) {
      var E = sL.get(t);
      if (E !== void 0) {
        var C = bs, x = t;
        switch (t) {
          case "keypress":
            if (Bl(l) === 0)
              return;
          /* falls through */
          case "keydown":
          case "keyup":
            C = $E;
            break;
          case "focusin":
            x = "focus", C = tl;
            break;
          case "focusout":
            x = "blur", C = tl;
            break;
          case "beforeblur":
          case "afterblur":
            C = tl;
            break;
          case "click":
            if (l.button === 2)
              return;
          /* falls through */
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          // TODO: Disabled elements should not respond to mouse events
          /* falls through */
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            C = Ig;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            C = fu;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            C = PE;
            break;
          case nL:
          case iL:
          case rL:
            C = xE;
            break;
          case aL:
            C = Ea;
            break;
          case "scroll":
            C = Pr;
            break;
          case "wheel":
            C = gk;
            break;
          case "copy":
          case "cut":
          case "paste":
            C = Sm;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            C = OE;
            break;
        }
        var M = (m & ha) !== 0;
        {
          var z = !M && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          t === "scroll", N = eH(a, E, l.type, M, z);
          if (N.length > 0) {
            var q = new C(E, x, null, l, c);
            e.push({
              event: q,
              listeners: N
            });
          }
        }
      }
    }
    WV(), U(), wk(), BV(), Sk();
    function XV(e, t, a, l, c, m, T) {
      KV(e, t, a, l, c, m);
      var E = (m & dg) === 0;
      E && (I(e, t, a, l, c), F(e, t, a, l, c), GV(e, t, a, l, c), Tk(e, t, a, l, c));
    }
    var Jg = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], Rk = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Jg));
    function oL(e, t, a) {
      var l = e.type || "unknown-event";
      e.currentTarget = a, ps(l, t, void 0, e), e.currentTarget = null;
    }
    function ZV(e, t, a) {
      var l;
      if (a)
        for (var c = t.length - 1; c >= 0; c--) {
          var m = t[c], T = m.instance, E = m.currentTarget, C = m.listener;
          if (T !== l && e.isPropagationStopped())
            return;
          oL(e, C, E), l = T;
        }
      else
        for (var x = 0; x < t.length; x++) {
          var M = t[x], z = M.instance, N = M.currentTarget, q = M.listener;
          if (z !== l && e.isPropagationStopped())
            return;
          oL(e, q, N), l = z;
        }
    }
    function uL(e, t) {
      for (var a = (t & ha) !== 0, l = 0; l < e.length; l++) {
        var c = e[l], m = c.event, T = c.listeners;
        ZV(m, T, a);
      }
      cf();
    }
    function JV(e, t, a, l, c) {
      var m = fg(a), T = [];
      XV(T, e, l, a, m, t), uL(T, t);
    }
    function kn(e, t) {
      Rk.has(e) || y('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', e);
      var a = !1, l = M3(t), c = iH(e);
      l.has(c) || (cL(t, e, Rp, a), l.add(c));
    }
    function Dk(e, t, a) {
      Rk.has(e) && !t && y('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', e);
      var l = 0;
      t && (l |= ha), cL(a, e, l, t);
    }
    var HE = "_reactListening" + Math.random().toString(36).slice(2);
    function eS(e) {
      if (!e[HE]) {
        e[HE] = !0, ri.forEach(function(a) {
          a !== "selectionchange" && (Rk.has(a) || Dk(a, !1, e), Dk(a, !0, e));
        });
        var t = e.nodeType === Qs ? e : e.ownerDocument;
        t !== null && (t[HE] || (t[HE] = !0, Dk("selectionchange", !1, t)));
      }
    }
    function cL(e, t, a, l, c) {
      var m = Oi(e, t, a), T = void 0;
      uf && (t === "touchstart" || t === "touchmove" || t === "wheel") && (T = !0), e = e, l ? T !== void 0 ? Hg(e, t, m, T) : Ar(e, t, m) : T !== void 0 ? $c(e, t, m, T) : Ff(e, t, m);
    }
    function dL(e, t) {
      return e === t || e.nodeType === Yn && e.parentNode === t;
    }
    function Mk(e, t, a, l, c) {
      var m = l;
      if (!(t & cg) && !(t & Rp)) {
        var T = c;
        if (l !== null) {
          var E = l;
          e: for (; ; ) {
            if (E === null)
              return;
            var C = E.tag;
            if (C === A || C === B) {
              var x = E.stateNode.containerInfo;
              if (dL(x, T))
                break;
              if (C === B)
                for (var M = E.return; M !== null; ) {
                  var z = M.tag;
                  if (z === A || z === B) {
                    var N = M.stateNode.containerInfo;
                    if (dL(N, T))
                      return;
                  }
                  M = M.return;
                }
              for (; x !== null; ) {
                var q = Gf(x);
                if (q === null)
                  return;
                var Q = q.tag;
                if (Q === W || Q === ne) {
                  E = m = q;
                  continue e;
                }
                x = x.parentNode;
              }
            }
            E = E.return;
          }
        }
      }
      Xw(function() {
        return JV(e, t, a, m);
      });
    }
    function tS(e, t, a) {
      return {
        instance: e,
        listener: t,
        currentTarget: a
      };
    }
    function eH(e, t, a, l, c, m) {
      for (var T = t !== null ? t + "Capture" : null, E = l ? T : t, C = [], x = e, M = null; x !== null; ) {
        var z = x, N = z.stateNode, q = z.tag;
        if (q === W && N !== null && (M = N, E !== null)) {
          var Q = Ol(x, E);
          Q != null && C.push(tS(x, Q, M));
        }
        if (c)
          break;
        x = x.return;
      }
      return C;
    }
    function IE(e, t) {
      for (var a = t + "Capture", l = [], c = e; c !== null; ) {
        var m = c, T = m.stateNode, E = m.tag;
        if (E === W && T !== null) {
          var C = T, x = Ol(c, a);
          x != null && l.unshift(tS(c, x, C));
          var M = Ol(c, t);
          M != null && l.push(tS(c, M, C));
        }
        c = c.return;
      }
      return l;
    }
    function Lm(e) {
      if (e === null)
        return null;
      do
        e = e.return;
      while (e && e.tag !== W);
      return e || null;
    }
    function tH(e, t) {
      for (var a = e, l = t, c = 0, m = a; m; m = Lm(m))
        c++;
      for (var T = 0, E = l; E; E = Lm(E))
        T++;
      for (; c - T > 0; )
        a = Lm(a), c--;
      for (; T - c > 0; )
        l = Lm(l), T--;
      for (var C = c; C--; ) {
        if (a === l || l !== null && a === l.alternate)
          return a;
        a = Lm(a), l = Lm(l);
      }
      return null;
    }
    function fL(e, t, a, l, c) {
      for (var m = t._reactName, T = [], E = a; E !== null && E !== l; ) {
        var C = E, x = C.alternate, M = C.stateNode, z = C.tag;
        if (x !== null && x === l)
          break;
        if (z === W && M !== null) {
          var N = M;
          if (c) {
            var q = Ol(E, m);
            q != null && T.unshift(tS(E, q, N));
          } else if (!c) {
            var Q = Ol(E, m);
            Q != null && T.push(tS(E, Q, N));
          }
        }
        E = E.return;
      }
      T.length !== 0 && e.push({
        event: t,
        listeners: T
      });
    }
    function nH(e, t, a, l, c) {
      var m = l && c ? tH(l, c) : null;
      l !== null && fL(e, t, l, m, !1), c !== null && a !== null && fL(e, a, c, m, !0);
    }
    function iH(e, t) {
      return e + "__bubble";
    }
    var Ca = !1, nS = "dangerouslySetInnerHTML", qE = "suppressContentEditableWarning", Nc = "suppressHydrationWarning", hL = "autoFocus", Qf = "children", Yf = "style", jE = "__html", Lk, BE, iS, pL, QE, mL, vL;
    Lk = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, BE = function(e, t) {
      lg(e, t), kp(e, t), Gw(e, t, {
        registrationNameDependencies: ai,
        possibleRegistrationNames: bi
      });
    }, mL = _n && !document.documentMode, iS = function(e, t, a) {
      if (!Ca) {
        var l = YE(a), c = YE(t);
        c !== l && (Ca = !0, y("Prop `%s` did not match. Server: %s Client: %s", e, JSON.stringify(c), JSON.stringify(l)));
      }
    }, pL = function(e) {
      if (!Ca) {
        Ca = !0;
        var t = [];
        e.forEach(function(a) {
          t.push(a);
        }), y("Extra attributes from the server: %s", t);
      }
    }, QE = function(e, t) {
      t === !1 ? y("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : y("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof t);
    }, vL = function(e, t) {
      var a = e.namespaceURI === js ? e.ownerDocument.createElement(e.tagName) : e.ownerDocument.createElementNS(e.namespaceURI, e.tagName);
      return a.innerHTML = t, a.innerHTML;
    };
    var rH = /\r\n?/g, aH = /\u0000|\uFFFD/g;
    function YE(e) {
      Lo(e);
      var t = typeof e == "string" ? e : "" + e;
      return t.replace(rH, `
`).replace(aH, "");
    }
    function GE(e, t, a, l) {
      var c = YE(t), m = YE(e);
      if (m !== c && (l && (Ca || (Ca = !0, y('Text content did not match. Server: "%s" Client: "%s"', m, c))), a && ot))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function yL(e) {
      return e.nodeType === Qs ? e : e.ownerDocument;
    }
    function sH() {
    }
    function WE(e) {
      e.onclick = sH;
    }
    function lH(e, t, a, l, c) {
      for (var m in l)
        if (l.hasOwnProperty(m)) {
          var T = l[m];
          if (m === Yf)
            T && Object.freeze(T), Iw(t, T);
          else if (m === nS) {
            var E = T ? T[jE] : void 0;
            E != null && Lw(t, E);
          } else if (m === Qf)
            if (typeof T == "string") {
              var C = e !== "textarea" || T !== "";
              C && hc(t, T);
            } else typeof T == "number" && hc(t, "" + T);
          else m === qE || m === Nc || m === hL || (ai.hasOwnProperty(m) ? T != null && (typeof T != "function" && QE(m, T), m === "onScroll" && kn("scroll", t)) : T != null && Ao(t, m, T, c));
        }
    }
    function oH(e, t, a, l) {
      for (var c = 0; c < t.length; c += 2) {
        var m = t[c], T = t[c + 1];
        m === Yf ? Iw(e, T) : m === nS ? Lw(e, T) : m === Qf ? hc(e, T) : Ao(e, m, T, l);
      }
    }
    function uH(e, t, a, l) {
      var c, m = yL(a), T, E = l;
      if (E === js && (E = eg(e)), E === js) {
        if (c = Ll(e, t), !c && e !== e.toLowerCase() && y("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", e), e === "script") {
          var C = m.createElement("div");
          C.innerHTML = "<script><\/script>";
          var x = C.firstChild;
          T = C.removeChild(x);
        } else if (typeof t.is == "string")
          T = m.createElement(e, {
            is: t.is
          });
        else if (T = m.createElement(e), e === "select") {
          var M = T;
          t.multiple ? M.multiple = !0 : t.size && (M.size = t.size);
        }
      } else
        T = m.createElementNS(E, e);
      return E === js && !c && Object.prototype.toString.call(T) === "[object HTMLUnknownElement]" && !er.call(Lk, e) && (Lk[e] = !0, y("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", e)), T;
    }
    function cH(e, t) {
      return yL(t).createTextNode(e);
    }
    function dH(e, t, a, l) {
      var c = Ll(t, a);
      BE(t, a);
      var m;
      switch (t) {
        case "dialog":
          kn("cancel", e), kn("close", e), m = a;
          break;
        case "iframe":
        case "object":
        case "embed":
          kn("load", e), m = a;
          break;
        case "video":
        case "audio":
          for (var T = 0; T < Jg.length; T++)
            kn(Jg[T], e);
          m = a;
          break;
        case "source":
          kn("error", e), m = a;
          break;
        case "img":
        case "image":
        case "link":
          kn("error", e), kn("load", e), m = a;
          break;
        case "details":
          kn("toggle", e), m = a;
          break;
        case "input":
          qs(e, a), m = pp(e, a), kn("invalid", e);
          break;
        case "option":
          dc(e, a), m = a;
          break;
        case "select":
          Tp(e, a), m = Wy(e, a), kn("invalid", e);
          break;
        case "textarea":
          Xy(e, a), m = Ky(e, a), kn("invalid", e);
          break;
        default:
          m = a;
      }
      switch (Cp(t, m), lH(t, e, l, m, c), t) {
        case "input":
          Ml(e), Qy(e, a, !1);
          break;
        case "textarea":
          Ml(e), Dw(e);
          break;
        case "option":
          B0(e, a);
          break;
        case "select":
          Y0(e, a);
          break;
        default:
          typeof m.onClick == "function" && WE(e);
          break;
      }
    }
    function fH(e, t, a, l, c) {
      BE(t, l);
      var m = null, T, E;
      switch (t) {
        case "input":
          T = pp(e, a), E = pp(e, l), m = [];
          break;
        case "select":
          T = Wy(e, a), E = Wy(e, l), m = [];
          break;
        case "textarea":
          T = Ky(e, a), E = Ky(e, l), m = [];
          break;
        default:
          T = a, E = l, typeof T.onClick != "function" && typeof E.onClick == "function" && WE(e);
          break;
      }
      Cp(t, E);
      var C, x, M = null;
      for (C in T)
        if (!(E.hasOwnProperty(C) || !T.hasOwnProperty(C) || T[C] == null))
          if (C === Yf) {
            var z = T[C];
            for (x in z)
              z.hasOwnProperty(x) && (M || (M = {}), M[x] = "");
          } else C === nS || C === Qf || C === qE || C === Nc || C === hL || (ai.hasOwnProperty(C) ? m || (m = []) : (m = m || []).push(C, null));
      for (C in E) {
        var N = E[C], q = T != null ? T[C] : void 0;
        if (!(!E.hasOwnProperty(C) || N === q || N == null && q == null))
          if (C === Yf)
            if (N && Object.freeze(N), q) {
              for (x in q)
                q.hasOwnProperty(x) && (!N || !N.hasOwnProperty(x)) && (M || (M = {}), M[x] = "");
              for (x in N)
                N.hasOwnProperty(x) && q[x] !== N[x] && (M || (M = {}), M[x] = N[x]);
            } else
              M || (m || (m = []), m.push(C, M)), M = N;
          else if (C === nS) {
            var Q = N ? N[jE] : void 0, Y = q ? q[jE] : void 0;
            Q != null && Y !== Q && (m = m || []).push(C, Q);
          } else C === Qf ? (typeof N == "string" || typeof N == "number") && (m = m || []).push(C, "" + N) : C === qE || C === Nc || (ai.hasOwnProperty(C) ? (N != null && (typeof N != "function" && QE(C, N), C === "onScroll" && kn("scroll", e)), !m && q !== N && (m = [])) : (m = m || []).push(C, N));
      }
      return M && (nk(M, E[Yf]), (m = m || []).push(Yf, M)), m;
    }
    function hH(e, t, a, l, c) {
      a === "input" && c.type === "radio" && c.name != null && mp(e, c);
      var m = Ll(a, l), T = Ll(a, c);
      switch (oH(e, t, m, T), a) {
        case "input":
          cc(e, c);
          break;
        case "textarea":
          Rw(e, c);
          break;
        case "select":
          G0(e, c);
          break;
      }
    }
    function pH(e) {
      {
        var t = e.toLowerCase();
        return af.hasOwnProperty(t) && af[t] || null;
      }
    }
    function mH(e, t, a, l, c, m, T) {
      var E, C;
      switch (E = Ll(t, a), BE(t, a), t) {
        case "dialog":
          kn("cancel", e), kn("close", e);
          break;
        case "iframe":
        case "object":
        case "embed":
          kn("load", e);
          break;
        case "video":
        case "audio":
          for (var x = 0; x < Jg.length; x++)
            kn(Jg[x], e);
          break;
        case "source":
          kn("error", e);
          break;
        case "img":
        case "image":
        case "link":
          kn("error", e), kn("load", e);
          break;
        case "details":
          kn("toggle", e);
          break;
        case "input":
          qs(e, a), kn("invalid", e);
          break;
        case "option":
          dc(e, a);
          break;
        case "select":
          Tp(e, a), kn("invalid", e);
          break;
        case "textarea":
          Xy(e, a), kn("invalid", e);
          break;
      }
      Cp(t, a);
      {
        C = /* @__PURE__ */ new Set();
        for (var M = e.attributes, z = 0; z < M.length; z++) {
          var N = M[z].name.toLowerCase();
          switch (N) {
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              C.add(M[z].name);
          }
        }
      }
      var q = null;
      for (var Q in a)
        if (a.hasOwnProperty(Q)) {
          var Y = a[Q];
          if (Q === Qf)
            typeof Y == "string" ? e.textContent !== Y && (a[Nc] !== !0 && GE(e.textContent, Y, m, T), q = [Qf, Y]) : typeof Y == "number" && e.textContent !== "" + Y && (a[Nc] !== !0 && GE(e.textContent, Y, m, T), q = [Qf, "" + Y]);
          else if (ai.hasOwnProperty(Q))
            Y != null && (typeof Y != "function" && QE(Q, Y), Q === "onScroll" && kn("scroll", e));
          else if (T && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof E == "boolean") {
            var ve = void 0, Ue = Qn(Q);
            if (a[Nc] !== !0) {
              if (!(Q === qE || Q === Nc || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              Q === "value" || Q === "checked" || Q === "selected")) {
                if (Q === nS) {
                  var Me = e.innerHTML, kt = Y ? Y[jE] : void 0;
                  if (kt != null) {
                    var pt = vL(e, kt);
                    pt !== Me && iS(Q, Me, pt);
                  }
                } else if (Q === Yf) {
                  if (C.delete(Q), mL) {
                    var V = ek(Y);
                    ve = e.getAttribute("style"), V !== ve && iS(Q, ve, V);
                  }
                } else if (E)
                  C.delete(Q.toLowerCase()), ve = Oy(e, Q, Y), Y !== ve && iS(Q, ve, Y);
                else if (!wr(Q, Ue, E) && !Er(Q, Y, Ue, E)) {
                  var G = !1;
                  if (Ue !== null)
                    C.delete(Ue.attributeName), ve = $y(e, Q, Y, Ue);
                  else {
                    var H = l;
                    if (H === js && (H = eg(t)), H === js)
                      C.delete(Q.toLowerCase());
                    else {
                      var ae = pH(Q);
                      ae !== null && ae !== Q && (G = !0, C.delete(ae)), C.delete(Q);
                    }
                    ve = Oy(e, Q, Y);
                  }
                  var Ee = yt;
                  !Ee && Y !== ve && !G && iS(Q, ve, Y);
                }
              }
            }
          }
        }
      switch (T && // $FlowFixMe - Should be inferred as not undefined.
      C.size > 0 && a[Nc] !== !0 && pL(C), t) {
        case "input":
          Ml(e), Qy(e, a, !0);
          break;
        case "textarea":
          Ml(e), Dw(e);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof a.onClick == "function" && WE(e);
          break;
      }
      return q;
    }
    function vH(e, t, a) {
      var l = e.nodeValue !== t;
      return l;
    }
    function $k(e, t) {
      {
        if (Ca)
          return;
        Ca = !0, y("Did not expect server HTML to contain a <%s> in <%s>.", t.nodeName.toLowerCase(), e.nodeName.toLowerCase());
      }
    }
    function Ok(e, t) {
      {
        if (Ca)
          return;
        Ca = !0, y('Did not expect server HTML to contain the text node "%s" in <%s>.', t.nodeValue, e.nodeName.toLowerCase());
      }
    }
    function Ak(e, t, a) {
      {
        if (Ca)
          return;
        Ca = !0, y("Expected server HTML to contain a matching <%s> in <%s>.", t, e.nodeName.toLowerCase());
      }
    }
    function Pk(e, t) {
      {
        if (t === "" || Ca)
          return;
        Ca = !0, y('Expected server HTML to contain a matching text node for "%s" in <%s>.', t, e.nodeName.toLowerCase());
      }
    }
    function yH(e, t, a) {
      switch (t) {
        case "input":
          vp(e, a);
          return;
        case "textarea":
          K0(e, a);
          return;
        case "select":
          W0(e, a);
          return;
      }
    }
    var rS = function() {
    }, aS = function() {
    };
    {
      var gH = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], gL = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], SH = gL.concat(["button"]), TH = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], SL = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      aS = function(e, t) {
        var a = gt({}, e || SL), l = {
          tag: t
        };
        return gL.indexOf(t) !== -1 && (a.aTagInScope = null, a.buttonTagInScope = null, a.nobrTagInScope = null), SH.indexOf(t) !== -1 && (a.pTagInButtonScope = null), gH.indexOf(t) !== -1 && t !== "address" && t !== "div" && t !== "p" && (a.listItemTagAutoclosing = null, a.dlItemTagAutoclosing = null), a.current = l, t === "form" && (a.formTag = l), t === "a" && (a.aTagInScope = l), t === "button" && (a.buttonTagInScope = l), t === "nobr" && (a.nobrTagInScope = l), t === "p" && (a.pTagInButtonScope = l), t === "li" && (a.listItemTagAutoclosing = l), (t === "dd" || t === "dt") && (a.dlItemTagAutoclosing = l), a;
      };
      var wH = function(e, t) {
        switch (t) {
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
          case "select":
            return e === "option" || e === "optgroup" || e === "#text";
          case "optgroup":
            return e === "option" || e === "#text";
          // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
          // but
          case "option":
            return e === "#text";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
          // No special behavior since these rules fall back to "in body" mode for
          // all except special table nodes which cause bad parsing behavior anyway.
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
          case "tr":
            return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
          case "tbody":
          case "thead":
          case "tfoot":
            return e === "tr" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
          case "colgroup":
            return e === "col" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
          case "table":
            return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
          case "head":
            return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
          case "html":
            return e === "head" || e === "body" || e === "frameset";
          case "frameset":
            return e === "frame";
          case "#document":
            return e === "html";
        }
        switch (e) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t !== "h1" && t !== "h2" && t !== "h3" && t !== "h4" && t !== "h5" && t !== "h6";
          case "rp":
          case "rt":
            return TH.indexOf(t) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return t == null;
        }
        return !0;
      }, EH = function(e, t) {
        switch (e) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t.pTagInButtonScope;
          case "form":
            return t.formTag || t.pTagInButtonScope;
          case "li":
            return t.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return t.dlItemTagAutoclosing;
          case "button":
            return t.buttonTagInScope;
          case "a":
            return t.aTagInScope;
          case "nobr":
            return t.nobrTagInScope;
        }
        return null;
      }, TL = {};
      rS = function(e, t, a) {
        a = a || SL;
        var l = a.current, c = l && l.tag;
        t != null && (e != null && y("validateDOMNesting: when childText is passed, childTag should be null"), e = "#text");
        var m = wH(e, c) ? null : l, T = m ? null : EH(e, a), E = m || T;
        if (E) {
          var C = E.tag, x = !!m + "|" + e + "|" + C;
          if (!TL[x]) {
            TL[x] = !0;
            var M = e, z = "";
            if (e === "#text" ? /\S/.test(t) ? M = "Text nodes" : (M = "Whitespace text nodes", z = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : M = "<" + e + ">", m) {
              var N = "";
              C === "table" && e === "tr" && (N += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), y("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", M, C, z, N);
            } else
              y("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", M, C);
          }
        }
      };
    }
    var KE = "suppressHydrationWarning", XE = "$", ZE = "/$", sS = "$?", lS = "$!", CH = "style", _k = null, Nk = null;
    function bH(e) {
      var t, a, l = e.nodeType;
      switch (l) {
        case Qs:
        case ng: {
          t = l === Qs ? "#document" : "#fragment";
          var c = e.documentElement;
          a = c ? c.namespaceURI : tg(null, "");
          break;
        }
        default: {
          var m = l === Yn ? e.parentNode : e, T = m.namespaceURI || null;
          t = m.tagName, a = tg(T, t);
          break;
        }
      }
      {
        var E = t.toLowerCase(), C = aS(null, E);
        return {
          namespace: a,
          ancestorInfo: C
        };
      }
    }
    function kH(e, t, a) {
      {
        var l = e, c = tg(l.namespace, t), m = aS(l.ancestorInfo, t);
        return {
          namespace: c,
          ancestorInfo: m
        };
      }
    }
    function pQ(e) {
      return e;
    }
    function xH(e) {
      _k = Jn(), Nk = VV();
      var t = null;
      return ci(!1), t;
    }
    function RH(e) {
      HV(Nk), ci(_k), _k = null, Nk = null;
    }
    function DH(e, t, a, l, c) {
      var m;
      {
        var T = l;
        if (rS(e, null, T.ancestorInfo), typeof t.children == "string" || typeof t.children == "number") {
          var E = "" + t.children, C = aS(T.ancestorInfo, e);
          rS(null, E, C);
        }
        m = T.namespace;
      }
      var x = uH(e, t, a, m);
      return cS(c, x), jk(x, t), x;
    }
    function MH(e, t) {
      e.appendChild(t);
    }
    function LH(e, t, a, l, c) {
      switch (dH(e, t, a, l), t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!a.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function $H(e, t, a, l, c, m) {
      {
        var T = m;
        if (typeof l.children != typeof a.children && (typeof l.children == "string" || typeof l.children == "number")) {
          var E = "" + l.children, C = aS(T.ancestorInfo, t);
          rS(null, E, C);
        }
      }
      return fH(e, t, a, l);
    }
    function Uk(e, t) {
      return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
    }
    function OH(e, t, a, l) {
      {
        var c = a;
        rS(null, e, c.ancestorInfo);
      }
      var m = cH(e, t);
      return cS(l, m), m;
    }
    function AH() {
      var e = window.event;
      return e === void 0 ? Sa : vm(e.type);
    }
    var zk = typeof setTimeout == "function" ? setTimeout : void 0, PH = typeof clearTimeout == "function" ? clearTimeout : void 0, Fk = -1, wL = typeof Promise == "function" ? Promise : void 0, _H = typeof queueMicrotask == "function" ? queueMicrotask : typeof wL < "u" ? function(e) {
      return wL.resolve(null).then(e).catch(NH);
    } : zk;
    function NH(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function UH(e, t, a, l) {
      switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          a.autoFocus && e.focus();
          return;
        case "img": {
          a.src && (e.src = a.src);
          return;
        }
      }
    }
    function zH(e, t, a, l, c, m) {
      hH(e, t, a, l, c), jk(e, c);
    }
    function EL(e) {
      hc(e, "");
    }
    function FH(e, t, a) {
      e.nodeValue = a;
    }
    function VH(e, t) {
      e.appendChild(t);
    }
    function HH(e, t) {
      var a;
      e.nodeType === Yn ? (a = e.parentNode, a.insertBefore(t, e)) : (a = e, a.appendChild(t));
      var l = e._reactRootContainer;
      l == null && a.onclick === null && WE(a);
    }
    function IH(e, t, a) {
      e.insertBefore(t, a);
    }
    function qH(e, t, a) {
      e.nodeType === Yn ? e.parentNode.insertBefore(t, a) : e.insertBefore(t, a);
    }
    function jH(e, t) {
      e.removeChild(t);
    }
    function BH(e, t) {
      e.nodeType === Yn ? e.parentNode.removeChild(t) : e.removeChild(t);
    }
    function Vk(e, t) {
      var a = t, l = 0;
      do {
        var c = a.nextSibling;
        if (e.removeChild(a), c && c.nodeType === Yn) {
          var m = c.data;
          if (m === ZE)
            if (l === 0) {
              e.removeChild(c), uu(t);
              return;
            } else
              l--;
          else (m === XE || m === sS || m === lS) && l++;
        }
        a = c;
      } while (a);
      uu(t);
    }
    function QH(e, t) {
      e.nodeType === Yn ? Vk(e.parentNode, t) : e.nodeType === br && Vk(e, t), uu(e);
    }
    function YH(e) {
      e = e;
      var t = e.style;
      typeof t.setProperty == "function" ? t.setProperty("display", "none", "important") : t.display = "none";
    }
    function GH(e) {
      e.nodeValue = "";
    }
    function WH(e, t) {
      e = e;
      var a = t[CH], l = a != null && a.hasOwnProperty("display") ? a.display : null;
      e.style.display = Ep("display", l);
    }
    function KH(e, t) {
      e.nodeValue = t;
    }
    function XH(e) {
      e.nodeType === br ? e.textContent = "" : e.nodeType === Qs && e.documentElement && e.removeChild(e.documentElement);
    }
    function ZH(e, t, a) {
      return e.nodeType !== br || t.toLowerCase() !== e.nodeName.toLowerCase() ? null : e;
    }
    function JH(e, t) {
      return t === "" || e.nodeType !== Bs ? null : e;
    }
    function e3(e) {
      return e.nodeType !== Yn ? null : e;
    }
    function CL(e) {
      return e.data === sS;
    }
    function Hk(e) {
      return e.data === lS;
    }
    function t3(e) {
      var t = e.nextSibling && e.nextSibling.dataset, a, l, c;
      return t && (a = t.dgst, l = t.msg, c = t.stck), {
        message: l,
        digest: a,
        stack: c
      };
    }
    function n3(e, t) {
      e._reactRetry = t;
    }
    function JE(e) {
      for (; e != null; e = e.nextSibling) {
        var t = e.nodeType;
        if (t === br || t === Bs)
          break;
        if (t === Yn) {
          var a = e.data;
          if (a === XE || a === lS || a === sS)
            break;
          if (a === ZE)
            return null;
        }
      }
      return e;
    }
    function oS(e) {
      return JE(e.nextSibling);
    }
    function i3(e) {
      return JE(e.firstChild);
    }
    function r3(e) {
      return JE(e.firstChild);
    }
    function a3(e) {
      return JE(e.nextSibling);
    }
    function s3(e, t, a, l, c, m, T) {
      cS(m, e), jk(e, a);
      var E;
      {
        var C = c;
        E = C.namespace;
      }
      var x = (m.mode & dt) !== _e;
      return mH(e, t, a, E, l, x, T);
    }
    function l3(e, t, a, l) {
      return cS(a, e), a.mode & dt, vH(e, t);
    }
    function o3(e, t) {
      cS(t, e);
    }
    function u3(e) {
      for (var t = e.nextSibling, a = 0; t; ) {
        if (t.nodeType === Yn) {
          var l = t.data;
          if (l === ZE) {
            if (a === 0)
              return oS(t);
            a--;
          } else (l === XE || l === lS || l === sS) && a++;
        }
        t = t.nextSibling;
      }
      return null;
    }
    function bL(e) {
      for (var t = e.previousSibling, a = 0; t; ) {
        if (t.nodeType === Yn) {
          var l = t.data;
          if (l === XE || l === lS || l === sS) {
            if (a === 0)
              return t;
            a--;
          } else l === ZE && a++;
        }
        t = t.previousSibling;
      }
      return null;
    }
    function c3(e) {
      uu(e);
    }
    function d3(e) {
      uu(e);
    }
    function f3(e) {
      return e !== "head" && e !== "body";
    }
    function h3(e, t, a, l) {
      var c = !0;
      GE(t.nodeValue, a, l, c);
    }
    function p3(e, t, a, l, c, m) {
      if (t[KE] !== !0) {
        var T = !0;
        GE(l.nodeValue, c, m, T);
      }
    }
    function m3(e, t) {
      t.nodeType === br ? $k(e, t) : t.nodeType === Yn || Ok(e, t);
    }
    function v3(e, t) {
      {
        var a = e.parentNode;
        a !== null && (t.nodeType === br ? $k(a, t) : t.nodeType === Yn || Ok(a, t));
      }
    }
    function y3(e, t, a, l, c) {
      (c || t[KE] !== !0) && (l.nodeType === br ? $k(a, l) : l.nodeType === Yn || Ok(a, l));
    }
    function g3(e, t, a) {
      Ak(e, t);
    }
    function S3(e, t) {
      Pk(e, t);
    }
    function T3(e, t, a) {
      {
        var l = e.parentNode;
        l !== null && Ak(l, t);
      }
    }
    function w3(e, t) {
      {
        var a = e.parentNode;
        a !== null && Pk(a, t);
      }
    }
    function E3(e, t, a, l, c, m) {
      (m || t[KE] !== !0) && Ak(a, l);
    }
    function C3(e, t, a, l, c) {
      (c || t[KE] !== !0) && Pk(a, l);
    }
    function b3(e) {
      y("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", e.nodeName.toLowerCase());
    }
    function k3(e) {
      eS(e);
    }
    var $m = Math.random().toString(36).slice(2), Om = "__reactFiber$" + $m, Ik = "__reactProps$" + $m, uS = "__reactContainer$" + $m, qk = "__reactEvents$" + $m, x3 = "__reactListeners$" + $m, R3 = "__reactHandles$" + $m;
    function D3(e) {
      delete e[Om], delete e[Ik], delete e[qk], delete e[x3], delete e[R3];
    }
    function cS(e, t) {
      t[Om] = e;
    }
    function eC(e, t) {
      t[uS] = e;
    }
    function kL(e) {
      e[uS] = null;
    }
    function dS(e) {
      return !!e[uS];
    }
    function Gf(e) {
      var t = e[Om];
      if (t)
        return t;
      for (var a = e.parentNode; a; ) {
        if (t = a[uS] || a[Om], t) {
          var l = t.alternate;
          if (t.child !== null || l !== null && l.child !== null)
            for (var c = bL(e); c !== null; ) {
              var m = c[Om];
              if (m)
                return m;
              c = bL(c);
            }
          return t;
        }
        e = a, a = e.parentNode;
      }
      return null;
    }
    function Uc(e) {
      var t = e[Om] || e[uS];
      return t && (t.tag === W || t.tag === ne || t.tag === Ye || t.tag === A) ? t : null;
    }
    function Am(e) {
      if (e.tag === W || e.tag === ne)
        return e.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function tC(e) {
      return e[Ik] || null;
    }
    function jk(e, t) {
      e[Ik] = t;
    }
    function M3(e) {
      var t = e[qk];
      return t === void 0 && (t = e[qk] = /* @__PURE__ */ new Set()), t;
    }
    var xL = {}, RL = n.ReactDebugCurrentFrame;
    function nC(e) {
      if (e) {
        var t = e._owner, a = zo(e.type, e._source, t ? t.type : null);
        RL.setExtraStackFrame(a);
      } else
        RL.setExtraStackFrame(null);
    }
    function il(e, t, a, l, c) {
      {
        var m = Function.call.bind(er);
        for (var T in e)
          if (m(e, T)) {
            var E = void 0;
            try {
              if (typeof e[T] != "function") {
                var C = Error((l || "React class") + ": " + a + " type `" + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[T] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw C.name = "Invariant Violation", C;
              }
              E = e[T](t, T, l, a, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              E = x;
            }
            E && !(E instanceof Error) && (nC(c), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", l || "React class", a, T, typeof E), nC(null)), E instanceof Error && !(E.message in xL) && (xL[E.message] = !0, nC(c), y("Failed %s type: %s", a, E.message), nC(null));
          }
      }
    }
    var Bk = [], iC;
    iC = [];
    var pu = -1;
    function zc(e) {
      return {
        current: e
      };
    }
    function _r(e, t) {
      if (pu < 0) {
        y("Unexpected pop.");
        return;
      }
      t !== iC[pu] && y("Unexpected Fiber popped."), e.current = Bk[pu], Bk[pu] = null, iC[pu] = null, pu--;
    }
    function Nr(e, t, a) {
      pu++, Bk[pu] = e.current, iC[pu] = a, e.current = t;
    }
    var Qk;
    Qk = {};
    var Ka = {};
    Object.freeze(Ka);
    var mu = zc(Ka), Kl = zc(!1), Yk = Ka;
    function Pm(e, t, a) {
      return a && Xl(t) ? Yk : mu.current;
    }
    function DL(e, t, a) {
      {
        var l = e.stateNode;
        l.__reactInternalMemoizedUnmaskedChildContext = t, l.__reactInternalMemoizedMaskedChildContext = a;
      }
    }
    function _m(e, t) {
      {
        var a = e.type, l = a.contextTypes;
        if (!l)
          return Ka;
        var c = e.stateNode;
        if (c && c.__reactInternalMemoizedUnmaskedChildContext === t)
          return c.__reactInternalMemoizedMaskedChildContext;
        var m = {};
        for (var T in l)
          m[T] = t[T];
        {
          var E = nt(e) || "Unknown";
          il(l, m, "context", E);
        }
        return c && DL(e, t, m), m;
      }
    }
    function rC() {
      return Kl.current;
    }
    function Xl(e) {
      {
        var t = e.childContextTypes;
        return t != null;
      }
    }
    function aC(e) {
      _r(Kl, e), _r(mu, e);
    }
    function Gk(e) {
      _r(Kl, e), _r(mu, e);
    }
    function ML(e, t, a) {
      {
        if (mu.current !== Ka)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        Nr(mu, t, e), Nr(Kl, a, e);
      }
    }
    function LL(e, t, a) {
      {
        var l = e.stateNode, c = t.childContextTypes;
        if (typeof l.getChildContext != "function") {
          {
            var m = nt(e) || "Unknown";
            Qk[m] || (Qk[m] = !0, y("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", m, m));
          }
          return a;
        }
        var T = l.getChildContext();
        for (var E in T)
          if (!(E in c))
            throw new Error((nt(e) || "Unknown") + '.getChildContext(): key "' + E + '" is not defined in childContextTypes.');
        {
          var C = nt(e) || "Unknown";
          il(c, T, "child context", C);
        }
        return gt({}, a, T);
      }
    }
    function sC(e) {
      {
        var t = e.stateNode, a = t && t.__reactInternalMemoizedMergedChildContext || Ka;
        return Yk = mu.current, Nr(mu, a, e), Nr(Kl, Kl.current, e), !0;
      }
    }
    function $L(e, t, a) {
      {
        var l = e.stateNode;
        if (!l)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (a) {
          var c = LL(e, t, Yk);
          l.__reactInternalMemoizedMergedChildContext = c, _r(Kl, e), _r(mu, e), Nr(mu, c, e), Nr(Kl, a, e);
        } else
          _r(Kl, e), Nr(Kl, a, e);
      }
    }
    function L3(e) {
      {
        if (!Wo(e) || e.tag !== $)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var t = e;
        do {
          switch (t.tag) {
            case A:
              return t.stateNode.context;
            case $: {
              var a = t.type;
              if (Xl(a))
                return t.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          t = t.return;
        } while (t !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Fc = 0, lC = 1, vu = null, Wk = !1, Kk = !1;
    function OL(e) {
      vu === null ? vu = [e] : vu.push(e);
    }
    function $3(e) {
      Wk = !0, OL(e);
    }
    function AL() {
      Wk && Vc();
    }
    function Vc() {
      if (!Kk && vu !== null) {
        Kk = !0;
        var e = 0, t = wa();
        try {
          var a = !0, l = vu;
          for (Zn(ir); e < l.length; e++) {
            var c = l[e];
            do
              c = c(a);
            while (c !== null);
          }
          vu = null, Wk = !1;
        } catch (m) {
          throw vu !== null && (vu = vu.slice(e + 1)), pg(hf, Vc), m;
        } finally {
          Zn(t), Kk = !1;
        }
      }
      return null;
    }
    var Nm = [], Um = 0, oC = null, uC = 0, ks = [], xs = 0, Wf = null, yu = 1, gu = "";
    function O3(e) {
      return Xf(), (e.flags & ms) !== Pe;
    }
    function A3(e) {
      return Xf(), uC;
    }
    function P3() {
      var e = gu, t = yu, a = t & ~_3(t);
      return a.toString(32) + e;
    }
    function Kf(e, t) {
      Xf(), Nm[Um++] = uC, Nm[Um++] = oC, oC = e, uC = t;
    }
    function PL(e, t, a) {
      Xf(), ks[xs++] = yu, ks[xs++] = gu, ks[xs++] = Wf, Wf = e;
      var l = yu, c = gu, m = cC(l) - 1, T = l & ~(1 << m), E = a + 1, C = cC(t) + m;
      if (C > 30) {
        var x = m - m % 5, M = (1 << x) - 1, z = (T & M).toString(32), N = T >> x, q = m - x, Q = cC(t) + q, Y = E << q, ve = Y | N, Ue = z + c;
        yu = 1 << Q | ve, gu = Ue;
      } else {
        var Me = E << m, kt = Me | T, pt = c;
        yu = 1 << C | kt, gu = pt;
      }
    }
    function Xk(e) {
      Xf();
      var t = e.return;
      if (t !== null) {
        var a = 1, l = 0;
        Kf(e, a), PL(e, a, l);
      }
    }
    function cC(e) {
      return 32 - Kn(e);
    }
    function _3(e) {
      return 1 << cC(e) - 1;
    }
    function Zk(e) {
      for (; e === oC; )
        oC = Nm[--Um], Nm[Um] = null, uC = Nm[--Um], Nm[Um] = null;
      for (; e === Wf; )
        Wf = ks[--xs], ks[xs] = null, gu = ks[--xs], ks[xs] = null, yu = ks[--xs], ks[xs] = null;
    }
    function N3() {
      return Xf(), Wf !== null ? {
        id: yu,
        overflow: gu
      } : null;
    }
    function U3(e, t) {
      Xf(), ks[xs++] = yu, ks[xs++] = gu, ks[xs++] = Wf, yu = t.id, gu = t.overflow, Wf = e;
    }
    function Xf() {
      or() || y("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var lr = null, Rs = null, rl = !1, Zf = !1, Hc = null;
    function z3() {
      rl && y("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function _L() {
      Zf = !0;
    }
    function F3() {
      return Zf;
    }
    function V3(e) {
      var t = e.stateNode.containerInfo;
      return Rs = r3(t), lr = e, rl = !0, Hc = null, Zf = !1, !0;
    }
    function H3(e, t, a) {
      return Rs = a3(t), lr = e, rl = !0, Hc = null, Zf = !1, a !== null && U3(e, a), !0;
    }
    function NL(e, t) {
      switch (e.tag) {
        case A: {
          m3(e.stateNode.containerInfo, t);
          break;
        }
        case W: {
          var a = (e.mode & dt) !== _e;
          y3(
            e.type,
            e.memoizedProps,
            e.stateNode,
            t,
            // TODO: Delete this argument when we remove the legacy root API.
            a
          );
          break;
        }
        case Ye: {
          var l = e.memoizedState;
          l.dehydrated !== null && v3(l.dehydrated, t);
          break;
        }
      }
    }
    function UL(e, t) {
      NL(e, t);
      var a = Bq();
      a.stateNode = t, a.return = e;
      var l = e.deletions;
      l === null ? (e.deletions = [a], e.flags |= pa) : l.push(a);
    }
    function Jk(e, t) {
      {
        if (Zf)
          return;
        switch (e.tag) {
          case A: {
            var a = e.stateNode.containerInfo;
            switch (t.tag) {
              case W:
                var l = t.type;
                t.pendingProps, g3(a, l);
                break;
              case ne:
                var c = t.pendingProps;
                S3(a, c);
                break;
            }
            break;
          }
          case W: {
            var m = e.type, T = e.memoizedProps, E = e.stateNode;
            switch (t.tag) {
              case W: {
                var C = t.type, x = t.pendingProps, M = (e.mode & dt) !== _e;
                E3(
                  m,
                  T,
                  E,
                  C,
                  x,
                  // TODO: Delete this argument when we remove the legacy root API.
                  M
                );
                break;
              }
              case ne: {
                var z = t.pendingProps, N = (e.mode & dt) !== _e;
                C3(
                  m,
                  T,
                  E,
                  z,
                  // TODO: Delete this argument when we remove the legacy root API.
                  N
                );
                break;
              }
            }
            break;
          }
          case Ye: {
            var q = e.memoizedState, Q = q.dehydrated;
            if (Q !== null) switch (t.tag) {
              case W:
                var Y = t.type;
                t.pendingProps, T3(Q, Y);
                break;
              case ne:
                var ve = t.pendingProps;
                w3(Q, ve);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function zL(e, t) {
      t.flags = t.flags & -4097 | Nn, Jk(e, t);
    }
    function FL(e, t) {
      switch (e.tag) {
        case W: {
          var a = e.type;
          e.pendingProps;
          var l = ZH(t, a);
          return l !== null ? (e.stateNode = l, lr = e, Rs = i3(l), !0) : !1;
        }
        case ne: {
          var c = e.pendingProps, m = JH(t, c);
          return m !== null ? (e.stateNode = m, lr = e, Rs = null, !0) : !1;
        }
        case Ye: {
          var T = e3(t);
          if (T !== null) {
            var E = {
              dehydrated: T,
              treeContext: N3(),
              retryLane: Wr
            };
            e.memoizedState = E;
            var C = Qq(T);
            return C.return = e, e.child = C, lr = e, Rs = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function ex(e) {
      return (e.mode & dt) !== _e && (e.flags & Oe) === Pe;
    }
    function tx(e) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function nx(e) {
      if (rl) {
        var t = Rs;
        if (!t) {
          ex(e) && (Jk(lr, e), tx()), zL(lr, e), rl = !1, lr = e;
          return;
        }
        var a = t;
        if (!FL(e, t)) {
          ex(e) && (Jk(lr, e), tx()), t = oS(a);
          var l = lr;
          if (!t || !FL(e, t)) {
            zL(lr, e), rl = !1, lr = e;
            return;
          }
          UL(l, a);
        }
      }
    }
    function I3(e, t, a) {
      var l = e.stateNode, c = !Zf, m = s3(l, e.type, e.memoizedProps, t, a, e, c);
      return e.updateQueue = m, m !== null;
    }
    function q3(e) {
      var t = e.stateNode, a = e.memoizedProps, l = l3(t, a, e);
      if (l) {
        var c = lr;
        if (c !== null)
          switch (c.tag) {
            case A: {
              var m = c.stateNode.containerInfo, T = (c.mode & dt) !== _e;
              h3(
                m,
                t,
                a,
                // TODO: Delete this argument when we remove the legacy root API.
                T
              );
              break;
            }
            case W: {
              var E = c.type, C = c.memoizedProps, x = c.stateNode, M = (c.mode & dt) !== _e;
              p3(
                E,
                C,
                x,
                t,
                a,
                // TODO: Delete this argument when we remove the legacy root API.
                M
              );
              break;
            }
          }
      }
      return l;
    }
    function j3(e) {
      var t = e.memoizedState, a = t !== null ? t.dehydrated : null;
      if (!a)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      o3(a, e);
    }
    function B3(e) {
      var t = e.memoizedState, a = t !== null ? t.dehydrated : null;
      if (!a)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return u3(a);
    }
    function VL(e) {
      for (var t = e.return; t !== null && t.tag !== W && t.tag !== A && t.tag !== Ye; )
        t = t.return;
      lr = t;
    }
    function dC(e) {
      if (e !== lr)
        return !1;
      if (!rl)
        return VL(e), rl = !0, !1;
      if (e.tag !== A && (e.tag !== W || f3(e.type) && !Uk(e.type, e.memoizedProps))) {
        var t = Rs;
        if (t)
          if (ex(e))
            HL(e), tx();
          else
            for (; t; )
              UL(e, t), t = oS(t);
      }
      return VL(e), e.tag === Ye ? Rs = B3(e) : Rs = lr ? oS(e.stateNode) : null, !0;
    }
    function Q3() {
      return rl && Rs !== null;
    }
    function HL(e) {
      for (var t = Rs; t; )
        NL(e, t), t = oS(t);
    }
    function zm() {
      lr = null, Rs = null, rl = !1, Zf = !1;
    }
    function IL() {
      Hc !== null && (_O(Hc), Hc = null);
    }
    function or() {
      return rl;
    }
    function ix(e) {
      Hc === null ? Hc = [e] : Hc.push(e);
    }
    var Y3 = n.ReactCurrentBatchConfig, G3 = null;
    function W3() {
      return Y3.transition;
    }
    var al = {
      recordUnsafeLifecycleWarnings: function(e, t) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(e, t) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var K3 = function(e) {
        for (var t = null, a = e; a !== null; )
          a.mode & Jt && (t = a), a = a.return;
        return t;
      }, Jf = function(e) {
        var t = [];
        return e.forEach(function(a) {
          t.push(a);
        }), t.sort().join(", ");
      }, fS = [], hS = [], pS = [], mS = [], vS = [], yS = [], eh = /* @__PURE__ */ new Set();
      al.recordUnsafeLifecycleWarnings = function(e, t) {
        eh.has(e.type) || (typeof t.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        t.componentWillMount.__suppressDeprecationWarning !== !0 && fS.push(e), e.mode & Jt && typeof t.UNSAFE_componentWillMount == "function" && hS.push(e), typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && pS.push(e), e.mode & Jt && typeof t.UNSAFE_componentWillReceiveProps == "function" && mS.push(e), typeof t.componentWillUpdate == "function" && t.componentWillUpdate.__suppressDeprecationWarning !== !0 && vS.push(e), e.mode & Jt && typeof t.UNSAFE_componentWillUpdate == "function" && yS.push(e));
      }, al.flushPendingUnsafeLifecycleWarnings = function() {
        var e = /* @__PURE__ */ new Set();
        fS.length > 0 && (fS.forEach(function(N) {
          e.add(nt(N) || "Component"), eh.add(N.type);
        }), fS = []);
        var t = /* @__PURE__ */ new Set();
        hS.length > 0 && (hS.forEach(function(N) {
          t.add(nt(N) || "Component"), eh.add(N.type);
        }), hS = []);
        var a = /* @__PURE__ */ new Set();
        pS.length > 0 && (pS.forEach(function(N) {
          a.add(nt(N) || "Component"), eh.add(N.type);
        }), pS = []);
        var l = /* @__PURE__ */ new Set();
        mS.length > 0 && (mS.forEach(function(N) {
          l.add(nt(N) || "Component"), eh.add(N.type);
        }), mS = []);
        var c = /* @__PURE__ */ new Set();
        vS.length > 0 && (vS.forEach(function(N) {
          c.add(nt(N) || "Component"), eh.add(N.type);
        }), vS = []);
        var m = /* @__PURE__ */ new Set();
        if (yS.length > 0 && (yS.forEach(function(N) {
          m.add(nt(N) || "Component"), eh.add(N.type);
        }), yS = []), t.size > 0) {
          var T = Jf(t);
          y(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, T);
        }
        if (l.size > 0) {
          var E = Jf(l);
          y(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, E);
        }
        if (m.size > 0) {
          var C = Jf(m);
          y(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, C);
        }
        if (e.size > 0) {
          var x = Jf(e);
          v(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, x);
        }
        if (a.size > 0) {
          var M = Jf(a);
          v(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, M);
        }
        if (c.size > 0) {
          var z = Jf(c);
          v(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, z);
        }
      };
      var fC = /* @__PURE__ */ new Map(), qL = /* @__PURE__ */ new Set();
      al.recordLegacyContextWarning = function(e, t) {
        var a = K3(e);
        if (a === null) {
          y("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!qL.has(e.type)) {
          var l = fC.get(a);
          (e.type.contextTypes != null || e.type.childContextTypes != null || t !== null && typeof t.getChildContext == "function") && (l === void 0 && (l = [], fC.set(a, l)), l.push(e));
        }
      }, al.flushLegacyContextWarning = function() {
        fC.forEach(function(e, t) {
          if (e.length !== 0) {
            var a = e[0], l = /* @__PURE__ */ new Set();
            e.forEach(function(m) {
              l.add(nt(m) || "Component"), qL.add(m.type);
            });
            var c = Jf(l);
            try {
              pn(a), y(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, c);
            } finally {
              On();
            }
          }
        });
      }, al.discardPendingWarnings = function() {
        fS = [], hS = [], pS = [], mS = [], vS = [], yS = [], fC = /* @__PURE__ */ new Map();
      };
    }
    var rx, ax, sx, lx, ox, jL = function(e, t) {
    };
    rx = !1, ax = !1, sx = {}, lx = {}, ox = {}, jL = function(e, t) {
      if (!(e === null || typeof e != "object") && !(!e._store || e._store.validated || e.key != null)) {
        if (typeof e._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        e._store.validated = !0;
        var a = nt(t) || "Component";
        lx[a] || (lx[a] = !0, y('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function X3(e) {
      return e.prototype && e.prototype.isReactComponent;
    }
    function gS(e, t, a) {
      var l = a.ref;
      if (l !== null && typeof l != "function" && typeof l != "object") {
        if ((e.mode & Jt || Nt) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(a._owner && a._self && a._owner.stateNode !== a._self) && // Will already throw with "Function components cannot have string refs"
        !(a._owner && a._owner.tag !== $) && // Will already warn with "Function components cannot be given refs"
        !(typeof a.type == "function" && !X3(a.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        a._owner) {
          var c = nt(e) || "Component";
          sx[c] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', c, l), sx[c] = !0);
        }
        if (a._owner) {
          var m = a._owner, T;
          if (m) {
            var E = m;
            if (E.tag !== $)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            T = E.stateNode;
          }
          if (!T)
            throw new Error("Missing owner for string ref " + l + ". This error is likely caused by a bug in React. Please file an issue.");
          var C = T;
          Id(l, "ref");
          var x = "" + l;
          if (t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === x)
            return t.ref;
          var M = function(z) {
            var N = C.refs;
            z === null ? delete N[x] : N[x] = z;
          };
          return M._stringRef = x, M;
        } else {
          if (typeof l != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!a._owner)
            throw new Error("Element ref was specified as a string (" + l + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return l;
    }
    function hC(e, t) {
      var a = Object.prototype.toString.call(t);
      throw new Error("Objects are not valid as a React child (found: " + (a === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : a) + "). If you meant to render a collection of children, use an array instead.");
    }
    function pC(e) {
      {
        var t = nt(e) || "Component";
        if (ox[t])
          return;
        ox[t] = !0, y("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function BL(e) {
      var t = e._payload, a = e._init;
      return a(t);
    }
    function QL(e) {
      function t(V, G) {
        if (e) {
          var H = V.deletions;
          H === null ? (V.deletions = [G], V.flags |= pa) : H.push(G);
        }
      }
      function a(V, G) {
        if (!e)
          return null;
        for (var H = G; H !== null; )
          t(V, H), H = H.sibling;
        return null;
      }
      function l(V, G) {
        for (var H = /* @__PURE__ */ new Map(), ae = G; ae !== null; )
          ae.key !== null ? H.set(ae.key, ae) : H.set(ae.index, ae), ae = ae.sibling;
        return H;
      }
      function c(V, G) {
        var H = uh(V, G);
        return H.index = 0, H.sibling = null, H;
      }
      function m(V, G, H) {
        if (V.index = H, !e)
          return V.flags |= ms, G;
        var ae = V.alternate;
        if (ae !== null) {
          var Ee = ae.index;
          return Ee < G ? (V.flags |= Nn, G) : Ee;
        } else
          return V.flags |= Nn, G;
      }
      function T(V) {
        return e && V.alternate === null && (V.flags |= Nn), V;
      }
      function E(V, G, H, ae) {
        if (G === null || G.tag !== ne) {
          var Ee = iR(H, V.mode, ae);
          return Ee.return = V, Ee;
        } else {
          var Se = c(G, H);
          return Se.return = V, Se;
        }
      }
      function C(V, G, H, ae) {
        var Ee = H.type;
        if (Ee === ac)
          return M(V, G, H.props.children, ae, H.key);
        if (G !== null && (G.elementType === Ee || // Keep this check inline so it only runs on the false path:
        XO(G, H) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Ee == "object" && Ee !== null && Ee.$$typeof === qi && BL(Ee) === G.type)) {
          var Se = c(G, H.props);
          return Se.ref = gS(V, G, H), Se.return = V, Se._debugSource = H._source, Se._debugOwner = H._owner, Se;
        }
        var Qe = nR(H, V.mode, ae);
        return Qe.ref = gS(V, G, H), Qe.return = V, Qe;
      }
      function x(V, G, H, ae) {
        if (G === null || G.tag !== B || G.stateNode.containerInfo !== H.containerInfo || G.stateNode.implementation !== H.implementation) {
          var Ee = rR(H, V.mode, ae);
          return Ee.return = V, Ee;
        } else {
          var Se = c(G, H.children || []);
          return Se.return = V, Se;
        }
      }
      function M(V, G, H, ae, Ee) {
        if (G === null || G.tag !== ce) {
          var Se = Zc(H, V.mode, ae, Ee);
          return Se.return = V, Se;
        } else {
          var Qe = c(G, H);
          return Qe.return = V, Qe;
        }
      }
      function z(V, G, H) {
        if (typeof G == "string" && G !== "" || typeof G == "number") {
          var ae = iR("" + G, V.mode, H);
          return ae.return = V, ae;
        }
        if (typeof G == "object" && G !== null) {
          switch (G.$$typeof) {
            case xl: {
              var Ee = nR(G, V.mode, H);
              return Ee.ref = gS(V, null, G), Ee.return = V, Ee;
            }
            case Fa: {
              var Se = rR(G, V.mode, H);
              return Se.return = V, Se;
            }
            case qi: {
              var Qe = G._payload, et = G._init;
              return z(V, et(Qe), H);
            }
          }
          if (Di(G) || sn(G)) {
            var tn = Zc(G, V.mode, H, null);
            return tn.return = V, tn;
          }
          hC(V, G);
        }
        return typeof G == "function" && pC(V), null;
      }
      function N(V, G, H, ae) {
        var Ee = G !== null ? G.key : null;
        if (typeof H == "string" && H !== "" || typeof H == "number")
          return Ee !== null ? null : E(V, G, "" + H, ae);
        if (typeof H == "object" && H !== null) {
          switch (H.$$typeof) {
            case xl:
              return H.key === Ee ? C(V, G, H, ae) : null;
            case Fa:
              return H.key === Ee ? x(V, G, H, ae) : null;
            case qi: {
              var Se = H._payload, Qe = H._init;
              return N(V, G, Qe(Se), ae);
            }
          }
          if (Di(H) || sn(H))
            return Ee !== null ? null : M(V, G, H, ae, null);
          hC(V, H);
        }
        return typeof H == "function" && pC(V), null;
      }
      function q(V, G, H, ae, Ee) {
        if (typeof ae == "string" && ae !== "" || typeof ae == "number") {
          var Se = V.get(H) || null;
          return E(G, Se, "" + ae, Ee);
        }
        if (typeof ae == "object" && ae !== null) {
          switch (ae.$$typeof) {
            case xl: {
              var Qe = V.get(ae.key === null ? H : ae.key) || null;
              return C(G, Qe, ae, Ee);
            }
            case Fa: {
              var et = V.get(ae.key === null ? H : ae.key) || null;
              return x(G, et, ae, Ee);
            }
            case qi:
              var tn = ae._payload, Vt = ae._init;
              return q(V, G, H, Vt(tn), Ee);
          }
          if (Di(ae) || sn(ae)) {
            var fi = V.get(H) || null;
            return M(G, fi, ae, Ee, null);
          }
          hC(G, ae);
        }
        return typeof ae == "function" && pC(G), null;
      }
      function Q(V, G, H) {
        {
          if (typeof V != "object" || V === null)
            return G;
          switch (V.$$typeof) {
            case xl:
            case Fa:
              jL(V, H);
              var ae = V.key;
              if (typeof ae != "string")
                break;
              if (G === null) {
                G = /* @__PURE__ */ new Set(), G.add(ae);
                break;
              }
              if (!G.has(ae)) {
                G.add(ae);
                break;
              }
              y("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", ae);
              break;
            case qi:
              var Ee = V._payload, Se = V._init;
              Q(Se(Ee), G, H);
              break;
          }
        }
        return G;
      }
      function Y(V, G, H, ae) {
        for (var Ee = null, Se = 0; Se < H.length; Se++) {
          var Qe = H[Se];
          Ee = Q(Qe, Ee, V);
        }
        for (var et = null, tn = null, Vt = G, fi = 0, Ht = 0, ti = null; Vt !== null && Ht < H.length; Ht++) {
          Vt.index > Ht ? (ti = Vt, Vt = null) : ti = Vt.sibling;
          var zr = N(V, Vt, H[Ht], ae);
          if (zr === null) {
            Vt === null && (Vt = ti);
            break;
          }
          e && Vt && zr.alternate === null && t(V, Vt), fi = m(zr, fi, Ht), tn === null ? et = zr : tn.sibling = zr, tn = zr, Vt = ti;
        }
        if (Ht === H.length) {
          if (a(V, Vt), or()) {
            var mr = Ht;
            Kf(V, mr);
          }
          return et;
        }
        if (Vt === null) {
          for (; Ht < H.length; Ht++) {
            var Za = z(V, H[Ht], ae);
            Za !== null && (fi = m(Za, fi, Ht), tn === null ? et = Za : tn.sibling = Za, tn = Za);
          }
          if (or()) {
            var ta = Ht;
            Kf(V, ta);
          }
          return et;
        }
        for (var na = l(V, Vt); Ht < H.length; Ht++) {
          var Fr = q(na, V, Ht, H[Ht], ae);
          Fr !== null && (e && Fr.alternate !== null && na.delete(Fr.key === null ? Ht : Fr.key), fi = m(Fr, fi, Ht), tn === null ? et = Fr : tn.sibling = Fr, tn = Fr);
        }
        if (e && na.forEach(function(iv) {
          return t(V, iv);
        }), or()) {
          var ku = Ht;
          Kf(V, ku);
        }
        return et;
      }
      function ve(V, G, H, ae) {
        var Ee = sn(H);
        if (typeof Ee != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          H[Symbol.toStringTag] === "Generator" && (ax || y("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), ax = !0), H.entries === Ee && (rx || y("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), rx = !0);
          var Se = Ee.call(H);
          if (Se)
            for (var Qe = null, et = Se.next(); !et.done; et = Se.next()) {
              var tn = et.value;
              Qe = Q(tn, Qe, V);
            }
        }
        var Vt = Ee.call(H);
        if (Vt == null)
          throw new Error("An iterable object provided no iterator.");
        for (var fi = null, Ht = null, ti = G, zr = 0, mr = 0, Za = null, ta = Vt.next(); ti !== null && !ta.done; mr++, ta = Vt.next()) {
          ti.index > mr ? (Za = ti, ti = null) : Za = ti.sibling;
          var na = N(V, ti, ta.value, ae);
          if (na === null) {
            ti === null && (ti = Za);
            break;
          }
          e && ti && na.alternate === null && t(V, ti), zr = m(na, zr, mr), Ht === null ? fi = na : Ht.sibling = na, Ht = na, ti = Za;
        }
        if (ta.done) {
          if (a(V, ti), or()) {
            var Fr = mr;
            Kf(V, Fr);
          }
          return fi;
        }
        if (ti === null) {
          for (; !ta.done; mr++, ta = Vt.next()) {
            var ku = z(V, ta.value, ae);
            ku !== null && (zr = m(ku, zr, mr), Ht === null ? fi = ku : Ht.sibling = ku, Ht = ku);
          }
          if (or()) {
            var iv = mr;
            Kf(V, iv);
          }
          return fi;
        }
        for (var KS = l(V, ti); !ta.done; mr++, ta = Vt.next()) {
          var ao = q(KS, V, mr, ta.value, ae);
          ao !== null && (e && ao.alternate !== null && KS.delete(ao.key === null ? mr : ao.key), zr = m(ao, zr, mr), Ht === null ? fi = ao : Ht.sibling = ao, Ht = ao);
        }
        if (e && KS.forEach(function(Cj) {
          return t(V, Cj);
        }), or()) {
          var Ej = mr;
          Kf(V, Ej);
        }
        return fi;
      }
      function Ue(V, G, H, ae) {
        if (G !== null && G.tag === ne) {
          a(V, G.sibling);
          var Ee = c(G, H);
          return Ee.return = V, Ee;
        }
        a(V, G);
        var Se = iR(H, V.mode, ae);
        return Se.return = V, Se;
      }
      function Me(V, G, H, ae) {
        for (var Ee = H.key, Se = G; Se !== null; ) {
          if (Se.key === Ee) {
            var Qe = H.type;
            if (Qe === ac) {
              if (Se.tag === ce) {
                a(V, Se.sibling);
                var et = c(Se, H.props.children);
                return et.return = V, et._debugSource = H._source, et._debugOwner = H._owner, et;
              }
            } else if (Se.elementType === Qe || // Keep this check inline so it only runs on the false path:
            XO(Se, H) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Qe == "object" && Qe !== null && Qe.$$typeof === qi && BL(Qe) === Se.type) {
              a(V, Se.sibling);
              var tn = c(Se, H.props);
              return tn.ref = gS(V, Se, H), tn.return = V, tn._debugSource = H._source, tn._debugOwner = H._owner, tn;
            }
            a(V, Se);
            break;
          } else
            t(V, Se);
          Se = Se.sibling;
        }
        if (H.type === ac) {
          var Vt = Zc(H.props.children, V.mode, ae, H.key);
          return Vt.return = V, Vt;
        } else {
          var fi = nR(H, V.mode, ae);
          return fi.ref = gS(V, G, H), fi.return = V, fi;
        }
      }
      function kt(V, G, H, ae) {
        for (var Ee = H.key, Se = G; Se !== null; ) {
          if (Se.key === Ee)
            if (Se.tag === B && Se.stateNode.containerInfo === H.containerInfo && Se.stateNode.implementation === H.implementation) {
              a(V, Se.sibling);
              var Qe = c(Se, H.children || []);
              return Qe.return = V, Qe;
            } else {
              a(V, Se);
              break;
            }
          else
            t(V, Se);
          Se = Se.sibling;
        }
        var et = rR(H, V.mode, ae);
        return et.return = V, et;
      }
      function pt(V, G, H, ae) {
        var Ee = typeof H == "object" && H !== null && H.type === ac && H.key === null;
        if (Ee && (H = H.props.children), typeof H == "object" && H !== null) {
          switch (H.$$typeof) {
            case xl:
              return T(Me(V, G, H, ae));
            case Fa:
              return T(kt(V, G, H, ae));
            case qi:
              var Se = H._payload, Qe = H._init;
              return pt(V, G, Qe(Se), ae);
          }
          if (Di(H))
            return Y(V, G, H, ae);
          if (sn(H))
            return ve(V, G, H, ae);
          hC(V, H);
        }
        return typeof H == "string" && H !== "" || typeof H == "number" ? T(Ue(V, G, "" + H, ae)) : (typeof H == "function" && pC(V), a(V, G));
      }
      return pt;
    }
    var Fm = QL(!0), YL = QL(!1);
    function Z3(e, t) {
      if (e !== null && t.child !== e.child)
        throw new Error("Resuming work not yet implemented.");
      if (t.child !== null) {
        var a = t.child, l = uh(a, a.pendingProps);
        for (t.child = l, l.return = t; a.sibling !== null; )
          a = a.sibling, l = l.sibling = uh(a, a.pendingProps), l.return = t;
        l.sibling = null;
      }
    }
    function J3(e, t) {
      for (var a = e.child; a !== null; )
        Vq(a, t), a = a.sibling;
    }
    var ux = zc(null), cx;
    cx = {};
    var mC = null, Vm = null, dx = null, vC = !1;
    function yC() {
      mC = null, Vm = null, dx = null, vC = !1;
    }
    function GL() {
      vC = !0;
    }
    function WL() {
      vC = !1;
    }
    function KL(e, t, a) {
      Nr(ux, t._currentValue, e), t._currentValue = a, t._currentRenderer !== void 0 && t._currentRenderer !== null && t._currentRenderer !== cx && y("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), t._currentRenderer = cx;
    }
    function fx(e, t) {
      var a = ux.current;
      _r(ux, t), e._currentValue = a;
    }
    function hx(e, t, a) {
      for (var l = e; l !== null; ) {
        var c = l.alternate;
        if (ou(l.childLanes, t) ? c !== null && !ou(c.childLanes, t) && (c.childLanes = it(c.childLanes, t)) : (l.childLanes = it(l.childLanes, t), c !== null && (c.childLanes = it(c.childLanes, t))), l === a)
          break;
        l = l.return;
      }
      l !== a && y("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function eI(e, t, a) {
      tI(e, t, a);
    }
    function tI(e, t, a) {
      var l = e.child;
      for (l !== null && (l.return = e); l !== null; ) {
        var c = void 0, m = l.dependencies;
        if (m !== null) {
          c = l.child;
          for (var T = m.firstContext; T !== null; ) {
            if (T.context === t) {
              if (l.tag === $) {
                var E = Rf(a), C = Su(ln, E);
                C.tag = SC;
                var x = l.updateQueue;
                if (x !== null) {
                  var M = x.shared, z = M.pending;
                  z === null ? C.next = C : (C.next = z.next, z.next = C), M.pending = C;
                }
              }
              l.lanes = it(l.lanes, a);
              var N = l.alternate;
              N !== null && (N.lanes = it(N.lanes, a)), hx(l.return, a, e), m.lanes = it(m.lanes, a);
              break;
            }
            T = T.next;
          }
        } else if (l.tag === $t)
          c = l.type === e.type ? null : l.child;
        else if (l.tag === ft) {
          var q = l.return;
          if (q === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          q.lanes = it(q.lanes, a);
          var Q = q.alternate;
          Q !== null && (Q.lanes = it(Q.lanes, a)), hx(q, a, e), c = l.sibling;
        } else
          c = l.child;
        if (c !== null)
          c.return = l;
        else
          for (c = l; c !== null; ) {
            if (c === e) {
              c = null;
              break;
            }
            var Y = c.sibling;
            if (Y !== null) {
              Y.return = c.return, c = Y;
              break;
            }
            c = c.return;
          }
        l = c;
      }
    }
    function Hm(e, t) {
      mC = e, Vm = null, dx = null;
      var a = e.dependencies;
      if (a !== null) {
        var l = a.firstContext;
        l !== null && ($r(a.lanes, t) && AS(), a.firstContext = null);
      }
    }
    function Ti(e) {
      vC && y("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var t = e._currentValue;
      if (dx !== e) {
        var a = {
          context: e,
          memoizedValue: t,
          next: null
        };
        if (Vm === null) {
          if (mC === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Vm = a, mC.dependencies = {
            lanes: ee,
            firstContext: a
          };
        } else
          Vm = Vm.next = a;
      }
      return t;
    }
    var th = null;
    function px(e) {
      th === null ? th = [e] : th.push(e);
    }
    function nI() {
      if (th !== null) {
        for (var e = 0; e < th.length; e++) {
          var t = th[e], a = t.interleaved;
          if (a !== null) {
            t.interleaved = null;
            var l = a.next, c = t.pending;
            if (c !== null) {
              var m = c.next;
              c.next = l, a.next = m;
            }
            t.pending = a;
          }
        }
        th = null;
      }
    }
    function XL(e, t, a, l) {
      var c = t.interleaved;
      return c === null ? (a.next = a, px(t)) : (a.next = c.next, c.next = a), t.interleaved = a, gC(e, l);
    }
    function iI(e, t, a, l) {
      var c = t.interleaved;
      c === null ? (a.next = a, px(t)) : (a.next = c.next, c.next = a), t.interleaved = a;
    }
    function rI(e, t, a, l) {
      var c = t.interleaved;
      return c === null ? (a.next = a, px(t)) : (a.next = c.next, c.next = a), t.interleaved = a, gC(e, l);
    }
    function ba(e, t) {
      return gC(e, t);
    }
    var aI = gC;
    function gC(e, t) {
      e.lanes = it(e.lanes, t);
      var a = e.alternate;
      a !== null && (a.lanes = it(a.lanes, t)), a === null && (e.flags & (Nn | ma)) !== Pe && YO(e);
      for (var l = e, c = e.return; c !== null; )
        c.childLanes = it(c.childLanes, t), a = c.alternate, a !== null ? a.childLanes = it(a.childLanes, t) : (c.flags & (Nn | ma)) !== Pe && YO(e), l = c, c = c.return;
      if (l.tag === A) {
        var m = l.stateNode;
        return m;
      } else
        return null;
    }
    var ZL = 0, JL = 1, SC = 2, mx = 3, TC = !1, vx, wC;
    vx = !1, wC = null;
    function yx(e) {
      var t = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: ee
        },
        effects: null
      };
      e.updateQueue = t;
    }
    function e$(e, t) {
      var a = t.updateQueue, l = e.updateQueue;
      if (a === l) {
        var c = {
          baseState: l.baseState,
          firstBaseUpdate: l.firstBaseUpdate,
          lastBaseUpdate: l.lastBaseUpdate,
          shared: l.shared,
          effects: l.effects
        };
        t.updateQueue = c;
      }
    }
    function Su(e, t) {
      var a = {
        eventTime: e,
        lane: t,
        tag: ZL,
        payload: null,
        callback: null,
        next: null
      };
      return a;
    }
    function Ic(e, t, a) {
      var l = e.updateQueue;
      if (l === null)
        return null;
      var c = l.shared;
      if (wC === c && !vx && (y("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), vx = !0), iq()) {
        var m = c.pending;
        return m === null ? t.next = t : (t.next = m.next, m.next = t), c.pending = t, aI(e, a);
      } else
        return rI(e, c, t, a);
    }
    function EC(e, t, a) {
      var l = t.updateQueue;
      if (l !== null) {
        var c = l.shared;
        if ($g(a)) {
          var m = c.lanes;
          m = Ag(m, e.pendingLanes);
          var T = it(m, a);
          c.lanes = T, fm(e, T);
        }
      }
    }
    function gx(e, t) {
      var a = e.updateQueue, l = e.alternate;
      if (l !== null) {
        var c = l.updateQueue;
        if (a === c) {
          var m = null, T = null, E = a.firstBaseUpdate;
          if (E !== null) {
            var C = E;
            do {
              var x = {
                eventTime: C.eventTime,
                lane: C.lane,
                tag: C.tag,
                payload: C.payload,
                callback: C.callback,
                next: null
              };
              T === null ? m = T = x : (T.next = x, T = x), C = C.next;
            } while (C !== null);
            T === null ? m = T = t : (T.next = t, T = t);
          } else
            m = T = t;
          a = {
            baseState: c.baseState,
            firstBaseUpdate: m,
            lastBaseUpdate: T,
            shared: c.shared,
            effects: c.effects
          }, e.updateQueue = a;
          return;
        }
      }
      var M = a.lastBaseUpdate;
      M === null ? a.firstBaseUpdate = t : M.next = t, a.lastBaseUpdate = t;
    }
    function sI(e, t, a, l, c, m) {
      switch (a.tag) {
        case JL: {
          var T = a.payload;
          if (typeof T == "function") {
            GL();
            var E = T.call(m, l, c);
            {
              if (e.mode & Jt) {
                Cn(!0);
                try {
                  T.call(m, l, c);
                } finally {
                  Cn(!1);
                }
              }
              WL();
            }
            return E;
          }
          return T;
        }
        case mx:
          e.flags = e.flags & -65537 | Oe;
        // Intentional fallthrough
        case ZL: {
          var C = a.payload, x;
          if (typeof C == "function") {
            GL(), x = C.call(m, l, c);
            {
              if (e.mode & Jt) {
                Cn(!0);
                try {
                  C.call(m, l, c);
                } finally {
                  Cn(!1);
                }
              }
              WL();
            }
          } else
            x = C;
          return x == null ? l : gt({}, l, x);
        }
        case SC:
          return TC = !0, l;
      }
      return l;
    }
    function CC(e, t, a, l) {
      var c = e.updateQueue;
      TC = !1, wC = c.shared;
      var m = c.firstBaseUpdate, T = c.lastBaseUpdate, E = c.shared.pending;
      if (E !== null) {
        c.shared.pending = null;
        var C = E, x = C.next;
        C.next = null, T === null ? m = x : T.next = x, T = C;
        var M = e.alternate;
        if (M !== null) {
          var z = M.updateQueue, N = z.lastBaseUpdate;
          N !== T && (N === null ? z.firstBaseUpdate = x : N.next = x, z.lastBaseUpdate = C);
        }
      }
      if (m !== null) {
        var q = c.baseState, Q = ee, Y = null, ve = null, Ue = null, Me = m;
        do {
          var kt = Me.lane, pt = Me.eventTime;
          if (ou(l, kt)) {
            if (Ue !== null) {
              var G = {
                eventTime: pt,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Ot,
                tag: Me.tag,
                payload: Me.payload,
                callback: Me.callback,
                next: null
              };
              Ue = Ue.next = G;
            }
            q = sI(e, c, Me, q, t, a);
            var H = Me.callback;
            if (H !== null && // If the update was already committed, we should not queue its
            // callback again.
            Me.lane !== Ot) {
              e.flags |= un;
              var ae = c.effects;
              ae === null ? c.effects = [Me] : ae.push(Me);
            }
          } else {
            var V = {
              eventTime: pt,
              lane: kt,
              tag: Me.tag,
              payload: Me.payload,
              callback: Me.callback,
              next: null
            };
            Ue === null ? (ve = Ue = V, Y = q) : Ue = Ue.next = V, Q = it(Q, kt);
          }
          if (Me = Me.next, Me === null) {
            if (E = c.shared.pending, E === null)
              break;
            var Ee = E, Se = Ee.next;
            Ee.next = null, Me = Se, c.lastBaseUpdate = Ee, c.shared.pending = null;
          }
        } while (!0);
        Ue === null && (Y = q), c.baseState = Y, c.firstBaseUpdate = ve, c.lastBaseUpdate = Ue;
        var Qe = c.shared.interleaved;
        if (Qe !== null) {
          var et = Qe;
          do
            Q = it(Q, et.lane), et = et.next;
          while (et !== Qe);
        } else m === null && (c.shared.lanes = ee);
        BS(Q), e.lanes = Q, e.memoizedState = q;
      }
      wC = null;
    }
    function lI(e, t) {
      if (typeof e != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + e));
      e.call(t);
    }
    function t$() {
      TC = !1;
    }
    function bC() {
      return TC;
    }
    function n$(e, t, a) {
      var l = t.effects;
      if (t.effects = null, l !== null)
        for (var c = 0; c < l.length; c++) {
          var m = l[c], T = m.callback;
          T !== null && (m.callback = null, lI(T, a));
        }
    }
    var SS = {}, qc = zc(SS), TS = zc(SS), kC = zc(SS);
    function xC(e) {
      if (e === SS)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return e;
    }
    function i$() {
      var e = xC(kC.current);
      return e;
    }
    function Sx(e, t) {
      Nr(kC, t, e), Nr(TS, e, e), Nr(qc, SS, e);
      var a = bH(t);
      _r(qc, e), Nr(qc, a, e);
    }
    function Im(e) {
      _r(qc, e), _r(TS, e), _r(kC, e);
    }
    function Tx() {
      var e = xC(qc.current);
      return e;
    }
    function r$(e) {
      xC(kC.current);
      var t = xC(qc.current), a = kH(t, e.type);
      t !== a && (Nr(TS, e, e), Nr(qc, a, e));
    }
    function wx(e) {
      TS.current === e && (_r(qc, e), _r(TS, e));
    }
    var oI = 0, a$ = 1, s$ = 1, wS = 2, sl = zc(oI);
    function Ex(e, t) {
      return (e & t) !== 0;
    }
    function qm(e) {
      return e & a$;
    }
    function Cx(e, t) {
      return e & a$ | t;
    }
    function uI(e, t) {
      return e | t;
    }
    function jc(e, t) {
      Nr(sl, t, e);
    }
    function jm(e) {
      _r(sl, e);
    }
    function cI(e, t) {
      var a = e.memoizedState;
      return a !== null ? a.dehydrated !== null : (e.memoizedProps, !0);
    }
    function RC(e) {
      for (var t = e; t !== null; ) {
        if (t.tag === Ye) {
          var a = t.memoizedState;
          if (a !== null) {
            var l = a.dehydrated;
            if (l === null || CL(l) || Hk(l))
              return t;
          }
        } else if (t.tag === Kt && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        t.memoizedProps.revealOrder !== void 0) {
          var c = (t.flags & Oe) !== Pe;
          if (c)
            return t;
        } else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e)
          return null;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    var ka = (
      /*   */
      0
    ), Ai = (
      /* */
      1
    ), Zl = (
      /*  */
      2
    ), Pi = (
      /*    */
      4
    ), ur = (
      /*   */
      8
    ), bx = [];
    function kx() {
      for (var e = 0; e < bx.length; e++) {
        var t = bx[e];
        t._workInProgressVersionPrimary = null;
      }
      bx.length = 0;
    }
    function dI(e, t) {
      var a = t._getVersion, l = a(t._source);
      e.mutableSourceEagerHydrationData == null ? e.mutableSourceEagerHydrationData = [t, l] : e.mutableSourceEagerHydrationData.push(t, l);
    }
    var we = n.ReactCurrentDispatcher, ES = n.ReactCurrentBatchConfig, xx, Bm;
    xx = /* @__PURE__ */ new Set();
    var nh = ee, en = null, _i = null, Ni = null, DC = !1, CS = !1, bS = 0, fI = 0, hI = 25, X = null, Ds = null, Bc = -1, Rx = !1;
    function Gt() {
      {
        var e = X;
        Ds === null ? Ds = [e] : Ds.push(e);
      }
    }
    function fe() {
      {
        var e = X;
        Ds !== null && (Bc++, Ds[Bc] !== e && pI(e));
      }
    }
    function Qm(e) {
      e != null && !Di(e) && y("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", X, typeof e);
    }
    function pI(e) {
      {
        var t = nt(en);
        if (!xx.has(t) && (xx.add(t), Ds !== null)) {
          for (var a = "", l = 30, c = 0; c <= Bc; c++) {
            for (var m = Ds[c], T = c === Bc ? e : m, E = c + 1 + ". " + m; E.length < l; )
              E += " ";
            E += T + `
`, a += E;
          }
          y(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, t, a);
        }
      }
    }
    function Ur() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function Dx(e, t) {
      if (Rx)
        return !1;
      if (t === null)
        return y("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", X), !1;
      e.length !== t.length && y(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, X, "[" + t.join(", ") + "]", "[" + e.join(", ") + "]");
      for (var a = 0; a < t.length && a < e.length; a++)
        if (!ge(e[a], t[a]))
          return !1;
      return !0;
    }
    function Ym(e, t, a, l, c, m) {
      nh = m, en = t, Ds = e !== null ? e._debugHookTypes : null, Bc = -1, Rx = e !== null && e.type !== t.type, t.memoizedState = null, t.updateQueue = null, t.lanes = ee, e !== null && e.memoizedState !== null ? we.current = D$ : Ds !== null ? we.current = R$ : we.current = x$;
      var T = a(l, c);
      if (CS) {
        var E = 0;
        do {
          if (CS = !1, bS = 0, E >= hI)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          E += 1, Rx = !1, _i = null, Ni = null, t.updateQueue = null, Bc = -1, we.current = M$, T = a(l, c);
        } while (CS);
      }
      we.current = HC, t._debugHookTypes = Ds;
      var C = _i !== null && _i.next !== null;
      if (nh = ee, en = null, _i = null, Ni = null, X = null, Ds = null, Bc = -1, e !== null && (e.flags & Wn) !== (t.flags & Wn) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (e.mode & dt) !== _e && y("Internal React error: Expected static flag was missing. Please notify the React team."), DC = !1, C)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return T;
    }
    function Gm() {
      var e = bS !== 0;
      return bS = 0, e;
    }
    function l$(e, t, a) {
      t.updateQueue = e.updateQueue, (t.mode & zt) !== _e ? t.flags &= -50333701 : t.flags &= -2053, e.lanes = Df(e.lanes, a);
    }
    function o$() {
      if (we.current = HC, DC) {
        for (var e = en.memoizedState; e !== null; ) {
          var t = e.queue;
          t !== null && (t.pending = null), e = e.next;
        }
        DC = !1;
      }
      nh = ee, en = null, _i = null, Ni = null, Ds = null, Bc = -1, X = null, w$ = !1, CS = !1, bS = 0;
    }
    function Jl() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Ni === null ? en.memoizedState = Ni = e : Ni = Ni.next = e, Ni;
    }
    function Ms() {
      var e;
      if (_i === null) {
        var t = en.alternate;
        t !== null ? e = t.memoizedState : e = null;
      } else
        e = _i.next;
      var a;
      if (Ni === null ? a = en.memoizedState : a = Ni.next, a !== null)
        Ni = a, a = Ni.next, _i = e;
      else {
        if (e === null)
          throw new Error("Rendered more hooks than during the previous render.");
        _i = e;
        var l = {
          memoizedState: _i.memoizedState,
          baseState: _i.baseState,
          baseQueue: _i.baseQueue,
          queue: _i.queue,
          next: null
        };
        Ni === null ? en.memoizedState = Ni = l : Ni = Ni.next = l;
      }
      return Ni;
    }
    function u$() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function Mx(e, t) {
      return typeof t == "function" ? t(e) : t;
    }
    function Lx(e, t, a) {
      var l = Jl(), c;
      a !== void 0 ? c = a(t) : c = t, l.memoizedState = l.baseState = c;
      var m = {
        pending: null,
        interleaved: null,
        lanes: ee,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: c
      };
      l.queue = m;
      var T = m.dispatch = gI.bind(null, en, m);
      return [l.memoizedState, T];
    }
    function $x(e, t, a) {
      var l = Ms(), c = l.queue;
      if (c === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      c.lastRenderedReducer = e;
      var m = _i, T = m.baseQueue, E = c.pending;
      if (E !== null) {
        if (T !== null) {
          var C = T.next, x = E.next;
          T.next = x, E.next = C;
        }
        m.baseQueue !== T && y("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), m.baseQueue = T = E, c.pending = null;
      }
      if (T !== null) {
        var M = T.next, z = m.baseState, N = null, q = null, Q = null, Y = M;
        do {
          var ve = Y.lane;
          if (ou(nh, ve)) {
            if (Q !== null) {
              var Me = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Ot,
                action: Y.action,
                hasEagerState: Y.hasEagerState,
                eagerState: Y.eagerState,
                next: null
              };
              Q = Q.next = Me;
            }
            if (Y.hasEagerState)
              z = Y.eagerState;
            else {
              var kt = Y.action;
              z = e(z, kt);
            }
          } else {
            var Ue = {
              lane: ve,
              action: Y.action,
              hasEagerState: Y.hasEagerState,
              eagerState: Y.eagerState,
              next: null
            };
            Q === null ? (q = Q = Ue, N = z) : Q = Q.next = Ue, en.lanes = it(en.lanes, ve), BS(ve);
          }
          Y = Y.next;
        } while (Y !== null && Y !== M);
        Q === null ? N = z : Q.next = q, ge(z, l.memoizedState) || AS(), l.memoizedState = z, l.baseState = N, l.baseQueue = Q, c.lastRenderedState = z;
      }
      var pt = c.interleaved;
      if (pt !== null) {
        var V = pt;
        do {
          var G = V.lane;
          en.lanes = it(en.lanes, G), BS(G), V = V.next;
        } while (V !== pt);
      } else T === null && (c.lanes = ee);
      var H = c.dispatch;
      return [l.memoizedState, H];
    }
    function Ox(e, t, a) {
      var l = Ms(), c = l.queue;
      if (c === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      c.lastRenderedReducer = e;
      var m = c.dispatch, T = c.pending, E = l.memoizedState;
      if (T !== null) {
        c.pending = null;
        var C = T.next, x = C;
        do {
          var M = x.action;
          E = e(E, M), x = x.next;
        } while (x !== C);
        ge(E, l.memoizedState) || AS(), l.memoizedState = E, l.baseQueue === null && (l.baseState = E), c.lastRenderedState = E;
      }
      return [E, m];
    }
    function mQ(e, t, a) {
    }
    function vQ(e, t, a) {
    }
    function Ax(e, t, a) {
      var l = en, c = Jl(), m, T = or();
      if (T) {
        if (a === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        m = a(), Bm || m !== a() && (y("The result of getServerSnapshot should be cached to avoid an infinite loop"), Bm = !0);
      } else {
        if (m = t(), !Bm) {
          var E = t();
          ge(m, E) || (y("The result of getSnapshot should be cached to avoid an infinite loop"), Bm = !0);
        }
        var C = sb();
        if (C === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        cm(C, nh) || c$(l, t, m);
      }
      c.memoizedState = m;
      var x = {
        value: m,
        getSnapshot: t
      };
      return c.queue = x, AC(f$.bind(null, l, x, e), [e]), l.flags |= xr, kS(Ai | ur, d$.bind(null, l, x, m, t), void 0, null), m;
    }
    function MC(e, t, a) {
      var l = en, c = Ms(), m = t();
      if (!Bm) {
        var T = t();
        ge(m, T) || (y("The result of getSnapshot should be cached to avoid an infinite loop"), Bm = !0);
      }
      var E = c.memoizedState, C = !ge(E, m);
      C && (c.memoizedState = m, AS());
      var x = c.queue;
      if (RS(f$.bind(null, l, x, e), [e]), x.getSnapshot !== t || C || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Ni !== null && Ni.memoizedState.tag & Ai) {
        l.flags |= xr, kS(Ai | ur, d$.bind(null, l, x, m, t), void 0, null);
        var M = sb();
        if (M === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        cm(M, nh) || c$(l, t, m);
      }
      return m;
    }
    function c$(e, t, a) {
      e.flags |= Ec;
      var l = {
        getSnapshot: t,
        value: a
      }, c = en.updateQueue;
      if (c === null)
        c = u$(), en.updateQueue = c, c.stores = [l];
      else {
        var m = c.stores;
        m === null ? c.stores = [l] : m.push(l);
      }
    }
    function d$(e, t, a, l) {
      t.value = a, t.getSnapshot = l, h$(t) && p$(e);
    }
    function f$(e, t, a) {
      var l = function() {
        h$(t) && p$(e);
      };
      return a(l);
    }
    function h$(e) {
      var t = e.getSnapshot, a = e.value;
      try {
        var l = t();
        return !ge(a, l);
      } catch {
        return !0;
      }
    }
    function p$(e) {
      var t = ba(e, je);
      t !== null && Vi(t, e, je, ln);
    }
    function LC(e) {
      var t = Jl();
      typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e;
      var a = {
        pending: null,
        interleaved: null,
        lanes: ee,
        dispatch: null,
        lastRenderedReducer: Mx,
        lastRenderedState: e
      };
      t.queue = a;
      var l = a.dispatch = SI.bind(null, en, a);
      return [t.memoizedState, l];
    }
    function Px(e) {
      return $x(Mx);
    }
    function _x(e) {
      return Ox(Mx);
    }
    function kS(e, t, a, l) {
      var c = {
        tag: e,
        create: t,
        destroy: a,
        deps: l,
        // Circular
        next: null
      }, m = en.updateQueue;
      if (m === null)
        m = u$(), en.updateQueue = m, m.lastEffect = c.next = c;
      else {
        var T = m.lastEffect;
        if (T === null)
          m.lastEffect = c.next = c;
        else {
          var E = T.next;
          T.next = c, c.next = E, m.lastEffect = c;
        }
      }
      return c;
    }
    function Nx(e) {
      var t = Jl();
      {
        var a = {
          current: e
        };
        return t.memoizedState = a, a;
      }
    }
    function $C(e) {
      var t = Ms();
      return t.memoizedState;
    }
    function xS(e, t, a, l) {
      var c = Jl(), m = l === void 0 ? null : l;
      en.flags |= e, c.memoizedState = kS(Ai | t, a, void 0, m);
    }
    function OC(e, t, a, l) {
      var c = Ms(), m = l === void 0 ? null : l, T = void 0;
      if (_i !== null) {
        var E = _i.memoizedState;
        if (T = E.destroy, m !== null) {
          var C = E.deps;
          if (Dx(m, C)) {
            c.memoizedState = kS(t, a, T, m);
            return;
          }
        }
      }
      en.flags |= e, c.memoizedState = kS(Ai | t, a, T, m);
    }
    function AC(e, t) {
      return (en.mode & zt) !== _e ? xS(vs | xr | Up, ur, e, t) : xS(xr | Up, ur, e, t);
    }
    function RS(e, t) {
      return OC(xr, ur, e, t);
    }
    function Ux(e, t) {
      return xS(Et, Zl, e, t);
    }
    function PC(e, t) {
      return OC(Et, Zl, e, t);
    }
    function zx(e, t) {
      var a = Et;
      return a |= Gs, (en.mode & zt) !== _e && (a |= Pl), xS(a, Pi, e, t);
    }
    function _C(e, t) {
      return OC(Et, Pi, e, t);
    }
    function m$(e, t) {
      if (typeof t == "function") {
        var a = t, l = e();
        return a(l), function() {
          a(null);
        };
      } else if (t != null) {
        var c = t;
        c.hasOwnProperty("current") || y("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(c).join(", ") + "}");
        var m = e();
        return c.current = m, function() {
          c.current = null;
        };
      }
    }
    function Fx(e, t, a) {
      typeof t != "function" && y("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var l = a != null ? a.concat([e]) : null, c = Et;
      return c |= Gs, (en.mode & zt) !== _e && (c |= Pl), xS(c, Pi, m$.bind(null, t, e), l);
    }
    function NC(e, t, a) {
      typeof t != "function" && y("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var l = a != null ? a.concat([e]) : null;
      return OC(Et, Pi, m$.bind(null, t, e), l);
    }
    function mI(e, t) {
    }
    var UC = mI;
    function Vx(e, t) {
      var a = Jl(), l = t === void 0 ? null : t;
      return a.memoizedState = [e, l], e;
    }
    function zC(e, t) {
      var a = Ms(), l = t === void 0 ? null : t, c = a.memoizedState;
      if (c !== null && l !== null) {
        var m = c[1];
        if (Dx(l, m))
          return c[0];
      }
      return a.memoizedState = [e, l], e;
    }
    function Hx(e, t) {
      var a = Jl(), l = t === void 0 ? null : t, c = e();
      return a.memoizedState = [c, l], c;
    }
    function FC(e, t) {
      var a = Ms(), l = t === void 0 ? null : t, c = a.memoizedState;
      if (c !== null && l !== null) {
        var m = c[1];
        if (Dx(l, m))
          return c[0];
      }
      var T = e();
      return a.memoizedState = [T, l], T;
    }
    function Ix(e) {
      var t = Jl();
      return t.memoizedState = e, e;
    }
    function v$(e) {
      var t = Ms(), a = _i, l = a.memoizedState;
      return g$(t, l, e);
    }
    function y$(e) {
      var t = Ms();
      if (_i === null)
        return t.memoizedState = e, e;
      var a = _i.memoizedState;
      return g$(t, a, e);
    }
    function g$(e, t, a) {
      var l = !Mg(nh);
      if (l) {
        if (!ge(a, t)) {
          var c = Og();
          en.lanes = it(en.lanes, c), BS(c), e.baseState = !0;
        }
        return t;
      } else
        return e.baseState && (e.baseState = !1, AS()), e.memoizedState = a, a;
    }
    function vI(e, t, a) {
      var l = wa();
      Zn(gE(l, Ts)), e(!0);
      var c = ES.transition;
      ES.transition = {};
      var m = ES.transition;
      ES.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        e(!1), t();
      } finally {
        if (Zn(l), ES.transition = c, c === null && m._updatedFibers) {
          var T = m._updatedFibers.size;
          T > 10 && v("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), m._updatedFibers.clear();
        }
      }
    }
    function qx() {
      var e = LC(!1), t = e[0], a = e[1], l = vI.bind(null, a), c = Jl();
      return c.memoizedState = l, [t, l];
    }
    function S$() {
      var e = Px(), t = e[0], a = Ms(), l = a.memoizedState;
      return [t, l];
    }
    function T$() {
      var e = _x(), t = e[0], a = Ms(), l = a.memoizedState;
      return [t, l];
    }
    var w$ = !1;
    function yI() {
      return w$;
    }
    function jx() {
      var e = Jl(), t = sb(), a = t.identifierPrefix, l;
      if (or()) {
        var c = P3();
        l = ":" + a + "R" + c;
        var m = bS++;
        m > 0 && (l += "H" + m.toString(32)), l += ":";
      } else {
        var T = fI++;
        l = ":" + a + "r" + T.toString(32) + ":";
      }
      return e.memoizedState = l, l;
    }
    function VC() {
      var e = Ms(), t = e.memoizedState;
      return t;
    }
    function gI(e, t, a) {
      typeof arguments[3] == "function" && y("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var l = Kc(e), c = {
        lane: l,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (E$(e))
        C$(t, c);
      else {
        var m = XL(e, t, c, l);
        if (m !== null) {
          var T = ea();
          Vi(m, e, l, T), b$(m, t, l);
        }
      }
      k$(e, l);
    }
    function SI(e, t, a) {
      typeof arguments[3] == "function" && y("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var l = Kc(e), c = {
        lane: l,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (E$(e))
        C$(t, c);
      else {
        var m = e.alternate;
        if (e.lanes === ee && (m === null || m.lanes === ee)) {
          var T = t.lastRenderedReducer;
          if (T !== null) {
            var E;
            E = we.current, we.current = ll;
            try {
              var C = t.lastRenderedState, x = T(C, a);
              if (c.hasEagerState = !0, c.eagerState = x, ge(x, C)) {
                iI(e, t, c, l);
                return;
              }
            } catch {
            } finally {
              we.current = E;
            }
          }
        }
        var M = XL(e, t, c, l);
        if (M !== null) {
          var z = ea();
          Vi(M, e, l, z), b$(M, t, l);
        }
      }
      k$(e, l);
    }
    function E$(e) {
      var t = e.alternate;
      return e === en || t !== null && t === en;
    }
    function C$(e, t) {
      CS = DC = !0;
      var a = e.pending;
      a === null ? t.next = t : (t.next = a.next, a.next = t), e.pending = t;
    }
    function b$(e, t, a) {
      if ($g(a)) {
        var l = t.lanes;
        l = Ag(l, e.pendingLanes);
        var c = it(l, a);
        t.lanes = c, fm(e, c);
      }
    }
    function k$(e, t, a) {
      gf(e, t);
    }
    var HC = {
      readContext: Ti,
      useCallback: Ur,
      useContext: Ur,
      useEffect: Ur,
      useImperativeHandle: Ur,
      useInsertionEffect: Ur,
      useLayoutEffect: Ur,
      useMemo: Ur,
      useReducer: Ur,
      useRef: Ur,
      useState: Ur,
      useDebugValue: Ur,
      useDeferredValue: Ur,
      useTransition: Ur,
      useMutableSource: Ur,
      useSyncExternalStore: Ur,
      useId: Ur,
      unstable_isNewReconciler: oe
    }, x$ = null, R$ = null, D$ = null, M$ = null, eo = null, ll = null, IC = null;
    {
      var Bx = function() {
        y("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Xe = function() {
        y("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      x$ = {
        readContext: function(e) {
          return Ti(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", Gt(), Qm(t), Vx(e, t);
        },
        useContext: function(e) {
          return X = "useContext", Gt(), Ti(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", Gt(), Qm(t), AC(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", Gt(), Qm(a), Fx(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", Gt(), Qm(t), Ux(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", Gt(), Qm(t), zx(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", Gt(), Qm(t);
          var a = we.current;
          we.current = eo;
          try {
            return Hx(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", Gt();
          var l = we.current;
          we.current = eo;
          try {
            return Lx(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", Gt(), Nx(e);
        },
        useState: function(e) {
          X = "useState", Gt();
          var t = we.current;
          we.current = eo;
          try {
            return LC(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", Gt(), void 0;
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", Gt(), Ix(e);
        },
        useTransition: function() {
          return X = "useTransition", Gt(), qx();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", Gt(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", Gt(), Ax(e, t, a);
        },
        useId: function() {
          return X = "useId", Gt(), jx();
        },
        unstable_isNewReconciler: oe
      }, R$ = {
        readContext: function(e) {
          return Ti(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", fe(), Vx(e, t);
        },
        useContext: function(e) {
          return X = "useContext", fe(), Ti(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", fe(), AC(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", fe(), Fx(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", fe(), Ux(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", fe(), zx(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", fe();
          var a = we.current;
          we.current = eo;
          try {
            return Hx(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", fe();
          var l = we.current;
          we.current = eo;
          try {
            return Lx(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", fe(), Nx(e);
        },
        useState: function(e) {
          X = "useState", fe();
          var t = we.current;
          we.current = eo;
          try {
            return LC(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", fe(), void 0;
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", fe(), Ix(e);
        },
        useTransition: function() {
          return X = "useTransition", fe(), qx();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", fe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", fe(), Ax(e, t, a);
        },
        useId: function() {
          return X = "useId", fe(), jx();
        },
        unstable_isNewReconciler: oe
      }, D$ = {
        readContext: function(e) {
          return Ti(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", fe(), zC(e, t);
        },
        useContext: function(e) {
          return X = "useContext", fe(), Ti(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", fe(), RS(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", fe(), NC(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", fe(), PC(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", fe(), _C(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", fe();
          var a = we.current;
          we.current = ll;
          try {
            return FC(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", fe();
          var l = we.current;
          we.current = ll;
          try {
            return $x(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", fe(), $C();
        },
        useState: function(e) {
          X = "useState", fe();
          var t = we.current;
          we.current = ll;
          try {
            return Px(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", fe(), UC();
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", fe(), v$(e);
        },
        useTransition: function() {
          return X = "useTransition", fe(), S$();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", fe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", fe(), MC(e, t);
        },
        useId: function() {
          return X = "useId", fe(), VC();
        },
        unstable_isNewReconciler: oe
      }, M$ = {
        readContext: function(e) {
          return Ti(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", fe(), zC(e, t);
        },
        useContext: function(e) {
          return X = "useContext", fe(), Ti(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", fe(), RS(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", fe(), NC(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", fe(), PC(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", fe(), _C(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", fe();
          var a = we.current;
          we.current = IC;
          try {
            return FC(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", fe();
          var l = we.current;
          we.current = IC;
          try {
            return Ox(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", fe(), $C();
        },
        useState: function(e) {
          X = "useState", fe();
          var t = we.current;
          we.current = IC;
          try {
            return _x(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", fe(), UC();
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", fe(), y$(e);
        },
        useTransition: function() {
          return X = "useTransition", fe(), T$();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", fe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", fe(), MC(e, t);
        },
        useId: function() {
          return X = "useId", fe(), VC();
        },
        unstable_isNewReconciler: oe
      }, eo = {
        readContext: function(e) {
          return Bx(), Ti(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", Xe(), Gt(), Vx(e, t);
        },
        useContext: function(e) {
          return X = "useContext", Xe(), Gt(), Ti(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", Xe(), Gt(), AC(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", Xe(), Gt(), Fx(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", Xe(), Gt(), Ux(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", Xe(), Gt(), zx(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", Xe(), Gt();
          var a = we.current;
          we.current = eo;
          try {
            return Hx(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", Xe(), Gt();
          var l = we.current;
          we.current = eo;
          try {
            return Lx(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", Xe(), Gt(), Nx(e);
        },
        useState: function(e) {
          X = "useState", Xe(), Gt();
          var t = we.current;
          we.current = eo;
          try {
            return LC(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", Xe(), Gt(), void 0;
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", Xe(), Gt(), Ix(e);
        },
        useTransition: function() {
          return X = "useTransition", Xe(), Gt(), qx();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", Xe(), Gt(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", Xe(), Gt(), Ax(e, t, a);
        },
        useId: function() {
          return X = "useId", Xe(), Gt(), jx();
        },
        unstable_isNewReconciler: oe
      }, ll = {
        readContext: function(e) {
          return Bx(), Ti(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", Xe(), fe(), zC(e, t);
        },
        useContext: function(e) {
          return X = "useContext", Xe(), fe(), Ti(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", Xe(), fe(), RS(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", Xe(), fe(), NC(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", Xe(), fe(), PC(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", Xe(), fe(), _C(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", Xe(), fe();
          var a = we.current;
          we.current = ll;
          try {
            return FC(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", Xe(), fe();
          var l = we.current;
          we.current = ll;
          try {
            return $x(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", Xe(), fe(), $C();
        },
        useState: function(e) {
          X = "useState", Xe(), fe();
          var t = we.current;
          we.current = ll;
          try {
            return Px(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", Xe(), fe(), UC();
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", Xe(), fe(), v$(e);
        },
        useTransition: function() {
          return X = "useTransition", Xe(), fe(), S$();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", Xe(), fe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", Xe(), fe(), MC(e, t);
        },
        useId: function() {
          return X = "useId", Xe(), fe(), VC();
        },
        unstable_isNewReconciler: oe
      }, IC = {
        readContext: function(e) {
          return Bx(), Ti(e);
        },
        useCallback: function(e, t) {
          return X = "useCallback", Xe(), fe(), zC(e, t);
        },
        useContext: function(e) {
          return X = "useContext", Xe(), fe(), Ti(e);
        },
        useEffect: function(e, t) {
          return X = "useEffect", Xe(), fe(), RS(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return X = "useImperativeHandle", Xe(), fe(), NC(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return X = "useInsertionEffect", Xe(), fe(), PC(e, t);
        },
        useLayoutEffect: function(e, t) {
          return X = "useLayoutEffect", Xe(), fe(), _C(e, t);
        },
        useMemo: function(e, t) {
          X = "useMemo", Xe(), fe();
          var a = we.current;
          we.current = ll;
          try {
            return FC(e, t);
          } finally {
            we.current = a;
          }
        },
        useReducer: function(e, t, a) {
          X = "useReducer", Xe(), fe();
          var l = we.current;
          we.current = ll;
          try {
            return Ox(e, t, a);
          } finally {
            we.current = l;
          }
        },
        useRef: function(e) {
          return X = "useRef", Xe(), fe(), $C();
        },
        useState: function(e) {
          X = "useState", Xe(), fe();
          var t = we.current;
          we.current = ll;
          try {
            return _x(e);
          } finally {
            we.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return X = "useDebugValue", Xe(), fe(), UC();
        },
        useDeferredValue: function(e) {
          return X = "useDeferredValue", Xe(), fe(), y$(e);
        },
        useTransition: function() {
          return X = "useTransition", Xe(), fe(), T$();
        },
        useMutableSource: function(e, t, a) {
          return X = "useMutableSource", Xe(), fe(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return X = "useSyncExternalStore", Xe(), fe(), MC(e, t);
        },
        useId: function() {
          return X = "useId", Xe(), fe(), VC();
        },
        unstable_isNewReconciler: oe
      };
    }
    var Qc = s.unstable_now, L$ = 0, qC = -1, DS = -1, jC = -1, Qx = !1, BC = !1;
    function $$() {
      return Qx;
    }
    function TI() {
      BC = !0;
    }
    function wI() {
      Qx = !1, BC = !1;
    }
    function EI() {
      Qx = BC, BC = !1;
    }
    function O$() {
      return L$;
    }
    function A$() {
      L$ = Qc();
    }
    function Yx(e) {
      DS = Qc(), e.actualStartTime < 0 && (e.actualStartTime = Qc());
    }
    function P$(e) {
      DS = -1;
    }
    function QC(e, t) {
      if (DS >= 0) {
        var a = Qc() - DS;
        e.actualDuration += a, t && (e.selfBaseDuration = a), DS = -1;
      }
    }
    function to(e) {
      if (qC >= 0) {
        var t = Qc() - qC;
        qC = -1;
        for (var a = e.return; a !== null; ) {
          switch (a.tag) {
            case A:
              var l = a.stateNode;
              l.effectDuration += t;
              return;
            case ct:
              var c = a.stateNode;
              c.effectDuration += t;
              return;
          }
          a = a.return;
        }
      }
    }
    function Gx(e) {
      if (jC >= 0) {
        var t = Qc() - jC;
        jC = -1;
        for (var a = e.return; a !== null; ) {
          switch (a.tag) {
            case A:
              var l = a.stateNode;
              l !== null && (l.passiveEffectDuration += t);
              return;
            case ct:
              var c = a.stateNode;
              c !== null && (c.passiveEffectDuration += t);
              return;
          }
          a = a.return;
        }
      }
    }
    function no() {
      qC = Qc();
    }
    function Wx() {
      jC = Qc();
    }
    function Kx(e) {
      for (var t = e.child; t; )
        e.actualDuration += t.actualDuration, t = t.sibling;
    }
    function ol(e, t) {
      if (e && e.defaultProps) {
        var a = gt({}, t), l = e.defaultProps;
        for (var c in l)
          a[c] === void 0 && (a[c] = l[c]);
        return a;
      }
      return t;
    }
    var Xx = {}, Zx, Jx, e1, t1, n1, _$, YC, i1, r1, a1, MS;
    {
      Zx = /* @__PURE__ */ new Set(), Jx = /* @__PURE__ */ new Set(), e1 = /* @__PURE__ */ new Set(), t1 = /* @__PURE__ */ new Set(), i1 = /* @__PURE__ */ new Set(), n1 = /* @__PURE__ */ new Set(), r1 = /* @__PURE__ */ new Set(), a1 = /* @__PURE__ */ new Set(), MS = /* @__PURE__ */ new Set();
      var N$ = /* @__PURE__ */ new Set();
      YC = function(e, t) {
        if (!(e === null || typeof e == "function")) {
          var a = t + "_" + e;
          N$.has(a) || (N$.add(a), y("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e));
        }
      }, _$ = function(e, t) {
        if (t === void 0) {
          var a = Zt(e) || "Component";
          n1.has(a) || (n1.add(a), y("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", a));
        }
      }, Object.defineProperty(Xx, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(Xx);
    }
    function s1(e, t, a, l) {
      var c = e.memoizedState, m = a(l, c);
      {
        if (e.mode & Jt) {
          Cn(!0);
          try {
            m = a(l, c);
          } finally {
            Cn(!1);
          }
        }
        _$(t, m);
      }
      var T = m == null ? c : gt({}, c, m);
      if (e.memoizedState = T, e.lanes === ee) {
        var E = e.updateQueue;
        E.baseState = T;
      }
    }
    var l1 = {
      isMounted: nE,
      enqueueSetState: function(e, t, a) {
        var l = wc(e), c = ea(), m = Kc(l), T = Su(c, m);
        T.payload = t, a != null && (YC(a, "setState"), T.callback = a);
        var E = Ic(l, T, m);
        E !== null && (Vi(E, l, m, c), EC(E, l, m)), gf(l, m);
      },
      enqueueReplaceState: function(e, t, a) {
        var l = wc(e), c = ea(), m = Kc(l), T = Su(c, m);
        T.tag = JL, T.payload = t, a != null && (YC(a, "replaceState"), T.callback = a);
        var E = Ic(l, T, m);
        E !== null && (Vi(E, l, m, c), EC(E, l, m)), gf(l, m);
      },
      enqueueForceUpdate: function(e, t) {
        var a = wc(e), l = ea(), c = Kc(a), m = Su(l, c);
        m.tag = SC, t != null && (YC(t, "forceUpdate"), m.callback = t);
        var T = Ic(a, m, c);
        T !== null && (Vi(T, a, c, l), EC(T, a, c)), jp(a, c);
      }
    };
    function U$(e, t, a, l, c, m, T) {
      var E = e.stateNode;
      if (typeof E.shouldComponentUpdate == "function") {
        var C = E.shouldComponentUpdate(l, m, T);
        {
          if (e.mode & Jt) {
            Cn(!0);
            try {
              C = E.shouldComponentUpdate(l, m, T);
            } finally {
              Cn(!1);
            }
          }
          C === void 0 && y("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Zt(t) || "Component");
        }
        return C;
      }
      return t.prototype && t.prototype.isPureReactComponent ? !Ne(a, l) || !Ne(c, m) : !0;
    }
    function CI(e, t, a) {
      var l = e.stateNode;
      {
        var c = Zt(t) || "Component", m = l.render;
        m || (t.prototype && typeof t.prototype.render == "function" ? y("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", c) : y("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", c)), l.getInitialState && !l.getInitialState.isReactClassApproved && !l.state && y("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", c), l.getDefaultProps && !l.getDefaultProps.isReactClassApproved && y("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", c), l.propTypes && y("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", c), l.contextType && y("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", c), t.childContextTypes && !MS.has(t) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & Jt) === _e && (MS.add(t), y(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, c)), t.contextTypes && !MS.has(t) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & Jt) === _e && (MS.add(t), y(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, c)), l.contextTypes && y("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", c), t.contextType && t.contextTypes && !r1.has(t) && (r1.add(t), y("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", c)), typeof l.componentShouldUpdate == "function" && y("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", c), t.prototype && t.prototype.isPureReactComponent && typeof l.shouldComponentUpdate < "u" && y("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Zt(t) || "A pure component"), typeof l.componentDidUnmount == "function" && y("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", c), typeof l.componentDidReceiveProps == "function" && y("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", c), typeof l.componentWillRecieveProps == "function" && y("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", c), typeof l.UNSAFE_componentWillRecieveProps == "function" && y("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", c);
        var T = l.props !== a;
        l.props !== void 0 && T && y("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", c, c), l.defaultProps && y("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", c, c), typeof l.getSnapshotBeforeUpdate == "function" && typeof l.componentDidUpdate != "function" && !e1.has(t) && (e1.add(t), y("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Zt(t))), typeof l.getDerivedStateFromProps == "function" && y("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", c), typeof l.getDerivedStateFromError == "function" && y("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", c), typeof t.getSnapshotBeforeUpdate == "function" && y("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", c);
        var E = l.state;
        E && (typeof E != "object" || Di(E)) && y("%s.state: must be set to an object or null", c), typeof l.getChildContext == "function" && typeof t.childContextTypes != "object" && y("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", c);
      }
    }
    function z$(e, t) {
      t.updater = l1, e.stateNode = t, Go(t, e), t._reactInternalInstance = Xx;
    }
    function F$(e, t, a) {
      var l = !1, c = Ka, m = Ka, T = t.contextType;
      if ("contextType" in t) {
        var E = (
          // Allow null for conditional declaration
          T === null || T !== void 0 && T.$$typeof === Bd && T._context === void 0
        );
        if (!E && !a1.has(t)) {
          a1.add(t);
          var C = "";
          T === void 0 ? C = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof T != "object" ? C = " However, it is set to a " + typeof T + "." : T.$$typeof === lc ? C = " Did you accidentally pass the Context.Provider instead?" : T._context !== void 0 ? C = " Did you accidentally pass the Context.Consumer instead?" : C = " However, it is set to an object with keys {" + Object.keys(T).join(", ") + "}.", y("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Zt(t) || "Component", C);
        }
      }
      if (typeof T == "object" && T !== null)
        m = Ti(T);
      else {
        c = Pm(e, t, !0);
        var x = t.contextTypes;
        l = x != null, m = l ? _m(e, c) : Ka;
      }
      var M = new t(a, m);
      if (e.mode & Jt) {
        Cn(!0);
        try {
          M = new t(a, m);
        } finally {
          Cn(!1);
        }
      }
      var z = e.memoizedState = M.state !== null && M.state !== void 0 ? M.state : null;
      z$(e, M);
      {
        if (typeof t.getDerivedStateFromProps == "function" && z === null) {
          var N = Zt(t) || "Component";
          Jx.has(N) || (Jx.add(N), y("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", N, M.state === null ? "null" : "undefined", N));
        }
        if (typeof t.getDerivedStateFromProps == "function" || typeof M.getSnapshotBeforeUpdate == "function") {
          var q = null, Q = null, Y = null;
          if (typeof M.componentWillMount == "function" && M.componentWillMount.__suppressDeprecationWarning !== !0 ? q = "componentWillMount" : typeof M.UNSAFE_componentWillMount == "function" && (q = "UNSAFE_componentWillMount"), typeof M.componentWillReceiveProps == "function" && M.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Q = "componentWillReceiveProps" : typeof M.UNSAFE_componentWillReceiveProps == "function" && (Q = "UNSAFE_componentWillReceiveProps"), typeof M.componentWillUpdate == "function" && M.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Y = "componentWillUpdate" : typeof M.UNSAFE_componentWillUpdate == "function" && (Y = "UNSAFE_componentWillUpdate"), q !== null || Q !== null || Y !== null) {
            var ve = Zt(t) || "Component", Ue = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            t1.has(ve) || (t1.add(ve), y(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, ve, Ue, q !== null ? `
  ` + q : "", Q !== null ? `
  ` + Q : "", Y !== null ? `
  ` + Y : ""));
          }
        }
      }
      return l && DL(e, c, m), M;
    }
    function bI(e, t) {
      var a = t.state;
      typeof t.componentWillMount == "function" && t.componentWillMount(), typeof t.UNSAFE_componentWillMount == "function" && t.UNSAFE_componentWillMount(), a !== t.state && (y("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", nt(e) || "Component"), l1.enqueueReplaceState(t, t.state, null));
    }
    function V$(e, t, a, l) {
      var c = t.state;
      if (typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(a, l), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(a, l), t.state !== c) {
        {
          var m = nt(e) || "Component";
          Zx.has(m) || (Zx.add(m), y("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", m));
        }
        l1.enqueueReplaceState(t, t.state, null);
      }
    }
    function o1(e, t, a, l) {
      CI(e, t, a);
      var c = e.stateNode;
      c.props = a, c.state = e.memoizedState, c.refs = {}, yx(e);
      var m = t.contextType;
      if (typeof m == "object" && m !== null)
        c.context = Ti(m);
      else {
        var T = Pm(e, t, !0);
        c.context = _m(e, T);
      }
      {
        if (c.state === a) {
          var E = Zt(t) || "Component";
          i1.has(E) || (i1.add(E), y("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", E));
        }
        e.mode & Jt && al.recordLegacyContextWarning(e, c), al.recordUnsafeLifecycleWarnings(e, c);
      }
      c.state = e.memoizedState;
      var C = t.getDerivedStateFromProps;
      if (typeof C == "function" && (s1(e, t, C, a), c.state = e.memoizedState), typeof t.getDerivedStateFromProps != "function" && typeof c.getSnapshotBeforeUpdate != "function" && (typeof c.UNSAFE_componentWillMount == "function" || typeof c.componentWillMount == "function") && (bI(e, c), CC(e, a, c, l), c.state = e.memoizedState), typeof c.componentDidMount == "function") {
        var x = Et;
        x |= Gs, (e.mode & zt) !== _e && (x |= Pl), e.flags |= x;
      }
    }
    function kI(e, t, a, l) {
      var c = e.stateNode, m = e.memoizedProps;
      c.props = m;
      var T = c.context, E = t.contextType, C = Ka;
      if (typeof E == "object" && E !== null)
        C = Ti(E);
      else {
        var x = Pm(e, t, !0);
        C = _m(e, x);
      }
      var M = t.getDerivedStateFromProps, z = typeof M == "function" || typeof c.getSnapshotBeforeUpdate == "function";
      !z && (typeof c.UNSAFE_componentWillReceiveProps == "function" || typeof c.componentWillReceiveProps == "function") && (m !== a || T !== C) && V$(e, c, a, C), t$();
      var N = e.memoizedState, q = c.state = N;
      if (CC(e, a, c, l), q = e.memoizedState, m === a && N === q && !rC() && !bC()) {
        if (typeof c.componentDidMount == "function") {
          var Q = Et;
          Q |= Gs, (e.mode & zt) !== _e && (Q |= Pl), e.flags |= Q;
        }
        return !1;
      }
      typeof M == "function" && (s1(e, t, M, a), q = e.memoizedState);
      var Y = bC() || U$(e, t, m, a, N, q, C);
      if (Y) {
        if (!z && (typeof c.UNSAFE_componentWillMount == "function" || typeof c.componentWillMount == "function") && (typeof c.componentWillMount == "function" && c.componentWillMount(), typeof c.UNSAFE_componentWillMount == "function" && c.UNSAFE_componentWillMount()), typeof c.componentDidMount == "function") {
          var ve = Et;
          ve |= Gs, (e.mode & zt) !== _e && (ve |= Pl), e.flags |= ve;
        }
      } else {
        if (typeof c.componentDidMount == "function") {
          var Ue = Et;
          Ue |= Gs, (e.mode & zt) !== _e && (Ue |= Pl), e.flags |= Ue;
        }
        e.memoizedProps = a, e.memoizedState = q;
      }
      return c.props = a, c.state = q, c.context = C, Y;
    }
    function xI(e, t, a, l, c) {
      var m = t.stateNode;
      e$(e, t);
      var T = t.memoizedProps, E = t.type === t.elementType ? T : ol(t.type, T);
      m.props = E;
      var C = t.pendingProps, x = m.context, M = a.contextType, z = Ka;
      if (typeof M == "object" && M !== null)
        z = Ti(M);
      else {
        var N = Pm(t, a, !0);
        z = _m(t, N);
      }
      var q = a.getDerivedStateFromProps, Q = typeof q == "function" || typeof m.getSnapshotBeforeUpdate == "function";
      !Q && (typeof m.UNSAFE_componentWillReceiveProps == "function" || typeof m.componentWillReceiveProps == "function") && (T !== C || x !== z) && V$(t, m, l, z), t$();
      var Y = t.memoizedState, ve = m.state = Y;
      if (CC(t, l, m, c), ve = t.memoizedState, T === C && Y === ve && !rC() && !bC())
        return typeof m.componentDidUpdate == "function" && (T !== e.memoizedProps || Y !== e.memoizedState) && (t.flags |= Et), typeof m.getSnapshotBeforeUpdate == "function" && (T !== e.memoizedProps || Y !== e.memoizedState) && (t.flags |= oi), !1;
      typeof q == "function" && (s1(t, a, q, l), ve = t.memoizedState);
      var Ue = bC() || U$(t, a, E, l, Y, ve, z) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      Le;
      return Ue ? (!Q && (typeof m.UNSAFE_componentWillUpdate == "function" || typeof m.componentWillUpdate == "function") && (typeof m.componentWillUpdate == "function" && m.componentWillUpdate(l, ve, z), typeof m.UNSAFE_componentWillUpdate == "function" && m.UNSAFE_componentWillUpdate(l, ve, z)), typeof m.componentDidUpdate == "function" && (t.flags |= Et), typeof m.getSnapshotBeforeUpdate == "function" && (t.flags |= oi)) : (typeof m.componentDidUpdate == "function" && (T !== e.memoizedProps || Y !== e.memoizedState) && (t.flags |= Et), typeof m.getSnapshotBeforeUpdate == "function" && (T !== e.memoizedProps || Y !== e.memoizedState) && (t.flags |= oi), t.memoizedProps = l, t.memoizedState = ve), m.props = l, m.state = ve, m.context = z, Ue;
    }
    function ih(e, t) {
      return {
        value: e,
        source: t,
        stack: dp(t),
        digest: null
      };
    }
    function u1(e, t, a) {
      return {
        value: e,
        source: null,
        stack: a ?? null,
        digest: t ?? null
      };
    }
    function RI(e, t) {
      return !0;
    }
    function c1(e, t) {
      try {
        var a = RI(e, t);
        if (a === !1)
          return;
        var l = t.value, c = t.source, m = t.stack, T = m !== null ? m : "";
        if (l != null && l._suppressLogging) {
          if (e.tag === $)
            return;
          console.error(l);
        }
        var E = c ? nt(c) : null, C = E ? "The above error occurred in the <" + E + "> component:" : "The above error occurred in one of your React components:", x;
        if (e.tag === A)
          x = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var M = nt(e) || "Anonymous";
          x = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + M + ".");
        }
        var z = C + `
` + T + `

` + ("" + x);
        console.error(z);
      } catch (N) {
        setTimeout(function() {
          throw N;
        });
      }
    }
    var DI = typeof WeakMap == "function" ? WeakMap : Map;
    function H$(e, t, a) {
      var l = Su(ln, a);
      l.tag = mx, l.payload = {
        element: null
      };
      var c = t.value;
      return l.callback = function() {
        Tq(c), c1(e, t);
      }, l;
    }
    function d1(e, t, a) {
      var l = Su(ln, a);
      l.tag = mx;
      var c = e.type.getDerivedStateFromError;
      if (typeof c == "function") {
        var m = t.value;
        l.payload = function() {
          return c(m);
        }, l.callback = function() {
          ZO(e), c1(e, t);
        };
      }
      var T = e.stateNode;
      return T !== null && typeof T.componentDidCatch == "function" && (l.callback = function() {
        ZO(e), c1(e, t), typeof c != "function" && gq(this);
        var C = t.value, x = t.stack;
        this.componentDidCatch(C, {
          componentStack: x !== null ? x : ""
        }), typeof c != "function" && ($r(e.lanes, je) || y("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", nt(e) || "Unknown"));
      }), l;
    }
    function I$(e, t, a) {
      var l = e.pingCache, c;
      if (l === null ? (l = e.pingCache = new DI(), c = /* @__PURE__ */ new Set(), l.set(t, c)) : (c = l.get(t), c === void 0 && (c = /* @__PURE__ */ new Set(), l.set(t, c))), !c.has(a)) {
        c.add(a);
        var m = wq.bind(null, e, t, a);
        Lr && QS(e, a), t.then(m, m);
      }
    }
    function MI(e, t, a, l) {
      var c = e.updateQueue;
      if (c === null) {
        var m = /* @__PURE__ */ new Set();
        m.add(a), e.updateQueue = m;
      } else
        c.add(a);
    }
    function LI(e, t) {
      var a = e.tag;
      if ((e.mode & dt) === _e && (a === D || a === Ve || a === He)) {
        var l = e.alternate;
        l ? (e.updateQueue = l.updateQueue, e.memoizedState = l.memoizedState, e.lanes = l.lanes) : (e.updateQueue = null, e.memoizedState = null);
      }
    }
    function q$(e) {
      var t = e;
      do {
        if (t.tag === Ye && cI(t))
          return t;
        t = t.return;
      } while (t !== null);
      return null;
    }
    function j$(e, t, a, l, c) {
      if ((e.mode & dt) === _e) {
        if (e === t)
          e.flags |= Rr;
        else {
          if (e.flags |= Oe, a.flags |= Np, a.flags &= -52805, a.tag === $) {
            var m = a.alternate;
            if (m === null)
              a.tag = Ge;
            else {
              var T = Su(ln, je);
              T.tag = SC, Ic(a, T, je);
            }
          }
          a.lanes = it(a.lanes, je);
        }
        return e;
      }
      return e.flags |= Rr, e.lanes = c, e;
    }
    function $I(e, t, a, l, c) {
      if (a.flags |= ff, Lr && QS(e, c), l !== null && typeof l == "object" && typeof l.then == "function") {
        var m = l;
        LI(a), or() && a.mode & dt && _L();
        var T = q$(t);
        if (T !== null) {
          T.flags &= -257, j$(T, t, a, e, c), T.mode & dt && I$(e, m, c), MI(T, e, m);
          return;
        } else {
          if (!cE(c)) {
            I$(e, m, c), j1();
            return;
          }
          var E = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          l = E;
        }
      } else if (or() && a.mode & dt) {
        _L();
        var C = q$(t);
        if (C !== null) {
          (C.flags & Rr) === Pe && (C.flags |= kr), j$(C, t, a, e, c), ix(ih(l, a));
          return;
        }
      }
      l = ih(l, a), cq(l);
      var x = t;
      do {
        switch (x.tag) {
          case A: {
            var M = l;
            x.flags |= Rr;
            var z = Rf(c);
            x.lanes = it(x.lanes, z);
            var N = H$(x, M, z);
            gx(x, N);
            return;
          }
          case $:
            var q = l, Q = x.type, Y = x.stateNode;
            if ((x.flags & Oe) === Pe && (typeof Q.getDerivedStateFromError == "function" || Y !== null && typeof Y.componentDidCatch == "function" && !qO(Y))) {
              x.flags |= Rr;
              var ve = Rf(c);
              x.lanes = it(x.lanes, ve);
              var Ue = d1(x, q, ve);
              gx(x, Ue);
              return;
            }
            break;
        }
        x = x.return;
      } while (x !== null);
    }
    function OI() {
      return null;
    }
    var LS = n.ReactCurrentOwner, ul = !1, f1, $S, h1, p1, m1, rh, v1, GC, OS;
    f1 = {}, $S = {}, h1 = {}, p1 = {}, m1 = {}, rh = !1, v1 = {}, GC = {}, OS = {};
    function Zr(e, t, a, l) {
      e === null ? t.child = YL(t, null, a, l) : t.child = Fm(t, e.child, a, l);
    }
    function AI(e, t, a, l) {
      t.child = Fm(t, e.child, null, l), t.child = Fm(t, null, a, l);
    }
    function B$(e, t, a, l, c) {
      if (t.type !== t.elementType) {
        var m = a.propTypes;
        m && il(
          m,
          l,
          // Resolved props
          "prop",
          Zt(a)
        );
      }
      var T = a.render, E = t.ref, C, x;
      Hm(t, c), Yr(t);
      {
        if (LS.current = t, Ri(!0), C = Ym(e, t, T, l, E, c), x = Gm(), t.mode & Jt) {
          Cn(!0);
          try {
            C = Ym(e, t, T, l, E, c), x = Gm();
          } finally {
            Cn(!1);
          }
        }
        Ri(!1);
      }
      return Gr(), e !== null && !ul ? (l$(e, t, c), Tu(e, t, c)) : (or() && x && Xk(t), t.flags |= ja, Zr(e, t, C, c), t.child);
    }
    function Q$(e, t, a, l, c) {
      if (e === null) {
        var m = a.type;
        if (zq(m) && a.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        a.defaultProps === void 0) {
          var T = m;
          return T = nv(m), t.tag = He, t.type = T, S1(t, m), Y$(e, t, T, l, c);
        }
        {
          var E = m.propTypes;
          if (E && il(
            E,
            l,
            // Resolved props
            "prop",
            Zt(m)
          ), a.defaultProps !== void 0) {
            var C = Zt(m) || "Unknown";
            OS[C] || (y("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", C), OS[C] = !0);
          }
        }
        var x = tR(a.type, null, l, t, t.mode, c);
        return x.ref = t.ref, x.return = t, t.child = x, x;
      }
      {
        var M = a.type, z = M.propTypes;
        z && il(
          z,
          l,
          // Resolved props
          "prop",
          Zt(M)
        );
      }
      var N = e.child, q = k1(e, c);
      if (!q) {
        var Q = N.memoizedProps, Y = a.compare;
        if (Y = Y !== null ? Y : Ne, Y(Q, l) && e.ref === t.ref)
          return Tu(e, t, c);
      }
      t.flags |= ja;
      var ve = uh(N, l);
      return ve.ref = t.ref, ve.return = t, t.child = ve, ve;
    }
    function Y$(e, t, a, l, c) {
      if (t.type !== t.elementType) {
        var m = t.elementType;
        if (m.$$typeof === qi) {
          var T = m, E = T._payload, C = T._init;
          try {
            m = C(E);
          } catch {
            m = null;
          }
          var x = m && m.propTypes;
          x && il(
            x,
            l,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Zt(m)
          );
        }
      }
      if (e !== null) {
        var M = e.memoizedProps;
        if (Ne(M, l) && e.ref === t.ref && // Prevent bailout if the implementation changed due to hot reload.
        t.type === e.type)
          if (ul = !1, t.pendingProps = l = M, k1(e, c))
            (e.flags & Np) !== Pe && (ul = !0);
          else return t.lanes = e.lanes, Tu(e, t, c);
      }
      return y1(e, t, a, l, c);
    }
    function G$(e, t, a) {
      var l = t.pendingProps, c = l.children, m = e !== null ? e.memoizedState : null;
      if (l.mode === "hidden" || he)
        if ((t.mode & dt) === _e) {
          var T = {
            baseLanes: ee,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = T, lb(t, a);
        } else if ($r(a, Wr)) {
          var z = {
            baseLanes: ee,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = z;
          var N = m !== null ? m.baseLanes : a;
          lb(t, N);
        } else {
          var E = null, C;
          if (m !== null) {
            var x = m.baseLanes;
            C = it(x, a);
          } else
            C = a;
          t.lanes = t.childLanes = Wr;
          var M = {
            baseLanes: C,
            cachePool: E,
            transitions: null
          };
          return t.memoizedState = M, t.updateQueue = null, lb(t, C), null;
        }
      else {
        var q;
        m !== null ? (q = it(m.baseLanes, a), t.memoizedState = null) : q = a, lb(t, q);
      }
      return Zr(e, t, c, a), t.child;
    }
    function PI(e, t, a) {
      var l = t.pendingProps;
      return Zr(e, t, l, a), t.child;
    }
    function _I(e, t, a) {
      var l = t.pendingProps.children;
      return Zr(e, t, l, a), t.child;
    }
    function NI(e, t, a) {
      {
        t.flags |= Et;
        {
          var l = t.stateNode;
          l.effectDuration = 0, l.passiveEffectDuration = 0;
        }
      }
      var c = t.pendingProps, m = c.children;
      return Zr(e, t, m, a), t.child;
    }
    function W$(e, t) {
      var a = t.ref;
      (e === null && a !== null || e !== null && e.ref !== a) && (t.flags |= An, t.flags |= Cc);
    }
    function y1(e, t, a, l, c) {
      if (t.type !== t.elementType) {
        var m = a.propTypes;
        m && il(
          m,
          l,
          // Resolved props
          "prop",
          Zt(a)
        );
      }
      var T;
      {
        var E = Pm(t, a, !0);
        T = _m(t, E);
      }
      var C, x;
      Hm(t, c), Yr(t);
      {
        if (LS.current = t, Ri(!0), C = Ym(e, t, a, l, T, c), x = Gm(), t.mode & Jt) {
          Cn(!0);
          try {
            C = Ym(e, t, a, l, T, c), x = Gm();
          } finally {
            Cn(!1);
          }
        }
        Ri(!1);
      }
      return Gr(), e !== null && !ul ? (l$(e, t, c), Tu(e, t, c)) : (or() && x && Xk(t), t.flags |= ja, Zr(e, t, C, c), t.child);
    }
    function K$(e, t, a, l, c) {
      {
        switch (Jq(t)) {
          case !1: {
            var m = t.stateNode, T = t.type, E = new T(t.memoizedProps, m.context), C = E.state;
            m.updater.enqueueSetState(m, C, null);
            break;
          }
          case !0: {
            t.flags |= Oe, t.flags |= Rr;
            var x = new Error("Simulated error coming from DevTools"), M = Rf(c);
            t.lanes = it(t.lanes, M);
            var z = d1(t, ih(x, t), M);
            gx(t, z);
            break;
          }
        }
        if (t.type !== t.elementType) {
          var N = a.propTypes;
          N && il(
            N,
            l,
            // Resolved props
            "prop",
            Zt(a)
          );
        }
      }
      var q;
      Xl(a) ? (q = !0, sC(t)) : q = !1, Hm(t, c);
      var Q = t.stateNode, Y;
      Q === null ? (KC(e, t), F$(t, a, l), o1(t, a, l, c), Y = !0) : e === null ? Y = kI(t, a, l, c) : Y = xI(e, t, a, l, c);
      var ve = g1(e, t, a, Y, q, c);
      {
        var Ue = t.stateNode;
        Y && Ue.props !== l && (rh || y("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", nt(t) || "a component"), rh = !0);
      }
      return ve;
    }
    function g1(e, t, a, l, c, m) {
      W$(e, t);
      var T = (t.flags & Oe) !== Pe;
      if (!l && !T)
        return c && $L(t, a, !1), Tu(e, t, m);
      var E = t.stateNode;
      LS.current = t;
      var C;
      if (T && typeof a.getDerivedStateFromError != "function")
        C = null, P$();
      else {
        Yr(t);
        {
          if (Ri(!0), C = E.render(), t.mode & Jt) {
            Cn(!0);
            try {
              E.render();
            } finally {
              Cn(!1);
            }
          }
          Ri(!1);
        }
        Gr();
      }
      return t.flags |= ja, e !== null && T ? AI(e, t, C, m) : Zr(e, t, C, m), t.memoizedState = E.state, c && $L(t, a, !0), t.child;
    }
    function X$(e) {
      var t = e.stateNode;
      t.pendingContext ? ML(e, t.pendingContext, t.pendingContext !== t.context) : t.context && ML(e, t.context, !1), Sx(e, t.containerInfo);
    }
    function UI(e, t, a) {
      if (X$(t), e === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var l = t.pendingProps, c = t.memoizedState, m = c.element;
      e$(e, t), CC(t, l, null, a);
      var T = t.memoizedState;
      t.stateNode;
      var E = T.element;
      if (c.isDehydrated) {
        var C = {
          element: E,
          isDehydrated: !1,
          cache: T.cache,
          pendingSuspenseBoundaries: T.pendingSuspenseBoundaries,
          transitions: T.transitions
        }, x = t.updateQueue;
        if (x.baseState = C, t.memoizedState = C, t.flags & kr) {
          var M = ih(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), t);
          return Z$(e, t, E, a, M);
        } else if (E !== m) {
          var z = ih(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), t);
          return Z$(e, t, E, a, z);
        } else {
          V3(t);
          var N = YL(t, null, E, a);
          t.child = N;
          for (var q = N; q; )
            q.flags = q.flags & -3 | ma, q = q.sibling;
        }
      } else {
        if (zm(), E === m)
          return Tu(e, t, a);
        Zr(e, t, E, a);
      }
      return t.child;
    }
    function Z$(e, t, a, l, c) {
      return zm(), ix(c), t.flags |= kr, Zr(e, t, a, l), t.child;
    }
    function zI(e, t, a) {
      r$(t), e === null && nx(t);
      var l = t.type, c = t.pendingProps, m = e !== null ? e.memoizedProps : null, T = c.children, E = Uk(l, c);
      return E ? T = null : m !== null && Uk(l, m) && (t.flags |= Ba), W$(e, t), Zr(e, t, T, a), t.child;
    }
    function FI(e, t) {
      return e === null && nx(t), null;
    }
    function VI(e, t, a, l) {
      KC(e, t);
      var c = t.pendingProps, m = a, T = m._payload, E = m._init, C = E(T);
      t.type = C;
      var x = t.tag = Fq(C), M = ol(C, c), z;
      switch (x) {
        case D:
          return S1(t, C), t.type = C = nv(C), z = y1(null, t, C, M, l), z;
        case $:
          return t.type = C = W1(C), z = K$(null, t, C, M, l), z;
        case Ve:
          return t.type = C = K1(C), z = B$(null, t, C, M, l), z;
        case Tt: {
          if (t.type !== t.elementType) {
            var N = C.propTypes;
            N && il(
              N,
              M,
              // Resolved for outer only
              "prop",
              Zt(C)
            );
          }
          return z = Q$(
            null,
            t,
            C,
            ol(C.type, M),
            // The inner type can have defaults too
            l
          ), z;
        }
      }
      var q = "";
      throw C !== null && typeof C == "object" && C.$$typeof === qi && (q = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + C + ". " + ("Lazy element type must resolve to a class or function." + q));
    }
    function HI(e, t, a, l, c) {
      KC(e, t), t.tag = $;
      var m;
      return Xl(a) ? (m = !0, sC(t)) : m = !1, Hm(t, c), F$(t, a, l), o1(t, a, l, c), g1(null, t, a, !0, m, c);
    }
    function II(e, t, a, l) {
      KC(e, t);
      var c = t.pendingProps, m;
      {
        var T = Pm(t, a, !1);
        m = _m(t, T);
      }
      Hm(t, l);
      var E, C;
      Yr(t);
      {
        if (a.prototype && typeof a.prototype.render == "function") {
          var x = Zt(a) || "Unknown";
          f1[x] || (y("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", x, x), f1[x] = !0);
        }
        t.mode & Jt && al.recordLegacyContextWarning(t, null), Ri(!0), LS.current = t, E = Ym(null, t, a, c, m, l), C = Gm(), Ri(!1);
      }
      if (Gr(), t.flags |= ja, typeof E == "object" && E !== null && typeof E.render == "function" && E.$$typeof === void 0) {
        var M = Zt(a) || "Unknown";
        $S[M] || (y("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", M, M, M), $S[M] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof E == "object" && E !== null && typeof E.render == "function" && E.$$typeof === void 0
      ) {
        {
          var z = Zt(a) || "Unknown";
          $S[z] || (y("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", z, z, z), $S[z] = !0);
        }
        t.tag = $, t.memoizedState = null, t.updateQueue = null;
        var N = !1;
        return Xl(a) ? (N = !0, sC(t)) : N = !1, t.memoizedState = E.state !== null && E.state !== void 0 ? E.state : null, yx(t), z$(t, E), o1(t, a, c, l), g1(null, t, a, !0, N, l);
      } else {
        if (t.tag = D, t.mode & Jt) {
          Cn(!0);
          try {
            E = Ym(null, t, a, c, m, l), C = Gm();
          } finally {
            Cn(!1);
          }
        }
        return or() && C && Xk(t), Zr(null, t, E, l), S1(t, a), t.child;
      }
    }
    function S1(e, t) {
      {
        if (t && t.childContextTypes && y("%s(...): childContextTypes cannot be defined on a function component.", t.displayName || t.name || "Component"), e.ref !== null) {
          var a = "", l = da();
          l && (a += `

Check the render method of \`` + l + "`.");
          var c = l || "", m = e._debugSource;
          m && (c = m.fileName + ":" + m.lineNumber), m1[c] || (m1[c] = !0, y("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", a));
        }
        if (t.defaultProps !== void 0) {
          var T = Zt(t) || "Unknown";
          OS[T] || (y("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", T), OS[T] = !0);
        }
        if (typeof t.getDerivedStateFromProps == "function") {
          var E = Zt(t) || "Unknown";
          p1[E] || (y("%s: Function components do not support getDerivedStateFromProps.", E), p1[E] = !0);
        }
        if (typeof t.contextType == "object" && t.contextType !== null) {
          var C = Zt(t) || "Unknown";
          h1[C] || (y("%s: Function components do not support contextType.", C), h1[C] = !0);
        }
      }
    }
    var T1 = {
      dehydrated: null,
      treeContext: null,
      retryLane: Ot
    };
    function w1(e) {
      return {
        baseLanes: e,
        cachePool: OI(),
        transitions: null
      };
    }
    function qI(e, t) {
      var a = null;
      return {
        baseLanes: it(e.baseLanes, t),
        cachePool: a,
        transitions: e.transitions
      };
    }
    function jI(e, t, a, l) {
      if (t !== null) {
        var c = t.memoizedState;
        if (c === null)
          return !1;
      }
      return Ex(e, wS);
    }
    function BI(e, t) {
      return Df(e.childLanes, t);
    }
    function J$(e, t, a) {
      var l = t.pendingProps;
      ej(t) && (t.flags |= Oe);
      var c = sl.current, m = !1, T = (t.flags & Oe) !== Pe;
      if (T || jI(c, e) ? (m = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (c = uI(c, s$)), c = qm(c), jc(t, c), e === null) {
        nx(t);
        var E = t.memoizedState;
        if (E !== null) {
          var C = E.dehydrated;
          if (C !== null)
            return KI(t, C);
        }
        var x = l.children, M = l.fallback;
        if (m) {
          var z = QI(t, x, M, a), N = t.child;
          return N.memoizedState = w1(a), t.memoizedState = T1, z;
        } else
          return E1(t, x);
      } else {
        var q = e.memoizedState;
        if (q !== null) {
          var Q = q.dehydrated;
          if (Q !== null)
            return XI(e, t, T, l, Q, q, a);
        }
        if (m) {
          var Y = l.fallback, ve = l.children, Ue = GI(e, t, ve, Y, a), Me = t.child, kt = e.child.memoizedState;
          return Me.memoizedState = kt === null ? w1(a) : qI(kt, a), Me.childLanes = BI(e, a), t.memoizedState = T1, Ue;
        } else {
          var pt = l.children, V = YI(e, t, pt, a);
          return t.memoizedState = null, V;
        }
      }
    }
    function E1(e, t, a) {
      var l = e.mode, c = {
        mode: "visible",
        children: t
      }, m = C1(c, l);
      return m.return = e, e.child = m, m;
    }
    function QI(e, t, a, l) {
      var c = e.mode, m = e.child, T = {
        mode: "hidden",
        children: t
      }, E, C;
      return (c & dt) === _e && m !== null ? (E = m, E.childLanes = ee, E.pendingProps = T, e.mode & Ut && (E.actualDuration = 0, E.actualStartTime = -1, E.selfBaseDuration = 0, E.treeBaseDuration = 0), C = Zc(a, c, l, null)) : (E = C1(T, c), C = Zc(a, c, l, null)), E.return = e, C.return = e, E.sibling = C, e.child = E, C;
    }
    function C1(e, t, a) {
      return eA(e, t, ee, null);
    }
    function eO(e, t) {
      return uh(e, t);
    }
    function YI(e, t, a, l) {
      var c = e.child, m = c.sibling, T = eO(c, {
        mode: "visible",
        children: a
      });
      if ((t.mode & dt) === _e && (T.lanes = l), T.return = t, T.sibling = null, m !== null) {
        var E = t.deletions;
        E === null ? (t.deletions = [m], t.flags |= pa) : E.push(m);
      }
      return t.child = T, T;
    }
    function GI(e, t, a, l, c) {
      var m = t.mode, T = e.child, E = T.sibling, C = {
        mode: "hidden",
        children: a
      }, x;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (m & dt) === _e && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        t.child !== T
      ) {
        var M = t.child;
        x = M, x.childLanes = ee, x.pendingProps = C, t.mode & Ut && (x.actualDuration = 0, x.actualStartTime = -1, x.selfBaseDuration = T.selfBaseDuration, x.treeBaseDuration = T.treeBaseDuration), t.deletions = null;
      } else
        x = eO(T, C), x.subtreeFlags = T.subtreeFlags & Wn;
      var z;
      return E !== null ? z = uh(E, l) : (z = Zc(l, m, c, null), z.flags |= Nn), z.return = t, x.return = t, x.sibling = z, t.child = x, z;
    }
    function WC(e, t, a, l) {
      l !== null && ix(l), Fm(t, e.child, null, a);
      var c = t.pendingProps, m = c.children, T = E1(t, m);
      return T.flags |= Nn, t.memoizedState = null, T;
    }
    function WI(e, t, a, l, c) {
      var m = t.mode, T = {
        mode: "visible",
        children: a
      }, E = C1(T, m), C = Zc(l, m, c, null);
      return C.flags |= Nn, E.return = t, C.return = t, E.sibling = C, t.child = E, (t.mode & dt) !== _e && Fm(t, e.child, null, c), C;
    }
    function KI(e, t, a) {
      return (e.mode & dt) === _e ? (y("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), e.lanes = je) : Hk(t) ? e.lanes = ji : e.lanes = Wr, null;
    }
    function XI(e, t, a, l, c, m, T) {
      if (a)
        if (t.flags & kr) {
          t.flags &= -257;
          var V = u1(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return WC(e, t, T, V);
        } else {
          if (t.memoizedState !== null)
            return t.child = e.child, t.flags |= Oe, null;
          var G = l.children, H = l.fallback, ae = WI(e, t, G, H, T), Ee = t.child;
          return Ee.memoizedState = w1(T), t.memoizedState = T1, ae;
        }
      else {
        if (z3(), (t.mode & dt) === _e)
          return WC(
            e,
            t,
            T,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (Hk(c)) {
          var E, C, x;
          {
            var M = t3(c);
            E = M.digest, C = M.message, x = M.stack;
          }
          var z;
          C ? z = new Error(C) : z = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var N = u1(z, E, x);
          return WC(e, t, T, N);
        }
        var q = $r(T, e.childLanes);
        if (ul || q) {
          var Q = sb();
          if (Q !== null) {
            var Y = _g(Q, T);
            if (Y !== Ot && Y !== m.retryLane) {
              m.retryLane = Y;
              var ve = ln;
              ba(e, Y), Vi(Q, e, Y, ve);
            }
          }
          j1();
          var Ue = u1(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return WC(e, t, T, Ue);
        } else if (CL(c)) {
          t.flags |= Oe, t.child = e.child;
          var Me = Eq.bind(null, e);
          return n3(c, Me), null;
        } else {
          H3(t, c, m.treeContext);
          var kt = l.children, pt = E1(t, kt);
          return pt.flags |= ma, pt;
        }
      }
    }
    function tO(e, t, a) {
      e.lanes = it(e.lanes, t);
      var l = e.alternate;
      l !== null && (l.lanes = it(l.lanes, t)), hx(e.return, t, a);
    }
    function ZI(e, t, a) {
      for (var l = t; l !== null; ) {
        if (l.tag === Ye) {
          var c = l.memoizedState;
          c !== null && tO(l, a, e);
        } else if (l.tag === Kt)
          tO(l, a, e);
        else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === e)
          return;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === e)
            return;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    }
    function JI(e) {
      for (var t = e, a = null; t !== null; ) {
        var l = t.alternate;
        l !== null && RC(l) === null && (a = t), t = t.sibling;
      }
      return a;
    }
    function e4(e) {
      if (e !== void 0 && e !== "forwards" && e !== "backwards" && e !== "together" && !v1[e])
        if (v1[e] = !0, typeof e == "string")
          switch (e.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              y('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', e, e.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              y('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', e, e.toLowerCase());
              break;
            }
            default:
              y('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
              break;
          }
        else
          y('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
    }
    function t4(e, t) {
      e !== void 0 && !GC[e] && (e !== "collapsed" && e !== "hidden" ? (GC[e] = !0, y('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', e)) : t !== "forwards" && t !== "backwards" && (GC[e] = !0, y('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', e)));
    }
    function nO(e, t) {
      {
        var a = Di(e), l = !a && typeof sn(e) == "function";
        if (a || l) {
          var c = a ? "array" : "iterable";
          return y("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", c, t, c), !1;
        }
      }
      return !0;
    }
    function n4(e, t) {
      if ((t === "forwards" || t === "backwards") && e !== void 0 && e !== null && e !== !1)
        if (Di(e)) {
          for (var a = 0; a < e.length; a++)
            if (!nO(e[a], a))
              return;
        } else {
          var l = sn(e);
          if (typeof l == "function") {
            var c = l.call(e);
            if (c)
              for (var m = c.next(), T = 0; !m.done; m = c.next()) {
                if (!nO(m.value, T))
                  return;
                T++;
              }
          } else
            y('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', t);
        }
    }
    function b1(e, t, a, l, c) {
      var m = e.memoizedState;
      m === null ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: l,
        tail: a,
        tailMode: c
      } : (m.isBackwards = t, m.rendering = null, m.renderingStartTime = 0, m.last = l, m.tail = a, m.tailMode = c);
    }
    function iO(e, t, a) {
      var l = t.pendingProps, c = l.revealOrder, m = l.tail, T = l.children;
      e4(c), t4(m, c), n4(T, c), Zr(e, t, T, a);
      var E = sl.current, C = Ex(E, wS);
      if (C)
        E = Cx(E, wS), t.flags |= Oe;
      else {
        var x = e !== null && (e.flags & Oe) !== Pe;
        x && ZI(t, t.child, a), E = qm(E);
      }
      if (jc(t, E), (t.mode & dt) === _e)
        t.memoizedState = null;
      else
        switch (c) {
          case "forwards": {
            var M = JI(t.child), z;
            M === null ? (z = t.child, t.child = null) : (z = M.sibling, M.sibling = null), b1(
              t,
              !1,
              // isBackwards
              z,
              M,
              m
            );
            break;
          }
          case "backwards": {
            var N = null, q = t.child;
            for (t.child = null; q !== null; ) {
              var Q = q.alternate;
              if (Q !== null && RC(Q) === null) {
                t.child = q;
                break;
              }
              var Y = q.sibling;
              q.sibling = N, N = q, q = Y;
            }
            b1(
              t,
              !0,
              // isBackwards
              N,
              null,
              // last
              m
            );
            break;
          }
          case "together": {
            b1(
              t,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            t.memoizedState = null;
        }
      return t.child;
    }
    function i4(e, t, a) {
      Sx(t, t.stateNode.containerInfo);
      var l = t.pendingProps;
      return e === null ? t.child = Fm(t, null, l, a) : Zr(e, t, l, a), t.child;
    }
    var rO = !1;
    function r4(e, t, a) {
      var l = t.type, c = l._context, m = t.pendingProps, T = t.memoizedProps, E = m.value;
      {
        "value" in m || rO || (rO = !0, y("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var C = t.type.propTypes;
        C && il(C, m, "prop", "Context.Provider");
      }
      if (KL(t, c, E), T !== null) {
        var x = T.value;
        if (ge(x, E)) {
          if (T.children === m.children && !rC())
            return Tu(e, t, a);
        } else
          eI(t, c, a);
      }
      var M = m.children;
      return Zr(e, t, M, a), t.child;
    }
    var aO = !1;
    function a4(e, t, a) {
      var l = t.type;
      l._context === void 0 ? l !== l.Consumer && (aO || (aO = !0, y("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : l = l._context;
      var c = t.pendingProps, m = c.children;
      typeof m != "function" && y("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Hm(t, a);
      var T = Ti(l);
      Yr(t);
      var E;
      return LS.current = t, Ri(!0), E = m(T), Ri(!1), Gr(), t.flags |= ja, Zr(e, t, E, a), t.child;
    }
    function AS() {
      ul = !0;
    }
    function KC(e, t) {
      (t.mode & dt) === _e && e !== null && (e.alternate = null, t.alternate = null, t.flags |= Nn);
    }
    function Tu(e, t, a) {
      return e !== null && (t.dependencies = e.dependencies), P$(), BS(t.lanes), $r(a, t.childLanes) ? (Z3(e, t), t.child) : null;
    }
    function s4(e, t, a) {
      {
        var l = t.return;
        if (l === null)
          throw new Error("Cannot swap the root fiber.");
        if (e.alternate = null, t.alternate = null, a.index = t.index, a.sibling = t.sibling, a.return = t.return, a.ref = t.ref, t === l.child)
          l.child = a;
        else {
          var c = l.child;
          if (c === null)
            throw new Error("Expected parent to have a child.");
          for (; c.sibling !== t; )
            if (c = c.sibling, c === null)
              throw new Error("Expected to find the previous sibling.");
          c.sibling = a;
        }
        var m = l.deletions;
        return m === null ? (l.deletions = [e], l.flags |= pa) : m.push(e), a.flags |= Nn, a;
      }
    }
    function k1(e, t) {
      var a = e.lanes;
      return !!$r(a, t);
    }
    function l4(e, t, a) {
      switch (t.tag) {
        case A:
          X$(t), t.stateNode, zm();
          break;
        case W:
          r$(t);
          break;
        case $: {
          var l = t.type;
          Xl(l) && sC(t);
          break;
        }
        case B:
          Sx(t, t.stateNode.containerInfo);
          break;
        case $t: {
          var c = t.memoizedProps.value, m = t.type._context;
          KL(t, m, c);
          break;
        }
        case ct:
          {
            var T = $r(a, t.childLanes);
            T && (t.flags |= Et);
            {
              var E = t.stateNode;
              E.effectDuration = 0, E.passiveEffectDuration = 0;
            }
          }
          break;
        case Ye: {
          var C = t.memoizedState;
          if (C !== null) {
            if (C.dehydrated !== null)
              return jc(t, qm(sl.current)), t.flags |= Oe, null;
            var x = t.child, M = x.childLanes;
            if ($r(a, M))
              return J$(e, t, a);
            jc(t, qm(sl.current));
            var z = Tu(e, t, a);
            return z !== null ? z.sibling : null;
          } else
            jc(t, qm(sl.current));
          break;
        }
        case Kt: {
          var N = (e.flags & Oe) !== Pe, q = $r(a, t.childLanes);
          if (N) {
            if (q)
              return iO(e, t, a);
            t.flags |= Oe;
          }
          var Q = t.memoizedState;
          if (Q !== null && (Q.rendering = null, Q.tail = null, Q.lastEffect = null), jc(t, sl.current), q)
            break;
          return null;
        }
        case Ae:
        case wt:
          return t.lanes = ee, G$(e, t, a);
      }
      return Tu(e, t, a);
    }
    function sO(e, t, a) {
      if (t._debugNeedsRemount && e !== null)
        return s4(e, t, tR(t.type, t.key, t.pendingProps, t._debugOwner || null, t.mode, t.lanes));
      if (e !== null) {
        var l = e.memoizedProps, c = t.pendingProps;
        if (l !== c || rC() || // Force a re-render if the implementation changed due to hot reload:
        t.type !== e.type)
          ul = !0;
        else {
          var m = k1(e, a);
          if (!m && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (t.flags & Oe) === Pe)
            return ul = !1, l4(e, t, a);
          (e.flags & Np) !== Pe ? ul = !0 : ul = !1;
        }
      } else if (ul = !1, or() && O3(t)) {
        var T = t.index, E = A3();
        PL(t, E, T);
      }
      switch (t.lanes = ee, t.tag) {
        case _:
          return II(e, t, t.type, a);
        case de: {
          var C = t.elementType;
          return VI(e, t, C, a);
        }
        case D: {
          var x = t.type, M = t.pendingProps, z = t.elementType === x ? M : ol(x, M);
          return y1(e, t, x, z, a);
        }
        case $: {
          var N = t.type, q = t.pendingProps, Q = t.elementType === N ? q : ol(N, q);
          return K$(e, t, N, Q, a);
        }
        case A:
          return UI(e, t, a);
        case W:
          return zI(e, t, a);
        case ne:
          return FI(e, t);
        case Ye:
          return J$(e, t, a);
        case B:
          return i4(e, t, a);
        case Ve: {
          var Y = t.type, ve = t.pendingProps, Ue = t.elementType === Y ? ve : ol(Y, ve);
          return B$(e, t, Y, Ue, a);
        }
        case ce:
          return PI(e, t, a);
        case Re:
          return _I(e, t, a);
        case ct:
          return NI(e, t, a);
        case $t:
          return r4(e, t, a);
        case Lt:
          return a4(e, t, a);
        case Tt: {
          var Me = t.type, kt = t.pendingProps, pt = ol(Me, kt);
          if (t.type !== t.elementType) {
            var V = Me.propTypes;
            V && il(
              V,
              pt,
              // Resolved for outer only
              "prop",
              Zt(Me)
            );
          }
          return pt = ol(Me.type, pt), Q$(e, t, Me, pt, a);
        }
        case He:
          return Y$(e, t, t.type, t.pendingProps, a);
        case Ge: {
          var G = t.type, H = t.pendingProps, ae = t.elementType === G ? H : ol(G, H);
          return HI(e, t, G, ae, a);
        }
        case Kt:
          return iO(e, t, a);
        case Mt:
          break;
        case Ae:
          return G$(e, t, a);
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Wm(e) {
      e.flags |= Et;
    }
    function lO(e) {
      e.flags |= An, e.flags |= Cc;
    }
    var oO, x1, uO, cO;
    oO = function(e, t, a, l) {
      for (var c = t.child; c !== null; ) {
        if (c.tag === W || c.tag === ne)
          MH(e, c.stateNode);
        else if (c.tag !== B) {
          if (c.child !== null) {
            c.child.return = c, c = c.child;
            continue;
          }
        }
        if (c === t)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === t)
            return;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
    }, x1 = function(e, t) {
    }, uO = function(e, t, a, l, c) {
      var m = e.memoizedProps;
      if (m !== l) {
        var T = t.stateNode, E = Tx(), C = $H(T, a, m, l, c, E);
        t.updateQueue = C, C && Wm(t);
      }
    }, cO = function(e, t, a, l) {
      a !== l && Wm(t);
    };
    function PS(e, t) {
      if (!or())
        switch (e.tailMode) {
          case "hidden": {
            for (var a = e.tail, l = null; a !== null; )
              a.alternate !== null && (l = a), a = a.sibling;
            l === null ? e.tail = null : l.sibling = null;
            break;
          }
          case "collapsed": {
            for (var c = e.tail, m = null; c !== null; )
              c.alternate !== null && (m = c), c = c.sibling;
            m === null ? !t && e.tail !== null ? e.tail.sibling = null : e.tail = null : m.sibling = null;
            break;
          }
        }
    }
    function cr(e) {
      var t = e.alternate !== null && e.alternate.child === e.child, a = ee, l = Pe;
      if (t) {
        if ((e.mode & Ut) !== _e) {
          for (var C = e.selfBaseDuration, x = e.child; x !== null; )
            a = it(a, it(x.lanes, x.childLanes)), l |= x.subtreeFlags & Wn, l |= x.flags & Wn, C += x.treeBaseDuration, x = x.sibling;
          e.treeBaseDuration = C;
        } else
          for (var M = e.child; M !== null; )
            a = it(a, it(M.lanes, M.childLanes)), l |= M.subtreeFlags & Wn, l |= M.flags & Wn, M.return = e, M = M.sibling;
        e.subtreeFlags |= l;
      } else {
        if ((e.mode & Ut) !== _e) {
          for (var c = e.actualDuration, m = e.selfBaseDuration, T = e.child; T !== null; )
            a = it(a, it(T.lanes, T.childLanes)), l |= T.subtreeFlags, l |= T.flags, c += T.actualDuration, m += T.treeBaseDuration, T = T.sibling;
          e.actualDuration = c, e.treeBaseDuration = m;
        } else
          for (var E = e.child; E !== null; )
            a = it(a, it(E.lanes, E.childLanes)), l |= E.subtreeFlags, l |= E.flags, E.return = e, E = E.sibling;
        e.subtreeFlags |= l;
      }
      return e.childLanes = a, t;
    }
    function o4(e, t, a) {
      if (Q3() && (t.mode & dt) !== _e && (t.flags & Oe) === Pe)
        return HL(t), zm(), t.flags |= kr | ff | Rr, !1;
      var l = dC(t);
      if (a !== null && a.dehydrated !== null)
        if (e === null) {
          if (!l)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (j3(t), cr(t), (t.mode & Ut) !== _e) {
            var c = a !== null;
            if (c) {
              var m = t.child;
              m !== null && (t.treeBaseDuration -= m.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (zm(), (t.flags & Oe) === Pe && (t.memoizedState = null), t.flags |= Et, cr(t), (t.mode & Ut) !== _e) {
            var T = a !== null;
            if (T) {
              var E = t.child;
              E !== null && (t.treeBaseDuration -= E.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return IL(), !0;
    }
    function dO(e, t, a) {
      var l = t.pendingProps;
      switch (Zk(t), t.tag) {
        case _:
        case de:
        case He:
        case D:
        case Ve:
        case ce:
        case Re:
        case ct:
        case Lt:
        case Tt:
          return cr(t), null;
        case $: {
          var c = t.type;
          return Xl(c) && aC(t), cr(t), null;
        }
        case A: {
          var m = t.stateNode;
          if (Im(t), Gk(t), kx(), m.pendingContext && (m.context = m.pendingContext, m.pendingContext = null), e === null || e.child === null) {
            var T = dC(t);
            if (T)
              Wm(t);
            else if (e !== null) {
              var E = e.memoizedState;
              // Check if this is a client root
              (!E.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (t.flags & kr) !== Pe) && (t.flags |= oi, IL());
            }
          }
          return x1(e, t), cr(t), null;
        }
        case W: {
          wx(t);
          var C = i$(), x = t.type;
          if (e !== null && t.stateNode != null)
            uO(e, t, x, l, C), e.ref !== t.ref && lO(t);
          else {
            if (!l) {
              if (t.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return cr(t), null;
            }
            var M = Tx(), z = dC(t);
            if (z)
              I3(t, C, M) && Wm(t);
            else {
              var N = DH(x, l, C, M, t);
              oO(N, t, !1, !1), t.stateNode = N, LH(N, x, l, C) && Wm(t);
            }
            t.ref !== null && lO(t);
          }
          return cr(t), null;
        }
        case ne: {
          var q = l;
          if (e && t.stateNode != null) {
            var Q = e.memoizedProps;
            cO(e, t, Q, q);
          } else {
            if (typeof q != "string" && t.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Y = i$(), ve = Tx(), Ue = dC(t);
            Ue ? q3(t) && Wm(t) : t.stateNode = OH(q, Y, ve, t);
          }
          return cr(t), null;
        }
        case Ye: {
          jm(t);
          var Me = t.memoizedState;
          if (e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            var kt = o4(e, t, Me);
            if (!kt)
              return t.flags & Rr ? t : null;
          }
          if ((t.flags & Oe) !== Pe)
            return t.lanes = a, (t.mode & Ut) !== _e && Kx(t), t;
          var pt = Me !== null, V = e !== null && e.memoizedState !== null;
          if (pt !== V && pt) {
            var G = t.child;
            if (G.flags |= Gn, (t.mode & dt) !== _e) {
              var H = e === null && (t.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
              H || Ex(sl.current, s$) ? uq() : j1();
            }
          }
          var ae = t.updateQueue;
          if (ae !== null && (t.flags |= Et), cr(t), (t.mode & Ut) !== _e && pt) {
            var Ee = t.child;
            Ee !== null && (t.treeBaseDuration -= Ee.treeBaseDuration);
          }
          return null;
        }
        case B:
          return Im(t), x1(e, t), e === null && k3(t.stateNode.containerInfo), cr(t), null;
        case $t:
          var Se = t.type._context;
          return fx(Se, t), cr(t), null;
        case Ge: {
          var Qe = t.type;
          return Xl(Qe) && aC(t), cr(t), null;
        }
        case Kt: {
          jm(t);
          var et = t.memoizedState;
          if (et === null)
            return cr(t), null;
          var tn = (t.flags & Oe) !== Pe, Vt = et.rendering;
          if (Vt === null)
            if (tn)
              PS(et, !1);
            else {
              var fi = dq() && (e === null || (e.flags & Oe) === Pe);
              if (!fi)
                for (var Ht = t.child; Ht !== null; ) {
                  var ti = RC(Ht);
                  if (ti !== null) {
                    tn = !0, t.flags |= Oe, PS(et, !1);
                    var zr = ti.updateQueue;
                    return zr !== null && (t.updateQueue = zr, t.flags |= Et), t.subtreeFlags = Pe, J3(t, a), jc(t, Cx(sl.current, wS)), t.child;
                  }
                  Ht = Ht.sibling;
                }
              et.tail !== null && ui() > OO() && (t.flags |= Oe, tn = !0, PS(et, !1), t.lanes = xg);
            }
          else {
            if (!tn) {
              var mr = RC(Vt);
              if (mr !== null) {
                t.flags |= Oe, tn = !0;
                var Za = mr.updateQueue;
                if (Za !== null && (t.updateQueue = Za, t.flags |= Et), PS(et, !0), et.tail === null && et.tailMode === "hidden" && !Vt.alternate && !or())
                  return cr(t), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              ui() * 2 - et.renderingStartTime > OO() && a !== Wr && (t.flags |= Oe, tn = !0, PS(et, !1), t.lanes = xg);
            }
            if (et.isBackwards)
              Vt.sibling = t.child, t.child = Vt;
            else {
              var ta = et.last;
              ta !== null ? ta.sibling = Vt : t.child = Vt, et.last = Vt;
            }
          }
          if (et.tail !== null) {
            var na = et.tail;
            et.rendering = na, et.tail = na.sibling, et.renderingStartTime = ui(), na.sibling = null;
            var Fr = sl.current;
            return tn ? Fr = Cx(Fr, wS) : Fr = qm(Fr), jc(t, Fr), na;
          }
          return cr(t), null;
        }
        case Mt:
          break;
        case Ae:
        case wt: {
          q1(t);
          var ku = t.memoizedState, iv = ku !== null;
          if (e !== null) {
            var KS = e.memoizedState, ao = KS !== null;
            ao !== iv && (t.flags |= Gn);
          }
          return !iv || (t.mode & dt) === _e ? cr(t) : $r(ro, Wr) && (cr(t), t.subtreeFlags & (Nn | Et) && (t.flags |= Gn)), null;
        }
        case Sn:
          return null;
        case Je:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function u4(e, t, a) {
      switch (Zk(t), t.tag) {
        case $: {
          var l = t.type;
          Xl(l) && aC(t);
          var c = t.flags;
          return c & Rr ? (t.flags = c & -65537 | Oe, (t.mode & Ut) !== _e && Kx(t), t) : null;
        }
        case A: {
          t.stateNode, Im(t), Gk(t), kx();
          var m = t.flags;
          return (m & Rr) !== Pe && (m & Oe) === Pe ? (t.flags = m & -65537 | Oe, t) : null;
        }
        case W:
          return wx(t), null;
        case Ye: {
          jm(t);
          var T = t.memoizedState;
          if (T !== null && T.dehydrated !== null) {
            if (t.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            zm();
          }
          var E = t.flags;
          return E & Rr ? (t.flags = E & -65537 | Oe, (t.mode & Ut) !== _e && Kx(t), t) : null;
        }
        case Kt:
          return jm(t), null;
        case B:
          return Im(t), null;
        case $t:
          var C = t.type._context;
          return fx(C, t), null;
        case Ae:
        case wt:
          return q1(t), null;
        case Sn:
          return null;
        default:
          return null;
      }
    }
    function fO(e, t, a) {
      switch (Zk(t), t.tag) {
        case $: {
          var l = t.type.childContextTypes;
          l != null && aC(t);
          break;
        }
        case A: {
          t.stateNode, Im(t), Gk(t), kx();
          break;
        }
        case W: {
          wx(t);
          break;
        }
        case B:
          Im(t);
          break;
        case Ye:
          jm(t);
          break;
        case Kt:
          jm(t);
          break;
        case $t:
          var c = t.type._context;
          fx(c, t);
          break;
        case Ae:
        case wt:
          q1(t);
          break;
      }
    }
    var hO = null;
    hO = /* @__PURE__ */ new Set();
    var XC = !1, dr = !1, c4 = typeof WeakSet == "function" ? WeakSet : Set, xe = null, Km = null, Xm = null;
    function d4(e) {
      Al(null, function() {
        throw e;
      }), df();
    }
    var f4 = function(e, t) {
      if (t.props = e.memoizedProps, t.state = e.memoizedState, e.mode & Ut)
        try {
          no(), t.componentWillUnmount();
        } finally {
          to(e);
        }
      else
        t.componentWillUnmount();
    };
    function pO(e, t) {
      try {
        Yc(Pi, e);
      } catch (a) {
        mn(e, t, a);
      }
    }
    function R1(e, t, a) {
      try {
        f4(e, a);
      } catch (l) {
        mn(e, t, l);
      }
    }
    function h4(e, t, a) {
      try {
        a.componentDidMount();
      } catch (l) {
        mn(e, t, l);
      }
    }
    function mO(e, t) {
      try {
        yO(e);
      } catch (a) {
        mn(e, t, a);
      }
    }
    function Zm(e, t) {
      var a = e.ref;
      if (a !== null)
        if (typeof a == "function") {
          var l;
          try {
            if (jn && oa && e.mode & Ut)
              try {
                no(), l = a(null);
              } finally {
                to(e);
              }
            else
              l = a(null);
          } catch (c) {
            mn(e, t, c);
          }
          typeof l == "function" && y("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", nt(e));
        } else
          a.current = null;
    }
    function ZC(e, t, a) {
      try {
        a();
      } catch (l) {
        mn(e, t, l);
      }
    }
    var vO = !1;
    function p4(e, t) {
      xH(e.containerInfo), xe = t, m4();
      var a = vO;
      return vO = !1, a;
    }
    function m4() {
      for (; xe !== null; ) {
        var e = xe, t = e.child;
        (e.subtreeFlags & _l) !== Pe && t !== null ? (t.return = e, xe = t) : v4();
      }
    }
    function v4() {
      for (; xe !== null; ) {
        var e = xe;
        pn(e);
        try {
          y4(e);
        } catch (a) {
          mn(e, e.return, a);
        }
        On();
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, xe = t;
          return;
        }
        xe = e.return;
      }
    }
    function y4(e) {
      var t = e.alternate, a = e.flags;
      if ((a & oi) !== Pe) {
        switch (pn(e), e.tag) {
          case D:
          case Ve:
          case He:
            break;
          case $: {
            if (t !== null) {
              var l = t.memoizedProps, c = t.memoizedState, m = e.stateNode;
              e.type === e.elementType && !rh && (m.props !== e.memoizedProps && y("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", nt(e) || "instance"), m.state !== e.memoizedState && y("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", nt(e) || "instance"));
              var T = m.getSnapshotBeforeUpdate(e.elementType === e.type ? l : ol(e.type, l), c);
              {
                var E = hO;
                T === void 0 && !E.has(e.type) && (E.add(e.type), y("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", nt(e)));
              }
              m.__reactInternalSnapshotBeforeUpdate = T;
            }
            break;
          }
          case A: {
            {
              var C = e.stateNode;
              XH(C.containerInfo);
            }
            break;
          }
          case W:
          case ne:
          case B:
          case Ge:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        On();
      }
    }
    function cl(e, t, a) {
      var l = t.updateQueue, c = l !== null ? l.lastEffect : null;
      if (c !== null) {
        var m = c.next, T = m;
        do {
          if ((T.tag & e) === e) {
            var E = T.destroy;
            T.destroy = void 0, E !== void 0 && ((e & ur) !== ka ? Xs(t) : (e & Pi) !== ka && pf(t), (e & Zl) !== ka && YS(!0), ZC(t, a, E), (e & Zl) !== ka && YS(!1), (e & ur) !== ka ? Fl() : (e & Pi) !== ka && bg());
          }
          T = T.next;
        } while (T !== m);
      }
    }
    function Yc(e, t) {
      var a = t.updateQueue, l = a !== null ? a.lastEffect : null;
      if (l !== null) {
        var c = l.next, m = c;
        do {
          if ((m.tag & e) === e) {
            (e & ur) !== ka ? Cg(t) : (e & Pi) !== ka && Ip(t);
            var T = m.create;
            (e & Zl) !== ka && YS(!0), m.destroy = T(), (e & Zl) !== ka && YS(!1), (e & ur) !== ka ? aE() : (e & Pi) !== ka && sE();
            {
              var E = m.destroy;
              if (E !== void 0 && typeof E != "function") {
                var C = void 0;
                (m.tag & Pi) !== Pe ? C = "useLayoutEffect" : (m.tag & Zl) !== Pe ? C = "useInsertionEffect" : C = "useEffect";
                var x = void 0;
                E === null ? x = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof E.then == "function" ? x = `

It looks like you wrote ` + C + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + C + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : x = " You returned: " + E, y("%s must not return anything besides a function, which is used for clean-up.%s", C, x);
              }
            }
          }
          m = m.next;
        } while (m !== c);
      }
    }
    function g4(e, t) {
      if ((t.flags & Et) !== Pe)
        switch (t.tag) {
          case ct: {
            var a = t.stateNode.passiveEffectDuration, l = t.memoizedProps, c = l.id, m = l.onPostCommit, T = O$(), E = t.alternate === null ? "mount" : "update";
            $$() && (E = "nested-update"), typeof m == "function" && m(c, E, a, T);
            var C = t.return;
            e: for (; C !== null; ) {
              switch (C.tag) {
                case A:
                  var x = C.stateNode;
                  x.passiveEffectDuration += a;
                  break e;
                case ct:
                  var M = C.stateNode;
                  M.passiveEffectDuration += a;
                  break e;
              }
              C = C.return;
            }
            break;
          }
        }
    }
    function S4(e, t, a, l) {
      if ((a.flags & Ul) !== Pe)
        switch (a.tag) {
          case D:
          case Ve:
          case He: {
            if (!dr)
              if (a.mode & Ut)
                try {
                  no(), Yc(Pi | Ai, a);
                } finally {
                  to(a);
                }
              else
                Yc(Pi | Ai, a);
            break;
          }
          case $: {
            var c = a.stateNode;
            if (a.flags & Et && !dr)
              if (t === null)
                if (a.type === a.elementType && !rh && (c.props !== a.memoizedProps && y("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", nt(a) || "instance"), c.state !== a.memoizedState && y("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", nt(a) || "instance")), a.mode & Ut)
                  try {
                    no(), c.componentDidMount();
                  } finally {
                    to(a);
                  }
                else
                  c.componentDidMount();
              else {
                var m = a.elementType === a.type ? t.memoizedProps : ol(a.type, t.memoizedProps), T = t.memoizedState;
                if (a.type === a.elementType && !rh && (c.props !== a.memoizedProps && y("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", nt(a) || "instance"), c.state !== a.memoizedState && y("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", nt(a) || "instance")), a.mode & Ut)
                  try {
                    no(), c.componentDidUpdate(m, T, c.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    to(a);
                  }
                else
                  c.componentDidUpdate(m, T, c.__reactInternalSnapshotBeforeUpdate);
              }
            var E = a.updateQueue;
            E !== null && (a.type === a.elementType && !rh && (c.props !== a.memoizedProps && y("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", nt(a) || "instance"), c.state !== a.memoizedState && y("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", nt(a) || "instance")), n$(a, E, c));
            break;
          }
          case A: {
            var C = a.updateQueue;
            if (C !== null) {
              var x = null;
              if (a.child !== null)
                switch (a.child.tag) {
                  case W:
                    x = a.child.stateNode;
                    break;
                  case $:
                    x = a.child.stateNode;
                    break;
                }
              n$(a, C, x);
            }
            break;
          }
          case W: {
            var M = a.stateNode;
            if (t === null && a.flags & Et) {
              var z = a.type, N = a.memoizedProps;
              UH(M, z, N);
            }
            break;
          }
          case ne:
            break;
          case B:
            break;
          case ct: {
            {
              var q = a.memoizedProps, Q = q.onCommit, Y = q.onRender, ve = a.stateNode.effectDuration, Ue = O$(), Me = t === null ? "mount" : "update";
              $$() && (Me = "nested-update"), typeof Y == "function" && Y(a.memoizedProps.id, Me, a.actualDuration, a.treeBaseDuration, a.actualStartTime, Ue);
              {
                typeof Q == "function" && Q(a.memoizedProps.id, Me, ve, Ue), vq(a);
                var kt = a.return;
                e: for (; kt !== null; ) {
                  switch (kt.tag) {
                    case A:
                      var pt = kt.stateNode;
                      pt.effectDuration += ve;
                      break e;
                    case ct:
                      var V = kt.stateNode;
                      V.effectDuration += ve;
                      break e;
                  }
                  kt = kt.return;
                }
              }
            }
            break;
          }
          case Ye: {
            R4(e, a);
            break;
          }
          case Kt:
          case Ge:
          case Mt:
          case Ae:
          case wt:
          case Je:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      dr || a.flags & An && yO(a);
    }
    function T4(e) {
      switch (e.tag) {
        case D:
        case Ve:
        case He: {
          if (e.mode & Ut)
            try {
              no(), pO(e, e.return);
            } finally {
              to(e);
            }
          else
            pO(e, e.return);
          break;
        }
        case $: {
          var t = e.stateNode;
          typeof t.componentDidMount == "function" && h4(e, e.return, t), mO(e, e.return);
          break;
        }
        case W: {
          mO(e, e.return);
          break;
        }
      }
    }
    function w4(e, t) {
      for (var a = null, l = e; ; ) {
        if (l.tag === W) {
          if (a === null) {
            a = l;
            try {
              var c = l.stateNode;
              t ? YH(c) : WH(l.stateNode, l.memoizedProps);
            } catch (T) {
              mn(e, e.return, T);
            }
          }
        } else if (l.tag === ne) {
          if (a === null)
            try {
              var m = l.stateNode;
              t ? GH(m) : KH(m, l.memoizedProps);
            } catch (T) {
              mn(e, e.return, T);
            }
        } else if (!((l.tag === Ae || l.tag === wt) && l.memoizedState !== null && l !== e)) {
          if (l.child !== null) {
            l.child.return = l, l = l.child;
            continue;
          }
        }
        if (l === e)
          return;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === e)
            return;
          a === l && (a = null), l = l.return;
        }
        a === l && (a = null), l.sibling.return = l.return, l = l.sibling;
      }
    }
    function yO(e) {
      var t = e.ref;
      if (t !== null) {
        var a = e.stateNode, l;
        switch (e.tag) {
          case W:
            l = a;
            break;
          default:
            l = a;
        }
        if (typeof t == "function") {
          var c;
          if (e.mode & Ut)
            try {
              no(), c = t(l);
            } finally {
              to(e);
            }
          else
            c = t(l);
          typeof c == "function" && y("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", nt(e));
        } else
          t.hasOwnProperty("current") || y("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", nt(e)), t.current = l;
      }
    }
    function E4(e) {
      var t = e.alternate;
      t !== null && (t.return = null), e.return = null;
    }
    function gO(e) {
      var t = e.alternate;
      t !== null && (e.alternate = null, gO(t));
      {
        if (e.child = null, e.deletions = null, e.sibling = null, e.tag === W) {
          var a = e.stateNode;
          a !== null && D3(a);
        }
        e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
      }
    }
    function C4(e) {
      for (var t = e.return; t !== null; ) {
        if (SO(t))
          return t;
        t = t.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function SO(e) {
      return e.tag === W || e.tag === A || e.tag === B;
    }
    function TO(e) {
      var t = e;
      e: for (; ; ) {
        for (; t.sibling === null; ) {
          if (t.return === null || SO(t.return))
            return null;
          t = t.return;
        }
        for (t.sibling.return = t.return, t = t.sibling; t.tag !== W && t.tag !== ne && t.tag !== ft; ) {
          if (t.flags & Nn || t.child === null || t.tag === B)
            continue e;
          t.child.return = t, t = t.child;
        }
        if (!(t.flags & Nn))
          return t.stateNode;
      }
    }
    function b4(e) {
      var t = C4(e);
      switch (t.tag) {
        case W: {
          var a = t.stateNode;
          t.flags & Ba && (EL(a), t.flags &= -33);
          var l = TO(e);
          M1(e, l, a);
          break;
        }
        case A:
        case B: {
          var c = t.stateNode.containerInfo, m = TO(e);
          D1(e, m, c);
          break;
        }
        // eslint-disable-next-line-no-fallthrough
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function D1(e, t, a) {
      var l = e.tag, c = l === W || l === ne;
      if (c) {
        var m = e.stateNode;
        t ? qH(a, m, t) : HH(a, m);
      } else if (l !== B) {
        var T = e.child;
        if (T !== null) {
          D1(T, t, a);
          for (var E = T.sibling; E !== null; )
            D1(E, t, a), E = E.sibling;
        }
      }
    }
    function M1(e, t, a) {
      var l = e.tag, c = l === W || l === ne;
      if (c) {
        var m = e.stateNode;
        t ? IH(a, m, t) : VH(a, m);
      } else if (l !== B) {
        var T = e.child;
        if (T !== null) {
          M1(T, t, a);
          for (var E = T.sibling; E !== null; )
            M1(E, t, a), E = E.sibling;
        }
      }
    }
    var fr = null, dl = !1;
    function k4(e, t, a) {
      {
        var l = t;
        e: for (; l !== null; ) {
          switch (l.tag) {
            case W: {
              fr = l.stateNode, dl = !1;
              break e;
            }
            case A: {
              fr = l.stateNode.containerInfo, dl = !0;
              break e;
            }
            case B: {
              fr = l.stateNode.containerInfo, dl = !0;
              break e;
            }
          }
          l = l.return;
        }
        if (fr === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        wO(e, t, a), fr = null, dl = !1;
      }
      E4(a);
    }
    function Gc(e, t, a) {
      for (var l = a.child; l !== null; )
        wO(e, t, l), l = l.sibling;
    }
    function wO(e, t, a) {
      switch (Tg(a), a.tag) {
        case W:
          dr || Zm(a, t);
        // eslint-disable-next-line-no-fallthrough
        case ne: {
          {
            var l = fr, c = dl;
            fr = null, Gc(e, t, a), fr = l, dl = c, fr !== null && (dl ? BH(fr, a.stateNode) : jH(fr, a.stateNode));
          }
          return;
        }
        case ft: {
          fr !== null && (dl ? QH(fr, a.stateNode) : Vk(fr, a.stateNode));
          return;
        }
        case B: {
          {
            var m = fr, T = dl;
            fr = a.stateNode.containerInfo, dl = !0, Gc(e, t, a), fr = m, dl = T;
          }
          return;
        }
        case D:
        case Ve:
        case Tt:
        case He: {
          if (!dr) {
            var E = a.updateQueue;
            if (E !== null) {
              var C = E.lastEffect;
              if (C !== null) {
                var x = C.next, M = x;
                do {
                  var z = M, N = z.destroy, q = z.tag;
                  N !== void 0 && ((q & Zl) !== ka ? ZC(a, t, N) : (q & Pi) !== ka && (pf(a), a.mode & Ut ? (no(), ZC(a, t, N), to(a)) : ZC(a, t, N), bg())), M = M.next;
                } while (M !== x);
              }
            }
          }
          Gc(e, t, a);
          return;
        }
        case $: {
          if (!dr) {
            Zm(a, t);
            var Q = a.stateNode;
            typeof Q.componentWillUnmount == "function" && R1(a, t, Q);
          }
          Gc(e, t, a);
          return;
        }
        case Mt: {
          Gc(e, t, a);
          return;
        }
        case Ae: {
          if (
            // TODO: Remove this dead flag
            a.mode & dt
          ) {
            var Y = dr;
            dr = Y || a.memoizedState !== null, Gc(e, t, a), dr = Y;
          } else
            Gc(e, t, a);
          break;
        }
        default: {
          Gc(e, t, a);
          return;
        }
      }
    }
    function x4(e) {
      e.memoizedState;
    }
    function R4(e, t) {
      var a = t.memoizedState;
      if (a === null) {
        var l = t.alternate;
        if (l !== null) {
          var c = l.memoizedState;
          if (c !== null) {
            var m = c.dehydrated;
            m !== null && d3(m);
          }
        }
      }
    }
    function EO(e) {
      var t = e.updateQueue;
      if (t !== null) {
        e.updateQueue = null;
        var a = e.stateNode;
        a === null && (a = e.stateNode = new c4()), t.forEach(function(l) {
          var c = Cq.bind(null, e, l);
          if (!a.has(l)) {
            if (a.add(l), Lr)
              if (Km !== null && Xm !== null)
                QS(Xm, Km);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            l.then(c, c);
          }
        });
      }
    }
    function D4(e, t, a) {
      Km = a, Xm = e, pn(t), CO(t, e), pn(t), Km = null, Xm = null;
    }
    function fl(e, t, a) {
      var l = t.deletions;
      if (l !== null)
        for (var c = 0; c < l.length; c++) {
          var m = l[c];
          try {
            k4(e, t, m);
          } catch (C) {
            mn(m, t, C);
          }
        }
      var T = Gd();
      if (t.subtreeFlags & Nl)
        for (var E = t.child; E !== null; )
          pn(E), CO(E, e), E = E.sibling;
      pn(T);
    }
    function CO(e, t, a) {
      var l = e.alternate, c = e.flags;
      switch (e.tag) {
        case D:
        case Ve:
        case Tt:
        case He: {
          if (fl(t, e), io(e), c & Et) {
            try {
              cl(Zl | Ai, e, e.return), Yc(Zl | Ai, e);
            } catch (Qe) {
              mn(e, e.return, Qe);
            }
            if (e.mode & Ut) {
              try {
                no(), cl(Pi | Ai, e, e.return);
              } catch (Qe) {
                mn(e, e.return, Qe);
              }
              to(e);
            } else
              try {
                cl(Pi | Ai, e, e.return);
              } catch (Qe) {
                mn(e, e.return, Qe);
              }
          }
          return;
        }
        case $: {
          fl(t, e), io(e), c & An && l !== null && Zm(l, l.return);
          return;
        }
        case W: {
          fl(t, e), io(e), c & An && l !== null && Zm(l, l.return);
          {
            if (e.flags & Ba) {
              var m = e.stateNode;
              try {
                EL(m);
              } catch (Qe) {
                mn(e, e.return, Qe);
              }
            }
            if (c & Et) {
              var T = e.stateNode;
              if (T != null) {
                var E = e.memoizedProps, C = l !== null ? l.memoizedProps : E, x = e.type, M = e.updateQueue;
                if (e.updateQueue = null, M !== null)
                  try {
                    zH(T, M, x, C, E, e);
                  } catch (Qe) {
                    mn(e, e.return, Qe);
                  }
              }
            }
          }
          return;
        }
        case ne: {
          if (fl(t, e), io(e), c & Et) {
            if (e.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var z = e.stateNode, N = e.memoizedProps, q = l !== null ? l.memoizedProps : N;
            try {
              FH(z, q, N);
            } catch (Qe) {
              mn(e, e.return, Qe);
            }
          }
          return;
        }
        case A: {
          if (fl(t, e), io(e), c & Et && l !== null) {
            var Q = l.memoizedState;
            if (Q.isDehydrated)
              try {
                c3(t.containerInfo);
              } catch (Qe) {
                mn(e, e.return, Qe);
              }
          }
          return;
        }
        case B: {
          fl(t, e), io(e);
          return;
        }
        case Ye: {
          fl(t, e), io(e);
          var Y = e.child;
          if (Y.flags & Gn) {
            var ve = Y.stateNode, Ue = Y.memoizedState, Me = Ue !== null;
            if (ve.isHidden = Me, Me) {
              var kt = Y.alternate !== null && Y.alternate.memoizedState !== null;
              kt || oq();
            }
          }
          if (c & Et) {
            try {
              x4(e);
            } catch (Qe) {
              mn(e, e.return, Qe);
            }
            EO(e);
          }
          return;
        }
        case Ae: {
          var pt = l !== null && l.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            e.mode & dt
          ) {
            var V = dr;
            dr = V || pt, fl(t, e), dr = V;
          } else
            fl(t, e);
          if (io(e), c & Gn) {
            var G = e.stateNode, H = e.memoizedState, ae = H !== null, Ee = e;
            if (G.isHidden = ae, ae && !pt && (Ee.mode & dt) !== _e) {
              xe = Ee;
              for (var Se = Ee.child; Se !== null; )
                xe = Se, L4(Se), Se = Se.sibling;
            }
            w4(Ee, ae);
          }
          return;
        }
        case Kt: {
          fl(t, e), io(e), c & Et && EO(e);
          return;
        }
        case Mt:
          return;
        default: {
          fl(t, e), io(e);
          return;
        }
      }
    }
    function io(e) {
      var t = e.flags;
      if (t & Nn) {
        try {
          b4(e);
        } catch (a) {
          mn(e, e.return, a);
        }
        e.flags &= -3;
      }
      t & ma && (e.flags &= -4097);
    }
    function M4(e, t, a) {
      Km = a, Xm = t, xe = e, bO(e, t, a), Km = null, Xm = null;
    }
    function bO(e, t, a) {
      for (var l = (e.mode & dt) !== _e; xe !== null; ) {
        var c = xe, m = c.child;
        if (c.tag === Ae && l) {
          var T = c.memoizedState !== null, E = T || XC;
          if (E) {
            L1(e, t, a);
            continue;
          } else {
            var C = c.alternate, x = C !== null && C.memoizedState !== null, M = x || dr, z = XC, N = dr;
            XC = E, dr = M, dr && !N && (xe = c, $4(c));
            for (var q = m; q !== null; )
              xe = q, bO(
                q,
                // New root; bubble back up to here and stop.
                t,
                a
              ), q = q.sibling;
            xe = c, XC = z, dr = N, L1(e, t, a);
            continue;
          }
        }
        (c.subtreeFlags & Ul) !== Pe && m !== null ? (m.return = c, xe = m) : L1(e, t, a);
      }
    }
    function L1(e, t, a) {
      for (; xe !== null; ) {
        var l = xe;
        if ((l.flags & Ul) !== Pe) {
          var c = l.alternate;
          pn(l);
          try {
            S4(t, c, l, a);
          } catch (T) {
            mn(l, l.return, T);
          }
          On();
        }
        if (l === e) {
          xe = null;
          return;
        }
        var m = l.sibling;
        if (m !== null) {
          m.return = l.return, xe = m;
          return;
        }
        xe = l.return;
      }
    }
    function L4(e) {
      for (; xe !== null; ) {
        var t = xe, a = t.child;
        switch (t.tag) {
          case D:
          case Ve:
          case Tt:
          case He: {
            if (t.mode & Ut)
              try {
                no(), cl(Pi, t, t.return);
              } finally {
                to(t);
              }
            else
              cl(Pi, t, t.return);
            break;
          }
          case $: {
            Zm(t, t.return);
            var l = t.stateNode;
            typeof l.componentWillUnmount == "function" && R1(t, t.return, l);
            break;
          }
          case W: {
            Zm(t, t.return);
            break;
          }
          case Ae: {
            var c = t.memoizedState !== null;
            if (c) {
              kO(e);
              continue;
            }
            break;
          }
        }
        a !== null ? (a.return = t, xe = a) : kO(e);
      }
    }
    function kO(e) {
      for (; xe !== null; ) {
        var t = xe;
        if (t === e) {
          xe = null;
          return;
        }
        var a = t.sibling;
        if (a !== null) {
          a.return = t.return, xe = a;
          return;
        }
        xe = t.return;
      }
    }
    function $4(e) {
      for (; xe !== null; ) {
        var t = xe, a = t.child;
        if (t.tag === Ae) {
          var l = t.memoizedState !== null;
          if (l) {
            xO(e);
            continue;
          }
        }
        a !== null ? (a.return = t, xe = a) : xO(e);
      }
    }
    function xO(e) {
      for (; xe !== null; ) {
        var t = xe;
        pn(t);
        try {
          T4(t);
        } catch (l) {
          mn(t, t.return, l);
        }
        if (On(), t === e) {
          xe = null;
          return;
        }
        var a = t.sibling;
        if (a !== null) {
          a.return = t.return, xe = a;
          return;
        }
        xe = t.return;
      }
    }
    function O4(e, t, a, l) {
      xe = t, A4(t, e, a, l);
    }
    function A4(e, t, a, l) {
      for (; xe !== null; ) {
        var c = xe, m = c.child;
        (c.subtreeFlags & Ws) !== Pe && m !== null ? (m.return = c, xe = m) : P4(e, t, a, l);
      }
    }
    function P4(e, t, a, l) {
      for (; xe !== null; ) {
        var c = xe;
        if ((c.flags & xr) !== Pe) {
          pn(c);
          try {
            _4(t, c, a, l);
          } catch (T) {
            mn(c, c.return, T);
          }
          On();
        }
        if (c === e) {
          xe = null;
          return;
        }
        var m = c.sibling;
        if (m !== null) {
          m.return = c.return, xe = m;
          return;
        }
        xe = c.return;
      }
    }
    function _4(e, t, a, l) {
      switch (t.tag) {
        case D:
        case Ve:
        case He: {
          if (t.mode & Ut) {
            Wx();
            try {
              Yc(ur | Ai, t);
            } finally {
              Gx(t);
            }
          } else
            Yc(ur | Ai, t);
          break;
        }
      }
    }
    function N4(e) {
      xe = e, U4();
    }
    function U4() {
      for (; xe !== null; ) {
        var e = xe, t = e.child;
        if ((xe.flags & pa) !== Pe) {
          var a = e.deletions;
          if (a !== null) {
            for (var l = 0; l < a.length; l++) {
              var c = a[l];
              xe = c, V4(c, e);
            }
            {
              var m = e.alternate;
              if (m !== null) {
                var T = m.child;
                if (T !== null) {
                  m.child = null;
                  do {
                    var E = T.sibling;
                    T.sibling = null, T = E;
                  } while (T !== null);
                }
              }
            }
            xe = e;
          }
        }
        (e.subtreeFlags & Ws) !== Pe && t !== null ? (t.return = e, xe = t) : z4();
      }
    }
    function z4() {
      for (; xe !== null; ) {
        var e = xe;
        (e.flags & xr) !== Pe && (pn(e), F4(e), On());
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, xe = t;
          return;
        }
        xe = e.return;
      }
    }
    function F4(e) {
      switch (e.tag) {
        case D:
        case Ve:
        case He: {
          e.mode & Ut ? (Wx(), cl(ur | Ai, e, e.return), Gx(e)) : cl(ur | Ai, e, e.return);
          break;
        }
      }
    }
    function V4(e, t) {
      for (; xe !== null; ) {
        var a = xe;
        pn(a), I4(a, t), On();
        var l = a.child;
        l !== null ? (l.return = a, xe = l) : H4(e);
      }
    }
    function H4(e) {
      for (; xe !== null; ) {
        var t = xe, a = t.sibling, l = t.return;
        if (gO(t), t === e) {
          xe = null;
          return;
        }
        if (a !== null) {
          a.return = l, xe = a;
          return;
        }
        xe = l;
      }
    }
    function I4(e, t) {
      switch (e.tag) {
        case D:
        case Ve:
        case He: {
          e.mode & Ut ? (Wx(), cl(ur, e, t), Gx(e)) : cl(ur, e, t);
          break;
        }
      }
    }
    function q4(e) {
      switch (e.tag) {
        case D:
        case Ve:
        case He: {
          try {
            Yc(Pi | Ai, e);
          } catch (a) {
            mn(e, e.return, a);
          }
          break;
        }
        case $: {
          var t = e.stateNode;
          try {
            t.componentDidMount();
          } catch (a) {
            mn(e, e.return, a);
          }
          break;
        }
      }
    }
    function j4(e) {
      switch (e.tag) {
        case D:
        case Ve:
        case He: {
          try {
            Yc(ur | Ai, e);
          } catch (t) {
            mn(e, e.return, t);
          }
          break;
        }
      }
    }
    function B4(e) {
      switch (e.tag) {
        case D:
        case Ve:
        case He: {
          try {
            cl(Pi | Ai, e, e.return);
          } catch (a) {
            mn(e, e.return, a);
          }
          break;
        }
        case $: {
          var t = e.stateNode;
          typeof t.componentWillUnmount == "function" && R1(e, e.return, t);
          break;
        }
      }
    }
    function Q4(e) {
      switch (e.tag) {
        case D:
        case Ve:
        case He:
          try {
            cl(ur | Ai, e, e.return);
          } catch (t) {
            mn(e, e.return, t);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var _S = Symbol.for;
      _S("selector.component"), _S("selector.has_pseudo_class"), _S("selector.role"), _S("selector.test_id"), _S("selector.text");
    }
    var Y4 = [];
    function G4() {
      Y4.forEach(function(e) {
        return e();
      });
    }
    var W4 = n.ReactCurrentActQueue;
    function K4(e) {
      {
        var t = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), a = typeof jest < "u";
        return a && t !== !1;
      }
    }
    function RO() {
      {
        var e = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !e && W4.current !== null && y("The current testing environment is not configured to support act(...)"), e;
      }
    }
    var X4 = Math.ceil, $1 = n.ReactCurrentDispatcher, O1 = n.ReactCurrentOwner, hr = n.ReactCurrentBatchConfig, hl = n.ReactCurrentActQueue, Ui = (
      /*             */
      0
    ), DO = (
      /*               */
      1
    ), pr = (
      /*                */
      2
    ), Ls = (
      /*                */
      4
    ), wu = 0, NS = 1, ah = 2, JC = 3, US = 4, MO = 5, A1 = 6, bt = Ui, Jr = null, In = null, zi = ee, ro = ee, P1 = zc(ee), Fi = wu, zS = null, eb = ee, FS = ee, tb = ee, VS = null, xa = null, _1 = 0, LO = 500, $O = 1 / 0, Z4 = 500, Eu = null;
    function HS() {
      $O = ui() + Z4;
    }
    function OO() {
      return $O;
    }
    var nb = !1, N1 = null, Jm = null, sh = !1, Wc = null, IS = ee, U1 = [], z1 = null, J4 = 50, qS = 0, F1 = null, V1 = !1, ib = !1, eq = 50, ev = 0, rb = null, jS = ln, ab = ee, AO = !1;
    function sb() {
      return Jr;
    }
    function ea() {
      return (bt & (pr | Ls)) !== Ui ? ui() : (jS !== ln || (jS = ui()), jS);
    }
    function Kc(e) {
      var t = e.mode;
      if ((t & dt) === _e)
        return je;
      if ((bt & pr) !== Ui && zi !== ee)
        return Rf(zi);
      var a = W3() !== G3;
      if (a) {
        if (hr.transition !== null) {
          var l = hr.transition;
          l._updatedFibers || (l._updatedFibers = /* @__PURE__ */ new Set()), l._updatedFibers.add(e);
        }
        return ab === Ot && (ab = Og()), ab;
      }
      var c = wa();
      if (c !== Ot)
        return c;
      var m = AH();
      return m;
    }
    function tq(e) {
      var t = e.mode;
      return (t & dt) === _e ? je : fE();
    }
    function Vi(e, t, a, l) {
      kq(), AO && y("useInsertionEffect must not schedule updates."), V1 && (ib = !0), Rc(e, a, l), (bt & pr) !== ee && e === Jr ? Dq(t) : (Lr && Lf(e, t, a), Mq(t), e === Jr && ((bt & pr) === Ui && (FS = it(FS, a)), Fi === US && Xc(e, zi)), Ra(e, l), a === je && bt === Ui && (t.mode & dt) === _e && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !hl.isBatchingLegacy && (HS(), AL()));
    }
    function nq(e, t, a) {
      var l = e.current;
      l.lanes = t, Rc(e, t, a), Ra(e, a);
    }
    function iq(e) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (bt & pr) !== Ui
      );
    }
    function Ra(e, t) {
      var a = e.callbackNode;
      om(e, t);
      var l = lm(e, e === Jr ? zi : ee);
      if (l === ee) {
        a !== null && WO(a), e.callbackNode = null, e.callbackPriority = Ot;
        return;
      }
      var c = Il(l), m = e.callbackPriority;
      if (m === c && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(hl.current !== null && a !== Y1)) {
        a == null && m !== je && y("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      a != null && WO(a);
      var T;
      if (c === je)
        e.tag === Fc ? (hl.isBatchingLegacy !== null && (hl.didScheduleLegacyUpdate = !0), $3(NO.bind(null, e))) : OL(NO.bind(null, e)), hl.current !== null ? hl.current.push(Vc) : _H(function() {
          (bt & (pr | Ls)) === Ui && Vc();
        }), T = null;
      else {
        var E;
        switch (SE(l)) {
          case ir:
            E = hf;
            break;
          case Ts:
            E = zl;
            break;
          case Sa:
            E = Ks;
            break;
          case Ta:
            E = Ko;
            break;
          default:
            E = Ks;
            break;
        }
        T = G1(E, PO.bind(null, e));
      }
      e.callbackPriority = c, e.callbackNode = T;
    }
    function PO(e, t) {
      if (wI(), jS = ln, ab = ee, (bt & (pr | Ls)) !== Ui)
        throw new Error("Should not already be working.");
      var a = e.callbackNode, l = bu();
      if (l && e.callbackNode !== a)
        return null;
      var c = lm(e, e === Jr ? zi : ee);
      if (c === ee)
        return null;
      var m = !cm(e, c) && !dE(e, c) && !t, T = m ? hq(e, c) : ob(e, c);
      if (T !== wu) {
        if (T === ah) {
          var E = um(e);
          E !== ee && (c = E, T = H1(e, E));
        }
        if (T === NS) {
          var C = zS;
          throw lh(e, ee), Xc(e, c), Ra(e, ui()), C;
        }
        if (T === A1)
          Xc(e, c);
        else {
          var x = !cm(e, c), M = e.current.alternate;
          if (x && !aq(M)) {
            if (T = ob(e, c), T === ah) {
              var z = um(e);
              z !== ee && (c = z, T = H1(e, z));
            }
            if (T === NS) {
              var N = zS;
              throw lh(e, ee), Xc(e, c), Ra(e, ui()), N;
            }
          }
          e.finishedWork = M, e.finishedLanes = c, rq(e, T, c);
        }
      }
      return Ra(e, ui()), e.callbackNode === a ? PO.bind(null, e) : null;
    }
    function H1(e, t) {
      var a = VS;
      if (hm(e)) {
        var l = lh(e, t);
        l.flags |= kr, b3(e.containerInfo);
      }
      var c = ob(e, t);
      if (c !== ah) {
        var m = xa;
        xa = a, m !== null && _O(m);
      }
      return c;
    }
    function _O(e) {
      xa === null ? xa = e : xa.push.apply(xa, e);
    }
    function rq(e, t, a) {
      switch (t) {
        case wu:
        case NS:
          throw new Error("Root did not complete. This is a bug in React.");
        // Flow knows about invariant, so it complains if I add a break
        // statement, but eslint doesn't know about invariant, so it complains
        // if I do. eslint-disable-next-line no-fallthrough
        case ah: {
          oh(e, xa, Eu);
          break;
        }
        case JC: {
          if (Xc(e, a), lu(a) && // do not delay if we're inside an act() scope
          !KO()) {
            var l = _1 + LO - ui();
            if (l > 10) {
              var c = lm(e, ee);
              if (c !== ee)
                break;
              var m = e.suspendedLanes;
              if (!ou(m, a)) {
                ea(), dm(e, m);
                break;
              }
              e.timeoutHandle = zk(oh.bind(null, e, xa, Eu), l);
              break;
            }
          }
          oh(e, xa, Eu);
          break;
        }
        case US: {
          if (Xc(e, a), Lg(a))
            break;
          if (!KO()) {
            var T = Ya(e, a), E = T, C = ui() - E, x = bq(C) - C;
            if (x > 10) {
              e.timeoutHandle = zk(oh.bind(null, e, xa, Eu), x);
              break;
            }
          }
          oh(e, xa, Eu);
          break;
        }
        case MO: {
          oh(e, xa, Eu);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function aq(e) {
      for (var t = e; ; ) {
        if (t.flags & Ec) {
          var a = t.updateQueue;
          if (a !== null) {
            var l = a.stores;
            if (l !== null)
              for (var c = 0; c < l.length; c++) {
                var m = l[c], T = m.getSnapshot, E = m.value;
                try {
                  if (!ge(T(), E))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var C = t.child;
        if (t.subtreeFlags & Ec && C !== null) {
          C.return = t, t = C;
          continue;
        }
        if (t === e)
          return !0;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return !0;
    }
    function Xc(e, t) {
      t = Df(t, tb), t = Df(t, FS), mE(e, t);
    }
    function NO(e) {
      if (EI(), (bt & (pr | Ls)) !== Ui)
        throw new Error("Should not already be working.");
      bu();
      var t = lm(e, ee);
      if (!$r(t, je))
        return Ra(e, ui()), null;
      var a = ob(e, t);
      if (e.tag !== Fc && a === ah) {
        var l = um(e);
        l !== ee && (t = l, a = H1(e, l));
      }
      if (a === NS) {
        var c = zS;
        throw lh(e, ee), Xc(e, t), Ra(e, ui()), c;
      }
      if (a === A1)
        throw new Error("Root did not complete. This is a bug in React.");
      var m = e.current.alternate;
      return e.finishedWork = m, e.finishedLanes = t, oh(e, xa, Eu), Ra(e, ui()), null;
    }
    function sq(e, t) {
      t !== ee && (fm(e, it(t, je)), Ra(e, ui()), (bt & (pr | Ls)) === Ui && (HS(), Vc()));
    }
    function I1(e, t) {
      var a = bt;
      bt |= DO;
      try {
        return e(t);
      } finally {
        bt = a, bt === Ui && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !hl.isBatchingLegacy && (HS(), AL());
      }
    }
    function lq(e, t, a, l, c) {
      var m = wa(), T = hr.transition;
      try {
        return hr.transition = null, Zn(ir), e(t, a, l, c);
      } finally {
        Zn(m), hr.transition = T, bt === Ui && HS();
      }
    }
    function Cu(e) {
      Wc !== null && Wc.tag === Fc && (bt & (pr | Ls)) === Ui && bu();
      var t = bt;
      bt |= DO;
      var a = hr.transition, l = wa();
      try {
        return hr.transition = null, Zn(ir), e ? e() : void 0;
      } finally {
        Zn(l), hr.transition = a, bt = t, (bt & (pr | Ls)) === Ui && Vc();
      }
    }
    function UO() {
      return (bt & (pr | Ls)) !== Ui;
    }
    function lb(e, t) {
      Nr(P1, ro, e), ro = it(ro, t);
    }
    function q1(e) {
      ro = P1.current, _r(P1, e);
    }
    function lh(e, t) {
      e.finishedWork = null, e.finishedLanes = ee;
      var a = e.timeoutHandle;
      if (a !== Fk && (e.timeoutHandle = Fk, PH(a)), In !== null)
        for (var l = In.return; l !== null; ) {
          var c = l.alternate;
          fO(c, l), l = l.return;
        }
      Jr = e;
      var m = uh(e.current, null);
      return In = m, zi = ro = t, Fi = wu, zS = null, eb = ee, FS = ee, tb = ee, VS = null, xa = null, nI(), al.discardPendingWarnings(), m;
    }
    function zO(e, t) {
      do {
        var a = In;
        try {
          if (yC(), o$(), On(), O1.current = null, a === null || a.return === null) {
            Fi = NS, zS = t, In = null;
            return;
          }
          if (jn && a.mode & Ut && QC(a, !0), Ii)
            if (Gr(), t !== null && typeof t == "object" && typeof t.then == "function") {
              var l = t;
              Ss(a, l, zi);
            } else
              mf(a, t, zi);
          $I(e, a.return, a, t, zi), IO(a);
        } catch (c) {
          t = c, In === a && a !== null ? (a = a.return, In = a) : a = In;
          continue;
        }
        return;
      } while (!0);
    }
    function FO() {
      var e = $1.current;
      return $1.current = HC, e === null ? HC : e;
    }
    function VO(e) {
      $1.current = e;
    }
    function oq() {
      _1 = ui();
    }
    function BS(e) {
      eb = it(e, eb);
    }
    function uq() {
      Fi === wu && (Fi = JC);
    }
    function j1() {
      (Fi === wu || Fi === JC || Fi === ah) && (Fi = US), Jr !== null && (xf(eb) || xf(FS)) && Xc(Jr, zi);
    }
    function cq(e) {
      Fi !== US && (Fi = ah), VS === null ? VS = [e] : VS.push(e);
    }
    function dq() {
      return Fi === wu;
    }
    function ob(e, t) {
      var a = bt;
      bt |= pr;
      var l = FO();
      if (Jr !== e || zi !== t) {
        if (Lr) {
          var c = e.memoizedUpdaters;
          c.size > 0 && (QS(e, zi), c.clear()), vE(e, t);
        }
        Eu = Ng(), lh(e, t);
      }
      eu(t);
      do
        try {
          fq();
          break;
        } catch (m) {
          zO(e, m);
        }
      while (!0);
      if (yC(), bt = a, VO(l), In !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return qp(), Jr = null, zi = ee, Fi;
    }
    function fq() {
      for (; In !== null; )
        HO(In);
    }
    function hq(e, t) {
      var a = bt;
      bt |= pr;
      var l = FO();
      if (Jr !== e || zi !== t) {
        if (Lr) {
          var c = e.memoizedUpdaters;
          c.size > 0 && (QS(e, zi), c.clear()), vE(e, t);
        }
        Eu = Ng(), HS(), lh(e, t);
      }
      eu(t);
      do
        try {
          pq();
          break;
        } catch (m) {
          zO(e, m);
        }
      while (!0);
      return yC(), VO(l), bt = a, In !== null ? (lE(), wu) : (qp(), Jr = null, zi = ee, Fi);
    }
    function pq() {
      for (; In !== null && !mg(); )
        HO(In);
    }
    function HO(e) {
      var t = e.alternate;
      pn(e);
      var a;
      (e.mode & Ut) !== _e ? (Yx(e), a = B1(t, e, ro), QC(e, !0)) : a = B1(t, e, ro), On(), e.memoizedProps = e.pendingProps, a === null ? IO(e) : In = a, O1.current = null;
    }
    function IO(e) {
      var t = e;
      do {
        var a = t.alternate, l = t.return;
        if ((t.flags & ff) === Pe) {
          pn(t);
          var c = void 0;
          if ((t.mode & Ut) === _e ? c = dO(a, t, ro) : (Yx(t), c = dO(a, t, ro), QC(t, !1)), On(), c !== null) {
            In = c;
            return;
          }
        } else {
          var m = u4(a, t);
          if (m !== null) {
            m.flags &= tE, In = m;
            return;
          }
          if ((t.mode & Ut) !== _e) {
            QC(t, !1);
            for (var T = t.actualDuration, E = t.child; E !== null; )
              T += E.actualDuration, E = E.sibling;
            t.actualDuration = T;
          }
          if (l !== null)
            l.flags |= ff, l.subtreeFlags = Pe, l.deletions = null;
          else {
            Fi = A1, In = null;
            return;
          }
        }
        var C = t.sibling;
        if (C !== null) {
          In = C;
          return;
        }
        t = l, In = t;
      } while (t !== null);
      Fi === wu && (Fi = MO);
    }
    function oh(e, t, a) {
      var l = wa(), c = hr.transition;
      try {
        hr.transition = null, Zn(ir), mq(e, t, a, l);
      } finally {
        hr.transition = c, Zn(l);
      }
      return null;
    }
    function mq(e, t, a, l) {
      do
        bu();
      while (Wc !== null);
      if (xq(), (bt & (pr | Ls)) !== Ui)
        throw new Error("Should not already be working.");
      var c = e.finishedWork, m = e.finishedLanes;
      if (wg(m), c === null)
        return Eg(), null;
      if (m === ee && y("root.finishedLanes should not be empty during a commit. This is a bug in React."), e.finishedWork = null, e.finishedLanes = ee, c === e.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      e.callbackNode = null, e.callbackPriority = Ot;
      var T = it(c.lanes, c.childLanes);
      Pg(e, T), e === Jr && (Jr = null, In = null, zi = ee), ((c.subtreeFlags & Ws) !== Pe || (c.flags & Ws) !== Pe) && (sh || (sh = !0, z1 = a, G1(Ks, function() {
        return bu(), null;
      })));
      var E = (c.subtreeFlags & (_l | Nl | Ul | Ws)) !== Pe, C = (c.flags & (_l | Nl | Ul | Ws)) !== Pe;
      if (E || C) {
        var x = hr.transition;
        hr.transition = null;
        var M = wa();
        Zn(ir);
        var z = bt;
        bt |= Ls, O1.current = null, p4(e, c), A$(), D4(e, c, m), RH(e.containerInfo), e.current = c, vf(m), M4(c, e, m), yf(), vg(), bt = z, Zn(M), hr.transition = x;
      } else
        e.current = c, A$();
      var N = sh;
      if (sh ? (sh = !1, Wc = e, IS = m) : (ev = 0, rb = null), T = e.pendingLanes, T === ee && (Jm = null), N || QO(e.current, !1), gg(c.stateNode, l), Lr && e.memoizedUpdaters.clear(), G4(), Ra(e, ui()), t !== null)
        for (var q = e.onRecoverableError, Q = 0; Q < t.length; Q++) {
          var Y = t[Q], ve = Y.stack, Ue = Y.digest;
          q(Y.value, {
            componentStack: ve,
            digest: Ue
          });
        }
      if (nb) {
        nb = !1;
        var Me = N1;
        throw N1 = null, Me;
      }
      return $r(IS, je) && e.tag !== Fc && bu(), T = e.pendingLanes, $r(T, je) ? (TI(), e === F1 ? qS++ : (qS = 0, F1 = e)) : qS = 0, Vc(), Eg(), null;
    }
    function bu() {
      if (Wc !== null) {
        var e = SE(IS), t = Of(Sa, e), a = hr.transition, l = wa();
        try {
          return hr.transition = null, Zn(t), yq();
        } finally {
          Zn(l), hr.transition = a;
        }
      }
      return !1;
    }
    function vq(e) {
      U1.push(e), sh || (sh = !0, G1(Ks, function() {
        return bu(), null;
      }));
    }
    function yq() {
      if (Wc === null)
        return !1;
      var e = z1;
      z1 = null;
      var t = Wc, a = IS;
      if (Wc = null, IS = ee, (bt & (pr | Ls)) !== Ui)
        throw new Error("Cannot flush passive effects while already rendering.");
      V1 = !0, ib = !1, Jo(a);
      var l = bt;
      bt |= Ls, N4(t.current), O4(t, t.current, a, e);
      {
        var c = U1;
        U1 = [];
        for (var m = 0; m < c.length; m++) {
          var T = c[m];
          g4(t, T);
        }
      }
      kg(), QO(t.current, !0), bt = l, Vc(), ib ? t === rb ? ev++ : (ev = 0, rb = t) : ev = 0, V1 = !1, ib = !1, Sg(t);
      {
        var E = t.current.stateNode;
        E.effectDuration = 0, E.passiveEffectDuration = 0;
      }
      return !0;
    }
    function qO(e) {
      return Jm !== null && Jm.has(e);
    }
    function gq(e) {
      Jm === null ? Jm = /* @__PURE__ */ new Set([e]) : Jm.add(e);
    }
    function Sq(e) {
      nb || (nb = !0, N1 = e);
    }
    var Tq = Sq;
    function jO(e, t, a) {
      var l = ih(a, t), c = H$(e, l, je), m = Ic(e, c, je), T = ea();
      m !== null && (Rc(m, je, T), Ra(m, T));
    }
    function mn(e, t, a) {
      if (d4(a), YS(!1), e.tag === A) {
        jO(e, e, a);
        return;
      }
      var l = null;
      for (l = t; l !== null; ) {
        if (l.tag === A) {
          jO(l, e, a);
          return;
        } else if (l.tag === $) {
          var c = l.type, m = l.stateNode;
          if (typeof c.getDerivedStateFromError == "function" || typeof m.componentDidCatch == "function" && !qO(m)) {
            var T = ih(a, e), E = d1(l, T, je), C = Ic(l, E, je), x = ea();
            C !== null && (Rc(C, je, x), Ra(C, x));
            return;
          }
        }
        l = l.return;
      }
      y(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, a);
    }
    function wq(e, t, a) {
      var l = e.pingCache;
      l !== null && l.delete(t);
      var c = ea();
      dm(e, a), Lq(e), Jr === e && ou(zi, a) && (Fi === US || Fi === JC && lu(zi) && ui() - _1 < LO ? lh(e, ee) : tb = it(tb, a)), Ra(e, c);
    }
    function BO(e, t) {
      t === Ot && (t = tq(e));
      var a = ea(), l = ba(e, t);
      l !== null && (Rc(l, t, a), Ra(l, a));
    }
    function Eq(e) {
      var t = e.memoizedState, a = Ot;
      t !== null && (a = t.retryLane), BO(e, a);
    }
    function Cq(e, t) {
      var a = Ot, l;
      switch (e.tag) {
        case Ye:
          l = e.stateNode;
          var c = e.memoizedState;
          c !== null && (a = c.retryLane);
          break;
        case Kt:
          l = e.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      l !== null && l.delete(t), BO(e, a);
    }
    function bq(e) {
      return e < 120 ? 120 : e < 480 ? 480 : e < 1080 ? 1080 : e < 1920 ? 1920 : e < 3e3 ? 3e3 : e < 4320 ? 4320 : X4(e / 1960) * 1960;
    }
    function kq() {
      if (qS > J4)
        throw qS = 0, F1 = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      ev > eq && (ev = 0, rb = null, y("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function xq() {
      al.flushLegacyContextWarning(), al.flushPendingUnsafeLifecycleWarnings();
    }
    function QO(e, t) {
      pn(e), ub(e, Pl, B4), t && ub(e, vs, Q4), ub(e, Pl, q4), t && ub(e, vs, j4), On();
    }
    function ub(e, t, a) {
      for (var l = e, c = null; l !== null; ) {
        var m = l.subtreeFlags & t;
        l !== c && l.child !== null && m !== Pe ? l = l.child : ((l.flags & t) !== Pe && a(l), l.sibling !== null ? l = l.sibling : l = c = l.return);
      }
    }
    var cb = null;
    function YO(e) {
      {
        if ((bt & pr) !== Ui || !(e.mode & dt))
          return;
        var t = e.tag;
        if (t !== _ && t !== A && t !== $ && t !== D && t !== Ve && t !== Tt && t !== He)
          return;
        var a = nt(e) || "ReactComponent";
        if (cb !== null) {
          if (cb.has(a))
            return;
          cb.add(a);
        } else
          cb = /* @__PURE__ */ new Set([a]);
        var l = nr;
        try {
          pn(e), y("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          l ? pn(e) : On();
        }
      }
    }
    var B1;
    {
      var Rq = null;
      B1 = function(e, t, a) {
        var l = tA(Rq, t);
        try {
          return sO(e, t, a);
        } catch (m) {
          if (F3() || m !== null && typeof m == "object" && typeof m.then == "function")
            throw m;
          if (yC(), o$(), fO(e, t), tA(t, l), t.mode & Ut && Yx(t), Al(null, sO, null, e, t, a), Ys()) {
            var c = df();
            typeof c == "object" && c !== null && c._suppressLogging && typeof m == "object" && m !== null && !m._suppressLogging && (m._suppressLogging = !0);
          }
          throw m;
        }
      };
    }
    var GO = !1, Q1;
    Q1 = /* @__PURE__ */ new Set();
    function Dq(e) {
      if (Rl && !yI())
        switch (e.tag) {
          case D:
          case Ve:
          case He: {
            var t = In && nt(In) || "Unknown", a = t;
            if (!Q1.has(a)) {
              Q1.add(a);
              var l = nt(e) || "Unknown";
              y("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", l, t, t);
            }
            break;
          }
          case $: {
            GO || (y("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), GO = !0);
            break;
          }
        }
    }
    function QS(e, t) {
      if (Lr) {
        var a = e.memoizedUpdaters;
        a.forEach(function(l) {
          Lf(e, l, t);
        });
      }
    }
    var Y1 = {};
    function G1(e, t) {
      {
        var a = hl.current;
        return a !== null ? (a.push(t), Y1) : pg(e, t);
      }
    }
    function WO(e) {
      if (e !== Y1)
        return iE(e);
    }
    function KO() {
      return hl.current !== null;
    }
    function Mq(e) {
      {
        if (e.mode & dt) {
          if (!RO())
            return;
        } else if (!K4() || bt !== Ui || e.tag !== D && e.tag !== Ve && e.tag !== He)
          return;
        if (hl.current === null) {
          var t = nr;
          try {
            pn(e), y(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, nt(e));
          } finally {
            t ? pn(e) : On();
          }
        }
      }
    }
    function Lq(e) {
      e.tag !== Fc && RO() && hl.current === null && y(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function YS(e) {
      AO = e;
    }
    var $s = null, tv = null, $q = function(e) {
      $s = e;
    };
    function nv(e) {
      {
        if ($s === null)
          return e;
        var t = $s(e);
        return t === void 0 ? e : t.current;
      }
    }
    function W1(e) {
      return nv(e);
    }
    function K1(e) {
      {
        if ($s === null)
          return e;
        var t = $s(e);
        if (t === void 0) {
          if (e != null && typeof e.render == "function") {
            var a = nv(e.render);
            if (e.render !== a) {
              var l = {
                $$typeof: oc,
                render: a
              };
              return e.displayName !== void 0 && (l.displayName = e.displayName), l;
            }
          }
          return e;
        }
        return t.current;
      }
    }
    function XO(e, t) {
      {
        if ($s === null)
          return !1;
        var a = e.elementType, l = t.type, c = !1, m = typeof l == "object" && l !== null ? l.$$typeof : null;
        switch (e.tag) {
          case $: {
            typeof l == "function" && (c = !0);
            break;
          }
          case D: {
            (typeof l == "function" || m === qi) && (c = !0);
            break;
          }
          case Ve: {
            (m === oc || m === qi) && (c = !0);
            break;
          }
          case Tt:
          case He: {
            (m === Va || m === qi) && (c = !0);
            break;
          }
          default:
            return !1;
        }
        if (c) {
          var T = $s(a);
          if (T !== void 0 && T === $s(l))
            return !0;
        }
        return !1;
      }
    }
    function ZO(e) {
      {
        if ($s === null || typeof WeakSet != "function")
          return;
        tv === null && (tv = /* @__PURE__ */ new WeakSet()), tv.add(e);
      }
    }
    var Oq = function(e, t) {
      {
        if ($s === null)
          return;
        var a = t.staleFamilies, l = t.updatedFamilies;
        bu(), Cu(function() {
          X1(e.current, l, a);
        });
      }
    }, Aq = function(e, t) {
      {
        if (e.context !== Ka)
          return;
        bu(), Cu(function() {
          GS(t, e, null, null);
        });
      }
    };
    function X1(e, t, a) {
      {
        var l = e.alternate, c = e.child, m = e.sibling, T = e.tag, E = e.type, C = null;
        switch (T) {
          case D:
          case He:
          case $:
            C = E;
            break;
          case Ve:
            C = E.render;
            break;
        }
        if ($s === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var x = !1, M = !1;
        if (C !== null) {
          var z = $s(C);
          z !== void 0 && (a.has(z) ? M = !0 : t.has(z) && (T === $ ? M = !0 : x = !0));
        }
        if (tv !== null && (tv.has(e) || l !== null && tv.has(l)) && (M = !0), M && (e._debugNeedsRemount = !0), M || x) {
          var N = ba(e, je);
          N !== null && Vi(N, e, je, ln);
        }
        c !== null && !M && X1(c, t, a), m !== null && X1(m, t, a);
      }
    }
    var Pq = function(e, t) {
      {
        var a = /* @__PURE__ */ new Set(), l = new Set(t.map(function(c) {
          return c.current;
        }));
        return Z1(e.current, l, a), a;
      }
    };
    function Z1(e, t, a) {
      {
        var l = e.child, c = e.sibling, m = e.tag, T = e.type, E = null;
        switch (m) {
          case D:
          case He:
          case $:
            E = T;
            break;
          case Ve:
            E = T.render;
            break;
        }
        var C = !1;
        E !== null && t.has(E) && (C = !0), C ? _q(e, a) : l !== null && Z1(l, t, a), c !== null && Z1(c, t, a);
      }
    }
    function _q(e, t) {
      {
        var a = Nq(e, t);
        if (a)
          return;
        for (var l = e; ; ) {
          switch (l.tag) {
            case W:
              t.add(l.stateNode);
              return;
            case B:
              t.add(l.stateNode.containerInfo);
              return;
            case A:
              t.add(l.stateNode.containerInfo);
              return;
          }
          if (l.return === null)
            throw new Error("Expected to reach root first.");
          l = l.return;
        }
      }
    }
    function Nq(e, t) {
      for (var a = e, l = !1; ; ) {
        if (a.tag === W)
          l = !0, t.add(a.stateNode);
        else if (a.child !== null) {
          a.child.return = a, a = a.child;
          continue;
        }
        if (a === e)
          return l;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === e)
            return l;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return !1;
    }
    var J1;
    {
      J1 = !1;
      try {
        var JO = Object.preventExtensions({});
      } catch {
        J1 = !0;
      }
    }
    function Uq(e, t, a, l) {
      this.tag = e, this.key = a, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = t, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = l, this.flags = Pe, this.subtreeFlags = Pe, this.deletions = null, this.lanes = ee, this.childLanes = ee, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !J1 && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var Xa = function(e, t, a, l) {
      return new Uq(e, t, a, l);
    };
    function eR(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function zq(e) {
      return typeof e == "function" && !eR(e) && e.defaultProps === void 0;
    }
    function Fq(e) {
      if (typeof e == "function")
        return eR(e) ? $ : D;
      if (e != null) {
        var t = e.$$typeof;
        if (t === oc)
          return Ve;
        if (t === Va)
          return Tt;
      }
      return _;
    }
    function uh(e, t) {
      var a = e.alternate;
      a === null ? (a = Xa(e.tag, t, e.key, e.mode), a.elementType = e.elementType, a.type = e.type, a.stateNode = e.stateNode, a._debugSource = e._debugSource, a._debugOwner = e._debugOwner, a._debugHookTypes = e._debugHookTypes, a.alternate = e, e.alternate = a) : (a.pendingProps = t, a.type = e.type, a.flags = Pe, a.subtreeFlags = Pe, a.deletions = null, a.actualDuration = 0, a.actualStartTime = -1), a.flags = e.flags & Wn, a.childLanes = e.childLanes, a.lanes = e.lanes, a.child = e.child, a.memoizedProps = e.memoizedProps, a.memoizedState = e.memoizedState, a.updateQueue = e.updateQueue;
      var l = e.dependencies;
      switch (a.dependencies = l === null ? null : {
        lanes: l.lanes,
        firstContext: l.firstContext
      }, a.sibling = e.sibling, a.index = e.index, a.ref = e.ref, a.selfBaseDuration = e.selfBaseDuration, a.treeBaseDuration = e.treeBaseDuration, a._debugNeedsRemount = e._debugNeedsRemount, a.tag) {
        case _:
        case D:
        case He:
          a.type = nv(e.type);
          break;
        case $:
          a.type = W1(e.type);
          break;
        case Ve:
          a.type = K1(e.type);
          break;
      }
      return a;
    }
    function Vq(e, t) {
      e.flags &= Wn | Nn;
      var a = e.alternate;
      if (a === null)
        e.childLanes = ee, e.lanes = t, e.child = null, e.subtreeFlags = Pe, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0;
      else {
        e.childLanes = a.childLanes, e.lanes = a.lanes, e.child = a.child, e.subtreeFlags = Pe, e.deletions = null, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, e.type = a.type;
        var l = a.dependencies;
        e.dependencies = l === null ? null : {
          lanes: l.lanes,
          firstContext: l.firstContext
        }, e.selfBaseDuration = a.selfBaseDuration, e.treeBaseDuration = a.treeBaseDuration;
      }
      return e;
    }
    function Hq(e, t, a) {
      var l;
      return e === lC ? (l = dt, t === !0 && (l |= Jt, l |= zt)) : l = _e, Lr && (l |= Ut), Xa(A, null, null, l);
    }
    function tR(e, t, a, l, c, m) {
      var T = _, E = e;
      if (typeof e == "function")
        eR(e) ? (T = $, E = W1(E)) : E = nv(E);
      else if (typeof e == "string")
        T = W;
      else
        e: switch (e) {
          case ac:
            return Zc(a.children, c, m, t);
          case Po:
            T = Re, c |= Jt, (c & dt) !== _e && (c |= zt);
            break;
          case sc:
            return Iq(a, c, m, t);
          case op:
            return qq(a, c, m, t);
          case up:
            return jq(a, c, m, t);
          case Ay:
            return eA(a, c, m, t);
          case yw:
          // eslint-disable-next-line no-fallthrough
          case vw:
          // eslint-disable-next-line no-fallthrough
          case gw:
          // eslint-disable-next-line no-fallthrough
          case Sw:
          // eslint-disable-next-line no-fallthrough
          case z0:
          // eslint-disable-next-line no-fallthrough
          default: {
            if (typeof e == "object" && e !== null)
              switch (e.$$typeof) {
                case lc:
                  T = $t;
                  break e;
                case Bd:
                  T = Lt;
                  break e;
                case oc:
                  T = Ve, E = K1(E);
                  break e;
                case Va:
                  T = Tt;
                  break e;
                case qi:
                  T = de, E = null;
                  break e;
              }
            var C = "";
            {
              (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (C += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var x = l ? nt(l) : null;
              x && (C += `

Check the render method of \`` + x + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (e == null ? e : typeof e) + "." + C));
          }
        }
      var M = Xa(T, a, t, c);
      return M.elementType = e, M.type = E, M.lanes = m, M._debugOwner = l, M;
    }
    function nR(e, t, a) {
      var l = null;
      l = e._owner;
      var c = e.type, m = e.key, T = e.props, E = tR(c, m, T, l, t, a);
      return E._debugSource = e._source, E._debugOwner = e._owner, E;
    }
    function Zc(e, t, a, l) {
      var c = Xa(ce, e, l, t);
      return c.lanes = a, c;
    }
    function Iq(e, t, a, l) {
      typeof e.id != "string" && y('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof e.id);
      var c = Xa(ct, e, l, t | Ut);
      return c.elementType = sc, c.lanes = a, c.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, c;
    }
    function qq(e, t, a, l) {
      var c = Xa(Ye, e, l, t);
      return c.elementType = op, c.lanes = a, c;
    }
    function jq(e, t, a, l) {
      var c = Xa(Kt, e, l, t);
      return c.elementType = up, c.lanes = a, c;
    }
    function eA(e, t, a, l) {
      var c = Xa(Ae, e, l, t);
      c.elementType = Ay, c.lanes = a;
      var m = {
        isHidden: !1
      };
      return c.stateNode = m, c;
    }
    function iR(e, t, a) {
      var l = Xa(ne, e, null, t);
      return l.lanes = a, l;
    }
    function Bq() {
      var e = Xa(W, null, null, _e);
      return e.elementType = "DELETED", e;
    }
    function Qq(e) {
      var t = Xa(ft, null, null, _e);
      return t.stateNode = e, t;
    }
    function rR(e, t, a) {
      var l = e.children !== null ? e.children : [], c = Xa(B, l, e.key, t);
      return c.lanes = a, c.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: e.implementation
      }, c;
    }
    function tA(e, t) {
      return e === null && (e = Xa(_, null, null, _e)), e.tag = t.tag, e.key = t.key, e.elementType = t.elementType, e.type = t.type, e.stateNode = t.stateNode, e.return = t.return, e.child = t.child, e.sibling = t.sibling, e.index = t.index, e.ref = t.ref, e.pendingProps = t.pendingProps, e.memoizedProps = t.memoizedProps, e.updateQueue = t.updateQueue, e.memoizedState = t.memoizedState, e.dependencies = t.dependencies, e.mode = t.mode, e.flags = t.flags, e.subtreeFlags = t.subtreeFlags, e.deletions = t.deletions, e.lanes = t.lanes, e.childLanes = t.childLanes, e.alternate = t.alternate, e.actualDuration = t.actualDuration, e.actualStartTime = t.actualStartTime, e.selfBaseDuration = t.selfBaseDuration, e.treeBaseDuration = t.treeBaseDuration, e._debugSource = t._debugSource, e._debugOwner = t._debugOwner, e._debugNeedsRemount = t._debugNeedsRemount, e._debugHookTypes = t._debugHookTypes, e;
    }
    function Yq(e, t, a, l, c) {
      this.tag = t, this.containerInfo = e, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = Fk, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Ot, this.eventTimes = Mf(ee), this.expirationTimes = Mf(ln), this.pendingLanes = ee, this.suspendedLanes = ee, this.pingedLanes = ee, this.expiredLanes = ee, this.mutableReadLanes = ee, this.finishedLanes = ee, this.entangledLanes = ee, this.entanglements = Mf(ee), this.identifierPrefix = l, this.onRecoverableError = c, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var m = this.pendingUpdatersLaneMap = [], T = 0; T < tu; T++)
          m.push(/* @__PURE__ */ new Set());
      }
      switch (t) {
        case lC:
          this._debugRootType = a ? "hydrateRoot()" : "createRoot()";
          break;
        case Fc:
          this._debugRootType = a ? "hydrate()" : "render()";
          break;
      }
    }
    function nA(e, t, a, l, c, m, T, E, C, x) {
      var M = new Yq(e, t, a, E, C), z = Hq(t, m);
      M.current = z, z.stateNode = M;
      {
        var N = {
          element: l,
          isDehydrated: a,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        z.memoizedState = N;
      }
      return yx(z), M;
    }
    var aR = "18.3.1";
    function Gq(e, t, a) {
      var l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return nc(l), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: Fa,
        key: l == null ? null : "" + l,
        children: e,
        containerInfo: t,
        implementation: a
      };
    }
    var sR, lR;
    sR = !1, lR = {};
    function iA(e) {
      if (!e)
        return Ka;
      var t = wc(e), a = L3(t);
      if (t.tag === $) {
        var l = t.type;
        if (Xl(l))
          return LL(t, l, a);
      }
      return a;
    }
    function Wq(e, t) {
      {
        var a = wc(e);
        if (a === void 0) {
          if (typeof e.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var l = Object.keys(e).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + l);
        }
        var c = Dr(a);
        if (c === null)
          return null;
        if (c.mode & Jt) {
          var m = nt(a) || "Component";
          if (!lR[m]) {
            lR[m] = !0;
            var T = nr;
            try {
              pn(c), a.mode & Jt ? y("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, m) : y("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, m);
            } finally {
              T ? pn(T) : On();
            }
          }
        }
        return c.stateNode;
      }
    }
    function rA(e, t, a, l, c, m, T, E) {
      var C = !1, x = null;
      return nA(e, t, C, x, a, l, c, m, T);
    }
    function aA(e, t, a, l, c, m, T, E, C, x) {
      var M = !0, z = nA(a, l, M, e, c, m, T, E, C);
      z.context = iA(null);
      var N = z.current, q = ea(), Q = Kc(N), Y = Su(q, Q);
      return Y.callback = t ?? null, Ic(N, Y, Q), nq(z, Q, q), z;
    }
    function GS(e, t, a, l) {
      yg(t, e);
      var c = t.current, m = ea(), T = Kc(c);
      bn(T);
      var E = iA(a);
      t.context === null ? t.context = E : t.pendingContext = E, Rl && nr !== null && !sR && (sR = !0, y(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, nt(nr) || "Unknown"));
      var C = Su(m, T);
      C.payload = {
        element: e
      }, l = l === void 0 ? null : l, l !== null && (typeof l != "function" && y("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", l), C.callback = l);
      var x = Ic(c, C, T);
      return x !== null && (Vi(x, c, T, m), EC(x, c, T)), T;
    }
    function db(e) {
      var t = e.current;
      if (!t.child)
        return null;
      switch (t.child.tag) {
        case W:
          return t.child.stateNode;
        default:
          return t.child.stateNode;
      }
    }
    function Kq(e) {
      switch (e.tag) {
        case A: {
          var t = e.stateNode;
          if (hm(t)) {
            var a = uE(t);
            sq(t, a);
          }
          break;
        }
        case Ye: {
          Cu(function() {
            var c = ba(e, je);
            if (c !== null) {
              var m = ea();
              Vi(c, e, je, m);
            }
          });
          var l = je;
          oR(e, l);
          break;
        }
      }
    }
    function sA(e, t) {
      var a = e.memoizedState;
      a !== null && a.dehydrated !== null && (a.retryLane = pE(a.retryLane, t));
    }
    function oR(e, t) {
      sA(e, t);
      var a = e.alternate;
      a && sA(a, t);
    }
    function Xq(e) {
      if (e.tag === Ye) {
        var t = Cf, a = ba(e, t);
        if (a !== null) {
          var l = ea();
          Vi(a, e, t, l);
        }
        oR(e, t);
      }
    }
    function Zq(e) {
      if (e.tag === Ye) {
        var t = Kc(e), a = ba(e, t);
        if (a !== null) {
          var l = ea();
          Vi(a, e, t, l);
        }
        oR(e, t);
      }
    }
    function lA(e) {
      var t = Tn(e);
      return t === null ? null : t.stateNode;
    }
    var oA = function(e) {
      return null;
    };
    function Jq(e) {
      return oA(e);
    }
    var uA = function(e) {
      return !1;
    };
    function ej(e) {
      return uA(e);
    }
    var cA = null, dA = null, fA = null, hA = null, pA = null, mA = null, vA = null, yA = null, gA = null;
    {
      var SA = function(e, t, a) {
        var l = t[a], c = Di(e) ? e.slice() : gt({}, e);
        return a + 1 === t.length ? (Di(c) ? c.splice(l, 1) : delete c[l], c) : (c[l] = SA(e[l], t, a + 1), c);
      }, TA = function(e, t) {
        return SA(e, t, 0);
      }, wA = function(e, t, a, l) {
        var c = t[l], m = Di(e) ? e.slice() : gt({}, e);
        if (l + 1 === t.length) {
          var T = a[l];
          m[T] = m[c], Di(m) ? m.splice(c, 1) : delete m[c];
        } else
          m[c] = wA(
            // $FlowFixMe number or string is fine here
            e[c],
            t,
            a,
            l + 1
          );
        return m;
      }, EA = function(e, t, a) {
        if (t.length !== a.length) {
          v("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var l = 0; l < a.length - 1; l++)
            if (t[l] !== a[l]) {
              v("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return wA(e, t, a, 0);
      }, CA = function(e, t, a, l) {
        if (a >= t.length)
          return l;
        var c = t[a], m = Di(e) ? e.slice() : gt({}, e);
        return m[c] = CA(e[c], t, a + 1, l), m;
      }, bA = function(e, t, a) {
        return CA(e, t, 0, a);
      }, uR = function(e, t) {
        for (var a = e.memoizedState; a !== null && t > 0; )
          a = a.next, t--;
        return a;
      };
      cA = function(e, t, a, l) {
        var c = uR(e, t);
        if (c !== null) {
          var m = bA(c.memoizedState, a, l);
          c.memoizedState = m, c.baseState = m, e.memoizedProps = gt({}, e.memoizedProps);
          var T = ba(e, je);
          T !== null && Vi(T, e, je, ln);
        }
      }, dA = function(e, t, a) {
        var l = uR(e, t);
        if (l !== null) {
          var c = TA(l.memoizedState, a);
          l.memoizedState = c, l.baseState = c, e.memoizedProps = gt({}, e.memoizedProps);
          var m = ba(e, je);
          m !== null && Vi(m, e, je, ln);
        }
      }, fA = function(e, t, a, l) {
        var c = uR(e, t);
        if (c !== null) {
          var m = EA(c.memoizedState, a, l);
          c.memoizedState = m, c.baseState = m, e.memoizedProps = gt({}, e.memoizedProps);
          var T = ba(e, je);
          T !== null && Vi(T, e, je, ln);
        }
      }, hA = function(e, t, a) {
        e.pendingProps = bA(e.memoizedProps, t, a), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var l = ba(e, je);
        l !== null && Vi(l, e, je, ln);
      }, pA = function(e, t) {
        e.pendingProps = TA(e.memoizedProps, t), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var a = ba(e, je);
        a !== null && Vi(a, e, je, ln);
      }, mA = function(e, t, a) {
        e.pendingProps = EA(e.memoizedProps, t, a), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var l = ba(e, je);
        l !== null && Vi(l, e, je, ln);
      }, vA = function(e) {
        var t = ba(e, je);
        t !== null && Vi(t, e, je, ln);
      }, yA = function(e) {
        oA = e;
      }, gA = function(e) {
        uA = e;
      };
    }
    function tj(e) {
      var t = Dr(e);
      return t === null ? null : t.stateNode;
    }
    function nj(e) {
      return null;
    }
    function ij() {
      return nr;
    }
    function rj(e) {
      var t = e.findFiberByHostInstance, a = n.ReactCurrentDispatcher;
      return bc({
        bundleType: e.bundleType,
        version: e.version,
        rendererPackageName: e.rendererPackageName,
        rendererConfig: e.rendererConfig,
        overrideHookState: cA,
        overrideHookStateDeletePath: dA,
        overrideHookStateRenamePath: fA,
        overrideProps: hA,
        overridePropsDeletePath: pA,
        overridePropsRenamePath: mA,
        setErrorHandler: yA,
        setSuspenseHandler: gA,
        scheduleUpdate: vA,
        currentDispatcherRef: a,
        findHostInstanceByFiber: tj,
        findFiberByHostInstance: t || nj,
        // React Refresh
        findHostInstancesForRefresh: Pq,
        scheduleRefresh: Oq,
        scheduleRoot: Aq,
        setRefreshHandler: $q,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: ij,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: aR
      });
    }
    var kA = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(e) {
      console.error(e);
    };
    function cR(e) {
      this._internalRoot = e;
    }
    fb.prototype.render = cR.prototype.render = function(e) {
      var t = this._internalRoot;
      if (t === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? y("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : hb(arguments[1]) ? y("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && y("You passed a second argument to root.render(...) but it only accepts one argument.");
        var a = t.containerInfo;
        if (a.nodeType !== Yn) {
          var l = lA(t.current);
          l && l.parentNode !== a && y("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      GS(e, t, null, null);
    }, fb.prototype.unmount = cR.prototype.unmount = function() {
      typeof arguments[0] == "function" && y("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var e = this._internalRoot;
      if (e !== null) {
        this._internalRoot = null;
        var t = e.containerInfo;
        UO() && y("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Cu(function() {
          GS(null, e, null, null);
        }), kL(t);
      }
    };
    function aj(e, t) {
      if (!hb(e))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      xA(e);
      var a = !1, l = !1, c = "", m = kA;
      t != null && (t.hydrate ? v("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof t == "object" && t !== null && t.$$typeof === xl && y(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), t.unstable_strictMode === !0 && (a = !0), t.identifierPrefix !== void 0 && (c = t.identifierPrefix), t.onRecoverableError !== void 0 && (m = t.onRecoverableError), t.transitionCallbacks !== void 0 && t.transitionCallbacks);
      var T = rA(e, lC, null, a, l, c, m);
      eC(T.current, e);
      var E = e.nodeType === Yn ? e.parentNode : e;
      return eS(E), new cR(T);
    }
    function fb(e) {
      this._internalRoot = e;
    }
    function sj(e) {
      e && bE(e);
    }
    fb.prototype.unstable_scheduleHydration = sj;
    function lj(e, t, a) {
      if (!hb(e))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      xA(e), t === void 0 && y("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var l = a ?? null, c = a != null && a.hydratedSources || null, m = !1, T = !1, E = "", C = kA;
      a != null && (a.unstable_strictMode === !0 && (m = !0), a.identifierPrefix !== void 0 && (E = a.identifierPrefix), a.onRecoverableError !== void 0 && (C = a.onRecoverableError));
      var x = aA(t, null, e, lC, l, m, T, E, C);
      if (eC(x.current, e), eS(e), c)
        for (var M = 0; M < c.length; M++) {
          var z = c[M];
          dI(x, z);
        }
      return new fb(x);
    }
    function hb(e) {
      return !!(e && (e.nodeType === br || e.nodeType === Qs || e.nodeType === ng));
    }
    function WS(e) {
      return !!(e && (e.nodeType === br || e.nodeType === Qs || e.nodeType === ng || e.nodeType === Yn && e.nodeValue === " react-mount-point-unstable "));
    }
    function xA(e) {
      e.nodeType === br && e.tagName && e.tagName.toUpperCase() === "BODY" && y("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), dS(e) && (e._reactRootContainer ? y("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : y("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var oj = n.ReactCurrentOwner, RA;
    RA = function(e) {
      if (e._reactRootContainer && e.nodeType !== Yn) {
        var t = lA(e._reactRootContainer.current);
        t && t.parentNode !== e && y("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var a = !!e._reactRootContainer, l = dR(e), c = !!(l && Uc(l));
      c && !a && y("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), e.nodeType === br && e.tagName && e.tagName.toUpperCase() === "BODY" && y("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function dR(e) {
      return e ? e.nodeType === Qs ? e.documentElement : e.firstChild : null;
    }
    function DA() {
    }
    function uj(e, t, a, l, c) {
      if (c) {
        if (typeof l == "function") {
          var m = l;
          l = function() {
            var N = db(T);
            m.call(N);
          };
        }
        var T = aA(
          t,
          l,
          e,
          Fc,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          DA
        );
        e._reactRootContainer = T, eC(T.current, e);
        var E = e.nodeType === Yn ? e.parentNode : e;
        return eS(E), Cu(), T;
      } else {
        for (var C; C = e.lastChild; )
          e.removeChild(C);
        if (typeof l == "function") {
          var x = l;
          l = function() {
            var N = db(M);
            x.call(N);
          };
        }
        var M = rA(
          e,
          Fc,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          DA
        );
        e._reactRootContainer = M, eC(M.current, e);
        var z = e.nodeType === Yn ? e.parentNode : e;
        return eS(z), Cu(function() {
          GS(t, M, a, l);
        }), M;
      }
    }
    function cj(e, t) {
      e !== null && typeof e != "function" && y("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e);
    }
    function pb(e, t, a, l, c) {
      RA(a), cj(c === void 0 ? null : c, "render");
      var m = a._reactRootContainer, T;
      if (!m)
        T = uj(a, t, e, c, l);
      else {
        if (T = m, typeof c == "function") {
          var E = c;
          c = function() {
            var C = db(T);
            E.call(C);
          };
        }
        GS(t, T, e, c);
      }
      return db(T);
    }
    var MA = !1;
    function dj(e) {
      {
        MA || (MA = !0, y("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var t = oj.current;
        if (t !== null && t.stateNode !== null) {
          var a = t.stateNode._warnedAboutRefsInRender;
          a || y("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Zt(t.type) || "A component"), t.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return e == null ? null : e.nodeType === br ? e : Wq(e, "findDOMNode");
    }
    function fj(e, t, a) {
      if (y("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !WS(t))
        throw new Error("Target container is not a DOM element.");
      {
        var l = dS(t) && t._reactRootContainer === void 0;
        l && y("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return pb(null, e, t, !0, a);
    }
    function hj(e, t, a) {
      if (y("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !WS(t))
        throw new Error("Target container is not a DOM element.");
      {
        var l = dS(t) && t._reactRootContainer === void 0;
        l && y("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return pb(null, e, t, !1, a);
    }
    function pj(e, t, a, l) {
      if (y("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !WS(a))
        throw new Error("Target container is not a DOM element.");
      if (e == null || !lk(e))
        throw new Error("parentComponent must be a valid React Component");
      return pb(e, t, a, !1, l);
    }
    var LA = !1;
    function mj(e) {
      if (LA || (LA = !0, y("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !WS(e))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var t = dS(e) && e._reactRootContainer === void 0;
        t && y("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (e._reactRootContainer) {
        {
          var a = dR(e), l = a && !Uc(a);
          l && y("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Cu(function() {
          pb(null, null, e, !1, function() {
            e._reactRootContainer = null, kL(e);
          });
        }), !0;
      } else {
        {
          var c = dR(e), m = !!(c && Uc(c)), T = e.nodeType === br && WS(e.parentNode) && !!e.parentNode._reactRootContainer;
          m && y("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", T ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Bi(Kq), Dc(Xq), TE(Zq), Pf(wa), Ug(yE), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && y("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Lp(yH), sk(I1, lq, Cu);
    function vj(e, t) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!hb(t))
        throw new Error("Target container is not a DOM element.");
      return Gq(e, t, null, a);
    }
    function yj(e, t, a, l) {
      return pj(e, t, a, l);
    }
    var fR = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Uc, Am, tC, yc, $p, I1]
    };
    function gj(e, t) {
      return fR.usingClientEntryPoint || y('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), aj(e, t);
    }
    function Sj(e, t, a) {
      return fR.usingClientEntryPoint || y('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), lj(e, t, a);
    }
    function Tj(e) {
      return UO() && y("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Cu(e);
    }
    var wj = rj({
      findFiberByHostInstance: Gf,
      bundleType: 1,
      version: aR,
      rendererPackageName: "react-dom"
    });
    if (!wj && _n && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var $A = window.location.protocol;
      /^(https?|file):$/.test($A) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + ($A === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Ma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fR, Ma.createPortal = vj, Ma.createRoot = gj, Ma.findDOMNode = dj, Ma.flushSync = Tj, Ma.hydrate = fj, Ma.hydrateRoot = Sj, Ma.render = hj, Ma.unmountComponentAtNode = mj, Ma.unstable_batchedUpdates = I1, Ma.unstable_renderSubtreeIntoContainer = yj, Ma.version = aR, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Ma;
}
var hP;
function rQ() {
  if (hP) return Sb.exports;
  hP = 1;
  function f() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(f);
      } catch (s) {
        console.error(s);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (f(), Sb.exports = nQ()) : Sb.exports = iQ(), Sb.exports;
}
var qQ = rQ();
const pP = GM.state.record, uV = Object.keys(pP).reduce(
  (f, s) => ({
    ...f,
    [s]() {
      return pP[s];
    }
  }),
  {}
);
function jQ(f, s) {
  var o;
  const n = hw(xy);
  return Dn((((o = s == null ? void 0 : s.current) == null ? void 0 : o.$state) || n || uV)[f]);
}
function BQ(f) {
  const s = hw(xy);
  return m6(f != null && f.current ? f.current.$state : s || uV);
}
const aQ = cs(l6), sQ = ue.forwardRef(
  ({ children: f, ...s }, n) => /* @__PURE__ */ lt(aQ, { ...s, ref: n, children: (o) => /* @__PURE__ */ lt(Ji.div, { ...o, children: f }) })
);
sQ.displayName = "Captions";
const lQ = cs(o6), oQ = ue.forwardRef(({ children: f, ...s }, n) => /* @__PURE__ */ lt(lQ, { ...s, children: (o, h) => /* @__PURE__ */ lt(
  cV,
  {
    ...o,
    instance: h,
    ref: Hd(o.ref, n),
    children: f
  }
) }));
oQ.displayName = "Time";
const cV = ue.forwardRef(
  ({ instance: f, children: s, ...n }, o) => {
    const { timeText: h } = f.$state, v = Dn(h);
    return /* @__PURE__ */ hy(Ji.div, { ...n, ref: o, children: [
      v,
      s
    ] });
  }
);
cV.displayName = "TimeText";
const QQ = ue.forwardRef(
  ({ size: f = 96, children: s, ...n }, o) => /* @__PURE__ */ lt(
    "svg",
    {
      width: f,
      height: f,
      fill: "none",
      viewBox: "0 0 120 120",
      "aria-hidden": "true",
      "data-part": "root",
      ...n,
      ref: o,
      children: s
    }
  )
), YQ = ue.forwardRef(
  ({ width: f = 8, children: s, ...n }, o) => /* @__PURE__ */ lt(
    "circle",
    {
      cx: "60",
      cy: "60",
      r: "54",
      stroke: "currentColor",
      strokeWidth: f,
      "data-part": "track",
      ...n,
      ref: o,
      children: s
    }
  )
), GQ = ue.forwardRef(
  ({ width: f = 8, fillPercent: s = 50, children: n, ...o }, h) => /* @__PURE__ */ lt(
    "circle",
    {
      cx: "60",
      cy: "60",
      r: "54",
      stroke: "currentColor",
      pathLength: "100",
      strokeWidth: f,
      strokeDasharray: 100,
      strokeDashoffset: 100 - s,
      "data-part": "track-fill",
      ...o,
      ref: h,
      children: n
    }
  )
);
function WQ() {
  const f = sp();
  return (f == null ? void 0 : f.player) || null;
}
function KQ(f) {
  const s = sp(), n = ue.useRef(null);
  return n.current || (n.current = new n_()), ue.useEffect(() => {
    const o = f, h = o instanceof GM, v = h ? o : s == null ? void 0 : s.player;
    n.current.setPlayer(v ?? null), n.current.setTarget(null);
  }, [s, f]), n.current;
}
function XQ({ off: f = !0 } = {}) {
  const s = sp(), { textTracks: n, textTrack: o } = s.$state, h = Dn(n);
  return Dn(o), ue.useMemo(() => {
    const v = h.filter(_a), y = v.map((k) => ({
      track: k,
      label: k.label,
      value: mP(k),
      get selected() {
        return o() === k;
      },
      select(D) {
        const $ = n().indexOf(k);
        $ >= 0 && s.remote.changeTextTrackMode($, "showing", D);
      }
    }));
    return f && y.unshift({
      track: null,
      label: Ze(f) ? f : "Off",
      value: "off",
      get selected() {
        return !o();
      },
      select(k) {
        s.remote.toggleCaptions(k);
      }
    }), Object.defineProperty(y, "disabled", {
      get() {
        return !v.length;
      }
    }), Object.defineProperty(y, "selectedTrack", {
      get() {
        return o();
      }
    }), Object.defineProperty(y, "selectedValue", {
      get() {
        const k = o();
        return k ? mP(k) : "off";
      }
    }), y;
  }, [h]);
}
function mP(f) {
  return f.id + ":" + f.kind + "-" + f.label.toLowerCase();
}
function ZQ({
  auto: f = !0,
  sort: s = "descending"
} = {}) {
  const n = sp(), { qualities: o, quality: h, autoQuality: v, canSetQuality: y } = n.$state, k = Dn(o);
  return Dn(h), Dn(v), Dn(y), ue.useMemo(() => {
    const D = o5(k, s === "descending"), $ = D.map((_) => ({
      quality: _,
      label: _.height + "p",
      value: vP(_),
      bitrateText: _.bitrate && _.bitrate > 0 ? `${(_.bitrate / 1e6).toFixed(2)} Mbps` : null,
      get selected() {
        return _ === h();
      },
      get autoSelected() {
        return v();
      },
      select(A) {
        const B = o().indexOf(_);
        B >= 0 && n.remote.changeQuality(B, A);
      }
    }));
    return f && $.unshift({
      quality: null,
      label: Ze(f) ? f : "Auto",
      value: "auto",
      bitrateText: null,
      get selected() {
        return v();
      },
      get autoSelected() {
        return v();
      },
      select(_) {
        n.remote.requestAutoQuality(_);
      }
    }), Object.defineProperty($, "disabled", {
      get() {
        return !y() || k.length <= 1;
      }
    }), Object.defineProperty($, "selectedQuality", {
      get() {
        return h();
      }
    }), Object.defineProperty($, "selectedValue", {
      get() {
        const _ = h();
        return !v() && _ ? vP(_) : "auto";
      }
    }), $;
  }, [k, s]);
}
function vP(f) {
  return f.height + "_" + f.bitrate;
}
function JQ({
  rates: f = AF,
  normalLabel: s = "Normal"
} = {}) {
  const n = sp(), { playbackRate: o, canSetPlaybackRate: h } = n.$state;
  return Dn(o), Dn(h), ue.useMemo(() => {
    const v = f.map((y) => {
      const k = typeof y == "number" ? y === 1 && s ? s : y + "x" : y.label, D = typeof y == "number" ? y : y.rate;
      return {
        label: k,
        value: D.toString(),
        rate: D,
        get selected() {
          return o() === D;
        },
        select($) {
          n.remote.changePlaybackRate(D, $);
        }
      };
    });
    return Object.defineProperty(v, "disabled", {
      get() {
        return !h() || !v.length;
      }
    }), Object.defineProperty(v, "selectedValue", {
      get() {
        return o().toString();
      }
    }), v;
  }, [f]);
}
const uQ = (f) => D0(f);
var Kh, fn, At, dy, fy, Dt, ph, dV, fV, hV, pV, mV, vV, yV, gV, SV, TV, wV, EV, CV, bV;
class e7 {
  constructor(s, n) {
    R(this, Dt);
    R(this, Kh);
    R(this, fn);
    R(this, At, null);
    R(this, dy, null);
    Z(this, "config", {});
    R(this, fy, /* @__PURE__ */ new Set());
    L(this, Kh, s), L(this, fn, n);
  }
  get instance() {
    return d(this, At);
  }
  setup(s) {
    const { streamType: n } = d(this, fn).$state, o = ye(n).includes("live"), h = ye(n).includes("ll-");
    L(this, At, new s({
      lowLatencyMode: h,
      backBufferLength: h ? 4 : o ? 8 : void 0,
      renderTextTracksNatively: !1,
      ...this.config
    }));
    const v = S(this, Dt, hV).bind(this);
    for (const y of Object.values(s.Events)) d(this, At).on(y, v);
    d(this, At).on(s.Events.ERROR, S(this, Dt, TV).bind(this));
    for (const y of d(this, fy)) y(d(this, At));
    d(this, fn).player.dispatch("hls-instance", {
      detail: d(this, At)
    }), d(this, At).attachMedia(d(this, Kh)), d(this, At).on(s.Events.AUDIO_TRACK_SWITCHED, S(this, Dt, vV).bind(this)), d(this, At).on(s.Events.LEVEL_SWITCHED, S(this, Dt, yV).bind(this)), d(this, At).on(s.Events.LEVEL_LOADED, S(this, Dt, SV).bind(this)), d(this, At).on(s.Events.LEVEL_UPDATED, S(this, Dt, gV).bind(this)), d(this, At).on(s.Events.NON_NATIVE_TEXT_TRACKS_FOUND, S(this, Dt, pV).bind(this)), d(this, At).on(s.Events.CUES_PARSED, S(this, Dt, mV).bind(this)), d(this, fn).qualities[la.enableAuto] = S(this, Dt, EV).bind(this), En(d(this, fn).qualities, "change", S(this, Dt, CV).bind(this)), En(d(this, fn).audioTracks, "change", S(this, Dt, bV).bind(this)), L(this, dy, J(S(this, Dt, dV).bind(this)));
  }
  onInstance(s) {
    return d(this, fy).add(s), () => d(this, fy).delete(s);
  }
  loadSource(s) {
    var n;
    Ze(s.src) && ((n = d(this, At)) == null || n.loadSource(s.src));
  }
  destroy() {
    var s, n;
    (s = d(this, At)) == null || s.destroy(), L(this, At, null), (n = d(this, dy)) == null || n.call(this), L(this, dy, null);
  }
}
Kh = new WeakMap(), fn = new WeakMap(), At = new WeakMap(), dy = new WeakMap(), fy = new WeakMap(), Dt = new WeakSet(), ph = function(s, n) {
  return new vt(uQ(s), { detail: n });
}, dV = function() {
  if (!d(this, fn).$state.live()) return;
  const s = new IM(S(this, Dt, fV).bind(this));
  return s.start(), s.stop.bind(s);
}, fV = function() {
  var s;
  d(this, fn).$state.liveSyncPosition.set(((s = d(this, At)) == null ? void 0 : s.liveSyncPosition) ?? 1 / 0);
}, hV = function(s, n) {
  var o;
  (o = d(this, fn).player) == null || o.dispatch(S(this, Dt, ph).call(this, s, n));
}, pV = function(s, n) {
  const o = S(this, Dt, ph).call(this, s, n);
  let h = -1;
  for (let v = 0; v < n.tracks.length; v++) {
    const y = n.tracks[v], k = y.subtitleTrack ?? y.closedCaptions, D = new Ud({
      id: `hls-${y.kind}-${v}`,
      src: k == null ? void 0 : k.url,
      label: y.label,
      language: k == null ? void 0 : k.lang,
      kind: y.kind,
      default: y.default
    });
    D[tt.readyState] = 2, D[tt.onModeChange] = () => {
      D.mode === "showing" ? (d(this, At).subtitleTrack = v, h = v) : h === v && (d(this, At).subtitleTrack = -1, h = -1);
    }, d(this, fn).textTracks.add(D, o);
  }
}, mV = function(s, n) {
  var y;
  const o = (y = d(this, At)) == null ? void 0 : y.subtitleTrack, h = d(this, fn).textTracks.getById(`hls-${n.type}-${o}`);
  if (!h) return;
  const v = S(this, Dt, ph).call(this, s, n);
  for (const k of n.cues)
    k.positionAlign = "auto", h.addCue(k, v);
}, vV = function(s, n) {
  const o = d(this, fn).audioTracks[n.id];
  if (o) {
    const h = S(this, Dt, ph).call(this, s, n);
    d(this, fn).audioTracks[at.select](o, !0, h);
  }
}, yV = function(s, n) {
  const o = d(this, fn).qualities[n.level];
  if (o) {
    const h = S(this, Dt, ph).call(this, s, n);
    d(this, fn).qualities[at.select](o, !0, h);
  }
}, gV = function(s, n) {
  n.details.totalduration > 0 && d(this, fn).$state.inferredLiveDVRWindow.set(n.details.totalduration);
}, SV = function(s, n) {
  var $;
  if (d(this, fn).$state.canPlay()) return;
  const { type: o, live: h, totalduration: v, targetduration: y } = n.details, k = S(this, Dt, ph).call(this, s, n);
  d(this, fn).notify(
    "stream-type-change",
    h ? o === "EVENT" && Number.isFinite(v) && y >= 10 ? "live:dvr" : "live" : "on-demand",
    k
  ), d(this, fn).notify("duration-change", v, k);
  const D = d(this, At).media;
  d(this, At).currentLevel === -1 && d(this, fn).qualities[la.setAuto](!0, k);
  for (const _ of d(this, At).audioTracks) {
    const A = {
      id: _.id.toString(),
      label: _.name,
      language: _.lang || "",
      kind: "main"
    };
    d(this, fn).audioTracks[at.add](A, k);
  }
  for (const _ of d(this, At).levels) {
    const A = {
      id: (($ = _.id) == null ? void 0 : $.toString()) ?? _.height + "p",
      width: _.width,
      height: _.height,
      codec: _.codecSet,
      bitrate: _.bitrate
    };
    d(this, fn).qualities[at.add](A, k);
  }
  D.dispatchEvent(new vt("canplay", { trigger: k }));
}, TV = function(s, n) {
  var o;
  if (n.fatal)
    switch (n.type) {
      case "mediaError":
        (o = d(this, At)) == null || o.recoverMediaError();
        break;
      default:
        S(this, Dt, wV).call(this, n.error);
        break;
    }
}, wV = function(s) {
  d(this, fn).notify("error", {
    message: s.message,
    code: 1,
    error: s
  });
}, EV = function() {
  d(this, At) && (d(this, At).currentLevel = -1);
}, CV = function() {
  const { qualities: s } = d(this, fn);
  !d(this, At) || s.auto || (d(this, At)[s.switch + "Level"] = s.selectedIndex, $0 && (d(this, Kh).currentTime = d(this, Kh).currentTime));
}, bV = function() {
  const { audioTracks: s } = d(this, fn);
  d(this, At) && d(this, At).audioTrack !== s.selectedIndex && (d(this, At).audioTrack = s.selectedIndex);
};
var Xh, yo, aw, Mo, kV, xV, RV, DV;
class t7 {
  constructor(s, n, o) {
    R(this, Mo);
    R(this, Xh);
    R(this, yo);
    R(this, aw);
    L(this, Xh, s), L(this, yo, n), L(this, aw, o), S(this, Mo, kV).call(this);
  }
}
Xh = new WeakMap(), yo = new WeakMap(), aw = new WeakMap(), Mo = new WeakSet(), kV = async function() {
  const s = {
    onLoadStart: S(this, Mo, xV).bind(this),
    onLoaded: S(this, Mo, RV).bind(this),
    onLoadError: S(this, Mo, DV).bind(this)
  };
  let n = await dQ(d(this, Xh), s);
  if (pi(n) && !Ze(d(this, Xh)) && (n = await cQ(d(this, Xh), s)), !n) return null;
  if (!n.isSupported()) {
    const o = "[vidstack] `hls.js` is not supported in this environment";
    return d(this, yo).player.dispatch(new vt("hls-unsupported")), d(this, yo).notify("error", { message: o, code: 4 }), null;
  }
  return n;
}, xV = function() {
  d(this, yo).player.dispatch(new vt("hls-lib-load-start"));
}, RV = function(s) {
  d(this, yo).player.dispatch(
    new vt("hls-lib-loaded", {
      detail: s
    })
  ), d(this, aw).call(this, s);
}, DV = function(s) {
  const n = lT(s);
  d(this, yo).player.dispatch(
    new vt("hls-lib-load-error", {
      detail: n
    })
  ), d(this, yo).notify("error", {
    message: n.message,
    code: 4,
    error: n
  });
};
async function cQ(f, s = {}) {
  var n, o, h, v, y;
  if (!pi(f)) {
    if ((n = s.onLoadStart) == null || n.call(s), f.prototype && f.prototype !== Function)
      return (o = s.onLoaded) == null || o.call(s, f), f;
    try {
      const k = (h = await f()) == null ? void 0 : h.default;
      if (k && k.isSupported)
        (v = s.onLoaded) == null || v.call(s, k);
      else
        throw Error(
          ""
        );
      return k;
    } catch (k) {
      (y = s.onLoadError) == null || y.call(s, k);
    }
  }
}
async function dQ(f, s = {}) {
  var n, o, h;
  if (Ze(f)) {
    (n = s.onLoadStart) == null || n.call(s);
    try {
      if (await NM(f), !ls(window.Hls))
        throw Error(
          ""
        );
      const v = window.Hls;
      return (o = s.onLoaded) == null || o.call(s, v), v;
    } catch (v) {
      (h = s.onLoadError) == null || h.call(s, v);
    }
  }
}
var go, Ty, MV, LV;
class n7 {
  constructor(s) {
    R(this, Ty);
    R(this, go);
    Z(this, "src", st(""));
    /**
     * Defines which referrer is sent when fetching the resource.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLIFrameElement/referrerPolicy}
     */
    Z(this, "referrerPolicy", null);
    L(this, go, s), s.setAttribute("frameBorder", "0"), s.setAttribute("aria-hidden", "true"), s.setAttribute(
      "allow",
      "autoplay; fullscreen; encrypted-media; picture-in-picture; accelerometer; gyroscope"
    ), this.referrerPolicy !== null && s.setAttribute("referrerpolicy", this.referrerPolicy);
  }
  get iframe() {
    return d(this, go);
  }
  setup() {
    En(window, "message", S(this, Ty, LV).bind(this)), En(d(this, go), "load", this.onLoad.bind(this)), J(S(this, Ty, MV).bind(this));
  }
  postMessage(s, n) {
    var o;
    (o = d(this, go).contentWindow) == null || o.postMessage(JSON.stringify(s), n ?? "*");
  }
}
go = new WeakMap(), Ty = new WeakSet(), MV = function() {
  const s = this.src();
  if (!s.length) {
    d(this, go).setAttribute("src", "");
    return;
  }
  const n = ye(() => this.buildParams());
  d(this, go).setAttribute("src", RB(s, n));
}, LV = function(s) {
  var h;
  const n = this.getOrigin();
  if ((s.source === null || s.source === ((h = d(this, go)) == null ? void 0 : h.contentWindow)) && (!Ze(n) || n === s.origin)) {
    try {
      const v = JSON.parse(s.data);
      v && this.onMessage(v, s);
      return;
    } catch {
    }
    s.data && this.onMessage(s.data, s);
  }
};
const i7 = [
  "bufferend",
  "bufferstart",
  // 'cuechange',
  "durationchange",
  "ended",
  "enterpictureinpicture",
  "error",
  "fullscreenchange",
  "leavepictureinpicture",
  "loaded",
  // 'loadeddata',
  // 'loadedmetadata',
  // 'loadstart',
  "playProgress",
  "loadProgress",
  "pause",
  "play",
  "playbackratechange",
  // 'progress',
  "qualitychange",
  "seeked",
  "seeking",
  // 'texttrackchange',
  "timeupdate",
  "volumechange",
  "waiting"
  // 'adstarted',
  // 'adcompleted',
  // 'aderror',
  // 'adskipped',
  // 'adallcompleted',
  // 'adclicked',
  // 'chapterchange',
  // 'chromecastconnected',
  // 'remoteplaybackavailabilitychange',
  // 'remoteplaybackconnecting',
  // 'remoteplaybackconnect',
  // 'remoteplaybackdisconnect',
  // 'liveeventended',
  // 'liveeventstarted',
  // 'livestreamoffline',
  // 'livestreamonline',
], r7 = {
  Unstarted: -1,
  Ended: 0,
  Playing: 1,
  Paused: 2,
  Buffering: 3,
  Cued: 5
};
var Od, Hr, $V, OV, AV, qb, jb;
class fQ {
  constructor() {
    R(this, Hr);
    Z(this, "name", "google-cast");
    Z(this, "target");
    R(this, Od);
  }
  /**
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.CastContext}
   */
  get cast() {
    return Rj();
  }
  mediaType() {
    return "video";
  }
  canPlay(s) {
    return $0 && !L0 && KP(s);
  }
  async prompt(s) {
    var v;
    let n, o, h;
    try {
      n = await S(this, Hr, $V).call(this, s), d(this, Od) || (L(this, Od, new cast.framework.RemotePlayer()), new cast.framework.RemotePlayerController(d(this, Od))), o = s.player.createEvent("google-cast-prompt-open", {
        trigger: n
      }), s.player.dispatchEvent(o), S(this, Hr, qb).call(this, s, "connecting", o), await S(this, Hr, OV).call(this, ye(s.$props.googleCast)), s.$state.remotePlaybackInfo.set({
        deviceName: (v = Dj()) == null ? void 0 : v.getCastDevice().friendlyName
      }), AA() && S(this, Hr, qb).call(this, s, "connected", o);
    } catch (y) {
      const k = y instanceof Error ? y : S(this, Hr, jb).call(this, (y + "").toUpperCase(), "Prompt failed.");
      throw h = s.player.createEvent("google-cast-prompt-error", {
        detail: k,
        trigger: o ?? n,
        cancelable: !0
      }), s.player.dispatch(h), S(this, Hr, qb).call(this, s, AA() ? "connected" : "disconnected", h), k;
    } finally {
      s.player.dispatch("google-cast-prompt-close", {
        trigger: h ?? o ?? n
      });
    }
  }
  async load(s) {
    if (!d(this, Od))
      throw Error("[vidstack] google cast player was not initialized");
    return new (await import("./vidstack-google-cast-CsCVUqMF.js").then((n) => n.p)).GoogleCastProvider(d(this, Od), s);
  }
}
Od = new WeakMap(), Hr = new WeakSet(), $V = async function(s) {
  if (Mj()) return;
  const n = s.player.createEvent("google-cast-load-start");
  s.player.dispatch(n), await NM(Aj()), await customElements.whenDefined("google-cast-launcher");
  const o = s.player.createEvent("google-cast-loaded", { trigger: n });
  if (s.player.dispatch(o), !Lj())
    throw S(this, Hr, jb).call(this, "CAST_NOT_AVAILABLE", "Google Cast not available on this platform.");
  return o;
}, OV = async function(s) {
  S(this, Hr, AV).call(this, s);
  const n = await this.cast.requestSession();
  if (n)
    throw S(this, Hr, jb).call(this, n.toUpperCase(), $j(n));
}, AV = function(s) {
  var n;
  (n = this.cast) == null || n.setOptions({
    ...Oj(),
    ...s
  });
}, qb = function(s, n, o) {
  const h = { type: "google-cast", state: n };
  s.notify("remote-playback-change", h, o);
}, jb = function(s, n) {
  const o = Error(n);
  return o.code = s, o;
};
const hQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GoogleCastLoader: fQ
}, Symbol.toStringTag, { value: "Module" }));
var El, b0, PV;
class a7 {
  constructor(s) {
    R(this, b0);
    R(this, El);
    L(this, El, new chrome.cast.media.MediaInfo(s.src, s.type));
  }
  build() {
    return d(this, El);
  }
  setStreamType(s) {
    return s.includes("live") ? d(this, El).streamType = chrome.cast.media.StreamType.LIVE : d(this, El).streamType = chrome.cast.media.StreamType.BUFFERED, this;
  }
  setTracks(s) {
    return d(this, El).tracks = s.map(S(this, b0, PV)), this;
  }
  setMetadata(s, n) {
    return d(this, El).metadata = new chrome.cast.media.GenericMediaMetadata(), d(this, El).metadata.title = s, d(this, El).metadata.images = [{ url: n }], this;
  }
}
El = new WeakMap(), b0 = new WeakSet(), PV = function(s, n) {
  const o = new chrome.cast.media.Track(n, chrome.cast.media.TrackType.TEXT);
  return o.name = s.label, o.trackContentId = s.src, o.trackContentType = "text/vtt", o.language = s.language, o.subtype = s.kind.toUpperCase(), o;
};
var Ad, So, sw, yn, TM, lv, _V, NV, UV, wM, Bb, EM;
class s7 {
  constructor(s, n, o) {
    R(this, yn);
    R(this, Ad);
    R(this, So);
    R(this, sw);
    L(this, Ad, s), L(this, So, n), L(this, sw, o);
  }
  setup() {
    const s = this.syncRemoteActiveIds.bind(this);
    En(d(this, So).audioTracks, "change", s), En(d(this, So).textTracks, "mode-change", s), J(S(this, yn, NV).bind(this));
  }
  getLocalTextTracks() {
    return d(this, So).$state.textTracks().filter((s) => s.src && s.type === "vtt");
  }
  syncRemoteTracks(s) {
    if (!d(this, Ad).isMediaLoaded) return;
    const n = S(this, yn, TM).call(this), o = this.getLocalTextTracks(), h = S(this, yn, lv).call(this, chrome.cast.media.TrackType.AUDIO), v = S(this, yn, lv).call(this, chrome.cast.media.TrackType.TEXT);
    for (const y of h) {
      if (S(this, yn, wM).call(this, n, y)) continue;
      const D = {
        id: y.trackId.toString(),
        label: y.name,
        language: y.language,
        kind: y.subtype ?? "main",
        selected: !1
      };
      d(this, So).audioTracks[at.add](D, s);
    }
    for (const y of v) {
      if (S(this, yn, wM).call(this, o, y)) continue;
      const D = {
        id: y.trackId.toString(),
        src: y.trackContentId,
        label: y.name,
        language: y.language,
        kind: y.subtype.toLowerCase()
      };
      d(this, So).textTracks.add(D, s);
    }
  }
  syncRemoteActiveIds(s) {
    if (!d(this, Ad).isMediaLoaded) return;
    const n = S(this, yn, _V).call(this), o = new chrome.cast.media.EditTracksInfoRequest(n);
    S(this, yn, UV).call(this, o).catch((h) => {
    });
  }
}
Ad = new WeakMap(), So = new WeakMap(), sw = new WeakMap(), yn = new WeakSet(), TM = function() {
  return d(this, So).$state.audioTracks();
}, lv = function(s) {
  var o;
  const n = ((o = d(this, Ad).mediaInfo) == null ? void 0 : o.tracks) ?? [];
  return s ? n.filter((h) => h.type === s) : n;
}, _V = function() {
  const s = [], n = S(this, yn, TM).call(this).find((h) => h.selected), o = this.getLocalTextTracks().filter((h) => h.mode === "showing");
  if (n) {
    const h = S(this, yn, lv).call(this, chrome.cast.media.TrackType.AUDIO), v = S(this, yn, Bb).call(this, h, n);
    v && s.push(v.trackId);
  }
  if (o != null && o.length) {
    const h = S(this, yn, lv).call(this, chrome.cast.media.TrackType.TEXT);
    if (h.length)
      for (const v of o) {
        const y = S(this, yn, Bb).call(this, h, v);
        y && s.push(y.trackId);
      }
  }
  return s;
}, NV = function() {
  const s = this.getLocalTextTracks();
  if (!d(this, Ad).isMediaLoaded) return;
  const n = S(this, yn, lv).call(this, chrome.cast.media.TrackType.TEXT);
  for (const o of s)
    if (!S(this, yn, Bb).call(this, n, o)) {
      py(() => {
        var v;
        return (v = d(this, sw)) == null ? void 0 : v.call(this);
      });
      break;
    }
}, UV = function(s) {
  const n = Pj();
  return new Promise((o, h) => n == null ? void 0 : n.editTracksInfo(s, o, h));
}, wM = function(s, n) {
  return s.find((o) => S(this, yn, EM).call(this, o, n));
}, Bb = function(s, n) {
  return s.find((o) => S(this, yn, EM).call(this, n, o));
}, // Note: we can't rely on id matching because they will differ between local/remote. A local
// track id might not even exist.
EM = function(s, n) {
  return n.name === s.label && n.language === s.language && n.subtype.toLowerCase() === s.kind.toLowerCase();
};
export {
  _a as $,
  MQ as A,
  Vr as B,
  i7 as C,
  zQ as D,
  n7 as E,
  NQ as F,
  s7 as G,
  OQ as H,
  Ud as I,
  pi as J,
  jj as K,
  at as L,
  ss as M,
  $Q as N,
  wQ as O,
  UQ as P,
  la as Q,
  IM as R,
  WQ as S,
  Cb as T,
  QQ as U,
  _Q as V,
  YQ as W,
  GQ as X,
  r7 as Y,
  jQ as Z,
  KQ as _,
  Ze as a,
  R6 as a0,
  sQ as a1,
  XQ as a2,
  ZQ as a3,
  JQ as a4,
  qM as a5,
  qQ as a6,
  M6 as a7,
  oQ as a8,
  B6 as a9,
  _6 as aa,
  W6 as ab,
  N6 as ac,
  P6 as ad,
  F6 as ae,
  I6 as af,
  bQ as ag,
  kQ as ah,
  RQ as ai,
  DQ as aj,
  xQ as ak,
  E6 as al,
  k6 as am,
  BQ as an,
  FQ as b,
  ye as c,
  Gb as d,
  vt as e,
  a7 as f,
  e7 as g,
  PM as h,
  vB as i,
  t7 as j,
  EQ as k,
  En as l,
  LQ as m,
  Rt as n,
  Wt as o,
  O0 as p,
  CQ as q,
  fB as r,
  Cl as s,
  dB as t,
  PQ as u,
  cB as v,
  AQ as w,
  st as x,
  J as y,
  DR as z
};
